var mr = Object.defineProperty;
var hr = (g, I, C) => I in g ? mr(g, I, { enumerable: !0, configurable: !0, writable: !0, value: C }) : g[I] = C;
var rc = (g, I, C) => (hr(g, typeof I != "symbol" ? I + "" : I, C), C);
import { jsx as o, jsxs as R, Fragment as sI } from "@emotion/react/jsx-runtime";
import { css as $ } from "@emotion/react";
import { useShowNotification as Mi, hideNotification as Wr, createPolymorphicComponent as Nr, Text as U, Anchor as Js, COLOR_PALETTE as rg, Indicator as xr, Group as Ig, OptimizeImage as bC, Box as P, TextInput as yr, ActionIcon as qg, Icon as sg, Menu as Xc, Stack as gg, Flex as Cg, AspectRatio as Ys, Skeleton as ng, desktopFirstMediaQuery as Mg, Button as xg, desktopFirstQuery as Fs, Tooltip as Vn, Textarea as zs, Modal as wg, UnstyledButton as fs, Progress as pr, Divider as Rr, Loader as Hs, Title as Br, Grid as mn, Popover as WC } from "@inflearn/ds-react";
import { Stack as Ki } from "@mantine/core";
import { createContext as jg, useContext as Zg, useState as O, useRef as Ag, useEffect as q, useCallback as k, useMemo as tg, createElement as ws, useLayoutEffect as Ss, memo as yg, lazy as vr, Fragment as _i, Suspense as Jr, useReducer as Yr, forwardRef as Fr, useInsertionEffect as Ts, useId as Ls, Component as zr } from "react";
import { jsx as Yl, Fragment as Us, jsxs as Ps } from "react/jsx-runtime";
import qi from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/ko";
import fr from "dayjs/plugin/localizedFormat";
import Hr from "dayjs/plugin/updateLocale";
import { useQuery as ug, useMutation as _C, useQueryClient as qA } from "@tanstack/react-query";
import { ResponseStatus as nt, IsomorphicFetch as ks, ApiError as GA, StatusCodeLookup as wr } from "@inflearn/datasource-rest";
import { useAnalytics as Ds } from "@inflearn/analytics";
import { useDebouncedValue as Sr, useDisclosure as Os, useMediaQuery as js } from "@mantine/hooks";
import { useLoadableVariationDetail as Tr, DecisionReason as hn } from "@hackler/react-sdk";
var Lr = typeof global == "object" && global && global.Object === Object && global;
const Es = Lr;
var Ur = typeof self == "object" && self && self.Object === Object && self, Pr = Es || Ur || Function("return this")();
const oI = Pr;
var kr = oI.Symbol;
const OC = kr;
var Qs = Object.prototype, Dr = Qs.hasOwnProperty, Or = Qs.toString, nA = OC ? OC.toStringTag : void 0;
function jr(g) {
  var I = Dr.call(g, nA), C = g[nA];
  try {
    g[nA] = void 0;
    var A = !0;
  } catch {
  }
  var c = Or.call(g);
  return A && (I ? g[nA] = C : delete g[nA]), c;
}
var Er = Object.prototype, Qr = Er.toString;
function Mr(g) {
  return Qr.call(g);
}
var Kr = "[object Null]", _r = "[object Undefined]", Wn = OC ? OC.toStringTag : void 0;
function TI(g) {
  return g == null ? g === void 0 ? _r : Kr : Wn && Wn in Object(g) ? jr(g) : Mr(g);
}
function GC(g) {
  return g != null && typeof g == "object";
}
var qr = "[object Symbol]";
function Fl(g) {
  return typeof g == "symbol" || GC(g) && TI(g) == qr;
}
function Ms(g, I) {
  for (var C = -1, A = g == null ? 0 : g.length, c = Array(A); ++C < A; )
    c[C] = I(g[C], C, g);
  return c;
}
var $r = Array.isArray;
const mI = $r;
var gX = 1 / 0, Nn = OC ? OC.prototype : void 0, xn = Nn ? Nn.toString : void 0;
function Ks(g) {
  if (typeof g == "string")
    return g;
  if (mI(g))
    return Ms(g, Ks) + "";
  if (Fl(g))
    return xn ? xn.call(g) : "";
  var I = g + "";
  return I == "0" && 1 / g == -gX ? "-0" : I;
}
var IX = /\s/;
function CX(g) {
  for (var I = g.length; I-- && IX.test(g.charAt(I)); )
    ;
  return I;
}
var AX = /^\s+/;
function cX(g) {
  return g && g.slice(0, CX(g) + 1).replace(AX, "");
}
function hI(g) {
  var I = typeof g;
  return g != null && (I == "object" || I == "function");
}
var yn = 0 / 0, lX = /^[-+]0x[0-9a-f]+$/i, tX = /^0b[01]+$/i, iX = /^0o[0-7]+$/i, eX = parseInt;
function nX(g) {
  if (typeof g == "number")
    return g;
  if (Fl(g))
    return yn;
  if (hI(g)) {
    var I = typeof g.valueOf == "function" ? g.valueOf() : g;
    g = hI(I) ? I + "" : I;
  }
  if (typeof g != "string")
    return g === 0 ? g : +g;
  g = cX(g);
  var C = tX.test(g);
  return C || iX.test(g) ? eX(g.slice(2), C ? 2 : 8) : lX.test(g) ? yn : +g;
}
var pn = 1 / 0, bX = 17976931348623157e292;
function aX(g) {
  if (!g)
    return g === 0 ? g : 0;
  if (g = nX(g), g === pn || g === -pn) {
    var I = g < 0 ? -1 : 1;
    return I * bX;
  }
  return g === g ? g : 0;
}
function sX(g) {
  var I = aX(g), C = I % 1;
  return I === I ? C ? I - C : I : 0;
}
function $i(g) {
  return g;
}
var uX = "[object AsyncFunction]", dX = "[object Function]", oX = "[object GeneratorFunction]", GX = "[object Proxy]";
function ge(g) {
  if (!hI(g))
    return !1;
  var I = TI(g);
  return I == dX || I == oX || I == uX || I == GX;
}
var rX = oI["__core-js_shared__"];
const bt = rX;
var Rn = function() {
  var g = /[^.]+$/.exec(bt && bt.keys && bt.keys.IE_PROTO || "");
  return g ? "Symbol(src)_1." + g : "";
}();
function XX(g) {
  return !!Rn && Rn in g;
}
var ZX = Function.prototype, VX = ZX.toString;
function rC(g) {
  if (g != null) {
    try {
      return VX.call(g);
    } catch {
    }
    try {
      return g + "";
    } catch {
    }
  }
  return "";
}
var mX = /[\\^$.*+?()[\]{}|]/g, hX = /^\[object .+?Constructor\]$/, WX = Function.prototype, NX = Object.prototype, xX = WX.toString, yX = NX.hasOwnProperty, pX = RegExp(
  "^" + xX.call(yX).replace(mX, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function RX(g) {
  if (!hI(g) || XX(g))
    return !1;
  var I = ge(g) ? pX : hX;
  return I.test(rC(g));
}
function BX(g, I) {
  return g == null ? void 0 : g[I];
}
function XC(g, I) {
  var C = BX(g, I);
  return RX(C) ? C : void 0;
}
var vX = XC(oI, "WeakMap");
const jt = vX;
var Bn = Object.create, JX = function() {
  function g() {
  }
  return function(I) {
    if (!hI(I))
      return {};
    if (Bn)
      return Bn(I);
    g.prototype = I;
    var C = new g();
    return g.prototype = void 0, C;
  };
}();
const YX = JX;
function FX(g, I, C) {
  switch (C.length) {
    case 0:
      return g.call(I);
    case 1:
      return g.call(I, C[0]);
    case 2:
      return g.call(I, C[0], C[1]);
    case 3:
      return g.call(I, C[0], C[1], C[2]);
  }
  return g.apply(I, C);
}
function zX(g, I) {
  var C = -1, A = g.length;
  for (I || (I = Array(A)); ++C < A; )
    I[C] = g[C];
  return I;
}
var fX = 800, HX = 16, wX = Date.now;
function SX(g) {
  var I = 0, C = 0;
  return function() {
    var A = wX(), c = HX - (A - C);
    if (C = A, c > 0) {
      if (++I >= fX)
        return arguments[0];
    } else
      I = 0;
    return g.apply(void 0, arguments);
  };
}
function _s(g) {
  return function() {
    return g;
  };
}
var TX = function() {
  try {
    var g = XC(Object, "defineProperty");
    return g({}, "", {}), g;
  } catch {
  }
}();
const qc = TX;
var LX = qc ? function(g, I) {
  return qc(g, "toString", {
    configurable: !0,
    enumerable: !1,
    value: _s(I),
    writable: !0
  });
} : $i;
const UX = LX;
var PX = SX(UX);
const kX = PX;
function DX(g, I, C, A) {
  for (var c = g.length, l = C + (A ? 1 : -1); A ? l-- : ++l < c; )
    if (I(g[l], l, g))
      return l;
  return -1;
}
function OX(g) {
  return g !== g;
}
function jX(g, I, C) {
  for (var A = C - 1, c = g.length; ++A < c; )
    if (g[A] === I)
      return A;
  return -1;
}
function EX(g, I, C) {
  return I === I ? jX(g, I, C) : DX(g, OX, C);
}
var QX = 9007199254740991, MX = /^(?:0|[1-9]\d*)$/;
function Ie(g, I) {
  var C = typeof g;
  return I = I ?? QX, !!I && (C == "number" || C != "symbol" && MX.test(g)) && g > -1 && g % 1 == 0 && g < I;
}
function Ce(g, I, C) {
  I == "__proto__" && qc ? qc(g, I, {
    configurable: !0,
    enumerable: !0,
    value: C,
    writable: !0
  }) : g[I] = C;
}
function zl(g, I) {
  return g === I || g !== g && I !== I;
}
var KX = Object.prototype, _X = KX.hasOwnProperty;
function qX(g, I, C) {
  var A = g[I];
  (!(_X.call(g, I) && zl(A, C)) || C === void 0 && !(I in g)) && Ce(g, I, C);
}
function $X(g, I, C, A) {
  var c = !C;
  C || (C = {});
  for (var l = -1, t = I.length; ++l < t; ) {
    var i = I[l], e = A ? A(C[i], g[i], i, C, g) : void 0;
    e === void 0 && (e = g[i]), c ? Ce(C, i, e) : qX(C, i, e);
  }
  return C;
}
var vn = Math.max;
function gZ(g, I, C) {
  return I = vn(I === void 0 ? g.length - 1 : I, 0), function() {
    for (var A = arguments, c = -1, l = vn(A.length - I, 0), t = Array(l); ++c < l; )
      t[c] = A[I + c];
    c = -1;
    for (var i = Array(I + 1); ++c < I; )
      i[c] = A[c];
    return i[I] = C(t), FX(g, this, i);
  };
}
function IZ(g, I) {
  return kX(gZ(g, I, $i), g + "");
}
var CZ = 9007199254740991;
function Ae(g) {
  return typeof g == "number" && g > -1 && g % 1 == 0 && g <= CZ;
}
function qC(g) {
  return g != null && Ae(g.length) && !ge(g);
}
function AZ(g, I, C) {
  if (!hI(C))
    return !1;
  var A = typeof I;
  return (A == "number" ? qC(C) && Ie(I, C.length) : A == "string" && I in C) ? zl(C[I], g) : !1;
}
function cZ(g) {
  return IZ(function(I, C) {
    var A = -1, c = C.length, l = c > 1 ? C[c - 1] : void 0, t = c > 2 ? C[2] : void 0;
    for (l = g.length > 3 && typeof l == "function" ? (c--, l) : void 0, t && AZ(C[0], C[1], t) && (l = c < 3 ? void 0 : l, c = 1), I = Object(I); ++A < c; ) {
      var i = C[A];
      i && g(I, i, A, l);
    }
    return I;
  });
}
var lZ = Object.prototype;
function fl(g) {
  var I = g && g.constructor, C = typeof I == "function" && I.prototype || lZ;
  return g === C;
}
function tZ(g, I) {
  for (var C = -1, A = Array(g); ++C < g; )
    A[C] = I(C);
  return A;
}
var iZ = "[object Arguments]";
function Jn(g) {
  return GC(g) && TI(g) == iZ;
}
var qs = Object.prototype, eZ = qs.hasOwnProperty, nZ = qs.propertyIsEnumerable, bZ = Jn(function() {
  return arguments;
}()) ? Jn : function(g) {
  return GC(g) && eZ.call(g, "callee") && !nZ.call(g, "callee");
};
const vA = bZ;
function aZ() {
  return !1;
}
var $s = typeof exports == "object" && exports && !exports.nodeType && exports, Yn = $s && typeof module == "object" && module && !module.nodeType && module, sZ = Yn && Yn.exports === $s, Fn = sZ ? oI.Buffer : void 0, uZ = Fn ? Fn.isBuffer : void 0, dZ = uZ || aZ;
const ce = dZ;
var oZ = "[object Arguments]", GZ = "[object Array]", rZ = "[object Boolean]", XZ = "[object Date]", ZZ = "[object Error]", VZ = "[object Function]", mZ = "[object Map]", hZ = "[object Number]", WZ = "[object Object]", NZ = "[object RegExp]", xZ = "[object Set]", yZ = "[object String]", pZ = "[object WeakMap]", RZ = "[object ArrayBuffer]", BZ = "[object DataView]", vZ = "[object Float32Array]", JZ = "[object Float64Array]", YZ = "[object Int8Array]", FZ = "[object Int16Array]", zZ = "[object Int32Array]", fZ = "[object Uint8Array]", HZ = "[object Uint8ClampedArray]", wZ = "[object Uint16Array]", SZ = "[object Uint32Array]", dg = {};
dg[vZ] = dg[JZ] = dg[YZ] = dg[FZ] = dg[zZ] = dg[fZ] = dg[HZ] = dg[wZ] = dg[SZ] = !0;
dg[oZ] = dg[GZ] = dg[RZ] = dg[rZ] = dg[BZ] = dg[XZ] = dg[ZZ] = dg[VZ] = dg[mZ] = dg[hZ] = dg[WZ] = dg[NZ] = dg[xZ] = dg[yZ] = dg[pZ] = !1;
function TZ(g) {
  return GC(g) && Ae(g.length) && !!dg[TI(g)];
}
function LZ(g) {
  return function(I) {
    return g(I);
  };
}
var gu = typeof exports == "object" && exports && !exports.nodeType && exports, mA = gu && typeof module == "object" && module && !module.nodeType && module, UZ = mA && mA.exports === gu, at = UZ && Es.process, PZ = function() {
  try {
    var g = mA && mA.require && mA.require("util").types;
    return g || at && at.binding && at.binding("util");
  } catch {
  }
}();
const zn = PZ;
var fn = zn && zn.isTypedArray, kZ = fn ? LZ(fn) : TZ;
const le = kZ;
var DZ = Object.prototype, OZ = DZ.hasOwnProperty;
function Iu(g, I) {
  var C = mI(g), A = !C && vA(g), c = !C && !A && ce(g), l = !C && !A && !c && le(g), t = C || A || c || l, i = t ? tZ(g.length, String) : [], e = i.length;
  for (var n in g)
    (I || OZ.call(g, n)) && !(t && // Safari 9 has enumerable `arguments.length` in strict mode.
    (n == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    c && (n == "offset" || n == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    l && (n == "buffer" || n == "byteLength" || n == "byteOffset") || // Skip index properties.
    Ie(n, e))) && i.push(n);
  return i;
}
function Cu(g, I) {
  return function(C) {
    return g(I(C));
  };
}
var jZ = Cu(Object.keys, Object);
const EZ = jZ;
var QZ = Object.prototype, MZ = QZ.hasOwnProperty;
function Au(g) {
  if (!fl(g))
    return EZ(g);
  var I = [];
  for (var C in Object(g))
    MZ.call(g, C) && C != "constructor" && I.push(C);
  return I;
}
function cu(g) {
  return qC(g) ? Iu(g) : Au(g);
}
function KZ(g) {
  var I = [];
  if (g != null)
    for (var C in Object(g))
      I.push(C);
  return I;
}
var _Z = Object.prototype, qZ = _Z.hasOwnProperty;
function $Z(g) {
  if (!hI(g))
    return KZ(g);
  var I = fl(g), C = [];
  for (var A in g)
    A == "constructor" && (I || !qZ.call(g, A)) || C.push(A);
  return C;
}
function lu(g) {
  return qC(g) ? Iu(g, !0) : $Z(g);
}
var g2 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, I2 = /^\w*$/;
function C2(g, I) {
  if (mI(g))
    return !1;
  var C = typeof g;
  return C == "number" || C == "symbol" || C == "boolean" || g == null || Fl(g) ? !0 : I2.test(g) || !g2.test(g) || I != null && g in Object(I);
}
var A2 = XC(Object, "create");
const JA = A2;
function c2() {
  this.__data__ = JA ? JA(null) : {}, this.size = 0;
}
function l2(g) {
  var I = this.has(g) && delete this.__data__[g];
  return this.size -= I ? 1 : 0, I;
}
var t2 = "__lodash_hash_undefined__", i2 = Object.prototype, e2 = i2.hasOwnProperty;
function n2(g) {
  var I = this.__data__;
  if (JA) {
    var C = I[g];
    return C === t2 ? void 0 : C;
  }
  return e2.call(I, g) ? I[g] : void 0;
}
var b2 = Object.prototype, a2 = b2.hasOwnProperty;
function s2(g) {
  var I = this.__data__;
  return JA ? I[g] !== void 0 : a2.call(I, g);
}
var u2 = "__lodash_hash_undefined__";
function d2(g, I) {
  var C = this.__data__;
  return this.size += this.has(g) ? 0 : 1, C[g] = JA && I === void 0 ? u2 : I, this;
}
function aC(g) {
  var I = -1, C = g == null ? 0 : g.length;
  for (this.clear(); ++I < C; ) {
    var A = g[I];
    this.set(A[0], A[1]);
  }
}
aC.prototype.clear = c2;
aC.prototype.delete = l2;
aC.prototype.get = n2;
aC.prototype.has = s2;
aC.prototype.set = d2;
function o2() {
  this.__data__ = [], this.size = 0;
}
function Hl(g, I) {
  for (var C = g.length; C--; )
    if (zl(g[C][0], I))
      return C;
  return -1;
}
var G2 = Array.prototype, r2 = G2.splice;
function X2(g) {
  var I = this.__data__, C = Hl(I, g);
  if (C < 0)
    return !1;
  var A = I.length - 1;
  return C == A ? I.pop() : r2.call(I, C, 1), --this.size, !0;
}
function Z2(g) {
  var I = this.__data__, C = Hl(I, g);
  return C < 0 ? void 0 : I[C][1];
}
function V2(g) {
  return Hl(this.__data__, g) > -1;
}
function m2(g, I) {
  var C = this.__data__, A = Hl(C, g);
  return A < 0 ? (++this.size, C.push([g, I])) : C[A][1] = I, this;
}
function vI(g) {
  var I = -1, C = g == null ? 0 : g.length;
  for (this.clear(); ++I < C; ) {
    var A = g[I];
    this.set(A[0], A[1]);
  }
}
vI.prototype.clear = o2;
vI.prototype.delete = X2;
vI.prototype.get = Z2;
vI.prototype.has = V2;
vI.prototype.set = m2;
var h2 = XC(oI, "Map");
const YA = h2;
function W2() {
  this.size = 0, this.__data__ = {
    hash: new aC(),
    map: new (YA || vI)(),
    string: new aC()
  };
}
function N2(g) {
  var I = typeof g;
  return I == "string" || I == "number" || I == "symbol" || I == "boolean" ? g !== "__proto__" : g === null;
}
function wl(g, I) {
  var C = g.__data__;
  return N2(I) ? C[typeof I == "string" ? "string" : "hash"] : C.map;
}
function x2(g) {
  var I = wl(this, g).delete(g);
  return this.size -= I ? 1 : 0, I;
}
function y2(g) {
  return wl(this, g).get(g);
}
function p2(g) {
  return wl(this, g).has(g);
}
function R2(g, I) {
  var C = wl(this, g), A = C.size;
  return C.set(g, I), this.size += C.size == A ? 0 : 1, this;
}
function LI(g) {
  var I = -1, C = g == null ? 0 : g.length;
  for (this.clear(); ++I < C; ) {
    var A = g[I];
    this.set(A[0], A[1]);
  }
}
LI.prototype.clear = W2;
LI.prototype.delete = x2;
LI.prototype.get = y2;
LI.prototype.has = p2;
LI.prototype.set = R2;
var B2 = "Expected a function";
function te(g, I) {
  if (typeof g != "function" || I != null && typeof I != "function")
    throw new TypeError(B2);
  var C = function() {
    var A = arguments, c = I ? I.apply(this, A) : A[0], l = C.cache;
    if (l.has(c))
      return l.get(c);
    var t = g.apply(this, A);
    return C.cache = l.set(c, t) || l, t;
  };
  return C.cache = new (te.Cache || LI)(), C;
}
te.Cache = LI;
var v2 = 500;
function J2(g) {
  var I = te(g, function(A) {
    return C.size === v2 && C.clear(), A;
  }), C = I.cache;
  return I;
}
var Y2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, F2 = /\\(\\)?/g, z2 = J2(function(g) {
  var I = [];
  return g.charCodeAt(0) === 46 && I.push(""), g.replace(Y2, function(C, A, c, l) {
    I.push(c ? l.replace(F2, "$1") : A || C);
  }), I;
});
const f2 = z2;
function H2(g) {
  return g == null ? "" : Ks(g);
}
function w2(g, I) {
  return mI(g) ? g : C2(g, I) ? [g] : f2(H2(g));
}
var S2 = 1 / 0;
function T2(g) {
  if (typeof g == "string" || Fl(g))
    return g;
  var I = g + "";
  return I == "0" && 1 / g == -S2 ? "-0" : I;
}
var L2 = Cu(Object.getPrototypeOf, Object);
const tu = L2;
var U2 = "[object Object]", P2 = Function.prototype, k2 = Object.prototype, iu = P2.toString, D2 = k2.hasOwnProperty, O2 = iu.call(Object);
function eu(g) {
  if (!GC(g) || TI(g) != U2)
    return !1;
  var I = tu(g);
  if (I === null)
    return !0;
  var C = D2.call(I, "constructor") && I.constructor;
  return typeof C == "function" && C instanceof C && iu.call(C) == O2;
}
function j2() {
  this.__data__ = new vI(), this.size = 0;
}
function E2(g) {
  var I = this.__data__, C = I.delete(g);
  return this.size = I.size, C;
}
function Q2(g) {
  return this.__data__.get(g);
}
function M2(g) {
  return this.__data__.has(g);
}
var K2 = 200;
function _2(g, I) {
  var C = this.__data__;
  if (C instanceof vI) {
    var A = C.__data__;
    if (!YA || A.length < K2 - 1)
      return A.push([g, I]), this.size = ++C.size, this;
    C = this.__data__ = new LI(A);
  }
  return C.set(g, I), this.size = C.size, this;
}
function $C(g) {
  var I = this.__data__ = new vI(g);
  this.size = I.size;
}
$C.prototype.clear = j2;
$C.prototype.delete = E2;
$C.prototype.get = Q2;
$C.prototype.has = M2;
$C.prototype.set = _2;
var nu = typeof exports == "object" && exports && !exports.nodeType && exports, Hn = nu && typeof module == "object" && module && !module.nodeType && module, q2 = Hn && Hn.exports === nu, wn = q2 ? oI.Buffer : void 0, Sn = wn ? wn.allocUnsafe : void 0;
function $2(g, I) {
  if (I)
    return g.slice();
  var C = g.length, A = Sn ? Sn(C) : new g.constructor(C);
  return g.copy(A), A;
}
var gV = XC(oI, "DataView");
const Et = gV;
var IV = XC(oI, "Promise");
const Qt = IV;
var CV = XC(oI, "Set");
const Mt = CV;
var Tn = "[object Map]", AV = "[object Object]", Ln = "[object Promise]", Un = "[object Set]", Pn = "[object WeakMap]", kn = "[object DataView]", cV = rC(Et), lV = rC(YA), tV = rC(Qt), iV = rC(Mt), eV = rC(jt), gC = TI;
(Et && gC(new Et(new ArrayBuffer(1))) != kn || YA && gC(new YA()) != Tn || Qt && gC(Qt.resolve()) != Ln || Mt && gC(new Mt()) != Un || jt && gC(new jt()) != Pn) && (gC = function(g) {
  var I = TI(g), C = I == AV ? g.constructor : void 0, A = C ? rC(C) : "";
  if (A)
    switch (A) {
      case cV:
        return kn;
      case lV:
        return Tn;
      case tV:
        return Ln;
      case iV:
        return Un;
      case eV:
        return Pn;
    }
  return I;
});
const nV = gC;
var bV = oI.Uint8Array;
const Dn = bV;
function aV(g) {
  var I = new g.constructor(g.byteLength);
  return new Dn(I).set(new Dn(g)), I;
}
function sV(g, I) {
  var C = I ? aV(g.buffer) : g.buffer;
  return new g.constructor(C, g.byteOffset, g.length);
}
function uV(g) {
  return typeof g.constructor == "function" && !fl(g) ? YX(tu(g)) : {};
}
function dV(g, I, C) {
  I = w2(I, g);
  for (var A = -1, c = I.length, l = !1; ++A < c; ) {
    var t = T2(I[A]);
    if (!(l = g != null && C(g, t)))
      break;
    g = g[t];
  }
  return l || ++A != c ? l : (c = g == null ? 0 : g.length, !!c && Ae(c) && Ie(t, c) && (mI(g) || vA(g)));
}
function oV(g) {
  return function(I, C, A) {
    for (var c = -1, l = Object(I), t = A(I), i = t.length; i--; ) {
      var e = t[g ? i : ++c];
      if (C(l[e], e, l) === !1)
        break;
    }
    return I;
  };
}
var GV = oV();
const bu = GV;
function rV(g, I) {
  return g && bu(g, I, cu);
}
function Kt(g, I, C) {
  (C !== void 0 && !zl(g[I], C) || C === void 0 && !(I in g)) && Ce(g, I, C);
}
function XV(g) {
  return GC(g) && qC(g);
}
function _t(g, I) {
  if (!(I === "constructor" && typeof g[I] == "function") && I != "__proto__")
    return g[I];
}
function ZV(g) {
  return $X(g, lu(g));
}
function VV(g, I, C, A, c, l, t) {
  var i = _t(g, C), e = _t(I, C), n = t.get(e);
  if (n) {
    Kt(g, C, n);
    return;
  }
  var b = l ? l(i, e, C + "", g, I, t) : void 0, a = b === void 0;
  if (a) {
    var s = mI(e), d = !s && ce(e), Z = !s && !d && le(e);
    b = e, s || d || Z ? mI(i) ? b = i : XV(i) ? b = zX(i) : d ? (a = !1, b = $2(e, !0)) : Z ? (a = !1, b = sV(e, !0)) : b = [] : eu(e) || vA(e) ? (b = i, vA(i) ? b = ZV(i) : (!hI(i) || ge(i)) && (b = uV(e))) : a = !1;
  }
  a && (t.set(e, b), c(b, e, A, l, t), t.delete(e)), Kt(g, C, b);
}
function au(g, I, C, A, c) {
  g !== I && bu(I, function(l, t) {
    if (c || (c = new $C()), hI(l))
      VV(g, I, t, C, au, A, c);
    else {
      var i = A ? A(_t(g, t), l, t + "", g, I, c) : void 0;
      i === void 0 && (i = l), Kt(g, t, i);
    }
  }, lu);
}
var mV = Object.prototype, hV = mV.hasOwnProperty;
function WV(g, I) {
  return g != null && hV.call(g, I);
}
function LC(g, I) {
  return g != null && dV(g, I, WV);
}
var NV = "[object String]";
function xV(g) {
  return typeof g == "string" || !mI(g) && GC(g) && TI(g) == NV;
}
function yV(g, I) {
  return Ms(I, function(C) {
    return g[C];
  });
}
function pV(g) {
  return g == null ? [] : yV(g, cu(g));
}
var RV = Math.max;
function Sl(g, I, C, A) {
  g = qC(g) ? g : pV(g), C = C && !A ? sX(C) : 0;
  var c = g.length;
  return C < 0 && (C = RV(c + C, 0)), xV(g) ? C <= c && g.indexOf(I, C) > -1 : !!c && EX(g, I, C) > -1;
}
function BV(g, I, C, A) {
  return rV(g, function(c, l, t) {
    I(A, C(c), l, t);
  }), A;
}
function vV(g, I) {
  return function(C, A) {
    return BV(C, g, I(A), {});
  };
}
var JV = Object.prototype, YV = JV.toString, FV = vV(function(g, I, C) {
  I != null && typeof I.toString != "function" && (I = YV.call(I)), g[I] = C;
}, _s($i));
const ie = FV;
var zV = "[object Map]", fV = "[object Set]", HV = Object.prototype, wV = HV.hasOwnProperty;
function rA(g) {
  if (g == null)
    return !0;
  if (qC(g) && (mI(g) || typeof g == "string" || typeof g.splice == "function" || ce(g) || le(g) || vA(g)))
    return !g.length;
  var I = nV(g);
  if (I == zV || I == fV)
    return !g.size;
  if (fl(g))
    return !Au(g).length;
  for (var C in g)
    if (wV.call(g, C))
      return !1;
  return !0;
}
function su(g) {
  return g == null;
}
var SV = cZ(function(g, I, C) {
  au(g, I, C);
});
const uu = SV;
/*! js-cookie v3.0.5 | MIT */
function Zc(g) {
  for (var I = 1; I < arguments.length; I++) {
    var C = arguments[I];
    for (var A in C)
      g[A] = C[A];
  }
  return g;
}
var TV = {
  read: function(g) {
    return g[0] === '"' && (g = g.slice(1, -1)), g.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(g) {
    return encodeURIComponent(g).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function qt(g, I) {
  function C(c, l, t) {
    if (!(typeof document > "u")) {
      t = Zc({}, I, t), typeof t.expires == "number" && (t.expires = new Date(Date.now() + t.expires * 864e5)), t.expires && (t.expires = t.expires.toUTCString()), c = encodeURIComponent(c).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var i = "";
      for (var e in t)
        t[e] && (i += "; " + e, t[e] !== !0 && (i += "=" + t[e].split(";")[0]));
      return document.cookie = c + "=" + g.write(l, c) + i;
    }
  }
  function A(c) {
    if (!(typeof document > "u" || arguments.length && !c)) {
      for (var l = document.cookie ? document.cookie.split("; ") : [], t = {}, i = 0; i < l.length; i++) {
        var e = l[i].split("="), n = e.slice(1).join("=");
        try {
          var b = decodeURIComponent(e[0]);
          if (t[b] = g.read(n, b), c === b)
            break;
        } catch {
        }
      }
      return c ? t[c] : t;
    }
  }
  return Object.create(
    {
      set: C,
      get: A,
      remove: function(c, l) {
        C(
          c,
          "",
          Zc({}, l, {
            expires: -1
          })
        );
      },
      withAttributes: function(c) {
        return qt(this.converter, Zc({}, this.attributes, c));
      },
      withConverter: function(c) {
        return qt(Zc({}, this.converter, c), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(I) },
      converter: { value: Object.freeze(g) }
    }
  );
}
var ee = qt(TV, { path: "/" });
const E5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ee
}, Symbol.toStringTag, { value: "Module" })), LV = {
  MODE: "development",
  CDN_URL: "https://cdn.devinflearn.com",
  API_URL: "https://www.devinflearn.com",
  SITE_URL: "https://www.devinflearn.com",
  MENTORING_SITE_URL: "https://mentoring.devinflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.devinflearn.com",
  ACCOUNT_API_URL: "https://account-api.devinflearn.com",
  COURSE_API_URL: "https://course-api.devinflearn.com",
  UCC_API_URL: "https://ucc-api.devinflearn.com",
  RALLIT_SITE_URL: "https://www.devrallit.com",
  BUSINESS_DOMAIN: "https://business.devinflearn.com",
  ADMIN_DOMAIN: "https://admin.devinflearn.com",
  COOKIE_DOMAIN: ".devinflearn.com",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.test",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "65fef69e7b3b778bd124",
  OAUTH_GITHUB_CLIENT_ID: "41f342acfada922e9fb5",
  OAUTH_GOOGLE_CLIENT_ID: "333892070963-abo0eoss3ielmeukj8dtvpr4l0fbniun.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "1281a93457d30e1f2ffafe9fe0c197ab",
  HACKLE_BROWSER_SDK_KEY: "ygFNanOzYS2M5JgfrE5gUk69EbkFIzZ4",
  MIXPANEL_TOKEN: "2df837e504078b475f90b32d9a268c01",
  CDN_INTEGRATION_URL: "https://cdn.devinflab.com"
}, UV = {
  MODE: "localhost",
  CDN_URL: "https://cdn.devinflearn.com",
  API_URL: "http://localhost:3000",
  SITE_URL: "http://localhost:3000",
  MENTORING_SITE_URL: "https://mentoring.devinflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.devinflearn.com",
  ACCOUNT_API_URL: "https://account-api.devinflearn.com",
  COURSE_API_URL: "https://course-api.devinflearn.com",
  UCC_API_URL: "https://ucc-api.devinflearn.com",
  RALLIT_SITE_URL: "https://www.devrallit.com",
  BUSINESS_DOMAIN: "http://localhost:7020",
  ADMIN_DOMAIN: "http://localhost:7010",
  COOKIE_DOMAIN: "localhost",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.test",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "65fef69e7b3b778bd124",
  OAUTH_GITHUB_CLIENT_ID: "41f342acfada922e9fb5",
  OAUTH_GOOGLE_CLIENT_ID: "333892070963-abo0eoss3ielmeukj8dtvpr4l0fbniun.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "1281a93457d30e1f2ffafe9fe0c197ab",
  HACKLE_BROWSER_SDK_KEY: "ygFNanOzYS2M5JgfrE5gUk69EbkFIzZ4",
  MIXPANEL_TOKEN: "2df837e504078b475f90b32d9a268c01",
  CDN_INTEGRATION_URL: "https://cdn.devinflab.com"
}, On = {
  MODE: "production",
  CDN_URL: "https://cdn.inflearn.com",
  API_URL: "https://www.inflearn.com",
  SITE_URL: "https://www.inflearn.com",
  MENTORING_SITE_URL: "https://mentoring.inflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.inflearn.com",
  ACCOUNT_API_URL: "https://account-api.inflearn.com",
  COURSE_API_URL: "https://course-api.inflearn.com",
  UCC_API_URL: "https://ucc-api.inflearn.com",
  RALLIT_SITE_URL: "https://www.rallit.com",
  BUSINESS_DOMAIN: "https://business.inflearn.com",
  ADMIN_DOMAIN: "https://admin.inflearn.com",
  COOKIE_DOMAIN: ".inflearn.com",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.web",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "5fd8e44b142806d9cbea",
  OAUTH_GITHUB_CLIENT_ID: "419780d6d3750d84d1db",
  OAUTH_GOOGLE_CLIENT_ID: "887875630717-ror9t8ig4obhvokdij07eoochpqbu5kf.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "0de1184063abadc9cef9dbf417c567a5",
  HACKLE_BROWSER_SDK_KEY: "rb1wDPCB39swIGfTAhDcz0QXvmh6hayS",
  MIXPANEL_TOKEN: "c05d8cc017a29af05e50c0d43d848d2d",
  CDN_INTEGRATION_URL: "https://cdn.inflab.com"
};
function PV() {
  return typeof window < "u" && (window != null && window.env) ? window.env : process.env.NEXT_PUBLIC_ENV || process.env.APP_ENV;
}
function kV() {
  const g = PV();
  return g ? g === "localhost" ? UV : g === "production" ? On : LV : (console.error("app-shell env is not defined"), On);
}
const Fg = kV(), jC = Fg.CDN_URL, ne = Fg.SITE_URL, $c = Fg.MENTORING_SITE_URL, Q5 = Fg.SOCIAL_ACCOUNT_URL, DV = Fg.API_URL, OV = `${DV}/api`, jV = Fg.ACCOUNT_API_URL, EV = Fg.COURSE_API_URL, QV = Fg.UCC_API_URL, MV = Fg.MODE, jn = Fg.RALLIT_SITE_URL, M5 = Fg.OAUTH_APPLE_CLIENT_ID, K5 = Fg.OAUTH_GITHUB_CLIENT_ID, _5 = Fg.OAUTH_GOOGLE_CLIENT_ID, q5 = Fg.OAUTH_KAKAO_REST_ID, KV = Fg.BUSINESS_DOMAIN, du = Fg.COOKIE_DOMAIN, $5 = Fg.HACKLE_BROWSER_SDK_KEY, _V = Fg.MIXPANEL_TOKEN;
Fg.CDN_INTEGRATION_URL;
const st = ee.withAttributes({
  path: "/",
  domain: du
}).withConverter({
  write: function(g) {
    return encodeURIComponent(g);
  }
});
class Pc {
  static set(I, C, A = this.COOKIE_EXPIRE_DAY, c = "Medium") {
    st.set(I, C, {
      expires: A,
      priority: c
    });
  }
  static get(I) {
    return st.get(I);
  }
  static remove(I) {
    st.remove(I);
  }
}
rc(Pc, "COOKIE_EXPIRE_DAY", 7);
function ou(g) {
  return g && g.__esModule && Object.prototype.hasOwnProperty.call(g, "default") ? g.default : g;
}
const qV = (...g) => {
  console != null && console.warn && (iC(g[0]) && (g[0] = `react-i18next:: ${g[0]}`), console.warn(...g));
}, En = {}, $t = (...g) => {
  iC(g[0]) && En[g[0]] || (iC(g[0]) && (En[g[0]] = /* @__PURE__ */ new Date()), qV(...g));
}, Gu = (g, I) => () => {
  if (g.isInitialized)
    I();
  else {
    const C = () => {
      setTimeout(() => {
        g.off("initialized", C);
      }, 0), I();
    };
    g.on("initialized", C);
  }
}, Qn = (g, I, C) => {
  g.loadNamespaces(I, Gu(g, C));
}, Mn = (g, I, C, A) => {
  iC(C) && (C = [C]), C.forEach((c) => {
    g.options.ns.indexOf(c) < 0 && g.options.ns.push(c);
  }), g.loadLanguages(I, Gu(g, A));
}, $V = (g, I, C = {}) => !I.languages || !I.languages.length ? ($t("i18n.languages were undefined or empty", I.languages), !0) : I.hasLoadedNamespace(g, {
  lng: C.lng,
  precheck: (A, c) => {
    var l;
    if (((l = C.bindI18n) == null ? void 0 : l.indexOf("languageChanging")) > -1 && A.services.backendConnector.backend && A.isLanguageChangingTo && !c(A.isLanguageChangingTo, g))
      return !1;
  }
}), iC = (g) => typeof g == "string", g0 = (g) => typeof g == "object" && g !== null, I0 = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, C0 = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, A0 = (g) => C0[g], c0 = (g) => g.replace(I0, A0);
let gi = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: c0
};
const l0 = (g = {}) => {
  gi = {
    ...gi,
    ...g
  };
}, t0 = () => gi;
let ru;
const i0 = (g) => {
  ru = g;
}, e0 = () => ru, Xu = {
  type: "3rdParty",
  init(g) {
    l0(g.options.react), i0(g);
  }
}, Zu = jg();
class n0 {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(I) {
    I.forEach((C) => {
      this.usedNamespaces[C] || (this.usedNamespaces[C] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const b0 = (g, I) => {
  const C = Ag();
  return q(() => {
    C.current = I ? C.current : g;
  }, [g, I]), C.current;
}, Vu = (g, I, C, A) => g.getFixedT(I, C, A), a0 = (g, I, C, A) => k(Vu(g, I, C, A), [g, I, C, A]), hg = (g, I = {}) => {
  var V, X, W, N;
  const {
    i18n: C
  } = I, {
    i18n: A,
    defaultNS: c
  } = Zg(Zu) || {}, l = C || A || e0();
  if (l && !l.reportNamespaces && (l.reportNamespaces = new n0()), !l) {
    $t("You will need to pass in an i18next instance by using initReactI18next");
    const m = (Y, v) => iC(v) ? v : g0(v) && iC(v.defaultValue) ? v.defaultValue : Array.isArray(Y) ? Y[Y.length - 1] : Y, p = [m, {}, !1];
    return p.t = m, p.i18n = {}, p.ready = !1, p;
  }
  (V = l.options.react) != null && V.wait && $t("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const t = {
    ...t0(),
    ...l.options.react,
    ...I
  }, {
    useSuspense: i,
    keyPrefix: e
  } = t;
  let n = g || c || ((X = l.options) == null ? void 0 : X.defaultNS);
  n = iC(n) ? [n] : n || ["translation"], (N = (W = l.reportNamespaces).addUsedNamespaces) == null || N.call(W, n);
  const b = (l.isInitialized || l.initializedStoreOnce) && n.every((m) => $V(m, l, t)), a = a0(l, I.lng || null, t.nsMode === "fallback" ? n : n[0], e), s = () => a, d = () => Vu(l, I.lng || null, t.nsMode === "fallback" ? n : n[0], e), [Z, r] = O(s);
  let h = n.join();
  I.lng && (h = `${I.lng}${h}`);
  const x = b0(h), u = Ag(!0);
  q(() => {
    const {
      bindI18n: m,
      bindI18nStore: p
    } = t;
    u.current = !0, !b && !i && (I.lng ? Mn(l, I.lng, n, () => {
      u.current && r(d);
    }) : Qn(l, n, () => {
      u.current && r(d);
    })), b && x && x !== h && u.current && r(d);
    const Y = () => {
      u.current && r(d);
    };
    return m && (l == null || l.on(m, Y)), p && (l == null || l.store.on(p, Y)), () => {
      u.current = !1, l && (m == null || m.split(" ").forEach((v) => l.off(v, Y))), p && l && p.split(" ").forEach((v) => l.store.off(v, Y));
    };
  }, [l, h]), q(() => {
    u.current && b && r(s);
  }, [l, e, b]);
  const G = [Z, l, b];
  if (G.t = Z, G.i18n = l, G.ready = b, b || !b && !i)
    return G;
  throw new Promise((m) => {
    I.lng ? Mn(l, I.lng, n, () => m()) : Qn(l, n, () => m());
  });
};
function s0({
  i18n: g,
  defaultNS: I,
  children: C
}) {
  const A = tg(() => ({
    i18n: g,
    defaultNS: I
  }), [g, I]);
  return ws(Zu.Provider, {
    value: A
  }, C);
}
function UI(g) {
  return hg("appShell", g);
}
var Tl = { exports: {} };
function u0(g) {
  try {
    return JSON.stringify(g);
  } catch {
    return '"[Circular]"';
  }
}
var d0 = o0;
function o0(g, I, C) {
  var A = C && C.stringify || u0, c = 1;
  if (typeof g == "object" && g !== null) {
    var l = I.length + c;
    if (l === 1)
      return g;
    var t = new Array(l);
    t[0] = A(g);
    for (var i = 1; i < l; i++)
      t[i] = A(I[i]);
    return t.join(" ");
  }
  if (typeof g != "string")
    return g;
  var e = I.length;
  if (e === 0)
    return g;
  for (var n = "", b = 1 - c, a = -1, s = g && g.length || 0, d = 0; d < s; ) {
    if (g.charCodeAt(d) === 37 && d + 1 < s) {
      switch (a = a > -1 ? a : 0, g.charCodeAt(d + 1)) {
        case 100:
        case 102:
          if (b >= e || I[b] == null)
            break;
          a < d && (n += g.slice(a, d)), n += Number(I[b]), a = d + 2, d++;
          break;
        case 105:
          if (b >= e || I[b] == null)
            break;
          a < d && (n += g.slice(a, d)), n += Math.floor(Number(I[b])), a = d + 2, d++;
          break;
        case 79:
        case 111:
        case 106:
          if (b >= e || I[b] === void 0)
            break;
          a < d && (n += g.slice(a, d));
          var Z = typeof I[b];
          if (Z === "string") {
            n += "'" + I[b] + "'", a = d + 2, d++;
            break;
          }
          if (Z === "function") {
            n += I[b].name || "<anonymous>", a = d + 2, d++;
            break;
          }
          n += A(I[b]), a = d + 2, d++;
          break;
        case 115:
          if (b >= e)
            break;
          a < d && (n += g.slice(a, d)), n += String(I[b]), a = d + 2, d++;
          break;
        case 37:
          a < d && (n += g.slice(a, d)), n += "%", a = d + 2, d++, b--;
          break;
      }
      ++b;
    }
    ++d;
  }
  return a === -1 ? g : (a < s && (n += g.slice(a)), n);
}
const Kn = d0;
Tl.exports = WI;
const FA = v0().console || {}, G0 = {
  mapHttpRequest: Vc,
  mapHttpResponse: Vc,
  wrapRequestSerializer: ut,
  wrapResponseSerializer: ut,
  wrapErrorSerializer: ut,
  req: Vc,
  res: Vc,
  err: qn,
  errWithCause: qn
};
function gl(g, I) {
  return g === "silent" ? 1 / 0 : I.levels.values[g];
}
const be = Symbol("pino.logFuncs"), Ii = Symbol("pino.hierarchy"), r0 = {
  error: "log",
  fatal: "error",
  warn: "error",
  info: "log",
  debug: "log",
  trace: "log"
};
function _n(g, I) {
  const C = {
    logger: I,
    parent: g[Ii]
  };
  I[Ii] = C;
}
function X0(g, I, C) {
  const A = {};
  I.forEach((c) => {
    A[c] = C[c] ? C[c] : FA[c] || FA[r0[c] || "log"] || zA;
  }), g[be] = A;
}
function Z0(g, I) {
  return Array.isArray(g) ? g.filter(function(A) {
    return A !== "!stdSerializers.err";
  }) : g === !0 ? Object.keys(I) : !1;
}
function WI(g) {
  g = g || {}, g.browser = g.browser || {};
  const I = g.browser.transmit;
  if (I && typeof I.send != "function")
    throw Error("pino: transmit option must have a send function");
  const C = g.browser.write || FA;
  g.browser.write && (g.browser.asObject = !0);
  const A = g.serializers || {}, c = Z0(g.browser.serialize, A);
  let l = g.browser.serialize;
  Array.isArray(g.browser.serialize) && g.browser.serialize.indexOf("!stdSerializers.err") > -1 && (l = !1);
  const t = Object.keys(g.customLevels || {}), i = ["error", "fatal", "warn", "info", "debug", "trace"].concat(t);
  typeof C == "function" && i.forEach(function(r) {
    C[r] = C;
  }), (g.enabled === !1 || g.browser.disabled) && (g.level = "silent");
  const e = g.level || "info", n = Object.create(C);
  n.log || (n.log = zA), X0(n, i, C), _n({}, n), Object.defineProperty(n, "levelVal", {
    get: a
  }), Object.defineProperty(n, "level", {
    get: s,
    set: d
  });
  const b = {
    transmit: I,
    serialize: c,
    asObject: g.browser.asObject,
    formatters: g.browser.formatters,
    levels: i,
    timestamp: p0(g)
  };
  n.levels = V0(g), n.level = e, n.setMaxListeners = n.getMaxListeners = n.emit = n.addListener = n.on = n.prependListener = n.once = n.prependOnceListener = n.removeListener = n.removeAllListeners = n.listeners = n.listenerCount = n.eventNames = n.write = n.flush = zA, n.serializers = A, n._serialize = c, n._stdErrSerialize = l, n.child = Z, I && (n._logEvent = Ci());
  function a() {
    return gl(this.level, this);
  }
  function s() {
    return this._level;
  }
  function d(r) {
    if (r !== "silent" && !this.levels.values[r])
      throw Error("unknown level " + r);
    this._level = r, _I(this, b, n, "error"), _I(this, b, n, "fatal"), _I(this, b, n, "warn"), _I(this, b, n, "info"), _I(this, b, n, "debug"), _I(this, b, n, "trace"), t.forEach((h) => {
      _I(this, b, n, h);
    });
  }
  function Z(r, h) {
    if (!r)
      throw new Error("missing bindings for child Pino");
    h = h || {}, c && r.serializers && (h.serializers = r.serializers);
    const x = h.serializers;
    if (c && x) {
      var u = Object.assign({}, A, x), G = g.browser.serialize === !0 ? Object.keys(u) : c;
      delete r.serializers, Ll([r], G, u, this._stdErrSerialize);
    }
    function V(W) {
      this._childLevel = (W._childLevel | 0) + 1, this.bindings = r, u && (this.serializers = u, this._serialize = G), I && (this._logEvent = Ci(
        [].concat(W._logEvent.bindings, r)
      ));
    }
    V.prototype = this;
    const X = new V(this);
    return _n(this, X), X.level = this.level, X;
  }
  return n;
}
function V0(g) {
  const I = g.customLevels || {}, C = Object.assign({}, WI.levels.values, I), A = Object.assign({}, WI.levels.labels, m0(I));
  return {
    values: C,
    labels: A
  };
}
function m0(g) {
  const I = {};
  return Object.keys(g).forEach(function(C) {
    I[g[C]] = C;
  }), I;
}
WI.levels = {
  values: {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10
  },
  labels: {
    10: "trace",
    20: "debug",
    30: "info",
    40: "warn",
    50: "error",
    60: "fatal"
  }
};
WI.stdSerializers = G0;
WI.stdTimeFunctions = Object.assign({}, { nullTime: mu, epochTime: hu, unixTime: R0, isoTime: B0 });
function h0(g) {
  const I = [];
  g.bindings && I.push(g.bindings);
  let C = g[Ii];
  for (; C.parent; )
    C = C.parent, C.logger.bindings && I.push(C.logger.bindings);
  return I.reverse();
}
function _I(g, I, C, A) {
  if (Object.defineProperty(g, A, {
    value: gl(g.level, C) > gl(A, C) ? zA : C[be][A],
    writable: !0,
    enumerable: !0,
    configurable: !0
  }), !I.transmit && g[A] === zA)
    return;
  g[A] = N0(g, I, C, A);
  const c = h0(g);
  c.length !== 0 && (g[A] = W0(c, g[A]));
}
function W0(g, I) {
  return function() {
    return I.apply(this, [...g, ...arguments]);
  };
}
function N0(g, I, C, A) {
  return function(c) {
    return function() {
      const t = I.timestamp(), i = new Array(arguments.length), e = Object.getPrototypeOf && Object.getPrototypeOf(this) === FA ? FA : this;
      for (var n = 0; n < i.length; n++)
        i[n] = arguments[n];
      if (I.serialize && !I.asObject && Ll(i, this._serialize, this.serializers, this._stdErrSerialize), I.asObject || I.formatters ? c.call(e, x0(this, A, i, t, I.formatters)) : c.apply(e, i), I.transmit) {
        const b = I.transmit.level || g._level, a = C.levels.values[b], s = C.levels.values[A];
        if (s < a)
          return;
        y0(this, {
          ts: t,
          methodLevel: A,
          methodValue: s,
          transmitLevel: b,
          transmitValue: C.levels.values[I.transmit.level || g._level],
          send: I.transmit.send,
          val: gl(g._level, C)
        }, i);
      }
    };
  }(g[be][A]);
}
function x0(g, I, C, A, c = {}) {
  const {
    level: l = () => g.levels.values[I],
    log: t = (s) => s
  } = c;
  g._serialize && Ll(C, g._serialize, g.serializers, g._stdErrSerialize);
  const i = C.slice();
  let e = i[0];
  const n = {};
  A && (n.time = A), n.level = l(I, g.levels.values[I]);
  let b = (g._childLevel | 0) + 1;
  if (b < 1 && (b = 1), e !== null && typeof e == "object") {
    for (; b-- && typeof i[0] == "object"; )
      Object.assign(n, i.shift());
    e = i.length ? Kn(i.shift(), i) : void 0;
  } else
    typeof e == "string" && (e = Kn(i.shift(), i));
  return e !== void 0 && (n.msg = e), t(n);
}
function Ll(g, I, C, A) {
  for (const c in g)
    if (A && g[c] instanceof Error)
      g[c] = WI.stdSerializers.err(g[c]);
    else if (typeof g[c] == "object" && !Array.isArray(g[c]))
      for (const l in g[c])
        I && I.indexOf(l) > -1 && l in C && (g[c][l] = C[l](g[c][l]));
}
function y0(g, I, C) {
  const A = I.send, c = I.ts, l = I.methodLevel, t = I.methodValue, i = I.val, e = g._logEvent.bindings;
  Ll(
    C,
    g._serialize || Object.keys(g.serializers),
    g.serializers,
    g._stdErrSerialize === void 0 ? !0 : g._stdErrSerialize
  ), g._logEvent.ts = c, g._logEvent.messages = C.filter(function(n) {
    return e.indexOf(n) === -1;
  }), g._logEvent.level.label = l, g._logEvent.level.value = t, A(l, g._logEvent, i), g._logEvent = Ci(e);
}
function Ci(g) {
  return {
    ts: 0,
    messages: [],
    bindings: g || [],
    level: { label: "", value: 0 }
  };
}
function qn(g) {
  const I = {
    type: g.constructor.name,
    msg: g.message,
    stack: g.stack
  };
  for (const C in g)
    I[C] === void 0 && (I[C] = g[C]);
  return I;
}
function p0(g) {
  return typeof g.timestamp == "function" ? g.timestamp : g.timestamp === !1 ? mu : hu;
}
function Vc() {
  return {};
}
function ut(g) {
  return g;
}
function zA() {
}
function mu() {
  return !1;
}
function hu() {
  return Date.now();
}
function R0() {
  return Math.round(Date.now() / 1e3);
}
function B0() {
  return new Date(Date.now()).toISOString();
}
function v0() {
  function g(I) {
    return typeof I < "u" && I;
  }
  try {
    return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
      get: function() {
        return delete Object.prototype.globalThis, this.globalThis = this;
      },
      configurable: !0
    }), globalThis;
  } catch {
    return g(self) || g(window) || g(this) || {};
  }
}
Tl.exports.default = WI;
Tl.exports.pino = WI;
var J0 = Tl.exports;
const Y0 = /* @__PURE__ */ ou(J0);
class F0 {
  constructor() {
    rc(this, "logger");
    /**
     * 서버와 log level을 동기화 하기 위한 설정
     * @see {@link https://github.com/winstonjs/winston#logging-levels Winston log level}
     */
    rc(this, "defaultLogLevelMap");
    this.defaultLogLevelMap = {
      error: 3,
      warn: 4,
      info: 6,
      debug: 7
    }, this.logger = Y0(), this.logger.levels = {
      labels: ie(this.defaultLogLevelMap),
      values: this.defaultLogLevelMap
    };
  }
  debug(I) {
    this.log("debug", I);
  }
  info(I) {
    this.log("info", I);
  }
  warn(I) {
    this.log("warn", I);
  }
  error(I) {
    this.log("error", I);
  }
  log(I, C) {
    if (this.isLogLevelKey(I)) {
      this.logger[I](C);
      return;
    }
    const A = this.findLoggerTypeForSyslogLevel(I);
    A && this.logger[A](C);
  }
  isLogLevelKey(I) {
    return typeof I == "string" && Sl(Object.keys(this.defaultLogLevelMap), I);
  }
  findLoggerTypeForSyslogLevel(I) {
    const C = this.logger.levels.labels[I];
    return this.isLogLevelKey(C) ? C : null;
  }
}
const $n = new F0(), z0 = 10 * 1e3, f0 = [nt.NOT_FOUND, nt.UNAUTHORIZED, nt.BAD_PARAMETER];
class gA extends ks {
  static from(I) {
    return new gA({
      credentials: "include",
      timeout: z0,
      ...I
    });
  }
  afterRequest(I, C, A, c) {
    if (GA.isHandledResponse(c)) {
      const l = GA.createApiError(c, {
        status: I,
        handled: !0,
        extra: c,
        url: A.path
      }), {
        level: t,
        message: i
      } = l.logMessage();
      throw $n[t](i), l;
    }
    return c;
  }
  performError(I) {
    if (!(I instanceof DOMException && I.name === "AbortError") && GA.isUnhandledResponse(I)) {
      const C = GA.createApiError({
        statusCode: wr[I.status] || String(I.status),
        message: `[${I.name}] ${I.url} | ${I}`,
        data: null
      }, {
        handled: !1,
        url: I.url,
        status: I.status
      }, f0), {
        level: A,
        message: c
      } = C.logMessage();
      $n[A](c);
    }
  }
}
const Ul = gA.from({
  baseUrl: OV
}), H0 = gA.from({
  baseUrl: jV
}), w0 = gA.from({
  baseUrl: EV
}), S0 = gA.from({
  baseUrl: QV
});
var Wu = /* @__PURE__ */ ((g) => (g.OK = "OK", g.SERVER_ERROR = "SERVER_ERROR", g.DUPLICATE = "DUPLICATE", g.NOT_FOUND = "NOT_FOUND", g.BAD_REQUEST = "BAD_REQUEST", g.BAD_PARAMETER = "BAD_PARAMETER", g.CONFLICT = "CONFLICT", g.UNAUTHORIZED = "UNAUTHORIZED", g.FORBIDDEN = "FORBIDDEN", g.PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE", g.TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS", g))(Wu || {});
const g3 = {
  V1_MESSAGE: "/user/api/v1/messages/unchecked",
  V1_USER_META: "/v1/user/meta",
  V1_GROUP_BY_USER: "/v1/group/by-user",
  V1_GROUP_ID_NOTICE_EXPOSURE: (g) => `/v1/group/${g}/notice/exposure`,
  V1_NOTICE_EXPOSURE: "/v1/notice/exposure"
}, T0 = async (g, I) => Ul.get(g, I);
function I3({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) {
  var l;
  const c = ug(g, () => T0(I, A), C);
  return {
    ...c,
    data: (l = c.data) == null ? void 0 : l.data
  };
}
const L0 = async (g, I) => Ul.get(g, I);
function C3({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) {
  var l;
  const c = ug(g, () => L0(I, A), C);
  return {
    ...c,
    data: (l = c.data) == null ? void 0 : l.data
  };
}
const U0 = async (g, I) => Ul.get(g, I);
function A3({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) {
  var l;
  const c = ug(g, () => U0(I, A), C);
  return {
    ...c,
    data: (l = c.data) == null ? void 0 : l.data
  };
}
const P0 = async (g, I) => Ul.get(g, I);
function c3({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) {
  var l;
  const c = ug(g, () => P0(I, A), C);
  return {
    ...c,
    data: (l = c.data) == null ? void 0 : l.data
  };
}
const $A = () => typeof window < "u", l3 = () => typeof document < "u", t3 = () => typeof window < "u", VI = (g) => {
  if (typeof window > "u")
    return "";
  try {
    return new URLSearchParams(window.location.search).get(g) ?? "";
  } catch {
    return "";
  }
}, k0 = (g) => new URL(g).hostname.split(".").slice(-2).join("."), D0 = (g) => {
  try {
    const I = k0(ne);
    if (!I)
      return !1;
    const C = new URL(g).hostname;
    return C === I || C.endsWith(`.${I}`);
  } catch {
    return !1;
  }
}, Pl = (g) => g.replace(/^\/(ko|en|ja|vi)(\/|$)/, "/"), eI = {
  COURSES: (g) => g === "/courses" || g.startsWith("/courses/") || g.startsWith("/course/"),
  CHALLENGES: (g) => g.startsWith("/challenges") || g.startsWith("/challenge"),
  MENTORING: (g, I) => I === $c || g.startsWith("/mentors"),
  ROADMAPS: (g) => g.startsWith("/roadmaps"),
  SEARCH: (g) => g.startsWith("/search"),
  CLIPS: (g) => g.startsWith("/clips") || g.startsWith("/clip"),
  COMMUNITY: (g) => g.startsWith("/community")
}, Nu = {
  COURSES: (g) => g === "/" || g === "/courses" || g.startsWith("/courses/"),
  CHALLENGES: (g) => g === "/challenges",
  MENTORING: (g) => g === "/mentors",
  ROADMAPS: (g) => g === "/roadmaps",
  SEARCH: (g) => g === "/search",
  CLIPS: (g) => g === "/clips",
  COMMUNITY: (g) => g === "/community"
}, O0 = () => {
  if (!$A())
    return !1;
  const g = window.location.pathname, I = Pl(g);
  return Object.values(Nu).some((C) => C(I));
}, j0 = (g) => {
  const I = Pl(g);
  return Object.values(Nu).some((C) => C(I));
}, gb = (g) => {
  if (!$A())
    return !1;
  const I = window.location.pathname, C = window.location.origin, A = Pl(I);
  return D0(C) ? C === $c ? g === "MENTORING" : g === "COURSES" ? eI.COURSES(A) : g === "ROADMAPS" ? eI.ROADMAPS(A) : g === "CLIPS" ? eI.CLIPS(A) : g === "CHALLENGES" ? eI.CHALLENGES(A) : g === "COMMUNITY" ? eI.COMMUNITY(A) : !1 : !1;
}, Ib = () => {
  if (!$A())
    return "COURSES";
  const g = window.location.pathname, I = window.location.origin, C = VI("types"), A = Pl(g);
  return eI.ROADMAPS(A) ? "ROADMAPS" : eI.CHALLENGES(A) ? "CHALLENGES" : eI.MENTORING(A, I) ? "MENTORING" : eI.CLIPS(A) ? "CLIPS" : C === "CHALLENGE" ? "CHALLENGES" : eI.COMMUNITY(A) ? "COMMUNITY" : "COURSES";
}, kc = "gnb_snapshot", xu = {
  COURSES: "courses",
  // 강의 메뉴
  ROADMAPS: "roadmaps",
  // 로드맵 메뉴
  MENTORING: "mentoring",
  // 멘토링 메뉴
  COMMUNITY: "community",
  // 커뮤니티 메뉴
  CHALLENGES: "challenges",
  // 챌린지 메뉴
  INSTRUCTOR: "instructor",
  // 강사 메뉴
  BUSINESS: "business",
  // 비즈니스 메뉴
  clips: "clips"
  // 클립 메뉴
}, Il = {
  SHOW_MENU: "data-show-menu",
  // 메뉴 표시 여부 (예: data-show-menu-courses="1")
  LABEL: "data-label",
  // 메뉴 라벨 텍스트 (예: data-label-courses="강의")
  SHOW_BUTTON: "data-show-button",
  // 버튼 표시 여부 (예: data-show-button-profile="1")
  COUNT: "data-count",
  // 카운트 값 (예: data-count-cart="3")
  FEATURE: "data-feature",
  // A/B 테스트 플래그 (예: data-feature-196="1")
  SHOW_SEARCH_BAR: "data-show-search-bar"
  // 검색바 표시 여부 (예: data-show-search-bar="1")
}, Ai = {
  LABEL: "--label",
  // 메뉴 라벨 (예: --label-courses: "강의")
  CART_COUNT: "--cart-count",
  // 장바구니 개수 (예: --cart-count: "3")
  GNB_LOGO_URL: "--gnb-logo-url",
  // GNB 로고 이미지 (예: --gnb-logo-url: url('logo.png'))
  PROFILE_THUMBNAIL_URL: "--profile-thumbnail-url"
  // 프로필 썸네일 (예: --profile-thumbnail-url: url('thumb.jpg'))
};
function Cb(g) {
  const I = {};
  return g && g.split(";").forEach((C) => {
    const A = C.indexOf("=");
    if (A < 0)
      return;
    const c = decodeURIComponent(C.slice(0, A).trim()), l = decodeURIComponent(C.slice(A + 1).trim());
    c && (I[c] = l);
  }), I;
}
function E0(g) {
  return (g == null ? void 0 : g.cookieHeader) != null ? Cb(g.cookieHeader) : typeof document < "u" ? Cb(document.cookie) : {};
}
function Q0(g) {
  if (g)
    try {
      return JSON.parse(g);
    } catch {
      return;
    }
}
const M0 = (g) => g ? `url('${g.replace(/'/g, "\\'")}')` : "none", Ab = (g) => g ? "1" : "0", K0 = (g) => g == null || g === "" ? "0" : "1", _0 = (g) => (g ?? "").toString(), yu = (g) => `'${(g ?? "").replace(/'/g, "\\'")}'`, q0 = (g, I) => {
  const C = {}, A = {};
  return Object.values(xu).forEach((c) => {
    const l = g[c], t = c === "courses" || I;
    C[`${Il.SHOW_MENU}-${c}`] = t ? K0(l) : "0", A[`${Il.LABEL}-${c}`] = _0(l);
  }), {
    visibilityAttributes: C,
    labelAttributes: A
  };
}, $0 = (g) => {
  const I = {};
  return Object.values(xu).forEach((C) => {
    const A = g[C];
    I[`${Ai.LABEL}-${C}`] = yu(A);
  }), I;
};
function gm(g, I) {
  const C = {
    attrs: {},
    cssVars: {}
  };
  if (!g)
    return C;
  const A = g.menuList || {}, c = g.lang === "ko", {
    visibilityAttributes: l,
    labelAttributes: t
  } = q0(A, c), i = $0(A);
  Object.assign(C.cssVars, i), C.cssVars[`${Ai.LABEL}-language`] = yu(g.lang), Object.assign(C.attrs, l, t);
  const e = I != null && I.pathname ? j0(I.pathname) : !1;
  if (C.attrs[Il.SHOW_SEARCH_BAR] = Ab(e), g.hackleFeatures)
    for (const [n, b] of Object.entries(g.hackleFeatures))
      C.attrs[`${Il.FEATURE}-${n}`] = Ab(!!b);
  return C.cssVars[Ai.GNB_LOGO_URL] = M0(g.logo), C;
}
function i3(g) {
  const I = E0(g), C = Q0(I[kc]), A = g != null && g.overwrite ? uu({}, C, g.overwrite) : C;
  return gm(A, {
    pathname: g == null ? void 0 : g.pathname
  });
}
function Im(g, I = "html", C = !1) {
  if (typeof document > "u")
    return C;
  const c = (I === "html" ? document.documentElement : I === "body" ? document.body : document.querySelector(I) || document.documentElement).getAttribute(g);
  return c === null ? C : c === "1" || c === "true" || c === "True";
}
function e3(g, I = "html", C = "") {
  if (typeof document > "u")
    return C;
  const c = (I === "html" ? document.documentElement : I === "body" ? document.body : document.querySelector(I) || document.documentElement).getAttribute(g);
  return c === null ? C : c;
}
function n3(g, I = "html") {
  if (typeof document > "u")
    return;
  const C = I === "html" ? document.documentElement : I === "body" ? document.body : document.querySelector(I) || document.documentElement;
  Object.entries(g.attrs).forEach(([A, c]) => C.setAttribute(A, c)), Object.entries(g.cssVars).forEach(([A, c]) => C.style.setProperty(A, c));
}
function Cm(g) {
  return g / (24 * 60);
}
const Am = 60 * 24, pu = () => {
  const g = k((C) => {
    const A = I(), c = typeof document < "u" && document.documentElement.lang || "ko", l = {
      ...C,
      lang: c
    };
    Pc.set(kc, JSON.stringify(uu({}, A, l)), Cm(Am), "High");
  }, []), I = k(() => {
    const C = Pc.get(kc);
    if (!C)
      return null;
    try {
      return JSON.parse(C);
    } catch (A) {
      return console.error("Failed to parse GNB Snapshot:", A), Pc.remove(kc), null;
    }
  }, []);
  return {
    setSnapshot: g,
    getSnapshot: I
  };
}, ci = (g) => !!g.group || !!g.managedGroup, cm = (g) => !!g.group, lm = (g) => !!g.managedGroup, tm = (g) => !!g.marketingPartner, im = 42, em = 6233, b3 = (g) => g === em || g === im, ae = H0, li = {
  CLIENT_V2_ACCOUNTS_PROFILE: "/client/api/v2/accounts/profile",
  CLIENT_V2_AUTH_SIGNIN: "/client/api/v2/auth/signin",
  CLIENT_V3_AUTH_SIGNUP_VERIFY_EMAIL: "/client/api/v3/auth/signup/verify/email"
};
function a3({
  url: g,
  options: I,
  requestOptions: C
}) {
  var c;
  const A = _C({
    mutationFn: (l) => ae.post(g, l, C),
    ...I
  });
  return {
    ...A,
    data: (c = A.data) == null ? void 0 : c.data
  };
}
function s3({
  url: g,
  options: I,
  requestOptions: C
}) {
  var c;
  const A = _C({
    mutationFn: (l) => ae.post(g, l, C),
    ...I
  });
  return {
    ...A,
    data: (c = A.data) == null ? void 0 : c.data
  };
}
const nm = async (g, I) => ae.get(g, I), bm = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => nm(I, A),
  ...C
});
function am(g) {
  var C;
  const I = ug(bm(g));
  return {
    ...I,
    data: (C = I.data) == null ? void 0 : C.data
  };
}
const u3 = (g) => g * (24 * (60 * (1e3 * 60))), d3 = (g) => g * 1e3, cb = (g) => g * (1e3 * 60);
function sm(g) {
  const I = g == null ? void 0 : g.options;
  return am({
    queryKey: [li.CLIENT_V2_ACCOUNTS_PROFILE],
    url: li.CLIENT_V2_ACCOUNTS_PROFILE,
    options: {
      cacheTime: cb(1),
      staleTime: cb(1),
      suspense: !1,
      useErrorBoundary: !1,
      keepPreviousData: !0,
      refetchOnReconnect: !0,
      ...I
    }
  });
}
const Ru = jg(null), o3 = (g) => /* @__PURE__ */ o(Ru.Provider, { value: {
  isShowing: g.isShowing
}, children: g.children }), um = () => {
  const g = Zg(Ru);
  if (!g)
    throw Error("useShowLoginNeededNotificationContext must use in ShowLoginNeededNotificationContext");
  return g;
};
function dm(g) {
  const {
    isShowing: I
  } = um(), {
    showNotification: C
  } = Mi(), {
    t: A
  } = UI();
  q(() => {
    g instanceof GA && g.statusCode === Wu.UNAUTHORIZED && I && (Wr("UNAUTHORIZED"), C({
      type: "error",
      id: "UNAUTHORIZED",
      title: A("로그인이 필요한 요청입니다.")
    }));
  }, [I, g]);
}
var Bu = {}, om = (g) => encodeURIComponent(g).replace(/[!'()*]/g, (I) => `%${I.charCodeAt(0).toString(16).toUpperCase()}`), vu = "%[a-f0-9]{2}", lb = new RegExp("(" + vu + ")|([^%]+?)", "gi"), tb = new RegExp("(" + vu + ")+", "gi");
function ti(g, I) {
  try {
    return [decodeURIComponent(g.join(""))];
  } catch {
  }
  if (g.length === 1)
    return g;
  I = I || 1;
  var C = g.slice(0, I), A = g.slice(I);
  return Array.prototype.concat.call([], ti(C), ti(A));
}
function Gm(g) {
  try {
    return decodeURIComponent(g);
  } catch {
    for (var I = g.match(lb) || [], C = 1; C < I.length; C++)
      g = ti(I, C).join(""), I = g.match(lb) || [];
    return g;
  }
}
function rm(g) {
  for (var I = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  }, C = tb.exec(g); C; ) {
    try {
      I[C[0]] = decodeURIComponent(C[0]);
    } catch {
      var A = Gm(C[0]);
      A !== C[0] && (I[C[0]] = A);
    }
    C = tb.exec(g);
  }
  I["%C2"] = "�";
  for (var c = Object.keys(I), l = 0; l < c.length; l++) {
    var t = c[l];
    g = g.replace(new RegExp(t, "g"), I[t]);
  }
  return g;
}
var Xm = function(g) {
  if (typeof g != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof g + "`");
  try {
    return g = g.replace(/\+/g, " "), decodeURIComponent(g);
  } catch {
    return rm(g);
  }
}, Zm = (g, I) => {
  if (!(typeof g == "string" && typeof I == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (I === "")
    return [g];
  const C = g.indexOf(I);
  return C === -1 ? [g] : [
    g.slice(0, C),
    g.slice(C + I.length)
  ];
}, Vm = function(g, I) {
  for (var C = {}, A = Object.keys(g), c = Array.isArray(I), l = 0; l < A.length; l++) {
    var t = A[l], i = g[t];
    (c ? I.indexOf(t) !== -1 : I(t, i, g)) && (C[t] = i);
  }
  return C;
};
(function(g) {
  const I = om, C = Xm, A = Zm, c = Vm, l = (u) => u == null, t = Symbol("encodeFragmentIdentifier");
  function i(u) {
    switch (u.arrayFormat) {
      case "index":
        return (G) => (V, X) => {
          const W = V.length;
          return X === void 0 || u.skipNull && X === null || u.skipEmptyString && X === "" ? V : X === null ? [...V, [b(G, u), "[", W, "]"].join("")] : [
            ...V,
            [b(G, u), "[", b(W, u), "]=", b(X, u)].join("")
          ];
        };
      case "bracket":
        return (G) => (V, X) => X === void 0 || u.skipNull && X === null || u.skipEmptyString && X === "" ? V : X === null ? [...V, [b(G, u), "[]"].join("")] : [...V, [b(G, u), "[]=", b(X, u)].join("")];
      case "colon-list-separator":
        return (G) => (V, X) => X === void 0 || u.skipNull && X === null || u.skipEmptyString && X === "" ? V : X === null ? [...V, [b(G, u), ":list="].join("")] : [...V, [b(G, u), ":list=", b(X, u)].join("")];
      case "comma":
      case "separator":
      case "bracket-separator": {
        const G = u.arrayFormat === "bracket-separator" ? "[]=" : "=";
        return (V) => (X, W) => W === void 0 || u.skipNull && W === null || u.skipEmptyString && W === "" ? X : (W = W === null ? "" : W, X.length === 0 ? [[b(V, u), G, b(W, u)].join("")] : [[X, b(W, u)].join(u.arrayFormatSeparator)]);
      }
      default:
        return (G) => (V, X) => X === void 0 || u.skipNull && X === null || u.skipEmptyString && X === "" ? V : X === null ? [...V, b(G, u)] : [...V, [b(G, u), "=", b(X, u)].join("")];
    }
  }
  function e(u) {
    let G;
    switch (u.arrayFormat) {
      case "index":
        return (V, X, W) => {
          if (G = /\[(\d*)\]$/.exec(V), V = V.replace(/\[\d*\]$/, ""), !G) {
            W[V] = X;
            return;
          }
          W[V] === void 0 && (W[V] = {}), W[V][G[1]] = X;
        };
      case "bracket":
        return (V, X, W) => {
          if (G = /(\[\])$/.exec(V), V = V.replace(/\[\]$/, ""), !G) {
            W[V] = X;
            return;
          }
          if (W[V] === void 0) {
            W[V] = [X];
            return;
          }
          W[V] = [].concat(W[V], X);
        };
      case "colon-list-separator":
        return (V, X, W) => {
          if (G = /(:list)$/.exec(V), V = V.replace(/:list$/, ""), !G) {
            W[V] = X;
            return;
          }
          if (W[V] === void 0) {
            W[V] = [X];
            return;
          }
          W[V] = [].concat(W[V], X);
        };
      case "comma":
      case "separator":
        return (V, X, W) => {
          const N = typeof X == "string" && X.includes(u.arrayFormatSeparator), m = typeof X == "string" && !N && a(X, u).includes(u.arrayFormatSeparator);
          X = m ? a(X, u) : X;
          const p = N || m ? X.split(u.arrayFormatSeparator).map((Y) => a(Y, u)) : X === null ? X : a(X, u);
          W[V] = p;
        };
      case "bracket-separator":
        return (V, X, W) => {
          const N = /(\[\])$/.test(V);
          if (V = V.replace(/\[\]$/, ""), !N) {
            W[V] = X && a(X, u);
            return;
          }
          const m = X === null ? [] : X.split(u.arrayFormatSeparator).map((p) => a(p, u));
          if (W[V] === void 0) {
            W[V] = m;
            return;
          }
          W[V] = [].concat(W[V], m);
        };
      default:
        return (V, X, W) => {
          if (W[V] === void 0) {
            W[V] = X;
            return;
          }
          W[V] = [].concat(W[V], X);
        };
    }
  }
  function n(u) {
    if (typeof u != "string" || u.length !== 1)
      throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function b(u, G) {
    return G.encode ? G.strict ? I(u) : encodeURIComponent(u) : u;
  }
  function a(u, G) {
    return G.decode ? C(u) : u;
  }
  function s(u) {
    return Array.isArray(u) ? u.sort() : typeof u == "object" ? s(Object.keys(u)).sort((G, V) => Number(G) - Number(V)).map((G) => u[G]) : u;
  }
  function d(u) {
    const G = u.indexOf("#");
    return G !== -1 && (u = u.slice(0, G)), u;
  }
  function Z(u) {
    let G = "";
    const V = u.indexOf("#");
    return V !== -1 && (G = u.slice(V)), G;
  }
  function r(u) {
    u = d(u);
    const G = u.indexOf("?");
    return G === -1 ? "" : u.slice(G + 1);
  }
  function h(u, G) {
    return G.parseNumbers && !Number.isNaN(Number(u)) && typeof u == "string" && u.trim() !== "" ? u = Number(u) : G.parseBooleans && u !== null && (u.toLowerCase() === "true" || u.toLowerCase() === "false") && (u = u.toLowerCase() === "true"), u;
  }
  function x(u, G) {
    G = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1
    }, G), n(G.arrayFormatSeparator);
    const V = e(G), X = /* @__PURE__ */ Object.create(null);
    if (typeof u != "string" || (u = u.trim().replace(/^[?#&]/, ""), !u))
      return X;
    for (const W of u.split("&")) {
      if (W === "")
        continue;
      let [N, m] = A(G.decode ? W.replace(/\+/g, " ") : W, "=");
      m = m === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(G.arrayFormat) ? m : a(m, G), V(a(N, G), m, X);
    }
    for (const W of Object.keys(X)) {
      const N = X[W];
      if (typeof N == "object" && N !== null)
        for (const m of Object.keys(N))
          N[m] = h(N[m], G);
      else
        X[W] = h(N, G);
    }
    return G.sort === !1 ? X : (G.sort === !0 ? Object.keys(X).sort() : Object.keys(X).sort(G.sort)).reduce((W, N) => {
      const m = X[N];
      return m && typeof m == "object" && !Array.isArray(m) ? W[N] = s(m) : W[N] = m, W;
    }, /* @__PURE__ */ Object.create(null));
  }
  g.extract = r, g.parse = x, g.stringify = (u, G) => {
    if (!u)
      return "";
    G = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ","
    }, G), n(G.arrayFormatSeparator);
    const V = (m) => G.skipNull && l(u[m]) || G.skipEmptyString && u[m] === "", X = i(G), W = {};
    for (const m of Object.keys(u))
      V(m) || (W[m] = u[m]);
    const N = Object.keys(W);
    return G.sort !== !1 && N.sort(G.sort), N.map((m) => {
      const p = u[m];
      return p === void 0 ? "" : p === null ? b(m, G) : Array.isArray(p) ? p.length === 0 && G.arrayFormat === "bracket-separator" ? b(m, G) + "[]" : p.reduce(X(m), []).join("&") : b(m, G) + "=" + b(p, G);
    }).filter((m) => m.length > 0).join("&");
  }, g.parseUrl = (u, G) => {
    G = Object.assign({
      decode: !0
    }, G);
    const [V, X] = A(u, "#");
    return Object.assign(
      {
        url: V.split("?")[0] || "",
        query: x(r(u), G)
      },
      G && G.parseFragmentIdentifier && X ? { fragmentIdentifier: a(X, G) } : {}
    );
  }, g.stringifyUrl = (u, G) => {
    G = Object.assign({
      encode: !0,
      strict: !0,
      [t]: !0
    }, G);
    const V = d(u.url).split("?")[0] || "", X = g.extract(u.url), W = g.parse(X, { sort: !1 }), N = Object.assign(W, u.query);
    let m = g.stringify(N, G);
    m && (m = `?${m}`);
    let p = Z(u.url);
    return u.fragmentIdentifier && (p = `#${G[t] ? b(u.fragmentIdentifier, G) : u.fragmentIdentifier}`), `${V}${m}${p}`;
  }, g.pick = (u, G, V) => {
    V = Object.assign({
      parseFragmentIdentifier: !0,
      [t]: !1
    }, V);
    const { url: X, query: W, fragmentIdentifier: N } = g.parseUrl(u, V);
    return g.stringifyUrl({
      url: X,
      query: c(W, G),
      fragmentIdentifier: N
    }, V);
  }, g.exclude = (u, G, V) => {
    const X = Array.isArray(G) ? (W) => !G.includes(W) : (W, N) => !G(W, N);
    return g.pick(u, X, V);
  };
})(Bu);
const tI = /* @__PURE__ */ ou(Bu), Og = {
  CLICK_SEARCHBAR: "click_searchbar",
  GNB_NOTI_ICON_CLICK: "GNB_noti-icon-click",
  GNB_ROADMAP_CLICK: "GNB_roadmap-click",
  GNB_PROFILE_ICON_CLICK: "GNB_profile-icon-click",
  GNB_OPENKNOWLEDGE_CLICK: "GNB_openknowledge-click",
  GNB_MENTORS_CLICK: "GNB_mentors-click",
  GNB_LOGIN_BTN_CLICK: "GNB_login-btn-click",
  CLICK_CATEGORY_AT_HEADER: "click_category_at_header",
  VIEW_SIGNIN_MODAL: "view_signin_modal",
  CLICK_SIGNIN_AT_SIGNIN: "click_signin_at_signin",
  CLICK_FIND_ID_AT_SIGNIN: "click_find_id_at_signin",
  CLICK_FIND_PW_AT_SIGNIN: "click_find_pw_at_signin",
  CLICK_SIGNUP_AT_SIGNIN: "click_signup_at_signin",
  /**
   * @deprecated 헤더 '인프런' 메뉴 deprecated
   * */
  GNB_COURSES_CLICK: "GNB_courses-click",
  GNB_COMMUNITY_CLICK: "GNB_community-click",
  GNB_CART_COURSE_CLICK: "GNB_cart-course-click",
  GNB_CART_TOTAL_CLICK: "GNB_cart-total-click",
  GNB_INFLEARN_LOGO_CLICK: "GNB_inflearn-logo-click",
  GNB_CART_ICON_CLICK: "GNB_cart-icon-click",
  GNB_RALLIT_CLICK: "GNB_Rallit_Click",
  GNB_SEARCH_ICON_CLICK: "GNB_search-icon-click",
  GNB_SEARCH_INPUT_CLICK: "GNB_search-input-click",
  GNB_DASHBOARD_CLICK: "GNB_dashboard-click",
  HEADER_BUSINESS_CLICK: "Header_business-click",
  HEADER_INFLEARN_CLICK: "Header_inflearn-click",
  HEADER_INSTRUCTOR_CLICK: "Header_instructor-click",
  HEADER_BIZ_INTRO_CLICK: "header_biz-intro-click",
  COMPLETE_SIGNUP: "complete_signup",
  COMPLETE_REGISTRATION: "complete_registration",
  CLICK_WELCOME_BUTTON: "click_welcome_button",
  CLICK_MYCATEGORY_GUIDE_BUTTON: "click_mycategory_guide_button",
  VIEW_MYCATEGORY: "view_mycategory",
  CLICK_SAVE_MYCATEGORY: "click_save_mycategory",
  SEARCH_COURSE: "search_course",
  EXPERIMENT_STARTED: "experiment_started",
  /**
   * 신규 헤더 신규 이벤트
   */
  CLICK_HEADER_MENU: "click_header_menu",
  CLICK_LOGO_AT_HEADER: "click_logo_at_header",
  CLICK_LOGIN_AT_HEADER: "click_login_at_header",
  CLICK_CART_AT_HEADER: "click_cart_at_header",
  CLICK_PROFILE_MENU_AT_HEADER: "click_profile_menu_at_header",
  CLICK_CATEGORY_AT_SEARCHBAR: "click_category_at_searchbar",
  CLICK_HEADER_MENU_AT_SEARCHBAR: "click_header_menu_at_searchbar",
  CLICK_RECOMMENDATION_AT_SEARCHBAR: "click_recommendation_at_searchbar",
  CLICK_HEADER_NOTICE: "click_header_notice",
  CLICK_SERVICE_MENU_AT_HEADER: "click_service_menu_at_header"
};
var vC = { ko: "ko", en: "en", ja: "ja", vi: "vi" }, EC = vC.ko;
Object.values(vC);
var mm = { [vC.ko]: "82", [vC.en]: "1", [vC.ja]: "81", [vC.vi]: "84" }, Pg = { ko: "ko-KR", en: "en-US", ja: "ja-JP", vi: "vi-VN" };
function se() {
  let { i18n: g } = hg();
  return tg(() => {
    let I = g.language || EC;
    return { lang: I, locale: Pg[I], countryCode: mm[I], isKo: I === EC };
  }, [g.language]);
}
var hm = ({ children: g }) => {
  let { isKo: I } = se();
  return Yl(Us, { children: I && g });
};
qi.extend(Hr);
qi.extend(fr);
qi.updateLocale("ko", { formats: { L: "YYYY. MM. DD.", LL: "YYYY년 MM월 DD일", LT: "A h:mm" } });
var XA = { [Pg.ko]: "KRW", [Pg.en]: "USD", [Pg.ja]: "JPY", [Pg.vi]: "VND" }, Wm = { [XA[Pg.ko]]: Pg.ko, [XA[Pg.en]]: Pg.en, [XA[Pg.ja]]: Pg.ja, [XA[Pg.vi]]: Pg.vi }, Nm = (g, I) => new Intl.NumberFormat(g, { style: "currency", currency: I }), xm = ({ locale: g, amount: I, currency: C, hiddenKRW: A = !1, leftSection: c = "", rightSection: l = "", ...t }) => {
  let i = g ?? Wm[C ?? Pg.ko], e = C ?? XA[i], n = tg(() => Nm(i, e), [i, e]), b = tg(() => A && g === Pg.ko ? I.toLocaleString() : n.format(Number(I)), [g, n, I, A]);
  return Yl(U, { ...t, children: Ps(Us, { children: [c, b, l] }) });
};
Nr(xm);
const K = (g) => typeof g == "string", bA = () => {
  let g, I;
  const C = new Promise((A, c) => {
    g = A, I = c;
  });
  return C.resolve = g, C.reject = I, C;
}, ib = (g) => g == null ? "" : "" + g, ym = (g, I, C) => {
  g.forEach((A) => {
    I[A] && (C[A] = I[A]);
  });
}, pm = /###/g, eb = (g) => g && g.indexOf("###") > -1 ? g.replace(pm, ".") : g, nb = (g) => !g || K(g), hA = (g, I, C) => {
  const A = K(I) ? I.split(".") : I;
  let c = 0;
  for (; c < A.length - 1; ) {
    if (nb(g))
      return {};
    const l = eb(A[c]);
    !g[l] && C && (g[l] = new C()), Object.prototype.hasOwnProperty.call(g, l) ? g = g[l] : g = {}, ++c;
  }
  return nb(g) ? {} : {
    obj: g,
    k: eb(A[c])
  };
}, bb = (g, I, C) => {
  const {
    obj: A,
    k: c
  } = hA(g, I, Object);
  if (A !== void 0 || I.length === 1) {
    A[c] = C;
    return;
  }
  let l = I[I.length - 1], t = I.slice(0, I.length - 1), i = hA(g, t, Object);
  for (; i.obj === void 0 && t.length; )
    l = `${t[t.length - 1]}.${l}`, t = t.slice(0, t.length - 1), i = hA(g, t, Object), i && i.obj && typeof i.obj[`${i.k}.${l}`] < "u" && (i.obj = void 0);
  i.obj[`${i.k}.${l}`] = C;
}, Rm = (g, I, C, A) => {
  const {
    obj: c,
    k: l
  } = hA(g, I, Object);
  c[l] = c[l] || [], c[l].push(C);
}, Cl = (g, I) => {
  const {
    obj: C,
    k: A
  } = hA(g, I);
  if (C)
    return C[A];
}, Bm = (g, I, C) => {
  const A = Cl(g, C);
  return A !== void 0 ? A : Cl(I, C);
}, Ju = (g, I, C) => {
  for (const A in I)
    A !== "__proto__" && A !== "constructor" && (A in g ? K(g[A]) || g[A] instanceof String || K(I[A]) || I[A] instanceof String ? C && (g[A] = I[A]) : Ju(g[A], I[A], C) : g[A] = I[A]);
  return g;
}, NC = (g) => g.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var vm = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const Jm = (g) => K(g) ? g.replace(/[&<>"'\/]/g, (I) => vm[I]) : g;
class Ym {
  constructor(I) {
    this.capacity = I, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(I) {
    const C = this.regExpMap.get(I);
    if (C !== void 0)
      return C;
    const A = new RegExp(I);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(I, A), this.regExpQueue.push(I), A;
  }
}
const Fm = [" ", ",", "?", "!", ";"], zm = new Ym(20), fm = (g, I, C) => {
  I = I || "", C = C || "";
  const A = Fm.filter((t) => I.indexOf(t) < 0 && C.indexOf(t) < 0);
  if (A.length === 0)
    return !0;
  const c = zm.getRegExp(`(${A.map((t) => t === "?" ? "\\?" : t).join("|")})`);
  let l = !c.test(g);
  if (!l) {
    const t = g.indexOf(C);
    t > 0 && !c.test(g.substring(0, t)) && (l = !0);
  }
  return l;
}, ii = function(g, I) {
  let C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!g)
    return;
  if (g[I])
    return g[I];
  const A = I.split(C);
  let c = g;
  for (let l = 0; l < A.length; ) {
    if (!c || typeof c != "object")
      return;
    let t, i = "";
    for (let e = l; e < A.length; ++e)
      if (e !== l && (i += C), i += A[e], t = c[i], t !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof t) > -1 && e < A.length - 1)
          continue;
        l += e - l + 1;
        break;
      }
    c = t;
  }
  return c;
}, Al = (g) => g && g.replace("_", "-"), Hm = {
  type: "logger",
  log(g) {
    this.output("log", g);
  },
  warn(g) {
    this.output("warn", g);
  },
  error(g) {
    this.output("error", g);
  },
  output(g, I) {
    console && console[g] && console[g].apply(console, I);
  }
};
class cl {
  constructor(I) {
    let C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(I, C);
  }
  init(I) {
    let C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = C.prefix || "i18next:", this.logger = I || Hm, this.options = C, this.debug = C.debug;
  }
  log() {
    for (var I = arguments.length, C = new Array(I), A = 0; A < I; A++)
      C[A] = arguments[A];
    return this.forward(C, "log", "", !0);
  }
  warn() {
    for (var I = arguments.length, C = new Array(I), A = 0; A < I; A++)
      C[A] = arguments[A];
    return this.forward(C, "warn", "", !0);
  }
  error() {
    for (var I = arguments.length, C = new Array(I), A = 0; A < I; A++)
      C[A] = arguments[A];
    return this.forward(C, "error", "");
  }
  deprecate() {
    for (var I = arguments.length, C = new Array(I), A = 0; A < I; A++)
      C[A] = arguments[A];
    return this.forward(C, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(I, C, A, c) {
    return c && !this.debug ? null : (K(I[0]) && (I[0] = `${A}${this.prefix} ${I[0]}`), this.logger[C](I));
  }
  create(I) {
    return new cl(this.logger, {
      prefix: `${this.prefix}:${I}:`,
      ...this.options
    });
  }
  clone(I) {
    return I = I || this.options, I.prefix = I.prefix || this.prefix, new cl(this.logger, I);
  }
}
var nI = new cl();
class kl {
  constructor() {
    this.observers = {};
  }
  on(I, C) {
    return I.split(" ").forEach((A) => {
      this.observers[A] || (this.observers[A] = /* @__PURE__ */ new Map());
      const c = this.observers[A].get(C) || 0;
      this.observers[A].set(C, c + 1);
    }), this;
  }
  off(I, C) {
    if (this.observers[I]) {
      if (!C) {
        delete this.observers[I];
        return;
      }
      this.observers[I].delete(C);
    }
  }
  emit(I) {
    for (var C = arguments.length, A = new Array(C > 1 ? C - 1 : 0), c = 1; c < C; c++)
      A[c - 1] = arguments[c];
    this.observers[I] && Array.from(this.observers[I].entries()).forEach((t) => {
      let [i, e] = t;
      for (let n = 0; n < e; n++)
        i(...A);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((t) => {
      let [i, e] = t;
      for (let n = 0; n < e; n++)
        i.apply(i, [I, ...A]);
    });
  }
}
class ab extends kl {
  constructor(I) {
    let C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = I || {}, this.options = C, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(I) {
    this.options.ns.indexOf(I) < 0 && this.options.ns.push(I);
  }
  removeNamespaces(I) {
    const C = this.options.ns.indexOf(I);
    C > -1 && this.options.ns.splice(C, 1);
  }
  getResource(I, C, A) {
    let c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const l = c.keySeparator !== void 0 ? c.keySeparator : this.options.keySeparator, t = c.ignoreJSONStructure !== void 0 ? c.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let i;
    I.indexOf(".") > -1 ? i = I.split(".") : (i = [I, C], A && (Array.isArray(A) ? i.push(...A) : K(A) && l ? i.push(...A.split(l)) : i.push(A)));
    const e = Cl(this.data, i);
    return !e && !C && !A && I.indexOf(".") > -1 && (I = i[0], C = i[1], A = i.slice(2).join(".")), e || !t || !K(A) ? e : ii(this.data && this.data[I] && this.data[I][C], A, l);
  }
  addResource(I, C, A, c) {
    let l = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const t = l.keySeparator !== void 0 ? l.keySeparator : this.options.keySeparator;
    let i = [I, C];
    A && (i = i.concat(t ? A.split(t) : A)), I.indexOf(".") > -1 && (i = I.split("."), c = C, C = i[1]), this.addNamespaces(C), bb(this.data, i, c), l.silent || this.emit("added", I, C, A, c);
  }
  addResources(I, C, A) {
    let c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const l in A)
      (K(A[l]) || Array.isArray(A[l])) && this.addResource(I, C, l, A[l], {
        silent: !0
      });
    c.silent || this.emit("added", I, C, A);
  }
  addResourceBundle(I, C, A, c, l) {
    let t = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, i = [I, C];
    I.indexOf(".") > -1 && (i = I.split("."), c = A, A = C, C = i[1]), this.addNamespaces(C);
    let e = Cl(this.data, i) || {};
    t.skipCopy || (A = JSON.parse(JSON.stringify(A))), c ? Ju(e, A, l) : e = {
      ...e,
      ...A
    }, bb(this.data, i, e), t.silent || this.emit("added", I, C, A);
  }
  removeResourceBundle(I, C) {
    this.hasResourceBundle(I, C) && delete this.data[I][C], this.removeNamespaces(C), this.emit("removed", I, C);
  }
  hasResourceBundle(I, C) {
    return this.getResource(I, C) !== void 0;
  }
  getResourceBundle(I, C) {
    return C || (C = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(I, C)
    } : this.getResource(I, C);
  }
  getDataByLanguage(I) {
    return this.data[I];
  }
  hasLanguageSomeTranslations(I) {
    const C = this.getDataByLanguage(I);
    return !!(C && Object.keys(C) || []).find((c) => C[c] && Object.keys(C[c]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Yu = {
  processors: {},
  addPostProcessor(g) {
    this.processors[g.name] = g;
  },
  handle(g, I, C, A, c) {
    return g.forEach((l) => {
      this.processors[l] && (I = this.processors[l].process(I, C, A, c));
    }), I;
  }
};
const sb = {};
class ll extends kl {
  constructor(I) {
    let C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), ym(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], I, this), this.options = C, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = nI.create("translator");
  }
  changeLanguage(I) {
    I && (this.language = I);
  }
  exists(I) {
    let C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (I == null)
      return !1;
    const A = this.resolve(I, C);
    return A && A.res !== void 0;
  }
  extractFromKey(I, C) {
    let A = C.nsSeparator !== void 0 ? C.nsSeparator : this.options.nsSeparator;
    A === void 0 && (A = ":");
    const c = C.keySeparator !== void 0 ? C.keySeparator : this.options.keySeparator;
    let l = C.ns || this.options.defaultNS || [];
    const t = A && I.indexOf(A) > -1, i = !this.options.userDefinedKeySeparator && !C.keySeparator && !this.options.userDefinedNsSeparator && !C.nsSeparator && !fm(I, A, c);
    if (t && !i) {
      const e = I.match(this.interpolator.nestingRegexp);
      if (e && e.length > 0)
        return {
          key: I,
          namespaces: l
        };
      const n = I.split(A);
      (A !== c || A === c && this.options.ns.indexOf(n[0]) > -1) && (l = n.shift()), I = n.join(c);
    }
    return K(l) && (l = [l]), {
      key: I,
      namespaces: l
    };
  }
  translate(I, C, A) {
    if (typeof C != "object" && this.options.overloadTranslationOptionHandler && (C = this.options.overloadTranslationOptionHandler(arguments)), typeof C == "object" && (C = {
      ...C
    }), C || (C = {}), I == null)
      return "";
    Array.isArray(I) || (I = [String(I)]);
    const c = C.returnDetails !== void 0 ? C.returnDetails : this.options.returnDetails, l = C.keySeparator !== void 0 ? C.keySeparator : this.options.keySeparator, {
      key: t,
      namespaces: i
    } = this.extractFromKey(I[I.length - 1], C), e = i[i.length - 1], n = C.lng || this.language, b = C.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (n && n.toLowerCase() === "cimode") {
      if (b) {
        const V = C.nsSeparator || this.options.nsSeparator;
        return c ? {
          res: `${e}${V}${t}`,
          usedKey: t,
          exactUsedKey: t,
          usedLng: n,
          usedNS: e,
          usedParams: this.getUsedParamsDetails(C)
        } : `${e}${V}${t}`;
      }
      return c ? {
        res: t,
        usedKey: t,
        exactUsedKey: t,
        usedLng: n,
        usedNS: e,
        usedParams: this.getUsedParamsDetails(C)
      } : t;
    }
    const a = this.resolve(I, C);
    let s = a && a.res;
    const d = a && a.usedKey || t, Z = a && a.exactUsedKey || t, r = Object.prototype.toString.apply(s), h = ["[object Number]", "[object Function]", "[object RegExp]"], x = C.joinArrays !== void 0 ? C.joinArrays : this.options.joinArrays, u = !this.i18nFormat || this.i18nFormat.handleAsObject, G = !K(s) && typeof s != "boolean" && typeof s != "number";
    if (u && s && G && h.indexOf(r) < 0 && !(K(x) && Array.isArray(s))) {
      if (!C.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const V = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(d, s, {
          ...C,
          ns: i
        }) : `key '${t} (${this.language})' returned an object instead of string.`;
        return c ? (a.res = V, a.usedParams = this.getUsedParamsDetails(C), a) : V;
      }
      if (l) {
        const V = Array.isArray(s), X = V ? [] : {}, W = V ? Z : d;
        for (const N in s)
          if (Object.prototype.hasOwnProperty.call(s, N)) {
            const m = `${W}${l}${N}`;
            X[N] = this.translate(m, {
              ...C,
              joinArrays: !1,
              ns: i
            }), X[N] === m && (X[N] = s[N]);
          }
        s = X;
      }
    } else if (u && K(x) && Array.isArray(s))
      s = s.join(x), s && (s = this.extendTranslation(s, I, C, A));
    else {
      let V = !1, X = !1;
      const W = C.count !== void 0 && !K(C.count), N = ll.hasDefaultValue(C), m = W ? this.pluralResolver.getSuffix(n, C.count, C) : "", p = C.ordinal && W ? this.pluralResolver.getSuffix(n, C.count, {
        ordinal: !1
      }) : "", Y = W && !C.ordinal && C.count === 0 && this.pluralResolver.shouldUseIntlApi(), v = Y && C[`defaultValue${this.options.pluralSeparator}zero`] || C[`defaultValue${m}`] || C[`defaultValue${p}`] || C.defaultValue;
      !this.isValidLookup(s) && N && (V = !0, s = v), this.isValidLookup(s) || (X = !0, s = t);
      const cg = (C.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && X ? void 0 : s, z = N && v !== s && this.options.updateMissing;
      if (X || V || z) {
        if (this.logger.log(z ? "updateKey" : "missingKey", n, e, t, z ? v : s), l) {
          const B = this.resolve(t, {
            ...C,
            keySeparator: !1
          });
          B && B.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let J = [];
        const y = this.languageUtils.getFallbackCodes(this.options.fallbackLng, C.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && y && y[0])
          for (let B = 0; B < y.length; B++)
            J.push(y[B]);
        else
          this.options.saveMissingTo === "all" ? J = this.languageUtils.toResolveHierarchy(C.lng || this.language) : J.push(C.lng || this.language);
        const f = (B, H, F) => {
          const E = N && F !== s ? F : cg;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(B, e, H, E, z, C) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(B, e, H, E, z, C), this.emit("missingKey", B, e, H, s);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && W ? J.forEach((B) => {
          const H = this.pluralResolver.getSuffixes(B, C);
          Y && C[`defaultValue${this.options.pluralSeparator}zero`] && H.indexOf(`${this.options.pluralSeparator}zero`) < 0 && H.push(`${this.options.pluralSeparator}zero`), H.forEach((F) => {
            f([B], t + F, C[`defaultValue${F}`] || v);
          });
        }) : f(J, t, v));
      }
      s = this.extendTranslation(s, I, C, a, A), X && s === t && this.options.appendNamespaceToMissingKey && (s = `${e}:${t}`), (X || V) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? s = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${e}:${t}` : t, V ? s : void 0) : s = this.options.parseMissingKeyHandler(s));
    }
    return c ? (a.res = s, a.usedParams = this.getUsedParamsDetails(C), a) : s;
  }
  extendTranslation(I, C, A, c, l) {
    var t = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      I = this.i18nFormat.parse(I, {
        ...this.options.interpolation.defaultVariables,
        ...A
      }, A.lng || this.language || c.usedLng, c.usedNS, c.usedKey, {
        resolved: c
      });
    else if (!A.skipInterpolation) {
      A.interpolation && this.interpolator.init({
        ...A,
        interpolation: {
          ...this.options.interpolation,
          ...A.interpolation
        }
      });
      const n = K(I) && (A && A.interpolation && A.interpolation.skipOnVariables !== void 0 ? A.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let b;
      if (n) {
        const s = I.match(this.interpolator.nestingRegexp);
        b = s && s.length;
      }
      let a = A.replace && !K(A.replace) ? A.replace : A;
      if (this.options.interpolation.defaultVariables && (a = {
        ...this.options.interpolation.defaultVariables,
        ...a
      }), I = this.interpolator.interpolate(I, a, A.lng || this.language || c.usedLng, A), n) {
        const s = I.match(this.interpolator.nestingRegexp), d = s && s.length;
        b < d && (A.nest = !1);
      }
      !A.lng && this.options.compatibilityAPI !== "v1" && c && c.res && (A.lng = this.language || c.usedLng), A.nest !== !1 && (I = this.interpolator.nest(I, function() {
        for (var s = arguments.length, d = new Array(s), Z = 0; Z < s; Z++)
          d[Z] = arguments[Z];
        return l && l[0] === d[0] && !A.context ? (t.logger.warn(`It seems you are nesting recursively key: ${d[0]} in key: ${C[0]}`), null) : t.translate(...d, C);
      }, A)), A.interpolation && this.interpolator.reset();
    }
    const i = A.postProcess || this.options.postProcess, e = K(i) ? [i] : i;
    return I != null && e && e.length && A.applyPostProcessor !== !1 && (I = Yu.handle(e, I, C, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...c,
        usedParams: this.getUsedParamsDetails(A)
      },
      ...A
    } : A, this)), I;
  }
  resolve(I) {
    let C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, A, c, l, t, i;
    return K(I) && (I = [I]), I.forEach((e) => {
      if (this.isValidLookup(A))
        return;
      const n = this.extractFromKey(e, C), b = n.key;
      c = b;
      let a = n.namespaces;
      this.options.fallbackNS && (a = a.concat(this.options.fallbackNS));
      const s = C.count !== void 0 && !K(C.count), d = s && !C.ordinal && C.count === 0 && this.pluralResolver.shouldUseIntlApi(), Z = C.context !== void 0 && (K(C.context) || typeof C.context == "number") && C.context !== "", r = C.lngs ? C.lngs : this.languageUtils.toResolveHierarchy(C.lng || this.language, C.fallbackLng);
      a.forEach((h) => {
        this.isValidLookup(A) || (i = h, !sb[`${r[0]}-${h}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(i) && (sb[`${r[0]}-${h}`] = !0, this.logger.warn(`key "${c}" for languages "${r.join(", ")}" won't get resolved as namespace "${i}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), r.forEach((x) => {
          if (this.isValidLookup(A))
            return;
          t = x;
          const u = [b];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(u, b, x, h, C);
          else {
            let V;
            s && (V = this.pluralResolver.getSuffix(x, C.count, C));
            const X = `${this.options.pluralSeparator}zero`, W = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (s && (u.push(b + V), C.ordinal && V.indexOf(W) === 0 && u.push(b + V.replace(W, this.options.pluralSeparator)), d && u.push(b + X)), Z) {
              const N = `${b}${this.options.contextSeparator}${C.context}`;
              u.push(N), s && (u.push(N + V), C.ordinal && V.indexOf(W) === 0 && u.push(N + V.replace(W, this.options.pluralSeparator)), d && u.push(N + X));
            }
          }
          let G;
          for (; G = u.pop(); )
            this.isValidLookup(A) || (l = G, A = this.getResource(x, h, G, C));
        }));
      });
    }), {
      res: A,
      usedKey: c,
      exactUsedKey: l,
      usedLng: t,
      usedNS: i
    };
  }
  isValidLookup(I) {
    return I !== void 0 && !(!this.options.returnNull && I === null) && !(!this.options.returnEmptyString && I === "");
  }
  getResource(I, C, A) {
    let c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(I, C, A, c) : this.resourceStore.getResource(I, C, A, c);
  }
  getUsedParamsDetails() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const C = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], A = I.replace && !K(I.replace);
    let c = A ? I.replace : I;
    if (A && typeof I.count < "u" && (c.count = I.count), this.options.interpolation.defaultVariables && (c = {
      ...this.options.interpolation.defaultVariables,
      ...c
    }), !A) {
      c = {
        ...c
      };
      for (const l of C)
        delete c[l];
    }
    return c;
  }
  static hasDefaultValue(I) {
    const C = "defaultValue";
    for (const A in I)
      if (Object.prototype.hasOwnProperty.call(I, A) && C === A.substring(0, C.length) && I[A] !== void 0)
        return !0;
    return !1;
  }
}
const dt = (g) => g.charAt(0).toUpperCase() + g.slice(1);
class ub {
  constructor(I) {
    this.options = I, this.supportedLngs = this.options.supportedLngs || !1, this.logger = nI.create("languageUtils");
  }
  getScriptPartFromCode(I) {
    if (I = Al(I), !I || I.indexOf("-") < 0)
      return null;
    const C = I.split("-");
    return C.length === 2 || (C.pop(), C[C.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(C.join("-"));
  }
  getLanguagePartFromCode(I) {
    if (I = Al(I), !I || I.indexOf("-") < 0)
      return I;
    const C = I.split("-");
    return this.formatLanguageCode(C[0]);
  }
  formatLanguageCode(I) {
    if (K(I) && I.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let c = Intl.getCanonicalLocales(I)[0];
          if (c && this.options.lowerCaseLng && (c = c.toLowerCase()), c)
            return c;
        } catch {
        }
      const C = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let A = I.split("-");
      return this.options.lowerCaseLng ? A = A.map((c) => c.toLowerCase()) : A.length === 2 ? (A[0] = A[0].toLowerCase(), A[1] = A[1].toUpperCase(), C.indexOf(A[1].toLowerCase()) > -1 && (A[1] = dt(A[1].toLowerCase()))) : A.length === 3 && (A[0] = A[0].toLowerCase(), A[1].length === 2 && (A[1] = A[1].toUpperCase()), A[0] !== "sgn" && A[2].length === 2 && (A[2] = A[2].toUpperCase()), C.indexOf(A[1].toLowerCase()) > -1 && (A[1] = dt(A[1].toLowerCase())), C.indexOf(A[2].toLowerCase()) > -1 && (A[2] = dt(A[2].toLowerCase()))), A.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? I.toLowerCase() : I;
  }
  isSupportedCode(I) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (I = this.getLanguagePartFromCode(I)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(I) > -1;
  }
  getBestMatchFromCodes(I) {
    if (!I)
      return null;
    let C;
    return I.forEach((A) => {
      if (C)
        return;
      const c = this.formatLanguageCode(A);
      (!this.options.supportedLngs || this.isSupportedCode(c)) && (C = c);
    }), !C && this.options.supportedLngs && I.forEach((A) => {
      if (C)
        return;
      const c = this.getLanguagePartFromCode(A);
      if (this.isSupportedCode(c))
        return C = c;
      C = this.options.supportedLngs.find((l) => {
        if (l === c)
          return l;
        if (!(l.indexOf("-") < 0 && c.indexOf("-") < 0) && (l.indexOf("-") > 0 && c.indexOf("-") < 0 && l.substring(0, l.indexOf("-")) === c || l.indexOf(c) === 0 && c.length > 1))
          return l;
      });
    }), C || (C = this.getFallbackCodes(this.options.fallbackLng)[0]), C;
  }
  getFallbackCodes(I, C) {
    if (!I)
      return [];
    if (typeof I == "function" && (I = I(C)), K(I) && (I = [I]), Array.isArray(I))
      return I;
    if (!C)
      return I.default || [];
    let A = I[C];
    return A || (A = I[this.getScriptPartFromCode(C)]), A || (A = I[this.formatLanguageCode(C)]), A || (A = I[this.getLanguagePartFromCode(C)]), A || (A = I.default), A || [];
  }
  toResolveHierarchy(I, C) {
    const A = this.getFallbackCodes(C || this.options.fallbackLng || [], I), c = [], l = (t) => {
      t && (this.isSupportedCode(t) ? c.push(t) : this.logger.warn(`rejecting language code not found in supportedLngs: ${t}`));
    };
    return K(I) && (I.indexOf("-") > -1 || I.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && l(this.formatLanguageCode(I)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && l(this.getScriptPartFromCode(I)), this.options.load !== "currentOnly" && l(this.getLanguagePartFromCode(I))) : K(I) && l(this.formatLanguageCode(I)), A.forEach((t) => {
      c.indexOf(t) < 0 && l(this.formatLanguageCode(t));
    }), c;
  }
}
let wm = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Sm = {
  1: (g) => +(g > 1),
  2: (g) => +(g != 1),
  3: (g) => 0,
  4: (g) => g % 10 == 1 && g % 100 != 11 ? 0 : g % 10 >= 2 && g % 10 <= 4 && (g % 100 < 10 || g % 100 >= 20) ? 1 : 2,
  5: (g) => g == 0 ? 0 : g == 1 ? 1 : g == 2 ? 2 : g % 100 >= 3 && g % 100 <= 10 ? 3 : g % 100 >= 11 ? 4 : 5,
  6: (g) => g == 1 ? 0 : g >= 2 && g <= 4 ? 1 : 2,
  7: (g) => g == 1 ? 0 : g % 10 >= 2 && g % 10 <= 4 && (g % 100 < 10 || g % 100 >= 20) ? 1 : 2,
  8: (g) => g == 1 ? 0 : g == 2 ? 1 : g != 8 && g != 11 ? 2 : 3,
  9: (g) => +(g >= 2),
  10: (g) => g == 1 ? 0 : g == 2 ? 1 : g < 7 ? 2 : g < 11 ? 3 : 4,
  11: (g) => g == 1 || g == 11 ? 0 : g == 2 || g == 12 ? 1 : g > 2 && g < 20 ? 2 : 3,
  12: (g) => +(g % 10 != 1 || g % 100 == 11),
  13: (g) => +(g !== 0),
  14: (g) => g == 1 ? 0 : g == 2 ? 1 : g == 3 ? 2 : 3,
  15: (g) => g % 10 == 1 && g % 100 != 11 ? 0 : g % 10 >= 2 && (g % 100 < 10 || g % 100 >= 20) ? 1 : 2,
  16: (g) => g % 10 == 1 && g % 100 != 11 ? 0 : g !== 0 ? 1 : 2,
  17: (g) => g == 1 || g % 10 == 1 && g % 100 != 11 ? 0 : 1,
  18: (g) => g == 0 ? 0 : g == 1 ? 1 : 2,
  19: (g) => g == 1 ? 0 : g == 0 || g % 100 > 1 && g % 100 < 11 ? 1 : g % 100 > 10 && g % 100 < 20 ? 2 : 3,
  20: (g) => g == 1 ? 0 : g == 0 || g % 100 > 0 && g % 100 < 20 ? 1 : 2,
  21: (g) => g % 100 == 1 ? 1 : g % 100 == 2 ? 2 : g % 100 == 3 || g % 100 == 4 ? 3 : 0,
  22: (g) => g == 1 ? 0 : g == 2 ? 1 : (g < 0 || g > 10) && g % 10 == 0 ? 2 : 3
};
const Tm = ["v1", "v2", "v3"], Lm = ["v4"], db = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Um = () => {
  const g = {};
  return wm.forEach((I) => {
    I.lngs.forEach((C) => {
      g[C] = {
        numbers: I.nr,
        plurals: Sm[I.fc]
      };
    });
  }), g;
};
class Pm {
  constructor(I) {
    let C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = I, this.options = C, this.logger = nI.create("pluralResolver"), (!this.options.compatibilityJSON || Lm.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Um(), this.pluralRulesCache = {};
  }
  addRule(I, C) {
    this.rules[I] = C;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(I) {
    let C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        const A = Al(I === "dev" ? "en" : I), c = C.ordinal ? "ordinal" : "cardinal", l = JSON.stringify({
          cleanedCode: A,
          type: c
        });
        if (l in this.pluralRulesCache)
          return this.pluralRulesCache[l];
        const t = new Intl.PluralRules(A, {
          type: c
        });
        return this.pluralRulesCache[l] = t, t;
      } catch {
        return;
      }
    return this.rules[I] || this.rules[this.languageUtils.getLanguagePartFromCode(I)];
  }
  needsPlural(I) {
    let C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const A = this.getRule(I, C);
    return this.shouldUseIntlApi() ? A && A.resolvedOptions().pluralCategories.length > 1 : A && A.numbers.length > 1;
  }
  getPluralFormsOfKey(I, C) {
    let A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(I, A).map((c) => `${C}${c}`);
  }
  getSuffixes(I) {
    let C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const A = this.getRule(I, C);
    return A ? this.shouldUseIntlApi() ? A.resolvedOptions().pluralCategories.sort((c, l) => db[c] - db[l]).map((c) => `${this.options.prepend}${C.ordinal ? `ordinal${this.options.prepend}` : ""}${c}`) : A.numbers.map((c) => this.getSuffix(I, c, C)) : [];
  }
  getSuffix(I, C) {
    let A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const c = this.getRule(I, A);
    return c ? this.shouldUseIntlApi() ? `${this.options.prepend}${A.ordinal ? `ordinal${this.options.prepend}` : ""}${c.select(C)}` : this.getSuffixRetroCompatible(c, C) : (this.logger.warn(`no plural rule found for: ${I}`), "");
  }
  getSuffixRetroCompatible(I, C) {
    const A = I.noAbs ? I.plurals(C) : I.plurals(Math.abs(C));
    let c = I.numbers[A];
    this.options.simplifyPluralSuffix && I.numbers.length === 2 && I.numbers[0] === 1 && (c === 2 ? c = "plural" : c === 1 && (c = ""));
    const l = () => this.options.prepend && c.toString() ? this.options.prepend + c.toString() : c.toString();
    return this.options.compatibilityJSON === "v1" ? c === 1 ? "" : typeof c == "number" ? `_plural_${c.toString()}` : l() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && I.numbers.length === 2 && I.numbers[0] === 1 ? l() : this.options.prepend && A.toString() ? this.options.prepend + A.toString() : A.toString();
  }
  shouldUseIntlApi() {
    return !Tm.includes(this.options.compatibilityJSON);
  }
}
const ob = function(g, I, C) {
  let A = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", c = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, l = Bm(g, I, C);
  return !l && c && K(C) && (l = ii(g, C, A), l === void 0 && (l = ii(I, C, A))), l;
}, ot = (g) => g.replace(/\$/g, "$$$$");
class km {
  constructor() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = nI.create("interpolator"), this.options = I, this.format = I.interpolation && I.interpolation.format || ((C) => C), this.init(I);
  }
  init() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    I.interpolation || (I.interpolation = {
      escapeValue: !0
    });
    const {
      escape: C,
      escapeValue: A,
      useRawValueToEscape: c,
      prefix: l,
      prefixEscaped: t,
      suffix: i,
      suffixEscaped: e,
      formatSeparator: n,
      unescapeSuffix: b,
      unescapePrefix: a,
      nestingPrefix: s,
      nestingPrefixEscaped: d,
      nestingSuffix: Z,
      nestingSuffixEscaped: r,
      nestingOptionsSeparator: h,
      maxReplaces: x,
      alwaysFormat: u
    } = I.interpolation;
    this.escape = C !== void 0 ? C : Jm, this.escapeValue = A !== void 0 ? A : !0, this.useRawValueToEscape = c !== void 0 ? c : !1, this.prefix = l ? NC(l) : t || "{{", this.suffix = i ? NC(i) : e || "}}", this.formatSeparator = n || ",", this.unescapePrefix = b ? "" : a || "-", this.unescapeSuffix = this.unescapePrefix ? "" : b || "", this.nestingPrefix = s ? NC(s) : d || NC("$t("), this.nestingSuffix = Z ? NC(Z) : r || NC(")"), this.nestingOptionsSeparator = h || ",", this.maxReplaces = x || 1e3, this.alwaysFormat = u !== void 0 ? u : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const I = (C, A) => C && C.source === A ? (C.lastIndex = 0, C) : new RegExp(A, "g");
    this.regexp = I(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = I(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = I(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(I, C, A, c) {
    let l, t, i;
    const e = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, n = (d) => {
      if (d.indexOf(this.formatSeparator) < 0) {
        const x = ob(C, e, d, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(x, void 0, A, {
          ...c,
          ...C,
          interpolationkey: d
        }) : x;
      }
      const Z = d.split(this.formatSeparator), r = Z.shift().trim(), h = Z.join(this.formatSeparator).trim();
      return this.format(ob(C, e, r, this.options.keySeparator, this.options.ignoreJSONStructure), h, A, {
        ...c,
        ...C,
        interpolationkey: r
      });
    };
    this.resetRegExp();
    const b = c && c.missingInterpolationHandler || this.options.missingInterpolationHandler, a = c && c.interpolation && c.interpolation.skipOnVariables !== void 0 ? c.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (d) => ot(d)
    }, {
      regex: this.regexp,
      safeValue: (d) => this.escapeValue ? ot(this.escape(d)) : ot(d)
    }].forEach((d) => {
      for (i = 0; l = d.regex.exec(I); ) {
        const Z = l[1].trim();
        if (t = n(Z), t === void 0)
          if (typeof b == "function") {
            const h = b(I, l, c);
            t = K(h) ? h : "";
          } else if (c && Object.prototype.hasOwnProperty.call(c, Z))
            t = "";
          else if (a) {
            t = l[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${Z} for interpolating ${I}`), t = "";
        else
          !K(t) && !this.useRawValueToEscape && (t = ib(t));
        const r = d.safeValue(t);
        if (I = I.replace(l[0], r), a ? (d.regex.lastIndex += t.length, d.regex.lastIndex -= l[0].length) : d.regex.lastIndex = 0, i++, i >= this.maxReplaces)
          break;
      }
    }), I;
  }
  nest(I, C) {
    let A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, c, l, t;
    const i = (e, n) => {
      const b = this.nestingOptionsSeparator;
      if (e.indexOf(b) < 0)
        return e;
      const a = e.split(new RegExp(`${b}[ ]*{`));
      let s = `{${a[1]}`;
      e = a[0], s = this.interpolate(s, t);
      const d = s.match(/'/g), Z = s.match(/"/g);
      (d && d.length % 2 === 0 && !Z || Z.length % 2 !== 0) && (s = s.replace(/'/g, '"'));
      try {
        t = JSON.parse(s), n && (t = {
          ...n,
          ...t
        });
      } catch (r) {
        return this.logger.warn(`failed parsing options string in nesting for key ${e}`, r), `${e}${b}${s}`;
      }
      return t.defaultValue && t.defaultValue.indexOf(this.prefix) > -1 && delete t.defaultValue, e;
    };
    for (; c = this.nestingRegexp.exec(I); ) {
      let e = [];
      t = {
        ...A
      }, t = t.replace && !K(t.replace) ? t.replace : t, t.applyPostProcessor = !1, delete t.defaultValue;
      let n = !1;
      if (c[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(c[1])) {
        const b = c[1].split(this.formatSeparator).map((a) => a.trim());
        c[1] = b.shift(), e = b, n = !0;
      }
      if (l = C(i.call(this, c[1].trim(), t), t), l && c[0] === I && !K(l))
        return l;
      K(l) || (l = ib(l)), l || (this.logger.warn(`missed to resolve ${c[1]} for nesting ${I}`), l = ""), n && (l = e.reduce((b, a) => this.format(b, a, A.lng, {
        ...A,
        interpolationkey: c[1].trim()
      }), l.trim())), I = I.replace(c[0], l), this.regexp.lastIndex = 0;
    }
    return I;
  }
}
const Dm = (g) => {
  let I = g.toLowerCase().trim();
  const C = {};
  if (g.indexOf("(") > -1) {
    const A = g.split("(");
    I = A[0].toLowerCase().trim();
    const c = A[1].substring(0, A[1].length - 1);
    I === "currency" && c.indexOf(":") < 0 ? C.currency || (C.currency = c.trim()) : I === "relativetime" && c.indexOf(":") < 0 ? C.range || (C.range = c.trim()) : c.split(";").forEach((t) => {
      if (t) {
        const [i, ...e] = t.split(":"), n = e.join(":").trim().replace(/^'+|'+$/g, ""), b = i.trim();
        C[b] || (C[b] = n), n === "false" && (C[b] = !1), n === "true" && (C[b] = !0), isNaN(n) || (C[b] = parseInt(n, 10));
      }
    });
  }
  return {
    formatName: I,
    formatOptions: C
  };
}, xC = (g) => {
  const I = {};
  return (C, A, c) => {
    let l = c;
    c && c.interpolationkey && c.formatParams && c.formatParams[c.interpolationkey] && c[c.interpolationkey] && (l = {
      ...l,
      [c.interpolationkey]: void 0
    });
    const t = A + JSON.stringify(l);
    let i = I[t];
    return i || (i = g(Al(A), c), I[t] = i), i(C);
  };
};
class Om {
  constructor() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = nI.create("formatter"), this.options = I, this.formats = {
      number: xC((C, A) => {
        const c = new Intl.NumberFormat(C, {
          ...A
        });
        return (l) => c.format(l);
      }),
      currency: xC((C, A) => {
        const c = new Intl.NumberFormat(C, {
          ...A,
          style: "currency"
        });
        return (l) => c.format(l);
      }),
      datetime: xC((C, A) => {
        const c = new Intl.DateTimeFormat(C, {
          ...A
        });
        return (l) => c.format(l);
      }),
      relativetime: xC((C, A) => {
        const c = new Intl.RelativeTimeFormat(C, {
          ...A
        });
        return (l) => c.format(l, A.range || "day");
      }),
      list: xC((C, A) => {
        const c = new Intl.ListFormat(C, {
          ...A
        });
        return (l) => c.format(l);
      })
    }, this.init(I);
  }
  init(I) {
    let C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = C.interpolation.formatSeparator || ",";
  }
  add(I, C) {
    this.formats[I.toLowerCase().trim()] = C;
  }
  addCached(I, C) {
    this.formats[I.toLowerCase().trim()] = xC(C);
  }
  format(I, C, A) {
    let c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const l = C.split(this.formatSeparator);
    if (l.length > 1 && l[0].indexOf("(") > 1 && l[0].indexOf(")") < 0 && l.find((i) => i.indexOf(")") > -1)) {
      const i = l.findIndex((e) => e.indexOf(")") > -1);
      l[0] = [l[0], ...l.splice(1, i)].join(this.formatSeparator);
    }
    return l.reduce((i, e) => {
      const {
        formatName: n,
        formatOptions: b
      } = Dm(e);
      if (this.formats[n]) {
        let a = i;
        try {
          const s = c && c.formatParams && c.formatParams[c.interpolationkey] || {}, d = s.locale || s.lng || c.locale || c.lng || A;
          a = this.formats[n](i, d, {
            ...b,
            ...c,
            ...s
          });
        } catch (s) {
          this.logger.warn(s);
        }
        return a;
      } else
        this.logger.warn(`there was no format function for ${n}`);
      return i;
    }, I);
  }
}
const jm = (g, I) => {
  g.pending[I] !== void 0 && (delete g.pending[I], g.pendingCount--);
};
class Em extends kl {
  constructor(I, C, A) {
    let c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = I, this.store = C, this.services = A, this.languageUtils = A.languageUtils, this.options = c, this.logger = nI.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = c.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = c.maxRetries >= 0 ? c.maxRetries : 5, this.retryTimeout = c.retryTimeout >= 1 ? c.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(A, c.backend, c);
  }
  queueLoad(I, C, A, c) {
    const l = {}, t = {}, i = {}, e = {};
    return I.forEach((n) => {
      let b = !0;
      C.forEach((a) => {
        const s = `${n}|${a}`;
        !A.reload && this.store.hasResourceBundle(n, a) ? this.state[s] = 2 : this.state[s] < 0 || (this.state[s] === 1 ? t[s] === void 0 && (t[s] = !0) : (this.state[s] = 1, b = !1, t[s] === void 0 && (t[s] = !0), l[s] === void 0 && (l[s] = !0), e[a] === void 0 && (e[a] = !0)));
      }), b || (i[n] = !0);
    }), (Object.keys(l).length || Object.keys(t).length) && this.queue.push({
      pending: t,
      pendingCount: Object.keys(t).length,
      loaded: {},
      errors: [],
      callback: c
    }), {
      toLoad: Object.keys(l),
      pending: Object.keys(t),
      toLoadLanguages: Object.keys(i),
      toLoadNamespaces: Object.keys(e)
    };
  }
  loaded(I, C, A) {
    const c = I.split("|"), l = c[0], t = c[1];
    C && this.emit("failedLoading", l, t, C), !C && A && this.store.addResourceBundle(l, t, A, void 0, void 0, {
      skipCopy: !0
    }), this.state[I] = C ? -1 : 2, C && A && (this.state[I] = 0);
    const i = {};
    this.queue.forEach((e) => {
      Rm(e.loaded, [l], t), jm(e, I), C && e.errors.push(C), e.pendingCount === 0 && !e.done && (Object.keys(e.loaded).forEach((n) => {
        i[n] || (i[n] = {});
        const b = e.loaded[n];
        b.length && b.forEach((a) => {
          i[n][a] === void 0 && (i[n][a] = !0);
        });
      }), e.done = !0, e.errors.length ? e.callback(e.errors) : e.callback());
    }), this.emit("loaded", i), this.queue = this.queue.filter((e) => !e.done);
  }
  read(I, C, A) {
    let c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, l = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, t = arguments.length > 5 ? arguments[5] : void 0;
    if (!I.length)
      return t(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: I,
        ns: C,
        fcName: A,
        tried: c,
        wait: l,
        callback: t
      });
      return;
    }
    this.readingCalls++;
    const i = (n, b) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const a = this.waitingReads.shift();
        this.read(a.lng, a.ns, a.fcName, a.tried, a.wait, a.callback);
      }
      if (n && b && c < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, I, C, A, c + 1, l * 2, t);
        }, l);
        return;
      }
      t(n, b);
    }, e = this.backend[A].bind(this.backend);
    if (e.length === 2) {
      try {
        const n = e(I, C);
        n && typeof n.then == "function" ? n.then((b) => i(null, b)).catch(i) : i(null, n);
      } catch (n) {
        i(n);
      }
      return;
    }
    return e(I, C, i);
  }
  prepareLoading(I, C) {
    let A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, c = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), c && c();
    K(I) && (I = this.languageUtils.toResolveHierarchy(I)), K(C) && (C = [C]);
    const l = this.queueLoad(I, C, A, c);
    if (!l.toLoad.length)
      return l.pending.length || c(), null;
    l.toLoad.forEach((t) => {
      this.loadOne(t);
    });
  }
  load(I, C, A) {
    this.prepareLoading(I, C, {}, A);
  }
  reload(I, C, A) {
    this.prepareLoading(I, C, {
      reload: !0
    }, A);
  }
  loadOne(I) {
    let C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const A = I.split("|"), c = A[0], l = A[1];
    this.read(c, l, "read", void 0, void 0, (t, i) => {
      t && this.logger.warn(`${C}loading namespace ${l} for language ${c} failed`, t), !t && i && this.logger.log(`${C}loaded namespace ${l} for language ${c}`, i), this.loaded(I, t, i);
    });
  }
  saveMissing(I, C, A, c, l) {
    let t = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, i = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(C)) {
      this.logger.warn(`did not save key "${A}" as the namespace "${C}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(A == null || A === "")) {
      if (this.backend && this.backend.create) {
        const e = {
          ...t,
          isUpdate: l
        }, n = this.backend.create.bind(this.backend);
        if (n.length < 6)
          try {
            let b;
            n.length === 5 ? b = n(I, C, A, c, e) : b = n(I, C, A, c), b && typeof b.then == "function" ? b.then((a) => i(null, a)).catch(i) : i(null, b);
          } catch (b) {
            i(b);
          }
        else
          n(I, C, A, c, i, e);
      }
      !I || !I[0] || this.store.addResource(I[0], C, A, c);
    }
  }
}
const Gb = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (g) => {
    let I = {};
    if (typeof g[1] == "object" && (I = g[1]), K(g[1]) && (I.defaultValue = g[1]), K(g[2]) && (I.tDescription = g[2]), typeof g[2] == "object" || typeof g[3] == "object") {
      const C = g[3] || g[2];
      Object.keys(C).forEach((A) => {
        I[A] = C[A];
      });
    }
    return I;
  },
  interpolation: {
    escapeValue: !0,
    format: (g) => g,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), rb = (g) => (K(g.ns) && (g.ns = [g.ns]), K(g.fallbackLng) && (g.fallbackLng = [g.fallbackLng]), K(g.fallbackNS) && (g.fallbackNS = [g.fallbackNS]), g.supportedLngs && g.supportedLngs.indexOf("cimode") < 0 && (g.supportedLngs = g.supportedLngs.concat(["cimode"])), g), mc = () => {
}, Qm = (g) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(g)).forEach((C) => {
    typeof g[C] == "function" && (g[C] = g[C].bind(g));
  });
};
class fA extends kl {
  constructor() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, C = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = rb(I), this.services = {}, this.logger = nI, this.modules = {
      external: []
    }, Qm(this), C && !this.isInitialized && !I.isClone) {
      if (!this.options.initImmediate)
        return this.init(I, C), this;
      setTimeout(() => {
        this.init(I, C);
      }, 0);
    }
  }
  init() {
    var I = this;
    let C = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, A = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof C == "function" && (A = C, C = {}), !C.defaultNS && C.defaultNS !== !1 && C.ns && (K(C.ns) ? C.defaultNS = C.ns : C.ns.indexOf("translation") < 0 && (C.defaultNS = C.ns[0]));
    const c = Gb();
    this.options = {
      ...c,
      ...this.options,
      ...rb(C)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...c.interpolation,
      ...this.options.interpolation
    }), C.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = C.keySeparator), C.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = C.nsSeparator);
    const l = (b) => b ? typeof b == "function" ? new b() : b : null;
    if (!this.options.isClone) {
      this.modules.logger ? nI.init(l(this.modules.logger), this.options) : nI.init(null, this.options);
      let b;
      this.modules.formatter ? b = this.modules.formatter : typeof Intl < "u" && (b = Om);
      const a = new ub(this.options);
      this.store = new ab(this.options.resources, this.options);
      const s = this.services;
      s.logger = nI, s.resourceStore = this.store, s.languageUtils = a, s.pluralResolver = new Pm(a, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), b && (!this.options.interpolation.format || this.options.interpolation.format === c.interpolation.format) && (s.formatter = l(b), s.formatter.init(s, this.options), this.options.interpolation.format = s.formatter.format.bind(s.formatter)), s.interpolator = new km(this.options), s.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, s.backendConnector = new Em(l(this.modules.backend), s.resourceStore, s, this.options), s.backendConnector.on("*", function(d) {
        for (var Z = arguments.length, r = new Array(Z > 1 ? Z - 1 : 0), h = 1; h < Z; h++)
          r[h - 1] = arguments[h];
        I.emit(d, ...r);
      }), this.modules.languageDetector && (s.languageDetector = l(this.modules.languageDetector), s.languageDetector.init && s.languageDetector.init(s, this.options.detection, this.options)), this.modules.i18nFormat && (s.i18nFormat = l(this.modules.i18nFormat), s.i18nFormat.init && s.i18nFormat.init(this)), this.translator = new ll(this.services, this.options), this.translator.on("*", function(d) {
        for (var Z = arguments.length, r = new Array(Z > 1 ? Z - 1 : 0), h = 1; h < Z; h++)
          r[h - 1] = arguments[h];
        I.emit(d, ...r);
      }), this.modules.external.forEach((d) => {
        d.init && d.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, A || (A = mc), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const b = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      b.length > 0 && b[0] !== "dev" && (this.options.lng = b[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((b) => {
      this[b] = function() {
        return I.store[b](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((b) => {
      this[b] = function() {
        return I.store[b](...arguments), I;
      };
    });
    const e = bA(), n = () => {
      const b = (a, s) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), e.resolve(s), A(a, s);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return b(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, b);
    };
    return this.options.resources || !this.options.initImmediate ? n() : setTimeout(n, 0), e;
  }
  loadResources(I) {
    let A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : mc;
    const c = K(I) ? I : this.language;
    if (typeof I == "function" && (A = I), !this.options.resources || this.options.partialBundledLanguages) {
      if (c && c.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return A();
      const l = [], t = (i) => {
        if (!i || i === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(i).forEach((n) => {
          n !== "cimode" && l.indexOf(n) < 0 && l.push(n);
        });
      };
      c ? t(c) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((e) => t(e)), this.options.preload && this.options.preload.forEach((i) => t(i)), this.services.backendConnector.load(l, this.options.ns, (i) => {
        !i && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), A(i);
      });
    } else
      A(null);
  }
  reloadResources(I, C, A) {
    const c = bA();
    return typeof I == "function" && (A = I, I = void 0), typeof C == "function" && (A = C, C = void 0), I || (I = this.languages), C || (C = this.options.ns), A || (A = mc), this.services.backendConnector.reload(I, C, (l) => {
      c.resolve(), A(l);
    }), c;
  }
  use(I) {
    if (!I)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!I.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return I.type === "backend" && (this.modules.backend = I), (I.type === "logger" || I.log && I.warn && I.error) && (this.modules.logger = I), I.type === "languageDetector" && (this.modules.languageDetector = I), I.type === "i18nFormat" && (this.modules.i18nFormat = I), I.type === "postProcessor" && Yu.addPostProcessor(I), I.type === "formatter" && (this.modules.formatter = I), I.type === "3rdParty" && this.modules.external.push(I), this;
  }
  setResolvedLanguage(I) {
    if (!(!I || !this.languages) && !(["cimode", "dev"].indexOf(I) > -1))
      for (let C = 0; C < this.languages.length; C++) {
        const A = this.languages[C];
        if (!(["cimode", "dev"].indexOf(A) > -1) && this.store.hasLanguageSomeTranslations(A)) {
          this.resolvedLanguage = A;
          break;
        }
      }
  }
  changeLanguage(I, C) {
    var A = this;
    this.isLanguageChangingTo = I;
    const c = bA();
    this.emit("languageChanging", I);
    const l = (e) => {
      this.language = e, this.languages = this.services.languageUtils.toResolveHierarchy(e), this.resolvedLanguage = void 0, this.setResolvedLanguage(e);
    }, t = (e, n) => {
      n ? (l(n), this.translator.changeLanguage(n), this.isLanguageChangingTo = void 0, this.emit("languageChanged", n), this.logger.log("languageChanged", n)) : this.isLanguageChangingTo = void 0, c.resolve(function() {
        return A.t(...arguments);
      }), C && C(e, function() {
        return A.t(...arguments);
      });
    }, i = (e) => {
      !I && !e && this.services.languageDetector && (e = []);
      const n = K(e) ? e : this.services.languageUtils.getBestMatchFromCodes(e);
      n && (this.language || l(n), this.translator.language || this.translator.changeLanguage(n), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(n)), this.loadResources(n, (b) => {
        t(b, n);
      });
    };
    return !I && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !I && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(I), c;
  }
  getFixedT(I, C, A) {
    var c = this;
    const l = function(t, i) {
      let e;
      if (typeof i != "object") {
        for (var n = arguments.length, b = new Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++)
          b[a - 2] = arguments[a];
        e = c.options.overloadTranslationOptionHandler([t, i].concat(b));
      } else
        e = {
          ...i
        };
      e.lng = e.lng || l.lng, e.lngs = e.lngs || l.lngs, e.ns = e.ns || l.ns, e.keyPrefix !== "" && (e.keyPrefix = e.keyPrefix || A || l.keyPrefix);
      const s = c.options.keySeparator || ".";
      let d;
      return e.keyPrefix && Array.isArray(t) ? d = t.map((Z) => `${e.keyPrefix}${s}${Z}`) : d = e.keyPrefix ? `${e.keyPrefix}${s}${t}` : t, c.t(d, e);
    };
    return K(I) ? l.lng = I : l.lngs = I, l.ns = C, l.keyPrefix = A, l;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(I) {
    this.options.defaultNS = I;
  }
  hasLoadedNamespace(I) {
    let C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const A = C.lng || this.resolvedLanguage || this.languages[0], c = this.options ? this.options.fallbackLng : !1, l = this.languages[this.languages.length - 1];
    if (A.toLowerCase() === "cimode")
      return !0;
    const t = (i, e) => {
      const n = this.services.backendConnector.state[`${i}|${e}`];
      return n === -1 || n === 0 || n === 2;
    };
    if (C.precheck) {
      const i = C.precheck(this, t);
      if (i !== void 0)
        return i;
    }
    return !!(this.hasResourceBundle(A, I) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || t(A, I) && (!c || t(l, I)));
  }
  loadNamespaces(I, C) {
    const A = bA();
    return this.options.ns ? (K(I) && (I = [I]), I.forEach((c) => {
      this.options.ns.indexOf(c) < 0 && this.options.ns.push(c);
    }), this.loadResources((c) => {
      A.resolve(), C && C(c);
    }), A) : (C && C(), Promise.resolve());
  }
  loadLanguages(I, C) {
    const A = bA();
    K(I) && (I = [I]);
    const c = this.options.preload || [], l = I.filter((t) => c.indexOf(t) < 0 && this.services.languageUtils.isSupportedCode(t));
    return l.length ? (this.options.preload = c.concat(l), this.loadResources((t) => {
      A.resolve(), C && C(t);
    }), A) : (C && C(), Promise.resolve());
  }
  dir(I) {
    if (I || (I = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !I)
      return "rtl";
    const C = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], A = this.services && this.services.languageUtils || new ub(Gb());
    return C.indexOf(A.getLanguagePartFromCode(I)) > -1 || I.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, C = arguments.length > 1 ? arguments[1] : void 0;
    return new fA(I, C);
  }
  cloneInstance() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : mc;
    const A = I.forkResourceStore;
    A && delete I.forkResourceStore;
    const c = {
      ...this.options,
      ...I,
      isClone: !0
    }, l = new fA(c);
    return (I.debug !== void 0 || I.prefix !== void 0) && (l.logger = l.logger.clone(I)), ["store", "services", "language"].forEach((i) => {
      l[i] = this[i];
    }), l.services = {
      ...this.services
    }, l.services.utils = {
      hasLoadedNamespace: l.hasLoadedNamespace.bind(l)
    }, A && (l.store = new ab(this.store.data, c), l.services.resourceStore = l.store), l.translator = new ll(l.services, c), l.translator.on("*", function(i) {
      for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), b = 1; b < e; b++)
        n[b - 1] = arguments[b];
      l.emit(i, ...n);
    }), l.init(c, C), l.translator.options = c, l.translator.backendConnector.services.utils = {
      hasLoadedNamespace: l.hasLoadedNamespace.bind(l)
    }, l;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const fg = fA.createInstance();
fg.createInstance = fA.createInstance;
fg.createInstance;
fg.dir;
fg.init;
fg.loadResources;
fg.reloadResources;
fg.use;
fg.changeLanguage;
fg.getFixedT;
fg.t;
fg.exists;
fg.setDefaultNamespace;
fg.hasLoadedNamespace;
fg.loadNamespaces;
fg.loadLanguages;
const {
  slice: Mm,
  forEach: Km
} = [];
function _m(g) {
  return Km.call(Mm.call(arguments, 1), (I) => {
    if (I)
      for (const C in I)
        g[C] === void 0 && (g[C] = I[C]);
  }), g;
}
const Xb = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, qm = (g, I, C) => {
  const A = C || {};
  A.path = A.path || "/";
  const c = encodeURIComponent(I);
  let l = `${g}=${c}`;
  if (A.maxAge > 0) {
    const t = A.maxAge - 0;
    if (Number.isNaN(t))
      throw new Error("maxAge should be a Number");
    l += `; Max-Age=${Math.floor(t)}`;
  }
  if (A.domain) {
    if (!Xb.test(A.domain))
      throw new TypeError("option domain is invalid");
    l += `; Domain=${A.domain}`;
  }
  if (A.path) {
    if (!Xb.test(A.path))
      throw new TypeError("option path is invalid");
    l += `; Path=${A.path}`;
  }
  if (A.expires) {
    if (typeof A.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    l += `; Expires=${A.expires.toUTCString()}`;
  }
  if (A.httpOnly && (l += "; HttpOnly"), A.secure && (l += "; Secure"), A.sameSite)
    switch (typeof A.sameSite == "string" ? A.sameSite.toLowerCase() : A.sameSite) {
      case !0:
        l += "; SameSite=Strict";
        break;
      case "lax":
        l += "; SameSite=Lax";
        break;
      case "strict":
        l += "; SameSite=Strict";
        break;
      case "none":
        l += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  return l;
}, Zb = {
  create(g, I, C, A) {
    let c = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    C && (c.expires = /* @__PURE__ */ new Date(), c.expires.setTime(c.expires.getTime() + C * 60 * 1e3)), A && (c.domain = A), document.cookie = qm(g, encodeURIComponent(I), c);
  },
  read(g) {
    const I = `${g}=`, C = document.cookie.split(";");
    for (let A = 0; A < C.length; A++) {
      let c = C[A];
      for (; c.charAt(0) === " "; )
        c = c.substring(1, c.length);
      if (c.indexOf(I) === 0)
        return c.substring(I.length, c.length);
    }
    return null;
  },
  remove(g) {
    this.create(g, "", -1);
  }
};
var $m = {
  name: "cookie",
  // Deconstruct the options object and extract the lookupCookie property
  lookup(g) {
    let {
      lookupCookie: I
    } = g;
    if (I && typeof document < "u")
      return Zb.read(I) || void 0;
  },
  // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
  cacheUserLanguage(g, I) {
    let {
      lookupCookie: C,
      cookieMinutes: A,
      cookieDomain: c,
      cookieOptions: l
    } = I;
    C && typeof document < "u" && Zb.create(C, g, A, c, l);
  }
}, g1 = {
  name: "querystring",
  // Deconstruct the options object and extract the lookupQuerystring property
  lookup(g) {
    var A;
    let {
      lookupQuerystring: I
    } = g, C;
    if (typeof window < "u") {
      let {
        search: c
      } = window.location;
      !window.location.search && ((A = window.location.hash) == null ? void 0 : A.indexOf("?")) > -1 && (c = window.location.hash.substring(window.location.hash.indexOf("?")));
      const t = c.substring(1).split("&");
      for (let i = 0; i < t.length; i++) {
        const e = t[i].indexOf("=");
        e > 0 && t[i].substring(0, e) === I && (C = t[i].substring(e + 1));
      }
    }
    return C;
  }
};
let aA = null;
const Vb = () => {
  if (aA !== null)
    return aA;
  try {
    aA = window !== "undefined" && window.localStorage !== null;
    const g = "i18next.translate.boo";
    window.localStorage.setItem(g, "foo"), window.localStorage.removeItem(g);
  } catch {
    aA = !1;
  }
  return aA;
};
var I1 = {
  name: "localStorage",
  // Deconstruct the options object and extract the lookupLocalStorage property
  lookup(g) {
    let {
      lookupLocalStorage: I
    } = g;
    if (I && Vb())
      return window.localStorage.getItem(I) || void 0;
  },
  // Deconstruct the options object and extract the lookupLocalStorage property
  cacheUserLanguage(g, I) {
    let {
      lookupLocalStorage: C
    } = I;
    C && Vb() && window.localStorage.setItem(C, g);
  }
};
let sA = null;
const mb = () => {
  if (sA !== null)
    return sA;
  try {
    sA = window !== "undefined" && window.sessionStorage !== null;
    const g = "i18next.translate.boo";
    window.sessionStorage.setItem(g, "foo"), window.sessionStorage.removeItem(g);
  } catch {
    sA = !1;
  }
  return sA;
};
var C1 = {
  name: "sessionStorage",
  lookup(g) {
    let {
      lookupSessionStorage: I
    } = g;
    if (I && mb())
      return window.sessionStorage.getItem(I) || void 0;
  },
  cacheUserLanguage(g, I) {
    let {
      lookupSessionStorage: C
    } = I;
    C && mb() && window.sessionStorage.setItem(C, g);
  }
}, A1 = {
  name: "navigator",
  lookup(g) {
    const I = [];
    if (typeof navigator < "u") {
      const {
        languages: C,
        userLanguage: A,
        language: c
      } = navigator;
      if (C)
        for (let l = 0; l < C.length; l++)
          I.push(C[l]);
      A && I.push(A), c && I.push(c);
    }
    return I.length > 0 ? I : void 0;
  }
}, c1 = {
  name: "htmlTag",
  // Deconstruct the options object and extract the htmlTag property
  lookup(g) {
    let {
      htmlTag: I
    } = g, C;
    const A = I || (typeof document < "u" ? document.documentElement : null);
    return A && typeof A.getAttribute == "function" && (C = A.getAttribute("lang")), C;
  }
}, l1 = {
  name: "path",
  // Deconstruct the options object and extract the lookupFromPathIndex property
  lookup(g) {
    var c;
    let {
      lookupFromPathIndex: I
    } = g;
    if (typeof window > "u")
      return;
    const C = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
    return Array.isArray(C) ? (c = C[typeof I == "number" ? I : 0]) == null ? void 0 : c.replace("/", "") : void 0;
  }
}, t1 = {
  name: "subdomain",
  lookup(g) {
    var c, l;
    let {
      lookupFromSubdomainIndex: I
    } = g;
    const C = typeof I == "number" ? I + 1 : 1, A = typeof window < "u" && ((l = (c = window.location) == null ? void 0 : c.hostname) == null ? void 0 : l.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i));
    if (A)
      return A[C];
  }
};
function i1() {
  return {
    order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    // cache user language
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"],
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'
    convertDetectedLanguage: (g) => g
  };
}
class Fu {
  constructor(I) {
    let C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.type = "languageDetector", this.detectors = {}, this.init(I, C);
  }
  init(I) {
    let C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, A = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.services = I || {
      languageUtils: {}
    }, this.options = _m(C, this.options || {}, i1()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = (c) => c.replace("-", "_")), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = A, this.addDetector($m), this.addDetector(g1), this.addDetector(I1), this.addDetector(C1), this.addDetector(A1), this.addDetector(c1), this.addDetector(l1), this.addDetector(t1);
  }
  addDetector(I) {
    return this.detectors[I.name] = I, this;
  }
  detect(I) {
    I || (I = this.options.order);
    let C = [];
    return I.forEach((A) => {
      if (this.detectors[A]) {
        let c = this.detectors[A].lookup(this.options);
        c && typeof c == "string" && (c = [c]), c && (C = C.concat(c));
      }
    }), C = C.map((A) => this.options.convertDetectedLanguage(A)), this.services.languageUtils.getBestMatchFromCodes ? C : C.length > 0 ? C[0] : null;
  }
  cacheUserLanguage(I, C) {
    C || (C = this.options.caches), C && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(I) > -1 || C.forEach((A) => {
      this.detectors[A] && this.detectors[A].cacheUserLanguage(I, this.options);
    }));
  }
}
Fu.type = "languageDetector";
const e1 = {
  "(주)인프랩": "Inflab Co., Ltd.",
  "(주)인프랩 사업자 정보": "Inflab Co., Ltd. Business Information",
  "3동 5층": "Republic of Korea",
  "IT 인재 채용 서비스": "IT talents recruiting service",
  "MY 카테고리": "My category",
  "With us": "With us",
  "{{category.title}} > 전체": "{{category.title}} > All",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}, thank you for being with Inflearn. 😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}, we’re cheering for your first step forward. 🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}, we’re cheering for your career growth. 👏",
  "{{profile?.name}}님의 프로필 이미지": "{{profile?.name}}’s profile image",
  "{{provider}}-로그인-버튼": "{{provider}}-Login-Button",
  "{{socialProviderNameMap[provider]}}로 로그인": "Log in with {{socialProviderNameMap[provider]}}",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "With 'Inflearn Business,' you can provide an environment where all team members can",
  "가입 이메일 인증이 필요합니다.": "Email verification is required for registration.",
  "이메일 인증이 필요한 계정입니다.\n24시간 후 재시도하거나 고객센터에 문의해주세요.": `This account requires email verification.
Please try again after 24 hours or contact customer support.`,
  "간편 로그인": "Social login",
  강의: "Course",
  "강의 · 기능요청": "Ask for course/function",
  "강의/강사명을 입력해주세요": "Enter the course/instructor name",
  "강의리스트 보기": "View course list",
  개: "ea",
  "개인정보보호책임자: 이동욱": "CPO: Lee Dongwook",
  개인정보처리방침: "Privacy Policy",
  검색: "Search",
  "검색바.01": "What are you interested in now?",
  "검색바.02": "Enter a keyword you’re exploring.",
  "검색바.03": "Which skill are you exploring now?",
  "검색바.04": "Discover courses for your next step.",
  "검색바.05": "Looking for something specific?",
  "검색바.06": "Type a course, topic, or keyword.",
  "검색바.07": "What do you want to learn today?",
  "검색바.08": "Search for anything.",
  "검색바.09": "What are you interested in now?",
  "검색바.10": "What do you want to learn today?",
  "검색바.11": "Which skill are you exploring now?",
  "검색할 강의 입력": "Enter course name",
  "경기도 성남시 분당구 판교로289번길 20": "5F, Bldg #3, 20, Pangyo-ro 289beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do,",
  "경제적 보상을 받아보세요.": "and get financial rewards.",
  "계정 설정": "Account Settings",
  고객센터: "Customer Services",
  고민있어요: "I need help",
  공지사항: "Notice",
  교육: "Training",
  구글: "Google",
  "구매 / 혜택": "Purchase / Benefits",
  "구매 내역": "Purchase history",
  국비지원교육: "Government-sponsored courses",
  기업: "Business",
  "기업 교육을 위한 인프런": "Inflearn for business education",
  깃허브: "GitHub",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "Search for great pieces of knowledge that’ll help you grow.",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "Find practical courses that can actually help you grow.",
  난이도: "Level",
  "난이도 선택": "Select Level",
  "난이도 옵션": "Level Options",
  "난이도 초기화": "Reset Level",
  "나한테 딱 맞는 걸 찾고 싶다면": "Looking for the perfect match?",
  "어떤 강의가 나한테 맞을까?": "Which course is right for me?",
  "목표와 관심사에 맞는 인기 강의를 찾아드릴게요": "Find courses for your goals",
  "지금 많이 듣는 강의 확인해보세요": "Check out the most popular courses right now",
  "남았어요.": "left.",
  "내 학습": "My learning",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "Naver does not support Google Login.",
  "누구나 들을 수 있는": "Open to everyone",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "Please use a different mobile browser (Chrome, Safari).",
  닫기: "Close",
  "담긴 강의가 없습니다.": "No courses in cart.",
  대시보드: "Dashboard",
  "대표자: 이형주": "CEO: Lee Hyeongjoo",
  더보기: "More",
  둘러보기: "Explore",
  "딱 맞는 강의가 기다리고 있어요.": "The perfect course for you awaits.",
  "랠릿 서비스 링크": "Rallit service link",
  로그아웃: "Log out",
  로그인: "Sign in",
  "로그인 또는 회원가입": "Log In or Sign Up",
  "로그인이 필요한 요청입니다.": "You need to log in to make this request.",
  로드맵: "Roadmap",
  "마음에 드는 강의를 수강해보세요!": "Take the course that draws your attention!",
  "많은 사람들에게 배움의 기회를 주고,": "Provide an opportunity to learn",
  "메인 페이지로 이동하기": "Go to main page",
  멘토링: "Mentoring",
  "멘토링 소개": "About mentoring",
  "멘토링 후기": "Mentoring Reviews",
  "모임/부트캠프": "Clubs/Bootcamp",
  "문제가 발생했습니다.": "An issue has occurred.",
  보관함: "Storage",
  분: "min",
  블로그: "Blog",
  비밀번호: "Password",
  "비밀번호 찾기": "Find my password",
  "비밀번호를 입력해주세요.": "Enter your password.",
  비즈니스: "Business",
  "비즈니스 브랜드 로고": "Business brand logo",
  "비즈니스 수강내역": "Business course history",
  "사업자 정보 확인": "Check business information",
  "사업자번호: 499-81-00612": "Business Registration No.: 499-81-00612",
  "사용자 대시보드 페이지로 이동": "Go to user dashboard page",
  "사용자 알림 페이지로 이동": "Go to user notification page",
  서비스: "Service",
  "서비스 언어를 선택하세요.": "Select the service language.",
  "선수 지식이 필요한": "Prerequisite knowledge required",
  설정: "Settings",
  수강바구니: "Cart",
  "수강바구니에서 전체보기": "Go to cart",
  "수강코드 등록": "Register course code",
  수강평: "Review",
  "수강평 모아보기": "See all reviews",
  "수료증 확인": "See certificate",
  스터디: "Study Clubs",
  시간: "hr",
  신청하기: "Apply",
  "아이디(이메일) 찾기": "Find my ID (email)",
  애플: "Apple",
  어드민: "Admin",
  "언어 변경": "Change Language",
  "언어 설정": "Language Settings",
  원: "$",
  "유저 대시보드로 이동": "Go to user dashboard",
  "이 공지를 그만 볼래요": "Don't show me this notice",
  이메일: "Email",
  "이메일 또는 비밀번호를 확인해주세요.": "Check your email or password again.",
  "이메일 형식이 올바르지 않습니다.": "Invalid email format",
  "이메일을 입력해주세요.": "Enter your email.",
  "이어서 학습하기": "Continue learning",
  이용약관: "Terms of Use",
  인프랩: "Inflab",
  "인프랩 스토리": "Inflab story",
  "인프랩 실Log": "Inflab Log",
  "인프랩 테크": "Inflab tech",
  인프런: "Inflearn",
  "인프런 네이버 블로그 바로가기": "Go to Inflearn’s Naver blog",
  "인프런 네이버 포스트 바로가기": "Go to Inflearn’s Naver post",
  "인프런 메인 페이지로 이동": "Go to Inflearn main page",
  "인프런 브랜드 로고": "Inflearn brand logo",
  "인프런 비즈니스": "Inflearn business",
  "인프런 소개": "About Inflearn",
  "인프런 영문 브랜드 로고": "Inflearn English brand logo",
  "인프런 유튜브 바로가기": "Go to Inflearn’s YouTube channel",
  "인프런 인스타그램 바로가기": "Go to Inflearn’s Instagram",
  "인프런 제휴": "Inflearn partners",
  "인프런 통합 검색": "Search in Inflearn",
  "인프런 트위터 바로가기": "Go to Inflearn’s X (Twitter)",
  "인프런 페이스북 바로가기": "Go to Inflearn’s Facebook",
  "인프런 피드": "Inflearn feed",
  "인프런으로 이동하기": "Go to Inflearn",
  입문: "Beginner",
  잎: "leaf",
  "자유롭게 학습하는 환경을 제공하세요.": "learn all they want through Inflearn’s courses.",
  "자주묻는 질문": "FAQ",
  "작성한 게시글": "Written posts",
  "장바구니 페이지로 이동": "Go to cart page",
  "저작권 신고센터": "Report copyright issues",
  "전문성을 높이는": "Enhancing expertise",
  전체: "All",
  "전체 강의": "All courses",
  "전화번호: 070-4948-1181": "Phone: 070-4948-1181",
  좋아요: "Likes",
  주소: "Address",
  중급이상: "Intermediate",
  "지금 둘러 보기": "Check out now",
  지식공유: "Instructor",
  "지식공유 참여": "Teach on Inflearn",
  지식공유자: "Instructors",
  "지식공유자 되기": "Teach on Inflearn",
  지식공유참여: "Teach on Inflearn",
  지식공유하기: "Share Knowledge",
  "질문 & 답변": "QnA",
  "질문 게시판": "Questions",
  "채널톡 아이콘": "ChannelTalk icon",
  챌린지: "Challenge",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "Something went wrong. Please try again later.",
  "청강대 게임스쿨": "Chungkang College Game School",
  초: "sec",
  초급: "Basic",
  "총 결제금액": "Total amount",
  "최근 강의 바로가기": "Go to recent course",
  "최근 로그인": "Recent login",
  카카오: "Kakao",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "KakaoTalk does not support Google Login.",
  "카테고리 설정": "Set category",
  커리어: "Career",
  커뮤니티: "Community",
  "코드 등록": "Register Code",
  쿠폰: "Coupon",
  "통신판매업: 2018-성남분당B-0062": "E-Commerce Business: 2018-SeongnamBundangB-0062",
  "특정 상거래법": "",
  "팀 프로젝트": "Team Projects",
  파트너스: "Partners",
  포인트: "Points",
  "포인트코드 등록": "Register point code",
  학생: "Student",
  "할인 종료까지": "Discount ends in",
  홈: "Home",
  확인: "OK",
  회원가입: "Sign up",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Surprise! Enjoy a special {{discountPercent}}% thank-you discount on our courses – don’t miss out!",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 A special discount for new members has been applied to courses, so don’t wait and grab it now!",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Your first-purchase discount ({{discountPercent}}%) is already applied — start learning now!"
}, n1 = {
  "(주)인프랩": "株式会社インフラップ",
  "(주)인프랩 사업자 정보": "株式会社インフラップ事業者情報",
  "3동 5층": "3棟5階",
  "IT 인재 채용 서비스": "IT人材採用サービス",
  "MY 카테고리": "私のカテゴリ",
  "With us": "ウィズアス",
  "{{category.title}} > 전체": "{{category.title}} > 全体",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}さん、インフランと一緒にいてくれてありがとう。😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}さんの初飛躍を応援しています。🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}さんのキャリアを応援しています。👏",
  "{{profile?.name}}님의 프로필 이미지": "{{profile?.name}}さんのプロフィール画像",
  "{{provider}}-로그인-버튼": "{{provider}}-ログイン-ボタン",
  "{{socialProviderNameMap[provider]}}로 로그인": "{{socialProviderNameMap[provider]}}でログイン",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "「インフラントビジネス」を通じてすべてのチームメンバーがインフランの講義を",
  "가입 이메일 인증이 필요합니다.": "登録メールの認証が必要です。",
  "이메일 인증이 필요한 계정입니다.\n24시간 후 재시도하거나 고객센터에 문의해주세요.": `メール認証が必要なアカウントです。
24時間後に再度お試しいただくか、カスタマーサポートへお問い合わせください。`,
  "간편 로그인": "簡単ログイン",
  강의: "講義",
  "강의 · 기능요청": "講義・機能リクエスト",
  "강의/강사명을 입력해주세요": "講義/講師名を入力してください",
  "강의리스트 보기": "講義リストを見る",
  개: "個",
  "개인정보보호책임자: 이동욱": "個人情報保護責任者：イ・ドンウク",
  개인정보처리방침: "個人情報処理方針",
  검색: "検索",
  "검색바.01": "今日は何を学びますか？",
  "검색바.02": "今すぐ検索",
  "검색바.03": "キーワード入力",
  "검색바.04": "今学びたいことは何ですか？",
  "검색바.05": "「プログラミング」で検索",
  "검색바.06": "「Python」で検索",
  "검색바.07": "「デザイン」で検索",
  "검색바.08": "新しい学び、新しい未来ーインフラン",
  "검색바.09": "今日は何を学びますか？",
  "검색바.10": "「デザイン」で検索",
  "검색바.11": "キーワード入力",
  "검색할 강의 입력": "講義名を入力",
  "경기도 성남시 분당구 판교로289번길 20": "京畿道城南市盆唐区パンギョ路289番道20",
  "경제적 보상을 받아보세요.": "経済的な報酬を受け取ってください。",
  "계정 설정": "アカウント設定",
  고객센터: "カスタマーセンター",
  고민있어요: "悩みがありますか",
  공지사항: "お知らせ",
  교육: "教育",
  구글: "グーグル",
  "구매 / 혜택": "購入 / 特典",
  "구매 내역": "購入履歴",
  국비지원교육: "国費支援教育",
  기업: "企業",
  "기업 교육을 위한 인프런": "企業教育のためのインフラン",
  깃허브: "ギットハブ",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "私を成長させてくれる良い知識を探してみてください。",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "私の本当の成長を助ける実務講義を探してみてください",
  난이도: "レベル",
  "난이도 선택": "レベルを選択",
  "난이도 옵션": "レベルオプション",
  "난이도 초기화": "レベルをリセット",
  "나한테 딱 맞는 걸 찾고 싶다면": "ぴったりな講座をお探しなら",
  "어떤 강의가 나한테 맞을까?": "自分に合う講座はどれ？",
  "목표와 관심사에 맞는 인기 강의를 찾아드릴게요": "目標に合った講座を見つける",
  "지금 많이 듣는 강의 확인해보세요": "今人気の講座をチェックしてみましょう",
  "남았어요.": "残っています。",
  "내 학습": "私の学習",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "ネイバーではグーグルログインをサポートしていません。",
  "누구나 들을 수 있는": "誰でも受講できる",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "他のモバイルブラウザ（Chrome、Safari）をご利用ください。",
  닫기: "閉じる",
  "담긴 강의가 없습니다.": "含まれている講義はありません。",
  대시보드: "ダッシュボード",
  "대표자: 이형주": "代表者：イ・ヒョンジュ",
  더보기: "もっと見る",
  둘러보기: "閲覧",
  "딱 맞는 강의가 기다리고 있어요.": "ぴったりの講義が待っています。",
  "랠릿 서비스 링크": "レリットサービスリンク",
  로그아웃: "ログアウト",
  로그인: "ログイン",
  "로그인 또는 회원가입": "ログインまたは新規登録",
  "로그인이 필요한 요청입니다.": "ログインが必要なリクエストです。",
  로드맵: "ロードマップ",
  "마음에 드는 강의를 수강해보세요!": "気に入った講義を受けてみてください！",
  "많은 사람들에게 배움의 기회를 주고,": "多くの人々に学習の機会を与え、",
  "메인 페이지로 이동하기": "メインページに移動する",
  멘토링: "メンタリング",
  "멘토링 소개": "メンタリング紹介",
  "멘토링 후기": "メンタリング後記",
  "모임/부트캠프": "集まり/ブートキャンプ",
  "문제가 발생했습니다.": "問題が発生しました。",
  보관함: "保管箱",
  분: "分",
  블로그: "ブログ",
  비밀번호: "パスワード",
  "비밀번호 찾기": "パスワード探し",
  "비밀번호를 입력해주세요.": "パスワードを入力してください。",
  비즈니스: "ビジネス",
  "비즈니스 브랜드 로고": "ビジネスブランドロゴ",
  "비즈니스 수강내역": "ビジネス受講履歴",
  "사업자 정보 확인": "事業者情報確認",
  "사업자번호: 499-81-00612": "事業者番号：499-81-00612",
  "사용자 대시보드 페이지로 이동": "ユーザーダッシュボードページに移動",
  "사용자 알림 페이지로 이동": "ユーザー通知ページに移動",
  서비스: "サービス",
  "서비스 언어를 선택하세요.": "サービス言語を選択してください。",
  "선수 지식이 필요한": "前提知識が必要な",
  설정: "設定",
  수강바구니: "受講カート",
  "수강바구니에서 전체보기": "受講カートで全体を見る",
  "수강코드 등록": "受講コード登録",
  수강평: "受講評価",
  "수강평 모아보기": "受講評価をまとめて見る",
  "수료증 확인": "修了証確認",
  스터디: "スタディ",
  시간: "時間",
  신청하기: "申し込む",
  "아이디(이메일) 찾기": "ID（メール）検索",
  애플: "アップル",
  어드민: "アドミン",
  "언어 변경": "言語変更",
  "언어 설정": "言語設定",
  원: "ウォン",
  "유저 대시보드로 이동": "ユーザーダッシュボードに移動",
  "이 공지를 그만 볼래요": "この通知をもう見たくない",
  이메일: "メール",
  "이메일 또는 비밀번호를 확인해주세요.": "メールまたはパスワードを確認してください。",
  "이메일 형식이 올바르지 않습니다.": "メールアドレスの形式が正しくありません。",
  "이메일을 입력해주세요.": "メールを入力してください。",
  "이어서 학습하기": "続けて学習する",
  이용약관: "利用約款",
  인프랩: "インフラップ",
  "인프랩 스토리": "インフラップストーリー",
  "인프랩 실Log": "インフラップ実ログ",
  "인프랩 테크": "インフラップテック",
  인프런: "インフラン",
  "인프런 네이버 블로그 바로가기": "インフランネイバーブログ直接リンク",
  "인프런 네이버 포스트 바로가기": "インフランネイバーポスト直接リンク",
  "인프런 메인 페이지로 이동": "インフランメインページに移動",
  "인프런 브랜드 로고": "インフランブランドロゴ",
  "인프런 비즈니스": "インフランビジネス",
  "인프런 소개": "インフラン紹介",
  "인프런 영문 브랜드 로고": "インフラン英文ブランドロゴ",
  "인프런 유튜브 바로가기": "インフランユーチューブ直接リンク",
  "인프런 인스타그램 바로가기": "インフランインスタグラム直接リンク",
  "인프런 제휴": "インフラン提携",
  "인프런 통합 검색": "インフラン統合検索",
  "인프런 트위터 바로가기": "インフラントゥイッター直接リンク",
  "인프런 페이스북 바로가기": "インフランフェイスブック直接リンク",
  "인프런 피드": "インフランフィード",
  "인프런으로 이동하기": "インフランへ移動する",
  입문: "入門",
  잎: "リーフ",
  "자유롭게 학습하는 환경을 제공하세요.": "自由に学習できる環境を提供してください。",
  "자주묻는 질문": "よくある質問",
  "작성한 게시글": "作成した投稿",
  "장바구니 페이지로 이동": "カートページに移動",
  "저작권 신고센터": "著作権通報センター",
  "전문성을 높이는": "専門性を高める",
  전체: "全体",
  "전체 강의": "全体講義",
  "전화번호: 070-4948-1181": "電話番号：070-4948-1181",
  좋아요: "いいね",
  주소: "住所",
  중급이상: "中級以上",
  "지금 둘러 보기": "今すぐ見る",
  지식공유: "知識共有",
  "지식공유 참여": "知識共有参加",
  지식공유자: "知識共有者",
  "지식공유자 되기": "知識共有者になる",
  지식공유참여: "知識共有参加",
  지식공유하기: "知識を共有",
  "질문 & 답변": "質問と回答",
  "질문 게시판": "質問掲示板",
  "채널톡 아이콘": "チャンネルトークアイコン",
  챌린지: "Challenge",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "処理中にエラーが発生しました。しばらくしてから再試行してください。",
  "청강대 게임스쿨": "青江大ゲームスクール",
  초: "秒",
  초급: "初級",
  "총 결제금액": "総決済金額",
  "최근 강의 바로가기": "最近の講義への直接リンク",
  "최근 로그인": "最近のログイン",
  카카오: "カカオ",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "カカオトークではグーグルログインをサポートしていません。",
  "카테고리 설정": "カテゴリ設定",
  커리어: "キャリア",
  커뮤니티: "コミュニティ",
  "코드 등록": "コード登録",
  쿠폰: "クーポン",
  "통신판매업: 2018-성남분당B-0062": "通信販売業：2018-城南盆唐B-0062",
  "특정 상거래법": "特定商取引法",
  "팀 프로젝트": "チームプロジェクト",
  파트너스: "パートナーズ",
  포인트: "ポイント",
  "포인트코드 등록": "ポイントコード登録",
  학생: "学生",
  "할인 종료까지": "割引終了まで",
  홈: "ホーム",
  확인: "確認",
  회원가입: "会員登録",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 サプライズ感謝割引({{discountPercent}}%)が講義に適用されていますので、今すぐ購入してみてください！",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 新規登録割引({{discountPercent}}%)が講義に適用されていますので、今すぐ購入してみてください！",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 初購入割引({{discountPercent}}%)が講義に適用されていますので、今すぐ購入してみてください！"
}, b1 = {
  "(주)인프랩": "(주)인프랩",
  "(주)인프랩 사업자 정보": "(주)인프랩 사업자 정보",
  "3동 5층": "3동 5층",
  "IT 인재 채용 서비스": "IT 인재 채용 서비스",
  "MY 카테고리": "MY 카테고리",
  "With us": "With us",
  "{{category.title}} > 전체": "{{category.title}} > 전체",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}님 인프런과 함께 해주셔서 감사해요.😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}님의 첫 도약을 응원하고 있어요. 🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}님의 커리어를 응원하고 있어요. 👏",
  "{{profile?.name}}님의 프로필 이미지": "{{profile?.name}}님의 프로필 이미지",
  "{{provider}}-로그인-버튼": "{{provider}}-로그인-버튼",
  "{{socialProviderNameMap[provider]}}로 로그인": "{{socialProviderNameMap[provider]}}로 로그인",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를",
  "가입 이메일 인증이 필요합니다.": "가입 이메일 인증이 필요합니다.",
  "이메일 인증이 필요한 계정입니다.\n24시간 후 재시도하거나 고객센터에 문의해주세요.": `이메일 인증이 필요한 계정입니다.
24시간 후 재시도하거나 고객센터에 문의해주세요.`,
  "간편 로그인": "간편 로그인",
  강의: "강의",
  "강의 · 기능요청": "강의 · 기능요청",
  "강의/강사명을 입력해주세요": "강의/강사명을 입력해주세요",
  "강의리스트 보기": "강의리스트 보기",
  개: "개",
  "개인정보보호책임자: 이동욱": "개인정보보호책임자: 이동욱",
  개인정보처리방침: "개인정보처리방침",
  검색: "검색",
  "검색바.01": "우리는 성장 기회의 평등을 추구합니다.",
  "검색바.02": "요즘 관심 있는 주제나 기술이 있나요?",
  "검색바.03": "진짜 성장을 도와줄 강의를 찾아보세요.",
  "검색바.04": "실전에서 쓸 지식을 지금 배워보세요.",
  "검색바.05": "인프런에서 성장 여정을 시작해보세요.",
  "검색바.06": "성장을 위한 콘텐츠가 여기 있어요.",
  "검색바.07": "AI 시대에 필요한 무기, 지금 배워보세요.",
  "검색바.08": "지금 배우고싶은 지식을 찾아보세요.",
  "검색바.09": "우리는 성장 기회의 평등을 추구합니다.",
  "검색바.10": "성장하는 모든 사람을 응원합니다.",
  "검색바.11": "실전에 필요한 지식을 지금 배워보세요.",
  "검색할 강의 입력": "검색할 강의 입력",
  "경기도 성남시 분당구 판교로289번길 20": "경기도 성남시 분당구 판교로289번길 20",
  "경제적 보상을 받아보세요.": "경제적 보상을 받아보세요.",
  "계정 설정": "계정 설정",
  고객센터: "고객센터",
  고민있어요: "고민있어요",
  공지사항: "공지사항",
  교육: "교육",
  구글: "구글",
  "구매 / 혜택": "구매 / 혜택",
  "구매 내역": "구매 내역",
  국비지원교육: "국비지원교육",
  기업: "기업",
  "기업 교육을 위한 인프런": "기업 교육을 위한 인프런",
  깃허브: "깃허브",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "나를 성장 시켜줄 좋은 지식들을 찾아보세요.",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요",
  "나한테 딱 맞는 걸 찾고 싶다면": "나한테 딱 맞는 걸 찾고 싶다면",
  "어떤 강의가 나한테 맞을까?": "어떤 강의가 나한테 맞을까?",
  "목표와 관심사에 맞는 인기 강의를 찾아드릴게요": "목표·관심사에 맞는 인기 강의를 찾아드릴게요",
  "지금 많이 듣는 강의 확인해보세요": "지금 많이 듣는 강의 확인해보세요",
  난이도: "난이도",
  "난이도 선택": "난이도 선택",
  "난이도 옵션": "난이도 옵션",
  "난이도 초기화": "난이도 초기화",
  "남았어요.": "남았어요.",
  "내 학습": "내 학습",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "네이버에서 구글 로그인을 지원하지 않습니다.",
  "누구나 들을 수 있는": "누구나 들을 수 있는",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.",
  닫기: "닫기",
  "담긴 강의가 없습니다.": "담긴 강의가 없습니다.",
  대시보드: "대시보드",
  "대표자: 이형주": "대표자: 이형주",
  더보기: "더보기",
  둘러보기: "둘러보기",
  "딱 맞는 강의가 기다리고 있어요.": "딱 맞는 강의가 기다리고 있어요.",
  "랠릿 서비스 링크": "랠릿 서비스 링크",
  로그아웃: "로그아웃",
  로그인: "로그인",
  "로그인 또는 회원가입": "로그인 또는 회원가입",
  "로그인이 필요한 요청입니다.": "로그인이 필요한 요청입니다.",
  로드맵: "로드맵",
  "마음에 드는 강의를 수강해보세요!": "마음에 드는 강의를 수강해보세요!",
  "많은 사람들에게 배움의 기회를 주고,": "많은 사람들에게 배움의 기회를 주고,",
  "메인 페이지로 이동하기": "메인 페이지로 이동하기",
  멘토링: "멘토링",
  "멘토링 소개": "멘토링 소개",
  "멘토링 후기": "멘토링 후기",
  "모임/부트캠프": "모임/부트캠프",
  "문제가 발생했습니다.": "문제가 발생했습니다.",
  보관함: "보관함",
  분: "분",
  블로그: "블로그",
  비밀번호: "비밀번호",
  "비밀번호 찾기": "비밀번호 찾기",
  "비밀번호를 입력해주세요.": "비밀번호를 입력해주세요.",
  비즈니스: "비즈니스",
  "비즈니스 브랜드 로고": "비즈니스 브랜드 로고",
  "비즈니스 수강내역": "비즈니스 수강내역",
  "사업자 정보 확인": "사업자 정보 확인",
  "사업자번호: 499-81-00612": "사업자번호: 499-81-00612",
  "사용자 대시보드 페이지로 이동": "사용자 대시보드 페이지로 이동",
  "사용자 알림 페이지로 이동": "사용자 알림 페이지로 이동",
  서비스: "서비스",
  "서비스 언어를 선택하세요.": "서비스 언어를 선택하세요.",
  "선수 지식이 필요한": "선수 지식이 필요한",
  설정: "설정",
  수강바구니: "수강바구니",
  "수강바구니에서 전체보기": "수강바구니에서 전체보기",
  "수강코드 등록": "수강코드 등록",
  수강평: "수강평",
  "수강평 모아보기": "수강평 모아보기",
  "수료증 확인": "수료증 확인",
  스터디: "스터디",
  시간: "시간",
  신청하기: "신청하기",
  "아이디(이메일) 찾기": "아이디(이메일) 찾기",
  애플: "애플",
  어드민: "어드민",
  "언어 변경": "언어 변경",
  "언어 설정": "언어 설정",
  원: "원",
  "유저 대시보드로 이동": "유저 대시보드로 이동",
  "이 공지를 그만 볼래요": "이 공지를 그만 볼래요",
  이메일: "이메일",
  "이메일 또는 비밀번호를 확인해주세요.": "이메일 또는 비밀번호를 확인해주세요.",
  "이메일 형식이 올바르지 않습니다.": "이메일 형식이 올바르지 않습니다.",
  "이메일을 입력해주세요.": "이메일을 입력해주세요.",
  "이어서 학습하기": "이어서 학습하기",
  이용약관: "이용약관",
  인프랩: "인프랩",
  "인프랩 스토리": "인프랩 스토리",
  "인프랩 실Log": "인프랩 실Log",
  "인프랩 테크": "인프랩 테크",
  인프런: "인프런",
  "인프런 네이버 블로그 바로가기": "인프런 네이버 블로그 바로가기",
  "인프런 네이버 포스트 바로가기": "인프런 네이버 포스트 바로가기",
  "인프런 메인 페이지로 이동": "인프런 메인 페이지로 이동",
  "인프런 브랜드 로고": "인프런 브랜드 로고",
  "인프런 비즈니스": "인프런 비즈니스",
  "인프런 소개": "인프런 소개",
  "인프런 영문 브랜드 로고": "인프런 영문 브랜드 로고",
  "인프런 유튜브 바로가기": "인프런 유튜브 바로가기",
  "인프런 인스타그램 바로가기": "인프런 인스타그램 바로가기",
  "인프런 제휴": "인프런 제휴",
  "인프런 통합 검색": "인프런 통합 검색",
  "인프런 트위터 바로가기": "인프런 트위터 바로가기",
  "인프런 페이스북 바로가기": "인프런 페이스북 바로가기",
  "인프런 피드": "인프런 피드",
  "인프런으로 이동하기": "인프런으로 이동하기",
  입문: "입문",
  잎: "잎",
  "자유롭게 학습하는 환경을 제공하세요.": "자유롭게 학습하는 환경을 제공하세요.",
  "자주묻는 질문": "자주묻는 질문",
  "작성한 게시글": "작성한 게시글",
  "장바구니 페이지로 이동": "장바구니 페이지로 이동",
  "저작권 신고센터": "저작권 신고센터",
  "전문성을 높이는": "전문성을 높이는",
  전체: "전체",
  "전체 강의": "전체 강의",
  "전화번호: 070-4948-1181": "전화번호: 070-4948-1181",
  좋아요: "좋아요",
  주소: "주소",
  중급이상: "중급이상",
  "지금 둘러 보기": "지금 둘러 보기",
  지식공유: "지식공유",
  "지식공유 참여": "지식공유 참여",
  지식공유자: "지식공유자",
  "지식공유자 되기": "지식공유자 되기",
  지식공유참여: "지식공유참여",
  지식공유하기: "지식공유하기",
  "질문 & 답변": "질문 & 답변",
  "질문 게시판": "질문 게시판",
  "채널톡 아이콘": "채널톡 아이콘",
  챌린지: "챌린지",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
  "청강대 게임스쿨": "청강대 게임스쿨",
  초: "초",
  초급: "초급",
  "총 결제금액": "총 결제금액",
  "최근 강의 바로가기": "최근 강의 바로가기",
  "최근 로그인": "최근 로그인",
  카카오: "카카오",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "카카오톡에서 구글 로그인을 지원하지 않습니다.",
  "카테고리 설정": "카테고리 설정",
  커리어: "커리어",
  커뮤니티: "커뮤니티",
  "코드 등록": "코드 등록",
  쿠폰: "쿠폰",
  "통신판매업: 2018-성남분당B-0062": "통신판매업: 2018-성남분당B-0062",
  "특정 상거래법": "",
  "팀 프로젝트": "팀 프로젝트",
  파트너스: "파트너스",
  포인트: "포인트",
  "포인트코드 등록": "포인트코드 등록",
  학생: "학생",
  "할인 종료까지": "할인 종료까지",
  홈: "홈",
  확인: "확인",
  회원가입: "회원가입",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!"
}, a1 = {
  "(주)인프랩": "Công ty TNHH Inflab",
  "(주)인프랩 사업자 정보": "Thông tin doanh nghiệp Công ty TNHH Inflab",
  "3동 5층": "Đại Hàn Dân Quốc",
  "IT 인재 채용 서비스": "Dịch vụ tuyển dụng nhân tài IT",
  "MY 카테고리": "Danh mục của tôi",
  "With us": "Cùng chúng tôi",
  "{{category.title}} > 전체": "{{category.title}} > Tất cả",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}, cảm ơn bạn đã đồng hành cùng Inflearn 😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}, chúng tôi cổ vũ bước tiến đầu tiên của bạn 🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}, chúng tôi cổ vũ cho sự nghiệp của bạn 👏",
  "{{profile?.name}}님의 프로필 이미지": "Hình ảnh hồ sơ của {{profile?.name}}",
  "{{provider}}-로그인-버튼": "Nút đăng nhập {{provider}}",
  "{{socialProviderNameMap[provider]}}로 로그인": "Đăng nhập với {{socialProviderNameMap[provider]}}",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "Với 'Inflearn Business', tất cả thành viên trong đội có thể tham gia các khóa học của Inflearn",
  "가입 이메일 인증이 필요합니다.": "Cần xác thực email để đăng ký.",
  "이메일 인증이 필요한 계정입니다.\n24시간 후 재시도하거나 고객센터에 문의해주세요.": `Tài khoản này cần xác thực email.
Vui lòng thử lại sau 24 giờ hoặc liên hệ bộ phận hỗ trợ khách hàng.`,
  "간편 로그인": "Đăng nhập nhanh",
  강의: "Khóa học",
  "강의 · 기능요청": "Yêu cầu khóa học/tính năng",
  "강의/강사명을 입력해주세요": "Vui lòng nhập tên khóa học/giảng viên",
  "강의리스트 보기": "Xem danh sách khóa học",
  개: "cái",
  "개인정보보호책임자: 이동욱": "Người phụ trách bảo mật thông tin cá nhân: Lee Dongwook",
  개인정보처리방침: "Chính sách bảo mật",
  검색: "Tìm kiếm",
  "검색바.01": "Bạn quan tâm gì hôm nay?",
  "검색바.02": "Nhập từ khóa bạn muốn.",
  "검색바.03": "Đang tìm gì cụ thể?",
  "검색바.04": "Nhập tên khóa học hoặc chủ đề.",
  "검색바.05": "Đang tìm khóa học Python?",
  "검색바.06": "Hãy thử gõ “Python”.",
  "검색바.07": "Bạn muốn rèn kỹ năng nào?",
  "검색바.08": "Khám phá khóa học mới.",
  "검색바.09": "Bạn quan tâm gì hôm nay?",
  "검색바.10": "Bạn muốn rèn kỹ năng nào?",
  "검색바.11": "Đang tìm gì cụ thể?",
  "검색할 강의 입력": "Nhập tên khóa học",
  "경기도 성남시 분당구 판교로289번길 20": "Tầng 5, Tòa nhà số 3, 20, Pangyo-ro 289beon-gil, Quận Bundang, Thành phố Seongnam, Gyeonggi-do",
  "경제적 보상을 받아보세요.": "Hãy nhận phần thưởng tài chính.",
  "계정 설정": "Cài đặt tài khoản",
  고객센터: "Trung tâm khách hàng",
  고민있어요: "Tôi cần giúp đỡ",
  공지사항: "Thông báo",
  교육: "Đào tạo",
  구글: "Google",
  "구매 / 혜택": "Mua hàng / Ưu đãi ",
  "구매 내역": "Lịch sử mua hàng",
  국비지원교육: "Khóa học được hỗ trợ bởi nhà nước",
  기업: "Doanh nghiệp",
  "기업 교육을 위한 인프런": "Inflearn cho giáo dục doanh nghiệp",
  깃허브: "GitHub",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "Hãy tìm kiếm những kiến thức tuyệt vời giúp bạn phát triển.",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "Tìm các khóa học thực tiễn giúp bạn thực sự phát triển.",
  난이도: "Cấp độ",
  "난이도 선택": "Chọn cấp độ",
  "난이도 옵션": "Tùy chọn cấp độ",
  "난이도 초기화": "Đặt lại cấp độ",
  "나한테 딱 맞는 걸 찾고 싶다면": "Bạn muốn tìm khóa học phù hợp?",
  "어떤 강의가 나한테 맞을까?": "Khóa học nào phù hợp với tôi?",
  "목표와 관심사에 맞는 인기 강의를 찾아드릴게요": "Tìm khóa học cho mục tiêu của bạn",
  "지금 많이 듣는 강의 확인해보세요": "Xem ngay những khóa học đang được học nhiều nhất",
  "남았어요.": "còn lại.",
  "내 학습": "Học tập của tôi",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "Naver không hỗ trợ đăng nhập bằng Google.",
  "누구나 들을 수 있는": "Mở cho tất cả mọi người",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "Vui lòng sử dụng trình duyệt di động khác (Chrome, Safari).",
  닫기: "Đóng",
  "담긴 강의가 없습니다.": "Không có khóa học nào trong giỏ hàng.",
  대시보드: "Bảng điều khiển",
  "대표자: 이형주": "Người đại diện: Lee Hyeongjoo",
  더보기: "Xem thêm",
  둘러보기: "Khám phá",
  "딱 맞는 강의가 기다리고 있어요.": "Khóa học phù hợp nhất đang chờ bạn.",
  "랠릿 서비스 링크": "Liên kết dịch vụ Rallit",
  로그아웃: "Đăng xuất",
  로그인: "Đăng nhập",
  "로그인 또는 회원가입": "Đăng nhập hoặc Đăng ký",
  "로그인이 필요한 요청입니다.": "Bạn cần đăng nhập để thực hiện yêu cầu này.",
  로드맵: "Lộ trình",
  "마음에 드는 강의를 수강해보세요!": "Hãy tham gia khóa học bạn yêu thích!",
  "많은 사람들에게 배움의 기회를 주고,": "Mang lại cơ hội học tập cho nhiều người,",
  "메인 페이지로 이동하기": "Đi đến trang chính",
  멘토링: "Mentoring",
  "멘토링 소개": "Giới thiệu mentoring",
  "멘토링 후기": "Đánh giá mentoring",
  "모임/부트캠프": "Câu lạc bộ/Bootcamp",
  "문제가 발생했습니다.": "Đã xảy ra sự cố.",
  보관함: "Kho lưu trữ",
  분: "phút",
  블로그: "Blog",
  비밀번호: "Mật khẩu",
  "비밀번호 찾기": "Tìm mật khẩu",
  "비밀번호를 입력해주세요.": "Vui lòng nhập mật khẩu.",
  비즈니스: "Doanh nghiệp",
  "비즈니스 브랜드 로고": "Logo thương hiệu doanh nghiệp",
  "비즈니스 수강내역": "Lịch sử khóa học doanh nghiệp",
  "사업자 정보 확인": "Kiểm tra thông tin doanh nghiệp",
  "사업자번호: 499-81-00612": "Mã số kinh doanh: 499-81-00612",
  "사용자 대시보드 페이지로 이동": "Đi đến trang bảng điều khiển người dùng",
  "사용자 알림 페이지로 이동": "Đi đến trang thông báo của người dùng",
  서비스: "Dịch vụ",
  "서비스 언어를 선택하세요.": "Vui lòng chọn ngôn ngữ dịch vụ.",
  "선수 지식이 필요한": "Yêu cầu kiến thức nền tảng",
  설정: "Cài đặt",
  수강바구니: "Giỏ khóa học",
  "수강바구니에서 전체보기": "Xem toàn bộ trong giỏ khóa học",
  "수강코드 등록": "Đăng ký mã khóa học",
  수강평: "Đánh giá khóa học",
  "수강평 모아보기": "Xem tất cả đánh giá",
  "수료증 확인": "Xem chứng chỉ hoàn thành",
  스터디: "Câu lạc bộ học tập",
  시간: "giờ",
  신청하기: "Đăng ký",
  "아이디(이메일) 찾기": "Tìm ID (email)",
  애플: "Apple",
  어드민: "Quản trị viên",
  "언어 변경": "Thay đổi ngôn ngữ",
  "언어 설정": "Cài đặt ngôn ngữ",
  원: "₫",
  "유저 대시보드로 이동": "Đi đến bảng điều khiển người dùng",
  "이 공지를 그만 볼래요": "Không muốn thấy thông báo này nữa",
  이메일: "Email",
  "이메일 또는 비밀번호를 확인해주세요.": "Vui lòng kiểm tra lại email hoặc mật khẩu.",
  "이메일 형식이 올바르지 않습니다.": "Định dạng email không hợp lệ.",
  "이메일을 입력해주세요.": "Vui lòng nhập email.",
  "이어서 학습하기": "Tiếp tục học",
  이용약관: "Điều khoản sử dụng",
  인프랩: "Inflab",
  "인프랩 스토리": "Câu chuyện về Inflab",
  "인프랩 실Log": "Nhật ký của Inflab",
  "인프랩 테크": "Công nghệ của Inflab",
  인프런: "Inflearn",
  "인프런 네이버 블로그 바로가기": "Đi đến blog Naver của Inflearn",
  "인프런 네이버 포스트 바로가기": "Đi đến bài viết Naver của Inflearn",
  "인프런 메인 페이지로 이동": "Đi đến trang chính của Inflearn",
  "인프런 브랜드 로고": "Logo thương hiệu Inflearn",
  "인프런 비즈니스": "Inflearn doanh nghiệp",
  "인프런 소개": "Giới thiệu Inflearn",
  "인프런 영문 브랜드 로고": "Logo thương hiệu tiếng Anh của Inflearn",
  "인프런 유튜브 바로가기": "Đi đến kênh YouTube của Inflearn",
  "인프런 인스타그램 바로가기": "Đi đến Instagram của Inflearn",
  "인프런 제휴": "Đối tác Inflearn",
  "인프런 통합 검색": "Tìm kiếm trong Inflearn",
  "인프런 트위터 바로가기": "Đi đến X (Twitter) của Inflearn",
  "인프런 페이스북 바로가기": "Đi đến Facebook của Inflearn",
  "인프런 피드": "Bảng tin Inflearn",
  "인프런으로 이동하기": "Đi đến Inflearn",
  입문: "Nhập môn",
  잎: "lá",
  "자유롭게 학습하는 환경을 제공하세요.": "Hãy cung cấp một môi trường học tập tự do.",
  "자주묻는 질문": "Câu hỏi thường gặp",
  "작성한 게시글": "Bài viết đã tạo",
  "장바구니 페이지로 이동": "Đi đến trang giỏ hàng",
  "저작권 신고센터": "Trung tâm báo cáo vi phạm bản quyền",
  "전문성을 높이는": "Nâng cao chuyên môn",
  전체: "Tất cả",
  "전체 강의": "Tất cả khóa học",
  "전화번호: 070-4948-1181": "Số điện thoại: 070-4948-1181",
  좋아요: "Thích",
  주소: "Địa chỉ",
  중급이상: "Trung cấp trở lên",
  "지금 둘러 보기": "Xem ngay bây giờ",
  지식공유: "Chia sẻ kiến thức",
  "지식공유 참여": "Tham gia chia sẻ kiến thức",
  지식공유자: "Người chia sẻ kiến thức",
  "지식공유자 되기": "Trở thành người chia sẻ kiến thức",
  지식공유참여: "Tham gia chia sẻ kiến thức",
  지식공유하기: "Chia sẻ kiến thức",
  "질문 & 답변": "Hỏi & Đáp",
  "질문 게시판": "Bảng câu hỏi",
  "채널톡 아이콘": "Biểu tượng ChannelTalk",
  챌린지: "Challenge",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "Đã xảy ra lỗi trong quá trình xử lý. Vui lòng thử lại sau.",
  "청강대 게임스쿨": "Trường Game Chungkang",
  초: "giây",
  초급: "Cơ bản",
  "총 결제금액": "Tổng số tiền thanh toán",
  "최근 강의 바로가기": "Đi đến khóa học gần đây",
  "최근 로그인": "Đăng nhập gần đây",
  카카오: "Kakao",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "KakaoTalk không hỗ trợ đăng nhập bằng Google.",
  "카테고리 설정": "Cài đặt danh mục",
  커리어: "Sự nghiệp",
  커뮤니티: "Cộng đồng",
  "코드 등록": "Đăng ký mã",
  쿠폰: "Coupon",
  "통신판매업: 2018-성남분당B-0062": "Ngành bán hàng trực tuyến: 2018-SeongnamBundangB-0062",
  "특정 상거래법": "",
  "팀 프로젝트": "Dự án nhóm",
  파트너스: "Đối tác",
  포인트: "Điểm",
  "포인트코드 등록": "Đăng ký mã điểm",
  학생: "Học sinh",
  "할인 종료까지": "Kết thúc giảm giá trong",
  홈: "Trang chủ",
  확인: "Xác nhận",
  회원가입: "Đăng ký thành viên",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Giảm giá cảm ơn bất ngờ ({{discountPercent}}%) đã được áp dụng cho khóa học, hãy mua ngay!",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Giảm giá cho thành viên mới ({{discountPercent}}%) đã được áp dụng cho khóa học, hãy mua ngay!",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Giảm giá lần mua đầu tiên ({{discountPercent}}%) đã được áp dụng cho khóa học, hãy mua ngay!"
}, zu = {
  ko: {
    appShell: b1
  },
  en: {
    appShell: e1
  },
  vi: {
    appShell: a1
  },
  ja: {
    appShell: n1
  }
}, fu = Object.keys(zu), tl = fg.createInstance();
tl.use(Fu).use(Xu).init({
  defaultNS: "appShell",
  fallbackLng: EC,
  supportedLngs: fu,
  detection: {
    order: ["path"]
  },
  interpolation: {
    escapeValue: !1
  },
  debug: !1,
  cleanCode: !0,
  // e.g. EN -> en
  resources: zu
});
function s1(g) {
  return !!fu.find((I) => I === g);
}
function QC() {
  return s1(tl.language) ? tl.language : EC;
}
function Hu() {
  return QC() === EC;
}
function UC(g, I) {
  return () => tl.t(g, I) ?? "";
}
function G3(g, I = QC()) {
  return tI.stringifyUrl({
    url: g,
    query: {
      lang: I
    }
  });
}
const MC = {
  EMAIL: "info@inflearn.com",
  SITE: ne,
  MEMBER_HISTORY: "https://doc.clickup.com/d/3gfz7-5843/log/3gfz7-75205/%EC%9D%B8%ED%94%84%EB%9E%A9-%EC%8B%A4-log",
  STORY: "https://story.inflab.com/",
  TECH_BLOG: "https://tech.inflab.com/",
  RALLIT_BUSINESS: "https://business.rallit.com/"
};
function u1() {
  return Hu() ? MC.SITE : `${MC.SITE}/${QC()}`;
}
function S(g, I) {
  const C = I ?? (MV === "localhost" ? "" : MC.SITE), A = g.startsWith("/") ? g : `/${g}`;
  return Hu() ? `${C}${A}` : `${C}/${QC()}${A}`;
}
const r3 = {
  INFO_PRIVACY: S("/policy/privacy"),
  INFO_TERMS: S("/policy/terms-of-service"),
  BIZ_INFO: "http://www.ftc.go.kr/bizCommPop.do?wrkr_no=4998100612",
  INF_EMAIL: `mailto:${MC.EMAIL}`
}, X3 = {
  SPECIFIED_COMMERCIAL_TRANSACTIONS: `${MC.SITE}/ja/policy/specified-commercial-transactions`
}, Z3 = {
  RALLIT_SITE: jn,
  RALLIT_MY_LOG: `${jn}/my/log`
}, V3 = `${MC.SITE}/channeltalk`, Jg = {
  CHALLENGES: S("/challenges"),
  MAIN: u1(),
  WITH_US: S("/pages/withus"),
  INSTRUCTOR: S(QC() === EC ? "/instructor" : "/instructor/courses"),
  INSTRUCTOR_ABROAD: S("/instructor/courses"),
  APPLY_INSTRUCTOR: S("/instructor/application"),
  APPLY_B2B: S("/intro-group"),
  SIGN_UP: S("/signup"),
  SIGN_IN: S("/signin"),
  SIGNUP_EMAIL_REVERIFY: S("/signup/email/reverify"),
  INTRO_GROUP: S("/intro-group"),
  COURSES: (g) => {
    const I = g != null && g.category ? `/${g == null ? void 0 : g.category}` : "", C = g != null && g.subCategory ? `/${g == null ? void 0 : g.subCategory}` : "", A = ((g == null ? void 0 : g.searchKeyword) ?? "").trim();
    return A ? Jg.SEARCH({
      order: g == null ? void 0 : g.order,
      types: g == null ? void 0 : g.types,
      skill: g == null ? void 0 : g.skill,
      searchKeyword: A,
      completionAttributionToken: g == null ? void 0 : g.completionAttributionToken,
      selectedSuggestion: g == null ? void 0 : g.selectedSuggestion,
      selectedPosition: g == null ? void 0 : g.selectedPosition,
      levels: g == null ? void 0 : g.levels,
      tab: g == null ? void 0 : g.tab
    }) : tI.stringifyUrl({
      url: S(`/courses${I}${C}`),
      query: {
        order: g == null ? void 0 : g.order,
        types: g == null ? void 0 : g.types,
        skill: g == null ? void 0 : g.skill,
        s: A,
        completionAttributionToken: g == null ? void 0 : g.completionAttributionToken,
        selectedSuggestion: g == null ? void 0 : g.selectedSuggestion,
        selectedPosition: g == null ? void 0 : g.selectedPosition,
        levels: g == null ? void 0 : g.levels,
        onboarding: g == null ? void 0 : g.onboarding,
        redirectTo: g == null ? void 0 : g.redirectTo
      }
    }, {
      skipNull: !0,
      skipEmptyString: !0
    });
  },
  SEARCH: (g) => tI.stringifyUrl({
    url: S("/search"),
    query: {
      order: g == null ? void 0 : g.order,
      types: g == null ? void 0 : g.types,
      skill: g == null ? void 0 : g.skill,
      s: g == null ? void 0 : g.searchKeyword,
      completionAttributionToken: g == null ? void 0 : g.completionAttributionToken,
      selectedSuggestion: g == null ? void 0 : g.selectedSuggestion,
      selectedPosition: g == null ? void 0 : g.selectedPosition,
      levels: g == null ? void 0 : g.levels,
      tab: g == null ? void 0 : g.tab
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  }),
  COMMUNITY: S("/community"),
  COMMUNITY_USER_POSTS: S("/my/posts/question"),
  COMMUNITY_WITH_SEARCH: ({
    keyword: g
  }) => tI.stringifyUrl({
    url: S("/community"),
    query: {
      s: g
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  }),
  ROADMAPS: S("/roadmaps"),
  ROADMAPS_WITH_SEARCH: ({
    keyword: g,
    sort: I,
    pageNumber: C
  }) => tI.stringifyUrl({
    url: S("/roadmaps"),
    query: {
      s: g,
      sort: I,
      page_number: C
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  }),
  ENROLLED_ROADMAPS: S("/user/roadmaps/enrolled"),
  MENTORS: S("/mentors", $c),
  MENTORING_WITH_SEARCH: ({
    keyword: g
  }) => tI.stringifyUrl({
    url: S("/mentors", $c),
    query: {
      s: g
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  }),
  COMMUNITY_QUESTION: S("/community/questions"),
  COMMUNITY_REVIEWS: S("/community/reviews"),
  BLOGS: S("/blogs"),
  COMMUNITY_STUDIES: S("/community/studies"),
  COMMUNITY_CHATS: S("/community/chats"),
  COMMUNITY_PROJECTS: S("/community/projects"),
  COMMUNITY_MENTORINGS_REVIEWS: S("/community/mentorings-reviews"),
  NOTICE_LIST: S("/notices"),
  STORIES: S("/pages"),
  INFLEARN: S("/inflearn"),
  REQUEST_TO_INFLEARN: S("/request-to-inflearn"),
  ACCOUNT_DASHBOARD: S("/users/me/dashboard"),
  ACCOUNT_SETTING: S("/my/settings/account"),
  CARTS: S("/carts"),
  MESSAGE_LIST: S("/user/messages"),
  EVENTS: S("/pages?type=event"),
  LOGOUT: (g) => tI.stringifyUrl({
    url: `${ne}/signout`,
    query: {
      lang: QC(),
      redirectTo: g.redirectTo
    }
  }),
  LECTURE_LAST_VOUCHER: (g, I) => S(`/course/${g}/unit/${I}`),
  FIND_ID: S("/signin/find/id"),
  청강대게임스쿨: S("/tag-curation/tag/18123"),
  FIND_PW: S("/signin/find/password"),
  USER_MENTORINGS: S("/my/mentorings"),
  USER_POSTS: S("/my/posts"),
  MY_PARTNERS: S("/my/partners"),
  MY_PARTNERS_LINKS: S("/my/partners-links"),
  PARTNERS_NEW: S("/partners/new"),
  USER_INQUIRIES: S("/user/inquiries"),
  USER_LIKES: S("/my/likes"),
  USER_SETTINGS_ACCOUNT: S("/my/settings/account"),
  USER_COURSES: S("/my/courses"),
  MY_RECEIVED_GIFTS: S("/my/gifts/received"),
  USER_POINT: S("/user/points"),
  USER_COUPONS: S("/user/coupons"),
  FAQ: S("/faq"),
  KDT: S("/tag-curation/common_tag/kdt"),
  PARTNERS_LANDING: S("/pages/partners"),
  PARTNERS_INTRODUCE_VI: "https://www.inflearn.com/tag-curation/common_tag/partners-vi",
  BUSINESS: (g) => `${KV}/new/groups/${g}/dashboard`,
  BUSINESS_ENROLMENTS: S("/biz-enrolments"),
  USER_PROFILE: (g, I) => S(I ? `/users/${g}/@${I}` : `/users/${g}`),
  ORDERS: S("/my/orders"),
  FIND_RECOMMEND_COURSES: S("/courses?charge=free&order=seq"),
  CERTIFICATE: S("/certificate"),
  COURSE_DETAIL: (g) => S(`/course/${g}`),
  CLIPS: S("/clips"),
  CLIPS_WITH_SEARCH: ({
    searchKeyword: g,
    sort: I
  }) => tI.stringifyUrl({
    url: S("/clips"),
    query: {
      s: g,
      sort: I
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  })
}, m3 = {
  MY_CATEGORY: "my-category"
}, h3 = {
  INTRO: S("/inflearn"),
  FEED: S("/pages"),
  OPEN_KNOWLEDGE: S("/open-knowledge"),
  MENTORS_INTRO: S("/mentors-intro"),
  INTRO_GROUP: S("/intro-group"),
  PARTNERS: S("/partners"),
  COURSE_CODE: S("/course-code"),
  POINT_CODE: S("/point-code"),
  COPYRIGHT: S("/copyright"),
  REQUEST_TO_INFLEARN: S("/request-to-inflearn")
}, W3 = {
  NAVER_BLOG: "https://blog.naver.com/inflearn",
  INSTAGRAM: "https://www.instagram.com/inflearn__official",
  YOUTUBE: "https://www.youtube.com/channel/UC0Y0T9JpgIBbyGDjvy9PbOg",
  FACEBOOK: "https://www.facebook.com/inflearn",
  TWITTER: "https://twitter.com/inflearn",
  THREADS: "https://www.threads.com/@inflearn__official"
}, N3 = {
  AI_CHAT: "https://www.inflearn.com/chat/set-cookie"
};
function PI() {
  const g = qA(), {
    analytics: I
  } = Ds(), C = () => {
    var c, l;
    try {
      const t = g.getQueryData([li.CLIENT_V2_ACCOUNTS_PROFILE]);
      if (!(t != null && t.data))
        return {
          user_id: null,
          user_name: null,
          user_email: null,
          user_group_id: null,
          user_group_subscription_id: null,
          role_b2b: !1,
          role_b2c: !1,
          role_admin: !1,
          role_instructor: !1
        };
      const {
        id: i,
        name: e,
        email: n
      } = t.data;
      return {
        user_id: i,
        user_name: e,
        user_email: n,
        user_group_id: (c = t.data.group) == null ? void 0 : c.id,
        user_group_subscription_id: (l = t.data.group) == null ? void 0 : l.groupSubscriptionId,
        role_b2b: ci(t.data),
        role_b2c: !ci(t.data),
        role_admin: t.data.isAdmin,
        role_instructor: t.data.isInstructor
      };
    } catch {
      return {
        user_id: null,
        user_name: null,
        user_email: null,
        user_group_id: null,
        user_group_subscription_id: null,
        role_b2b: !1,
        role_b2c: !1,
        role_admin: !1,
        role_instructor: !1
      };
    }
  };
  return {
    trackEvent: (c, l) => I.track(c, {
      mixpanelToken: _V,
      userId: C().user_id,
      mxp___user: C(),
      ...l
    })
  };
}
var gc = {}, wu = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "magnifying-glass", A = 512, c = 512, l = [128269, "search"], t = "f002", i = "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faMagnifyingGlass = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(wu);
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = wu;
  g.definition = {
    prefix: I.prefix,
    iconName: I.iconName,
    icon: [
      I.width,
      I.height,
      I.aliases,
      I.unicode,
      I.svgPathData
    ]
  }, g.faSearch = g.definition, g.prefix = I.prefix, g.iconName = I.iconName, g.width = I.width, g.height = I.height, g.ligatures = I.aliases, g.unicode = I.unicode, g.svgPathData = I.svgPathData, g.aliases = I.aliases;
})(gc);
var Su = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "globe", A = 512, c = 512, l = [127760], t = "f0ac", i = "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faGlobe = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(Su);
var Tu = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "grid", A = 448, c = 512, l = ["grid-3"], t = "e195", i = "M0 72C0 49.9 17.9 32 40 32H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V72zM0 232c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V232zM128 392v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40zM160 72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V72zM288 232v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM160 392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392zM448 72v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM320 232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V232zM448 392v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faGrid = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(Tu);
const Lu = jg({
  profile: void 0,
  isLoading: !1
}), x3 = ({
  children: g
}) => {
  const {
    data: I,
    isLoading: C,
    error: A
  } = sm();
  dm(A);
  const c = tg(() => ({
    profile: I ? {
      ...I,
      isB2b: ci(I),
      isGroupManager: lm(I),
      isGroupUser: cm(I),
      isPartner: tm(I)
    } : void 0,
    isLoading: C
  }), [I, C]);
  return /* @__PURE__ */ o(Lu.Provider, { value: c, children: g });
}, Ic = () => {
  const g = Zg(Lu);
  if (!g)
    throw new Error("useProfileContext must be used within a ProfileProvider");
  return g;
}, d1 = (g) => !(g != null && g.isB2b), o1 = () => {
  var r, h, x, u;
  const {
    t: g
  } = UI(), {
    isKo: I
  } = se(), {
    profile: C,
    isLoading: A
  } = Ic(), {
    getSnapshot: c,
    setSnapshot: l
  } = pu(), t = c(), i = (r = t == null ? void 0 : t.menuList) == null ? void 0 : r.roadmaps, e = (h = t == null ? void 0 : t.menuList) == null ? void 0 : h.challenges, n = (x = t == null ? void 0 : t.menuList) == null ? void 0 : x.mentoring, b = (u = t == null ? void 0 : t.menuList) == null ? void 0 : u.clips, a = tg(() => ({
    roadmaps: !rA(i),
    challenges: !rA(e),
    mentoring: !rA(n),
    clips: !rA(b)
  }), [i, e, n, b]), [s, d] = O(() => ({
    roadmaps: a.roadmaps,
    challenges: a.challenges,
    mentoring: a.mentoring,
    clips: a.clips
  })), Z = tg(() => ({
    roadmaps: I && d1(C),
    challenges: I,
    mentoring: I,
    clips: I
  }), [I, C]);
  return Ss(() => {
    A || a.roadmaps === Z.roadmaps && a.challenges === Z.challenges && a.mentoring === Z.mentoring && a.clips === Z.clips || (d((G) => G.roadmaps === Z.roadmaps && G.challenges === Z.challenges && G.mentoring === Z.mentoring && G.clips === Z.clips ? G : {
      roadmaps: Z.roadmaps,
      challenges: Z.challenges,
      mentoring: Z.mentoring,
      clips: Z.clips
    }), l({
      menuList: {
        courses: g("강의"),
        challenges: Z.challenges ? g("챌린지") : "",
        mentoring: Z.mentoring ? g("멘토링") : "",
        roadmaps: Z.roadmaps ? g("로드맵") : "",
        clips: Z.clips ? g("클립") : ""
      }
    }));
  }, [g, Z, a, l, A]), {
    shouldShowMenu: s
  };
}, Uu = (g) => {
  const I = Ag(g);
  I.current = g, q(() => {
    let C = window.location.href;
    const A = () => {
      C = window.location.href, I.current();
    };
    function c() {
      const t = window.location.href;
      C !== t && (C = t, A());
    }
    window.addEventListener("popstate", A);
    const l = setInterval(c, 100);
    return () => {
      window.removeEventListener("popstate", A), clearInterval(l);
    };
  }, []);
}, G1 = "mantine-Popover-dropdown", Pu = "app-shell-input-explore-item", y3 = {
  SIGNUP: -1,
  FIRST_ORDER: -2,
  RE_ORDER: -3
}, p3 = {
  SIGNUP: (g) => UC("{{name}}님 인프런과 함께 해주셔서 감사해요. 😊", {
    name: g
  })(),
  FIRST_ORDER: (g) => UC("{{name}}님의 첫 도약을 응원하고 있어요. 🙌", {
    name: g
  })(),
  RE_ORDER: (g) => UC("{{name}}님의 커리어를 응원하고 있어요. 👏", {
    name: g
  })()
}, R3 = {
  SIGNUP: (g) => UC("🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!", {
    discountPercent: g
  })(),
  FIRST_ORDER: (g) => UC("🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!", {
    discountPercent: g
  })(),
  RE_ORDER: (g) => UC("🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!", {
    discountPercent: g
  })()
}, B3 = (g, I) => /* @__PURE__ */ $({
  "--fa-secondary-opacity": "1",
  "--fa-secondary-color": I,
  "--fa-primary-color": g
}, process.env.NODE_ENV === "production" ? "" : ";label:styleDuotone;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), r1 = {
  COURSES: "COURSES",
  CHALLENGES: "CHALLENGES",
  MENTORING: "MENTORING",
  CLIPS: "CLIPS",
  ROADMAPS: "ROADMAPS",
  COMMUNITY: "COMMUNITY"
}, ue = 285, il = 25 * 3, iI = {
  COURSES: {
    icon: "course",
    text: "강의",
    href: Jg.COURSES()
  },
  CHALLENGES: {
    icon: "challenge",
    text: "챌린지",
    href: Jg.CHALLENGES
  },
  MENTORING: {
    icon: "mentoring",
    text: "멘토링",
    href: Jg.MENTORS
  },
  ROADMAPS: {
    icon: "roadmap",
    text: "로드맵",
    href: Jg.ROADMAPS
  },
  COMMUNITY: {
    icon: "community",
    text: "커뮤니티",
    href: Jg.COMMUNITY
  },
  CLIPS: {
    icon: "clip",
    text: "클립",
    href: Jg.CLIPS
  }
}, ZC = {
  // 검색바 내부 요소들
  SEARCH_MENU_DROPDOWN: 1,
  // 메뉴 드롭다운
  SEARCH_INPUT: 2,
  // 검색 입력 필드
  EXPLORE_ITEM: 2,
  // 검색 입력 필드의 둘러보기 아이템
  SEARCH_BUTTON: 3,
  // 검색 버튼
  // 메인 GNB 요소들
  BRAND_LOGO: 10,
  // 브랜드 로고
  MENU_LIST: 20,
  // 메뉴 리스트
  // 플로팅 버튼들
  MOVE_TOP: 30,
  // 맨 위로 이동 버튼
  // 제외할 요소들
  HIDDEN: -1
  // 탭 포커스에서 제외
};
function Cc() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const v3 = () => {
  const {
    shouldShowMenu: g
  } = o1(), {
    trackEvent: I
  } = PI();
  return /* @__PURE__ */ R(Ig, { spacing: 10, noWrap: !0, children: [
    /* @__PURE__ */ o(pC, { type: "COURSES", onClick: () => I(Og.CLICK_HEADER_MENU, {
      label: "courses"
    }) }),
    g.challenges && /* @__PURE__ */ o(pC, { type: "CHALLENGES", showIndicator: !0, onClick: () => I(Og.CLICK_HEADER_MENU, {
      label: "challenges"
    }) }),
    g.mentoring && /* @__PURE__ */ o(pC, { type: "MENTORING", onClick: () => I(Og.CLICK_HEADER_MENU, {
      label: "mentoring"
    }) }),
    g.clips && /* @__PURE__ */ o(pC, { type: "CLIPS", showIndicator: !0, onClick: () => I(Og.CLICK_HEADER_MENU, {
      label: "clips"
    }) }),
    g.roadmaps && /* @__PURE__ */ o(pC, { type: "ROADMAPS", onClick: () => I(Og.CLICK_HEADER_MENU, {
      label: "roadmaps"
    }) })
  ] });
};
var X1 = process.env.NODE_ENV === "production" ? {
  name: "1bmnxg7",
  styles: "white-space:nowrap"
} : {
  name: "121elym-MenuItemWithIcon",
  styles: "white-space:nowrap;label:MenuItemWithIcon;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Cc
}, Z1 = process.env.NODE_ENV === "production" ? {
  name: "1j389vi",
  styles: "font-weight:700"
} : {
  name: "l85uma-MenuItemWithIcon",
  styles: "font-weight:700;label:MenuItemWithIcon;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvSGVhZGVyL2NvbXBvbmVudHMvTWVudUxpc3QudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTRJMEMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL2NvbXBvbmVudHMvbmV4dC9IZWFkZXIvY29tcG9uZW50cy9NZW51TGlzdC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge1xuICBBbmNob3IsXG4gIEJveCxcbiAgQ09MT1JfUEFMRVRURSxcbiAgR3JvdXAsXG4gIEljb24sXG4gIEluZGljYXRvcixcbiAgT3B0aW1pemVJbWFnZSxcbiAgVGV4dCxcbn0gZnJvbSAnQGluZmxlYXJuL2RzLXJlYWN0JztcbmltcG9ydCB7IHNvbGlkIH0gZnJvbSAnQGluZmxlYXJuL2ZvbnRhd2Vzb21lLXN2Zy1jb3JlL2ltcG9ydC5tYWNybyc7XG5pbXBvcnQgeyB1c2VDYWxsYmFjaywgdXNlU3RhdGUgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IENETl9VUkwgfSBmcm9tICcuLi8uLi8uLi8uLi9hcHBDb25maWcnO1xuaW1wb3J0IHsgZXZlbnROYW1lcyB9IGZyb20gJy4uLy4uLy4uLy4uL2NvbnN0YW50cy9ndG1FdmVudE5hbWVzJztcbmltcG9ydCB7IHVzZUFwcFNoZWxsVHJhbnNsYXRpb24gfSBmcm9tICcuLi8uLi8uLi8uLi9ob29rcy91c2VBcHBTaGVsbFRyYW5zbGF0aW9uJztcbmltcG9ydCB7IHVzZU1lbnVMaXN0IH0gZnJvbSAnLi4vLi4vLi4vLi4vaG9va3MvdXNlTWVudUxpc3QnO1xuaW1wb3J0IHsgdXNlVXJsQ2hhbmdlIH0gZnJvbSAnLi4vLi4vLi4vLi4vaG9va3MvdXNlVXJsQ2hhbmdlJztcbmltcG9ydCB7IGlzQWN0aXZlTWVudSB9IGZyb20gJy4uLy4uLy4uLy4uL3V0aWxzL21lbnVMaXN0JztcbmltcG9ydCB7IHVzZVRyYWNrRXZlbnQgfSBmcm9tICcuLi8uLi8uLi8uLi91dGlscy91c2VUcmFja0V2ZW50JztcbmltcG9ydCB0eXBlIHsgTUVOVV9MQUJFTFMgfSBmcm9tICcuLi9jb25zdGFudHMnO1xuaW1wb3J0IHsgTUVOVV9JQ09OX09QVElNSVpFX0lNQUdFX1dJRFRIIH0gZnJvbSAnLi4vY29uc3RhbnRzJztcbmltcG9ydCB7IE1FTlVfSVRFTVMgfSBmcm9tICcuLi9jb25zdGFudHMnO1xuaW1wb3J0IHsgVEFCX0lOREVYIH0gZnJvbSAnLi4vY29uc3RhbnRzL3RhYkluZGV4JztcblxuZXhwb3J0IGNvbnN0IE1lbnVMaXN0ID0gKCkgPT4ge1xuICBjb25zdCB7IHNob3VsZFNob3dNZW51IH0gPSB1c2VNZW51TGlzdCgpO1xuICBjb25zdCB7IHRyYWNrRXZlbnQgfSA9IHVzZVRyYWNrRXZlbnQoKTtcblxuICByZXR1cm4gKFxuICAgIDxHcm91cCBzcGFjaW5nPXsxMH0gbm9XcmFwPlxuICAgICAgPE1lbnVJdGVtV2l0aEljb25cbiAgICAgICAgdHlwZT1cIkNPVVJTRVNcIlxuICAgICAgICBvbkNsaWNrPXsoKSA9PlxuICAgICAgICAgIHRyYWNrRXZlbnQoZXZlbnROYW1lcy5DTElDS19IRUFERVJfTUVOVSwge1xuICAgICAgICAgICAgbGFiZWw6ICdjb3Vyc2VzJyxcbiAgICAgICAgICB9KVxuICAgICAgICB9XG4gICAgICAvPlxuICAgICAge3Nob3VsZFNob3dNZW51LmNoYWxsZW5nZXMgJiYgKFxuICAgICAgICA8TWVudUl0ZW1XaXRoSWNvblxuICAgICAgICAgIHR5cGU9XCJDSEFMTEVOR0VTXCJcbiAgICAgICAgICBzaG93SW5kaWNhdG9yXG4gICAgICAgICAgb25DbGljaz17KCkgPT5cbiAgICAgICAgICAgIHRyYWNrRXZlbnQoZXZlbnROYW1lcy5DTElDS19IRUFERVJfTUVOVSwge1xuICAgICAgICAgICAgICBsYWJlbDogJ2NoYWxsZW5nZXMnLFxuICAgICAgICAgICAgfSlcbiAgICAgICAgICB9XG4gICAgICAgIC8+XG4gICAgICApfVxuICAgICAge3Nob3VsZFNob3dNZW51Lm1lbnRvcmluZyAmJiAoXG4gICAgICAgIDxNZW51SXRlbVdpdGhJY29uXG4gICAgICAgICAgdHlwZT1cIk1FTlRPUklOR1wiXG4gICAgICAgICAgb25DbGljaz17KCkgPT5cbiAgICAgICAgICAgIHRyYWNrRXZlbnQoZXZlbnROYW1lcy5DTElDS19IRUFERVJfTUVOVSwge1xuICAgICAgICAgICAgICBsYWJlbDogJ21lbnRvcmluZycsXG4gICAgICAgICAgICB9KVxuICAgICAgICAgIH1cbiAgICAgICAgLz5cbiAgICAgICl9XG4gICAgICB7c2hvdWxkU2hvd01lbnUuY2xpcHMgJiYgKFxuICAgICAgICA8TWVudUl0ZW1XaXRoSWNvblxuICAgICAgICAgIHR5cGU9XCJDTElQU1wiXG4gICAgICAgICAgc2hvd0luZGljYXRvclxuICAgICAgICAgIG9uQ2xpY2s9eygpID0+XG4gICAgICAgICAgICB0cmFja0V2ZW50KGV2ZW50TmFtZXMuQ0xJQ0tfSEVBREVSX01FTlUsIHtcbiAgICAgICAgICAgICAgbGFiZWw6ICdjbGlwcycsXG4gICAgICAgICAgICB9KVxuICAgICAgICAgIH1cbiAgICAgICAgLz5cbiAgICAgICl9XG4gICAgICB7c2hvdWxkU2hvd01lbnUucm9hZG1hcHMgJiYgKFxuICAgICAgICA8TWVudUl0ZW1XaXRoSWNvblxuICAgICAgICAgIHR5cGU9XCJST0FETUFQU1wiXG4gICAgICAgICAgb25DbGljaz17KCkgPT5cbiAgICAgICAgICAgIHRyYWNrRXZlbnQoZXZlbnROYW1lcy5DTElDS19IRUFERVJfTUVOVSwge1xuICAgICAgICAgICAgICBsYWJlbDogJ3JvYWRtYXBzJyxcbiAgICAgICAgICAgIH0pXG4gICAgICAgICAgfVxuICAgICAgICAvPlxuICAgICAgKX1cbiAgICA8L0dyb3VwPlxuICApO1xufTtcblxuZXhwb3J0IGNvbnN0IE1lbnVJdGVtV2l0aEljb24gPSAoe1xuICB0eXBlLFxuICBzaG93SW5kaWNhdG9yID0gZmFsc2UsXG4gIG9uQ2xpY2ssXG4gIHNrZWxldG9uVHlwZSxcbn06IHtcbiAgdHlwZToga2V5b2YgdHlwZW9mIE1FTlVfSVRFTVM7XG4gIHNob3dJbmRpY2F0b3I/OiBib29sZWFuO1xuICBvbkNsaWNrPzogKCkgPT4gdm9pZDtcbiAgc2tlbGV0b25UeXBlPzoga2V5b2YgdHlwZW9mIE1FTlVfSVRFTVM7XG59KSA9PiB7XG4gIGNvbnN0IHsgdCB9ID0gdXNlQXBwU2hlbGxUcmFuc2xhdGlvbigpO1xuXG4gIHJldHVybiAoXG4gICAgPEFuY2hvclxuICAgICAgaD17NDR9XG4gICAgICBweT17Nn1cbiAgICAgIHB4PXsxMH1cbiAgICAgIGhyZWY9e3R5cGUgPyBNRU5VX0lURU1TW3R5cGVdLmhyZWYgOiB1bmRlZmluZWR9XG4gICAgICB0YWJJbmRleD17VEFCX0lOREVYLk1FTlVfTElTVH1cbiAgICAgIGRpc3BsYXk9XCJmbGV4XCJcbiAgICAgIGNzcz17e1xuICAgICAgICBmbGV4U2hyaW5rOiAwLFxuICAgICAgICAnJjpob3Zlcic6IHtcbiAgICAgICAgICB0ZXh0RGVjb3JhdGlvbjogJ25vbmUnLFxuICAgICAgICAgIGJvcmRlclJhZGl1czogNTAsXG4gICAgICAgICAgYmFja2dyb3VuZENvbG9yOiBDT0xPUl9QQUxFVFRFLmdyYXlbMF0sXG4gICAgICAgIH0sXG4gICAgICB9fVxuICAgICAgb25DbGljaz17b25DbGlja30+XG4gICAgICB7c2hvd0luZGljYXRvciA/IChcbiAgICAgICAgPEluZGljYXRvciBzaXplPXsxNn0gcmFkaXVzPVwieGxcIiBsYWJlbD1cIk5cIiBwb3NpdGlvbj1cInRvcC1lbmRcIiBjb2xvcj1cInJlZFwiIG9mZnNldD17M30gaW5saW5lPlxuICAgICAgICAgIDxHcm91cCBhbGlnbj1cImNlbnRlclwiIHNwYWNpbmc9ezR9IG5vV3JhcD5cbiAgICAgICAgICAgIDxHcm91cCB3PXszMn0gaD17MzJ9IGFsaWduPVwiY2VudGVyXCIgcG9zaXRpb249XCJjZW50ZXJcIj5cbiAgICAgICAgICAgICAgPE9wdGltaXplSW1hZ2VcbiAgICAgICAgICAgICAgICBzcmM9e2Ake0NETl9VUkx9L2Fzc2V0cy9pbWFnZXMvaGVhZGVyLyR7TUVOVV9JVEVNU1t0eXBlXS5pY29ufS5wbmdgfVxuICAgICAgICAgICAgICAgIGFsdD17TUVOVV9JVEVNU1t0eXBlXS50ZXh0fVxuICAgICAgICAgICAgICAgIHc9e01FTlVfSUNPTl9PUFRJTUlaRV9JTUFHRV9XSURUSH1cbiAgICAgICAgICAgICAgICB3aWR0aD17MzJ9XG4gICAgICAgICAgICAgICAgaGVpZ2h0PXszMn1cbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgIDwvR3JvdXA+XG4gICAgICAgICAgICA8TWVudUxpc3RBY3RpdmVXcmFwcGVyIHR5cGU9e3R5cGV9IGlzU2tlbGV0b249eyEhc2tlbGV0b25UeXBlfT5cbiAgICAgICAgICAgICAgPFRleHRcbiAgICAgICAgICAgICAgICBzaXplPXsxNn1cbiAgICAgICAgICAgICAgICBjb2xvcj1cImdyYXkuOVwiXG4gICAgICAgICAgICAgICAgZnc9ezcwMH1cbiAgICAgICAgICAgICAgICBjbGFzc05hbWU9e3NrZWxldG9uVHlwZSA/IGBjbGFzcy1sYWJlbC0ke3NrZWxldG9uVHlwZS50b0xvd2VyQ2FzZSgpfWAgOiAnJ31cbiAgICAgICAgICAgICAgICBjc3M9e3sgd2hpdGVTcGFjZTogJ25vd3JhcCcgfX0+XG4gICAgICAgICAgICAgICAgeyFza2VsZXRvblR5cGUgJiYgdChNRU5VX0lURU1TW3R5cGVdLnRleHQpfVxuICAgICAgICAgICAgICA8L1RleHQ+XG4gICAgICAgICAgICA8L01lbnVMaXN0QWN0aXZlV3JhcHBlcj5cbiAgICAgICAgICA8L0dyb3VwPlxuICAgICAgICA8L0luZGljYXRvcj5cbiAgICAgICkgOiAoXG4gICAgICAgIDxHcm91cCBhbGlnbj1cImNlbnRlclwiIHNwYWNpbmc9ezR9IGNzcz17eyBmb250V2VpZ2h0OiA3MDAgfX0gbm9XcmFwPlxuICAgICAgICAgIDxHcm91cCB3PXszMn0gaD17MzJ9IGFsaWduPVwiY2VudGVyXCIgcG9zaXRpb249XCJjZW50ZXJcIj5cbiAgICAgICAgICAgIDxPcHRpbWl6ZUltYWdlXG4gICAgICAgICAgICAgIHNyYz17YCR7Q0ROX1VSTH0vYXNzZXRzL2ltYWdlcy9oZWFkZXIvJHtNRU5VX0lURU1TW3R5cGVdLmljb259LnBuZ2B9XG4gICAgICAgICAgICAgIGFsdD17TUVOVV9JVEVNU1t0eXBlXS50ZXh0fVxuICAgICAgICAgICAgICB3PXtNRU5VX0lDT05fT1BUSU1JWkVfSU1BR0VfV0lEVEh9XG4gICAgICAgICAgICAgIHdpZHRoPXszMn1cbiAgICAgICAgICAgICAgaGVpZ2h0PXszMn1cbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgPC9Hcm91cD5cbiAgICAgICAgICA8TWVudUxpc3RBY3RpdmVXcmFwcGVyIHR5cGU9e3R5cGV9IGlzU2tlbGV0b249eyEhc2tlbGV0b25UeXBlfT5cbiAgICAgICAgICAgIDxUZXh0XG4gICAgICAgICAgICAgIHNpemU9ezE2fVxuICAgICAgICAgICAgICBjb2xvcj1cImdyYXkuOVwiXG4gICAgICAgICAgICAgIGZ3PXs3MDB9XG4gICAgICAgICAgICAgIGNsYXNzTmFtZT17c2tlbGV0b25UeXBlID8gYGNsYXNzLWxhYmVsLSR7c2tlbGV0b25UeXBlLnRvTG93ZXJDYXNlKCl9YCA6ICcnfVxuICAgICAgICAgICAgICBjc3M9e3sgd2hpdGVTcGFjZTogJ25vd3JhcCcgfX0+XG4gICAgICAgICAgICAgIHshc2tlbGV0b25UeXBlICYmIHQoTUVOVV9JVEVNU1t0eXBlXS50ZXh0KX1cbiAgICAgICAgICAgIDwvVGV4dD5cbiAgICAgICAgICA8L01lbnVMaXN0QWN0aXZlV3JhcHBlcj5cbiAgICAgICAgPC9Hcm91cD5cbiAgICAgICl9XG4gICAgPC9BbmNob3I+XG4gICk7XG59O1xuXG5leHBvcnQgdHlwZSBNZW51SXRlbVdpdGhSb2xlID0gJ0lOU1RSVUNUT1InIHwgJ0JVU0lORVNTJztcblxuZXhwb3J0IGNvbnN0IE1lbnVJdGVtID0gKHtcbiAgaHJlZixcbiAgdGV4dCxcbiAgb25DbGljayxcbiAgc2tlbGV0b25UeXBlLFxufToge1xuICBocmVmOiBzdHJpbmc7XG4gIHRleHQ/OiBzdHJpbmc7XG4gIG9uQ2xpY2s/OiAoKSA9PiB2b2lkO1xuICBza2VsZXRvblR5cGU/OiBNZW51SXRlbVdpdGhSb2xlO1xufSkgPT4gKFxuICA8QW5jaG9yXG4gICAgaHJlZj17aHJlZn1cbiAgICB0YWJJbmRleD17VEFCX0lOREVYLk1FTlVfTElTVH1cbiAgICBkaXNwbGF5PVwiZmxleFwiXG4gICAgY3NzPXt7ICcmOmhvdmVyJzogeyB0ZXh0RGVjb3JhdGlvbjogJ25vbmUnIH0gfX1cbiAgICBvbkNsaWNrPXtvbkNsaWNrfT5cbiAgICA8R3JvdXAgYWxpZ249XCJjZW50ZXJcIiBzcGFjaW5nPXs0fT5cbiAgICAgIDxUZXh0XG4gICAgICAgIHNpemU9ezE2fVxuICAgICAgICBjb2xvcj1cImdyYXkuN1wiXG4gICAgICAgIGZ3PXs2MDB9XG4gICAgICAgIGNsYXNzTmFtZT17c2tlbGV0b25UeXBlID8gYGNsYXNzLWxhYmVsLSR7c2tlbGV0b25UeXBlLnRvTG93ZXJDYXNlKCl9YCA6ICcnfT5cbiAgICAgICAgeyFza2VsZXRvblR5cGUgJiYgdGV4dH1cbiAgICAgIDwvVGV4dD5cbiAgICAgIDxJY29uIGljb249e3NvbGlkKCdhbmdsZS1yaWdodCcpfSBzaXplPVwieHNcIiBjb2xvcj1cImdyYXkuOVwiIC8+XG4gICAgPC9Hcm91cD5cbiAgPC9BbmNob3I+XG4pO1xuXG5leHBvcnQgY29uc3QgTWVudUxpc3RBY3RpdmVXcmFwcGVyID0gKHtcbiAgdHlwZSxcbiAgY2hpbGRyZW4sXG4gIGlzU2tlbGV0b246IGlzU1NSID0gZmFsc2UsXG59OiB7XG4gIHR5cGU6IGtleW9mIHR5cGVvZiBNRU5VX0xBQkVMUztcbiAgY2hpbGRyZW46IFJlYWN0LlJlYWN0Tm9kZTtcbiAgaXNTa2VsZXRvbj86IGJvb2xlYW47XG59KSA9PiB7XG4gIGNvbnN0IFtpc0FjdGl2ZSwgc2V0SXNBY3RpdmVdID0gdXNlU3RhdGUoKCkgPT4gKGlzU1NSID8gZmFsc2UgOiBpc0FjdGl2ZU1lbnUodHlwZSkpKTtcblxuICAvLyBVUkwg67OA6rK9IOyLnCBhY3RpdmUg7IOB7YOcIOuPmeq4sO2ZlFxuICBjb25zdCBoYW5kbGVMb2NhdGlvbkNoYW5nZSA9IHVzZUNhbGxiYWNrKCgpID0+IHtcbiAgICBpZiAoaXNTU1IpIHtcbiAgICAgIHJldHVybjtcbiAgICB9XG5cbiAgICBjb25zdCBuZXdJc0FjdGl2ZSA9IGlzQWN0aXZlTWVudSh0eXBlKTtcbiAgICBzZXRJc0FjdGl2ZShuZXdJc0FjdGl2ZSk7XG4gIH0sIFt0eXBlLCBpc1NTUl0pO1xuXG4gIHVzZVVybENoYW5nZShoYW5kbGVMb2NhdGlvbkNoYW5nZSk7XG5cbiAgcmV0dXJuIChcbiAgICA8Qm94IGNzcz17eyBwb3NpdGlvbjogJ3JlbGF0aXZlJyB9fT5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICAgIHtpc0FjdGl2ZSAmJiAoXG4gICAgICAgIDxCb3hcbiAgICAgICAgICB3PVwiMTAwJVwiXG4gICAgICAgICAgaD17M31cbiAgICAgICAgICBjc3M9e3tcbiAgICAgICAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgICAgICAgYm90dG9tOiAtMixcbiAgICAgICAgICAgIGxlZnQ6ICc1MCUnLFxuICAgICAgICAgICAgdHJhbnNmb3JtOiAndHJhbnNsYXRlWCgtNTAlKScsXG4gICAgICAgICAgfX0+XG4gICAgICAgICAgPEJveFxuICAgICAgICAgICAgdz1cIjEwMCVcIlxuICAgICAgICAgICAgaD17Mn1cbiAgICAgICAgICAgIGNzcz17e1xuICAgICAgICAgICAgICBib3JkZXJSYWRpdXM6IDgsXG4gICAgICAgICAgICAgIGJhY2tncm91bmRDb2xvcjogQ09MT1JfUEFMRVRURS5pbmZncmVlbls3XSxcbiAgICAgICAgICAgIH19XG4gICAgICAgICAgLz5cbiAgICAgICAgPC9Cb3g+XG4gICAgICApfVxuICAgIDwvQm94PlxuICApO1xufTtcbiJdfQ== */",
  toString: Cc
}, V1 = process.env.NODE_ENV === "production" ? {
  name: "1bmnxg7",
  styles: "white-space:nowrap"
} : {
  name: "121elym-MenuItemWithIcon",
  styles: "white-space:nowrap;label:MenuItemWithIcon;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Cc
};
const pC = ({
  type: g,
  showIndicator: I = !1,
  onClick: C,
  skeletonType: A
}) => {
  const {
    t: c
  } = UI();
  return /* @__PURE__ */ o(Js, { h: 44, py: 6, px: 10, href: g ? iI[g].href : void 0, tabIndex: ZC.MENU_LIST, display: "flex", css: /* @__PURE__ */ $({
    flexShrink: 0,
    "&:hover": {
      textDecoration: "none",
      borderRadius: 50,
      backgroundColor: rg.gray[0]
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:MenuItemWithIcon;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), onClick: C, children: I ? /* @__PURE__ */ o(xr, { size: 16, radius: "xl", label: "N", position: "top-end", color: "red", offset: 3, inline: !0, children: /* @__PURE__ */ R(Ig, { align: "center", spacing: 4, noWrap: !0, children: [
    /* @__PURE__ */ o(Ig, { w: 32, h: 32, align: "center", position: "center", children: /* @__PURE__ */ o(bC, { src: `${jC}/assets/images/header/${iI[g].icon}.png`, alt: iI[g].text, w: il, width: 32, height: 32 }) }),
    /* @__PURE__ */ o(hb, { type: g, isSkeleton: !!A, children: /* @__PURE__ */ o(U, { size: 16, color: "gray.9", fw: 700, className: A ? `class-label-${A.toLowerCase()}` : "", css: X1, children: !A && c(iI[g].text) }) })
  ] }) }) : /* @__PURE__ */ R(Ig, { align: "center", spacing: 4, css: Z1, noWrap: !0, children: [
    /* @__PURE__ */ o(Ig, { w: 32, h: 32, align: "center", position: "center", children: /* @__PURE__ */ o(bC, { src: `${jC}/assets/images/header/${iI[g].icon}.png`, alt: iI[g].text, w: il, width: 32, height: 32 }) }),
    /* @__PURE__ */ o(hb, { type: g, isSkeleton: !!A, children: /* @__PURE__ */ o(U, { size: 16, color: "gray.9", fw: 700, className: A ? `class-label-${A.toLowerCase()}` : "", css: V1, children: !A && c(iI[g].text) }) })
  ] }) });
};
process.env.NODE_ENV;
var m1 = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "1y6y0da-MenuListActiveWrapper",
  styles: "position:relative;label:MenuListActiveWrapper;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Cc
};
const hb = ({
  type: g,
  children: I,
  isSkeleton: C = !1
}) => {
  const [A, c] = O(() => C ? !1 : gb(g)), l = k(() => {
    if (C)
      return;
    const t = gb(g);
    c(t);
  }, [g, C]);
  return Uu(l), /* @__PURE__ */ R(P, { css: m1, children: [
    I,
    A && /* @__PURE__ */ o(P, { w: "100%", h: 3, css: /* @__PURE__ */ $({
      position: "absolute",
      bottom: -2,
      left: "50%",
      transform: "translateX(-50%)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:MenuListActiveWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ o(P, { w: "100%", h: 2, css: /* @__PURE__ */ $({
      borderRadius: 8,
      backgroundColor: rg.infgreen[7]
    }, process.env.NODE_ENV === "production" ? "" : ";label:MenuListActiveWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") }) })
  ] });
};
function h1() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const J3 = process.env.NODE_ENV === "production" ? {
  name: "lidyt8",
  styles: "*{box-sizing:border-box;}a{text-decoration:none;}.hidden{display:none;}.disabledScroll{overflow:hidden;}"
} : {
  name: "ncoqxb-globals",
  styles: "*{box-sizing:border-box;}a{text-decoration:none;}.hidden{display:none;}.disabledScroll{overflow:hidden;};label:globals;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9zdHlsZXMvZ2xvYmFscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFbUIiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL3N0eWxlcy9nbG9iYWxzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5jb25zdCBnbG9iYWxzID0gY3NzYFxuICAqIHtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICB9XG5cbiAgYSB7XG4gICAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuICB9XG5cbiAgLmhpZGRlbiB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxuXG4gIC5kaXNhYmxlZFNjcm9sbCB7XG4gICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgfVxuYDtcblxuZXhwb3J0IGRlZmF1bHQgZ2xvYmFscztcbiJdfQ== */",
  toString: h1
}, Y3 = {
  mobile: 768,
  tablet: 1024,
  laptop: 1365,
  desktop: 1920
}, hc = {
  desktop: "@media (max-width: 1200px)",
  tablet: "@media (max-width: 1024px)",
  mobile: "@media (max-width: 768px)",
  smallMobile: "@media (max-width: 480px)"
};
function $g(g) {
  return g === "mobile" ? hc.mobile : g === "tablet" ? hc.tablet : hc.desktop;
}
const de = (g = !1) => ({
  HEADER: g ? 72 : 200,
  HEADER_NOTICE: g ? 73 : 201,
  SCRIM: g ? 10 : 200,
  // NOTE: drawer overlay
  MOBILE_ASIDE: g ? 76 : 201,
  // NOTE: drawer
  BOTTOM_NAVIGATION: g ? 74 : 200,
  MOVE_TOP: g ? 9 : 200,
  // NOTE: 모달  dimmed 영역의 zIndex 201보다 작아야 함
  POPOVER: g ? 10 : 15,
  SEARCHBAR_MODAL: 202
}), F3 = {
  CHILDREN_WRAPPER: "children-wrapper",
  HEADER_DIVIDER_DESKTOP: "header-divider-desktop",
  HEADER_DIVIDER_MOBILE: "header-divider-mobile",
  HEADER_CONTAINER_DESKTOP: "header-container-desktop",
  HEADER_CONTAINER_MOBILE: "header-container-mobile",
  /**
   * @NOTE
   * 헤더 아래로 돌출되는 검색바 영역을 실제 레이아웃 공간으로 확보하는 스페이서.
   * main/footer 를 transform 으로 밀어내던 방식은 스크롤 중 콘텐츠가 움직이는
   * 체감 CLS(드득거림)를 유발해서 flow 상의 공간 확보로 대체함
   */
  HEADER_SEARCH_BAR_SPACER: "header-search-bar-spacer",
  FOOTER_CONTAINER: "footer-container",
  /**
   * @NOTE
   * 아래로 스크롤 했을 때 모바일 헤더 가려지게 하기 위한 식별자
   */
  HEADER_MOBILE_TOP: "header-mobile-top",
  /**
   * @NOTE
   * 아래로 스크롤 했을 때 바텀 네비 가려지게 하기 위한 식별자
   * 앤트맨에서 참조하기 위해 사용
   */
  HEADER_MOBILE_BOTTOM: "header-mobile-bottom"
}, ku = {
  DESKTOP: {
    DEFAULT: 65,
    SEARCH_BAR: 80
  },
  MOBILE: {
    DEFAULT: 50,
    SEARCH_BAR: 80
  }
}, Du = ku.DESKTOP.DEFAULT, z3 = ku.MOBILE.DEFAULT, W1 = /* @__PURE__ */ $({
  position: "relative",
  display: "flex",
  alignItems: "center",
  height: Du,
  padding: "0 32px",
  maxWidth: 1440,
  width: "100%",
  minHeight: "unset",
  [$g("tablet")]: {
    padding: "0 32px",
    height: "auto"
  },
  [$g("mobile")]: {
    padding: "0 16px",
    height: "auto"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleHeaderContent;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Ou = jg({
  isFocused: !1,
  setIsFocused: () => {
  },
  keyword: "",
  setKeyword: () => {
  },
  selectedMenu: "COURSES",
  setSelectedMenu: () => {
  },
  inputRef: {
    current: null
  }
}), N1 = ({
  children: g
}) => {
  const [I, C] = O(!1), [A, c] = O(VI("s")), [l, t] = O(() => Ib()), i = Ag(null), e = k(() => {
    const b = VI("s"), a = Ib();
    c(b), t(a);
  }, [c, t]);
  Uu(e);
  const n = tg(() => ({
    isFocused: I,
    setIsFocused: C,
    keyword: A,
    setKeyword: c,
    selectedMenu: l,
    setSelectedMenu: t,
    inputRef: i
  }), [I, C, A, c, l, t, i]);
  return /* @__PURE__ */ o(Ou.Provider, { value: n, children: g });
}, kI = () => {
  const g = Zg(Ou);
  if (!g)
    throw new Error("useSearchBarContext must be used within a SearchBarContextProvider");
  return g;
}, x1 = () => tg(() => O0(), []), ju = jg({
  showMenuList: !1,
  setShowMenuList: () => {
  },
  isSearchBarVisible: !1,
  setIsSearchBarVisible: () => {
  }
}), f3 = ({
  showMenuList: g,
  children: I
}) => {
  const C = x1(), [A, c] = O(g), [l, t] = O(Im("data-show-search-bar")), i = tg(() => ({
    showMenuList: A,
    setShowMenuList: c,
    isSearchBarVisible: l,
    setIsSearchBarVisible: t
  }), [A, c, l, t]);
  return q(() => {
    c(g);
  }, [g]), q(() => {
    t(C);
  }, [C]), /* @__PURE__ */ o(ju.Provider, { value: i, children: I });
}, IA = () => {
  const g = Zg(ju);
  if (!g)
    throw new Error("useSearchBarContext must be used within a SearchBarProvider");
  return g;
};
function y1() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const p1 = 4e3, Wb = 1e3, Nb = 60;
var R1 = process.env.NODE_ENV === "production" ? {
  name: "r6nmxn",
  styles: "flex:1;overflow:hidden;width:100%"
} : {
  name: "1rplhw5-AppShellInput",
  styles: "flex:1;overflow:hidden;width:100%;label:AppShellInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: y1
};
const Eu = ({
  isMobile: g = !1,
  disabled: I = !1
}) => {
  const {
    showMenuList: C
  } = IA(), {
    trackEvent: A
  } = PI(), {
    isFocused: c,
    setIsFocused: l,
    keyword: t,
    setKeyword: i,
    inputRef: e
  } = kI(), n = g ? !1 : C, b = () => {
    I || (A(Og.CLICK_SEARCHBAR), l(!0));
  }, a = (s) => {
    I || s.target.value.length > Nb || i(s.target.value);
  };
  return /* @__PURE__ */ R(Ig, { pos: "relative", w: "100%", h: WA(n), css: R1, children: [
    !c && !t && /* @__PURE__ */ o(v1, { isFocused: c, isMobile: g }),
    /* @__PURE__ */ o(yr, { ref: e, "data-autofocus": !0, type: "search", enterKeyHint: "search", "aria-keyshortcuts": "Control+K Meta+K", miw: 279, w: "100%", maw: "100%", tabIndex: ZC.SEARCH_INPUT, value: t, onChange: a, onFocusCapture: b, onBlurCapture: () => I ? null : l(!1), maxLength: Nb, readOnly: I, styles: {
      root: {
        width: "100%",
        flexGrow: 1
      },
      wrapper: {
        width: "100%"
      },
      input: {
        border: "none",
        padding: 0,
        flex: 1,
        fontSize: 16
      }
    } })
  ] });
}, B1 = ["검색바.01", "검색바.02", "검색바.03", "검색바.04", "검색바.05", "검색바.06", "검색바.07", "검색바.08", "검색바.09", "검색바.10", "검색바.11"], WA = (g) => g ? 58 : 46;
function v1({
  isFocused: g,
  isMobile: I
}) {
  const {
    showMenuList: C
  } = IA(), {
    t: A
  } = UI(), [c, l] = O(B1), [t, i] = O(!0), [e, n] = O(0), b = Ag(null), a = Ag(null), s = I ? !1 : C;
  return q(() => {
    if (g) {
      b.current && (clearInterval(b.current), b.current = null), a.current && (clearTimeout(a.current), a.current = null);
      return;
    }
    const d = () => {
      i(!0), n(-WA(s)), a.current = setTimeout(() => {
        i(!1), n(0), l((Z) => {
          const [r, ...h] = Z;
          return [...h, r];
        });
      }, Wb);
    };
    return d(), b.current = setInterval(d, p1), () => {
      b.current && (clearInterval(b.current), b.current = null), a.current && (clearTimeout(a.current), a.current = null);
    };
  }, [g, s]), /* @__PURE__ */ o(P, { css: /* @__PURE__ */ $({
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    height: WA(s),
    overflow: "hidden",
    zIndex: 2,
    pointerEvents: "none",
    opacity: g ? 0 : 1,
    transition: "opacity 0.2s ease-out"
  }, process.env.NODE_ENV === "production" ? "" : ";label:RollingText;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ o(P, { css: /* @__PURE__ */ $({
    display: "flex",
    flexDirection: "column",
    transition: t ? `transform ${Wb}ms cubic-bezier(0.4,0,0.2,1)` : "none",
    transform: `translateY(${e}px)`
  }, process.env.NODE_ENV === "production" ? "" : ";label:RollingText;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvU2VhcmNoQmFyL0FwcFNoZWxsSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXVMUSIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9mZS1zaGFyZWQvZmUtc2hhcmVkL3BhY2thZ2VzL2FwcC1zaGVsbC9zcmMvY29tcG9uZW50cy9uZXh0L1NlYXJjaEJhci9BcHBTaGVsbElucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEJveCwgR3JvdXAsIFRleHQsIFRleHRJbnB1dCB9IGZyb20gJ0BpbmZsZWFybi9kcy1yZWFjdCc7XG5pbXBvcnQgeyB1c2VFZmZlY3QsIHVzZVN0YXRlLCB1c2VSZWYgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IHVzZUFwcFNoZWxsSW5wdXRDb250ZXh0IH0gZnJvbSAnLi91c2VBcHBTaGVsbElucHV0Q29udGV4dCc7XG5pbXBvcnQgeyBldmVudE5hbWVzIH0gZnJvbSAnLi4vLi4vLi4vY29uc3RhbnRzL2d0bUV2ZW50TmFtZXMnO1xuaW1wb3J0IHsgdXNlQXBwU2hlbGxUcmFuc2xhdGlvbiB9IGZyb20gJy4uLy4uLy4uL2hvb2tzL3VzZUFwcFNoZWxsVHJhbnNsYXRpb24nO1xuaW1wb3J0IHsgdXNlVHJhY2tFdmVudCB9IGZyb20gJy4uLy4uLy4uL3V0aWxzL3VzZVRyYWNrRXZlbnQnO1xuaW1wb3J0IHsgVEFCX0lOREVYIH0gZnJvbSAnLi4vSGVhZGVyL2NvbnN0YW50cy90YWJJbmRleCc7XG5pbXBvcnQgeyB1c2VTZWFyY2hCYXJDb250ZXh0IH0gZnJvbSAnLi4vSGVhZGVyL3VzZVNlYXJjaEJhckNvbnRleHQnO1xuXG5leHBvcnQgY29uc3QgUk9MTElOR19JTlRFUlZBTCA9IDQwMDA7IC8vIOuhpOungSDso7zquLAobXMpXG5leHBvcnQgY29uc3QgUk9MTElOR19EVVJBVElPTiA9IDEwMDA7IC8vIOyVoOuLiOuplOydtOyFmCDsp4Dsho3si5zqsIQobXMpXG5cbmNvbnN0IE1BWF9MRU5HVEggPSA2MDtcblxuZXhwb3J0IGNvbnN0IEFwcFNoZWxsSW5wdXQgPSAoe1xuICBpc01vYmlsZSA9IGZhbHNlLFxuICBkaXNhYmxlZCA9IGZhbHNlLFxufToge1xuICBpc01vYmlsZT86IGJvb2xlYW47XG4gIGRpc2FibGVkPzogYm9vbGVhbjtcbn0pID0+IHtcbiAgY29uc3QgeyBzaG93TWVudUxpc3Q6IHNob3dNZW51TGlzdEluRGVza3RvcCB9ID0gdXNlU2VhcmNoQmFyQ29udGV4dCgpO1xuICBjb25zdCB7IHRyYWNrRXZlbnQgfSA9IHVzZVRyYWNrRXZlbnQoKTtcbiAgY29uc3QgeyBpc0ZvY3VzZWQsIHNldElzRm9jdXNlZCwga2V5d29yZCwgc2V0S2V5d29yZCwgaW5wdXRSZWYgfSA9IHVzZUFwcFNoZWxsSW5wdXRDb250ZXh0KCk7XG5cbiAgY29uc3Qgc2hvd01lbnVMaXN0ID0gaXNNb2JpbGUgPyBmYWxzZSA6IHNob3dNZW51TGlzdEluRGVza3RvcDtcblxuICBjb25zdCBoYW5kbGVGb2N1c0NhcHR1cmUgPSAoKSA9PiB7XG4gICAgaWYgKGRpc2FibGVkKSB7XG4gICAgICByZXR1cm47XG4gICAgfVxuICAgIHZvaWQgdHJhY2tFdmVudChldmVudE5hbWVzLkNMSUNLX1NFQVJDSEJBUik7XG4gICAgc2V0SXNGb2N1c2VkKHRydWUpO1xuICB9O1xuXG4gIGNvbnN0IGhhbmRsZUNoYW5nZSA9IChlOiBSZWFjdC5DaGFuZ2VFdmVudDxIVE1MSW5wdXRFbGVtZW50PikgPT4ge1xuICAgIGlmIChkaXNhYmxlZCkge1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIGlmIChlLnRhcmdldC52YWx1ZS5sZW5ndGggPiBNQVhfTEVOR1RIKSB7XG4gICAgICByZXR1cm47XG4gICAgfVxuICAgIHNldEtleXdvcmQoZS50YXJnZXQudmFsdWUpO1xuICB9O1xuXG4gIHJldHVybiAoXG4gICAgPEdyb3VwXG4gICAgICBwb3M9XCJyZWxhdGl2ZVwiXG4gICAgICB3PVwiMTAwJVwiXG4gICAgICBoPXtQTEFDRUhPTERFUl9IRUlHSFQoc2hvd01lbnVMaXN0KX1cbiAgICAgIGNzcz17eyBmbGV4OiAxLCBvdmVyZmxvdzogJ2hpZGRlbicsIHdpZHRoOiAnMTAwJScgfX0+XG4gICAgICB7IWlzRm9jdXNlZCAmJiAha2V5d29yZCAmJiA8Um9sbGluZ1RleHQgaXNGb2N1c2VkPXtpc0ZvY3VzZWR9IGlzTW9iaWxlPXtpc01vYmlsZX0gLz59XG4gICAgICA8VGV4dElucHV0XG4gICAgICAgIHJlZj17aW5wdXRSZWZ9XG4gICAgICAgIGRhdGEtYXV0b2ZvY3VzXG4gICAgICAgIHR5cGU9XCJzZWFyY2hcIlxuICAgICAgICBlbnRlcktleUhpbnQ9XCJzZWFyY2hcIlxuICAgICAgICBhcmlhLWtleXNob3J0Y3V0cz1cIkNvbnRyb2wrSyBNZXRhK0tcIlxuICAgICAgICBtaXc9ezI3OX1cbiAgICAgICAgdz1cIjEwMCVcIlxuICAgICAgICBtYXc9XCIxMDAlXCJcbiAgICAgICAgdGFiSW5kZXg9e1RBQl9JTkRFWC5TRUFSQ0hfSU5QVVR9XG4gICAgICAgIHZhbHVlPXtrZXl3b3JkfVxuICAgICAgICBvbkNoYW5nZT17aGFuZGxlQ2hhbmdlfVxuICAgICAgICBvbkZvY3VzQ2FwdHVyZT17aGFuZGxlRm9jdXNDYXB0dXJlfVxuICAgICAgICBvbkJsdXJDYXB0dXJlPXsoKSA9PiAoZGlzYWJsZWQgPyBudWxsIDogc2V0SXNGb2N1c2VkKGZhbHNlKSl9XG4gICAgICAgIG1heExlbmd0aD17TUFYX0xFTkdUSH1cbiAgICAgICAgcmVhZE9ubHk9e2Rpc2FibGVkfVxuICAgICAgICBzdHlsZXM9e3tcbiAgICAgICAgICByb290OiB7XG4gICAgICAgICAgICB3aWR0aDogJzEwMCUnLFxuICAgICAgICAgICAgZmxleEdyb3c6IDEsXG4gICAgICAgICAgfSxcbiAgICAgICAgICB3cmFwcGVyOiB7XG4gICAgICAgICAgICB3aWR0aDogJzEwMCUnLFxuICAgICAgICAgIH0sXG4gICAgICAgICAgaW5wdXQ6IHtcbiAgICAgICAgICAgIGJvcmRlcjogJ25vbmUnLFxuICAgICAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgICAgIGZsZXg6IDEsXG4gICAgICAgICAgICBmb250U2l6ZTogMTYsXG4gICAgICAgICAgfSxcbiAgICAgICAgfX1cbiAgICAgIC8+XG4gICAgPC9Hcm91cD5cbiAgKTtcbn07XG5cbmNvbnN0IFJPTExJTkdfVEVYVCA9IFtcbiAgJ+qygOyDieuwlC4wMScsXG4gICfqsoDsg4nrsJQuMDInLFxuICAn6rKA7IOJ67CULjAzJyxcbiAgJ+qygOyDieuwlC4wNCcsXG4gICfqsoDsg4nrsJQuMDUnLFxuICAn6rKA7IOJ67CULjA2JyxcbiAgJ+qygOyDieuwlC4wNycsXG4gICfqsoDsg4nrsJQuMDgnLFxuICAn6rKA7IOJ67CULjA5JyxcbiAgJ+qygOyDieuwlC4xMCcsXG4gICfqsoDsg4nrsJQuMTEnLFxuXTtcblxuZXhwb3J0IGNvbnN0IFBMQUNFSE9MREVSX0hFSUdIVCA9IChzaG93TWVudUxpc3Q6IGJvb2xlYW4pID0+IChzaG93TWVudUxpc3QgPyA1OCA6IDQ2KTtcblxuZnVuY3Rpb24gUm9sbGluZ1RleHQoeyBpc0ZvY3VzZWQsIGlzTW9iaWxlIH06IHsgaXNGb2N1c2VkOiBib29sZWFuOyBpc01vYmlsZTogYm9vbGVhbiB9KSB7XG4gIGNvbnN0IHsgc2hvd01lbnVMaXN0OiBzaG93TWVudUxpc3RJbkRlc2t0b3AgfSA9IHVzZVNlYXJjaEJhckNvbnRleHQoKTtcblxuICBjb25zdCB7IHQgfSA9IHVzZUFwcFNoZWxsVHJhbnNsYXRpb24oKTtcbiAgY29uc3QgW2xpbmVzLCBzZXRMaW5lc10gPSB1c2VTdGF0ZShST0xMSU5HX1RFWFQpO1xuICBjb25zdCBbaXNUcmFuc2l0aW9uLCBzZXRJc1RyYW5zaXRpb25dID0gdXNlU3RhdGUodHJ1ZSk7XG4gIGNvbnN0IFt0cmFuc2xhdGVZLCBzZXRUcmFuc2xhdGVZXSA9IHVzZVN0YXRlKDApO1xuICBjb25zdCBpbnRlcnZhbFJlZiA9IHVzZVJlZjxOb2RlSlMuVGltZW91dCB8IG51bGw+KG51bGwpO1xuICBjb25zdCB0aW1lb3V0UmVmID0gdXNlUmVmPE5vZGVKUy5UaW1lb3V0IHwgbnVsbD4obnVsbCk7XG5cbiAgY29uc3Qgc2hvd01lbnVMaXN0ID0gaXNNb2JpbGUgPyBmYWxzZSA6IHNob3dNZW51TGlzdEluRGVza3RvcDtcblxuICB1c2VFZmZlY3QoKCkgPT4ge1xuICAgIGlmIChpc0ZvY3VzZWQpIHtcbiAgICAgIC8vIO2PrOy7pOyKpCDsg4Htg5zrqbQg6riw7KG0IO2DgOydtOuouOuTpCDsoJXrpqxcbiAgICAgIGlmIChpbnRlcnZhbFJlZi5jdXJyZW50KSB7XG4gICAgICAgIGNsZWFySW50ZXJ2YWwoaW50ZXJ2YWxSZWYuY3VycmVudCk7XG4gICAgICAgIGludGVydmFsUmVmLmN1cnJlbnQgPSBudWxsO1xuICAgICAgfVxuXG4gICAgICBpZiAodGltZW91dFJlZi5jdXJyZW50KSB7XG4gICAgICAgIGNsZWFyVGltZW91dCh0aW1lb3V0UmVmLmN1cnJlbnQpO1xuICAgICAgICB0aW1lb3V0UmVmLmN1cnJlbnQgPSBudWxsO1xuICAgICAgfVxuXG4gICAgICByZXR1cm47XG4gICAgfVxuXG4gICAgY29uc3Qgc3RhcnRSb2xsaW5nID0gKCkgPT4ge1xuICAgICAgc2V0SXNUcmFuc2l0aW9uKHRydWUpO1xuICAgICAgc2V0VHJhbnNsYXRlWSgtUExBQ0VIT0xERVJfSEVJR0hUKHNob3dNZW51TGlzdCkpO1xuXG4gICAgICB0aW1lb3V0UmVmLmN1cnJlbnQgPSBzZXRUaW1lb3V0KCgpID0+IHtcbiAgICAgICAgc2V0SXNUcmFuc2l0aW9uKGZhbHNlKTtcbiAgICAgICAgc2V0VHJhbnNsYXRlWSgwKTtcbiAgICAgICAgc2V0TGluZXMoKHByZXYpID0+IHtcbiAgICAgICAgICBjb25zdCBbZmlyc3QsIC4uLnJlc3RdID0gcHJldjtcblxuICAgICAgICAgIHJldHVybiBbLi4ucmVzdCwgZmlyc3RdO1xuICAgICAgICB9KTtcbiAgICAgIH0sIFJPTExJTkdfRFVSQVRJT04pO1xuICAgIH07XG5cbiAgICAvLyDsponsi5wg7Iuc7J6RXG4gICAgc3RhcnRSb2xsaW5nKCk7XG5cbiAgICAvLyDso7zquLDsoIHsnLzroZwg7Iuk7ZaJXG4gICAgaW50ZXJ2YWxSZWYuY3VycmVudCA9IHNldEludGVydmFsKHN0YXJ0Um9sbGluZywgUk9MTElOR19JTlRFUlZBTCk7XG5cbiAgICByZXR1cm4gKCkgPT4ge1xuICAgICAgaWYgKGludGVydmFsUmVmLmN1cnJlbnQpIHtcbiAgICAgICAgY2xlYXJJbnRlcnZhbChpbnRlcnZhbFJlZi5jdXJyZW50KTtcbiAgICAgICAgaW50ZXJ2YWxSZWYuY3VycmVudCA9IG51bGw7XG4gICAgICB9XG5cbiAgICAgIGlmICh0aW1lb3V0UmVmLmN1cnJlbnQpIHtcbiAgICAgICAgY2xlYXJUaW1lb3V0KHRpbWVvdXRSZWYuY3VycmVudCk7XG4gICAgICAgIHRpbWVvdXRSZWYuY3VycmVudCA9IG51bGw7XG4gICAgICB9XG4gICAgfTtcbiAgfSwgW2lzRm9jdXNlZCwgc2hvd01lbnVMaXN0XSk7XG5cbiAgcmV0dXJuIChcbiAgICA8Qm94XG4gICAgICBjc3M9e3tcbiAgICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICAgIGxlZnQ6IDAsXG4gICAgICAgIHJpZ2h0OiAwLFxuICAgICAgICB0b3A6IDAsXG4gICAgICAgIGhlaWdodDogUExBQ0VIT0xERVJfSEVJR0hUKHNob3dNZW51TGlzdCksXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcbiAgICAgICAgekluZGV4OiAyLFxuICAgICAgICBwb2ludGVyRXZlbnRzOiAnbm9uZScsXG4gICAgICAgIG9wYWNpdHk6IGlzRm9jdXNlZCA/IDAgOiAxLFxuICAgICAgICB0cmFuc2l0aW9uOiAnb3BhY2l0eSAwLjJzIGVhc2Utb3V0JyxcbiAgICAgIH19PlxuICAgICAgPEJveFxuICAgICAgICBjc3M9e3tcbiAgICAgICAgICBkaXNwbGF5OiAnZmxleCcsXG4gICAgICAgICAgZmxleERpcmVjdGlvbjogJ2NvbHVtbicsXG4gICAgICAgICAgdHJhbnNpdGlvbjogaXNUcmFuc2l0aW9uXG4gICAgICAgICAgICA/IGB0cmFuc2Zvcm0gJHtST0xMSU5HX0RVUkFUSU9OfW1zIGN1YmljLWJlemllcigwLjQsMCwwLjIsMSlgXG4gICAgICAgICAgICA6ICdub25lJyxcbiAgICAgICAgICB0cmFuc2Zvcm06IGB0cmFuc2xhdGVZKCR7dHJhbnNsYXRlWX1weClgLFxuICAgICAgICB9fT5cbiAgICAgICAge2xpbmVzLm1hcCgodGV4dCwgaWR4KSA9PiAoXG4gICAgICAgICAgPEdyb3VwXG4gICAgICAgICAgICBrZXk9e2lkeH1cbiAgICAgICAgICAgIHc9XCIxMDAlXCJcbiAgICAgICAgICAgIGg9e1BMQUNFSE9MREVSX0hFSUdIVChzaG93TWVudUxpc3QpfVxuICAgICAgICAgICAgY29sb3I9XCJncmF5LjZcIlxuICAgICAgICAgICAgYWxpZ249XCJjZW50ZXJcIj5cbiAgICAgICAgICAgIDxUZXh0XG4gICAgICAgICAgICAgIGtleT17aWR4fVxuICAgICAgICAgICAgICB3PVwiMTAwJVwiXG4gICAgICAgICAgICAgIGNvbG9yPVwiZ3JheS42XCJcbiAgICAgICAgICAgICAgY3NzPXt7XG4gICAgICAgICAgICAgICAgdGV4dEFsaWduOiAnc3RhcnQnLFxuICAgICAgICAgICAgICAgIGZvbnRTaXplOiAxNixcbiAgICAgICAgICAgICAgICB3aGl0ZVNwYWNlOiBzaG93TWVudUxpc3QgPyAnbm9ybWFsJyA6ICdub3dyYXAnLFxuICAgICAgICAgICAgICB9fT5cbiAgICAgICAgICAgICAge3QodGV4dCl9XG4gICAgICAgICAgICA8L1RleHQ+XG4gICAgICAgICAgPC9Hcm91cD5cbiAgICAgICAgKSl9XG4gICAgICA8L0JveD5cbiAgICA8L0JveD5cbiAgKTtcbn1cbiJdfQ== */"), children: c.map((d, Z) => /* @__PURE__ */ o(Ig, { w: "100%", h: WA(s), color: "gray.6", align: "center", children: /* @__PURE__ */ o(U, { w: "100%", color: "gray.6", css: /* @__PURE__ */ $({
    textAlign: "start",
    fontSize: 16,
    whiteSpace: s ? "normal" : "nowrap"
  }, process.env.NODE_ENV === "production" ? "" : ";label:RollingText;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: A(d) }, Z) }, Z)) }) });
}
const Qu = ({
  isMobile: g = !1
}) => {
  const {
    showMenuList: I
  } = IA();
  return /* @__PURE__ */ o(qg, { "aria-label": "search", type: "submit", size: (g ? !1 : I) ? "n-md" : "n-xs", variant: "filled", color: "infgreen", radius: 999, tabIndex: ZC.SEARCH_BUTTON, css: /* @__PURE__ */ $({
    marginTop: -2,
    transition: "width 0.2s ease-out, height 0.2s ease-out"
  }, process.env.NODE_ENV === "production" ? "" : ";label:AppShellInputButton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvU2VhcmNoQmFyL0FwcFNoZWxsSW5wdXRCdXR0b24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW1CTSIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9mZS1zaGFyZWQvZmUtc2hhcmVkL3BhY2thZ2VzL2FwcC1zaGVsbC9zcmMvY29tcG9uZW50cy9uZXh0L1NlYXJjaEJhci9BcHBTaGVsbElucHV0QnV0dG9uLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEFjdGlvbkljb24sIEljb24gfSBmcm9tICdAaW5mbGVhcm4vZHMtcmVhY3QnO1xuaW1wb3J0IHsgc29saWQgfSBmcm9tICdAaW5mbGVhcm4vZm9udGF3ZXNvbWUtc3ZnLWNvcmUvaW1wb3J0Lm1hY3JvJztcblxuaW1wb3J0IHsgVEFCX0lOREVYIH0gZnJvbSAnLi4vSGVhZGVyL2NvbnN0YW50cy90YWJJbmRleCc7XG5pbXBvcnQgeyB1c2VTZWFyY2hCYXJDb250ZXh0IH0gZnJvbSAnLi4vSGVhZGVyL3VzZVNlYXJjaEJhckNvbnRleHQnO1xuXG5leHBvcnQgY29uc3QgQXBwU2hlbGxJbnB1dEJ1dHRvbiA9ICh7IGlzTW9iaWxlID0gZmFsc2UgfTogeyBpc01vYmlsZT86IGJvb2xlYW4gfSkgPT4ge1xuICBjb25zdCB7IHNob3dNZW51TGlzdDogc2hvd01lbnVMaXN0SW5EZXNrdG9wIH0gPSB1c2VTZWFyY2hCYXJDb250ZXh0KCk7XG4gIGNvbnN0IHNob3dNZW51TGlzdCA9IGlzTW9iaWxlID8gZmFsc2UgOiBzaG93TWVudUxpc3RJbkRlc2t0b3A7XG5cbiAgcmV0dXJuIChcbiAgICA8QWN0aW9uSWNvblxuICAgICAgYXJpYS1sYWJlbD1cInNlYXJjaFwiXG4gICAgICB0eXBlPVwic3VibWl0XCJcbiAgICAgIHNpemU9e3Nob3dNZW51TGlzdCA/ICduLW1kJyA6ICduLXhzJ31cbiAgICAgIHZhcmlhbnQ9XCJmaWxsZWRcIlxuICAgICAgY29sb3I9XCJpbmZncmVlblwiXG4gICAgICByYWRpdXM9ezk5OX1cbiAgICAgIHRhYkluZGV4PXtUQUJfSU5ERVguU0VBUkNIX0JVVFRPTn1cbiAgICAgIGNzcz17e1xuICAgICAgICBtYXJnaW5Ub3A6IC0yLFxuICAgICAgICB0cmFuc2l0aW9uOiAnd2lkdGggMC4ycyBlYXNlLW91dCwgaGVpZ2h0IDAuMnMgZWFzZS1vdXQnLFxuICAgICAgfX0+XG4gICAgICA8SWNvbiBpY29uPXtzb2xpZCgnc2VhcmNoJyl9IHNpemU9XCJtZFwiIC8+XG4gICAgPC9BY3Rpb25JY29uPlxuICApO1xufTtcbiJdfQ== */"), children: /* @__PURE__ */ o(sg, { icon: gc.faSearch, size: "md" }) });
};
var Mu = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "caret-down", A = 320, c = 512, l = [], t = "f0d7", i = "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faCaretDown = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(Mu);
const Wc = 17.5, Ku = ({
  isMobile: g = !1,
  disabled: I = !1
}) => {
  const {
    showMenuList: C
  } = IA(), {
    t: A
  } = UI();
  Ic();
  const {
    selectedMenu: c,
    setSelectedMenu: l,
    inputRef: t
  } = kI(), {
    trackEvent: i
  } = PI(), e = Ag(!1), n = g ? !1 : C, b = (a) => {
    var s;
    l(a), (s = t.current) == null || s.focus(), i(Og.CLICK_HEADER_MENU_AT_SEARCHBAR, {
      label: a.toLowerCase()
    });
  };
  return /* @__PURE__ */ o(P, { children: /* @__PURE__ */ o(hm, { children: /* @__PURE__ */ R(Xc, { disabled: I, onOpen: () => {
    i(Og.CLICK_HEADER_MENU_AT_SEARCHBAR, {
      label: "popover-open"
    });
  }, onClose: () => {
    if (e.current) {
      e.current = !1;
      return;
    }
    i(Og.CLICK_HEADER_MENU_AT_SEARCHBAR, {
      label: "popover-close"
    });
  }, closeOnEscape: !0, closeOnClickOutside: !0, position: "bottom", shadow: "md", radius: "md", offset: 10, withinPortal: !0, children: [
    /* @__PURE__ */ o(Xc.Target, { children: /* @__PURE__ */ o(qg, { "aria-label": "search-menu", "aria-haspopup": "menu", radius: "xl", tabIndex: ZC.SEARCH_MENU_DROPDOWN, css: /* @__PURE__ */ $({
      width: n ? 61 : 49,
      height: n ? 42 : 30
    }, process.env.NODE_ENV === "production" ? "" : ";label:AppShellInputMenu;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ R(Ig, { spacing: 4, noWrap: !0, children: [
      /* @__PURE__ */ o(Ig, { w: 30, position: "center", children: /* @__PURE__ */ o(bC, { src: `${jC}/assets/images/header/${iI[c].icon}.png`, alt: iI[c].text, w: il, width: 30, height: 30 }) }),
      /* @__PURE__ */ o(sg, { icon: Mu.faCaretDown, color: "gray.9", size: "xs" })
    ] }) }) }),
    /* @__PURE__ */ o(Xc.Dropdown, { children: Object.keys(r1).map((a) => {
      const s = iI[a];
      return /* @__PURE__ */ o(Xc.Item, { onClick: () => {
        e.current = !0, b(a);
      }, value: a, children: /* @__PURE__ */ R(Ig, { spacing: 10, align: "center", css: /* @__PURE__ */ $({
        picture: {
          width: Wc,
          height: Wc
        }
      }, process.env.NODE_ENV === "production" ? "" : ";label:AppShellInputMenu;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
        /* @__PURE__ */ o(bC, { src: `${jC}/assets/images/header/${s.icon}.png`, alt: s.text, w: il, width: Wc, height: Wc }),
        /* @__PURE__ */ o(U, { size: 14, color: "gray.9", fw: 400, children: A(s.text) })
      ] }) }, a);
    }) })
  ] }) }) });
};
var oe = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "far", C = "magnifying-glass", A = 512, c = 512, l = [128269, "search"], t = "f002", i = "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faMagnifyingGlass = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(oe);
const J1 = ({
  dataLength: g,
  isVisible: I,
  onEnterKey: C
}) => {
  const {
    inputRef: A
  } = kI(), [c, l] = O(-1), [t, i] = O(!1), e = Ag(null), n = (b) => {
    var a, s;
    if (!(b.isComposing || b.keyCode === 229) && !(!I || g === 0))
      switch (b.key) {
        case "ArrowDown":
          b.preventDefault(), i(!0), l((d) => d === -1 ? 0 : d < g - 1 ? d + 1 : d);
          break;
        case "ArrowUp":
          if (b.preventDefault(), c > 0) {
            i(!0), l((d) => d - 1);
            return;
          }
          if (c === 0) {
            i(!1), l(-1), (a = A.current) == null || a.focus();
            return;
          }
          if (c === -1) {
            i(!0), l(g - 1);
            return;
          }
          break;
        case "Escape":
          b.preventDefault(), i(!1), l(-1), (s = A.current) == null || s.focus();
          break;
        case "Enter":
          c >= 0 && c < g && (b.preventDefault(), C == null || C(c));
          break;
      }
  };
  return q(() => {
    (!I || g === 0) && (l(-1), i(!1));
  }, [I, g]), q(() => {
    g > 0 && c >= g && l(g - 1);
  }, [g, c]), q(() => {
    const b = A.current;
    if (b)
      return b.addEventListener("keydown", n), () => {
        b.removeEventListener("keydown", n);
      };
  }, [I, g, C]), q(() => {
    if (c >= 0 && e.current) {
      const b = e.current.children[c];
      b && b.scrollIntoView({
        block: "nearest",
        behavior: "smooth"
      });
    }
  }, [c]), {
    selectedIndex: c,
    isNavigatingDropdown: t,
    dropdownRef: e,
    setSelectedIndex: l,
    setIsNavigatingDropdown: i
  };
}, DI = w0;
var Y1 = /* @__PURE__ */ ((g) => (g.OK = "OK", g.SERVER_ERROR = "SERVER_ERROR", g.DUPLICATE = "DUPLICATE", g.NOT_FOUND = "NOT_FOUND", g.BAD_REQUEST = "BAD_REQUEST", g.BAD_PARAMETER = "BAD_PARAMETER", g.CONFLICT = "CONFLICT", g.UNAUTHORIZED = "UNAUTHORIZED", g.FORBIDDEN = "FORBIDDEN", g.PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE", g.TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS", g))(Y1 || {});
const Dl = {
  CLIENT_V1_COURSE_CONTRACT_HISTORIES_INFLEARN_MARKETING_CONFIRM: "/client/api/v1/course-contract-histories/inflearn-marketing-confirm",
  CLIENT_V1_CART: "/client/api/v1/cart",
  CLIENT_V1_VOUCHERS_RECENT_LEARNING: "/client/api/v1/vouchers/recent-learning",
  CLIENT_V1_COURSE_AUTO_COMPLETE: "/client/api/v1/course/auto-complete",
  CLIENT_V1_COURSE_RECOMMENDATIONS_USER_ONBOARDING: "/client/api/v1/course-recommendations/user-onboarding",
  CLIENT_V1_COURSE_CONTRACTS_INFLEARN_MARKETING_CONTENTS_TERM: "/client/api/v1/course-contracts/inflearn-marketing-contents-term",
  CLIENT_V1_COURSE_CONTRACT_HISTORIES_INFLEARN_MARKETING_CONFIRM_REQUIRED: "/client/api/v1/course-contract-histories/inflearn-marketing-confirm-required",
  CLIENT_V1_COUPONS_EXPIRATION: "/client/api/v1/coupons/expiration",
  CLIENT_V1_CATEGORY_MAIN: "/client/api/v1/category/main"
};
function H3({
  url: g,
  options: I,
  requestOptions: C
}) {
  var c;
  const A = _C({
    mutationFn: (l) => DI.post(g, l, C),
    ...I
  });
  return {
    ...A,
    data: (c = A.data) == null ? void 0 : c.data
  };
}
const F1 = async (g, I) => DI.get(g, I), z1 = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => F1(I, A),
  ...C
});
function w3(g) {
  var C;
  const I = ug(z1(g));
  return {
    ...I,
    data: (C = I.data) == null ? void 0 : C.data
  };
}
const f1 = async (g, I) => DI.get(g, I), H1 = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => f1(I, A),
  ...C
});
function S3(g) {
  var C;
  const I = ug(H1(g));
  return {
    ...I,
    data: (C = I.data) == null ? void 0 : C.data
  };
}
const w1 = async (g, I) => DI.get(g, I), S1 = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => w1(I, A),
  ...C
});
function T1(g) {
  var C;
  const I = ug(S1(g));
  return {
    ...I,
    data: (C = I.data) == null ? void 0 : C.data
  };
}
const L1 = async (g, I) => DI.get(g, I), U1 = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => L1(I, A),
  ...C
});
function T3(g) {
  var C;
  const I = ug(U1(g));
  return {
    ...I,
    data: (C = I.data) == null ? void 0 : C.data
  };
}
const P1 = async (g, I) => DI.get(g, I), k1 = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => P1(I, A),
  ...C
});
function L3(g) {
  var C;
  const I = ug(k1(g));
  return {
    ...I,
    data: (C = I.data) == null ? void 0 : C.data
  };
}
const D1 = async (g, I) => DI.get(g, I), O1 = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => D1(I, A),
  ...C
});
function U3(g) {
  var C;
  const I = ug(O1(g));
  return {
    ...I,
    data: (C = I.data) == null ? void 0 : C.data
  };
}
const j1 = async (g, I) => DI.get(g, I), E1 = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => j1(I, A),
  ...C
});
function Q1(g) {
  var C;
  const I = ug(E1(g));
  return {
    ...I,
    data: (C = I.data) == null ? void 0 : C.data
  };
}
const M1 = {
  keyword: "",
  limit: 10
};
function K1({
  keyword: g,
  options: I
}) {
  const C = {
    ...M1,
    keyword: g
  };
  return T1({
    queryKey: _1(C),
    url: tI.stringifyUrl({
      url: Dl.CLIENT_V1_COURSE_AUTO_COMPLETE,
      query: C
    }),
    options: {
      ...I,
      suspense: !1
    }
  });
}
const _1 = (g) => [Dl.CLIENT_V1_COURSE_AUTO_COMPLETE, g], _u = (g) => {
  $A() && (window.location.href = g);
}, qu = jg(void 0);
function P3({
  navigate: g = _u,
  children: I
}) {
  return /* @__PURE__ */ o(qu.Provider, { value: {
    navigate: g
  }, children: I });
}
const Ge = () => {
  const g = Zg(qu);
  return g || (console.warn("[AppShell RouterProvider] not found. Use default navigateWindow"), {
    navigate: _u
  });
}, $u = ({
  onNavigate: g
}) => {
  const {
    navigate: I
  } = Ge(), {
    keyword: C,
    selectedMenu: A,
    setIsFocused: c,
    setKeyword: l
  } = kI(), [t, i] = O(VI("s")), [e] = Sr(t, 200), n = e.trim(), {
    data: b,
    refetch: a
  } = K1({
    keyword: n,
    options: {
      enabled: !1,
      useErrorBoundary: !1
    }
  }), {
    trackEvent: s
  } = PI(), d = b && b.items.length > 0 ? b.items.map((x, u) => ({
    value: x,
    position: u
  })) : [], Z = (x) => {
    const u = d[x];
    u && (s(Og.SEARCH_COURSE, {
      search_keyword: u.value,
      type: A.toLowerCase()
    }), l(u.value), i(u.value), c(!1), g == null || g(), I(Jg.COURSES({
      searchKeyword: u.value,
      completionAttributionToken: b == null ? void 0 : b.attributionToken,
      selectedSuggestion: u.value,
      selectedPosition: x,
      tab: VI("tab")
    })));
  }, {
    selectedIndex: r,
    dropdownRef: h
  } = J1({
    dataLength: d.length,
    isVisible: !!t && d.length > 0,
    onEnterKey: Z
  });
  return q(() => {
    i(C);
  }, [C]), q(() => {
    n.length < 1 || a();
  }, [n, a]), q(function() {
    const u = () => {
      i(VI("s"));
    };
    return window.addEventListener("locationChangeComplete", u), () => {
      window.removeEventListener("locationChangeComplete", u);
    };
  }, []), !t || d.length === 0 ? null : /* @__PURE__ */ o(gg, { component: "ul", ref: h, children: d.map(({
    value: x,
    position: u
  }) => /* @__PURE__ */ o(Ig, { component: "li", w: "100%", spacing: 8, css: /* @__PURE__ */ $({
    borderRadius: 8,
    backgroundColor: r === u ? rg.gray[1] : "transparent",
    "&:hover": {
      backgroundColor: rg.gray[1],
      cursor: "pointer"
    },
    "&:focus": {
      backgroundColor: rg.gray[1]
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:AppShellInputAutoComplete;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ R(Ig, { w: "100%", h: "100%", py: 10, px: 6, component: "a", href: Jg.COURSES({
    searchKeyword: x,
    tab: VI("tab")
  }), spacing: 8, onClick: (V) => {
    V.preventDefault(), Z(u);
  }, children: [
    /* @__PURE__ */ o(sg, { icon: oe.faMagnifyingGlass, color: "gray.7", size: "md" }),
    /* @__PURE__ */ o(U, { size: "md", weight: 400, color: "gray.9", children: x })
  ] }) }, u)) });
};
function xb(g, I) {
  var C = Object.keys(g);
  if (Object.getOwnPropertySymbols) {
    var A = Object.getOwnPropertySymbols(g);
    I && (A = A.filter(function(c) {
      return Object.getOwnPropertyDescriptor(g, c).enumerable;
    })), C.push.apply(C, A);
  }
  return C;
}
function T(g) {
  for (var I = 1; I < arguments.length; I++) {
    var C = arguments[I] != null ? arguments[I] : {};
    I % 2 ? xb(Object(C), !0).forEach(function(A) {
      Yg(g, A, C[A]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(g, Object.getOwnPropertyDescriptors(C)) : xb(Object(C)).forEach(function(A) {
      Object.defineProperty(g, A, Object.getOwnPropertyDescriptor(C, A));
    });
  }
  return g;
}
function el(g) {
  "@babel/helpers - typeof";
  return el = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(I) {
    return typeof I;
  } : function(I) {
    return I && typeof Symbol == "function" && I.constructor === Symbol && I !== Symbol.prototype ? "symbol" : typeof I;
  }, el(g);
}
function q1(g, I) {
  if (!(g instanceof I))
    throw new TypeError("Cannot call a class as a function");
}
function yb(g, I) {
  for (var C = 0; C < I.length; C++) {
    var A = I[C];
    A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), Object.defineProperty(g, A.key, A);
  }
}
function $1(g, I, C) {
  return I && yb(g.prototype, I), C && yb(g, C), Object.defineProperty(g, "prototype", {
    writable: !1
  }), g;
}
function Yg(g, I, C) {
  return I in g ? Object.defineProperty(g, I, {
    value: C,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : g[I] = C, g;
}
function re(g, I) {
  return Ih(g) || Ah(g, I) || gd(g, I) || lh();
}
function Ac(g) {
  return gh(g) || Ch(g) || gd(g) || ch();
}
function gh(g) {
  if (Array.isArray(g))
    return ei(g);
}
function Ih(g) {
  if (Array.isArray(g))
    return g;
}
function Ch(g) {
  if (typeof Symbol < "u" && g[Symbol.iterator] != null || g["@@iterator"] != null)
    return Array.from(g);
}
function Ah(g, I) {
  var C = g == null ? null : typeof Symbol < "u" && g[Symbol.iterator] || g["@@iterator"];
  if (C != null) {
    var A = [], c = !0, l = !1, t, i;
    try {
      for (C = C.call(g); !(c = (t = C.next()).done) && (A.push(t.value), !(I && A.length === I)); c = !0)
        ;
    } catch (e) {
      l = !0, i = e;
    } finally {
      try {
        !c && C.return != null && C.return();
      } finally {
        if (l)
          throw i;
      }
    }
    return A;
  }
}
function gd(g, I) {
  if (g) {
    if (typeof g == "string")
      return ei(g, I);
    var C = Object.prototype.toString.call(g).slice(8, -1);
    if (C === "Object" && g.constructor && (C = g.constructor.name), C === "Map" || C === "Set")
      return Array.from(g);
    if (C === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(C))
      return ei(g, I);
  }
}
function ei(g, I) {
  (I == null || I > g.length) && (I = g.length);
  for (var C = 0, A = new Array(I); C < I; C++)
    A[C] = g[C];
  return A;
}
function ch() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lh() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var pb = function() {
}, Xe = {}, Id = {}, Cd = null, Ad = {
  mark: pb,
  measure: pb
};
try {
  typeof window < "u" && (Xe = window), typeof document < "u" && (Id = document), typeof MutationObserver < "u" && (Cd = MutationObserver), typeof performance < "u" && (Ad = performance);
} catch {
}
var th = Xe.navigator || {}, Rb = th.userAgent, Bb = Rb === void 0 ? "" : Rb, HI = Xe, Gg = Id, vb = Cd, Nc = Ad;
HI.document;
var JI = !!Gg.documentElement && !!Gg.head && typeof Gg.addEventListener == "function" && typeof Gg.createElement == "function", cd = ~Bb.indexOf("MSIE") || ~Bb.indexOf("Trident/"), xc, yc, pc, Rc, Bc, NI = "___FONT_AWESOME___", ni = 16, ld = "fa", td = "svg-inline--fa", sC = "data-fa-i2svg", bi = "data-fa-pseudo-element", ih = "data-fa-pseudo-element-pending", Ze = "data-prefix", Ve = "data-icon", Jb = "fontawesome-i2svg", eh = "async", nh = ["HTML", "HEAD", "STYLE", "SCRIPT"], id = function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
}(), og = "classic", mg = "sharp", me = [og, mg];
function cc(g) {
  return new Proxy(g, {
    get: function(C, A) {
      return A in C ? C[A] : C[og];
    }
  });
}
var HA = cc((xc = {}, Yg(xc, og, {
  fa: "solid",
  fas: "solid",
  "fa-solid": "solid",
  far: "regular",
  "fa-regular": "regular",
  fal: "light",
  "fa-light": "light",
  fat: "thin",
  "fa-thin": "thin",
  fad: "duotone",
  "fa-duotone": "duotone",
  fab: "brands",
  "fa-brands": "brands",
  fak: "kit",
  "fa-kit": "kit"
}), Yg(xc, mg, {
  fa: "solid",
  fass: "solid",
  "fa-solid": "solid",
  fasr: "regular",
  "fa-regular": "regular",
  fasl: "light",
  "fa-light": "light"
}), xc)), wA = cc((yc = {}, Yg(yc, og, {
  solid: "fas",
  regular: "far",
  light: "fal",
  thin: "fat",
  duotone: "fad",
  brands: "fab",
  kit: "fak"
}), Yg(yc, mg, {
  solid: "fass",
  regular: "fasr",
  light: "fasl"
}), yc)), SA = cc((pc = {}, Yg(pc, og, {
  fab: "fa-brands",
  fad: "fa-duotone",
  fak: "fa-kit",
  fal: "fa-light",
  far: "fa-regular",
  fas: "fa-solid",
  fat: "fa-thin"
}), Yg(pc, mg, {
  fass: "fa-solid",
  fasr: "fa-regular",
  fasl: "fa-light"
}), pc)), bh = cc((Rc = {}, Yg(Rc, og, {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}), Yg(Rc, mg, {
  "fa-solid": "fass",
  "fa-regular": "fasr",
  "fa-light": "fasl"
}), Rc)), ah = /fa(s|r|l|t|d|b|k|ss|sr|sl)?[\-\ ]/, ed = "fa-layers-text", sh = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i, uh = cc((Bc = {}, Yg(Bc, og, {
  900: "fas",
  400: "far",
  normal: "far",
  300: "fal",
  100: "fat"
}), Yg(Bc, mg, {
  900: "fass",
  400: "fasr",
  300: "fasl"
}), Bc)), nd = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], dh = nd.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), oh = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], CC = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, TA = /* @__PURE__ */ new Set();
Object.keys(wA[og]).map(TA.add.bind(TA));
Object.keys(wA[mg]).map(TA.add.bind(TA));
var Gh = [].concat(me, Ac(TA), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", CC.GROUP, CC.SWAP_OPACITY, CC.PRIMARY, CC.SECONDARY]).concat(nd.map(function(g) {
  return "".concat(g, "x");
})).concat(dh.map(function(g) {
  return "w-".concat(g);
})), NA = HI.FontAwesomeConfig || {};
function rh(g) {
  var I = Gg.querySelector("script[" + g + "]");
  if (I)
    return I.getAttribute(g);
}
function Xh(g) {
  return g === "" ? !0 : g === "false" ? !1 : g === "true" ? !0 : g;
}
if (Gg && typeof Gg.querySelector == "function") {
  var Zh = [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  Zh.forEach(function(g) {
    var I = re(g, 2), C = I[0], A = I[1], c = Xh(rh(C));
    c != null && (NA[A] = c);
  });
}
var bd = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: ld,
  replacementClass: td,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
NA.familyPrefix && (NA.cssPrefix = NA.familyPrefix);
var KC = T(T({}, bd), NA);
KC.autoReplaceSvg || (KC.observeMutations = !1);
var D = {};
Object.keys(bd).forEach(function(g) {
  Object.defineProperty(D, g, {
    enumerable: !0,
    set: function(C) {
      KC[g] = C, xA.forEach(function(A) {
        return A(D);
      });
    },
    get: function() {
      return KC[g];
    }
  });
});
Object.defineProperty(D, "familyPrefix", {
  enumerable: !0,
  set: function(I) {
    KC.cssPrefix = I, xA.forEach(function(C) {
      return C(D);
    });
  },
  get: function() {
    return KC.cssPrefix;
  }
});
HI.FontAwesomeConfig = D;
var xA = [];
function Vh(g) {
  return xA.push(g), function() {
    xA.splice(xA.indexOf(g), 1);
  };
}
var FI = ni, bI = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function mh(g) {
  if (!(!g || !JI)) {
    var I = Gg.createElement("style");
    I.setAttribute("type", "text/css"), I.innerHTML = g;
    for (var C = Gg.head.childNodes, A = null, c = C.length - 1; c > -1; c--) {
      var l = C[c], t = (l.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(t) > -1 && (A = l);
    }
    return Gg.head.insertBefore(I, A), g;
  }
}
var hh = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function LA() {
  for (var g = 12, I = ""; g-- > 0; )
    I += hh[Math.random() * 62 | 0];
  return I;
}
function CA(g) {
  for (var I = [], C = (g || []).length >>> 0; C--; )
    I[C] = g[C];
  return I;
}
function he(g) {
  return g.classList ? CA(g.classList) : (g.getAttribute("class") || "").split(" ").filter(function(I) {
    return I;
  });
}
function ad(g) {
  return "".concat(g).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Wh(g) {
  return Object.keys(g || {}).reduce(function(I, C) {
    return I + "".concat(C, '="').concat(ad(g[C]), '" ');
  }, "").trim();
}
function Ol(g) {
  return Object.keys(g || {}).reduce(function(I, C) {
    return I + "".concat(C, ": ").concat(g[C].trim(), ";");
  }, "");
}
function We(g) {
  return g.size !== bI.size || g.x !== bI.x || g.y !== bI.y || g.rotate !== bI.rotate || g.flipX || g.flipY;
}
function Nh(g) {
  var I = g.transform, C = g.containerWidth, A = g.iconWidth, c = {
    transform: "translate(".concat(C / 2, " 256)")
  }, l = "translate(".concat(I.x * 32, ", ").concat(I.y * 32, ") "), t = "scale(".concat(I.size / 16 * (I.flipX ? -1 : 1), ", ").concat(I.size / 16 * (I.flipY ? -1 : 1), ") "), i = "rotate(".concat(I.rotate, " 0 0)"), e = {
    transform: "".concat(l, " ").concat(t, " ").concat(i)
  }, n = {
    transform: "translate(".concat(A / 2 * -1, " -256)")
  };
  return {
    outer: c,
    inner: e,
    path: n
  };
}
function xh(g) {
  var I = g.transform, C = g.width, A = C === void 0 ? ni : C, c = g.height, l = c === void 0 ? ni : c, t = g.startCentered, i = t === void 0 ? !1 : t, e = "";
  return i && cd ? e += "translate(".concat(I.x / FI - A / 2, "em, ").concat(I.y / FI - l / 2, "em) ") : i ? e += "translate(calc(-50% + ".concat(I.x / FI, "em), calc(-50% + ").concat(I.y / FI, "em)) ") : e += "translate(".concat(I.x / FI, "em, ").concat(I.y / FI, "em) "), e += "scale(".concat(I.size / FI * (I.flipX ? -1 : 1), ", ").concat(I.size / FI * (I.flipY ? -1 : 1), ") "), e += "rotate(".concat(I.rotate, "deg) "), e;
}
var yh = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-counter-scale, 0.25));
          transform: scale(var(--fa-counter-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  -webkit-animation-name: fa-beat;
          animation-name: fa-beat;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  -webkit-animation-name: fa-bounce;
          animation-name: fa-bounce;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  -webkit-animation-name: fa-fade;
          animation-name: fa-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  -webkit-animation-name: fa-beat-fade;
          animation-name: fa-beat-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  -webkit-animation-name: fa-flip;
          animation-name: fa-flip;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  -webkit-animation-name: fa-shake;
          animation-name: fa-shake;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 2s);
          animation-duration: var(--fa-animation-duration, 2s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
          animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    -webkit-animation-delay: -1ms;
            animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
            animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    -webkit-transition-delay: 0s;
            transition-delay: 0s;
    -webkit-transition-duration: 0s;
            transition-duration: 0s;
  }
}
@-webkit-keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@-webkit-keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@-webkit-keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@-webkit-keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@-webkit-keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@-webkit-keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

.fa-rotate-by {
  -webkit-transform: rotate(var(--fa-rotate-angle, none));
          transform: rotate(var(--fa-rotate-angle, none));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function sd() {
  var g = ld, I = td, C = D.cssPrefix, A = D.replacementClass, c = yh;
  if (C !== g || A !== I) {
    var l = new RegExp("\\.".concat(g, "\\-"), "g"), t = new RegExp("\\--".concat(g, "\\-"), "g"), i = new RegExp("\\.".concat(I), "g");
    c = c.replace(l, ".".concat(C, "-")).replace(t, "--".concat(C, "-")).replace(i, ".".concat(A));
  }
  return c;
}
var Yb = !1;
function Gt() {
  D.autoAddCss && !Yb && (mh(sd()), Yb = !0);
}
var ph = {
  mixout: function() {
    return {
      dom: {
        css: sd,
        insertCss: Gt
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        Gt();
      },
      beforeI2svg: function() {
        Gt();
      }
    };
  }
}, xI = HI || {};
xI[NI] || (xI[NI] = {});
xI[NI].styles || (xI[NI].styles = {});
xI[NI].hooks || (xI[NI].hooks = {});
xI[NI].shims || (xI[NI].shims = []);
var CI = xI[NI], ud = [], Rh = function g() {
  Gg.removeEventListener("DOMContentLoaded", g), nl = 1, ud.map(function(I) {
    return I();
  });
}, nl = !1;
JI && (nl = (Gg.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Gg.readyState), nl || Gg.addEventListener("DOMContentLoaded", Rh));
function Bh(g) {
  JI && (nl ? setTimeout(g, 0) : ud.push(g));
}
function lc(g) {
  var I = g.tag, C = g.attributes, A = C === void 0 ? {} : C, c = g.children, l = c === void 0 ? [] : c;
  return typeof g == "string" ? ad(g) : "<".concat(I, " ").concat(Wh(A), ">").concat(l.map(lc).join(""), "</").concat(I, ">");
}
function Fb(g, I, C) {
  if (g && g[I] && g[I][C])
    return {
      prefix: I,
      iconName: C,
      icon: g[I][C]
    };
}
var vh = function(I, C) {
  return function(A, c, l, t) {
    return I.call(C, A, c, l, t);
  };
}, rt = function(I, C, A, c) {
  var l = Object.keys(I), t = l.length, i = c !== void 0 ? vh(C, c) : C, e, n, b;
  for (A === void 0 ? (e = 1, b = I[l[0]]) : (e = 0, b = A); e < t; e++)
    n = l[e], b = i(b, I[n], n, I);
  return b;
};
function Jh(g) {
  for (var I = [], C = 0, A = g.length; C < A; ) {
    var c = g.charCodeAt(C++);
    if (c >= 55296 && c <= 56319 && C < A) {
      var l = g.charCodeAt(C++);
      (l & 64512) == 56320 ? I.push(((c & 1023) << 10) + (l & 1023) + 65536) : (I.push(c), C--);
    } else
      I.push(c);
  }
  return I;
}
function ai(g) {
  var I = Jh(g);
  return I.length === 1 ? I[0].toString(16) : null;
}
function Yh(g, I) {
  var C = g.length, A = g.charCodeAt(I), c;
  return A >= 55296 && A <= 56319 && C > I + 1 && (c = g.charCodeAt(I + 1), c >= 56320 && c <= 57343) ? (A - 55296) * 1024 + c - 56320 + 65536 : A;
}
function zb(g) {
  return Object.keys(g).reduce(function(I, C) {
    var A = g[C], c = !!A.icon;
    return c ? I[A.iconName] = A.icon : I[C] = A, I;
  }, {});
}
function si(g, I) {
  var C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, A = C.skipHooks, c = A === void 0 ? !1 : A, l = zb(I);
  typeof CI.hooks.addPack == "function" && !c ? CI.hooks.addPack(g, zb(I)) : CI.styles[g] = T(T({}, CI.styles[g] || {}), l), g === "fas" && si("fa", I);
}
var vc, Jc, Yc, JC = CI.styles, Fh = CI.shims, zh = (vc = {}, Yg(vc, og, Object.values(SA[og])), Yg(vc, mg, Object.values(SA[mg])), vc), Ne = null, dd = {}, od = {}, Gd = {}, rd = {}, Xd = {}, fh = (Jc = {}, Yg(Jc, og, Object.keys(HA[og])), Yg(Jc, mg, Object.keys(HA[mg])), Jc);
function Hh(g) {
  return ~Gh.indexOf(g);
}
function wh(g, I) {
  var C = I.split("-"), A = C[0], c = C.slice(1).join("-");
  return A === g && c !== "" && !Hh(c) ? c : null;
}
var Zd = function() {
  var I = function(l) {
    return rt(JC, function(t, i, e) {
      return t[e] = rt(i, l, {}), t;
    }, {});
  };
  dd = I(function(c, l, t) {
    if (l[3] && (c[l[3]] = t), l[2]) {
      var i = l[2].filter(function(e) {
        return typeof e == "number";
      });
      i.forEach(function(e) {
        c[e.toString(16)] = t;
      });
    }
    return c;
  }), od = I(function(c, l, t) {
    if (c[t] = t, l[2]) {
      var i = l[2].filter(function(e) {
        return typeof e == "string";
      });
      i.forEach(function(e) {
        c[e] = t;
      });
    }
    return c;
  }), Xd = I(function(c, l, t) {
    var i = l[2];
    return c[t] = t, i.forEach(function(e) {
      c[e] = t;
    }), c;
  });
  var C = "far" in JC || D.autoFetchSvg, A = rt(Fh, function(c, l) {
    var t = l[0], i = l[1], e = l[2];
    return i === "far" && !C && (i = "fas"), typeof t == "string" && (c.names[t] = {
      prefix: i,
      iconName: e
    }), typeof t == "number" && (c.unicodes[t.toString(16)] = {
      prefix: i,
      iconName: e
    }), c;
  }, {
    names: {},
    unicodes: {}
  });
  Gd = A.names, rd = A.unicodes, Ne = jl(D.styleDefault, {
    family: D.familyDefault
  });
};
Vh(function(g) {
  Ne = jl(g.styleDefault, {
    family: D.familyDefault
  });
});
Zd();
function xe(g, I) {
  return (dd[g] || {})[I];
}
function Sh(g, I) {
  return (od[g] || {})[I];
}
function AC(g, I) {
  return (Xd[g] || {})[I];
}
function Vd(g) {
  return Gd[g] || {
    prefix: null,
    iconName: null
  };
}
function Th(g) {
  var I = rd[g], C = xe("fas", g);
  return I || (C ? {
    prefix: "fas",
    iconName: C
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function wI() {
  return Ne;
}
var ye = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function jl(g) {
  var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, C = I.family, A = C === void 0 ? og : C, c = HA[A][g], l = wA[A][g] || wA[A][c], t = g in CI.styles ? g : null;
  return l || t || null;
}
var fb = (Yc = {}, Yg(Yc, og, Object.keys(SA[og])), Yg(Yc, mg, Object.keys(SA[mg])), Yc);
function El(g) {
  var I, C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, A = C.skipLookups, c = A === void 0 ? !1 : A, l = (I = {}, Yg(I, og, "".concat(D.cssPrefix, "-").concat(og)), Yg(I, mg, "".concat(D.cssPrefix, "-").concat(mg)), I), t = null, i = og;
  (g.includes(l[og]) || g.some(function(n) {
    return fb[og].includes(n);
  })) && (i = og), (g.includes(l[mg]) || g.some(function(n) {
    return fb[mg].includes(n);
  })) && (i = mg);
  var e = g.reduce(function(n, b) {
    var a = wh(D.cssPrefix, b);
    if (JC[b] ? (b = zh[i].includes(b) ? bh[i][b] : b, t = b, n.prefix = b) : fh[i].indexOf(b) > -1 ? (t = b, n.prefix = jl(b, {
      family: i
    })) : a ? n.iconName = a : b !== D.replacementClass && b !== l[og] && b !== l[mg] && n.rest.push(b), !c && n.prefix && n.iconName) {
      var s = t === "fa" ? Vd(n.iconName) : {}, d = AC(n.prefix, n.iconName);
      s.prefix && (t = null), n.iconName = s.iconName || d || n.iconName, n.prefix = s.prefix || n.prefix, n.prefix === "far" && !JC.far && JC.fas && !D.autoFetchSvg && (n.prefix = "fas");
    }
    return n;
  }, ye());
  return (g.includes("fa-brands") || g.includes("fab")) && (e.prefix = "fab"), (g.includes("fa-duotone") || g.includes("fad")) && (e.prefix = "fad"), !e.prefix && i === mg && (JC.fass || D.autoFetchSvg) && (e.prefix = "fass", e.iconName = AC(e.prefix, e.iconName) || e.iconName), (e.prefix === "fa" || t === "fa") && (e.prefix = wI() || "fas"), e;
}
var Lh = /* @__PURE__ */ function() {
  function g() {
    q1(this, g), this.definitions = {};
  }
  return $1(g, [{
    key: "add",
    value: function() {
      for (var C = this, A = arguments.length, c = new Array(A), l = 0; l < A; l++)
        c[l] = arguments[l];
      var t = c.reduce(this._pullDefinitions, {});
      Object.keys(t).forEach(function(i) {
        C.definitions[i] = T(T({}, C.definitions[i] || {}), t[i]), si(i, t[i]);
        var e = SA[og][i];
        e && si(e, t[i]), Zd();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(C, A) {
      var c = A.prefix && A.iconName && A.icon ? {
        0: A
      } : A;
      return Object.keys(c).map(function(l) {
        var t = c[l], i = t.prefix, e = t.iconName, n = t.icon, b = n[2];
        C[i] || (C[i] = {}), b.length > 0 && b.forEach(function(a) {
          typeof a == "string" && (C[i][a] = n);
        }), C[i][e] = n;
      }), C;
    }
  }]), g;
}(), Hb = [], YC = {}, PC = {}, Uh = Object.keys(PC);
function Ph(g, I) {
  var C = I.mixoutsTo;
  return Hb = g, YC = {}, Object.keys(PC).forEach(function(A) {
    Uh.indexOf(A) === -1 && delete PC[A];
  }), Hb.forEach(function(A) {
    var c = A.mixout ? A.mixout() : {};
    if (Object.keys(c).forEach(function(t) {
      typeof c[t] == "function" && (C[t] = c[t]), el(c[t]) === "object" && Object.keys(c[t]).forEach(function(i) {
        C[t] || (C[t] = {}), C[t][i] = c[t][i];
      });
    }), A.hooks) {
      var l = A.hooks();
      Object.keys(l).forEach(function(t) {
        YC[t] || (YC[t] = []), YC[t].push(l[t]);
      });
    }
    A.provides && A.provides(PC);
  }), C;
}
function ui(g, I) {
  for (var C = arguments.length, A = new Array(C > 2 ? C - 2 : 0), c = 2; c < C; c++)
    A[c - 2] = arguments[c];
  var l = YC[g] || [];
  return l.forEach(function(t) {
    I = t.apply(null, [I].concat(A));
  }), I;
}
function uC(g) {
  for (var I = arguments.length, C = new Array(I > 1 ? I - 1 : 0), A = 1; A < I; A++)
    C[A - 1] = arguments[A];
  var c = YC[g] || [];
  c.forEach(function(l) {
    l.apply(null, C);
  });
}
function yI() {
  var g = arguments[0], I = Array.prototype.slice.call(arguments, 1);
  return PC[g] ? PC[g].apply(null, I) : void 0;
}
function di(g) {
  g.prefix === "fa" && (g.prefix = "fas");
  var I = g.iconName, C = g.prefix || wI();
  if (I)
    return I = AC(C, I) || I, Fb(md.definitions, C, I) || Fb(CI.styles, C, I);
}
var md = new Lh(), kh = function() {
  D.autoReplaceSvg = !1, D.observeMutations = !1, uC("noAuto");
}, Dh = {
  i2svg: function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return JI ? (uC("beforeI2svg", I), yI("pseudoElements2svg", I), yI("i2svg", I)) : Promise.reject("Operation requires a DOM of some kind.");
  },
  watch: function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, C = I.autoReplaceSvgRoot;
    D.autoReplaceSvg === !1 && (D.autoReplaceSvg = !0), D.observeMutations = !0, Bh(function() {
      jh({
        autoReplaceSvgRoot: C
      }), uC("watch", I);
    });
  }
}, Oh = {
  icon: function(I) {
    if (I === null)
      return null;
    if (el(I) === "object" && I.prefix && I.iconName)
      return {
        prefix: I.prefix,
        iconName: AC(I.prefix, I.iconName) || I.iconName
      };
    if (Array.isArray(I) && I.length === 2) {
      var C = I[1].indexOf("fa-") === 0 ? I[1].slice(3) : I[1], A = jl(I[0]);
      return {
        prefix: A,
        iconName: AC(A, C) || C
      };
    }
    if (typeof I == "string" && (I.indexOf("".concat(D.cssPrefix, "-")) > -1 || I.match(ah))) {
      var c = El(I.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: c.prefix || wI(),
        iconName: AC(c.prefix, c.iconName) || c.iconName
      };
    }
    if (typeof I == "string") {
      var l = wI();
      return {
        prefix: l,
        iconName: AC(l, I) || I
      };
    }
  }
}, Eg = {
  noAuto: kh,
  config: D,
  dom: Dh,
  parse: Oh,
  library: md,
  findIconDefinition: di,
  toHtml: lc
}, jh = function() {
  var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, C = I.autoReplaceSvgRoot, A = C === void 0 ? Gg : C;
  (Object.keys(CI.styles).length > 0 || D.autoFetchSvg) && JI && D.autoReplaceSvg && Eg.dom.i2svg({
    node: A
  });
};
function Ql(g, I) {
  return Object.defineProperty(g, "abstract", {
    get: I
  }), Object.defineProperty(g, "html", {
    get: function() {
      return g.abstract.map(function(A) {
        return lc(A);
      });
    }
  }), Object.defineProperty(g, "node", {
    get: function() {
      if (JI) {
        var A = Gg.createElement("div");
        return A.innerHTML = g.html, A.children;
      }
    }
  }), g;
}
function Eh(g) {
  var I = g.children, C = g.main, A = g.mask, c = g.attributes, l = g.styles, t = g.transform;
  if (We(t) && C.found && !A.found) {
    var i = C.width, e = C.height, n = {
      x: i / e / 2,
      y: 0.5
    };
    c.style = Ol(T(T({}, l), {}, {
      "transform-origin": "".concat(n.x + t.x / 16, "em ").concat(n.y + t.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: c,
    children: I
  }];
}
function Qh(g) {
  var I = g.prefix, C = g.iconName, A = g.children, c = g.attributes, l = g.symbol, t = l === !0 ? "".concat(I, "-").concat(D.cssPrefix, "-").concat(C) : l;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: T(T({}, c), {}, {
        id: t
      }),
      children: A
    }]
  }];
}
function pe(g) {
  var I = g.icons, C = I.main, A = I.mask, c = g.prefix, l = g.iconName, t = g.transform, i = g.symbol, e = g.title, n = g.maskId, b = g.titleId, a = g.extra, s = g.watchable, d = s === void 0 ? !1 : s, Z = A.found ? A : C, r = Z.width, h = Z.height, x = c === "fak", u = [D.replacementClass, l ? "".concat(D.cssPrefix, "-").concat(l) : ""].filter(function(p) {
    return a.classes.indexOf(p) === -1;
  }).filter(function(p) {
    return p !== "" || !!p;
  }).concat(a.classes).join(" "), G = {
    children: [],
    attributes: T(T({}, a.attributes), {}, {
      "data-prefix": c,
      "data-icon": l,
      class: u,
      role: a.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(r, " ").concat(h)
    })
  }, V = x && !~a.classes.indexOf("fa-fw") ? {
    width: "".concat(r / h * 16 * 0.0625, "em")
  } : {};
  d && (G.attributes[sC] = ""), e && (G.children.push({
    tag: "title",
    attributes: {
      id: G.attributes["aria-labelledby"] || "title-".concat(b || LA())
    },
    children: [e]
  }), delete G.attributes.title);
  var X = T(T({}, G), {}, {
    prefix: c,
    iconName: l,
    main: C,
    mask: A,
    maskId: n,
    transform: t,
    symbol: i,
    styles: T(T({}, V), a.styles)
  }), W = A.found && C.found ? yI("generateAbstractMask", X) || {
    children: [],
    attributes: {}
  } : yI("generateAbstractIcon", X) || {
    children: [],
    attributes: {}
  }, N = W.children, m = W.attributes;
  return X.children = N, X.attributes = m, i ? Qh(X) : Eh(X);
}
function wb(g) {
  var I = g.content, C = g.width, A = g.height, c = g.transform, l = g.title, t = g.extra, i = g.watchable, e = i === void 0 ? !1 : i, n = T(T(T({}, t.attributes), l ? {
    title: l
  } : {}), {}, {
    class: t.classes.join(" ")
  });
  e && (n[sC] = "");
  var b = T({}, t.styles);
  We(c) && (b.transform = xh({
    transform: c,
    startCentered: !0,
    width: C,
    height: A
  }), b["-webkit-transform"] = b.transform);
  var a = Ol(b);
  a.length > 0 && (n.style = a);
  var s = [];
  return s.push({
    tag: "span",
    attributes: n,
    children: [I]
  }), l && s.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [l]
  }), s;
}
function Mh(g) {
  var I = g.content, C = g.title, A = g.extra, c = T(T(T({}, A.attributes), C ? {
    title: C
  } : {}), {}, {
    class: A.classes.join(" ")
  }), l = Ol(A.styles);
  l.length > 0 && (c.style = l);
  var t = [];
  return t.push({
    tag: "span",
    attributes: c,
    children: [I]
  }), C && t.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [C]
  }), t;
}
var Xt = CI.styles;
function oi(g) {
  var I = g[0], C = g[1], A = g.slice(4), c = re(A, 1), l = c[0], t = null;
  return Array.isArray(l) ? t = {
    tag: "g",
    attributes: {
      class: "".concat(D.cssPrefix, "-").concat(CC.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(D.cssPrefix, "-").concat(CC.SECONDARY),
        fill: "currentColor",
        d: l[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(D.cssPrefix, "-").concat(CC.PRIMARY),
        fill: "currentColor",
        d: l[1]
      }
    }]
  } : t = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: l
    }
  }, {
    found: !0,
    width: I,
    height: C,
    icon: t
  };
}
var Kh = {
  found: !1,
  width: 512,
  height: 512
};
function _h(g, I) {
  !id && !D.showMissingIcons && g && console.error('Icon with name "'.concat(g, '" and prefix "').concat(I, '" is missing.'));
}
function Gi(g, I) {
  var C = I;
  return I === "fa" && D.styleDefault !== null && (I = wI()), new Promise(function(A, c) {
    if (yI("missingIconAbstract"), C === "fa") {
      var l = Vd(g) || {};
      g = l.iconName || g, I = l.prefix || I;
    }
    if (g && I && Xt[I] && Xt[I][g]) {
      var t = Xt[I][g];
      return A(oi(t));
    }
    _h(g, I), A(T(T({}, Kh), {}, {
      icon: D.showMissingIcons && g ? yI("missingIconAbstract") || {} : {}
    }));
  });
}
var Sb = function() {
}, ri = D.measurePerformance && Nc && Nc.mark && Nc.measure ? Nc : {
  mark: Sb,
  measure: Sb
}, ZA = 'FA "6.4.2"', qh = function(I) {
  return ri.mark("".concat(ZA, " ").concat(I, " begins")), function() {
    return hd(I);
  };
}, hd = function(I) {
  ri.mark("".concat(ZA, " ").concat(I, " ends")), ri.measure("".concat(ZA, " ").concat(I), "".concat(ZA, " ").concat(I, " begins"), "".concat(ZA, " ").concat(I, " ends"));
}, Re = {
  begin: qh,
  end: hd
}, Dc = function() {
};
function Tb(g) {
  var I = g.getAttribute ? g.getAttribute(sC) : null;
  return typeof I == "string";
}
function $h(g) {
  var I = g.getAttribute ? g.getAttribute(Ze) : null, C = g.getAttribute ? g.getAttribute(Ve) : null;
  return I && C;
}
function gW(g) {
  return g && g.classList && g.classList.contains && g.classList.contains(D.replacementClass);
}
function IW() {
  if (D.autoReplaceSvg === !0)
    return Oc.replace;
  var g = Oc[D.autoReplaceSvg];
  return g || Oc.replace;
}
function CW(g) {
  return Gg.createElementNS("http://www.w3.org/2000/svg", g);
}
function AW(g) {
  return Gg.createElement(g);
}
function Wd(g) {
  var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, C = I.ceFn, A = C === void 0 ? g.tag === "svg" ? CW : AW : C;
  if (typeof g == "string")
    return Gg.createTextNode(g);
  var c = A(g.tag);
  Object.keys(g.attributes || []).forEach(function(t) {
    c.setAttribute(t, g.attributes[t]);
  });
  var l = g.children || [];
  return l.forEach(function(t) {
    c.appendChild(Wd(t, {
      ceFn: A
    }));
  }), c;
}
function cW(g) {
  var I = " ".concat(g.outerHTML, " ");
  return I = "".concat(I, "Font Awesome fontawesome.com "), I;
}
var Oc = {
  replace: function(I) {
    var C = I[0];
    if (C.parentNode)
      if (I[1].forEach(function(c) {
        C.parentNode.insertBefore(Wd(c), C);
      }), C.getAttribute(sC) === null && D.keepOriginalSource) {
        var A = Gg.createComment(cW(C));
        C.parentNode.replaceChild(A, C);
      } else
        C.remove();
  },
  nest: function(I) {
    var C = I[0], A = I[1];
    if (~he(C).indexOf(D.replacementClass))
      return Oc.replace(I);
    var c = new RegExp("".concat(D.cssPrefix, "-.*"));
    if (delete A[0].attributes.id, A[0].attributes.class) {
      var l = A[0].attributes.class.split(" ").reduce(function(i, e) {
        return e === D.replacementClass || e.match(c) ? i.toSvg.push(e) : i.toNode.push(e), i;
      }, {
        toNode: [],
        toSvg: []
      });
      A[0].attributes.class = l.toSvg.join(" "), l.toNode.length === 0 ? C.removeAttribute("class") : C.setAttribute("class", l.toNode.join(" "));
    }
    var t = A.map(function(i) {
      return lc(i);
    }).join(`
`);
    C.setAttribute(sC, ""), C.innerHTML = t;
  }
};
function Lb(g) {
  g();
}
function Nd(g, I) {
  var C = typeof I == "function" ? I : Dc;
  if (g.length === 0)
    C();
  else {
    var A = Lb;
    D.mutateApproach === eh && (A = HI.requestAnimationFrame || Lb), A(function() {
      var c = IW(), l = Re.begin("mutate");
      g.map(c), l(), C();
    });
  }
}
var Be = !1;
function xd() {
  Be = !0;
}
function Xi() {
  Be = !1;
}
var bl = null;
function Ub(g) {
  if (vb && D.observeMutations) {
    var I = g.treeCallback, C = I === void 0 ? Dc : I, A = g.nodeCallback, c = A === void 0 ? Dc : A, l = g.pseudoElementsCallback, t = l === void 0 ? Dc : l, i = g.observeMutationsRoot, e = i === void 0 ? Gg : i;
    bl = new vb(function(n) {
      if (!Be) {
        var b = wI();
        CA(n).forEach(function(a) {
          if (a.type === "childList" && a.addedNodes.length > 0 && !Tb(a.addedNodes[0]) && (D.searchPseudoElements && t(a.target), C(a.target)), a.type === "attributes" && a.target.parentNode && D.searchPseudoElements && t(a.target.parentNode), a.type === "attributes" && Tb(a.target) && ~oh.indexOf(a.attributeName))
            if (a.attributeName === "class" && $h(a.target)) {
              var s = El(he(a.target)), d = s.prefix, Z = s.iconName;
              a.target.setAttribute(Ze, d || b), Z && a.target.setAttribute(Ve, Z);
            } else
              gW(a.target) && c(a.target);
        });
      }
    }), JI && bl.observe(e, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function lW() {
  bl && bl.disconnect();
}
function tW(g) {
  var I = g.getAttribute("style"), C = [];
  return I && (C = I.split(";").reduce(function(A, c) {
    var l = c.split(":"), t = l[0], i = l.slice(1);
    return t && i.length > 0 && (A[t] = i.join(":").trim()), A;
  }, {})), C;
}
function iW(g) {
  var I = g.getAttribute("data-prefix"), C = g.getAttribute("data-icon"), A = g.innerText !== void 0 ? g.innerText.trim() : "", c = El(he(g));
  return c.prefix || (c.prefix = wI()), I && C && (c.prefix = I, c.iconName = C), c.iconName && c.prefix || (c.prefix && A.length > 0 && (c.iconName = Sh(c.prefix, g.innerText) || xe(c.prefix, ai(g.innerText))), !c.iconName && D.autoFetchSvg && g.firstChild && g.firstChild.nodeType === Node.TEXT_NODE && (c.iconName = g.firstChild.data)), c;
}
function eW(g) {
  var I = CA(g.attributes).reduce(function(c, l) {
    return c.name !== "class" && c.name !== "style" && (c[l.name] = l.value), c;
  }, {}), C = g.getAttribute("title"), A = g.getAttribute("data-fa-title-id");
  return D.autoA11y && (C ? I["aria-labelledby"] = "".concat(D.replacementClass, "-title-").concat(A || LA()) : (I["aria-hidden"] = "true", I.focusable = "false")), I;
}
function nW() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: bI,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function Pb(g) {
  var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, C = iW(g), A = C.iconName, c = C.prefix, l = C.rest, t = eW(g), i = ui("parseNodeAttributes", {}, g), e = I.styleParser ? tW(g) : [];
  return T({
    iconName: A,
    title: g.getAttribute("title"),
    titleId: g.getAttribute("data-fa-title-id"),
    prefix: c,
    transform: bI,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: l,
      styles: e,
      attributes: t
    }
  }, i);
}
var bW = CI.styles;
function yd(g) {
  var I = D.autoReplaceSvg === "nest" ? Pb(g, {
    styleParser: !1
  }) : Pb(g);
  return ~I.extra.classes.indexOf(ed) ? yI("generateLayersText", g, I) : yI("generateSvgReplacementMutation", g, I);
}
var SI = /* @__PURE__ */ new Set();
me.map(function(g) {
  SI.add("fa-".concat(g));
});
Object.keys(HA[og]).map(SI.add.bind(SI));
Object.keys(HA[mg]).map(SI.add.bind(SI));
SI = Ac(SI);
function kb(g) {
  var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!JI)
    return Promise.resolve();
  var C = Gg.documentElement.classList, A = function(a) {
    return C.add("".concat(Jb, "-").concat(a));
  }, c = function(a) {
    return C.remove("".concat(Jb, "-").concat(a));
  }, l = D.autoFetchSvg ? SI : me.map(function(b) {
    return "fa-".concat(b);
  }).concat(Object.keys(bW));
  l.includes("fa") || l.push("fa");
  var t = [".".concat(ed, ":not([").concat(sC, "])")].concat(l.map(function(b) {
    return ".".concat(b, ":not([").concat(sC, "])");
  })).join(", ");
  if (t.length === 0)
    return Promise.resolve();
  var i = [];
  try {
    i = CA(g.querySelectorAll(t));
  } catch {
  }
  if (i.length > 0)
    A("pending"), c("complete");
  else
    return Promise.resolve();
  var e = Re.begin("onTree"), n = i.reduce(function(b, a) {
    try {
      var s = yd(a);
      s && b.push(s);
    } catch (d) {
      id || d.name === "MissingIcon" && console.error(d);
    }
    return b;
  }, []);
  return new Promise(function(b, a) {
    Promise.all(n).then(function(s) {
      Nd(s, function() {
        A("active"), A("complete"), c("pending"), typeof I == "function" && I(), e(), b();
      });
    }).catch(function(s) {
      e(), a(s);
    });
  });
}
function aW(g) {
  var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  yd(g).then(function(C) {
    C && Nd([C], I);
  });
}
function sW(g) {
  return function(I) {
    var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, A = (I || {}).icon ? I : di(I || {}), c = C.mask;
    return c && (c = (c || {}).icon ? c : di(c || {})), g(A, T(T({}, C), {}, {
      mask: c
    }));
  };
}
var uW = function(I) {
  var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, A = C.transform, c = A === void 0 ? bI : A, l = C.symbol, t = l === void 0 ? !1 : l, i = C.mask, e = i === void 0 ? null : i, n = C.maskId, b = n === void 0 ? null : n, a = C.title, s = a === void 0 ? null : a, d = C.titleId, Z = d === void 0 ? null : d, r = C.classes, h = r === void 0 ? [] : r, x = C.attributes, u = x === void 0 ? {} : x, G = C.styles, V = G === void 0 ? {} : G;
  if (I) {
    var X = I.prefix, W = I.iconName, N = I.icon;
    return Ql(T({
      type: "icon"
    }, I), function() {
      return uC("beforeDOMElementCreation", {
        iconDefinition: I,
        params: C
      }), D.autoA11y && (s ? u["aria-labelledby"] = "".concat(D.replacementClass, "-title-").concat(Z || LA()) : (u["aria-hidden"] = "true", u.focusable = "false")), pe({
        icons: {
          main: oi(N),
          mask: e ? oi(e.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: X,
        iconName: W,
        transform: T(T({}, bI), c),
        symbol: t,
        title: s,
        maskId: b,
        titleId: Z,
        extra: {
          attributes: u,
          styles: V,
          classes: h
        }
      });
    });
  }
}, dW = {
  mixout: function() {
    return {
      icon: sW(uW)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(C) {
        return C.treeCallback = kb, C.nodeCallback = aW, C;
      }
    };
  },
  provides: function(I) {
    I.i2svg = function(C) {
      var A = C.node, c = A === void 0 ? Gg : A, l = C.callback, t = l === void 0 ? function() {
      } : l;
      return kb(c, t);
    }, I.generateSvgReplacementMutation = function(C, A) {
      var c = A.iconName, l = A.title, t = A.titleId, i = A.prefix, e = A.transform, n = A.symbol, b = A.mask, a = A.maskId, s = A.extra;
      return new Promise(function(d, Z) {
        Promise.all([Gi(c, i), b.iconName ? Gi(b.iconName, b.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(r) {
          var h = re(r, 2), x = h[0], u = h[1];
          d([C, pe({
            icons: {
              main: x,
              mask: u
            },
            prefix: i,
            iconName: c,
            transform: e,
            symbol: n,
            maskId: a,
            title: l,
            titleId: t,
            extra: s,
            watchable: !0
          })]);
        }).catch(Z);
      });
    }, I.generateAbstractIcon = function(C) {
      var A = C.children, c = C.attributes, l = C.main, t = C.transform, i = C.styles, e = Ol(i);
      e.length > 0 && (c.style = e);
      var n;
      return We(t) && (n = yI("generateAbstractTransformGrouping", {
        main: l,
        transform: t,
        containerWidth: l.width,
        iconWidth: l.width
      })), A.push(n || l.icon), {
        children: A,
        attributes: c
      };
    };
  }
}, oW = {
  mixout: function() {
    return {
      layer: function(C) {
        var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = A.classes, l = c === void 0 ? [] : c;
        return Ql({
          type: "layer"
        }, function() {
          uC("beforeDOMElementCreation", {
            assembler: C,
            params: A
          });
          var t = [];
          return C(function(i) {
            Array.isArray(i) ? i.map(function(e) {
              t = t.concat(e.abstract);
            }) : t = t.concat(i.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(D.cssPrefix, "-layers")].concat(Ac(l)).join(" ")
            },
            children: t
          }];
        });
      }
    };
  }
}, GW = {
  mixout: function() {
    return {
      counter: function(C) {
        var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = A.title, l = c === void 0 ? null : c, t = A.classes, i = t === void 0 ? [] : t, e = A.attributes, n = e === void 0 ? {} : e, b = A.styles, a = b === void 0 ? {} : b;
        return Ql({
          type: "counter",
          content: C
        }, function() {
          return uC("beforeDOMElementCreation", {
            content: C,
            params: A
          }), Mh({
            content: C.toString(),
            title: l,
            extra: {
              attributes: n,
              styles: a,
              classes: ["".concat(D.cssPrefix, "-layers-counter")].concat(Ac(i))
            }
          });
        });
      }
    };
  }
}, rW = {
  mixout: function() {
    return {
      text: function(C) {
        var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = A.transform, l = c === void 0 ? bI : c, t = A.title, i = t === void 0 ? null : t, e = A.classes, n = e === void 0 ? [] : e, b = A.attributes, a = b === void 0 ? {} : b, s = A.styles, d = s === void 0 ? {} : s;
        return Ql({
          type: "text",
          content: C
        }, function() {
          return uC("beforeDOMElementCreation", {
            content: C,
            params: A
          }), wb({
            content: C,
            transform: T(T({}, bI), l),
            title: i,
            extra: {
              attributes: a,
              styles: d,
              classes: ["".concat(D.cssPrefix, "-layers-text")].concat(Ac(n))
            }
          });
        });
      }
    };
  },
  provides: function(I) {
    I.generateLayersText = function(C, A) {
      var c = A.title, l = A.transform, t = A.extra, i = null, e = null;
      if (cd) {
        var n = parseInt(getComputedStyle(C).fontSize, 10), b = C.getBoundingClientRect();
        i = b.width / n, e = b.height / n;
      }
      return D.autoA11y && !c && (t.attributes["aria-hidden"] = "true"), Promise.resolve([C, wb({
        content: C.innerHTML,
        width: i,
        height: e,
        transform: l,
        title: c,
        extra: t,
        watchable: !0
      })]);
    };
  }
}, XW = new RegExp('"', "ug"), Db = [1105920, 1112319];
function ZW(g) {
  var I = g.replace(XW, ""), C = Yh(I, 0), A = C >= Db[0] && C <= Db[1], c = I.length === 2 ? I[0] === I[1] : !1;
  return {
    value: ai(c ? I[0] : I),
    isSecondary: A || c
  };
}
function Ob(g, I) {
  var C = "".concat(ih).concat(I.replace(":", "-"));
  return new Promise(function(A, c) {
    if (g.getAttribute(C) !== null)
      return A();
    var l = CA(g.children), t = l.filter(function(N) {
      return N.getAttribute(bi) === I;
    })[0], i = HI.getComputedStyle(g, I), e = i.getPropertyValue("font-family").match(sh), n = i.getPropertyValue("font-weight"), b = i.getPropertyValue("content");
    if (t && !e)
      return g.removeChild(t), A();
    if (e && b !== "none" && b !== "") {
      var a = i.getPropertyValue("content"), s = ~["Sharp"].indexOf(e[2]) ? mg : og, d = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(e[2]) ? wA[s][e[2].toLowerCase()] : uh[s][n], Z = ZW(a), r = Z.value, h = Z.isSecondary, x = e[0].startsWith("FontAwesome"), u = xe(d, r), G = u;
      if (x) {
        var V = Th(r);
        V.iconName && V.prefix && (u = V.iconName, d = V.prefix);
      }
      if (u && !h && (!t || t.getAttribute(Ze) !== d || t.getAttribute(Ve) !== G)) {
        g.setAttribute(C, G), t && g.removeChild(t);
        var X = nW(), W = X.extra;
        W.attributes[bi] = I, Gi(u, d).then(function(N) {
          var m = pe(T(T({}, X), {}, {
            icons: {
              main: N,
              mask: ye()
            },
            prefix: d,
            iconName: G,
            extra: W,
            watchable: !0
          })), p = Gg.createElementNS("http://www.w3.org/2000/svg", "svg");
          I === "::before" ? g.insertBefore(p, g.firstChild) : g.appendChild(p), p.outerHTML = m.map(function(Y) {
            return lc(Y);
          }).join(`
`), g.removeAttribute(C), A();
        }).catch(c);
      } else
        A();
    } else
      A();
  });
}
function VW(g) {
  return Promise.all([Ob(g, "::before"), Ob(g, "::after")]);
}
function mW(g) {
  return g.parentNode !== document.head && !~nh.indexOf(g.tagName.toUpperCase()) && !g.getAttribute(bi) && (!g.parentNode || g.parentNode.tagName !== "svg");
}
function jb(g) {
  if (JI)
    return new Promise(function(I, C) {
      var A = CA(g.querySelectorAll("*")).filter(mW).map(VW), c = Re.begin("searchPseudoElements");
      xd(), Promise.all(A).then(function() {
        c(), Xi(), I();
      }).catch(function() {
        c(), Xi(), C();
      });
    });
}
var hW = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(C) {
        return C.pseudoElementsCallback = jb, C;
      }
    };
  },
  provides: function(I) {
    I.pseudoElements2svg = function(C) {
      var A = C.node, c = A === void 0 ? Gg : A;
      D.searchPseudoElements && jb(c);
    };
  }
}, Eb = !1, WW = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          xd(), Eb = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        Ub(ui("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        lW();
      },
      watch: function(C) {
        var A = C.observeMutationsRoot;
        Eb ? Xi() : Ub(ui("mutationObserverCallbacks", {
          observeMutationsRoot: A
        }));
      }
    };
  }
}, Qb = function(I) {
  var C = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return I.toLowerCase().split(" ").reduce(function(A, c) {
    var l = c.toLowerCase().split("-"), t = l[0], i = l.slice(1).join("-");
    if (t && i === "h")
      return A.flipX = !0, A;
    if (t && i === "v")
      return A.flipY = !0, A;
    if (i = parseFloat(i), isNaN(i))
      return A;
    switch (t) {
      case "grow":
        A.size = A.size + i;
        break;
      case "shrink":
        A.size = A.size - i;
        break;
      case "left":
        A.x = A.x - i;
        break;
      case "right":
        A.x = A.x + i;
        break;
      case "up":
        A.y = A.y - i;
        break;
      case "down":
        A.y = A.y + i;
        break;
      case "rotate":
        A.rotate = A.rotate + i;
        break;
    }
    return A;
  }, C);
}, NW = {
  mixout: function() {
    return {
      parse: {
        transform: function(C) {
          return Qb(C);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(C, A) {
        var c = A.getAttribute("data-fa-transform");
        return c && (C.transform = Qb(c)), C;
      }
    };
  },
  provides: function(I) {
    I.generateAbstractTransformGrouping = function(C) {
      var A = C.main, c = C.transform, l = C.containerWidth, t = C.iconWidth, i = {
        transform: "translate(".concat(l / 2, " 256)")
      }, e = "translate(".concat(c.x * 32, ", ").concat(c.y * 32, ") "), n = "scale(".concat(c.size / 16 * (c.flipX ? -1 : 1), ", ").concat(c.size / 16 * (c.flipY ? -1 : 1), ") "), b = "rotate(".concat(c.rotate, " 0 0)"), a = {
        transform: "".concat(e, " ").concat(n, " ").concat(b)
      }, s = {
        transform: "translate(".concat(t / 2 * -1, " -256)")
      }, d = {
        outer: i,
        inner: a,
        path: s
      };
      return {
        tag: "g",
        attributes: T({}, d.outer),
        children: [{
          tag: "g",
          attributes: T({}, d.inner),
          children: [{
            tag: A.icon.tag,
            children: A.icon.children,
            attributes: T(T({}, A.icon.attributes), d.path)
          }]
        }]
      };
    };
  }
}, Zt = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function Mb(g) {
  var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return g.attributes && (g.attributes.fill || I) && (g.attributes.fill = "black"), g;
}
function xW(g) {
  return g.tag === "g" ? g.children : [g];
}
var yW = {
  hooks: function() {
    return {
      parseNodeAttributes: function(C, A) {
        var c = A.getAttribute("data-fa-mask"), l = c ? El(c.split(" ").map(function(t) {
          return t.trim();
        })) : ye();
        return l.prefix || (l.prefix = wI()), C.mask = l, C.maskId = A.getAttribute("data-fa-mask-id"), C;
      }
    };
  },
  provides: function(I) {
    I.generateAbstractMask = function(C) {
      var A = C.children, c = C.attributes, l = C.main, t = C.mask, i = C.maskId, e = C.transform, n = l.width, b = l.icon, a = t.width, s = t.icon, d = Nh({
        transform: e,
        containerWidth: a,
        iconWidth: n
      }), Z = {
        tag: "rect",
        attributes: T(T({}, Zt), {}, {
          fill: "white"
        })
      }, r = b.children ? {
        children: b.children.map(Mb)
      } : {}, h = {
        tag: "g",
        attributes: T({}, d.inner),
        children: [Mb(T({
          tag: b.tag,
          attributes: T(T({}, b.attributes), d.path)
        }, r))]
      }, x = {
        tag: "g",
        attributes: T({}, d.outer),
        children: [h]
      }, u = "mask-".concat(i || LA()), G = "clip-".concat(i || LA()), V = {
        tag: "mask",
        attributes: T(T({}, Zt), {}, {
          id: u,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [Z, x]
      }, X = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: G
          },
          children: xW(s)
        }, V]
      };
      return A.push(X, {
        tag: "rect",
        attributes: T({
          fill: "currentColor",
          "clip-path": "url(#".concat(G, ")"),
          mask: "url(#".concat(u, ")")
        }, Zt)
      }), {
        children: A,
        attributes: c
      };
    };
  }
}, pW = {
  provides: function(I) {
    var C = !1;
    HI.matchMedia && (C = HI.matchMedia("(prefers-reduced-motion: reduce)").matches), I.missingIconAbstract = function() {
      var A = [], c = {
        fill: "currentColor"
      }, l = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      A.push({
        tag: "path",
        attributes: T(T({}, c), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var t = T(T({}, l), {}, {
        attributeName: "opacity"
      }), i = {
        tag: "circle",
        attributes: T(T({}, c), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return C || i.children.push({
        tag: "animate",
        attributes: T(T({}, l), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: T(T({}, t), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), A.push(i), A.push({
        tag: "path",
        attributes: T(T({}, c), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: C ? [] : [{
          tag: "animate",
          attributes: T(T({}, t), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), C || A.push({
        tag: "path",
        attributes: T(T({}, c), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: T(T({}, t), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: A
      };
    };
  }
}, RW = {
  hooks: function() {
    return {
      parseNodeAttributes: function(C, A) {
        var c = A.getAttribute("data-fa-symbol"), l = c === null ? !1 : c === "" ? !0 : c;
        return C.symbol = l, C;
      }
    };
  }
}, BW = [ph, dW, oW, GW, rW, hW, WW, NW, yW, pW, RW];
Ph(BW, {
  mixoutsTo: Eg
});
Eg.noAuto;
Eg.config;
var vW = Eg.library;
Eg.dom;
Eg.parse;
var Kb = Eg.findIconDefinition;
Eg.toHtml;
Eg.icon;
Eg.layer;
Eg.text;
Eg.counter;
/*! js-cookie v3.0.5 | MIT */
function Fc(g) {
  for (var I = 1; I < arguments.length; I++) {
    var C = arguments[I];
    for (var A in C)
      g[A] = C[A];
  }
  return g;
}
var JW = {
  read: function(g) {
    return g[0] === '"' && (g = g.slice(1, -1)), g.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(g) {
    return encodeURIComponent(g).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Zi(g, I) {
  function C(c, l, t) {
    if (!(typeof document > "u")) {
      t = Fc({}, I, t), typeof t.expires == "number" && (t.expires = new Date(Date.now() + t.expires * 864e5)), t.expires && (t.expires = t.expires.toUTCString()), c = encodeURIComponent(c).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var i = "";
      for (var e in t)
        t[e] && (i += "; " + e, t[e] !== !0 && (i += "=" + t[e].split(";")[0]));
      return document.cookie = c + "=" + g.write(l, c) + i;
    }
  }
  function A(c) {
    if (!(typeof document > "u" || arguments.length && !c)) {
      for (var l = document.cookie ? document.cookie.split("; ") : [], t = {}, i = 0; i < l.length; i++) {
        var e = l[i].split("="), n = e.slice(1).join("=");
        try {
          var b = decodeURIComponent(e[0]);
          if (t[b] = g.read(n, b), c === b)
            break;
        } catch {
        }
      }
      return c ? t[c] : t;
    }
  }
  return Object.create(
    {
      set: C,
      get: A,
      remove: function(c, l) {
        C(
          c,
          "",
          Fc({}, l, {
            expires: -1
          })
        );
      },
      withAttributes: function(c) {
        return Zi(this.converter, Fc({}, this.attributes, c));
      },
      withConverter: function(c) {
        return Zi(Fc({}, this.converter, c), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(I) },
      converter: { value: Object.freeze(g) }
    }
  );
}
var YW = Zi(JW, { path: "/" }), FW = Object.defineProperty, zW = (g, I, C) => I in g ? FW(g, I, { enumerable: !0, configurable: !0, writable: !0, value: C }) : g[I] = C, cC = (g, I, C) => (zW(g, typeof I != "symbol" ? I + "" : I, C), C), GI = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function OI(g) {
  return g && g.__esModule && Object.prototype.hasOwnProperty.call(g, "default") ? g.default : g;
}
var Ml = { exports: {} };
function fW(g) {
  try {
    return JSON.stringify(g);
  } catch {
    return '"[Circular]"';
  }
}
var HW = wW;
function wW(g, I, C) {
  var A = C && C.stringify || fW, c = 1;
  if (typeof g == "object" && g !== null) {
    var l = I.length + c;
    if (l === 1)
      return g;
    var t = new Array(l);
    t[0] = A(g);
    for (var i = 1; i < l; i++)
      t[i] = A(I[i]);
    return t.join(" ");
  }
  if (typeof g != "string")
    return g;
  var e = I.length;
  if (e === 0)
    return g;
  for (var n = "", b = 1 - c, a = -1, s = g && g.length || 0, d = 0; d < s; ) {
    if (g.charCodeAt(d) === 37 && d + 1 < s) {
      switch (a = a > -1 ? a : 0, g.charCodeAt(d + 1)) {
        case 100:
        case 102:
          if (b >= e || I[b] == null)
            break;
          a < d && (n += g.slice(a, d)), n += Number(I[b]), a = d + 2, d++;
          break;
        case 105:
          if (b >= e || I[b] == null)
            break;
          a < d && (n += g.slice(a, d)), n += Math.floor(Number(I[b])), a = d + 2, d++;
          break;
        case 79:
        case 111:
        case 106:
          if (b >= e || I[b] === void 0)
            break;
          a < d && (n += g.slice(a, d));
          var Z = typeof I[b];
          if (Z === "string") {
            n += "'" + I[b] + "'", a = d + 2, d++;
            break;
          }
          if (Z === "function") {
            n += I[b].name || "<anonymous>", a = d + 2, d++;
            break;
          }
          n += A(I[b]), a = d + 2, d++;
          break;
        case 115:
          if (b >= e)
            break;
          a < d && (n += g.slice(a, d)), n += String(I[b]), a = d + 2, d++;
          break;
        case 37:
          a < d && (n += g.slice(a, d)), n += "%", a = d + 2, d++, b--;
          break;
      }
      ++b;
    }
    ++d;
  }
  return a === -1 ? g : (a < s && (n += g.slice(a)), n);
}
const _b = HW;
Ml.exports = pI;
const UA = qW().console || {}, SW = {
  mapHttpRequest: zc,
  mapHttpResponse: zc,
  wrapRequestSerializer: Vt,
  wrapResponseSerializer: Vt,
  wrapErrorSerializer: Vt,
  req: zc,
  res: zc,
  err: $b,
  errWithCause: $b
};
function al(g, I) {
  return g === "silent" ? 1 / 0 : I.levels.values[g];
}
const ve = Symbol("pino.logFuncs"), Vi = Symbol("pino.hierarchy"), TW = {
  error: "log",
  fatal: "error",
  warn: "error",
  info: "log",
  debug: "log",
  trace: "log"
};
function qb(g, I) {
  const C = {
    logger: I,
    parent: g[Vi]
  };
  I[Vi] = C;
}
function LW(g, I, C) {
  const A = {};
  I.forEach((c) => {
    A[c] = C[c] ? C[c] : UA[c] || UA[TW[c] || "log"] || PA;
  }), g[ve] = A;
}
function UW(g, I) {
  return Array.isArray(g) ? g.filter(function(C) {
    return C !== "!stdSerializers.err";
  }) : g === !0 ? Object.keys(I) : !1;
}
function pI(g) {
  g = g || {}, g.browser = g.browser || {};
  const I = g.browser.transmit;
  if (I && typeof I.send != "function")
    throw Error("pino: transmit option must have a send function");
  const C = g.browser.write || UA;
  g.browser.write && (g.browser.asObject = !0);
  const A = g.serializers || {}, c = UW(g.browser.serialize, A);
  let l = g.browser.serialize;
  Array.isArray(g.browser.serialize) && g.browser.serialize.indexOf("!stdSerializers.err") > -1 && (l = !1);
  const t = Object.keys(g.customLevels || {}), i = ["error", "fatal", "warn", "info", "debug", "trace"].concat(t);
  typeof C == "function" && i.forEach(function(r) {
    C[r] = C;
  }), (g.enabled === !1 || g.browser.disabled) && (g.level = "silent");
  const e = g.level || "info", n = Object.create(C);
  n.log || (n.log = PA), LW(n, i, C), qb({}, n), Object.defineProperty(n, "levelVal", {
    get: a
  }), Object.defineProperty(n, "level", {
    get: s,
    set: d
  });
  const b = {
    transmit: I,
    serialize: c,
    asObject: g.browser.asObject,
    formatters: g.browser.formatters,
    levels: i,
    timestamp: MW(g)
  };
  n.levels = PW(g), n.level = e, n.setMaxListeners = n.getMaxListeners = n.emit = n.addListener = n.on = n.prependListener = n.once = n.prependOnceListener = n.removeListener = n.removeAllListeners = n.listeners = n.listenerCount = n.eventNames = n.write = n.flush = PA, n.serializers = A, n._serialize = c, n._stdErrSerialize = l, n.child = Z, I && (n._logEvent = mi());
  function a() {
    return al(this.level, this);
  }
  function s() {
    return this._level;
  }
  function d(r) {
    if (r !== "silent" && !this.levels.values[r])
      throw Error("unknown level " + r);
    this._level = r, qI(this, b, n, "error"), qI(this, b, n, "fatal"), qI(this, b, n, "warn"), qI(this, b, n, "info"), qI(this, b, n, "debug"), qI(this, b, n, "trace"), t.forEach((h) => {
      qI(this, b, n, h);
    });
  }
  function Z(r, h) {
    if (!r)
      throw new Error("missing bindings for child Pino");
    h = h || {}, c && r.serializers && (h.serializers = r.serializers);
    const x = h.serializers;
    if (c && x) {
      var u = Object.assign({}, A, x), G = g.browser.serialize === !0 ? Object.keys(u) : c;
      delete r.serializers, Kl([r], G, u, this._stdErrSerialize);
    }
    function V(W) {
      this._childLevel = (W._childLevel | 0) + 1, this.bindings = r, u && (this.serializers = u, this._serialize = G), I && (this._logEvent = mi(
        [].concat(W._logEvent.bindings, r)
      ));
    }
    V.prototype = this;
    const X = new V(this);
    return qb(this, X), X.level = this.level, X;
  }
  return n;
}
function PW(g) {
  const I = g.customLevels || {}, C = Object.assign({}, pI.levels.values, I), A = Object.assign({}, pI.levels.labels, kW(I));
  return {
    values: C,
    labels: A
  };
}
function kW(g) {
  const I = {};
  return Object.keys(g).forEach(function(C) {
    I[g[C]] = C;
  }), I;
}
pI.levels = {
  values: {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10
  },
  labels: {
    10: "trace",
    20: "debug",
    30: "info",
    40: "warn",
    50: "error",
    60: "fatal"
  }
};
pI.stdSerializers = SW;
pI.stdTimeFunctions = Object.assign({}, { nullTime: pd, epochTime: Rd, unixTime: KW, isoTime: _W });
function DW(g) {
  const I = [];
  g.bindings && I.push(g.bindings);
  let C = g[Vi];
  for (; C.parent; )
    C = C.parent, C.logger.bindings && I.push(C.logger.bindings);
  return I.reverse();
}
function qI(g, I, C, A) {
  if (Object.defineProperty(g, A, {
    value: al(g.level, C) > al(A, C) ? PA : C[ve][A],
    writable: !0,
    enumerable: !0,
    configurable: !0
  }), !I.transmit && g[A] === PA)
    return;
  g[A] = jW(g, I, C, A);
  const c = DW(g);
  c.length !== 0 && (g[A] = OW(c, g[A]));
}
function OW(g, I) {
  return function() {
    return I.apply(this, [...g, ...arguments]);
  };
}
function jW(g, I, C, A) {
  return function(c) {
    return function() {
      const l = I.timestamp(), t = new Array(arguments.length), i = Object.getPrototypeOf && Object.getPrototypeOf(this) === UA ? UA : this;
      for (var e = 0; e < t.length; e++)
        t[e] = arguments[e];
      if (I.serialize && !I.asObject && Kl(t, this._serialize, this.serializers, this._stdErrSerialize), I.asObject || I.formatters ? c.call(i, EW(this, A, t, l, I.formatters)) : c.apply(i, t), I.transmit) {
        const n = I.transmit.level || g._level, b = C.levels.values[n], a = C.levels.values[A];
        if (a < b)
          return;
        QW(this, {
          ts: l,
          methodLevel: A,
          methodValue: a,
          transmitLevel: n,
          transmitValue: C.levels.values[I.transmit.level || g._level],
          send: I.transmit.send,
          val: al(g._level, C)
        }, t);
      }
    };
  }(g[ve][A]);
}
function EW(g, I, C, A, c = {}) {
  const {
    level: l = () => g.levels.values[I],
    log: t = (a) => a
  } = c;
  g._serialize && Kl(C, g._serialize, g.serializers, g._stdErrSerialize);
  const i = C.slice();
  let e = i[0];
  const n = {};
  A && (n.time = A), n.level = l(I, g.levels.values[I]);
  let b = (g._childLevel | 0) + 1;
  if (b < 1 && (b = 1), e !== null && typeof e == "object") {
    for (; b-- && typeof i[0] == "object"; )
      Object.assign(n, i.shift());
    e = i.length ? _b(i.shift(), i) : void 0;
  } else
    typeof e == "string" && (e = _b(i.shift(), i));
  return e !== void 0 && (n.msg = e), t(n);
}
function Kl(g, I, C, A) {
  for (const c in g)
    if (A && g[c] instanceof Error)
      g[c] = pI.stdSerializers.err(g[c]);
    else if (typeof g[c] == "object" && !Array.isArray(g[c]))
      for (const l in g[c])
        I && I.indexOf(l) > -1 && l in C && (g[c][l] = C[l](g[c][l]));
}
function QW(g, I, C) {
  const A = I.send, c = I.ts, l = I.methodLevel, t = I.methodValue, i = I.val, e = g._logEvent.bindings;
  Kl(
    C,
    g._serialize || Object.keys(g.serializers),
    g.serializers,
    g._stdErrSerialize === void 0 ? !0 : g._stdErrSerialize
  ), g._logEvent.ts = c, g._logEvent.messages = C.filter(function(n) {
    return e.indexOf(n) === -1;
  }), g._logEvent.level.label = l, g._logEvent.level.value = t, A(l, g._logEvent, i), g._logEvent = mi(e);
}
function mi(g) {
  return {
    ts: 0,
    messages: [],
    bindings: g || [],
    level: { label: "", value: 0 }
  };
}
function $b(g) {
  const I = {
    type: g.constructor.name,
    msg: g.message,
    stack: g.stack
  };
  for (const C in g)
    I[C] === void 0 && (I[C] = g[C]);
  return I;
}
function MW(g) {
  return typeof g.timestamp == "function" ? g.timestamp : g.timestamp === !1 ? pd : Rd;
}
function zc() {
  return {};
}
function Vt(g) {
  return g;
}
function PA() {
}
function pd() {
  return !1;
}
function Rd() {
  return Date.now();
}
function KW() {
  return Math.round(Date.now() / 1e3);
}
function _W() {
  return new Date(Date.now()).toISOString();
}
function qW() {
  function g(I) {
    return typeof I < "u" && I;
  }
  try {
    return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
      get: function() {
        return delete Object.prototype.globalThis, this.globalThis = this;
      },
      configurable: !0
    }), globalThis;
  } catch {
    return g(self) || g(window) || g(this) || {};
  }
}
Ml.exports.default = pI;
Ml.exports.pino = pI;
var $W = Ml.exports;
const g9 = /* @__PURE__ */ OI($W);
var sl = {
  error: 3,
  warn: 4,
  info: 6,
  debug: 7
}, I9 = class {
  constructor() {
    cC(this, "logger"), cC(this, "defaultLogLevelMap"), this.defaultLogLevelMap = sl, this.logger = g9(), this.logger.levels = {
      labels: ie(this.defaultLogLevelMap),
      values: this.defaultLogLevelMap
    };
  }
  debug(g) {
    this.log("debug", g);
  }
  info(g) {
    this.log("info", g);
  }
  warn(g) {
    this.log("warn", g);
  }
  error(g) {
    this.log("error", g);
  }
  log(g, I) {
    if (this.isLogLevelKey(g)) {
      this.logger[g](I);
      return;
    }
    let C = this.findLoggerTypeForSyslogLevel(g);
    C && this.logger[C](I);
  }
  isLogLevelKey(g) {
    return typeof g == "string" && Sl(Object.keys(this.defaultLogLevelMap), g);
  }
  findLoggerTypeForSyslogLevel(g) {
    let I = this.logger.levels.labels[g];
    return this.isLogLevelKey(I) ? I : null;
  }
};
new I9();
var Bd = (g) => eu(g) && !rA(g), C9 = (g) => typeof g == "number" && Sl(Object.values(sl), g), kA = class extends Error {
  constructor(g, I) {
    var C;
    super(g.message), cC(this, "statusCode"), cC(this, "errorCode"), cC(this, "data"), cC(this, "name"), this.errorDTO = g, this.info = I, this.statusCode = this.errorDTO.statusCode, this.data = this.errorDTO.data, this.errorCode = (C = this.errorDTO) == null ? void 0 : C.errorCode, this.name = this.info.handled ? "HandledApiError" : "UnhandledApiError";
  }
  get code() {
    var g;
    return this.errorCode || typeof this.data != "string" && ((g = this.data) == null ? void 0 : g.code) || "";
  }
  static createError(g, I, C) {
    return C9(C) ? new c9(g, I, C) : ["NOT_FOUND", "UNAUTHORIZED"].some((A) => A === g.statusCode) ? new A9(g, I) : new kA(g, I);
  }
  isErrorResponse(g) {
    return Bd(g) && LC(g, "data") && LC(g, "statusCode") && LC(g, "message") && g.statusCode !== "OK";
  }
  logMessage() {
    let {
      status: g,
      handled: I,
      url: C
    } = this.info, A = I ? "HANDLED" : "UNHANDLED", c = this.isErrorResponse(this.info.extra) ? `${this.info.extra.statusCode}: ${this.info.extra.message}` : "", l = `${g} error ${c}`;
    return {
      level: "error",
      message: `fetch: [${A} ${l}] *url: ${C} *data: ${this.info.extra ? JSON.stringify(this.info.extra) : ""}`
    };
  }
}, A9 = class extends kA {
  logMessage() {
    return {
      ...super.logMessage(),
      level: "info"
    };
  }
}, c9 = class extends kA {
  constructor(g, I, C) {
    super(g, I), cC(this, "customLogLevel"), this.customLogLevel = C;
  }
  isLogLevelKey(g) {
    return Sl(Object.keys(sl), g);
  }
  logMessage() {
    let g = super.logMessage(), I = ie(sl)[this.customLogLevel];
    return {
      ...g,
      level: this.isLogLevelKey(I) ? I : "error"
    };
  }
}, l9 = 10 * 1e3, AA = class extends ks {
  static from(g) {
    return new AA({
      timeout: l9,
      ...g
    });
  }
  afterRequest(g, I, C, A) {
    if (this.isErrorResponse(A)) {
      let c = kA.createError(A, {
        status: g,
        url: C.path,
        handled: !0,
        extra: A
      }, Number(I.get("goose-level"))), {
        level: l,
        message: t
      } = c.logMessage();
      throw console[l](t), c;
    }
    return A;
  }
  performError(g) {
    if (g instanceof kA) {
      let {
        level: I,
        message: C
      } = g.logMessage();
      console[I](C);
      return;
    }
    if (g instanceof DOMException && g.name === "AbortError") {
      console.error(`[CustomAbortError] ${g.message}`);
      return;
    }
    console.info(g);
  }
  isErrorResponse(g) {
    return Bd(g) && LC(g, "data") && LC(g, "statusCode") && LC(g, "message") && g.statusCode !== "OK";
  }
};
const t9 = {
  MODE: "development",
  CDN_URL: "https://cdn.devinflearn.com",
  SITE_URL: "https://www.devinflearn.com",
  MIXPANEL_TOKEN: "2df837e504078b475f90b32d9a268c01",
  HACKLE_BROWSER_SDK_KEY: "ygFNanOzYS2M5JgfrE5gUk69EbkFIzZ4",
  PUBLIC_UCC_API_URL: "https://ucc-api.devinflearn.com",
  PUBLIC_COURSE_API_URL: "https://course-api.devinflearn.com",
  PUBLIC_ACCOUNT_API_URL: "https://account-api.devinflearn.com",
  PUBLIC_PAYMENT_API_URL: "https://payment-api.devinflearn.com",
  COOKIE_DOMAIN: ".devinflearn.com",
  CDN_INTEGRATION_URL: "https://cdn.devinflab.com",
  PUBLIC_COURSE_CURATION_API_URL: "https://course-curation-api.devinflearn.com"
}, i9 = {
  MODE: "localhost",
  CDN_URL: "https://cdn.devinflearn.com",
  SITE_URL: "https://www.devinflearn.com",
  MIXPANEL_TOKEN: "2df837e504078b475f90b32d9a268c01",
  HACKLE_BROWSER_SDK_KEY: "ygFNanOzYS2M5JgfrE5gUk69EbkFIzZ4",
  PUBLIC_UCC_API_URL: "https://ucc-api.devinflearn.com",
  PUBLIC_COURSE_API_URL: "https://course-api.devinflearn.com",
  PUBLIC_ACCOUNT_API_URL: "https://account-api.devinflearn.com",
  PUBLIC_PAYMENT_API_URL: "https://payment-api.devinflearn.com",
  COOKIE_DOMAIN: "localhost",
  CDN_INTEGRATION_URL: "https://cdn.devinflab.com",
  PUBLIC_COURSE_CURATION_API_URL: "https://course-curation-api.devinflearn.com"
}, ga = {
  MODE: "production",
  CDN_URL: "https://cdn.inflearn.com",
  SITE_URL: "https://www.inflearn.com",
  MIXPANEL_TOKEN: "c05d8cc017a29af05e50c0d43d848d2d",
  HACKLE_BROWSER_SDK_KEY: "rb1wDPCB39swIGfTAhDcz0QXvmh6hayS",
  PUBLIC_UCC_API_URL: "https://ucc-api.inflearn.com",
  PUBLIC_COURSE_API_URL: "https://course-api.inflearn.com",
  PUBLIC_ACCOUNT_API_URL: "https://account-api.inflearn.com",
  PUBLIC_PAYMENT_API_URL: "https://payment-api.inflearn.com",
  COOKIE_DOMAIN: ".inflearn.com",
  CDN_INTEGRATION_URL: "https://cdn.inflearn.com",
  PUBLIC_COURSE_CURATION_API_URL: "https://course-curation-api.inflearn.com"
};
function e9() {
  return typeof window < "u" && window != null && window.env ? window.env : process.env.NEXT_PUBLIC_ENV || process.env.APP_ENV;
}
function n9() {
  const g = e9();
  return g ? g === "localhost" ? i9 : g === "production" ? ga : t9 : (console.error("app-shell env is not defined"), ga);
}
const YI = n9(), b9 = YI.CDN_URL, a9 = YI.SITE_URL, s9 = YI.MIXPANEL_TOKEN, u9 = YI.PUBLIC_COURSE_API_URL, d9 = YI.PUBLIC_ACCOUNT_API_URL, o9 = YI.PUBLIC_UCC_API_URL, vd = YI.PUBLIC_COURSE_CURATION_API_URL, Ia = YI.COOKIE_DOMAIN, G9 = YI.PUBLIC_PAYMENT_API_URL, r9 = new AA({
  baseUrl: u9,
  credentials: "include"
}), X9 = new AA({
  baseUrl: vd,
  credentials: "include"
}), Z9 = new AA({
  baseUrl: d9,
  credentials: "include"
}), V9 = new AA({
  baseUrl: o9,
  credentials: "include"
});
new AA({
  baseUrl: G9,
  credentials: "include"
});
var FC = { ko: "ko", en: "en", ja: "ja", vi: "vi" }, dC = FC.ko, Jd = Object.values(FC), ul = { exports: {} };
ul.exports;
(function(g, I) {
  (function(C, A) {
    g.exports = A();
  })(GI, function() {
    var C = 1e3, A = 6e4, c = 36e5, l = "millisecond", t = "second", i = "minute", e = "hour", n = "day", b = "week", a = "month", s = "quarter", d = "year", Z = "date", r = "Invalid Date", h = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, x = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(z) {
      var J = ["th", "st", "nd", "rd"], y = z % 100;
      return "[" + z + (J[(y - 20) % 10] || J[y] || J[0]) + "]";
    } }, G = function(z, J, y) {
      var f = String(z);
      return !f || f.length >= J ? z : "" + Array(J + 1 - f.length).join(y) + z;
    }, V = { s: G, z: function(z) {
      var J = -z.utcOffset(), y = Math.abs(J), f = Math.floor(y / 60), B = y % 60;
      return (J <= 0 ? "+" : "-") + G(f, 2, "0") + ":" + G(B, 2, "0");
    }, m: function z(J, y) {
      if (J.date() < y.date())
        return -z(y, J);
      var f = 12 * (y.year() - J.year()) + (y.month() - J.month()), B = J.clone().add(f, a), H = y - B < 0, F = J.clone().add(f + (H ? -1 : 1), a);
      return +(-(f + (y - B) / (H ? B - F : F - B)) || 0);
    }, a: function(z) {
      return z < 0 ? Math.ceil(z) || 0 : Math.floor(z);
    }, p: function(z) {
      return { M: a, y: d, w: b, d: n, D: Z, h: e, m: i, s: t, ms: l, Q: s }[z] || String(z || "").toLowerCase().replace(/s$/, "");
    }, u: function(z) {
      return z === void 0;
    } }, X = "en", W = {};
    W[X] = u;
    var N = "$isDayjsObject", m = function(z) {
      return z instanceof Q || !(!z || !z[N]);
    }, p = function z(J, y, f) {
      var B;
      if (!J)
        return X;
      if (typeof J == "string") {
        var H = J.toLowerCase();
        W[H] && (B = H), y && (W[H] = y, B = H);
        var F = J.split("-");
        if (!B && F.length > 1)
          return z(F[0]);
      } else {
        var E = J.name;
        W[E] = J, B = E;
      }
      return !f && B && (X = B), B || !f && X;
    }, Y = function(z, J) {
      if (m(z))
        return z.clone();
      var y = typeof J == "object" ? J : {};
      return y.date = z, y.args = arguments, new Q(y);
    }, v = V;
    v.l = p, v.i = m, v.w = function(z, J) {
      return Y(z, { locale: J.$L, utc: J.$u, x: J.$x, $offset: J.$offset });
    };
    var Q = function() {
      function z(y) {
        this.$L = p(y.locale, null, !0), this.parse(y), this.$x = this.$x || y.x || {}, this[N] = !0;
      }
      var J = z.prototype;
      return J.parse = function(y) {
        this.$d = function(f) {
          var B = f.date, H = f.utc;
          if (B === null)
            return /* @__PURE__ */ new Date(NaN);
          if (v.u(B))
            return /* @__PURE__ */ new Date();
          if (B instanceof Date)
            return new Date(B);
          if (typeof B == "string" && !/Z$/i.test(B)) {
            var F = B.match(h);
            if (F) {
              var E = F[2] - 1 || 0, M = (F[7] || "0").substring(0, 3);
              return H ? new Date(Date.UTC(F[1], E, F[3] || 1, F[4] || 0, F[5] || 0, F[6] || 0, M)) : new Date(F[1], E, F[3] || 1, F[4] || 0, F[5] || 0, F[6] || 0, M);
            }
          }
          return new Date(B);
        }(y), this.init();
      }, J.init = function() {
        var y = this.$d;
        this.$y = y.getFullYear(), this.$M = y.getMonth(), this.$D = y.getDate(), this.$W = y.getDay(), this.$H = y.getHours(), this.$m = y.getMinutes(), this.$s = y.getSeconds(), this.$ms = y.getMilliseconds();
      }, J.$utils = function() {
        return v;
      }, J.isValid = function() {
        return this.$d.toString() !== r;
      }, J.isSame = function(y, f) {
        var B = Y(y);
        return this.startOf(f) <= B && B <= this.endOf(f);
      }, J.isAfter = function(y, f) {
        return Y(y) < this.startOf(f);
      }, J.isBefore = function(y, f) {
        return this.endOf(f) < Y(y);
      }, J.$g = function(y, f, B) {
        return v.u(y) ? this[f] : this.set(B, y);
      }, J.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, J.valueOf = function() {
        return this.$d.getTime();
      }, J.startOf = function(y, f) {
        var B = this, H = !!v.u(f) || f, F = v.p(y), E = function(lg, ig) {
          var Ng = v.w(B.$u ? Date.UTC(B.$y, ig, lg) : new Date(B.$y, ig, lg), B);
          return H ? Ng : Ng.endOf(n);
        }, M = function(lg, ig) {
          return v.w(B.toDate()[lg].apply(B.toDate("s"), (H ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ig)), B);
        }, _ = this.$W, j = this.$M, eg = this.$D, Wg = "set" + (this.$u ? "UTC" : "");
        switch (F) {
          case d:
            return H ? E(1, 0) : E(31, 11);
          case a:
            return H ? E(1, j) : E(0, j + 1);
          case b:
            var Hg = this.$locale().weekStart || 0, rI = (_ < Hg ? _ + 7 : _) - Hg;
            return E(H ? eg - rI : eg + (6 - rI), j);
          case n:
          case Z:
            return M(Wg + "Hours", 0);
          case e:
            return M(Wg + "Minutes", 1);
          case i:
            return M(Wg + "Seconds", 2);
          case t:
            return M(Wg + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, J.endOf = function(y) {
        return this.startOf(y, !1);
      }, J.$set = function(y, f) {
        var B, H = v.p(y), F = "set" + (this.$u ? "UTC" : ""), E = (B = {}, B[n] = F + "Date", B[Z] = F + "Date", B[a] = F + "Month", B[d] = F + "FullYear", B[e] = F + "Hours", B[i] = F + "Minutes", B[t] = F + "Seconds", B[l] = F + "Milliseconds", B)[H], M = H === n ? this.$D + (f - this.$W) : f;
        if (H === a || H === d) {
          var _ = this.clone().set(Z, 1);
          _.$d[E](M), _.init(), this.$d = _.set(Z, Math.min(this.$D, _.daysInMonth())).$d;
        } else
          E && this.$d[E](M);
        return this.init(), this;
      }, J.set = function(y, f) {
        return this.clone().$set(y, f);
      }, J.get = function(y) {
        return this[v.p(y)]();
      }, J.add = function(y, f) {
        var B, H = this;
        y = Number(y);
        var F = v.p(f), E = function(j) {
          var eg = Y(H);
          return v.w(eg.date(eg.date() + Math.round(j * y)), H);
        };
        if (F === a)
          return this.set(a, this.$M + y);
        if (F === d)
          return this.set(d, this.$y + y);
        if (F === n)
          return E(1);
        if (F === b)
          return E(7);
        var M = (B = {}, B[i] = A, B[e] = c, B[t] = C, B)[F] || 1, _ = this.$d.getTime() + y * M;
        return v.w(_, this);
      }, J.subtract = function(y, f) {
        return this.add(-1 * y, f);
      }, J.format = function(y) {
        var f = this, B = this.$locale();
        if (!this.isValid())
          return B.invalidDate || r;
        var H = y || "YYYY-MM-DDTHH:mm:ssZ", F = v.z(this), E = this.$H, M = this.$m, _ = this.$M, j = B.weekdays, eg = B.months, Wg = B.meridiem, Hg = function(ig, Ng, ag, Lg) {
          return ig && (ig[Ng] || ig(f, H)) || ag[Ng].slice(0, Lg);
        }, rI = function(ig) {
          return v.s(E % 12 || 12, ig, "0");
        }, lg = Wg || function(ig, Ng, ag) {
          var Lg = ig < 12 ? "AM" : "PM";
          return ag ? Lg.toLowerCase() : Lg;
        };
        return H.replace(x, function(ig, Ng) {
          return Ng || function(ag) {
            switch (ag) {
              case "YY":
                return String(f.$y).slice(-2);
              case "YYYY":
                return v.s(f.$y, 4, "0");
              case "M":
                return _ + 1;
              case "MM":
                return v.s(_ + 1, 2, "0");
              case "MMM":
                return Hg(B.monthsShort, _, eg, 3);
              case "MMMM":
                return Hg(eg, _);
              case "D":
                return f.$D;
              case "DD":
                return v.s(f.$D, 2, "0");
              case "d":
                return String(f.$W);
              case "dd":
                return Hg(B.weekdaysMin, f.$W, j, 2);
              case "ddd":
                return Hg(B.weekdaysShort, f.$W, j, 3);
              case "dddd":
                return j[f.$W];
              case "H":
                return String(E);
              case "HH":
                return v.s(E, 2, "0");
              case "h":
                return rI(1);
              case "hh":
                return rI(2);
              case "a":
                return lg(E, M, !0);
              case "A":
                return lg(E, M, !1);
              case "m":
                return String(M);
              case "mm":
                return v.s(M, 2, "0");
              case "s":
                return String(f.$s);
              case "ss":
                return v.s(f.$s, 2, "0");
              case "SSS":
                return v.s(f.$ms, 3, "0");
              case "Z":
                return F;
            }
            return null;
          }(ig) || F.replace(":", "");
        });
      }, J.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, J.diff = function(y, f, B) {
        var H, F = this, E = v.p(f), M = Y(y), _ = (M.utcOffset() - this.utcOffset()) * A, j = this - M, eg = function() {
          return v.m(F, M);
        };
        switch (E) {
          case d:
            H = eg() / 12;
            break;
          case a:
            H = eg();
            break;
          case s:
            H = eg() / 3;
            break;
          case b:
            H = (j - _) / 6048e5;
            break;
          case n:
            H = (j - _) / 864e5;
            break;
          case e:
            H = j / c;
            break;
          case i:
            H = j / A;
            break;
          case t:
            H = j / C;
            break;
          default:
            H = j;
        }
        return B ? H : v.a(H);
      }, J.daysInMonth = function() {
        return this.endOf(a).$D;
      }, J.$locale = function() {
        return W[this.$L];
      }, J.locale = function(y, f) {
        if (!y)
          return this.$L;
        var B = this.clone(), H = p(y, f, !0);
        return H && (B.$L = H), B;
      }, J.clone = function() {
        return v.w(this.$d, this);
      }, J.toDate = function() {
        return new Date(this.valueOf());
      }, J.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, J.toISOString = function() {
        return this.$d.toISOString();
      }, J.toString = function() {
        return this.$d.toUTCString();
      }, z;
    }(), cg = Q.prototype;
    return Y.prototype = cg, [["$ms", l], ["$s", t], ["$m", i], ["$H", e], ["$W", n], ["$M", a], ["$y", d], ["$D", Z]].forEach(function(z) {
      cg[z[1]] = function(J) {
        return this.$g(J, z[0], z[1]);
      };
    }), Y.extend = function(z, J) {
      return z.$i || (z(J, Q, Y), z.$i = !0), Y;
    }, Y.locale = p, Y.isDayjs = m, Y.unix = function(z) {
      return Y(1e3 * z);
    }, Y.en = W[X], Y.Ls = W, Y.p = {}, Y;
  });
})(ul, ul.exports);
var _l = ul.exports;
const AI = /* @__PURE__ */ OI(_l);
var dl = { exports: {} };
dl.exports;
(function(g, I) {
  (function(C, A) {
    g.exports = A();
  })(GI, function() {
    return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(C) {
      var A = ["th", "st", "nd", "rd"], c = C % 100;
      return "[" + C + (A[(c - 20) % 10] || A[c] || A[0]) + "]";
    } };
  });
})(dl, dl.exports);
dl.exports;
var ol = { exports: {} };
ol.exports;
(function(g, I) {
  (function(C, A) {
    g.exports = A(_l);
  })(GI, function(C) {
    function A(t) {
      return t && typeof t == "object" && "default" in t ? t : { default: t };
    }
    var c = A(C), l = { name: "ko", weekdays: "일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"), weekdaysShort: "일_월_화_수_목_금_토".split("_"), weekdaysMin: "일_월_화_수_목_금_토".split("_"), months: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"), monthsShort: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"), ordinal: function(t) {
      return t + "일";
    }, formats: { LT: "A h:mm", LTS: "A h:mm:ss", L: "YYYY.MM.DD.", LL: "YYYY년 MMMM D일", LLL: "YYYY년 MMMM D일 A h:mm", LLLL: "YYYY년 MMMM D일 dddd A h:mm", l: "YYYY.MM.DD.", ll: "YYYY년 MMMM D일", lll: "YYYY년 MMMM D일 A h:mm", llll: "YYYY년 MMMM D일 dddd A h:mm" }, meridiem: function(t) {
      return t < 12 ? "오전" : "오후";
    }, relativeTime: { future: "%s 후", past: "%s 전", s: "몇 초", m: "1분", mm: "%d분", h: "한 시간", hh: "%d시간", d: "하루", dd: "%d일", M: "한 달", MM: "%d달", y: "일 년", yy: "%d년" } };
    return c.default.locale(l, null, !0), l;
  });
})(ol, ol.exports);
ol.exports;
var Gl = { exports: {} };
Gl.exports;
(function(g, I) {
  (function(C, A) {
    g.exports = A(_l);
  })(GI, function(C) {
    function A(t) {
      return t && typeof t == "object" && "default" in t ? t : { default: t };
    }
    var c = A(C), l = { name: "vi", weekdays: "chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy".split("_"), months: "tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split("_"), weekStart: 1, weekdaysShort: "CN_T2_T3_T4_T5_T6_T7".split("_"), monthsShort: "Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12".split("_"), weekdaysMin: "CN_T2_T3_T4_T5_T6_T7".split("_"), ordinal: function(t) {
      return t;
    }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM [năm] YYYY", LLL: "D MMMM [năm] YYYY HH:mm", LLLL: "dddd, D MMMM [năm] YYYY HH:mm", l: "DD/M/YYYY", ll: "D MMM YYYY", lll: "D MMM YYYY HH:mm", llll: "ddd, D MMM YYYY HH:mm" }, relativeTime: { future: "%s tới", past: "%s trước", s: "vài giây", m: "một phút", mm: "%d phút", h: "một giờ", hh: "%d giờ", d: "một ngày", dd: "%d ngày", M: "một tháng", MM: "%d tháng", y: "một năm", yy: "%d năm" } };
    return c.default.locale(l, null, !0), l;
  });
})(Gl, Gl.exports);
Gl.exports;
var rl = { exports: {} };
rl.exports;
(function(g, I) {
  (function(C, A) {
    g.exports = A(_l);
  })(GI, function(C) {
    function A(t) {
      return t && typeof t == "object" && "default" in t ? t : { default: t };
    }
    var c = A(C), l = { name: "ja", weekdays: "日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"), weekdaysShort: "日_月_火_水_木_金_土".split("_"), weekdaysMin: "日_月_火_水_木_金_土".split("_"), months: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), ordinal: function(t) {
      return t + "日";
    }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY/MM/DD", LL: "YYYY年M月D日", LLL: "YYYY年M月D日 HH:mm", LLLL: "YYYY年M月D日 dddd HH:mm", l: "YYYY/MM/DD", ll: "YYYY年M月D日", lll: "YYYY年M月D日 HH:mm", llll: "YYYY年M月D日(ddd) HH:mm" }, meridiem: function(t) {
      return t < 12 ? "午前" : "午後";
    }, relativeTime: { future: "%s後", past: "%s前", s: "数秒", m: "1分", mm: "%d分", h: "1時間", hh: "%d時間", d: "1日", dd: "%d日", M: "1ヶ月", MM: "%dヶ月", y: "1年", yy: "%d年" } };
    return c.default.locale(l, null, !0), l;
  });
})(rl, rl.exports);
rl.exports;
var Xl = { exports: {} };
Xl.exports;
(function(g, I) {
  (function(C, A) {
    g.exports = A();
  })(GI, function() {
    var C = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(A, c, l) {
      var t = c.prototype, i = t.format;
      l.en.formats = C, t.format = function(e) {
        e === void 0 && (e = "YYYY-MM-DDTHH:mm:ssZ");
        var n = this.$locale().formats, b = function(a, s) {
          return a.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(d, Z, r) {
            var h = r && r.toUpperCase();
            return Z || s[r] || C[r] || s[h].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(x, u, G) {
              return u || G.slice(1);
            });
          });
        }(e, n === void 0 ? {} : n);
        return i.call(this, b);
      };
    };
  });
})(Xl, Xl.exports);
var m9 = Xl.exports;
const h9 = /* @__PURE__ */ OI(m9);
var Zl = { exports: {} };
Zl.exports;
(function(g, I) {
  (function(C, A) {
    g.exports = A();
  })(GI, function() {
    var C = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, A = {};
    return function(c, l, t) {
      var i, e = function(s, d, Z) {
        Z === void 0 && (Z = {});
        var r = new Date(s), h = function(x, u) {
          u === void 0 && (u = {});
          var G = u.timeZoneName || "short", V = x + "|" + G, X = A[V];
          return X || (X = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: x, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: G }), A[V] = X), X;
        }(d, Z);
        return h.formatToParts(r);
      }, n = function(s, d) {
        for (var Z = e(s, d), r = [], h = 0; h < Z.length; h += 1) {
          var x = Z[h], u = x.type, G = x.value, V = C[u];
          V >= 0 && (r[V] = parseInt(G, 10));
        }
        var X = r[3], W = X === 24 ? 0 : X, N = r[0] + "-" + r[1] + "-" + r[2] + " " + W + ":" + r[4] + ":" + r[5] + ":000", m = +s;
        return (t.utc(N).valueOf() - (m -= m % 1e3)) / 6e4;
      }, b = l.prototype;
      b.tz = function(s, d) {
        s === void 0 && (s = i);
        var Z, r = this.utcOffset(), h = this.toDate(), x = h.toLocaleString("en-US", { timeZone: s }), u = Math.round((h - new Date(x)) / 1e3 / 60), G = 15 * -Math.round(h.getTimezoneOffset() / 15) - u;
        if (!Number(G))
          Z = this.utcOffset(0, d);
        else if (Z = t(x, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(G, !0), d) {
          var V = Z.utcOffset();
          Z = Z.add(r - V, "minute");
        }
        return Z.$x.$timezone = s, Z;
      }, b.offsetName = function(s) {
        var d = this.$x.$timezone || t.tz.guess(), Z = e(this.valueOf(), d, { timeZoneName: s }).find(function(r) {
          return r.type.toLowerCase() === "timezonename";
        });
        return Z && Z.value;
      };
      var a = b.startOf;
      b.startOf = function(s, d) {
        if (!this.$x || !this.$x.$timezone)
          return a.call(this, s, d);
        var Z = t(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return a.call(Z, s, d).tz(this.$x.$timezone, !0);
      }, t.tz = function(s, d, Z) {
        var r = Z && d, h = Z || d || i, x = n(+t(), h);
        if (typeof s != "string")
          return t(s).tz(h);
        var u = function(W, N, m) {
          var p = W - 60 * N * 1e3, Y = n(p, m);
          if (N === Y)
            return [p, N];
          var v = n(p -= 60 * (Y - N) * 1e3, m);
          return Y === v ? [p, Y] : [W - 60 * Math.min(Y, v) * 1e3, Math.max(Y, v)];
        }(t.utc(s, r).valueOf(), x, h), G = u[0], V = u[1], X = t(G).utcOffset(V);
        return X.$x.$timezone = h, X;
      }, t.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, t.tz.setDefault = function(s) {
        i = s;
      };
    };
  });
})(Zl, Zl.exports);
var W9 = Zl.exports;
const N9 = /* @__PURE__ */ OI(W9);
var Vl = { exports: {} };
Vl.exports;
(function(g, I) {
  (function(C, A) {
    g.exports = A();
  })(GI, function() {
    return function(C, A, c) {
      c.updateLocale = function(l, t) {
        var i = c.Ls[l];
        if (i)
          return (t ? Object.keys(t) : []).forEach(function(e) {
            i[e] = t[e];
          }), i;
      };
    };
  });
})(Vl, Vl.exports);
var x9 = Vl.exports;
const y9 = /* @__PURE__ */ OI(x9);
var ml = { exports: {} };
ml.exports;
(function(g, I) {
  (function(C, A) {
    g.exports = A();
  })(GI, function() {
    var C = "minute", A = /[+-]\d\d(?::?\d\d)?/g, c = /([+-]|\d\d)/g;
    return function(l, t, i) {
      var e = t.prototype;
      i.utc = function(r) {
        var h = { date: r, utc: !0, args: arguments };
        return new t(h);
      }, e.utc = function(r) {
        var h = i(this.toDate(), { locale: this.$L, utc: !0 });
        return r ? h.add(this.utcOffset(), C) : h;
      }, e.local = function() {
        return i(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var n = e.parse;
      e.parse = function(r) {
        r.utc && (this.$u = !0), this.$utils().u(r.$offset) || (this.$offset = r.$offset), n.call(this, r);
      };
      var b = e.init;
      e.init = function() {
        if (this.$u) {
          var r = this.$d;
          this.$y = r.getUTCFullYear(), this.$M = r.getUTCMonth(), this.$D = r.getUTCDate(), this.$W = r.getUTCDay(), this.$H = r.getUTCHours(), this.$m = r.getUTCMinutes(), this.$s = r.getUTCSeconds(), this.$ms = r.getUTCMilliseconds();
        } else
          b.call(this);
      };
      var a = e.utcOffset;
      e.utcOffset = function(r, h) {
        var x = this.$utils().u;
        if (x(r))
          return this.$u ? 0 : x(this.$offset) ? a.call(this) : this.$offset;
        if (typeof r == "string" && (r = function(X) {
          X === void 0 && (X = "");
          var W = X.match(A);
          if (!W)
            return null;
          var N = ("" + W[0]).match(c) || ["-", 0, 0], m = N[0], p = 60 * +N[1] + +N[2];
          return p === 0 ? 0 : m === "+" ? p : -p;
        }(r), r === null))
          return this;
        var u = Math.abs(r) <= 16 ? 60 * r : r, G = this;
        if (h)
          return G.$offset = u, G.$u = r === 0, G;
        if (r !== 0) {
          var V = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (G = this.local().add(u + V, C)).$offset = u, G.$x.$localOffset = V;
        } else
          G = this.utc();
        return G;
      };
      var s = e.format;
      e.format = function(r) {
        var h = r || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return s.call(this, h);
      }, e.valueOf = function() {
        var r = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * r;
      }, e.isUTC = function() {
        return !!this.$u;
      }, e.toISOString = function() {
        return this.toDate().toISOString();
      }, e.toString = function() {
        return this.toDate().toUTCString();
      };
      var d = e.toDate;
      e.toDate = function(r) {
        return r === "s" && this.$offset ? i(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : d.call(this);
      };
      var Z = e.diff;
      e.diff = function(r, h, x) {
        if (r && this.$u === r.$u)
          return Z.call(this, r, h, x);
        var u = this.local(), G = i(r).local();
        return Z.call(u, G, h, x);
      };
    };
  });
})(ml, ml.exports);
var p9 = ml.exports;
const R9 = /* @__PURE__ */ OI(p9);
var B9 = { [FC.ko]: "82", [FC.en]: "1", [FC.ja]: "81", [FC.vi]: "84" }, v9 = { ko: "ko-KR", en: "en-US", ja: "ja-JP", vi: "vi-VN" };
function Je() {
  let { i18n: g } = hg();
  return tg(() => {
    let I = g.language || dC;
    return { lang: I, locale: v9[I], countryCode: B9[I], isKo: I === dC };
  }, [g.language]);
}
AI.extend(N9);
AI.extend(R9);
AI.extend(y9);
AI.extend(h9);
AI.updateLocale("ko", { formats: { L: "YYYY. MM. DD.", LL: "YYYY년 MM월 DD일", LT: "A h:mm" } });
const J9 = "Paypal", Y9 = {
  "010부터 다시 입력해 주세요.": "Please re-enter starting with 010.",
  "2자 이상 입력": "Enter at least 2 characters",
  "2자 이상 입력해 주세요.": "Please enter at least 2 characters.",
  "3가지 질문을 통해": "Through 3 questions",
  "반가워요, {{name}}님": "Welcome, {{name}}!",
  Paypal: J9,
  "Paypal 링크": "Paypal Link",
  "YYYY년 MM월 DD일": "YYYY-MM-DD",
  "{{interests}} 인기 강의 둘러보기": "Browse popular {{interests}} courses",
  "{{label}} 입력": "Enter {{label}}",
  "{{name}}님을 위한 인기 강의 🔥": "Top courses for {{name}} 🔥",
  "{{runningHour}}시간_one": "{{runningHour}} hour",
  "{{runningHour}}시간_other": "{{runningHour}} hours",
  "{{runningMinute}}분_one": "{{runningMinute}} minute",
  "{{runningMinute}}분_other": "{{runningMinute}} minutes",
  "{{titleType}} 실명 확인": "{{titleType}} Real Name Verification",
  "{{titleType}}에는 실명이 꼭 필요해요!": "{{titleType}} requires your real name!",
  "감사합니다. 이제 {{realname}}님의 실명이 적힌 수료증을 확인할 수 있습니다.": "Thank you. You can now view the certificate with {{realname}}'s real name.",
  "강의 난이도": "Course Difficulty",
  "강의 난이도가 아쉬워요!": "The course difficulty was disappointing!",
  "강의 퀄리티": "Course Quality",
  "강의 퀄리티가 만족스럽지 않아요.": "The course quality is unsatisfactory.",
  "강의 폴더": "Lecture folder",
  "강의 폴더가 없어요": "No lecture folder exists.",
  "강의 폴더에 추가했어요.": "Added to lecture folder.",
  "강의 폴더에서 제거했어요.": "Removed from lecture folder.",
  "같은 문제가 계속 발생한다면 서비스에 문의해주세요.": "If the problem persists, please contact support.",
  개인: "Individual",
  "거의 다 왔어요! 배우고 싶은 기술을 선택해주세요 🎯": "Almost there! Please select the skills you want to learn 🎯",
  "견적서(국내송금)": "Quotation (Domestic Transfer)",
  "견적서(해외송금)": "Quotation (International Transfer)",
  계약자명: "Contractor Name",
  "계좌 인증에 실패했습니다. 고객센터에 문의해주세요.": "Account verification failed. Please contact customer support.",
  계좌번호: "Account Number",
  "계좌번호를 다시 확인해주세요. 오류가 지속되면 고객센터로 문의해주세요.": "Please double-check the account number. If the issue continues, contact support.",
  "고유번호가 부여된 단체는 입력이 불가합니다.": "Organizations with assigned unique IDs cannot be entered.",
  "관심 분야를 선택해주세요": "Please select your areas of interest",
  "관심있는 분야를 알려주세요.": "Please tell us your fields of interest.",
  교육시간: "Duration",
  나가기: "Close",
  "나만의 카테고리를 구성해보세요!": "Create your own category!",
  "나한테 딱 맞는걸 찾고 싶어요": "I want to find the perfect match for me",
  "내 강의 폴더로 이동": "Go to my lecture folder",
  "내 정산정보": "My Settlement Info",
  "내용을 입력해 주세요.": "Please enter the content.",
  다시입력: "Re-enter",
  "다운 가능한 이미지가 없습니다. 반복될 경우 고객센터에 문의해주세요.": "No downloadable image is available. If the problem persists, please contact customer service.",
  다음: "Next",
  "다음에 하기": "Skip for now",
  "다음에 할게요": "I'll do it later.",
  다음으로: "Next",
  "답해주신 내용을 바탕으로 인기 강의 또는 추가 답변으로 맞는 강의를 찾아보세요.": "Based on your responses, explore popular courses or find courses that match your additional answers.",
  "더 나은 강의를 위해 개선해야할 점을 작성해 주세요!": "Please write what needs to be improved for a better course!",
  "더 많은 강의 보기": "View More Courses",
  "더 이상 선택할 수 없어요.": "You can't select any more.",
  더보기: "More",
  등록하기: "Register",
  "로그인 하기": "Sign in",
  "링크 복사에 실패했습니다. 반복될 경우 고객센터에 문의해주세요.": "Failed to copy the link. If the problem persists, please contact customer service.",
  "링크가 복사되었습니다": "Link has been copied.",
  "링크드인 수료증 추가": "Add certificate to LinkedIn",
  "마음에 드는 강의를 클릭해보세요": "Click on a course you like",
  "마카테모달.접근.설명": "If you select <strong>categories</strong> you're interested in, you can gather only the courses you want!",
  "마카테모달.접근.제목": "Create your own category!",
  "마카테모달.최초접근.설명": "Let us know what <strong>topics</strong> you're interested in,<br/>and we'll help you find the perfect courses quickly!",
  "마카테모달.최초접근.제목": "Welcome to Inflearn, {{userName}}!",
  "모달 닫기": "Close modal",
  "문제가 발생했습니다. 잠시 후 다시 시도해 주세요.": "An error occurred. Please try again later.",
  보러가기: "View",
  사업자: "Business",
  "사업자 상태 인증에 실패했습니다. 고객센터에 문의해주세요.": "Failed to verify business status. Please contact customer support.",
  사업자등록번호: "Business Registration Number",
  "사업자를 찾을 수 없습니다.": "Business not found.",
  사업체명: "Business Name",
  "사운드 문제": "Sound Issue",
  "사운드에 문제가 있어요.": "There is a problem with the sound.",
  "새 강의 폴더를 만들어보세요": "Try creating a new lecture folder.",
  "새 폴더": "New folder",
  "새 폴더 만들기": "Create new folder",
  "새 폴더 이름 입력": "Enter new folder name",
  "새 폴더 입력창 닫기": "Close new folder input window",
  "새 폴더 제출": "Submit new folder",
  "새 폴더를 만들었어요.": "New folder created.",
  "서비스 언어를 선택하세요.": "Select the service language.",
  "선택 완료": "Complete Selection",
  "선택한 내용을 바탕으로 다음 행동을 골라주세요": "Please choose your next action based on your selections",
  "선택한 분야의 세부 기술이에요": "These are the detailed skills for your selected fields",
  "선택한 카테고리": "Selected Category",
  "선택한 카테고리는 강의 검색 페이지 MY 카테고리에 등록됩니다. 😉": "The category you selected will be added to 'My Category' on the course search page. 😉",
  "선택해주신 내용을 바탕으로 인기 강의를 모아봤어요! ✨": "We've gathered popular courses based on your selections! ✨",
  "세션 만료": "Session expired",
  "수강 확인증": "Certificate of Completion",
  "수강평 수정에 문제가 생겼어요.": "There was an issue with editing the review.",
  "수강평 작성에 문제가 생겼어요.": "There was an issue with submitting the review.",
  "수강평을 작성해보세요!": "Write a review!",
  수료일: "Completion Date",
  수료증: "Certificate",
  "수료증 pdf 다운로드": "Download certificate PDF",
  "수료증 링크 복사": "Copy certificate link",
  "수료증 정보를 가져오는데 실패했습니다.": "Failed to retrieve certificate information.",
  수정: "Edit",
  수정하기: "Edit",
  "숫자만 입력 가능합니다.": "Only numbers are allowed.",
  시작일: "Start Date",
  "실명 인증 모달 닫기": "Close real name verification modal",
  "실명 입력": "Enter full name",
  "실명 입력 실패": "Failed to enter real name",
  "실명 입력 완료": "Real name input completed",
  "실명:": "Real name:",
  "실사용자 검증을 위해 휴대폰 인증을 진행해 주세요.": "Please verify your phone number for real user validation.",
  "아쉬웠던 점을 1개 이상 선택해 주시면,": "Please select at least one area for improvement,",
  "아직 잘 모르겠다": "Not sure yet",
  "안녕하세요 {{name}}님": "Hello, {{name}}",
  "알 수 없는 오류가 발생했습니다.": "An unknown error occurred.",
  "어떻게 시작하면 좋을지 골라주세요.": "Choose how you'd like to start.",
  "언어 설정": "Language Settings",
  "예금주명이 일치하지 않습니다.": "Account holder name does not match.",
  "올바른 정산 유형을 선택해주세요.": "Please select a valid settlement type.",
  "외화 계좌는 입력이 불가합니다.": "Foreign currency accounts cannot be used.",
  "위의 교육과정을 성공적으로 수료하였음을 인정하여 이 인증서를 수여합니다.": "This certifies the successful completion of the above course.",
  유형: "Type",
  "유효한 사업자등록번호를 입력해야합니다.": "You must enter a valid business registration number.",
  "유효한 주민등록번호를 입력해야합니다.": "You must enter a valid resident registration number.",
  은행: "Bank",
  "은행을 선택해 주세요.": "Please select a bank.",
  "의견을 반영해 더 좋은 강의를 만들게요.": "and we will use your feedback to create better courses.",
  이름: "Name",
  "이름 (실명)": "Name (Real name)",
  "이름을 입력해 주세요.": "Enter your full name.",
  "이미 인증된 요청입니다.": "This request has already beenauthenticated.",
  "이미 저장된 실명이 있거나 오류가 발생했습니다.": "A real name is already saved or an error has occurred.",
  "인기 강의 둘러보기": "Browse Popular Courses",
  인증: "Verify",
  "인증 요청": "Send code",
  인증번호: "Verification code",
  "인증번호 요청 중 오류가 발생했습니다.": "An error occurredduring verification code request.",
  "인증번호 유효시간이 초과되었습니다.": "The verificationcode has expired.",
  "인증번호가 일치하지 않습니다.": "The verification codedoes not match.",
  "인증번호가 카카오톡 또는 문자로 전송되었습니다.": "Theverification code has been sent via KakaoTalk or textmessage.",
  "인증번호를 못 받으셨나요? 스팸차단 확인 방법": "Didn'treceive the verification code? Check spam filters.",
  인프랩: "InfLab",
  인프런: "Inflearn",
  "인프런 [문의하기]를 이용해 주세요.": "Please use Inflearn's [Contact Us].",
  "인프런 대표": "Inflearn CEO",
  "인프런에 어떤 목적으로 오셨나요?": "What brings you to Inflearn?",
  "일일 인증 횟수를 초과했습니다. 고객센터 문의 부탁드립니다.": "You have exceeded the daily authenticationlimit. Please contact customer support.",
  "입력 정보가 유효하지 않습니다.": "The entered information is invalid.",
  "입력된 실명은 수정이 불가하니 한번 더 확인해 주세요!": "The entered real name cannot be modified, so please double-check!",
  "자동 로그아웃 되었습니다. 다시 로그인해주세요.": "You have been automatically signed out. Please sign in again.",
  "자료 부족": "Lack of Materials",
  "자료가 부족해요!": "There aren't enough materials!",
  "잘 맞는 인기 강의를 추천해드릴게요": "We'll recommend popular courses that are perfect for you",
  "잘 모르겠어요": "Not sure yet",
  "잠시 후 다시 시도해주세요.": "Please try again later.",
  재전송: "Resend",
  "재전송은 최대 10회입니다. 10분 후 재시도해 주세요.": "The retransmission is up to 10 times. Please try again in 10minutes.",
  "저장에 실패했습니다. 잠시 후 다시 시도해주세요.": "Failed to save. Please try again later.",
  저장하기: "Save",
  전체: "All",
  "정산 정보 수정 완료": "Settlement Info Updated",
  "정산 확정 시 수정된 정보는 익월에 반영됩니다.": "Changes will take effect the following month after settlement confirmation.",
  "정산받으실 분의 성명 또는 사업체명을 입력": "Enter the name or business name of the recipient",
  "정산자 유형": "Settlement Type",
  정산자명: "Payee Name",
  "정산자명 (예금주명)": "Payee Name (Account Holder)",
  "정산정보 등록": "Register Settlement Info",
  "정산정보 수정": "Edit Settlement Info",
  "정산정보는 모든 강의에 동일하게 적용되며, 정산은 익월 10 영업일에 확정됩니다.": "Settlement info applies to all courses and will be finalized within 10 business days of the following month.",
  "정지된 계좌입니다.": "This account is suspended.",
  제출: "Submit",
  제출완료: "Confirm",
  "존재하지 않는 계좌입니다.": "This account does not exist.",
  "좋아요! 어떤 분야에 관심이 있으세요?": "Great! What fields are you interested in?",
  주민등록번호: "Resident Registration Number",
  "준비끝! 관심사를 파악했어요~": "All set! We've identified your interests~",
  "중복 선택 가능": "Multiple selections allowed",
  "지식공유에 관심이 있으시군요!": "You're interested in knowledge sharing!",
  지식공유자: "Instructor",
  "지식공유자 신청하러 가기": "Apply to Become an Instructor",
  지출증빙유형: "Expense Proof Type",
  "직접 둘러볼게요": "I'll browse on my own",
  "직접 입력하기": "Enter manually",
  "질문 답변 소통": "Q&A Communication",
  "질문 답변 소통이 원활하지 않아요.": "The Q&A communication is not smooth.",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "An error occurred during processing. Please try again later.",
  "처리중 오류가 발생했습니다. 잠시후 다시 시도해 주세요.": "An error occurred during processing. Please try again later.",
  "최대 {{count}}개까지 선택할 수 있습니다.": "You can select up to {{count}} items.",
  "추천 강의가 없습니다.": "No recommended courses.",
  "추후 수정이 불가하니 실수없이 입력해 주세요.": "Cannot be modified later, so please enter carefully.",
  취소: "Cancel",
  "폐업 상태인 사업자입니다.": "This business is closed.",
  "폴더명 입력": "Enter folder name",
  "학습 목적을 입력해주세요": "Please enter your learning purpose",
  "해외 거주자": "Overseas Resident",
  "홈으로 가기": "Go to Home",
  "화질 문제": "Video Quality Issue",
  "화질이 안 좋아요.": "The video quality is poor.",
  확인: "OK",
  "휴대폰 번호": "Mobile",
  "휴대폰 번호 인증": "Phone number verification",
  "휴대폰 번호 placeholder": "Numbers only, no dashes",
  인증완료: "Verified",
  "휴대폰 번호 입력": "Enter phone number",
  "휴대폰 번호 형식이 올바르지 않습니다.": "Invalid mobilephone number format.",
  "휴대폰 번호를 입력해 주세요.": "Please enter your phonenumber.",
  "휴대폰인증모달.인증안내": "<Span>Verification isperformed</Span> <Green>once.</Green>",
  "휴업 상태인 사업자입니다.": "This business is temporarily closed.",
  "힘이 되는 수강평을 남겨주세요!": "Leave an encouraging review!",
  "AI가 답변을 생성하고 있어요...": "AI is generating a response...",
  "추천 이유": "Recommendation reason",
  "추천 강의 {{count}}개": "{{count}} recommended courses",
  "메시지 입력... (질문권 {{count}}개)": "Type a message... ({{count}} questions left)",
  "질문 {{count}}개를 모두 사용했어요": "All {{count}} questions have been used",
  "이전 단계": "Previous step",
  "관심분야 인기강의 다시보기": "View popular courses in your interests again",
  "안녕하세요! 궁금한 점이 있으면 편하게 질문해주세요!": "Hello! Feel free to ask any questions!",
  "{{selections}} 에 관심이 있으시군요!\n혹시 실무에서 바로 쓰고 싶은 건지 기초부터 배우고 싶은 건지 알려주시면 더 정확하게 추천해드릴게요": `You're interested in {{selections}}!
Let us know if you want practical skills or basics, and we'll recommend more accurately`,
  "죄송합니다. 오류가 발생했어요. 다시 시도해주세요.": "Sorry, an error occurred. Please try again.",
  "대화 분석 및 사용자 선호도 추출": "Analyzing conversation and extracting preferences",
  "선호도에 맞는 강의 검색": "Searching courses matching preferences",
  "검색된 강의 상세 정보 조회": "Fetching course details",
  "추가 정보 필요 시 사용자에게 질문": "Asking user for more information",
  "최종 강의 추천 생성": "Generating final recommendations",
  "llm-empty-state.summary-title": "Here's what you've selected so far",
  "llm-empty-state.label-goal": "Goal",
  "llm-empty-state.label-interest": "Field of interest",
  "llm-empty-state.label-skill": "Skill",
  "llm-empty-state.prompt-hint": "Let us know if you have any other preferences!",
  "llm-empty-state.suggestion-1": "What should I learn first to switch careers as an AI engineer?",
  "llm-empty-state.suggestion-2": "Are there courses on RAG and LangChain I can apply to work right away?",
  "llm-empty-state.suggestion-3": "Recommend a project course where I can build a portfolio using AI",
  "llm-empty-state.suggestion-4": "Are there courses to learn LLM step by step from the basics?",
  "llm-empty-state.suggestion-5": "What skills are most in demand in the AI job market these days?",
  "llm-empty-state.input-placeholder": "You can ask up to {{count}} questions",
  "llm-chat.scroll-to-bottom": "Scroll to bottom",
  "llm-leave-confirm.title": "Wait!",
  "llm-leave-confirm.description": `We're preparing your answer.
If you leave now, you won't receive the response being generated.`,
  "llm-leave-confirm.cancel": "I'll wait",
  "llm-leave-confirm.confirm": "Leave anyway",
  "llm-survey.thanks-title": "Thanks for your feedback!",
  "llm-survey.thanks-description": "We'll use it to improve our recommendations",
  "link-coupon.title": "Get Coupon",
  "link-coupon.image-alt": "Discount coupon image",
  "link-coupon.description-1": "Inflearn supports your learning.",
  "link-coupon.description-2": "Use <strong>within {{remaining}}</strong> to enjoy this special benefit.",
  "link-coupon.remaining-days": "{{days}}d",
  "link-coupon.remaining-hours": "{{hours}}h",
  "link-coupon.remaining-minutes": "{{minutes}}m",
  "link-coupon.button-decline": "Not now",
  "link-coupon.button-receive": "Get Coupon",
  "link-coupon-error.view-my-coupons": "View my coupons",
  "link-coupon-error.inactive-title": "Deactivated coupon",
  "link-coupon-error.inactive-body": "This coupon cannot be used.",
  "link-coupon-error.limit-exceeded-title": "Coupon limit exceeded",
  "link-coupon-error.limit-exceeded-body": "The usage limit for this coupon has been exceeded.",
  "link-coupon-error.period-expired-title": "Coupon registration expired",
  "link-coupon-error.period-expired-body": "This coupon has expired and cannot be registered.",
  "link-coupon-error.register-disabled-title": "Cannot register coupon",
  "link-coupon-error.already-issued-body": "This coupon has already been registered.",
  "link-coupon-error.already-used-title": "Already used coupon",
  "link-coupon-error.already-used-body": "This coupon has already been used.",
  "link-coupon-error.voucher-exist-body": "Coupons cannot be issued for courses you are already taking. Please check the “My Learning” page!",
  "link-coupon-error.disallowed-country-title": "Coupon unavailable",
  "link-coupon-error.disallowed-country-body": "This coupon cannot be used in this country.",
  "link-coupon-error.generic-title": "Failed to look up or register coupon",
  "link-coupon-error.generic-body": `Failed to look up or register the coupon.
Please try again later.`
}, F9 = "Paypal", z9 = {
  "010부터 다시 입력해 주세요.": "010から再入力してください。",
  "2자 이상 입력": "2文字以上入力",
  "2자 이상 입력해 주세요.": "2文字以上入力してください。",
  "3가지 질문을 통해": "3つの質問を通じて",
  "반가워요, {{name}}님": "ようこそ、{{name}}様！",
  Paypal: F9,
  "Paypal 링크": "Paypalリンク",
  "YYYY년 MM월 DD일": "YYYY年MM月DD日",
  "{{interests}} 인기 강의 둘러보기": "{{interests}}の人気講座を見る",
  "{{label}} 입력": "{{label}} を入力",
  "{{name}}님을 위한 인기 강의 🔥": "{{name}}さんへのおすすめ講座",
  "{{runningHour}}시간": "{{runningHour}}時間",
  "{{runningHour}}시간_one": "{{runningHour}}時間",
  "{{runningHour}}시간_other": "{{runningHour}}時間",
  "{{runningMinute}}분": "{{runningMinute}}分",
  "{{runningMinute}}분_one": "{{runningMinute}}分",
  "{{runningMinute}}분_other": "{{runningMinute}}分",
  "{{titleType}} 실명 확인": "{{titleType}} 実名確認",
  "{{titleType}}에는 실명이 꼭 필요해요!": "{{titleType}}には実名が必要です！",
  "감사합니다. 이제 {{realname}}님의 실명이 적힌 수료증을 확인할 수 있습니다.": "ありがとうございます。これで{{realname}}様の実名が記載された修了証を確認できます。",
  "강의 난이도": "講義の難易度",
  "강의 난이도가 아쉬워요!": "講義の難易度が物足りないです！",
  "강의 퀄리티": "講義のクオリティ",
  "강의 퀄리티가 만족스럽지 않아요.": "講義のクオリティが満足できません。",
  "강의 폴더": "講義フォルダ",
  "강의 폴더가 없어요": "講義フォルダがありません",
  "강의 폴더에 추가했어요.": "講義フォルダに追加しました。",
  "강의 폴더에서 제거했어요.": "講義フォルダから削除しました。",
  "같은 문제가 계속 발생한다면 서비스에 문의해주세요.": "同じ問題が続けて発生する場合は、サービスにお問い合わせください。",
  개인: "個人",
  "거의 다 왔어요! 배우고 싶은 기술을 선택해주세요 🎯": "もう少しです！学びたい技術を選択してください 🎯",
  "견적서(국내송금)": "見積書（国内送金）",
  "견적서(해외송금)": "見積書（海外送金）",
  계약자명: "契約者名",
  "계좌 인증에 실패했습니다. 고객센터에 문의해주세요.": "口座の認証に失敗しました。カスタマーサポートにお問い合わせください。",
  계좌번호: "口座番号",
  "계좌번호를 다시 확인해주세요. 오류가 지속되면 고객센터로 문의해주세요.": "口座番号を再確認してください。エラーが続く場合は、サポートまでご連絡ください。",
  "고유번호가 부여된 단체는 입력이 불가합니다.": "固有番号が付与された団体は入力できません。",
  "관심 분야를 선택해주세요": "興味のある分野を選択してください",
  "관심있는 분야를 알려주세요.": "興味のある分野を教えてください。",
  교육시간: "教育時間",
  나가기: "閉じる",
  "나만의 카테고리를 구성해보세요!": "自分だけのカテゴリを構成してみてください！",
  "나한테 딱 맞는걸 찾고 싶어요": "自分にぴったりのものを見つけたい",
  "내 강의 폴더로 이동": "自分の講義フォルダに移動",
  "내 정산정보": "自分の精算情報",
  "내용을 입력해 주세요.": "内容を入力してください。",
  다시입력: "再入力",
  "다운 가능한 이미지가 없습니다. 반복될 경우 고객센터에 문의해주세요.": "ダウンロード可能な画像がありません。繰り返し発生する場合はカスタマーセンターにお問い合わせください。",
  다음: "次へ",
  "다음에 하기": "後で",
  "다음에 할게요": "次にします",
  다음으로: "次へ",
  "답해주신 내용을 바탕으로 인기 강의 또는 추가 답변으로 맞는 강의를 찾아보세요.": "ご回答いただいた内容をもとに、人気講座や追加の回答に合う講座を探してみてください。",
  "더 나은 강의를 위해 개선해야할 점을 작성해 주세요!": "より良い講義のために改善すべき点を書いてください！",
  "더 많은 강의 보기": "もっと多くの講座を見る",
  "더 이상 선택할 수 없어요.": "これ以上選択できません。",
  더보기: "もっと見る",
  등록하기: "登録する",
  "로그인 하기": "ログインする",
  "링크 복사에 실패했습니다. 반복될 경우 고객센터에 문의해주세요.": "リンクのコピーに失敗しました。繰り返し発生する場合はカスタマーセンターにお問い合わせください。",
  "링크가 복사되었습니다": "リンクがコピーされました",
  "링크드인 수료증 추가": "LinkedIn修了証を追加",
  "마음에 드는 강의를 클릭해보세요": "お気に入りの講座をクリックしてください",
  "마카테모달.접근.설명": "<strong>興味のあるカテゴリ</strong>を選択すると、自分が欲しい講義だけをまとめて見ることができます！",
  "마카테모달.접근.제목": "自分だけのカテゴリを作りましょう！",
  "마카테모달.최초접근.설명": "<strong>興味のあるテーマ</strong>を教えていただければ、</br>あなたにぴったりの講義をすぐに見つけることができます！",
  "마카테모달.최초접근.제목": "{{userName}}さん、<br/>インフランへようこそ！",
  "모달 닫기": "モーダルを閉じる",
  "문제가 발생했습니다. 잠시 후 다시 시도해 주세요.": "問題が発生しました。しばらくしてからもう一度お試しください。",
  보러가기: "見に行く",
  사업자: "事業者",
  "사업자 상태 인증에 실패했습니다. 고객센터에 문의해주세요.": "事業者の状態認証に失敗しました。カスタマーサポートにお問い合わせください。",
  사업자등록번호: "事業者登録番号",
  "사업자를 찾을 수 없습니다.": "事業者が見つかりません。",
  사업체명: "事業所名",
  "사운드 문제": "サウンド問題",
  "사운드에 문제가 있어요.": "サウンドに問題があります。",
  "새 강의 폴더를 만들어보세요": "新しい講義フォルダを作ってみてください",
  "새 폴더": "新しいフォルダ",
  "새 폴더 만들기": "新しいフォルダを作る",
  "새 폴더 이름 입력": "新しいフォルダ名を入力",
  "새 폴더 입력창 닫기": "新しいフォルダ入力欄を閉じる",
  "새 폴더 제출": "新しいフォルダの提出",
  "새 폴더를 만들었어요.": "新しいフォルダを作りました。",
  "서비스 언어를 선택하세요.": "サービス言語を選択してください。",
  "선택 완료": "選択完了",
  "선택한 내용을 바탕으로 다음 행동을 골라주세요": "選択内容に基づいて次の行動を選んでください",
  "선택한 분야의 세부 기술이에요": "選択した分野の詳細な技術です",
  "선택한 카테고리": "選択したカテゴリ",
  "선택한 카테고리는 강의 검색 페이지 MY 카테고리에 등록됩니다. 😉": "選択したカテゴリは講義検索ページの私のカテゴリに登録されます。😉",
  "선택해주신 내용을 바탕으로 인기 강의를 모아봤어요! ✨": "選択いただいた内容に基づいて人気講座を集めました！✨",
  "세션 만료": "セッションが期限切れです",
  "수강 확인증": "受講確認証",
  "수강평 수정에 문제가 생겼어요.": "受講評価の修正に問題が発生しました。",
  "수강평 작성에 문제가 생겼어요.": "受講評価の作成に問題が発生しました。",
  "수강평을 작성해보세요!": "受講評価を書いてみてください！",
  수료일: "修了日",
  수료증: "修了証",
  "수료증 pdf 다운로드": "修了証PDFダウンロード",
  "수료증 링크 복사": "修了証リンクをコピー",
  "수료증 정보를 가져오는데 실패했습니다.": "修了証の情報を取得できませんでした。",
  수정: "修正",
  수정하기: "修正する",
  "숫자만 입력 가능합니다.": "数字のみ入力可能です。",
  시작일: "開始日",
  "실명 인증 모달 닫기": "実名認証モーダルを閉じる",
  "실명 입력": "実名入力",
  "실명 입력 실패": "実名入力失敗",
  "실명 입력 완료": "実名入力完了",
  "실명:": "実名:",
  "실사용자 검증을 위해 휴대폰 인증을 진행해 주세요.": "実際の利用者確認のため、携帯電話認証を行ってください。",
  "아쉬웠던 점을 1개 이상 선택해 주시면,": "残念だった点を1つ以上選択してください、",
  "아직 잘 모르겠다": "よくわかりません",
  "안녕하세요 {{name}}님": "こんにちは、{{name}}さん",
  "알 수 없는 오류가 발생했습니다.": "不明なエラーが発生しました。",
  "어떻게 시작하면 좋을지 골라주세요.": "どのように始めるか選んでください。",
  "언어 설정": "言語設定",
  "예금주명이 일치하지 않습니다.": "口座名義が一致しません。",
  "올바른 정산 유형을 선택해주세요.": "正しい精算タイプを選択してください。",
  "외화 계좌는 입력이 불가합니다.": "外貨口座は使用できません。",
  "위의 교육과정을 성공적으로 수료하였음을 인정하여 이 인증서를 수여합니다.": "この者は上記の課程を修了したことを認め、ここに証明いたします。",
  유형: "タイプ",
  "유효한 사업자등록번호를 입력해야합니다.": "有効な事業者登録番号を入力してください。",
  "유효한 주민등록번호를 입력해야합니다.": "有効な住民登録番号を入力してください。",
  은행: "銀行",
  "은행을 선택해 주세요.": "銀行を選択してください。",
  "의견을 반영해 더 좋은 강의를 만들게요.": "ご意見を反映してより良い講義を提供します。",
  이름: "名前",
  "이름 (실명)": "名前（実名）",
  "이름을 입력해 주세요.": "お名前を入力してください。",
  "이미 인증된 요청입니다.": "すでに認証されたリクエストです。",
  "이미 저장된 실명이 있거나 오류가 발생했습니다.": "すでに保存された実名があるかエラーが発生しました。",
  "인기 강의 둘러보기": "人気講座を見る",
  인증: "認証",
  "인증 요청": "認証リクエスト",
  인증번호: "認証番号",
  "인증번호 요청 중 오류가 발생했습니다.": "認証番号のリクエスト中にエラーが発生しました。",
  "인증번호 유효시간이 초과되었습니다.": "認証番号の有効時間が切れました。",
  "인증번호가 일치하지 않습니다.": "認証番号が一致しません。",
  "인증번호가 카카오톡 또는 문자로 전송되었습니다.": "認証番号がカカオトークまたはSMSで送信されました。",
  "인증번호를 못 받으셨나요? 스팸차단 확인 방법": "認証番号を受け取れませんか？ スパム防止設定の確認方法",
  인프랩: "インフラップ",
  인프런: "インフラン",
  "인프런 [문의하기]를 이용해 주세요.": "インフラン [お問い合わせ]をご利用ください。",
  "인프런 대표": "インフラン代表",
  "인프런에 어떤 목적으로 오셨나요?": "Inflearnにどのような目的でお越しですか？",
  "일일 인증 횟수를 초과했습니다. 고객센터 문의 부탁드립니다.": "1日の認証回数を超えました。カスタマーサポートにお問い合わせください。",
  "입력 정보가 유효하지 않습니다.": "入力された情報が無効です。",
  "입력된 실명은 수정이 불가하니 한번 더 확인해 주세요!": "入力された実名は修正できませんので、もう一度確認してください！",
  "자동 로그아웃 되었습니다. 다시 로그인해주세요.": "自動ログアウトされました。再度ログインしてください。",
  "자료 부족": "資料不足",
  "자료가 부족해요!": "資料が不足しています！",
  "잘 맞는 인기 강의를 추천해드릴게요": "ぴったりの人気講座をおすすめします",
  "잘 모르겠어요": "まだよくわからない",
  "잠시 후 다시 시도해주세요.": "しばらくしてからもう一度お試しください。",
  재전송: "再送",
  "재전송은 최대 10회입니다. 10분 후 재시도해 주세요.": "再送は最大10回です。10分後に再度お試しください。",
  "저장에 실패했습니다. 잠시 후 다시 시도해주세요.": "保存に失敗しました。しばらくしてからもう一度お試しください。",
  저장하기: "保存する",
  전체: "全体",
  "정산 정보 수정 완료": "精算情報の修正が完了しました",
  "정산 확정 시 수정된 정보는 익월에 반영됩니다.": "精算確定後、修正された情報は翌月に反映されます。",
  "정산받으실 분의 성명 또는 사업체명을 입력": "精算を受け取る方の氏名または事業所名を入力してください",
  "정산자 유형": "精算者タイプ",
  정산자명: "精算者名",
  "정산자명 (예금주명)": "精算者名（口座名義）",
  "정산정보 등록": "精算情報を登録",
  "정산정보 수정": "精算情報を修正",
  "정산정보는 모든 강의에 동일하게 적용되며, 정산은 익월 10 영업일에 확정됩니다.": "精算情報はすべての講座に共通で適用され、精算は翌月10営業日以内に確定されます。",
  "정지된 계좌입니다.": "停止された口座です。",
  제출: "提出",
  제출완료: "提出完了",
  "존재하지 않는 계좌입니다.": "存在しない口座です。",
  "좋아요! 어떤 분야에 관심이 있으세요?": "いいですね！どの分野に興味がありますか？",
  주민등록번호: "住民登録番号",
  "준비끝! 관심사를 파악했어요~": "準備完了！興味を把握しました〜",
  "중복 선택 가능": "複数選択可能",
  "지식공유에 관심이 있으시군요!": "知識共有に関心がおありですね！",
  지식공유자: "知識共有者",
  "지식공유자 신청하러 가기": "知識共有者に申し込む",
  지출증빙유형: "支出証憑の種類",
  "직접 둘러볼게요": "自分で見てみます",
  "직접 입력하기": "直接入力する",
  "질문 답변 소통": "質問応答コミュニケーション",
  "질문 답변 소통이 원활하지 않아요.": "質問応答のコミュニケーションが円滑ではありません。",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "処理中にエラーが発生しました。しばらくしてから再試行してください。",
  "처리중 오류가 발생했습니다. 잠시후 다시 시도해 주세요.": "処理中にエラーが発生しました。少し時間をおいてから再試行してください。",
  "최대 {{count}}개까지 선택할 수 있습니다.": "最大{{count}}個まで選択できます。",
  "추천 강의가 없습니다.": "おすすめの講座がありません。",
  "추후 수정이 불가하니 실수없이 입력해 주세요.": "後で修正できませんので、ミスなく入力してください。",
  취소: "キャンセル",
  "폐업 상태인 사업자입니다.": "廃業状態の事業者です。",
  "폴더명 입력": "フォルダ名入力",
  "학습 목적을 입력해주세요": "学習目的を入力してください",
  "해외 거주자": "海外居住者",
  "홈으로 가기": "ホームに移動",
  "화질 문제": "画質問題",
  "화질이 안 좋아요.": "画質が良くありません。",
  확인: "確認",
  "휴대폰 번호": "携帯電話番号",
  "휴대폰 번호 인증": "携帯電話番号認証",
  "휴대폰 번호 placeholder": "ハイフンなしで数字のみ入力",
  인증완료: "認証完了",
  "휴대폰 번호 입력": "携帯電話番号入力",
  "휴대폰 번호 형식이 올바르지 않습니다.": "携帯電話番号の形式が正しくありません。",
  "휴대폰 번호를 입력해 주세요.": "携帯電話番号を入力してください。",
  "휴대폰인증모달.인증안내": "<Span>認証は</Span> <Green>最初の1回</Green><Span>だけ実施されます。</Span>",
  "휴업 상태인 사업자입니다.": "休業状態の事業者です。",
  "힘이 되는 수강평을 남겨주세요!": "励みになる受講評価を残してください！",
  "AI가 답변을 생성하고 있어요...": "AIが回答を生成しています...",
  "추천 이유": "おすすめの理由",
  "추천 강의 {{count}}개": "おすすめ講座 {{count}}件",
  "메시지 입력... (질문권 {{count}}개)": "メッセージを入力... (質問権 {{count}}個)",
  "질문 {{count}}개를 모두 사용했어요": "質問{{count}}個をすべて使い切りました",
  "이전 단계": "前のステップ",
  "관심분야 인기강의 다시보기": "関心分野の人気講座をもう一度見る",
  "안녕하세요! 궁금한 점이 있으면 편하게 질문해주세요!": "こんにちは！気になることがあればお気軽にご質問ください！",
  "{{selections}} 에 관심이 있으시군요!\n혹시 실무에서 바로 쓰고 싶은 건지 기초부터 배우고 싶은 건지 알려주시면 더 정확하게 추천해드릴게요": `{{selections}} に関心がおありですね！
実務ですぐ使いたいのか基礎から学びたいのか教えていただければ、より正確におすすめできます`,
  "죄송합니다. 오류가 발생했어요. 다시 시도해주세요.": "申し訳ありません。エラーが発生しました。もう一度お試しください。",
  "대화 분석 및 사용자 선호도 추출": "会話分析とユーザーの好み抽出",
  "선호도에 맞는 강의 검색": "好みに合った講座を検索",
  "검색된 강의 상세 정보 조회": "検索された講座の詳細情報を取得",
  "추가 정보 필요 시 사용자에게 질문": "追加情報が必要な場合ユーザーに質問",
  "최종 강의 추천 생성": "最終講座おすすめを生成",
  "AI에게 강의 추천 받기": "AIに講座をおすすめしてもらう",
  "llm-empty-state.summary-title": "これまでに選択された内容です",
  "llm-empty-state.label-goal": "目標",
  "llm-empty-state.label-interest": "関心分野",
  "llm-empty-state.label-skill": "スキル",
  "llm-empty-state.prompt-hint": "ほかに希望する条件があればお知らせください！",
  "llm-empty-state.suggestion-1": "AIエンジニアに転職するには何から学べばいいですか？",
  "llm-empty-state.suggestion-2": "RAGとLangChainを実務ですぐ使える講座はありますか？",
  "llm-empty-state.suggestion-3": "AIを活用してポートフォリオを作れるプロジェクト講座を推薦して",
  "llm-empty-state.suggestion-4": "LLMを基礎からステップアップで学べる講座はありますか？",
  "llm-empty-state.suggestion-5": "最近のAI採用市場で最も求められているスキルは何ですか？",
  "llm-empty-state.input-placeholder": "最大{{count}}回まで質問できます",
  "llm-chat.scroll-to-bottom": "一番下へ",
  "llm-leave-confirm.title": "ちょっと待って！",
  "llm-leave-confirm.description": `回答を準備しています。
今離れると、生成中の回答を受け取れなくなります。`,
  "llm-leave-confirm.cancel": "待ちます",
  "llm-leave-confirm.confirm": "それでも離れる",
  "llm-survey.thanks-title": "ご意見ありがとうございます！",
  "llm-survey.thanks-description": "より良いおすすめに反映します",
  "link-coupon.title": "クーポンを受け取る",
  "link-coupon.image-alt": "割引クーポンの画像",
  "link-coupon.description-1": "インフランがあなたの学びを応援します。",
  "link-coupon.description-2": "<strong>{{remaining}}以内に</strong>特別な特典をご利用ください。",
  "link-coupon.remaining-days": "{{days}}日",
  "link-coupon.remaining-hours": "{{hours}}時間",
  "link-coupon.remaining-minutes": "{{minutes}}分",
  "link-coupon.button-decline": "受け取らない",
  "link-coupon.button-receive": "クーポンを受け取る",
  "link-coupon-error.view-my-coupons": "マイクーポンを見る",
  "link-coupon-error.inactive-title": "無効化されたクーポン",
  "link-coupon-error.inactive-body": "使用できないクーポンです。",
  "link-coupon-error.limit-exceeded-title": "クーポンの上限超過",
  "link-coupon-error.limit-exceeded-body": "このクーポンの使用可能数量を超えました。",
  "link-coupon-error.period-expired-title": "クーポン登録期限切れ",
  "link-coupon-error.period-expired-body": "使用期限が過ぎたため、クーポンを登録できません。",
  "link-coupon-error.register-disabled-title": "クーポン登録不可",
  "link-coupon-error.already-issued-body": "すでに登録されているクーポンです。",
  "link-coupon-error.already-used-title": "使用済みのクーポン",
  "link-coupon-error.already-used-body": "すでに使用されたクーポンです。",
  "link-coupon-error.voucher-exist-body": "すでに受講中の講座にはクーポンを発行できません。「マイ学習」ページを確認してください。",
  "link-coupon-error.disallowed-country-title": "クーポン利用不可",
  "link-coupon-error.disallowed-country-body": "このクーポンは該当の国では使用できません。",
  "link-coupon-error.generic-title": "クーポンの照会または登録に失敗",
  "link-coupon-error.generic-body": `クーポンの照会または登録に失敗しました。
しばらくしてからもう一度お試しください。`
}, f9 = "Paypal", H9 = {
  "010부터 다시 입력해 주세요.": "010부터 다시 입력해주세요.",
  "2자 이상 입력": "2자 이상 입력",
  "2자 이상 입력해 주세요.": "2자 이상 입력해 주세요.",
  "3가지 질문을 통해": "3가지 질문을 통해",
  "반가워요, {{name}}님": "반가워요, {{name}}님",
  Paypal: f9,
  "Paypal 링크": "Paypal 링크",
  "YYYY년 MM월 DD일": "YYYY년 MM월 DD일",
  "{{interests}} 인기 강의 둘러보기": "{{interests}} 인기 강의 둘러보기",
  "{{label}} 입력": "{{label}} 입력",
  "{{name}}님을 위한 인기 강의 🔥": "{{name}}님을 위한 인기 강의 🔥",
  "{{runningHour}}시간": "{{runningHour}}시간",
  "{{runningHour}}시간_one": "{{runningHour}}시간",
  "{{runningHour}}시간_other": "{{runningHour}}시간",
  "{{runningMinute}}분": "{{runningMinute}}분",
  "{{runningMinute}}분_one": "{{runningMinute}}분",
  "{{runningMinute}}분_other": "{{runningMinute}}분",
  "{{titleType}} 실명 확인": "{{titleType}} 실명 확인",
  "{{titleType}}에는 실명이 꼭 필요해요!": "{{titleType}}에는 실명이 꼭 필요해요!",
  "감사합니다. 이제 {{realname}}님의 실명이 적힌 수료증을 확인할 수 있습니다.": "감사합니다. 이제 {{realname}}님의 실명이 적힌 수료증을 확인할 수 있습니다.",
  "강의 난이도": "강의 난이도",
  "강의 난이도가 아쉬워요!": "강의 난이도가 아쉬워요!",
  "강의 퀄리티": "강의 퀄리티",
  "강의 퀄리티가 만족스럽지 않아요.": "강의 퀄리티가 만족스럽지 않아요.",
  "강의 폴더": "강의 폴더",
  "강의 폴더가 없어요": "강의 폴더가 없어요",
  "강의 폴더에 추가했어요.": "강의 폴더에 추가했어요.",
  "강의 폴더에서 제거했어요.": "강의 폴더에서 제거했어요.",
  "같은 문제가 계속 발생한다면 서비스에 문의해주세요.": "같은 문제가 계속 발생한다면 서비스에 문의해주세요.",
  개인: "개인",
  "거의 다 왔어요! 배우고 싶은 기술을 선택해주세요 🎯": "거의 다 왔어요! 배우고 싶은 기술을 선택해주세요 🎯",
  "견적서(국내송금)": "견적서(국내송금)",
  "견적서(해외송금)": "견적서(해외송금)",
  계약자명: "계약자명",
  "계좌 인증에 실패했습니다. 고객센터에 문의해주세요.": "계좌 인증에 실패했습니다. 고객센터에 문의해주세요.",
  계좌번호: "계좌번호",
  "계좌번호를 다시 확인해주세요. 오류가 지속되면 고객센터로 문의해주세요.": "계좌번호를 다시 확인해주세요. 오류가 지속되면 고객센터로 문의해주세요.",
  "고유번호가 부여된 단체는 입력이 불가합니다.": "고유번호가 부여된 단체는 입력이 불가합니다.",
  "관심 분야를 선택해주세요": "관심 분야를 선택해주세요",
  "관심있는 분야를 알려주세요.": "관심있는 분야를 알려주세요.",
  교육시간: "교육시간",
  나가기: "나가기",
  "나만의 카테고리를 구성해보세요!": "나만의 카테고리를 구성해보세요!",
  "나한테 딱 맞는걸 찾고 싶어요": "나한테 딱 맞는걸 찾고 싶어요",
  "내 강의 폴더로 이동": "내 강의 폴더로 이동",
  "내 정산정보": "내 정산정보",
  "내용을 입력해 주세요.": "내용을 입력해 주세요.",
  다시입력: "다시입력",
  "다운 가능한 이미지가 없습니다. 반복될 경우 고객센터에 문의해주세요.": "다운 가능한 이미지가 없습니다. 반복될 경우 고객센터에 문의해주세요.",
  다음: "다음",
  "다음에 하기": "다음에 하기",
  "다음에 할게요": "다음에 할게요",
  다음으로: "다음으로",
  "답해주신 내용을 바탕으로 인기 강의 또는 추가 답변으로 맞는 강의를 찾아보세요.": "답해주신 내용을 바탕으로 인기 강의 또는 추가 답변으로 맞는 강의를 찾아보세요.",
  "더 나은 강의를 위해 개선해야할 점을 작성해 주세요!": "더 나은 강의를 위해 개선해야할 점을 작성해 주세요!",
  "더 많은 강의 보기": "더 많은 강의 보기",
  "더 이상 선택할 수 없어요.": "더 이상 선택할 수 없어요.",
  더보기: "더보기",
  등록하기: "등록하기",
  "로그인 하기": "로그인 하기",
  "링크 복사에 실패했습니다. 반복될 경우 고객센터에 문의해주세요.": "링크 복사에 실패했습니다. 반복될 경우 고객센터에 문의해주세요.",
  "링크가 복사되었습니다": "링크가 복사되었습니다",
  "링크드인 수료증 추가": "링크드인 수료증 추가",
  "마음에 드는 강의를 클릭해보세요": "마음에 드는 강의를 클릭해보세요",
  "마카테모달.접근.설명": "<strong>관심있는 카테고리</strong>를 선택하면, 내가 원하는 강의만 따로 모아 볼 수 있어요!",
  "마카테모달.접근.제목": "나만의 카테고리를 만들어보세요!",
  "마카테모달.최초접근.설명": "<strong>관심있는 주제</strong>에 대해 알려주시면,</br>나에게 딱 맞는 강의를 빠르게 찾을 수 있어요!",
  "마카테모달.최초접근.제목": "{{userName}} 님, <br/> 인프런에 오신 것을 환영해요!",
  "모달 닫기": "모달 닫기",
  "문제가 발생했습니다. 잠시 후 다시 시도해 주세요.": "문제가 발생했습니다. 잠시 후 다시 시도해 주세요.",
  보러가기: "보러가기",
  사업자: "사업자",
  "사업자 상태 인증에 실패했습니다. 고객센터에 문의해주세요.": "사업자 상태 인증에 실패했습니다. 고객센터에 문의해주세요.",
  사업자등록번호: "사업자등록번호",
  "사업자를 찾을 수 없습니다.": "사업자를 찾을 수 없습니다.",
  사업체명: "사업체명",
  "사운드 문제": "사운드 문제",
  "사운드에 문제가 있어요.": "사운드에 문제가 있어요.",
  "새 강의 폴더를 만들어보세요": "새 강의 폴더를 만들어보세요",
  "새 폴더": "새 폴더",
  "새 폴더 만들기": "새 폴더 만들기",
  "새 폴더 이름 입력": "새 폴더 이름 입력",
  "새 폴더 입력창 닫기": "새 폴더 입력창 닫기",
  "새 폴더 제출": "새 폴더 제출",
  "새 폴더를 만들었어요.": "새 폴더를 만들었어요.",
  "서비스 언어를 선택하세요.": "서비스 언어를 선택하세요.",
  "선택 완료": "선택 완료",
  "선택한 내용을 바탕으로 다음 행동을 골라주세요": "선택한 내용을 바탕으로 다음 행동을 골라주세요",
  "선택한 분야의 세부 기술이에요": "선택한 분야의 세부 기술이에요",
  "선택한 카테고리": "선택한 카테고리",
  "선택한 카테고리는 강의 검색 페이지 MY 카테고리에 등록됩니다. 😉": "선택한 카테고리는 강의 검색 페이지 MY 카테고리에 등록됩니다. 😉",
  "선택해주신 내용을 바탕으로 인기 강의를 모아봤어요! ✨": "선택해주신 내용을 바탕으로 인기 강의를 모아봤어요! ✨",
  "세션 만료": "세션 만료",
  "수강 확인증": "수강 확인증",
  "수강평 수정에 문제가 생겼어요.": "수강평 수정에 문제가 생겼어요.",
  "수강평 작성에 문제가 생겼어요.": "수강평 작성에 문제가 생겼어요.",
  "수강평을 작성해보세요!": "수강평을 작성해보세요!",
  수료일: "수료일",
  수료증: "수료증",
  "수료증 pdf 다운로드": "수료증 pdf 다운로드",
  "수료증 링크 복사": "수료증 링크 복사",
  "수료증 정보를 가져오는데 실패했습니다.": "수료증 정보를 가져오는데 실패했습니다.",
  수정: "수정",
  수정하기: "수정하기",
  "숫자만 입력 가능합니다.": "숫자만 입력 가능합니다.",
  시작일: "시작일",
  "실명 인증 모달 닫기": "실명 인증 모달 닫기",
  "실명 입력": "실명 입력",
  "실명 입력 실패": "실명 입력 실패",
  "실명 입력 완료": "실명 입력 완료",
  "실명:": "실명:",
  "실사용자 검증을 위해 휴대폰 인증을 진행해 주세요.": "실사용자 검증을 위해 휴대폰 인증을 진행해 주세요.",
  "아쉬웠던 점을 1개 이상 선택해 주시면,": "아쉬웠던 점을 1개 이상 선택해 주시면,",
  "아직 잘 모르겠다": "아직 잘 모르겠다",
  "안녕하세요 {{name}}님": "안녕하세요 {{name}}님",
  "알 수 없는 오류가 발생했습니다.": "알 수 없는 오류가 발생했습니다.",
  "어떻게 시작하면 좋을지 골라주세요.": "어떻게 시작하면 좋을지 골라주세요.",
  "언어 설정": "언어 설정",
  "예금주명이 일치하지 않습니다.": "예금주명이 일치하지 않습니다.",
  "올바른 정산 유형을 선택해주세요.": "올바른 정산 유형을 선택해주세요.",
  "외화 계좌는 입력이 불가합니다.": "외화 계좌는 입력이 불가합니다.",
  "위의 교육과정을 성공적으로 수료하였음을 인정하여 이 인증서를 수여합니다.": "위의 교육과정을 성공적으로 수료하였음을 인정하여 이 인증서를 수여합니다.",
  유형: "유형",
  "유효한 사업자등록번호를 입력해야합니다.": "유효한 사업자등록번호를 입력해야합니다.",
  "유효한 주민등록번호를 입력해야합니다.": "유효한 주민등록번호를 입력해야합니다.",
  은행: "은행",
  "은행을 선택해 주세요.": "은행을 선택해 주세요.",
  "의견을 반영해 더 좋은 강의를 만들게요.": "의견을 반영해 더 좋은 강의를 만들게요.",
  이름: "이름",
  "이름 (실명)": "이름 (실명)",
  "이름을 입력해 주세요.": "이름을 입력해 주세요.",
  "이미 인증된 요청입니다.": "이미 인증된 요청입니다.",
  "이미 저장된 실명이 있거나 오류가 발생했습니다.": "이미 저장된 실명이 있거나 오류가 발생했습니다.",
  "인기 강의 둘러보기": "인기 강의 둘러보기",
  인증: "인증",
  "인증 요청": "인증 요청",
  인증번호: "인증번호",
  "인증번호 요청 중 오류가 발생했습니다.": "인증번호 요청 중 오류가 발생했습니다.",
  "인증번호 유효시간이 초과되었습니다.": "인증번호 유효시간이 초과되었습니다.",
  "인증번호가 일치하지 않습니다.": "인증번호가 일치하지않습니다.",
  "인증번호가 카카오톡 또는 문자로 전송되었습니다.": "인증번호가 카카오톡 또는 문자로 전송되었습니다.",
  "인증번호를 못 받으셨나요? 스팸차단 확인 방법": "인증번호를 못 받으셨나요? 스팸차단 확인 방법",
  인프랩: "인프랩",
  인프런: "인프런",
  "인프런 [문의하기]를 이용해 주세요.": "인프런 [문의하기]를 이용해 주세요.",
  "인프런 대표": "인프런 대표",
  "인프런에 어떤 목적으로 오셨나요?": "인프런에 어떤 목적으로 오셨나요?",
  "일일 인증 횟수를 초과했습니다. 고객센터 문의 부탁드립니다.": "일일 인증 횟수를 초과했습니다. 고객센터 문의부탁드립니다.",
  "입력 정보가 유효하지 않습니다.": "입력 정보가 유효하지 않습니다.",
  "입력된 실명은 수정이 불가하니 한번 더 확인해 주세요!": "입력된 실명은 수정이 불가하니 한번 더 확인해 주세요!",
  "자동 로그아웃 되었습니다. 다시 로그인해주세요.": "자동 로그아웃 되었습니다. 다시 로그인해주세요.",
  "자료 부족": "자료 부족",
  "자료가 부족해요!": "자료가 부족해요!",
  "잘 맞는 인기 강의를 추천해드릴게요": "잘 맞는 인기 강의를 추천해드릴게요",
  "잘 모르겠어요": "잘 모르겠어요",
  "잠시 후 다시 시도해주세요.": "잠시 후 다시 시도해주세요.",
  재전송: "재전송",
  "재전송은 최대 10회입니다. 10분 후 재시도해 주세요.": "재전송은 최대 10회입니다. 10분 후 재시도해 주세요.",
  "저장에 실패했습니다. 잠시 후 다시 시도해주세요.": "저장에 실패했습니다. 잠시 후 다시 시도해주세요.",
  저장하기: "저장하기",
  전체: "전체",
  "정산 정보 수정 완료": "정산 정보 수정 완료",
  "정산 확정 시 수정된 정보는 익월에 반영됩니다.": "정산 확정 시 수정된 정보는 익월에 반영됩니다.",
  "정산받으실 분의 성명 또는 사업체명을 입력": "정산받으실 분의 성명 또는 사업체명을 입력",
  "정산자 유형": "정산자 유형",
  정산자명: "정산자명",
  "정산자명 (예금주명)": "정산자명 (예금주명)",
  "정산정보 등록": "정산정보 등록",
  "정산정보 수정": "정산정보 수정",
  "정산정보는 모든 강의에 동일하게 적용되며, 정산은 익월 10 영업일에 확정됩니다.": "정산정보는 모든 강의에 동일하게 적용되며, 정산은 익월 10 영업일에 확정됩니다.",
  "정지된 계좌입니다.": "정지된 계좌입니다.",
  제출: "제출",
  제출완료: "제출완료",
  "존재하지 않는 계좌입니다.": "존재하지 않는 계좌입니다.",
  "좋아요! 어떤 분야에 관심이 있으세요?": "좋아요! 어떤 분야에 관심이 있으세요?",
  주민등록번호: "주민등록번호",
  "준비끝! 관심사를 파악했어요~": "준비끝! 관심사를 파악했어요~",
  "중복 선택 가능": "중복 선택 가능",
  "지식공유에 관심이 있으시군요!": "지식공유에 관심이 있으시군요!",
  지식공유자: "지식공유자",
  "지식공유자 신청하러 가기": "지식공유자 신청하러 가기",
  지출증빙유형: "지출증빙유형",
  "직접 둘러볼게요": "직접 둘러볼게요",
  "직접 입력하기": "직접 입력하기",
  "질문 답변 소통": "질문 답변 소통",
  "질문 답변 소통이 원활하지 않아요.": "질문 답변 소통이 원활하지 않아요.",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
  "처리중 오류가 발생했습니다. 잠시후 다시 시도해 주세요.": "처리중 오류가 발생했습니다. 잠시후 다시 시도해 주세요.",
  "최대 {{count}}개까지 선택할 수 있습니다.": "최대 {{count}}개까지 선택할 수 있습니다.",
  "추천 강의가 없습니다.": "추천 강의가 없습니다.",
  "추후 수정이 불가하니 실수없이 입력해 주세요.": "추후 수정이 불가하니 실수없이 입력해 주세요.",
  취소: "취소",
  "폐업 상태인 사업자입니다.": "폐업 상태인 사업자입니다.",
  "폴더명 입력": "폴더명 입력",
  "학습 목적을 입력해주세요": "학습 목적을 입력해주세요",
  "해외 거주자": "해외 거주자",
  "홈으로 가기": "홈으로 가기",
  "화질 문제": "화질 문제",
  "화질이 안 좋아요.": "화질이 안 좋아요.",
  확인: "확인",
  "휴대폰 번호": "휴대폰 번호",
  "휴대폰 번호 인증": "휴대폰 번호 인증",
  "휴대폰 번호 placeholder": "-없이 숫자만 입력",
  인증완료: "인증완료",
  "휴대폰 번호 입력": "휴대폰 번호 입력",
  "휴대폰 번호 형식이 올바르지 않습니다.": "휴대폰 번호 형식이 올바르지 않습니다.",
  "휴대폰 번호를 입력해 주세요.": "휴대폰 번호를 입력해주세요.",
  "휴대폰인증모달.인증안내": "<Span>인증은</Span> <Green>최초1회</Green><Span>만 진행 됩니다.</Span>",
  "휴업 상태인 사업자입니다.": "휴업 상태인 사업자입니다.",
  "힘이 되는 수강평을 남겨주세요!": "힘이 되는 수강평을 남겨주세요!",
  "AI가 답변을 생성하고 있어요...": "AI가 답변을 생성하고 있어요...",
  "추천 이유": "추천 이유",
  "추천 강의 {{count}}개": "추천 강의 {{count}}개",
  "메시지 입력... (질문권 {{count}}개)": "메시지 입력... (질문권 {{count}}개)",
  "질문 {{count}}개를 모두 사용했어요": "질문 {{count}}개를 모두 사용했어요",
  "이전 단계": "이전 단계",
  "관심분야 인기강의 다시보기": "관심분야 인기강의 다시보기",
  "안녕하세요! 궁금한 점이 있으면 편하게 질문해주세요!": "안녕하세요! 궁금한 점이 있으면 편하게 질문해주세요!",
  "{{selections}} 에 관심이 있으시군요!\n혹시 실무에서 바로 쓰고 싶은 건지 기초부터 배우고 싶은 건지 알려주시면 더 정확하게 추천해드릴게요": `{{selections}} 에 관심이 있으시군요!
혹시 실무에서 바로 쓰고 싶은 건지 기초부터 배우고 싶은 건지 알려주시면 더 정확하게 추천해드릴게요`,
  "죄송합니다. 오류가 발생했어요. 다시 시도해주세요.": "죄송합니다. 오류가 발생했어요. 다시 시도해주세요.",
  "대화 분석 및 사용자 선호도 추출": "대화 분석 및 사용자 선호도 추출",
  "선호도에 맞는 강의 검색": "선호도에 맞는 강의 검색",
  "검색된 강의 상세 정보 조회": "검색된 강의 상세 정보 조회",
  "추가 정보 필요 시 사용자에게 질문": "추가 정보 필요 시 사용자에게 질문",
  "최종 강의 추천 생성": "최종 강의 추천 생성",
  "llm-empty-state.summary-title": "지금까지 선택하신 내용이에요",
  "llm-empty-state.label-goal": "목표",
  "llm-empty-state.label-interest": "관심 분야",
  "llm-empty-state.label-skill": "스킬",
  "llm-empty-state.prompt-hint": "추가로 원하는 조건이 있으면 알려주세요!",
  "llm-empty-state.suggestion-1": "AI 엔지니어로 이직하려면 뭐부터 배워야 해요?",
  "llm-empty-state.suggestion-2": "RAG랑 LangChain 실무에서 바로 쓸 수 있는 강의 있어요?",
  "llm-empty-state.suggestion-3": "AI 활용해서 포트폴리오 만들 수 있는 프로젝트 강의 추천해줘",
  "llm-empty-state.suggestion-4": "LLM 기초부터 차근차근 배울 수 있는 강의 있어요?",
  "llm-empty-state.suggestion-5": "요즘 AI 채용 시장에서 가장 많이 요구하는 스킬이 뭐야?",
  "llm-empty-state.input-placeholder": "최대 {{count}}번까지 질문할 수 있어요",
  "llm-chat.scroll-to-bottom": "맨 아래로",
  "llm-leave-confirm.title": "아직 답변을 만들고 있어요",
  "llm-leave-confirm.description": "지금 나가면 답변을 받을 수 없어요.",
  "llm-leave-confirm.cancel": "기다릴게요",
  "llm-leave-confirm.confirm": "그래도 나갈게요",
  "llm-survey.thanks-title": "의견 감사해요!",
  "llm-survey.thanks-description": "더 좋은 추천을 만드는데 반영할게요",
  "link-coupon.title": "쿠폰 받기",
  "link-coupon.image-alt": "할인 쿠폰 이미지",
  "link-coupon.description-1": "인프런이 당신의 배움을 응원해요",
  "link-coupon.description-2": "<strong>{{remaining}} 안에</strong> 특별한 혜택을 받아보세요.",
  "link-coupon.remaining-days": "{{days}}일",
  "link-coupon.remaining-hours": "{{hours}}시간",
  "link-coupon.remaining-minutes": "{{minutes}}분",
  "link-coupon.button-decline": "받지 않기",
  "link-coupon.button-receive": "쿠폰 받기",
  "link-coupon-error.view-my-coupons": "내 쿠폰함 보기",
  "link-coupon-error.inactive-title": "비활성화된 쿠폰",
  "link-coupon-error.inactive-body": "사용할 수 없는 쿠폰입니다.",
  "link-coupon-error.limit-exceeded-title": "쿠폰 수량 초과",
  "link-coupon-error.limit-exceeded-body": "해당 쿠폰의 사용 가능 수량이 초과되었습니다.",
  "link-coupon-error.period-expired-title": "쿠폰 등록일 만료",
  "link-coupon-error.period-expired-body": "사용 기한이 지나 쿠폰을 등록할 수 없습니다.",
  "link-coupon-error.register-disabled-title": "쿠폰 등록 불가",
  "link-coupon-error.already-issued-body": "이미 등록한 쿠폰입니다.",
  "link-coupon-error.already-used-title": "이미 사용한 쿠폰",
  "link-coupon-error.already-used-body": "이미 사용한 쿠폰입니다.",
  "link-coupon-error.voucher-exist-body": "이미 수강중인 강의는 쿠폰 발급이 불가능합니다. `내 학습` 페이지를 확인해주세요!",
  "link-coupon-error.disallowed-country-title": "쿠폰 사용 불가",
  "link-coupon-error.disallowed-country-body": "해당 쿠폰은 해당 국가에서 사용할 수 없습니다.",
  "link-coupon-error.generic-title": "쿠폰 조회 또는 등록 실패",
  "link-coupon-error.generic-body": `쿠폰 조회 또는 등록에 실패했습니다.
잠시 후 다시 시도해주세요.`
}, w9 = "Paypal", S9 = {
  "010부터 다시 입력해 주세요.": "Vui lòng nhập lại bắt đầu với 010.",
  "2자 이상 입력": "Nhập ít nhất 2 ký tự",
  "2자 이상 입력해 주세요.": "Vui lòng nhập ít nhất 2 ký tự.",
  "3가지 질문을 통해": "Thông qua 3 câu hỏi",
  "반가워요, {{name}}님": "Chào mừng, {{name}}!",
  Paypal: w9,
  "Paypal 링크": "Liên kết Paypal",
  "YYYY년 MM월 DD일": "YYYY-MM-DD",
  "{{interests}} 인기 강의 둘러보기": "Xem các khóa học {{interests}} phổ biến",
  "{{label}} 입력": "Nhập {{label}}",
  "{{name}}님을 위한 인기 강의 🔥": "Khóa học được đề xuất cho {{name}}",
  "{{runningHour}}시간_one": "{{runningHour}} giờ",
  "{{runningHour}}시간_other": "{{runningHour}} giờ",
  "{{runningMinute}}분_one": "{{runningMinute}} phút",
  "{{runningMinute}}분_other": "{{runningMinute}} phút",
  "{{titleType}} 실명 확인": "Xác minh tên thật {{titleType}}",
  "{{titleType}}에는 실명이 꼭 필요해요!": "{{titleType}} yêu cầu phải có tên thật!",
  "감사합니다. 이제 {{realname}}님의 실명이 적힌 수료증을 확인할 수 있습니다.": "Cảm ơn bạn. Bây giờ bạn có thể xem chứng chỉ với tên thật của {{realname}}.",
  "강의 난이도": "Độ khó của khóa học",
  "강의 난이도가 아쉬워요!": "Độ khó của khóa học không như mong đợi!",
  "강의 퀄리티": "Chất lượng khóa học",
  "강의 퀄리티가 만족스럽지 않아요.": "Chất lượng khóa học không đạt yêu cầu.",
  "강의 폴더": "Thư mục bài giảng",
  "강의 폴더가 없어요": "Không có thư mục bài giảng.",
  "강의 폴더에 추가했어요.": "Đã thêm vào thư mục bài giảng.",
  "강의 폴더에서 제거했어요.": "Đã xóa khỏi thư mục bài giảng.",
  "같은 문제가 계속 발생한다면 서비스에 문의해주세요.": "Nếu vấn đề tiếp tục xảy ra, vui lòng liên hệ dịch vụ hỗ trợ.",
  개인: "Cá nhân",
  "거의 다 왔어요! 배우고 싶은 기술을 선택해주세요 🎯": "Gần xong rồi! Vui lòng chọn kỹ năng bạn muốn học 🎯",
  "견적서(국내송금)": "Báo giá (Chuyển khoản nội địa)",
  "견적서(해외송금)": "Báo giá (Chuyển khoản quốc tế)",
  계약자명: "Tên người ký hợp đồng",
  "계좌 인증에 실패했습니다. 고객센터에 문의해주세요.": "Xác minh tài khoản thất bại. Vui lòng liên hệ bộ phận chăm sóc khách hàng.",
  계좌번호: "Số tài khoản",
  "계좌번호를 다시 확인해주세요. 오류가 지속되면 고객센터로 문의해주세요.": "Vui lòng kiểm tra lại số tài khoản. Nếu lỗi tiếp tục xảy ra, hãy liên hệ với bộ phận chăm sóc khách hàng.",
  "고유번호가 부여된 단체는 입력이 불가합니다.": "Không thể nhập tổ chức có mã số định danh.",
  "관심 분야를 선택해주세요": "Vui lòng chọn lĩnh vực quan tâm",
  "관심있는 분야를 알려주세요.": "Vui lòng cho biết lĩnh vực bạn quan tâm.",
  교육시간: "Thời lượng",
  나가기: "Đóng",
  "나만의 카테고리를 구성해보세요!": "Hãy tạo danh mục riêng của bạn!",
  "나한테 딱 맞는걸 찾고 싶어요": "Tôi muốn tìm thứ phù hợp hoàn hảo với mình",
  "내 강의 폴더로 이동": "Đi đến thư mục bài giảng của tôi",
  "내 정산정보": "Thông tin thanh toán của tôi",
  "내용을 입력해 주세요.": "Vui lòng nhập nội dung.",
  다시입력: "Nhập lại",
  "다운 가능한 이미지가 없습니다. 반복될 경우 고객센터에 문의해주세요.": "Không có hình ảnh nào để tải xuống. Nếu vấn đề tiếp diễn, vui lòng liên hệ với trung tâm dịch vụ khách hàng.",
  다음: "Tiếp theo",
  "다음에 하기": "Để sau",
  "다음에 할게요": "Tôi sẽ làm sau.",
  다음으로: "Tiếp theo",
  "답해주신 내용을 바탕으로 인기 강의 또는 추가 답변으로 맞는 강의를 찾아보세요.": "Dựa trên câu trả lời của bạn, hãy khám phá các khóa học phổ biến hoặc tìm khóa học phù hợp.",
  "더 나은 강의를 위해 개선해야할 점을 작성해 주세요!": "Vui lòng viết những điểm cần cải thiện để khóa học tốt hơn!",
  "더 많은 강의 보기": "Xem thêm khóa học",
  "더 이상 선택할 수 없어요.": "Bạn không thể chọn thêm nữa.",
  더보기: "Thêm",
  등록하기: "Đăng ký",
  "로그인 하기": "Đăng nhập",
  "링크 복사에 실패했습니다. 반복될 경우 고객센터에 문의해주세요.": "Không thể sao chép liên kết. Nếu vấn đề tiếp diễn, vui lòng liên hệ với trung tâm dịch vụ khách hàng.",
  "링크가 복사되었습니다": "Liên kết đã được sao chép.",
  "링크드인 수료증 추가": "Thêm chứng chỉ vào LinkedIn",
  "마음에 드는 강의를 클릭해보세요": "Nhấp vào khóa học bạn thích",
  "마카테모달.접근.설명": "Nếu bạn chọn <strong>các danh mục</strong> bạn quan tâm, bạn có thể tập hợp các khóa học bạn muốn!",
  "마카테모달.접근.제목": "Tạo danh mục riêng của bạn!",
  "마카테모달.최초접근.설명": "Hãy cho chúng tôi biết <strong>chủ đề</strong> bạn quan tâm,<br/>và chúng tôi sẽ giúp bạn tìm các khóa học phù hợp nhanh chóng!",
  "마카테모달.최초접근.제목": "Chào mừng đến với Inflearn, {{userName}}!",
  "모달 닫기": "Đóng cửa sổ",
  "문제가 발생했습니다. 잠시 후 다시 시도해 주세요.": "Có lỗi xảy ra. Vui lòng thử lại sau.",
  보러가기: "Xem",
  사업자: "Doanh nghiệp",
  "사업자 상태 인증에 실패했습니다. 고객센터에 문의해주세요.": "Xác minh trạng thái doanh nghiệp thất bại. Vui lòng liên hệ bộ phận chăm sóc khách hàng.",
  사업자등록번호: "Số đăng ký doanh nghiệp",
  "사업자를 찾을 수 없습니다.": "Không tìm thấy doanh nghiệp.",
  사업체명: "Tên doanh nghiệp",
  "사운드 문제": "Vấn đề âm thanh",
  "사운드에 문제가 있어요.": "Có vấn đề với âm thanh.",
  "새 강의 폴더를 만들어보세요": "Hãy thử tạo thư mục bài giảng mới.",
  "새 폴더": "Thư mục mới",
  "새 폴더 만들기": "Tạo thư mục mới",
  "새 폴더 이름 입력": "Nhập tên thư mục mới",
  "새 폴더 입력창 닫기": "Đóng cửa sổ nhập thư mục mới",
  "새 폴더 제출": "Gửi thư mục mới",
  "새 폴더를 만들었어요.": "Đã tạo thư mục mới.",
  "서비스 언어를 선택하세요.": "Vui lòng chọn ngôn ngữ dịch vụ.",
  "선택 완료": "Đã chọn xong",
  "선택한 내용을 바탕으로 다음 행동을 골라주세요": "Vui lòng chọn hành động tiếp theo dựa trên lựa chọn của bạn",
  "선택한 분야의 세부 기술이에요": "Đây là các kỹ năng chi tiết cho lĩnh vực bạn đã chọn",
  "선택한 카테고리": "Danh mục đã chọn",
  "선택한 카테고리는 강의 검색 페이지 MY 카테고리에 등록됩니다. 😉": "Danh mục bạn đã chọn sẽ được thêm vào 'Danh mục của tôi' trên trang tìm kiếm khóa học. 😉",
  "선택해주신 내용을 바탕으로 인기 강의를 모아봤어요! ✨": "Chúng tôi đã tổng hợp các khóa học phổ biến dựa trên lựa chọn của bạn! ✨",
  "세션 만료": "Phiên đã hết hạn",
  "수강 확인증": "Chứng nhận hoàn thành khóa học",
  "수강평 수정에 문제가 생겼어요.": "Đã xảy ra lỗi khi chỉnh sửa đánh giá.",
  "수강평 작성에 문제가 생겼어요.": "Đã xảy ra lỗi khi gửi đánh giá.",
  "수강평을 작성해보세요!": "Hãy viết đánh giá!",
  수료일: "Ngày hoàn thành",
  수료증: "Chứng chỉ",
  "수료증 pdf 다운로드": "Tải xuống PDF chứng chỉ",
  "수료증 링크 복사": "Sao chép liên kết chứng chỉ",
  "수료증 정보를 가져오는데 실패했습니다.": "Không thể lấy thông tin chứng chỉ.",
  수정: "Sửa",
  수정하기: "Chỉnh sửa",
  "숫자만 입력 가능합니다.": "Chỉ có thể nhập số.",
  시작일: "Ngày bắt đầu",
  "실명 인증 모달 닫기": "Đóng cửa sổ xác minh tên thật",
  "실명 입력": "Nhập tên đầy đủ",
  "실명 입력 실패": "Nhập tên thật thất bại",
  "실명 입력 완료": "Hoàn tất nhập tên thật",
  "실명:": "Tên thật:",
  "실사용자 검증을 위해 휴대폰 인증을 진행해 주세요.": "Vui lòng xác minh số điện thoại của bạn cho việc xác thực người dùng thực.",
  "아쉬웠던 점을 1개 이상 선택해 주시면,": "Vui lòng chọn ít nhất 1 điểm cần cải thiện,",
  "아직 잘 모르겠다": "Chưa chắc chắn",
  "안녕하세요 {{name}}님": "Xin chào, {{name}}",
  "알 수 없는 오류가 발생했습니다.": "Đã xảy ra lỗi không xác định.",
  "어떻게 시작하면 좋을지 골라주세요.": "Hãy chọn cách bạn muốn bắt đầu.",
  "언어 설정": "Cài đặt ngôn ngữ",
  "예금주명이 일치하지 않습니다.": "Tên chủ tài khoản không khớp.",
  "올바른 정산 유형을 선택해주세요.": "Vui lòng chọn loại thanh toán hợp lệ.",
  "외화 계좌는 입력이 불가합니다.": "Không thể nhập tài khoản ngoại tệ.",
  "위의 교육과정을 성공적으로 수료하였음을 인정하여 이 인증서를 수여합니다.": "Chúng tôi trao chứng chỉ này để công nhận bạn đã hoàn thành xuất sắc khóa học trên.",
  유형: "Loại",
  "유효한 사업자등록번호를 입력해야합니다.": "Bạn phải nhập số đăng ký doanh nghiệp hợp lệ.",
  "유효한 주민등록번호를 입력해야합니다.": "Bạn phải nhập số chứng minh nhân dân hợp lệ.",
  은행: "Ngân hàng",
  "은행을 선택해 주세요.": "Vui lòng chọn ngân hàng.",
  "의견을 반영해 더 좋은 강의를 만들게요.": "Chúng tôi sẽ sử dụng ý kiến của bạn để tạo ra các khóa học tốt hơn.",
  이름: "Tên",
  "이름 (실명)": "Tên (Tên thật)",
  "이름을 입력해 주세요.": "Nhập tên đầy đủ của bạn.",
  "이미 인증된 요청입니다.": "Yêu cầu này đã được xác thực.",
  "이미 저장된 실명이 있거나 오류가 발생했습니다.": "Tên thật đã được lưu hoặc đã xảy ra lỗi.",
  "인기 강의 둘러보기": "Xem các khóa học phổ biến",
  인증: "Xác minh",
  "인증 요청": "Gửi mã",
  인증번호: "Mã xác minh",
  "인증번호 요청 중 오류가 발생했습니다.": "Có lỗi xảy ra khi yêu cầu mã xác minh.",
  "인증번호 유효시간이 초과되었습니다.": "Mã xác minh đã hết hạn.",
  "인증번호가 일치하지 않습니다.": "Mã xác minh không khớp.",
  "인증번호가 카카오톡 또는 문자로 전송되었습니다.": "Mã xác minh đã được gửi qua KakaoTalk hoặc tin nhắn.",
  "인증번호를 못 받으셨나요? 스팸차단 확인 방법": "Bạn không nhận được mã xác minh? Kiểm tra bộ lọc thư rác.",
  인프랩: "InfLab",
  인프런: "Inflearn",
  "인프런 [문의하기]를 이용해 주세요.": "Vui lòng sử dụng [Liên hệ] của Inflearn.",
  "인프런 대표": "CEO Inflearn",
  "인프런에 어떤 목적으로 오셨나요?": "Mục đích của bạn khi đến Inflearn là gì?",
  "일일 인증 횟수를 초과했습니다. 고객센터 문의 부탁드립니다.": "Bạn đã vượt quá số lần xác thực hàng ngày. Vui lòng liên hệ bộ phận hỗ trợ.",
  "입력 정보가 유효하지 않습니다.": "Thông tin nhập vào không hợp lệ.",
  "입력된 실명은 수정이 불가하니 한번 더 확인해 주세요!": "Tên thật đã nhập không thể chỉnh sửa, vui lòng kiểm tra kỹ!",
  "자동 로그아웃 되었습니다. 다시 로그인해주세요.": "Bạn đã tự động đăng xuất. Vui lòng đăng nhập lại.",
  "자료 부족": "Thiếu tài liệu",
  "자료가 부족해요!": "Không đủ tài liệu!",
  "잘 맞는 인기 강의를 추천해드릴게요": "Chúng tôi sẽ đề xuất các khóa học phổ biến phù hợp với bạn",
  "잘 모르겠어요": "Chưa chắc chắn",
  "잠시 후 다시 시도해주세요.": "Vui lòng thử lại sau.",
  재전송: "Gửi lại",
  "재전송은 최대 10회입니다. 10분 후 재시도해 주세요.": "Việc gửi lại tối đa 10 lần. Vui lòng thử lại sau 10 phút.",
  "저장에 실패했습니다. 잠시 후 다시 시도해주세요.": "Lưu thất bại. Vui lòng thử lại sau.",
  저장하기: "Lưu",
  전체: "Tất cả",
  "정산 정보 수정 완료": "Đã cập nhật thông tin thanh toán",
  "정산 확정 시 수정된 정보는 익월에 반영됩니다.": "Khi thanh toán được chốt, thông tin đã chỉnh sửa sẽ được áp dụng vào tháng sau.",
  "정산받으실 분의 성명 또는 사업체명을 입력": "Nhập tên người nhận thanh toán hoặc tên doanh nghiệp",
  "정산자 유형": "Loại người nhận thanh toán",
  정산자명: "Tên người thanh toán",
  "정산자명 (예금주명)": "Tên người thanh toán (Chủ tài khoản)",
  "정산정보 등록": "Đăng ký thông tin thanh toán",
  "정산정보 수정": "Chỉnh sửa thông tin thanh toán",
  "정산정보는 모든 강의에 동일하게 적용되며, 정산은 익월 10 영업일에 확정됩니다.": "Thông tin thanh toán được áp dụng giống nhau cho tất cả các khóa học và sẽ được chốt vào ngày làm việc thứ 10 của tháng sau.",
  "정지된 계좌입니다.": "Tài khoản đã bị khóa.",
  제출: "Gửi",
  제출완료: "Xác nhận",
  "존재하지 않는 계좌입니다.": "Tài khoản không tồn tại.",
  "좋아요! 어떤 분야에 관심이 있으세요?": "Tuyệt! Bạn quan tâm đến lĩnh vực nào?",
  주민등록번호: "Số chứng minh nhân dân",
  "준비끝! 관심사를 파악했어요~": "Sẵn sàng! Chúng tôi đã nắm được sở thích của bạn~",
  "중복 선택 가능": "Có thể chọn nhiều",
  "지식공유에 관심이 있으시군요!": "Bạn quan tâm đến việc chia sẻ kiến thức!",
  지식공유자: "Giảng viên",
  "지식공유자 신청하러 가기": "Đăng ký trở thành giảng viên",
  지출증빙유형: "Loại chứng từ chi tiêu",
  "직접 둘러볼게요": "Tôi sẽ tự khám phá",
  "직접 입력하기": "Nhập thủ công",
  "질문 답변 소통": "Giao tiếp Hỏi & Đáp",
  "질문 답변 소통이 원활하지 않아요.": "Giao tiếp Hỏi & Đáp không suôn sẻ.",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "Đã xảy ra lỗi trong quá trình xử lý. Vui lòng thử lại sau.",
  "처리중 오류가 발생했습니다. 잠시후 다시 시도해 주세요.": "Đã xảy ra lỗi trong quá trình xử lý. Vui lòng thử lại sau.",
  "최대 {{count}}개까지 선택할 수 있습니다.": "Bạn có thể chọn tối đa {{count}} mục.",
  "추천 강의가 없습니다.": "Không có khóa học được đề xuất.",
  "추후 수정이 불가하니 실수없이 입력해 주세요.": "Không thể chỉnh sửa sau này, vui lòng nhập cẩn thận.",
  취소: "Hủy",
  "폐업 상태인 사업자입니다.": "Doanh nghiệp đã ngừng hoạt động.",
  "폴더명 입력": "Nhập tên thư mục",
  "학습 목적을 입력해주세요": "Vui lòng nhập mục đích học tập",
  "해외 거주자": "Người cư trú ở nước ngoài",
  "홈으로 가기": "Về trang chủ",
  "화질 문제": "Vấn đề chất lượng video",
  "화질이 안 좋아요.": "Chất lượng video kém.",
  확인: "OK",
  "휴대폰 번호": "Điện thoại",
  "휴대폰 번호 인증": "Xác minh số điện thoại",
  "휴대폰 번호 placeholder": "Chỉ nhập số, không gạch ngang",
  인증완료: "Đã xác minh",
  "휴대폰 번호 입력": "Nhập số điện thoại",
  "휴대폰 번호 형식이 올바르지 않습니다.": "Định dạng số điện thoại không đúng",
  "휴대폰 번호를 입력해 주세요.": "Nhập số điện thoại di động của bạn.",
  "휴대폰인증모달.인증안내": "<Span>Xác minh được thực hiện</Span> <Green>một lần.</Green>",
  "휴업 상태인 사업자입니다.": "Doanh nghiệp đang tạm ngừng hoạt động.",
  "힘이 되는 수강평을 남겨주세요!": "Hãy để lại đánh giá khích lệ!",
  "AI가 답변을 생성하고 있어요...": "AI đang tạo câu trả lời...",
  "추천 이유": "Lý do đề xuất",
  "추천 강의 {{count}}개": "{{count}} khóa học đề xuất",
  "메시지 입력... (질문권 {{count}}개)": "Nhập tin nhắn... (còn {{count}} câu hỏi)",
  "질문 {{count}}개를 모두 사용했어요": "Đã sử dụng hết {{count}} câu hỏi",
  "이전 단계": "Bước trước",
  "관심분야 인기강의 다시보기": "Xem lại các khóa học phổ biến theo lĩnh vực quan tâm",
  "안녕하세요! 궁금한 점이 있으면 편하게 질문해주세요!": "Xin chào! Hãy thoải mái đặt câu hỏi!",
  "{{selections}} 에 관심이 있으시군요!\n혹시 실무에서 바로 쓰고 싶은 건지 기초부터 배우고 싶은 건지 알려주시면 더 정확하게 추천해드릴게요": `Bạn quan tâm đến {{selections}}!
Nếu bạn cho chúng tôi biết bạn muốn áp dụng ngay trong công việc hay muốn học từ cơ bản, chúng tôi sẽ đề xuất chính xác hơn.`,
  "죄송합니다. 오류가 발생했어요. 다시 시도해주세요.": "Xin lỗi, đã xảy ra lỗi. Vui lòng thử lại.",
  "대화 분석 및 사용자 선호도 추출": "Phân tích cuộc trò chuyện và trích xuất sở thích",
  "선호도에 맞는 강의 검색": "Tìm kiếm khóa học phù hợp",
  "검색된 강의 상세 정보 조회": "Lấy thông tin chi tiết khóa học",
  "추가 정보 필요 시 사용자에게 질문": "Hỏi người dùng khi cần thêm thông tin",
  "최종 강의 추천 생성": "Tạo đề xuất khóa học cuối cùng",
  "llm-empty-state.summary-title": "Đây là những gì bạn đã chọn cho đến nay",
  "llm-empty-state.label-goal": "Mục tiêu",
  "llm-empty-state.label-interest": "Lĩnh vực quan tâm",
  "llm-empty-state.label-skill": "Kỹ năng",
  "llm-empty-state.prompt-hint": "Hãy cho chúng tôi biết nếu bạn có thêm yêu cầu nào khác!",
  "llm-empty-state.suggestion-1": "Tôi nên học gì trước để chuyển sang làm AI engineer?",
  "llm-empty-state.suggestion-2": "Có khóa học nào về RAG và LangChain có thể áp dụng ngay vào thực tế không?",
  "llm-empty-state.suggestion-3": "Hãy đề xuất khóa học dự án để tôi tạo portfolio bằng AI",
  "llm-empty-state.suggestion-4": "Có khóa học nào để học LLM từ cơ bản theo từng bước không?",
  "llm-empty-state.suggestion-5": "Kỹ năng nào được yêu cầu nhiều nhất trên thị trường tuyển dụng AI hiện nay?",
  "llm-empty-state.input-placeholder": "Bạn có thể đặt tối đa {{count}} câu hỏi",
  "llm-chat.scroll-to-bottom": "Cuộn xuống cuối",
  "llm-leave-confirm.title": "Khoan đã!",
  "llm-leave-confirm.description": `Chúng tôi đang chuẩn bị câu trả lời.
Nếu bạn rời đi ngay bây giờ, bạn sẽ không nhận được câu trả lời đang được tạo.`,
  "llm-leave-confirm.cancel": "Tôi sẽ đợi",
  "llm-leave-confirm.confirm": "Vẫn rời đi",
  "llm-survey.thanks-title": "Cảm ơn ý kiến của bạn!",
  "llm-survey.thanks-description": "Chúng tôi sẽ cải thiện đề xuất dựa trên phản hồi của bạn",
  "link-coupon.title": "Nhận phiếu giảm giá",
  "link-coupon.image-alt": "Hình ảnh phiếu giảm giá",
  "link-coupon.description-1": "Inflearn luôn đồng hành cùng hành trình học tập của bạn.",
  "link-coupon.description-2": "Hãy sử dụng <strong>trong {{remaining}}</strong> để nhận được ưu đãi đặc biệt.",
  "link-coupon.remaining-days": "{{days}} ngày",
  "link-coupon.remaining-hours": "{{hours}} giờ",
  "link-coupon.remaining-minutes": "{{minutes}} phút",
  "link-coupon.button-decline": "Không nhận",
  "link-coupon.button-receive": "Nhận phiếu giảm giá",
  "link-coupon-error.view-my-coupons": "Xem kho phiếu của tôi",
  "link-coupon-error.inactive-title": "Phiếu giảm giá đã bị vô hiệu hóa",
  "link-coupon-error.inactive-body": "Phiếu giảm giá này không thể sử dụng.",
  "link-coupon-error.limit-exceeded-title": "Vượt quá số lượng phiếu",
  "link-coupon-error.limit-exceeded-body": "Số lượng sử dụng của phiếu giảm giá này đã vượt quá giới hạn.",
  "link-coupon-error.period-expired-title": "Hết hạn đăng ký phiếu giảm giá",
  "link-coupon-error.period-expired-body": "Phiếu giảm giá này đã hết hạn nên không thể đăng ký.",
  "link-coupon-error.register-disabled-title": "Không thể đăng ký phiếu giảm giá",
  "link-coupon-error.already-issued-body": "Phiếu giảm giá này đã được đăng ký.",
  "link-coupon-error.already-used-title": "Phiếu giảm giá đã sử dụng",
  "link-coupon-error.already-used-body": "Phiếu giảm giá này đã được sử dụng.",
  "link-coupon-error.voucher-exist-body": "Bạn không thể phát hành coupon cho khóa học đang học. Vui lòng kiểm tra trang “Học tập của tôi”!",
  "link-coupon-error.disallowed-country-title": "Không thể sử dụng phiếu giảm giá",
  "link-coupon-error.disallowed-country-body": "Phiếu giảm giá này không thể sử dụng tại quốc gia này.",
  "link-coupon-error.generic-title": "Tra cứu hoặc đăng ký phiếu giảm giá thất bại",
  "link-coupon-error.generic-body": `Tra cứu hoặc đăng ký phiếu giảm giá thất bại.
Vui lòng thử lại sau.`
}, T9 = {
  ko: {
    modals: H9
  },
  en: {
    modals: Y9
  },
  vi: {
    modals: S9
  },
  ja: {
    modals: z9
  }
}, L9 = (g) => !!Jd.find((I) => g === I), eC = fg.createInstance();
eC.use(Xu).init({
  defaultNS: "modals",
  lng: dC,
  supportedLngs: Jd,
  fallbackLng: dC,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  resources: T9
});
const ql = r9, VC = {
  CLIENT_V1_MY_LISTS: "/client/api/v1/my-lists",
  CLIENT_V1_COURSE_CERTIFICATES_CONFIRM: "/client/api/v1/course-certificates/confirm",
  CLIENT_V1_BUYER: "/client/api/v1/buyer",
  CLIENT_V1_MY_LISTS_COURSE: "/client/api/v1/my-lists/course",
  CLIENT_V1_COUPONS: "/client/api/v1/coupons",
  CLIENT_V2_SKILLS_SEARCH: "/client/api/v2/skills/search",
  CLIENT_V1_COURSE_RECOMMENDATIONS_USER_ONBOARDING: "/client/api/v1/course-recommendations/user-onboarding",
  CLIENT_V1_COURSE_RECOMMENDATIONS_USER_ONBOARDING_LLM: "/client/api/v1/course-recommendations/user-onboarding-llm",
  CLIENT_V1_COURSE_CERTIFICATES_DETAIL: "/client/api/v1/course-certificates/detail",
  CLIENT_V1_CATEGORY_MAIN: "/client/api/v1/category/main"
};
function k3({
  url: g,
  options: I,
  requestOptions: C
}) {
  var A;
  const c = _C({
    mutationFn: (l) => ql.post(g, l, C),
    ...I
  });
  return {
    ...c,
    data: (A = c.data) == null ? void 0 : A.data
  };
}
const U9 = async (g, I) => ql.get(g, I), P9 = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => U9(I, A),
  ...C
});
function k9(g) {
  var I;
  const C = ug(P9(g));
  return {
    ...C,
    data: (I = C.data) == null ? void 0 : I.data
  };
}
const D9 = async (g, I) => ql.get(g, I), O9 = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => D9(I, A),
  ...C
});
function j9(g) {
  var I;
  const C = ug(O9(g));
  return {
    ...C,
    data: (I = C.data) == null ? void 0 : I.data
  };
}
const E9 = async (g, I) => ql.get(g, I), Q9 = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => E9(I, A),
  ...C
});
function M9(g) {
  var I;
  const C = ug(Q9(g));
  return {
    ...C,
    data: (I = C.data) == null ? void 0 : I.data
  };
}
function fc(g, I) {
  const C = (I || eC.language) === dC ? "" : `/${eC.language}`;
  return `${a9}${C}${g}`;
}
const K9 = {
  MY_COURSE_FOLDER_LIST: () => fc("/my/list"),
  MY_COURSE_FOLDER_ID: (g) => fc(`/my/list/${g}`),
  CERTIFICATE_DETAIL: (g) => fc(`/certificate/${g}`),
  USER_SIGNIN: "/signin",
  USER_COUPONS: () => "/user/coupons",
  COURSES: "/courses",
  COURSES_MY_CATEGORY: "/courses/my-category",
  OPEN_KNOWLEDGE: () => fc("/open-knowledge")
}, Ye = V9, mC = {
  CLIENT_V1_COURSE_CATEGORY: "/client/api/v1/course-category",
  CLIENT_V1_REACTIONS_COMMENTS_ID: (g) => `/client/api/v1/reactions/comments/${g}`,
  CLIENT_V1_FILES_POST_IMAGE: "/client/api/v1/files/post-image",
  CLIENT_V1_REVIEWS_ID: (g) => `/client/api/v1/reviews/${g}`,
  CLIENT_V2_REVIEWS: "/client/api/v2/reviews",
  CLIENT_V1_MY_CATEGORY: "/client/api/v1/my-category",
  CLIENT_V1_USER_SEGMENTS: "/client/api/v1/user-segments",
  CLIENT_V1_SUBMISSIONS_ID: (g) => `/client/api/v1/submissions/${g}`,
  CLIENT_V1_SUBMISSIONS_ID_REACTIONS: (g) => `/client/api/v1/submissions/${g}/reactions`,
  CLIENT_V1_SUBMISSIONS_ID_COMMENTS: (g) => `/client/api/v1/submissions/${g}/comments`,
  CLIENT_V1_SUBMISSIONS_ID_CLAPS: (g) => `/client/api/v1/submissions/${g}/claps`,
  CLIENT_V1_SUBMISSIONS_COMMENTS: "/client/api/v1/submissions/comments",
  CLIENT_V1_SUBMISSIONS_COMMENTS_COMMENTID: (g) => `/client/api/v1/submissions/comments/${g}`,
  CLIENT_V1_SUBMISSIONS_ID_NAVIGATION: (g) => `/client/api/v1/submissions/${g}/navigation`,
  CLIENT_V1_SUBMISSIONS_ID_PUBLIC: (g) => `/client/api/v1/submissions/${g}/public`,
  CLIENT_V1_USER_ONBOARDINGS_STATUS: "/client/api/v1/user-onboardings/status",
  CLIENT_V1_USER_ONBOARDINGS_ANSWERS: "/client/api/v1/user-onboardings/answers",
  CLIENT_V1_USAGE_PURPOSES: "/client/api/v1/usage-purposes"
};
function _9({
  url: g,
  options: I,
  requestOptions: C
}) {
  var A;
  const c = _C({
    mutationFn: (l) => Ye.post(g, l, C),
    ...I
  });
  return {
    ...c,
    data: (A = c.data) == null ? void 0 : A.data
  };
}
const q9 = async (g, I) => Ye.get(g, I), $9 = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => q9(I, A),
  ...C
});
function gN(g) {
  var I;
  const C = ug($9(g));
  return {
    ...C,
    data: (I = C.data) == null ? void 0 : I.data
  };
}
const IN = async (g, I) => Ye.get(g, I), CN = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => IN(I, A),
  ...C
});
function AN(g) {
  var I;
  const C = ug(CN(g));
  return {
    ...C,
    data: (I = C.data) == null ? void 0 : I.data
  };
}
const cN = Z9, Fe = {
  CLIENT_V1_ACCOUNTS_VERIFIED_PHONE_NUMBER: "/client/api/v1/accounts/verified-phone-number",
  CLIENT_V2_ACCOUNTS_PROFILE: "/client/api/v2/accounts/profile",
  CLIENT_V1_AUTH_PHONE_VERIFICATION: "/client/api/v1/auth/phone-verification",
  CLIENT_V1_AUTH_CHANGE_PHONE_NUMBER: "/client/api/v1/auth/change/phone-number",
  CLIENT_V1_DASHBOARD_CERTIFICATE_REALNAME: "/client/api/v1/dashboard/certificate-realname",
  CLIENT_V1_BANK_ACCOUNTS_ACCOUNT_HOLDER: "/client/api/v1/bank-accounts/account-holder",
  CLIENT_V1_BUSINESSES_BUSINESSNUMBER_SETTLEMENT_TYPE: (g) => `/client/api/v1/businesses/${g}/settlement-type`
}, lN = async (g, I) => cN.get(g, I), tN = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => lN(I, A),
  ...C
});
function iN(g) {
  var I;
  const C = ug(tN(g));
  return {
    ...C,
    data: (I = C.data) == null ? void 0 : I.data
  };
}
function ze(g) {
  return iN({
    url: Fe.CLIENT_V2_ACCOUNTS_PROFILE,
    queryKey: eN(),
    options: g
  });
}
function eN() {
  return [Fe.CLIENT_V2_ACCOUNTS_PROFILE];
}
const mt = {
  MY_CATEGORY_HIDE: {
    expireDay: 30,
    KEY: (g) => `my_category_hide-${g}`,
    DOMAIN: Ia
  },
  ONBOARDING_NO_SHOW: {
    expireDay: 30,
    KEY: (g) => `onboarding_no_show_${g}`,
    DOMAIN: Ia
  }
};
var nN = {
  prefix: "fas",
  iconName: "sparkles",
  icon: [512, 512, [10024], "f890", "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"]
}, bN = {
  prefix: "fas",
  iconName: "user",
  icon: [448, 512, [128100, 62144], "f007", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"]
}, aN = {
  prefix: "fas",
  iconName: "star",
  icon: [576, 512, [11088, 61446], "f005", "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"]
}, sN = {
  prefix: "fas",
  iconName: "paper-plane-top",
  icon: [512, 512, ["paper-plane-alt", "send"], "e20a", "M49.9 27.8C15.1 12.7-19.2 50.1-1.2 83.5L68.1 212.2c4.4 8.3 12.6 13.8 21.9 15c0 0 0 0 0 0l176 22c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7l-176 22s0 0 0 0c-9.3 1.2-17.5 6.8-21.9 15L-1.2 428.5c-18 33.4 16.3 70.8 51.1 55.7L491.8 292.7c32.1-13.9 32.1-59.5 0-73.4L49.9 27.8z"]
}, uN = {
  prefix: "fas",
  iconName: "mug-hot",
  icon: [512, 512, [9749], "f7b6", "M88 0C74.7 0 64 10.7 64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24zM32 192c-17.7 0-32 14.3-32 32V416c0 53 43 96 96 96H288c53 0 96-43 96-96h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H352 32zm352 64h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H384V256zM224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24z"]
}, dN = {
  prefix: "fas",
  iconName: "seedling",
  icon: [512, 512, [127793, "sprout"], "f4d8", "M512 32c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0h32c17.7 0 32 14.3 32 32zM0 96C0 78.3 14.3 64 32 64H64c123.7 0 224 100.3 224 224v32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320C100.3 320 0 219.7 0 96z"]
}, oN = dN, GN = {
  prefix: "fas",
  iconName: "sparkle",
  icon: [448, 512, [], "e5d6", "M245.8 45.9C241.9 37.4 233.4 32 224 32s-17.9 5.4-21.8 13.9L142.7 174.7 13.9 234.2C5.4 238.1 0 246.6 0 256s5.4 17.9 13.9 21.8l128.8 59.5 59.5 128.8c3.9 8.5 12.4 13.9 21.8 13.9s17.9-5.4 21.8-13.9l59.5-128.8 128.8-59.5c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8L305.3 174.7 245.8 45.9z"]
}, rN = {
  prefix: "fas",
  iconName: "arrow-turn-down-left",
  icon: [512, 512, [], "e2e1", "M448 64c0-17.7 14.3-32 32-32s32 14.3 32 32V224c0 53-43 96-96 96H109.3l73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H416c17.7 0 32-14.3 32-32V64z"]
}, XN = {
  prefix: "fas",
  iconName: "coins",
  icon: [512, 512, [], "f51e", "M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2l0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5V176c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336V300.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4V304v5.7V336zm32 0V304 278.1c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5V272c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5V432c0 44.2-86 80-192 80S0 476.2 0 432V396.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"]
}, ZN = {
  prefix: "fas",
  iconName: "id-card",
  icon: [576, 512, [62147, "drivers-license"], "f2c2", "M0 96l576 0c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 32V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128H0zM64 405.3c0-29.5 23.9-53.3 53.3-53.3H234.7c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16z"]
}, VN = {
  prefix: "fas",
  iconName: "bolt",
  icon: [448, 512, [9889, "zap"], "f0e7", "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"]
}, mN = {
  prefix: "fas",
  iconName: "rocket",
  icon: [512, 512, [], "f135", "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
}, ht = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [320, 512, [9002], "f054", "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
}, hN = {
  prefix: "fas",
  iconName: "briefcase",
  icon: [512, 512, [128188], "f0b1", "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"]
}, WN = {
  prefix: "fas",
  iconName: "book-open",
  icon: [576, 512, [128214, 128366], "f518", "M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5V78.6c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8V454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5V83.8c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11V456c0 11.4 11.7 19.3 22.4 15.5z"]
}, Yd = {}, NN = (g) => encodeURIComponent(g).replace(/[!'()*]/g, (I) => `%${I.charCodeAt(0).toString(16).toUpperCase()}`), Fd = "%[a-f0-9]{2}", Ca = new RegExp("(" + Fd + ")|([^%]+?)", "gi"), Aa = new RegExp("(" + Fd + ")+", "gi");
function hi(g, I) {
  try {
    return [decodeURIComponent(g.join(""))];
  } catch {
  }
  if (g.length === 1)
    return g;
  I = I || 1;
  var C = g.slice(0, I), A = g.slice(I);
  return Array.prototype.concat.call([], hi(C), hi(A));
}
function xN(g) {
  try {
    return decodeURIComponent(g);
  } catch {
    for (var I = g.match(Ca) || [], C = 1; C < I.length; C++)
      g = hi(I, C).join(""), I = g.match(Ca) || [];
    return g;
  }
}
function yN(g) {
  for (var I = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  }, C = Aa.exec(g); C; ) {
    try {
      I[C[0]] = decodeURIComponent(C[0]);
    } catch {
      var A = xN(C[0]);
      A !== C[0] && (I[C[0]] = A);
    }
    C = Aa.exec(g);
  }
  I["%C2"] = "�";
  for (var c = Object.keys(I), l = 0; l < c.length; l++) {
    var t = c[l];
    g = g.replace(new RegExp(t, "g"), I[t]);
  }
  return g;
}
var pN = function(g) {
  if (typeof g != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof g + "`");
  try {
    return g = g.replace(/\+/g, " "), decodeURIComponent(g);
  } catch {
    return yN(g);
  }
}, RN = (g, I) => {
  if (!(typeof g == "string" && typeof I == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (I === "")
    return [g];
  const C = g.indexOf(I);
  return C === -1 ? [g] : [
    g.slice(0, C),
    g.slice(C + I.length)
  ];
}, BN = function(g, I) {
  for (var C = {}, A = Object.keys(g), c = Array.isArray(I), l = 0; l < A.length; l++) {
    var t = A[l], i = g[t];
    (c ? I.indexOf(t) !== -1 : I(t, i, g)) && (C[t] = i);
  }
  return C;
};
(function(g) {
  const I = NN, C = pN, A = RN, c = BN, l = (u) => u == null, t = Symbol("encodeFragmentIdentifier");
  function i(u) {
    switch (u.arrayFormat) {
      case "index":
        return (G) => (V, X) => {
          const W = V.length;
          return X === void 0 || u.skipNull && X === null || u.skipEmptyString && X === "" ? V : X === null ? [...V, [b(G, u), "[", W, "]"].join("")] : [
            ...V,
            [b(G, u), "[", b(W, u), "]=", b(X, u)].join("")
          ];
        };
      case "bracket":
        return (G) => (V, X) => X === void 0 || u.skipNull && X === null || u.skipEmptyString && X === "" ? V : X === null ? [...V, [b(G, u), "[]"].join("")] : [...V, [b(G, u), "[]=", b(X, u)].join("")];
      case "colon-list-separator":
        return (G) => (V, X) => X === void 0 || u.skipNull && X === null || u.skipEmptyString && X === "" ? V : X === null ? [...V, [b(G, u), ":list="].join("")] : [...V, [b(G, u), ":list=", b(X, u)].join("")];
      case "comma":
      case "separator":
      case "bracket-separator": {
        const G = u.arrayFormat === "bracket-separator" ? "[]=" : "=";
        return (V) => (X, W) => W === void 0 || u.skipNull && W === null || u.skipEmptyString && W === "" ? X : (W = W === null ? "" : W, X.length === 0 ? [[b(V, u), G, b(W, u)].join("")] : [[X, b(W, u)].join(u.arrayFormatSeparator)]);
      }
      default:
        return (G) => (V, X) => X === void 0 || u.skipNull && X === null || u.skipEmptyString && X === "" ? V : X === null ? [...V, b(G, u)] : [...V, [b(G, u), "=", b(X, u)].join("")];
    }
  }
  function e(u) {
    let G;
    switch (u.arrayFormat) {
      case "index":
        return (V, X, W) => {
          if (G = /\[(\d*)\]$/.exec(V), V = V.replace(/\[\d*\]$/, ""), !G) {
            W[V] = X;
            return;
          }
          W[V] === void 0 && (W[V] = {}), W[V][G[1]] = X;
        };
      case "bracket":
        return (V, X, W) => {
          if (G = /(\[\])$/.exec(V), V = V.replace(/\[\]$/, ""), !G) {
            W[V] = X;
            return;
          }
          if (W[V] === void 0) {
            W[V] = [X];
            return;
          }
          W[V] = [].concat(W[V], X);
        };
      case "colon-list-separator":
        return (V, X, W) => {
          if (G = /(:list)$/.exec(V), V = V.replace(/:list$/, ""), !G) {
            W[V] = X;
            return;
          }
          if (W[V] === void 0) {
            W[V] = [X];
            return;
          }
          W[V] = [].concat(W[V], X);
        };
      case "comma":
      case "separator":
        return (V, X, W) => {
          const N = typeof X == "string" && X.includes(u.arrayFormatSeparator), m = typeof X == "string" && !N && a(X, u).includes(u.arrayFormatSeparator);
          X = m ? a(X, u) : X;
          const p = N || m ? X.split(u.arrayFormatSeparator).map((Y) => a(Y, u)) : X === null ? X : a(X, u);
          W[V] = p;
        };
      case "bracket-separator":
        return (V, X, W) => {
          const N = /(\[\])$/.test(V);
          if (V = V.replace(/\[\]$/, ""), !N) {
            W[V] = X && a(X, u);
            return;
          }
          const m = X === null ? [] : X.split(u.arrayFormatSeparator).map((p) => a(p, u));
          if (W[V] === void 0) {
            W[V] = m;
            return;
          }
          W[V] = [].concat(W[V], m);
        };
      default:
        return (V, X, W) => {
          if (W[V] === void 0) {
            W[V] = X;
            return;
          }
          W[V] = [].concat(W[V], X);
        };
    }
  }
  function n(u) {
    if (typeof u != "string" || u.length !== 1)
      throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function b(u, G) {
    return G.encode ? G.strict ? I(u) : encodeURIComponent(u) : u;
  }
  function a(u, G) {
    return G.decode ? C(u) : u;
  }
  function s(u) {
    return Array.isArray(u) ? u.sort() : typeof u == "object" ? s(Object.keys(u)).sort((G, V) => Number(G) - Number(V)).map((G) => u[G]) : u;
  }
  function d(u) {
    const G = u.indexOf("#");
    return G !== -1 && (u = u.slice(0, G)), u;
  }
  function Z(u) {
    let G = "";
    const V = u.indexOf("#");
    return V !== -1 && (G = u.slice(V)), G;
  }
  function r(u) {
    u = d(u);
    const G = u.indexOf("?");
    return G === -1 ? "" : u.slice(G + 1);
  }
  function h(u, G) {
    return G.parseNumbers && !Number.isNaN(Number(u)) && typeof u == "string" && u.trim() !== "" ? u = Number(u) : G.parseBooleans && u !== null && (u.toLowerCase() === "true" || u.toLowerCase() === "false") && (u = u.toLowerCase() === "true"), u;
  }
  function x(u, G) {
    G = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1
    }, G), n(G.arrayFormatSeparator);
    const V = e(G), X = /* @__PURE__ */ Object.create(null);
    if (typeof u != "string" || (u = u.trim().replace(/^[?#&]/, ""), !u))
      return X;
    for (const W of u.split("&")) {
      if (W === "")
        continue;
      let [N, m] = A(G.decode ? W.replace(/\+/g, " ") : W, "=");
      m = m === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(G.arrayFormat) ? m : a(m, G), V(a(N, G), m, X);
    }
    for (const W of Object.keys(X)) {
      const N = X[W];
      if (typeof N == "object" && N !== null)
        for (const m of Object.keys(N))
          N[m] = h(N[m], G);
      else
        X[W] = h(N, G);
    }
    return G.sort === !1 ? X : (G.sort === !0 ? Object.keys(X).sort() : Object.keys(X).sort(G.sort)).reduce((W, N) => {
      const m = X[N];
      return m && typeof m == "object" && !Array.isArray(m) ? W[N] = s(m) : W[N] = m, W;
    }, /* @__PURE__ */ Object.create(null));
  }
  g.extract = r, g.parse = x, g.stringify = (u, G) => {
    if (!u)
      return "";
    G = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ","
    }, G), n(G.arrayFormatSeparator);
    const V = (m) => G.skipNull && l(u[m]) || G.skipEmptyString && u[m] === "", X = i(G), W = {};
    for (const m of Object.keys(u))
      V(m) || (W[m] = u[m]);
    const N = Object.keys(W);
    return G.sort !== !1 && N.sort(G.sort), N.map((m) => {
      const p = u[m];
      return p === void 0 ? "" : p === null ? b(m, G) : Array.isArray(p) ? p.length === 0 && G.arrayFormat === "bracket-separator" ? b(m, G) + "[]" : p.reduce(X(m), []).join("&") : b(m, G) + "=" + b(p, G);
    }).filter((m) => m.length > 0).join("&");
  }, g.parseUrl = (u, G) => {
    G = Object.assign({
      decode: !0
    }, G);
    const [V, X] = A(u, "#");
    return Object.assign(
      {
        url: V.split("?")[0] || "",
        query: x(r(u), G)
      },
      G && G.parseFragmentIdentifier && X ? { fragmentIdentifier: a(X, G) } : {}
    );
  }, g.stringifyUrl = (u, G) => {
    G = Object.assign({
      encode: !0,
      strict: !0,
      [t]: !0
    }, G);
    const V = d(u.url).split("?")[0] || "", X = g.extract(u.url), W = g.parse(X, { sort: !1 }), N = Object.assign(W, u.query);
    let m = g.stringify(N, G);
    m && (m = `?${m}`);
    let p = Z(u.url);
    return u.fragmentIdentifier && (p = `#${G[t] ? b(u.fragmentIdentifier, G) : u.fragmentIdentifier}`), `${V}${m}${p}`;
  }, g.pick = (u, G, V) => {
    V = Object.assign({
      parseFragmentIdentifier: !0,
      [t]: !1
    }, V);
    const { url: X, query: W, fragmentIdentifier: N } = g.parseUrl(u, V);
    return g.stringifyUrl({
      url: X,
      query: c(W, G),
      fragmentIdentifier: N
    }, V);
  }, g.exclude = (u, G, V) => {
    const X = Array.isArray(G) ? (W) => !G.includes(W) : (W, N) => !G(W, N);
    return g.pick(u, X, V);
  };
})(Yd);
const tc = /* @__PURE__ */ OI(Yd), kC = {
  BEFORE_CONVERSATION: "before_conversation",
  DURING_CONVERSATION: "during_conversation",
  AFTER_RECOMMENDATION: "after_recommendation"
}, DA = {
  POPULAR_COURSES: "popular_courses",
  AI_RECOMMENDATION: "ai_recommendation"
}, Ug = {
  VIEW_MYCATEGORY: "view_mycategory",
  CLICK_SAVE_MYCATEGORY: "click_save_mycategory",
  COMPLETE_LANGUAGE_CHANGE: "complete_language_change",
  VIEW_LANGUAGE_SETTING: "view_language_setting",
  COMPLETE_PHONE_AUTH: "complete_phone_auth",
  CLICK_PHONE_AUTH_REQ_DIGIT: "click_phone_auth_req_digit",
  VIEW_PHONE_AUTH_MODAL: "view_phone_auth_modal",
  CLICK_PHONE_AUTH_SUBMIT: "click_phone_auth_submit",
  // AB 테스트 추적 이벤트
  EXPERIMENT_STARTED: "experiment_started",
  // 온보딩 모달 이벤트
  VIEW_ONBOARDING_RECOMMENDATION_MODAL: "view_onboarding_recommendation_modal",
  VIEW_COURSES_RECOMMENDATION: "view_courses_recommendation",
  CLICK_ONBOARDING_SELECTION: "click_onboarding_selection",
  SUBMIT_ONBOARDING_QUESTION: "submit_onboarding_question",
  CLICK_COURSE_AT_RECOMMENDATION: "click_course_at_recommendation",
  CLICK_RECOMMENDATION_CLOSE: "click_recommendation_close",
  CLICK_VIEW_MORE_RECOMMENDATION: "click_view_more_recommendation",
  // LLM 추천 이벤트
  CLICK_START_LLM_RECOMMENDATION: "click_start_llm_recommendation",
  START_LLM_RECOMMENDATION_SESSION: "start_llm_recommendation_session",
  SEND_LLM_PROMPT: "send_llm_prompt",
  CLICK_LLM_SUGGESTION: "click_llm_suggestion",
  VIEW_LLM_QUESTION: "view_llm_question",
  CLICK_BACK_TO_POPULAR_COURSES: "click_back_to_popular_courses",
  CLICK_LLM_WANT_MORE_CHAT: "click_llm_want_more_chat"
};
function zd() {
  const g = qA(), I = Ag(/* @__PURE__ */ new Set()), {
    analytics: C
  } = Ds(), A = () => {
    const l = g.getQueryData([Fe.CLIENT_V2_ACCOUNTS_PROFILE]);
    if (!(l != null && l.data))
      return {
        user_id: null,
        user_name: null,
        user_email: null,
        user_group_id: null,
        user_group_subscription_id: null,
        role_b2b: !1,
        role_b2c: !1,
        role_admin: !1,
        role_instructor: !1
      };
    const {
      id: t,
      name: i,
      email: e,
      isAdmin: n,
      isInstructor: b,
      group: a
    } = l.data, s = !!a;
    return {
      user_id: t,
      user_name: i,
      user_email: e,
      user_group_id: a == null ? void 0 : a.id,
      user_group_subscription_id: a == null ? void 0 : a.groupSubscriptionId,
      role_b2b: s,
      role_b2c: !s,
      role_admin: n,
      role_instructor: b
    };
  };
  function c(l, t) {
    const {
      props: i,
      once: e = !1
    } = t || {};
    if (!window.dataLayer) {
      console.log("[LOG] dataLayer is not defined");
      return;
    }
    if (e) {
      if (I.current.has(l)) {
        console.log(`[LOG] Event "${l}" already tracked, skipping...`);
        return;
      }
      I.current.add(l);
    }
    return C.track(l, {
      mixpanelToken: s9,
      userId: A().user_id,
      mxp___user: A(),
      ...i
    });
  }
  return {
    trackEvent: c
  };
}
var D3 = {
  prefix: "far",
  iconName: "language",
  icon: [640, 512, [], "f1ab", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H272h32 16H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H320 304 272 64zm512 48c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H320V112H576zM178.3 175.9l64 144c4.5 10.1-.1 21.9-10.2 26.4s-21.9-.1-26.4-10.2L196.8 316H123.2l-8.9 20.1c-4.5 10.1-16.3 14.6-26.4 10.2s-14.6-16.3-10.2-26.4l64-144c3.2-7.2 10.4-11.9 18.3-11.9s15.1 4.7 18.3 11.9zM179 276l-19-42.8L141 276h38zM456 164c-11 0-20 9-20 20v4H384c-11 0-20 9-20 20s9 20 20 20h72 35.1c-7.3 16.7-17.4 31.9-29.8 45l-.5-.5-14.6-14.6c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3L430 298.3c-5.9 3.6-12.1 6.9-18.5 9.8l-3.6 1.6c-10.1 4.5-14.6 16.3-10.2 26.4s16.3 14.6 26.4 10.2l3.6-1.6c12-5.3 23.4-11.8 34-19.4c4.3 3 8.6 5.8 13.1 8.5l18.9 11.3c9.5 5.7 21.8 2.6 27.4-6.9s2.6-21.8-6.9-27.4l-18.9-11.3c-.9-.5-1.8-1.1-2.7-1.6c17.2-18.8 30.7-40.9 39.6-65.4L534 228h2c11 0 20-9 20-20s-9-20-20-20H520 476v-4c0-11-9-20-20-20z"]
}, ca = {
  prefix: "far",
  iconName: "pen",
  icon: [512, 512, [128394], "f304", "M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8L321 129 383 191 154.6 419.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4z"]
}, vN = {
  prefix: "far",
  iconName: "arrow-left",
  icon: [448, 512, [8592], "f060", "M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z"]
}, JN = {
  prefix: "far",
  iconName: "angle-down",
  icon: [448, 512, [8964], "f107", "M241 337c-9.4 9.4-24.6 9.4-33.9 0L47 177c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 337z"]
}, YN = {
  prefix: "far",
  iconName: "xmark-large",
  icon: [448, 512, [], "e59b", "M41 39C31.6 29.7 16.4 29.7 7 39S-2.3 63.6 7 73l183 183L7 439c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l183-183L407 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-183-183L441 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-183 183L41 39z"]
}, FN = {
  prefix: "far",
  iconName: "arrow-down",
  icon: [384, 512, [8595], "f063", "M174.6 472.6c4.5 4.7 10.8 7.4 17.4 7.4s12.8-2.7 17.4-7.4l168-176c9.2-9.6 8.8-24.8-.8-33.9s-24.8-8.8-33.9 .8L216 396.1 216 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 340.1L41.4 263.4c-9.2-9.6-24.3-9.9-33.9-.8s-9.9 24.3-.8 33.9l168 176z"]
};
function uA(g, I) {
  return () => eC.t(g, I) ?? "";
}
function zN(g) {
  return hg("modals", g);
}
var hl = { exports: {} };
hl.exports;
(function(g, I) {
  (function(C, A) {
    g.exports = A();
  })(GI, function() {
    var C, A, c = 1e3, l = 6e4, t = 36e5, i = 864e5, e = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, n = 31536e6, b = 2628e6, a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, s = { years: n, months: b, days: i, hours: t, minutes: l, seconds: c, milliseconds: 1, weeks: 6048e5 }, d = function(W) {
      return W instanceof V;
    }, Z = function(W, N, m) {
      return new V(W, m, N.$l);
    }, r = function(W) {
      return A.p(W) + "s";
    }, h = function(W) {
      return W < 0;
    }, x = function(W) {
      return h(W) ? Math.ceil(W) : Math.floor(W);
    }, u = function(W) {
      return Math.abs(W);
    }, G = function(W, N) {
      return W ? h(W) ? { negative: !0, format: "" + u(W) + N } : { negative: !1, format: "" + W + N } : { negative: !1, format: "" };
    }, V = function() {
      function W(m, p, Y) {
        var v = this;
        if (this.$d = {}, this.$l = Y, m === void 0 && (this.$ms = 0, this.parseFromMilliseconds()), p)
          return Z(m * s[r(p)], this);
        if (typeof m == "number")
          return this.$ms = m, this.parseFromMilliseconds(), this;
        if (typeof m == "object")
          return Object.keys(m).forEach(function(z) {
            v.$d[r(z)] = m[z];
          }), this.calMilliseconds(), this;
        if (typeof m == "string") {
          var Q = m.match(a);
          if (Q) {
            var cg = Q.slice(2).map(function(z) {
              return z != null ? Number(z) : 0;
            });
            return this.$d.years = cg[0], this.$d.months = cg[1], this.$d.weeks = cg[2], this.$d.days = cg[3], this.$d.hours = cg[4], this.$d.minutes = cg[5], this.$d.seconds = cg[6], this.calMilliseconds(), this;
          }
        }
        return this;
      }
      var N = W.prototype;
      return N.calMilliseconds = function() {
        var m = this;
        this.$ms = Object.keys(this.$d).reduce(function(p, Y) {
          return p + (m.$d[Y] || 0) * s[Y];
        }, 0);
      }, N.parseFromMilliseconds = function() {
        var m = this.$ms;
        this.$d.years = x(m / n), m %= n, this.$d.months = x(m / b), m %= b, this.$d.days = x(m / i), m %= i, this.$d.hours = x(m / t), m %= t, this.$d.minutes = x(m / l), m %= l, this.$d.seconds = x(m / c), m %= c, this.$d.milliseconds = m;
      }, N.toISOString = function() {
        var m = G(this.$d.years, "Y"), p = G(this.$d.months, "M"), Y = +this.$d.days || 0;
        this.$d.weeks && (Y += 7 * this.$d.weeks);
        var v = G(Y, "D"), Q = G(this.$d.hours, "H"), cg = G(this.$d.minutes, "M"), z = this.$d.seconds || 0;
        this.$d.milliseconds && (z += this.$d.milliseconds / 1e3, z = Math.round(1e3 * z) / 1e3);
        var J = G(z, "S"), y = m.negative || p.negative || v.negative || Q.negative || cg.negative || J.negative, f = Q.format || cg.format || J.format ? "T" : "", B = (y ? "-" : "") + "P" + m.format + p.format + v.format + f + Q.format + cg.format + J.format;
        return B === "P" || B === "-P" ? "P0D" : B;
      }, N.toJSON = function() {
        return this.toISOString();
      }, N.format = function(m) {
        var p = m || "YYYY-MM-DDTHH:mm:ss", Y = { Y: this.$d.years, YY: A.s(this.$d.years, 2, "0"), YYYY: A.s(this.$d.years, 4, "0"), M: this.$d.months, MM: A.s(this.$d.months, 2, "0"), D: this.$d.days, DD: A.s(this.$d.days, 2, "0"), H: this.$d.hours, HH: A.s(this.$d.hours, 2, "0"), m: this.$d.minutes, mm: A.s(this.$d.minutes, 2, "0"), s: this.$d.seconds, ss: A.s(this.$d.seconds, 2, "0"), SSS: A.s(this.$d.milliseconds, 3, "0") };
        return p.replace(e, function(v, Q) {
          return Q || String(Y[v]);
        });
      }, N.as = function(m) {
        return this.$ms / s[r(m)];
      }, N.get = function(m) {
        var p = this.$ms, Y = r(m);
        return Y === "milliseconds" ? p %= 1e3 : p = Y === "weeks" ? x(p / s[Y]) : this.$d[Y], p || 0;
      }, N.add = function(m, p, Y) {
        var v;
        return v = p ? m * s[r(p)] : d(m) ? m.$ms : Z(m, this).$ms, Z(this.$ms + v * (Y ? -1 : 1), this);
      }, N.subtract = function(m, p) {
        return this.add(m, p, !0);
      }, N.locale = function(m) {
        var p = this.clone();
        return p.$l = m, p;
      }, N.clone = function() {
        return Z(this.$ms, this);
      }, N.humanize = function(m) {
        return C().add(this.$ms, "ms").locale(this.$l).fromNow(!m);
      }, N.valueOf = function() {
        return this.asMilliseconds();
      }, N.milliseconds = function() {
        return this.get("milliseconds");
      }, N.asMilliseconds = function() {
        return this.as("milliseconds");
      }, N.seconds = function() {
        return this.get("seconds");
      }, N.asSeconds = function() {
        return this.as("seconds");
      }, N.minutes = function() {
        return this.get("minutes");
      }, N.asMinutes = function() {
        return this.as("minutes");
      }, N.hours = function() {
        return this.get("hours");
      }, N.asHours = function() {
        return this.as("hours");
      }, N.days = function() {
        return this.get("days");
      }, N.asDays = function() {
        return this.as("days");
      }, N.weeks = function() {
        return this.get("weeks");
      }, N.asWeeks = function() {
        return this.as("weeks");
      }, N.months = function() {
        return this.get("months");
      }, N.asMonths = function() {
        return this.as("months");
      }, N.years = function() {
        return this.get("years");
      }, N.asYears = function() {
        return this.as("years");
      }, W;
    }(), X = function(W, N, m) {
      return W.add(N.years() * m, "y").add(N.months() * m, "M").add(N.days() * m, "d").add(N.hours() * m, "h").add(N.minutes() * m, "m").add(N.seconds() * m, "s").add(N.milliseconds() * m, "ms");
    };
    return function(W, N, m) {
      C = m, A = m().$utils(), m.duration = function(v, Q) {
        var cg = m.locale();
        return Z(v, { $l: cg }, Q);
      }, m.isDuration = d;
      var p = N.prototype.add, Y = N.prototype.subtract;
      N.prototype.add = function(v, Q) {
        return d(v) ? X(this, v, 1) : p.bind(this)(v, Q);
      }, N.prototype.subtract = function(v, Q) {
        return d(v) ? X(this, v, -1) : Y.bind(this)(v, Q);
      };
    };
  });
})(hl, hl.exports);
var fN = hl.exports;
const HN = /* @__PURE__ */ OI(fN);
AI.extend(HN);
AI.locale(dC);
function wN({
  lang: g,
  isOpened: I
}) {
  const [C, A] = Os(!1), c = async (l) => {
    eC.language !== l && (await eC.changeLanguage(l), AI.locale(l));
  };
  return q(function() {
    if (!I)
      return;
    const l = L9(g) ? g : dC;
    c(l).then(() => {
      A.open();
    });
  }, [g, I]), q(function() {
    I || A.close();
  }, [I]), {
    isReady: C,
    i18nInstance: eC
  };
}
const SN = () => [VC.CLIENT_V1_COURSE_RECOMMENDATIONS_USER_ONBOARDING_LLM];
function fd({
  lang: g = "ko",
  limit: I = 20,
  options: C
} = {}) {
  return j9({
    queryKey: fe({
      lang: g,
      limit: I
    }),
    url: tc.stringifyUrl({
      url: VC.CLIENT_V1_COURSE_RECOMMENDATIONS_USER_ONBOARDING,
      query: {
        lang: g,
        limit: I
      }
    }),
    options: C
  });
}
const fe = ({
  lang: g = "ko",
  limit: I
} = {}) => [VC.CLIENT_V1_COURSE_RECOMMENDATIONS_USER_ONBOARDING, {
  lang: g,
  limit: I
}], $l = X9, jI = {
  CLIENT_V1_USER_ONBOARDINGS_LATEST_SESSION: "/client/api/v1/user-onboardings/latest-session",
  CLIENT_V1_USER_ONBOARDINGS_SUGGESTED_QUESTIONS: "/client/api/v1/user-onboardings/suggested-questions",
  CLIENT_V1_USER_ONBOARDINGS_STREAM: "/client/api/v1/user-onboardings/stream",
  CLIENT_V1_USER_ONBOARDINGS_SATISFIES_SURVEY: "/client/api/v1/user-onboardings/satisfies-survey",
  CLIENT_V1_USER_ONBOARDINGS_SESSIONS_SESSIONID_SATISFIES_SURVEY_EXISTS: (g) => `/client/api/v1/user-onboardings/sessions/${g}/satisfies-survey/exists`
};
function TN({
  url: g,
  options: I,
  requestOptions: C
}) {
  var A;
  const c = _C({
    mutationFn: (l) => $l.post(g, l, C),
    ...I
  });
  return {
    ...c,
    data: (A = c.data) == null ? void 0 : A.data
  };
}
const LN = async (g, I) => $l.get(g, I), UN = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => LN(I, A),
  ...C
});
function PN(g) {
  var I;
  const C = ug(UN(g));
  return {
    ...C,
    data: (I = C.data) == null ? void 0 : I.data
  };
}
const kN = async (g, I) => $l.get(g, I), DN = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => kN(I, A),
  ...C
});
function ON(g) {
  var I;
  const C = ug(DN(g));
  return {
    ...C,
    data: (I = C.data) == null ? void 0 : I.data
  };
}
const jN = async (g, I) => $l.get(g, I), EN = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => jN(I, A),
  ...C
});
function QN(g) {
  var I;
  const C = ug(EN(g));
  return {
    ...C,
    data: (I = C.data) == null ? void 0 : I.data
  };
}
function Hd({
  options: g
}) {
  return PN({
    queryKey: Wl(),
    url: jI.CLIENT_V1_USER_ONBOARDINGS_LATEST_SESSION,
    options: g
  });
}
const Wl = () => [jI.CLIENT_V1_USER_ONBOARDINGS_LATEST_SESSION], MN = () => [mC.CLIENT_V1_USER_ONBOARDINGS_STATUS], KN = () => [mC.CLIENT_V1_USER_SEGMENTS], wd = jg(null), _N = () => {
  const g = Zg(wd);
  if (!g)
    throw new Error("useOnboardingContext must be used within OnboardingProvider");
  return g;
}, OA = {
  POP_UP: "pop-up",
  SEARCHBAR: "searchbar",
  SHORTCUT: "shortcut",
  SEARCH_RESULT: "search-result",
  SRP: "srp",
  MY_SETTINGS: "my_settings"
}, O3 = ({
  children: g,
  lang: I,
  onModalOpen: C,
  onModalClose: A,
  onSkip: c,
  onSubmit: l
}) => {
  const [t, i] = O(!1), [e, n] = O(OA.POP_UP), [b, a] = O(!1), [s, d] = O(void 0), [Z, r] = O(void 0), h = qA(), {
    data: x
  } = ze({
    suspense: !1,
    useErrorBoundary: !1
  }), u = k((m) => {
    n((m == null ? void 0 : m.entryPoint) ?? OA.POP_UP), a((m == null ? void 0 : m.isFirstSignUp) ?? !1), d(m == null ? void 0 : m.initialView), r(m == null ? void 0 : m.redirectTo), i(!0), C == null || C();
  }, [C]), G = k(() => {
    i(!1), x != null && x.id && YW.set(mt.ONBOARDING_NO_SHOW.KEY(x.id), "true", {
      expires: mt.ONBOARDING_NO_SHOW.expireDay,
      domain: mt.ONBOARDING_NO_SHOW.DOMAIN
    }), h.invalidateQueries({
      queryKey: KN()
    }), h.invalidateQueries({
      queryKey: MN()
    }), h.invalidateQueries({
      queryKey: fe({
        lang: I,
        limit: 20
      })
    }), h.invalidateQueries({
      queryKey: SN()
    }), h.invalidateQueries({
      queryKey: Wl()
    });
  }, [h, I, x]), V = k(() => {
    if (G(), A == null || A(), Z) {
      window.location.href = Z;
      return;
    }
  }, [A, G, Z]), X = k(() => {
    if (G(), c == null || c(), Z) {
      window.location.href = Z;
      return;
    }
  }, [c, G, Z]), W = k(() => {
    if (G(), l == null || l(), Z) {
      window.location.href = Z;
      return;
    }
  }, [l, G, Z]), N = tg(() => ({
    isModalOpen: t,
    openModal: u,
    closeModal: V,
    skipOnboarding: X,
    handleOnboardingSubmit: W,
    entryPoint: e,
    isFirstSignUp: b,
    initialView: s,
    redirectTo: Z
  }), [t, u, V, X, W, e, b, s, Z]);
  return /* @__PURE__ */ o(wd.Provider, { value: N, children: g });
};
function He() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var qN = process.env.NODE_ENV === "production" ? {
  name: "1dw4bon",
  styles: "flex-shrink:0;border-radius:16px;overflow:hidden"
} : {
  name: "1qwdq4k-CourseCardArticleSkeleton",
  styles: "flex-shrink:0;border-radius:16px;overflow:hidden;label:CourseCardArticleSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: He
}, $N = process.env.NODE_ENV === "production" ? {
  name: "fxp7t8",
  styles: "flex:1;min-width:0"
} : {
  name: "f8iznf-CourseCardArticleSkeleton",
  styles: "flex:1;min-width:0;label:CourseCardArticleSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: He
};
const Hc = yg(function() {
  return /* @__PURE__ */ R(Cg, { gap: 16, align: "flex-start", w: "100%", children: [
    /* @__PURE__ */ o(P, { w: 120, css: qN, children: /* @__PURE__ */ o(Ys, { ratio: 3 / 1.95, children: /* @__PURE__ */ o(ng, { w: "100%", h: "100%" }) }) }),
    /* @__PURE__ */ R(Cg, { direction: "column", gap: 6, css: $N, children: [
      /* @__PURE__ */ o(ng, { h: 20, w: "100%" }),
      /* @__PURE__ */ o(ng, { h: 20, w: "60%" }),
      /* @__PURE__ */ o(ng, { h: 14, w: 80 }),
      /* @__PURE__ */ o(ng, { h: 14, w: 100 })
    ] })
  ] });
});
var gx = process.env.NODE_ENV === "production" ? {
  name: "e2t4mt",
  styles: "flex-shrink:0;border-radius:8px;overflow:hidden"
} : {
  name: "58s91u-CourseCardArticle",
  styles: "flex-shrink:0;border-radius:8px;overflow:hidden;label:CourseCardArticle;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvbW9kYWxzL3NyYy9jb21wb25lbnRzL09uYm9hcmRpbmdNb2RhbC9jb21wb25lbnRzL0NvdXJzZUNhcmRBcnRpY2xlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE2RXFCIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvbW9kYWxzL3NyYy9jb21wb25lbnRzL09uYm9hcmRpbmdNb2RhbC9jb21wb25lbnRzL0NvdXJzZUNhcmRBcnRpY2xlLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7XG4gIEFzcGVjdFJhdGlvLFxuICBCb3gsXG4gIENPTE9SX1BBTEVUVEUsXG4gIGRlc2t0b3BGaXJzdE1lZGlhUXVlcnksXG4gIEZsZXgsXG4gIEdyb3VwLFxuICBJY29uLFxuICBPcHRpbWl6ZUltYWdlLFxuICBTa2VsZXRvbixcbiAgVGV4dCxcbn0gZnJvbSAnQGluZmxlYXJuL2RzLXJlYWN0JztcbmltcG9ydCB7IGZhU3RhciwgZmFVc2VyIH0gZnJvbSAnQGluZmxlYXJuL3Byby1zb2xpZC1zdmctaWNvbnMnO1xuaW1wb3J0IHsgbWVtbyB9IGZyb20gJ3JlYWN0JztcblxuaW50ZXJmYWNlIENvdXJzZUNhcmRBcnRpY2xlUHJvcHMge1xuICB0aXRsZTogc3RyaW5nO1xuICBpbnN0cnVjdG9yTmFtZTogc3RyaW5nO1xuICB0aHVtYm5haWxVcmw6IHN0cmluZztcbiAgc3RhcjogbnVtYmVyO1xuICByZXZpZXdDb3VudDogbnVtYmVyO1xuICBzdHVkZW50Q291bnQ6IG51bWJlcjtcbiAgc2x1Zzogc3RyaW5nO1xuICB1cmw/OiBzdHJpbmc7XG4gIG9uQ2xpY2s/OiAoKSA9PiB2b2lkO1xufVxuXG4vKiog7Iqk7LyI66CI7YakIOy7tO2PrOuEjO2KuCAqL1xuZXhwb3J0IGNvbnN0IENvdXJzZUNhcmRBcnRpY2xlU2tlbGV0b24gPSBtZW1vKGZ1bmN0aW9uIENvdXJzZUNhcmRBcnRpY2xlU2tlbGV0b24oKSB7XG4gIHJldHVybiAoXG4gICAgPEZsZXggZ2FwPXsxNn0gYWxpZ249XCJmbGV4LXN0YXJ0XCIgdz1cIjEwMCVcIj5cbiAgICAgIHsvKiDsjbjrhKTsnbwg7Iqk7LyI66CI7YakICovfVxuICAgICAgPEJveCB3PXsxMjB9IGNzcz17eyBmbGV4U2hyaW5rOiAwLCBib3JkZXJSYWRpdXM6IDE2LCBvdmVyZmxvdzogJ2hpZGRlbicgfX0+XG4gICAgICAgIDxBc3BlY3RSYXRpbyByYXRpbz17MyAvIDEuOTV9PlxuICAgICAgICAgIDxTa2VsZXRvbiB3PVwiMTAwJVwiIGg9XCIxMDAlXCIgLz5cbiAgICAgICAgPC9Bc3BlY3RSYXRpbz5cbiAgICAgIDwvQm94PlxuXG4gICAgICB7Lyog7L2Y7YWQ7LigIOyKpOy8iOugiO2GpCAqL31cbiAgICAgIDxGbGV4IGRpcmVjdGlvbj1cImNvbHVtblwiIGdhcD17Nn0gY3NzPXt7IGZsZXg6IDEsIG1pbldpZHRoOiAwIH19PlxuICAgICAgICA8U2tlbGV0b24gaD17MjB9IHc9XCIxMDAlXCIgLz5cbiAgICAgICAgPFNrZWxldG9uIGg9ezIwfSB3PVwiNjAlXCIgLz5cbiAgICAgICAgPFNrZWxldG9uIGg9ezE0fSB3PXs4MH0gLz5cbiAgICAgICAgPFNrZWxldG9uIGg9ezE0fSB3PXsxMDB9IC8+XG4gICAgICA8L0ZsZXg+XG4gICAgPC9GbGV4PlxuICApO1xufSk7XG5cbmV4cG9ydCBjb25zdCBDb3Vyc2VDYXJkQXJ0aWNsZSA9IG1lbW8oZnVuY3Rpb24gQ291cnNlQ2FyZEFydGljbGUoe1xuICB0aXRsZSxcbiAgaW5zdHJ1Y3Rvck5hbWUsXG4gIHRodW1ibmFpbFVybCxcbiAgc3RhcixcbiAgcmV2aWV3Q291bnQsXG4gIHN0dWRlbnRDb3VudCxcbiAgc2x1ZyxcbiAgdXJsLFxuICBvbkNsaWNrLFxufTogQ291cnNlQ2FyZEFydGljbGVQcm9wcykge1xuICBjb25zdCBocmVmID1cbiAgICB1cmwgJiYgKC9eaHR0cHM/OlxcL1xcLy8udGVzdCh1cmwpIHx8IHVybC5zdGFydHNXaXRoKCcvJykpID8gdXJsIDogc2x1ZyA/IGAvY291cnNlLyR7c2x1Z31gIDogJyMnO1xuXG4gIHJldHVybiAoXG4gICAgPGFcbiAgICAgIGhyZWY9e2hyZWZ9XG4gICAgICB0YXJnZXQ9XCJfYmxhbmtcIlxuICAgICAgcmVsPVwibm9vcGVuZXIgbm9yZWZlcnJlclwiXG4gICAgICBzdHlsZT17eyB0ZXh0RGVjb3JhdGlvbjogJ25vbmUnIH19XG4gICAgICBvbkNsaWNrPXtvbkNsaWNrfT5cbiAgICAgIDxGbGV4XG4gICAgICAgIGdhcD17MTZ9XG4gICAgICAgIGFsaWduPVwiZmxleC1zdGFydFwiXG4gICAgICAgIHc9XCIxMDAlXCJcbiAgICAgICAgcD17MTZ9XG4gICAgICAgIGNzcz17eyBib3JkZXJSYWRpdXM6IDE2LCBib3JkZXI6IGAxcHggc29saWQgJHtDT0xPUl9QQUxFVFRFLmdyYXlbM119YCB9fT5cbiAgICAgICAgey8qIOyNuOuEpOydvCAqL31cbiAgICAgICAgPEJveCB3PXsxMjB9IGNzcz17eyBmbGV4U2hyaW5rOiAwLCBib3JkZXJSYWRpdXM6IDgsIG92ZXJmbG93OiAnaGlkZGVuJyB9fT5cbiAgICAgICAgICA8QXNwZWN0UmF0aW8gcmF0aW89ezMgLyAxLjk1fT5cbiAgICAgICAgICAgIDxPcHRpbWl6ZUltYWdlIHdpZHRoPVwiMTAwJVwiIGhlaWdodD1cIjEwMCVcIiB3PXsyNDB9IHNyYz17dGh1bWJuYWlsVXJsfSBhbHQ9e3RpdGxlfSAvPlxuICAgICAgICAgIDwvQXNwZWN0UmF0aW8+XG4gICAgICAgIDwvQm94PlxuXG4gICAgICAgIHsvKiDsvZjthZDsuKAgKi99XG4gICAgICAgIDxGbGV4XG4gICAgICAgICAgZGlyZWN0aW9uPVwiY29sdW1uXCJcbiAgICAgICAgICBnYXA9ezZ9XG4gICAgICAgICAgY3NzPXt7IGZsZXg6IDEsIG1pbldpZHRoOiAwLCBbZGVza3RvcEZpcnN0TWVkaWFRdWVyeS5tb2JpbGVdOiB7IGdhcDogMiB9IH19PlxuICAgICAgICAgIDxUZXh0XG4gICAgICAgICAgICBmej1cIm1kXCJcbiAgICAgICAgICAgIGZ3PXs2MDB9XG4gICAgICAgICAgICBsaD17MS4zfVxuICAgICAgICAgICAgY29sb3I9XCJncmF5LjlcIlxuICAgICAgICAgICAgY3NzPXt7IFtkZXNrdG9wRmlyc3RNZWRpYVF1ZXJ5Lm1vYmlsZV06IHsgZm9udFNpemU6IDE0IH0sIHdvcmRCcmVhazogJ2JyZWFrLWFsbCcgfX0+XG4gICAgICAgICAgICB7dGl0bGV9XG4gICAgICAgICAgPC9UZXh0PlxuXG4gICAgICAgICAgPFRleHQgZno9XCJtZFwiIGZ3PXs0MDB9IGxoPXsxLjN9IGNvbG9yPVwiZ3JheS42XCI+XG4gICAgICAgICAgICB7aW5zdHJ1Y3Rvck5hbWV9XG4gICAgICAgICAgPC9UZXh0PlxuXG4gICAgICAgICAgPEdyb3VwIHNwYWNpbmc9ezh9PlxuICAgICAgICAgICAgey8qIOuzhOygkCAtIHJldmlld0NvdW506rCAIDDrs7Tri6Qg7YG0IOuVjOunjCDtkZzsi5wgKi99XG4gICAgICAgICAgICB7cmV2aWV3Q291bnQgPiAwICYmIChcbiAgICAgICAgICAgICAgPEdyb3VwIHNwYWNpbmc9ezJ9PlxuICAgICAgICAgICAgICAgIDxJY29uIGljb249e2ZhU3Rhcn0gc2l6ZT1cInhzXCIgY29sb3I9XCJ5ZWxsb3cuNlwiIC8+XG4gICAgICAgICAgICAgICAgPFRleHQgZno9XCJzbVwiIGZ3PXs2MDB9IGxoPXsxLjI1fSBjb2xvcj1cImdyYXkuN1wiPlxuICAgICAgICAgICAgICAgICAgeyhzdGFyID8/IDApLnRvRml4ZWQoMSl9XG4gICAgICAgICAgICAgICAgPC9UZXh0PlxuICAgICAgICAgICAgICAgIDxUZXh0IGZ6PVwic21cIiBmdz17NDAwfSBsaD17MS4yNX0gY29sb3I9XCJncmF5LjdcIj5cbiAgICAgICAgICAgICAgICAgICh7cmV2aWV3Q291bnR9KVxuICAgICAgICAgICAgICAgIDwvVGV4dD5cbiAgICAgICAgICAgICAgPC9Hcm91cD5cbiAgICAgICAgICAgICl9XG5cbiAgICAgICAgICAgIHsvKiDsiJjqsJXsg50gLSAxMOuqhSDsnbTsg4Hsnbwg65WM66eMIO2RnOyLnCAqL31cbiAgICAgICAgICAgIHtzdHVkZW50Q291bnQgPj0gMTAgJiYgKFxuICAgICAgICAgICAgICA8R3JvdXAgc3BhY2luZz17Mn0+XG4gICAgICAgICAgICAgICAgPEljb24gaWNvbj17ZmFVc2VyfSBzaXplPVwieHNcIiBjb2xvcj1cImdyYXkuN1wiIC8+XG4gICAgICAgICAgICAgICAgPFRleHQgZno9XCJzbVwiIGZ3PXs0MDB9IGxoPXsxLjI1fSBjb2xvcj1cImdyYXkuN1wiPlxuICAgICAgICAgICAgICAgICAge3N0dWRlbnRDb3VudC50b0xvY2FsZVN0cmluZygpfVxuICAgICAgICAgICAgICAgIDwvVGV4dD5cbiAgICAgICAgICAgICAgPC9Hcm91cD5cbiAgICAgICAgICAgICl9XG4gICAgICAgICAgPC9Hcm91cD5cbiAgICAgICAgPC9GbGV4PlxuICAgICAgPC9GbGV4PlxuICAgIDwvYT5cbiAgKTtcbn0pO1xuIl19 */",
  toString: He
};
const Sd = yg(function({
  title: g,
  instructorName: I,
  thumbnailUrl: C,
  star: A,
  reviewCount: c,
  studentCount: l,
  slug: t,
  url: i,
  onClick: e
}) {
  const n = i && (/^https?:\/\//.test(i) || i.startsWith("/")) ? i : t ? `/course/${t}` : "#";
  return /* @__PURE__ */ o("a", { href: n, target: "_blank", rel: "noopener noreferrer", style: {
    textDecoration: "none"
  }, onClick: e, children: /* @__PURE__ */ R(Cg, { gap: 16, align: "flex-start", w: "100%", p: 16, css: /* @__PURE__ */ $({
    borderRadius: 16,
    border: `1px solid ${rg.gray[3]}`
  }, process.env.NODE_ENV === "production" ? "" : ";label:CourseCardArticle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
    /* @__PURE__ */ o(P, { w: 120, css: gx, children: /* @__PURE__ */ o(Ys, { ratio: 3 / 1.95, children: /* @__PURE__ */ o(bC, { width: "100%", height: "100%", w: 240, src: C, alt: g }) }) }),
    /* @__PURE__ */ R(Cg, { direction: "column", gap: 6, css: /* @__PURE__ */ $({
      flex: 1,
      minWidth: 0,
      [Mg.mobile]: {
        gap: 2
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:CourseCardArticle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
      /* @__PURE__ */ o(U, { fz: "md", fw: 600, lh: 1.3, color: "gray.9", css: /* @__PURE__ */ $({
        [Mg.mobile]: {
          fontSize: 14
        },
        wordBreak: "break-all"
      }, process.env.NODE_ENV === "production" ? "" : ";label:CourseCardArticle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: g }),
      /* @__PURE__ */ o(U, { fz: "md", fw: 400, lh: 1.3, color: "gray.6", children: I }),
      /* @__PURE__ */ R(Ig, { spacing: 8, children: [
        c > 0 && /* @__PURE__ */ R(Ig, { spacing: 2, children: [
          /* @__PURE__ */ o(sg, { icon: aN, size: "xs", color: "yellow.6" }),
          /* @__PURE__ */ o(U, { fz: "sm", fw: 600, lh: 1.25, color: "gray.7", children: (A ?? 0).toFixed(1) }),
          /* @__PURE__ */ R(U, { fz: "sm", fw: 400, lh: 1.25, color: "gray.7", children: [
            "(",
            c,
            ")"
          ] })
        ] }),
        l >= 10 && /* @__PURE__ */ R(Ig, { spacing: 2, children: [
          /* @__PURE__ */ o(sg, { icon: bN, size: "xs", color: "gray.7" }),
          /* @__PURE__ */ o(U, { fz: "sm", fw: 400, lh: 1.25, color: "gray.7", children: l.toLocaleString() })
        ] })
      ] })
    ] })
  ] }) });
}), Ix = 50;
function Cx({
  value: g,
  onChange: I,
  maxLength: C = Ix
}) {
  const {
    t: A
  } = hg();
  return /* @__PURE__ */ R(P, { pos: "relative", w: "100%", maw: 330, children: [
    /* @__PURE__ */ o(zs, { w: "100%", size: "md", placeholder: A("학습 목적을 입력해주세요"), value: g, onChange: (c) => I(c.target.value), maxLength: C, autoFocus: !0, autosize: !0, minRows: 2, maxRows: 4, styles: {
      input: {
        fontSize: "16px",
        borderRadius: 8,
        border: "1px solid #DEE2E6",
        paddingRight: 50,
        "&:focus": {
          borderColor: "#212529"
        }
      }
    } }),
    /* @__PURE__ */ o(P, { pos: "absolute", bottom: 8, right: 12, style: {
      pointerEvents: "none"
    }, children: /* @__PURE__ */ R(U, { fz: "xs", c: "gray.5", children: [
      g.length,
      "/",
      C
    ] }) })
  ] });
}
function Ax() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var cx = process.env.NODE_ENV === "production" ? {
  name: "ml5scp",
  styles: "position:absolute;opacity:0;pointer-events:none"
} : {
  name: "1w98h52-GradientIcon",
  styles: "position:absolute;opacity:0;pointer-events:none;label:GradientIcon;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Ax
};
function lx({
  icon: g,
  size: I = "sm"
}) {
  const C = Ag(null), [A, c] = O("");
  return q(() => {
    if (!C.current)
      return;
    const l = C.current.querySelector("svg");
    if (!l)
      return;
    const t = l.cloneNode(!0);
    t.setAttribute("xmlns", "http://www.w3.org/2000/svg"), t.querySelectorAll("path, circle, rect, polygon, polyline, line, ellipse").forEach((n) => {
      n.setAttribute("fill", "#000"), n.removeAttribute("stroke");
    });
    const i = new XMLSerializer().serializeToString(t), e = encodeURIComponent(i);
    c(`url("data:image/svg+xml;charset=utf-8,${e}")`);
  }, [g]), /* @__PURE__ */ o(P, { css: /* @__PURE__ */ $({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(137deg, #0CB6A1 17.41%, #10B1D6 53.71%, #6D79EA 90%)",
    WebkitMask: A ? `${A} no-repeat center` : "none",
    WebkitMaskSize: "contain",
    mask: A ? `${A} no-repeat center` : "none",
    maskSize: "contain",
    width: "1em",
    height: "1em",
    visibility: A ? "visible" : "hidden"
  }, process.env.NODE_ENV === "production" ? "" : ";label:GradientIcon;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ o(P, { ref: C, css: cx, children: /* @__PURE__ */ o(sg, { icon: g, size: I }) }) });
}
function we({
  lang: g = "ko",
  options: I
} = {}) {
  return gN({
    queryKey: Se({
      lang: g
    }),
    url: tc.stringifyUrl({
      url: mC.CLIENT_V1_USER_ONBOARDINGS_ANSWERS,
      query: {
        lang: g
      }
    }),
    options: I
  });
}
const Se = ({
  lang: g = "ko"
} = {}) => [mC.CLIENT_V1_USER_ONBOARDINGS_ANSWERS, g], cA = () => {
  const {
    trackEvent: g
  } = zd(), I = k((r) => {
    g(Ug.VIEW_ONBOARDING_RECOMMENDATION_MODAL, {
      props: r
    });
  }, [g]), C = k((r) => {
    g(Ug.CLICK_ONBOARDING_SELECTION, {
      props: r
    });
  }, [g]), A = k((r) => {
    g(Ug.SUBMIT_ONBOARDING_QUESTION, {
      props: r
    });
  }, [g]), c = k((r) => {
    g(Ug.CLICK_COURSE_AT_RECOMMENDATION, {
      props: r
    });
  }, [g]), l = k((r) => {
    g(Ug.CLICK_RECOMMENDATION_CLOSE, {
      props: r
    });
  }, [g]), t = k((r) => {
    g(Ug.VIEW_COURSES_RECOMMENDATION, {
      props: r
    });
  }, [g]), i = k(() => {
    g(Ug.CLICK_VIEW_MORE_RECOMMENDATION, {});
  }, [g]), e = k((r) => {
    g(Ug.CLICK_START_LLM_RECOMMENDATION, {
      props: r
    });
  }, [g]), n = k((r) => {
    g(Ug.START_LLM_RECOMMENDATION_SESSION, {
      props: r
    });
  }, [g]), b = k((r) => {
    g(Ug.SEND_LLM_PROMPT, {
      props: r
    });
  }, [g]), a = k((r) => {
    g(Ug.CLICK_LLM_SUGGESTION, {
      props: r
    });
  }, [g]), s = k((r) => {
    g(Ug.VIEW_LLM_QUESTION, {
      props: r
    });
  }, [g]), d = k((r) => {
    g(Ug.CLICK_BACK_TO_POPULAR_COURSES, {
      props: r
    });
  }, [g]), Z = k((r) => {
    g(Ug.CLICK_LLM_WANT_MORE_CHAT, {
      props: r
    });
  }, [g]);
  return {
    trackViewOnboardingRecommendationModal: I,
    trackViewCoursesRecommendation: t,
    trackOnboardingSelection: C,
    trackOnboardingQuestionSubmit: A,
    trackCourseAtRecommendation: c,
    trackRecommendationClose: l,
    trackViewMoreRecommendation: i,
    trackClickStartLlmRecommendation: e,
    trackStartLlmRecommendationSession: n,
    trackSendLlmPrompt: b,
    trackClickLlmSuggestion: a,
    trackViewLlmQuestion: s,
    trackClickBackToPopularCourses: d,
    trackClickLlmWantMoreChat: Z
  };
}, ZI = (g, I) => (g == null ? void 0 : g.map((C) => C.type === "UNKNOWN" ? "not sure yet" : C.type === "CUSTOM_INPUT" ? "enter my own" : C[I]).filter(Boolean)) ?? [], Td = (g) => {
  var I, C, A;
  return g ? [...((I = g == null ? void 0 : g.usagePurposes) == null ? void 0 : I.filter((c) => c.type === "CUSTOM_INPUT").map((c) => c.content)) ?? [], ...((C = g == null ? void 0 : g.categories) == null ? void 0 : C.filter((c) => c.type === "CUSTOM_INPUT").map((c) => c.content ?? c.slug)) ?? [], ...((A = g == null ? void 0 : g.skillTags) == null ? void 0 : A.filter((c) => c.type === "CUSTOM_INPUT").map((c) => c.content ?? c.slug)) ?? []].filter((c) => !!c) : [];
}, tx = 4, ix = 20, ex = 1e3 * 60, nx = 1e3 * 60 * 5, Ld = yg(function({
  userName: g,
  onEnterLlm: I,
  onGoToMain: C,
  entryPoint: A
}) {
  const {
    t: c
  } = hg(), {
    lang: l
  } = Je(), {
    trackCourseAtRecommendation: t,
    trackViewCoursesRecommendation: i,
    trackViewMoreRecommendation: e,
    trackClickStartLlmRecommendation: n
  } = cA(), [b, a] = O(!1), {
    data: s,
    isLoading: d
  } = fd({
    lang: l,
    options: {
      staleTime: nx
    }
  }), {
    data: Z
  } = we({
    lang: l,
    options: {
      staleTime: ex
    }
  }), {
    data: r,
    isLoading: h
  } = ze(), x = !!(r != null && r.group || r != null && r.managedGroup), u = (s == null ? void 0 : s.items) ?? [], G = Ag("");
  q(() => {
    if (!d && u.length > 0) {
      const N = u.map((cg) => String(cg.course.id)), m = N.join(",");
      if (G.current === m)
        return;
      const p = ZI(Z == null ? void 0 : Z.usagePurposes, "content"), Y = ZI(Z == null ? void 0 : Z.categories, "slug"), v = ZI(Z == null ? void 0 : Z.skillTags, "slug"), Q = Td(Z);
      i({
        step: DA.POPULAR_COURSES,
        course_identification: N,
        course_count: u.length,
        q1_selection_label: p.length > 0 ? p : void 0,
        q2_selection_label: Y.length > 0 ? Y : void 0,
        q3_selection_label: v.length > 0 ? v : void 0,
        custom_input_text: Q.length > 0 ? Q : void 0,
        chat_session_id: void 0,
        response_time_ms: void 0
      }), G.current = m;
    }
  }, [d, u, Z == null ? void 0 : Z.usagePurposes, Z == null ? void 0 : Z.categories, Z == null ? void 0 : Z.skillTags, i]);
  const V = k((N, m, p, Y, v) => {
    t({
      step: DA.POPULAR_COURSES,
      course_identification: String(N),
      course_title: m,
      index_abs: p,
      seq0_instructor_name: Y,
      student_count: v
    });
  }, [t]), X = k(() => {
    e(), a(!0);
  }, [e]), W = k(() => {
    const N = ZI(Z == null ? void 0 : Z.usagePurposes, "content"), m = ZI(Z == null ? void 0 : Z.categories, "slug"), p = ZI(Z == null ? void 0 : Z.skillTags, "slug");
    n({
      q1_selection_label: N.length > 0 ? N : void 0,
      q2_selection_label: m.length > 0 ? m : void 0,
      q3_selection_label: p.length > 0 ? p : void 0
    }), I == null || I();
  }, [I, Z, n]);
  return /* @__PURE__ */ R(gg, { spacing: 16, children: [
    /* @__PURE__ */ o(U, { size: "md", fw: 600, lh: 1.5, color: "gray.9", children: c("{{name}}님을 위한 인기 강의 🔥", {
      name: g
    }) }),
    /* @__PURE__ */ o(gg, { spacing: 12, children: d ? /* @__PURE__ */ R(sI, { children: [
      /* @__PURE__ */ o(Hc, {}),
      /* @__PURE__ */ o(Hc, {}),
      /* @__PURE__ */ o(Hc, {}),
      /* @__PURE__ */ o(Hc, {})
    ] }) : u.length === 0 ? /* @__PURE__ */ o(P, { py: 40, children: /* @__PURE__ */ o(U, { size: "sm", color: "gray.6", ta: "center", children: c("추천 강의가 없습니다.") }) }) : u.slice(0, b ? ix : tx).map((N, m) => /* @__PURE__ */ o(Sd, { title: N.course.title, instructorName: N.instructor.name, thumbnailUrl: N.course.thumbnailUrl, star: N.course.star, reviewCount: N.course.reviewCount, studentCount: N.course.studentCount, slug: N.course.slug, onClick: () => V(N.course.id, N.course.title, m, N.instructor.name, N.course.studentCount) }, N.id)) }),
    /* @__PURE__ */ R(gg, { spacing: 10, pb: 32, children: [
      I && !h && !x && /* @__PURE__ */ o(xg, { variant: "filled", color: "infgreen", size: "md", fullWidth: !0, radius: "xl", onClick: W, children: c("나한테 딱 맞는걸 찾고 싶어요") }),
      !b && u.length > 4 && /* @__PURE__ */ o(xg, { variant: "light", color: "gray", size: "md", fullWidth: !0, radius: "xl", onClick: X, children: c("더 많은 강의 보기") }),
      A !== OA.MY_SETTINGS && /* @__PURE__ */ o(xg, { variant: "light", color: "gray", size: "md", fullWidth: !0, radius: "xl", onClick: C, children: c("홈으로 가기") })
    ] })
  ] });
}), bx = yg(function({
  userName: g,
  onApplyInstructor: I,
  onGoToMain: C,
  onEnterLlm: A
}) {
  const {
    t: c
  } = hg(), [l, t] = O(!1);
  return /* @__PURE__ */ R(Cg, { direction: "column", px: 20, py: 32, h: "100%", children: [
    /* @__PURE__ */ R(gg, { spacing: 4, children: [
      /* @__PURE__ */ o(U, { fz: "md", fw: 600, lh: 1.5, c: "gray.9", children: c("지식공유에 관심이 있으시군요!") }),
      /* @__PURE__ */ o(U, { fz: "md", fw: 400, lh: 1.5, c: "gray.9", children: c("선택한 내용을 바탕으로 다음 행동을 골라주세요") })
    ] }),
    /* @__PURE__ */ R(gg, { spacing: 10, align: "flex-end", w: "100%", mt: 20, children: [
      /* @__PURE__ */ o(xg, { variant: "filled", color: "infgreen", size: "md", fullWidth: !0, radius: "xl", onClick: I, children: c("지식공유자 신청하러 가기") }),
      !l && /* @__PURE__ */ o(xg, { variant: "light", color: "gray", size: "md", fullWidth: !0, radius: "xl", onClick: () => t(!0), children: c("인기 강의 둘러보기") })
    ] }),
    l && /* @__PURE__ */ o(gg, { spacing: 16, mt: 24, pb: 32, children: /* @__PURE__ */ o(Ld, { userName: g, onEnterLlm: A, onGoToMain: C }) })
  ] });
}), Ud = jg({});
function jA(g) {
  const I = Ag(null);
  return I.current === null && (I.current = g()), I.current;
}
const Pd = typeof window < "u", kd = Pd ? Ss : q, Te = /* @__PURE__ */ jg(null);
function Le(g, I) {
  g.indexOf(I) === -1 && g.push(I);
}
function Nl(g, I) {
  const C = g.indexOf(I);
  C > -1 && g.splice(C, 1);
}
const uI = (g, I, C) => C > I ? I : C < g ? g : C;
function Wi(g, I) {
  return I ? `${g}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${I}` : g;
}
let lA = () => {
}, RI = () => {
};
var la;
typeof process < "u" && ((la = process.env) == null ? void 0 : la.NODE_ENV) !== "production" && (lA = (g, I, C) => {
  !g && typeof console < "u" && console.warn(Wi(I, C));
}, RI = (g, I, C) => {
  if (!g)
    throw new Error(Wi(I, C));
});
const BI = {}, Dd = (g) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(g);
function Od(g) {
  return typeof g == "object" && g !== null;
}
const jd = (g) => /^0[^.\s]+$/u.test(g);
function Ed(g) {
  let I;
  return () => (I === void 0 && (I = g()), I);
}
const Kg = (g) => g, ax = (g, I) => (C) => I(g(C)), ic = (...g) => g.reduce(ax), EA = (g, I, C) => {
  const A = I - g;
  return A === 0 ? 1 : (C - g) / A;
};
class Ue {
  constructor() {
    this.subscriptions = [];
  }
  add(I) {
    return Le(this.subscriptions, I), () => Nl(this.subscriptions, I);
  }
  notify(I, C, A) {
    const c = this.subscriptions.length;
    if (c)
      if (c === 1)
        this.subscriptions[0](I, C, A);
      else
        for (let l = 0; l < c; l++) {
          const t = this.subscriptions[l];
          t && t(I, C, A);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const _g = (g) => g * 1e3, Qg = (g) => g / 1e3;
function Qd(g, I) {
  return I ? g * (1e3 / I) : 0;
}
const ta = /* @__PURE__ */ new Set();
function Pe(g, I, C) {
  g || ta.has(I) || (console.warn(Wi(I, C)), ta.add(I));
}
const Md = (g, I, C) => (((1 - 3 * C + 3 * I) * g + (3 * C - 6 * I)) * g + 3 * I) * g, sx = 1e-7, ux = 12;
function dx(g, I, C, A, c) {
  let l, t, i = 0;
  do
    t = I + (C - I) / 2, l = Md(t, A, c) - g, l > 0 ? C = t : I = t;
  while (Math.abs(l) > sx && ++i < ux);
  return t;
}
function ec(g, I, C, A) {
  if (g === I && C === A)
    return Kg;
  const c = (l) => dx(l, 0, 1, g, C);
  return (l) => l === 0 || l === 1 ? l : Md(c(l), I, A);
}
const Kd = (g) => (I) => I <= 0.5 ? g(2 * I) / 2 : (2 - g(2 * (1 - I))) / 2, _d = (g) => (I) => 1 - g(1 - I), qd = /* @__PURE__ */ ec(0.33, 1.53, 0.69, 0.99), ke = /* @__PURE__ */ _d(qd), $d = /* @__PURE__ */ Kd(ke), go = (g) => (g *= 2) < 1 ? 0.5 * ke(g) : 0.5 * (2 - Math.pow(2, -10 * (g - 1))), De = (g) => 1 - Math.sin(Math.acos(g)), Io = _d(De), Co = Kd(De), ox = /* @__PURE__ */ ec(0.42, 0, 1, 1), Gx = /* @__PURE__ */ ec(0, 0, 0.58, 1), Ao = /* @__PURE__ */ ec(0.42, 0, 0.58, 1), rx = (g) => Array.isArray(g) && typeof g[0] != "number", co = (g) => Array.isArray(g) && typeof g[0] == "number", ia = {
  linear: Kg,
  easeIn: ox,
  easeInOut: Ao,
  easeOut: Gx,
  circIn: De,
  circInOut: Co,
  circOut: Io,
  backIn: ke,
  backInOut: $d,
  backOut: qd,
  anticipate: go
}, Xx = (g) => typeof g == "string", ea = (g) => {
  if (co(g)) {
    RI(g.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [I, C, A, c] = g;
    return ec(I, C, A, c);
  } else if (Xx(g))
    return RI(ia[g] !== void 0, `Invalid easing type '${g}'`, "invalid-easing-type"), ia[g];
  return g;
}, wc = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], Ni = {
  value: null,
  addProjectionMetrics: null
};
function Zx(g, I) {
  let C = /* @__PURE__ */ new Set(), A = /* @__PURE__ */ new Set(), c = !1, l = !1;
  const t = /* @__PURE__ */ new WeakSet();
  let i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, e = 0;
  function n(a) {
    t.has(a) && (b.schedule(a), g()), e++, a(i);
  }
  const b = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (a, s = !1, d = !1) => {
      const Z = d && c ? C : A;
      return s && t.add(a), Z.has(a) || Z.add(a), a;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (a) => {
      A.delete(a), t.delete(a);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (a) => {
      if (i = a, c) {
        l = !0;
        return;
      }
      c = !0, [C, A] = [A, C], C.forEach(n), I && Ni.value && Ni.value.frameloop[I].push(e), e = 0, C.clear(), c = !1, l && (l = !1, b.process(a));
    }
  };
  return b;
}
const Vx = 40;
function lo(g, I) {
  let C = !1, A = !0;
  const c = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, l = () => C = !0, t = wc.reduce((x, u) => (x[u] = Zx(l, I ? u : void 0), x), {}), { setup: i, read: e, resolveKeyframes: n, preUpdate: b, update: a, preRender: s, render: d, postRender: Z } = t, r = () => {
    const x = BI.useManualTiming ? c.timestamp : performance.now();
    C = !1, BI.useManualTiming || (c.delta = A ? 1e3 / 60 : Math.max(Math.min(x - c.timestamp, Vx), 1)), c.timestamp = x, c.isProcessing = !0, i.process(c), e.process(c), n.process(c), b.process(c), a.process(c), s.process(c), d.process(c), Z.process(c), c.isProcessing = !1, C && I && (A = !1, g(r));
  }, h = () => {
    C = !0, A = !0, c.isProcessing || g(r);
  };
  return { schedule: wc.reduce((x, u) => {
    const G = t[u];
    return x[u] = (V, X = !1, W = !1) => (C || h(), G.schedule(V, X, W)), x;
  }, {}), cancel: (x) => {
    for (let u = 0; u < wc.length; u++)
      t[wc[u]].cancel(x);
  }, state: c, steps: t };
}
const { schedule: bg, cancel: dI, state: zg, steps: Wt } = /* @__PURE__ */ lo(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Kg, !0);
let jc;
function mx() {
  jc = void 0;
}
const kg = {
  now: () => (jc === void 0 && kg.set(zg.isProcessing || BI.useManualTiming ? zg.timestamp : performance.now()), jc),
  set: (g) => {
    jc = g, queueMicrotask(mx);
  }
}, to = (g) => (I) => typeof I == "string" && I.startsWith(g), io = /* @__PURE__ */ to("--"), hx = /* @__PURE__ */ to("var(--"), Oe = (g) => hx(g) ? Wx.test(g.split("/*")[0].trim()) : !1, Wx = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
function na(g) {
  return typeof g != "string" ? !1 : g.split("/*")[0].includes("var(--");
}
const tA = {
  test: (g) => typeof g == "number",
  parse: parseFloat,
  transform: (g) => g
}, QA = {
  ...tA,
  transform: (g) => uI(0, 1, g)
}, Sc = {
  ...tA,
  default: 1
}, yA = (g) => Math.round(g * 1e5) / 1e5, je = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Nx(g) {
  return g == null;
}
const xx = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Ee = (g, I) => (C) => !!(typeof C == "string" && xx.test(C) && C.startsWith(g) || I && !Nx(C) && Object.prototype.hasOwnProperty.call(C, I)), eo = (g, I, C) => (A) => {
  if (typeof A != "string")
    return A;
  const [c, l, t, i] = A.match(je);
  return {
    [g]: parseFloat(c),
    [I]: parseFloat(l),
    [C]: parseFloat(t),
    alpha: i !== void 0 ? parseFloat(i) : 1
  };
}, yx = (g) => uI(0, 255, g), Nt = {
  ...tA,
  transform: (g) => Math.round(yx(g))
}, lC = {
  test: /* @__PURE__ */ Ee("rgb", "red"),
  parse: /* @__PURE__ */ eo("red", "green", "blue"),
  transform: ({ red: g, green: I, blue: C, alpha: A = 1 }) => "rgba(" + Nt.transform(g) + ", " + Nt.transform(I) + ", " + Nt.transform(C) + ", " + yA(QA.transform(A)) + ")"
};
function px(g) {
  let I = "", C = "", A = "", c = "";
  return g.length > 5 ? (I = g.substring(1, 3), C = g.substring(3, 5), A = g.substring(5, 7), c = g.substring(7, 9)) : (I = g.substring(1, 2), C = g.substring(2, 3), A = g.substring(3, 4), c = g.substring(4, 5), I += I, C += C, A += A, c += c), {
    red: parseInt(I, 16),
    green: parseInt(C, 16),
    blue: parseInt(A, 16),
    alpha: c ? parseInt(c, 16) / 255 : 1
  };
}
const xi = {
  test: /* @__PURE__ */ Ee("#"),
  parse: px,
  transform: lC.transform
}, nc = (g) => ({
  test: (I) => typeof I == "string" && I.endsWith(g) && I.split(" ").length === 1,
  parse: parseFloat,
  transform: (I) => `${I}${g}`
}), zI = /* @__PURE__ */ nc("deg"), aI = /* @__PURE__ */ nc("%"), L = /* @__PURE__ */ nc("px"), Rx = /* @__PURE__ */ nc("vh"), Bx = /* @__PURE__ */ nc("vw"), ba = /* @__PURE__ */ (() => ({
  ...aI,
  parse: (g) => aI.parse(g) / 100,
  transform: (g) => aI.transform(g * 100)
}))(), zC = {
  test: /* @__PURE__ */ Ee("hsl", "hue"),
  parse: /* @__PURE__ */ eo("hue", "saturation", "lightness"),
  transform: ({ hue: g, saturation: I, lightness: C, alpha: A = 1 }) => "hsla(" + Math.round(g) + ", " + aI.transform(yA(I)) + ", " + aI.transform(yA(C)) + ", " + yA(QA.transform(A)) + ")"
}, Bg = {
  test: (g) => lC.test(g) || xi.test(g) || zC.test(g),
  parse: (g) => lC.test(g) ? lC.parse(g) : zC.test(g) ? zC.parse(g) : xi.parse(g),
  transform: (g) => typeof g == "string" ? g : g.hasOwnProperty("red") ? lC.transform(g) : zC.transform(g),
  getAnimatableNone: (g) => {
    const I = Bg.parse(g);
    return I.alpha = 0, Bg.transform(I);
  }
}, vx = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Jx(g) {
  var I, C;
  return isNaN(g) && typeof g == "string" && (((I = g.match(je)) == null ? void 0 : I.length) || 0) + (((C = g.match(vx)) == null ? void 0 : C.length) || 0) > 0;
}
const no = "number", bo = "color", Yx = "var", Fx = "var(", aa = "${}", zx = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function MA(g) {
  const I = g.toString(), C = [], A = {
    color: [],
    number: [],
    var: []
  }, c = [];
  let l = 0;
  const t = I.replace(zx, (i) => (Bg.test(i) ? (A.color.push(l), c.push(bo), C.push(Bg.parse(i))) : i.startsWith(Fx) ? (A.var.push(l), c.push(Yx), C.push(i)) : (A.number.push(l), c.push(no), C.push(parseFloat(i))), ++l, aa)).split(aa);
  return { values: C, split: t, indexes: A, types: c };
}
function ao(g) {
  return MA(g).values;
}
function so(g) {
  const { split: I, types: C } = MA(g), A = I.length;
  return (c) => {
    let l = "";
    for (let t = 0; t < A; t++)
      if (l += I[t], c[t] !== void 0) {
        const i = C[t];
        i === no ? l += yA(c[t]) : i === bo ? l += Bg.transform(c[t]) : l += c[t];
      }
    return l;
  };
}
const fx = (g) => typeof g == "number" ? 0 : Bg.test(g) ? Bg.getAnimatableNone(g) : g;
function Hx(g) {
  const I = ao(g);
  return so(g)(I.map(fx));
}
const cI = {
  test: Jx,
  parse: ao,
  createTransformer: so,
  getAnimatableNone: Hx
};
function xt(g, I, C) {
  return C < 0 && (C += 1), C > 1 && (C -= 1), C < 1 / 6 ? g + (I - g) * 6 * C : C < 1 / 2 ? I : C < 2 / 3 ? g + (I - g) * (2 / 3 - C) * 6 : g;
}
function wx({ hue: g, saturation: I, lightness: C, alpha: A }) {
  g /= 360, I /= 100, C /= 100;
  let c = 0, l = 0, t = 0;
  if (!I)
    c = l = t = C;
  else {
    const i = C < 0.5 ? C * (1 + I) : C + I - C * I, e = 2 * C - i;
    c = xt(e, i, g + 1 / 3), l = xt(e, i, g), t = xt(e, i, g - 1 / 3);
  }
  return {
    red: Math.round(c * 255),
    green: Math.round(l * 255),
    blue: Math.round(t * 255),
    alpha: A
  };
}
function xl(g, I) {
  return (C) => C > 0 ? I : g;
}
const Vg = (g, I, C) => g + (I - g) * C, yt = (g, I, C) => {
  const A = g * g, c = C * (I * I - A) + A;
  return c < 0 ? 0 : Math.sqrt(c);
}, Sx = [xi, lC, zC], Tx = (g) => Sx.find((I) => I.test(g));
function sa(g) {
  const I = Tx(g);
  if (lA(!!I, `'${g}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !I)
    return !1;
  let C = I.parse(g);
  return I === zC && (C = wx(C)), C;
}
const ua = (g, I) => {
  const C = sa(g), A = sa(I);
  if (!C || !A)
    return xl(g, I);
  const c = { ...C };
  return (l) => (c.red = yt(C.red, A.red, l), c.green = yt(C.green, A.green, l), c.blue = yt(C.blue, A.blue, l), c.alpha = Vg(C.alpha, A.alpha, l), lC.transform(c));
}, yi = /* @__PURE__ */ new Set(["none", "hidden"]);
function Lx(g, I) {
  return yi.has(g) ? (C) => C <= 0 ? g : I : (C) => C >= 1 ? I : g;
}
function Ux(g, I) {
  return (C) => Vg(g, I, C);
}
function Qe(g) {
  return typeof g == "number" ? Ux : typeof g == "string" ? Oe(g) ? xl : Bg.test(g) ? ua : Dx : Array.isArray(g) ? uo : typeof g == "object" ? Bg.test(g) ? ua : Px : xl;
}
function uo(g, I) {
  const C = [...g], A = C.length, c = g.map((l, t) => Qe(l)(l, I[t]));
  return (l) => {
    for (let t = 0; t < A; t++)
      C[t] = c[t](l);
    return C;
  };
}
function Px(g, I) {
  const C = { ...g, ...I }, A = {};
  for (const c in C)
    g[c] !== void 0 && I[c] !== void 0 && (A[c] = Qe(g[c])(g[c], I[c]));
  return (c) => {
    for (const l in A)
      C[l] = A[l](c);
    return C;
  };
}
function kx(g, I) {
  const C = [], A = { color: 0, var: 0, number: 0 };
  for (let c = 0; c < I.values.length; c++) {
    const l = I.types[c], t = g.indexes[l][A[l]], i = g.values[t] ?? 0;
    C[c] = i, A[l]++;
  }
  return C;
}
const Dx = (g, I) => {
  const C = cI.createTransformer(I), A = MA(g), c = MA(I);
  return A.indexes.var.length === c.indexes.var.length && A.indexes.color.length === c.indexes.color.length && A.indexes.number.length >= c.indexes.number.length ? yi.has(g) && !c.values.length || yi.has(I) && !A.values.length ? Lx(g, I) : ic(uo(kx(A, c), c.values), C) : (lA(!0, `Complex values '${g}' and '${I}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), xl(g, I));
};
function oo(g, I, C) {
  return typeof g == "number" && typeof I == "number" && typeof C == "number" ? Vg(g, I, C) : Qe(g)(g, I);
}
const Ox = (g) => {
  const I = ({ timestamp: C }) => g(C);
  return {
    start: (C = !0) => bg.update(I, C),
    stop: () => dI(I),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => zg.isProcessing ? zg.timestamp : kg.now()
  };
}, Go = (g, I, C = 10) => {
  let A = "";
  const c = Math.max(Math.round(I / C), 2);
  for (let l = 0; l < c; l++)
    A += Math.round(g(l / (c - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${A.substring(0, A.length - 2)})`;
}, yl = 2e4;
function Me(g) {
  let I = 0;
  const C = 50;
  let A = g.next(I);
  for (; !A.done && I < yl; )
    I += C, A = g.next(I);
  return I >= yl ? 1 / 0 : I;
}
function jx(g, I = 100, C) {
  const A = C({ ...g, keyframes: [0, I] }), c = Math.min(Me(A), yl);
  return {
    type: "keyframes",
    ease: (l) => A.next(c * l).value / I,
    duration: Qg(c)
  };
}
const Ex = 5;
function ro(g, I, C) {
  const A = Math.max(I - Ex, 0);
  return Qd(C - g(A), I - A);
}
const Xg = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, pt = 1e-3;
function Qx({ duration: g = Xg.duration, bounce: I = Xg.bounce, velocity: C = Xg.velocity, mass: A = Xg.mass }) {
  let c, l;
  lA(g <= _g(Xg.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let t = 1 - I;
  t = uI(Xg.minDamping, Xg.maxDamping, t), g = uI(Xg.minDuration, Xg.maxDuration, Qg(g)), t < 1 ? (c = (n) => {
    const b = n * t, a = b * g, s = b - C, d = pi(n, t), Z = Math.exp(-a);
    return pt - s / d * Z;
  }, l = (n) => {
    const b = n * t * g, a = b * C + C, s = Math.pow(t, 2) * Math.pow(n, 2) * g, d = Math.exp(-b), Z = pi(Math.pow(n, 2), t);
    return (-c(n) + pt > 0 ? -1 : 1) * ((a - s) * d) / Z;
  }) : (c = (n) => {
    const b = Math.exp(-n * g), a = (n - C) * g + 1;
    return -pt + b * a;
  }, l = (n) => {
    const b = Math.exp(-n * g), a = (C - n) * (g * g);
    return b * a;
  });
  const i = 5 / g, e = Kx(c, l, i);
  if (g = _g(g), isNaN(e))
    return {
      stiffness: Xg.stiffness,
      damping: Xg.damping,
      duration: g
    };
  {
    const n = Math.pow(e, 2) * A;
    return {
      stiffness: n,
      damping: t * 2 * Math.sqrt(A * n),
      duration: g
    };
  }
}
const Mx = 12;
function Kx(g, I, C) {
  let A = C;
  for (let c = 1; c < Mx; c++)
    A = A - g(A) / I(A);
  return A;
}
function pi(g, I) {
  return g * Math.sqrt(1 - I * I);
}
const _x = ["duration", "bounce"], qx = ["stiffness", "damping", "mass"];
function da(g, I) {
  return I.some((C) => g[C] !== void 0);
}
function $x(g) {
  let I = {
    velocity: Xg.velocity,
    stiffness: Xg.stiffness,
    damping: Xg.damping,
    mass: Xg.mass,
    isResolvedFromDuration: !1,
    ...g
  };
  if (!da(g, qx) && da(g, _x))
    if (g.visualDuration) {
      const C = g.visualDuration, A = 2 * Math.PI / (C * 1.2), c = A * A, l = 2 * uI(0.05, 1, 1 - (g.bounce || 0)) * Math.sqrt(c);
      I = {
        ...I,
        mass: Xg.mass,
        stiffness: c,
        damping: l
      };
    } else {
      const C = Qx(g);
      I = {
        ...I,
        ...C,
        mass: Xg.mass
      }, I.isResolvedFromDuration = !0;
    }
  return I;
}
function pl(g = Xg.visualDuration, I = Xg.bounce) {
  const C = typeof g != "object" ? {
    visualDuration: g,
    keyframes: [0, 1],
    bounce: I
  } : g;
  let { restSpeed: A, restDelta: c } = C;
  const l = C.keyframes[0], t = C.keyframes[C.keyframes.length - 1], i = { done: !1, value: l }, { stiffness: e, damping: n, mass: b, duration: a, velocity: s, isResolvedFromDuration: d } = $x({
    ...C,
    velocity: -Qg(C.velocity || 0)
  }), Z = s || 0, r = n / (2 * Math.sqrt(e * b)), h = t - l, x = Qg(Math.sqrt(e / b)), u = Math.abs(h) < 5;
  A || (A = u ? Xg.restSpeed.granular : Xg.restSpeed.default), c || (c = u ? Xg.restDelta.granular : Xg.restDelta.default);
  let G;
  if (r < 1) {
    const X = pi(x, r);
    G = (W) => {
      const N = Math.exp(-r * x * W);
      return t - N * ((Z + r * x * h) / X * Math.sin(X * W) + h * Math.cos(X * W));
    };
  } else if (r === 1)
    G = (X) => t - Math.exp(-x * X) * (h + (Z + x * h) * X);
  else {
    const X = x * Math.sqrt(r * r - 1);
    G = (W) => {
      const N = Math.exp(-r * x * W), m = Math.min(X * W, 300);
      return t - N * ((Z + r * x * h) * Math.sinh(m) + X * h * Math.cosh(m)) / X;
    };
  }
  const V = {
    calculatedDuration: d && a || null,
    next: (X) => {
      const W = G(X);
      if (d)
        i.done = X >= a;
      else {
        let N = X === 0 ? Z : 0;
        r < 1 && (N = X === 0 ? _g(Z) : ro(G, X, W));
        const m = Math.abs(N) <= A, p = Math.abs(t - W) <= c;
        i.done = m && p;
      }
      return i.value = i.done ? t : W, i;
    },
    toString: () => {
      const X = Math.min(Me(V), yl), W = Go((N) => V.next(X * N).value, X, 30);
      return X + "ms " + W;
    },
    toTransition: () => {
    }
  };
  return V;
}
pl.applyToOptions = (g) => {
  const I = jx(g, 100, pl);
  return g.ease = I.ease, g.duration = _g(I.duration), g.type = "keyframes", g;
};
function Ri({ keyframes: g, velocity: I = 0, power: C = 0.8, timeConstant: A = 325, bounceDamping: c = 10, bounceStiffness: l = 500, modifyTarget: t, min: i, max: e, restDelta: n = 0.5, restSpeed: b }) {
  const a = g[0], s = {
    done: !1,
    value: a
  }, d = (m) => i !== void 0 && m < i || e !== void 0 && m > e, Z = (m) => i === void 0 ? e : e === void 0 || Math.abs(i - m) < Math.abs(e - m) ? i : e;
  let r = C * I;
  const h = a + r, x = t === void 0 ? h : t(h);
  x !== h && (r = x - a);
  const u = (m) => -r * Math.exp(-m / A), G = (m) => x + u(m), V = (m) => {
    const p = u(m), Y = G(m);
    s.done = Math.abs(p) <= n, s.value = s.done ? x : Y;
  };
  let X, W;
  const N = (m) => {
    d(s.value) && (X = m, W = pl({
      keyframes: [s.value, Z(s.value)],
      velocity: ro(G, m, s.value),
      // TODO: This should be passing * 1000
      damping: c,
      stiffness: l,
      restDelta: n,
      restSpeed: b
    }));
  };
  return N(0), {
    calculatedDuration: null,
    next: (m) => {
      let p = !1;
      return !W && X === void 0 && (p = !0, V(m), N(m)), X !== void 0 && m >= X ? W.next(m - X) : (!p && V(m), s);
    }
  };
}
function gy(g, I, C) {
  const A = [], c = C || BI.mix || oo, l = g.length - 1;
  for (let t = 0; t < l; t++) {
    let i = c(g[t], g[t + 1]);
    if (I) {
      const e = Array.isArray(I) ? I[t] || Kg : I;
      i = ic(e, i);
    }
    A.push(i);
  }
  return A;
}
function Xo(g, I, { clamp: C = !0, ease: A, mixer: c } = {}) {
  const l = g.length;
  if (RI(l === I.length, "Both input and output ranges must be the same length", "range-length"), l === 1)
    return () => I[0];
  if (l === 2 && I[0] === I[1])
    return () => I[1];
  const t = g[0] === g[1];
  g[0] > g[l - 1] && (g = [...g].reverse(), I = [...I].reverse());
  const i = gy(I, A, c), e = i.length, n = (b) => {
    if (t && b < g[0])
      return I[0];
    let a = 0;
    if (e > 1)
      for (; a < g.length - 2 && !(b < g[a + 1]); a++)
        ;
    const s = EA(g[a], g[a + 1], b);
    return i[a](s);
  };
  return C ? (b) => n(uI(g[0], g[l - 1], b)) : n;
}
function Iy(g, I) {
  const C = g[g.length - 1];
  for (let A = 1; A <= I; A++) {
    const c = EA(0, I, A);
    g.push(Vg(C, 1, c));
  }
}
function Cy(g) {
  const I = [0];
  return Iy(I, g.length - 1), I;
}
function Ay(g, I) {
  return g.map((C) => C * I);
}
function cy(g, I) {
  return g.map(() => I || Ao).splice(0, g.length - 1);
}
function fC({ duration: g = 300, keyframes: I, times: C, ease: A = "easeInOut" }) {
  const c = rx(A) ? A.map(ea) : ea(A), l = {
    done: !1,
    value: I[0]
  }, t = Ay(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    C && C.length === I.length ? C : Cy(I),
    g
  ), i = Xo(t, I, {
    ease: Array.isArray(c) ? c : cy(I, c)
  });
  return {
    calculatedDuration: g,
    next: (e) => (l.value = i(e), l.done = e >= g, l)
  };
}
const ly = (g) => g !== null;
function Ke(g, { repeat: I, repeatType: C = "loop" }, A, c = 1) {
  const l = g.filter(ly), t = c < 0 || I && C !== "loop" && I % 2 === 1 ? 0 : l.length - 1;
  return !t || A === void 0 ? l[t] : A;
}
const ty = {
  decay: Ri,
  inertia: Ri,
  tween: fC,
  keyframes: fC,
  spring: pl
};
function Zo(g) {
  typeof g.type == "string" && (g.type = ty[g.type]);
}
class _e {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((I) => {
      this.resolve = I;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(I, C) {
    return this.finished.then(I, C);
  }
}
const iy = (g) => g / 100;
class qe extends _e {
  constructor(I) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      var C, A;
      const { motionValue: c } = this.options;
      c && c.updatedAt !== kg.now() && this.tick(kg.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (A = (C = this.options).onStop) == null || A.call(C));
    }, this.options = I, this.initAnimation(), this.play(), I.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: I } = this;
    Zo(I);
    const { type: C = fC, repeat: A = 0, repeatDelay: c = 0, repeatType: l, velocity: t = 0 } = I;
    let { keyframes: i } = I;
    const e = C || fC;
    process.env.NODE_ENV !== "production" && e !== fC && RI(i.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${i}`, "spring-two-frames"), e !== fC && typeof i[0] != "number" && (this.mixKeyframes = ic(iy, oo(i[0], i[1])), i = [0, 100]);
    const n = e({ ...I, keyframes: i });
    l === "mirror" && (this.mirroredGenerator = e({
      ...I,
      keyframes: [...i].reverse(),
      velocity: -t
    })), n.calculatedDuration === null && (n.calculatedDuration = Me(n));
    const { calculatedDuration: b } = n;
    this.calculatedDuration = b, this.resolvedDuration = b + c, this.totalDuration = this.resolvedDuration * (A + 1) - c, this.generator = n;
  }
  updateTime(I) {
    const C = Math.round(I - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = C;
  }
  tick(I, C = !1) {
    const { generator: A, totalDuration: c, mixKeyframes: l, mirroredGenerator: t, resolvedDuration: i, calculatedDuration: e } = this;
    if (this.startTime === null)
      return A.next(0);
    const { delay: n = 0, keyframes: b, repeat: a, repeatType: s, repeatDelay: d, type: Z, onUpdate: r, finalKeyframe: h } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, I) : this.speed < 0 && (this.startTime = Math.min(I - c / this.speed, this.startTime)), C ? this.currentTime = I : this.updateTime(I);
    const x = this.currentTime - n * (this.playbackSpeed >= 0 ? 1 : -1), u = this.playbackSpeed >= 0 ? x < 0 : x > c;
    this.currentTime = Math.max(x, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = c);
    let G = this.currentTime, V = A;
    if (a) {
      const m = Math.min(this.currentTime, c) / i;
      let p = Math.floor(m), Y = m % 1;
      !Y && m >= 1 && (Y = 1), Y === 1 && p--, p = Math.min(p, a + 1), p % 2 && (s === "reverse" ? (Y = 1 - Y, d && (Y -= d / i)) : s === "mirror" && (V = t)), G = uI(0, 1, Y) * i;
    }
    const X = u ? { done: !1, value: b[0] } : V.next(G);
    l && (X.value = l(X.value));
    let { done: W } = X;
    !u && e !== null && (W = this.playbackSpeed >= 0 ? this.currentTime >= c : this.currentTime <= 0);
    const N = this.holdTime === null && (this.state === "finished" || this.state === "running" && W);
    return N && Z !== Ri && (X.value = Ke(b, this.options, h, this.speed)), r && r(X.value), N && this.finish(), X;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(I, C) {
    return this.finished.then(I, C);
  }
  get duration() {
    return Qg(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: I = 0 } = this.options || {};
    return this.duration + Qg(I);
  }
  get time() {
    return Qg(this.currentTime);
  }
  set time(I) {
    var C;
    I = _g(I), this.currentTime = I, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = I : this.driver && (this.startTime = this.driver.now() - I / this.playbackSpeed), (C = this.driver) == null || C.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(I) {
    this.updateTime(kg.now());
    const C = this.playbackSpeed !== I;
    this.playbackSpeed = I, C && (this.time = Qg(this.currentTime));
  }
  play() {
    var I, C;
    if (this.isStopped)
      return;
    const { driver: A = Ox, startTime: c } = this.options;
    this.driver || (this.driver = A((t) => this.tick(t))), (C = (I = this.options).onPlay) == null || C.call(I);
    const l = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = l) : this.holdTime !== null ? this.startTime = l - this.holdTime : this.startTime || (this.startTime = c ?? l), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(kg.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var I, C;
    this.notifyFinished(), this.teardown(), this.state = "finished", (C = (I = this.options).onComplete) == null || C.call(I);
  }
  cancel() {
    var I, C;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (C = (I = this.options).onCancel) == null || C.call(I);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(I) {
    return this.startTime = 0, this.tick(I, !0);
  }
  attachTimeline(I) {
    var C;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (C = this.driver) == null || C.stop(), I.observe(this);
  }
}
function ey(g) {
  for (let I = 1; I < g.length; I++)
    g[I] ?? (g[I] = g[I - 1]);
}
const tC = (g) => g * 180 / Math.PI, Bi = (g) => {
  const I = tC(Math.atan2(g[1], g[0]));
  return vi(I);
}, ny = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (g) => (Math.abs(g[0]) + Math.abs(g[3])) / 2,
  rotate: Bi,
  rotateZ: Bi,
  skewX: (g) => tC(Math.atan(g[1])),
  skewY: (g) => tC(Math.atan(g[2])),
  skew: (g) => (Math.abs(g[1]) + Math.abs(g[2])) / 2
}, vi = (g) => (g = g % 360, g < 0 && (g += 360), g), oa = Bi, Ga = (g) => Math.sqrt(g[0] * g[0] + g[1] * g[1]), ra = (g) => Math.sqrt(g[4] * g[4] + g[5] * g[5]), by = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: Ga,
  scaleY: ra,
  scale: (g) => (Ga(g) + ra(g)) / 2,
  rotateX: (g) => vi(tC(Math.atan2(g[6], g[5]))),
  rotateY: (g) => vi(tC(Math.atan2(-g[2], g[0]))),
  rotateZ: oa,
  rotate: oa,
  skewX: (g) => tC(Math.atan(g[4])),
  skewY: (g) => tC(Math.atan(g[1])),
  skew: (g) => (Math.abs(g[1]) + Math.abs(g[4])) / 2
};
function Ji(g) {
  return g.includes("scale") ? 1 : 0;
}
function Yi(g, I) {
  if (!g || g === "none")
    return Ji(I);
  const C = g.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let A, c;
  if (C)
    A = by, c = C;
  else {
    const i = g.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    A = ny, c = i;
  }
  if (!c)
    return Ji(I);
  const l = A[I], t = c[1].split(",").map(sy);
  return typeof l == "function" ? l(t) : t[l];
}
const ay = (g, I) => {
  const { transform: C = "none" } = getComputedStyle(g);
  return Yi(C, I);
};
function sy(g) {
  return parseFloat(g.trim());
}
const iA = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], eA = /* @__PURE__ */ (() => new Set(iA))(), Xa = (g) => g === tA || g === L, uy = /* @__PURE__ */ new Set(["x", "y", "z"]), dy = iA.filter((g) => !uy.has(g));
function oy(g) {
  const I = [];
  return dy.forEach((C) => {
    const A = g.getValue(C);
    A !== void 0 && (I.push([C, A.get()]), A.set(C.startsWith("scale") ? 1 : 0));
  }), I;
}
const fI = {
  // Dimensions
  width: ({ x: g }, { paddingLeft: I = "0", paddingRight: C = "0" }) => g.max - g.min - parseFloat(I) - parseFloat(C),
  height: ({ y: g }, { paddingTop: I = "0", paddingBottom: C = "0" }) => g.max - g.min - parseFloat(I) - parseFloat(C),
  top: (g, { top: I }) => parseFloat(I),
  left: (g, { left: I }) => parseFloat(I),
  bottom: ({ y: g }, { top: I }) => parseFloat(I) + (g.max - g.min),
  right: ({ x: g }, { left: I }) => parseFloat(I) + (g.max - g.min),
  // Transform
  x: (g, { transform: I }) => Yi(I, "x"),
  y: (g, { transform: I }) => Yi(I, "y")
};
fI.translateX = fI.x;
fI.translateY = fI.y;
const nC = /* @__PURE__ */ new Set();
let Fi = !1, zi = !1, fi = !1;
function Vo() {
  if (zi) {
    const g = Array.from(nC).filter((A) => A.needsMeasurement), I = new Set(g.map((A) => A.element)), C = /* @__PURE__ */ new Map();
    I.forEach((A) => {
      const c = oy(A);
      c.length && (C.set(A, c), A.render());
    }), g.forEach((A) => A.measureInitialState()), I.forEach((A) => {
      A.render();
      const c = C.get(A);
      c && c.forEach(([l, t]) => {
        var i;
        (i = A.getValue(l)) == null || i.set(t);
      });
    }), g.forEach((A) => A.measureEndState()), g.forEach((A) => {
      A.suspendedScrollY !== void 0 && window.scrollTo(0, A.suspendedScrollY);
    });
  }
  zi = !1, Fi = !1, nC.forEach((g) => g.complete(fi)), nC.clear();
}
function mo() {
  nC.forEach((g) => {
    g.readKeyframes(), g.needsMeasurement && (zi = !0);
  });
}
function Gy() {
  fi = !0, mo(), Vo(), fi = !1;
}
class $e {
  constructor(I, C, A, c, l, t = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...I], this.onComplete = C, this.name = A, this.motionValue = c, this.element = l, this.isAsync = t;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (nC.add(this), Fi || (Fi = !0, bg.read(mo), bg.resolveKeyframes(Vo))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: I, name: C, element: A, motionValue: c } = this;
    if (I[0] === null) {
      const l = c == null ? void 0 : c.get(), t = I[I.length - 1];
      if (l !== void 0)
        I[0] = l;
      else if (A && C) {
        const i = A.readValue(C, t);
        i != null && (I[0] = i);
      }
      I[0] === void 0 && (I[0] = t), c && l === void 0 && c.set(I[0]);
    }
    ey(I);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(I = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, I), nC.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (nC.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const ry = (g) => g.startsWith("--");
function Xy(g, I, C) {
  ry(I) ? g.style.setProperty(I, C) : g.style[I] = C;
}
const Zy = {};
function ho(g, I) {
  const C = Ed(g);
  return () => Zy[I] ?? C();
}
const Vy = /* @__PURE__ */ ho(() => window.ScrollTimeline !== void 0, "scrollTimeline"), Wo = /* @__PURE__ */ ho(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), VA = ([g, I, C, A]) => `cubic-bezier(${g}, ${I}, ${C}, ${A})`, Za = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ VA([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ VA([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ VA([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ VA([0.33, 1.53, 0.69, 0.99])
};
function No(g, I) {
  if (g)
    return typeof g == "function" ? Wo() ? Go(g, I) : "ease-out" : co(g) ? VA(g) : Array.isArray(g) ? g.map((C) => No(C, I) || Za.easeOut) : Za[g];
}
function my(g, I, C, { delay: A = 0, duration: c = 300, repeat: l = 0, repeatType: t = "loop", ease: i = "easeOut", times: e } = {}, n = void 0) {
  const b = {
    [I]: C
  };
  e && (b.offset = e);
  const a = No(i, c);
  Array.isArray(a) && (b.easing = a);
  const s = {
    delay: A,
    duration: c,
    easing: Array.isArray(a) ? "linear" : a,
    fill: "both",
    iterations: l + 1,
    direction: t === "reverse" ? "alternate" : "normal"
  };
  return n && (s.pseudoElement = n), g.animate(b, s);
}
function xo(g) {
  return typeof g == "function" && "applyToOptions" in g;
}
function hy({ type: g, ...I }) {
  return xo(g) && Wo() ? g.applyToOptions(I) : (I.duration ?? (I.duration = 300), I.ease ?? (I.ease = "easeOut"), I);
}
class yo extends _e {
  constructor(I) {
    if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !I)
      return;
    const { element: C, name: A, keyframes: c, pseudoElement: l, allowFlatten: t = !1, finalKeyframe: i, onComplete: e } = I;
    this.isPseudoElement = !!l, this.allowFlatten = t, this.options = I, RI(typeof I.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const n = hy(I);
    this.animation = my(C, A, c, n, l), n.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !l) {
        const b = Ke(c, this.options, i, this.speed);
        this.updateMotionValue ? this.updateMotionValue(b) : Xy(C, A, b), this.animation.cancel();
      }
      e == null || e(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var I, C;
    (C = (I = this.animation).finish) == null || C.call(I);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: I } = this;
    I === "idle" || I === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var I, C, A;
    const c = (I = this.options) == null ? void 0 : I.element;
    !this.isPseudoElement && c != null && c.isConnected && ((A = (C = this.animation).commitStyles) == null || A.call(C));
  }
  get duration() {
    var I, C;
    const A = ((C = (I = this.animation.effect) == null ? void 0 : I.getComputedTiming) == null ? void 0 : C.call(I).duration) || 0;
    return Qg(Number(A));
  }
  get iterationDuration() {
    const { delay: I = 0 } = this.options || {};
    return this.duration + Qg(I);
  }
  get time() {
    return Qg(Number(this.animation.currentTime) || 0);
  }
  set time(I) {
    this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = _g(I);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(I) {
    I < 0 && (this.finishedTime = null), this.animation.playbackRate = I;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(I) {
    this.manualStartTime = this.animation.startTime = I;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: I, observe: C }) {
    var A;
    return this.allowFlatten && ((A = this.animation.effect) == null || A.updateTiming({ easing: "linear" })), this.animation.onfinish = null, I && Vy() ? (this.animation.timeline = I, Kg) : C(this);
  }
}
const po = {
  anticipate: go,
  backInOut: $d,
  circInOut: Co
};
function Wy(g) {
  return g in po;
}
function Ny(g) {
  typeof g.ease == "string" && Wy(g.ease) && (g.ease = po[g.ease]);
}
const Rt = 10;
class xy extends yo {
  constructor(I) {
    Ny(I), Zo(I), super(I), I.startTime !== void 0 && (this.startTime = I.startTime), this.options = I;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read committed styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(I) {
    const { motionValue: C, onUpdate: A, onComplete: c, element: l, ...t } = this.options;
    if (!C)
      return;
    if (I !== void 0) {
      C.set(I);
      return;
    }
    const i = new qe({
      ...t,
      autoplay: !1
    }), e = Math.max(Rt, kg.now() - this.startTime), n = uI(0, Rt, e - Rt);
    C.setWithVelocity(i.sample(Math.max(0, e - n)).value, i.sample(e).value, n), i.stop();
  }
}
const Va = (g, I) => I === "zIndex" ? !1 : !!(typeof g == "number" || Array.isArray(g) || typeof g == "string" && // It's animatable if we have a string
(cI.test(g) || g === "0") && // And it contains numbers and/or colors
!g.startsWith("url("));
function yy(g) {
  const I = g[0];
  if (g.length === 1)
    return !0;
  for (let C = 0; C < g.length; C++)
    if (g[C] !== I)
      return !0;
}
function py(g, I, C, A) {
  const c = g[0];
  if (c === null)
    return !1;
  if (I === "display" || I === "visibility")
    return !0;
  const l = g[g.length - 1], t = Va(c, I), i = Va(l, I);
  return lA(t === i, `You are trying to animate ${I} from "${c}" to "${l}". "${t ? l : c}" is not an animatable value.`, "value-not-animatable"), !t || !i ? !1 : yy(g) || (C === "spring" || xo(C)) && A;
}
function Hi(g) {
  g.duration = 0, g.type = "keyframes";
}
const Ry = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), By = /* @__PURE__ */ Ed(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function vy(g) {
  var I;
  const { motionValue: C, name: A, repeatDelay: c, repeatType: l, damping: t, type: i } = g;
  if (!(((I = C == null ? void 0 : C.owner) == null ? void 0 : I.current) instanceof HTMLElement))
    return !1;
  const { onUpdate: e, transformTemplate: n } = C.owner.getProps();
  return By() && A && Ry.has(A) && (A !== "transform" || !n) && /**
  * If we're outputting values to onUpdate then we can't use WAAPI as there's
  * no way to read the value from WAAPI every frame.
  */
  !e && !c && l !== "mirror" && t !== 0 && i !== "inertia";
}
const Jy = 40;
class Yy extends _e {
  constructor({ autoplay: I = !0, delay: C = 0, type: A = "keyframes", repeat: c = 0, repeatDelay: l = 0, repeatType: t = "loop", keyframes: i, name: e, motionValue: n, element: b, ...a }) {
    var s;
    super(), this.stop = () => {
      var r, h;
      this._animation && (this._animation.stop(), (r = this.stopTimeline) == null || r.call(this)), (h = this.keyframeResolver) == null || h.cancel();
    }, this.createdAt = kg.now();
    const d = {
      autoplay: I,
      delay: C,
      type: A,
      repeat: c,
      repeatDelay: l,
      repeatType: t,
      name: e,
      motionValue: n,
      element: b,
      ...a
    }, Z = (b == null ? void 0 : b.KeyframeResolver) || $e;
    this.keyframeResolver = new Z(i, (r, h, x) => this.onKeyframesResolved(r, h, d, !x), e, n, b), (s = this.keyframeResolver) == null || s.scheduleResolve();
  }
  onKeyframesResolved(I, C, A, c) {
    var l, t;
    this.keyframeResolver = void 0;
    const { name: i, type: e, velocity: n, delay: b, isHandoff: a, onUpdate: s } = A;
    this.resolvedAt = kg.now(), py(I, i, e, n) || ((BI.instantAnimations || !b) && (s == null || s(Ke(I, A, C))), I[0] = I[I.length - 1], Hi(A), A.repeat = 0);
    const d = {
      startTime: c ? this.resolvedAt ? this.resolvedAt - this.createdAt > Jy ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: C,
      ...A,
      keyframes: I
    }, Z = !a && vy(d), r = (t = (l = d.motionValue) == null ? void 0 : l.owner) == null ? void 0 : t.current, h = Z ? new xy({
      ...d,
      element: r
    }) : new qe(d);
    h.finished.then(() => {
      this.notifyFinished();
    }).catch(Kg), this.pendingTimeline && (this.stopTimeline = h.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = h;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(I, C) {
    return this.finished.finally(I).then(() => {
    });
  }
  get animation() {
    var I;
    return this._animation || ((I = this.keyframeResolver) == null || I.resume(), Gy()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(I) {
    this.animation.time = I;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(I) {
    this.animation.speed = I;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(I) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(I) : this.pendingTimeline = I, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var I;
    this._animation && this.animation.cancel(), (I = this.keyframeResolver) == null || I.cancel();
  }
}
function Ro(g, I, C, A = 0, c = 1) {
  const l = Array.from(g).sort((e, n) => e.sortNodePosition(n)).indexOf(I), t = g.size, i = (t - 1) * A;
  return typeof C == "function" ? C(l, t) : c === 1 ? l * A : i - l * A;
}
const Fy = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function zy(g) {
  const I = Fy.exec(g);
  if (!I)
    return [,];
  const [, C, A, c] = I;
  return [`--${C ?? A}`, c];
}
const fy = 4;
function Bo(g, I, C = 1) {
  RI(C <= fy, `Max CSS variable fallback depth detected in property "${g}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [A, c] = zy(g);
  if (!A)
    return;
  const l = window.getComputedStyle(I).getPropertyValue(A);
  if (l) {
    const t = l.trim();
    return Dd(t) ? parseFloat(t) : t;
  }
  return Oe(c) ? Bo(c, I, C + 1) : c;
}
const Hy = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, wy = (g) => ({
  type: "spring",
  stiffness: 550,
  damping: g === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), Sy = {
  type: "keyframes",
  duration: 0.8
}, Ty = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, Ly = (g, { keyframes: I }) => I.length > 2 ? Sy : eA.has(g) ? g.startsWith("scale") ? wy(I[1]) : Hy : Ty, Uy = (g) => g !== null;
function Py(g, { repeat: I, repeatType: C = "loop" }, A) {
  const c = g.filter(Uy), l = I && C !== "loop" && I % 2 === 1 ? 0 : c.length - 1;
  return !l || A === void 0 ? c[l] : A;
}
function vo(g, I) {
  if (g != null && g.inherit && I) {
    const { inherit: C, ...A } = g;
    return { ...I, ...A };
  }
  return g;
}
function gn(g, I) {
  const C = (g == null ? void 0 : g[I]) ?? (g == null ? void 0 : g.default) ?? g;
  return C !== g ? vo(C, g) : C;
}
function ky({ when: g, delay: I, delayChildren: C, staggerChildren: A, staggerDirection: c, repeat: l, repeatType: t, repeatDelay: i, from: e, elapsed: n, ...b }) {
  return !!Object.keys(b).length;
}
const In = (g, I, C, A = {}, c, l) => (t) => {
  const i = gn(A, g) || {}, e = i.delay || A.delay || 0;
  let { elapsed: n = 0 } = A;
  n = n - _g(e);
  const b = {
    keyframes: Array.isArray(C) ? C : [null, C],
    ease: "easeOut",
    velocity: I.getVelocity(),
    ...i,
    delay: -n,
    onUpdate: (s) => {
      I.set(s), i.onUpdate && i.onUpdate(s);
    },
    onComplete: () => {
      t(), i.onComplete && i.onComplete();
    },
    name: g,
    motionValue: I,
    element: l ? void 0 : c
  };
  ky(i) || Object.assign(b, Ly(g, b)), b.duration && (b.duration = _g(b.duration)), b.repeatDelay && (b.repeatDelay = _g(b.repeatDelay)), b.from !== void 0 && (b.keyframes[0] = b.from);
  let a = !1;
  if ((b.type === !1 || b.duration === 0 && !b.repeatDelay) && (Hi(b), b.delay === 0 && (a = !0)), (BI.instantAnimations || BI.skipAnimations || c != null && c.shouldSkipAnimations) && (a = !0, Hi(b), b.delay = 0), b.allowFlatten = !i.type && !i.ease, a && !l && I.get() !== void 0) {
    const s = Py(b.keyframes, i);
    if (s !== void 0) {
      bg.update(() => {
        b.onUpdate(s), b.onComplete();
      });
      return;
    }
  }
  return i.isSync ? new qe(b) : new Yy(b);
};
function ma(g) {
  const I = [{}, {}];
  return g == null || g.values.forEach((C, A) => {
    I[0][A] = C.get(), I[1][A] = C.getVelocity();
  }), I;
}
function Cn(g, I, C, A) {
  if (typeof I == "function") {
    const [c, l] = ma(A);
    I = I(C !== void 0 ? C : g.custom, c, l);
  }
  if (typeof I == "string" && (I = g.variants && g.variants[I]), typeof I == "function") {
    const [c, l] = ma(A);
    I = I(C !== void 0 ? C : g.custom, c, l);
  }
  return I;
}
function DC(g, I, C) {
  const A = g.getProps();
  return Cn(A, I, C !== void 0 ? C : A.custom, g);
}
const Jo = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...iA
]), ha = 30, Dy = (g) => !isNaN(parseFloat(g)), pA = {
  current: void 0
};
class Oy {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(I, C = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (A) => {
      var c;
      const l = kg.now();
      if (this.updatedAt !== l && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(A), this.current !== this.prev && ((c = this.events.change) == null || c.notify(this.current), this.dependents))
        for (const t of this.dependents)
          t.dirty();
    }, this.hasAnimated = !1, this.setCurrent(I), this.owner = C.owner;
  }
  setCurrent(I) {
    this.current = I, this.updatedAt = kg.now(), this.canTrackVelocity === null && I !== void 0 && (this.canTrackVelocity = Dy(this.current));
  }
  setPrevFrameValue(I = this.current) {
    this.prevFrameValue = I, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(I) {
    return process.env.NODE_ENV !== "production" && Pe(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", I);
  }
  on(I, C) {
    this.events[I] || (this.events[I] = new Ue());
    const A = this.events[I].add(C);
    return I === "change" ? () => {
      A(), bg.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : A;
  }
  clearListeners() {
    for (const I in this.events)
      this.events[I].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(I, C) {
    this.passiveEffect = I, this.stopPassiveEffect = C;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(I) {
    this.passiveEffect ? this.passiveEffect(I, this.updateAndNotify) : this.updateAndNotify(I);
  }
  setWithVelocity(I, C, A) {
    this.set(C), this.prev = void 0, this.prevFrameValue = I, this.prevUpdatedAt = this.updatedAt - A;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(I, C = !0) {
    this.updateAndNotify(I), this.prev = I, this.prevUpdatedAt = this.prevFrameValue = void 0, C && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var I;
    (I = this.events.change) == null || I.notify(this.current);
  }
  addDependent(I) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(I);
  }
  removeDependent(I) {
    this.dependents && this.dependents.delete(I);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return pA.current && pA.current.push(this), this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const I = kg.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || I - this.updatedAt > ha)
      return 0;
    const C = Math.min(this.updatedAt - this.prevUpdatedAt, ha);
    return Qd(parseFloat(this.current) - parseFloat(this.prevFrameValue), C);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(I) {
    return this.stop(), new Promise((C) => {
      this.hasAnimated = !0, this.animation = I(C), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var I, C;
    (I = this.dependents) == null || I.clear(), (C = this.events.destroy) == null || C.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function oC(g, I) {
  return new Oy(g, I);
}
const wi = (g) => Array.isArray(g);
function jy(g, I, C) {
  g.hasValue(I) ? g.getValue(I).set(C) : g.addValue(I, oC(C));
}
function Ey(g) {
  return wi(g) ? g[g.length - 1] || 0 : g;
}
function Qy(g, I) {
  const C = DC(g, I);
  let { transitionEnd: A = {}, transition: c = {}, ...l } = C || {};
  l = { ...l, ...A };
  for (const t in l) {
    const i = Ey(l[t]);
    jy(g, t, i);
  }
}
const Sg = (g) => !!(g && g.getVelocity);
function My(g) {
  return !!(Sg(g) && g.add);
}
function Si(g, I) {
  const C = g.getValue("willChange");
  if (My(C))
    return C.add(I);
  if (!C && BI.WillChange) {
    const A = new BI.WillChange("auto");
    g.addValue("willChange", A), A.add(I);
  }
}
function An(g) {
  return g.replace(/([A-Z])/g, (I) => `-${I.toLowerCase()}`);
}
const Ky = "framerAppearId", Yo = "data-" + An(Ky);
function Fo(g) {
  return g.props[Yo];
}
function _y({ protectedKeys: g, needsAnimating: I }, C) {
  const A = g.hasOwnProperty(C) && I[C] !== !0;
  return I[C] = !1, A;
}
function zo(g, I, { delay: C = 0, transitionOverride: A, type: c } = {}) {
  let { transition: l, transitionEnd: t, ...i } = I;
  const e = g.getDefaultTransition();
  l = l ? vo(l, e) : e;
  const n = l == null ? void 0 : l.reduceMotion;
  A && (l = A);
  const b = [], a = c && g.animationState && g.animationState.getState()[c];
  for (const s in i) {
    const d = g.getValue(s, g.latestValues[s] ?? null), Z = i[s];
    if (Z === void 0 || a && _y(a, s))
      continue;
    const r = {
      delay: C,
      ...gn(l || {}, s)
    }, h = d.get();
    if (h !== void 0 && !d.isAnimating && !Array.isArray(Z) && Z === h && !r.velocity)
      continue;
    let x = !1;
    if (window.MotionHandoffAnimation) {
      const V = Fo(g);
      if (V) {
        const X = window.MotionHandoffAnimation(V, s, bg);
        X !== null && (r.startTime = X, x = !0);
      }
    }
    Si(g, s);
    const u = n ?? g.shouldReduceMotion;
    d.start(In(s, d, Z, u && Jo.has(s) ? { type: !1 } : r, g, x));
    const G = d.animation;
    G && b.push(G);
  }
  if (t) {
    const s = () => bg.update(() => {
      t && Qy(g, t);
    });
    b.length ? Promise.all(b).then(s) : s();
  }
  return b;
}
function Ti(g, I, C = {}) {
  var A;
  const c = DC(g, I, C.type === "exit" ? (A = g.presenceContext) == null ? void 0 : A.custom : void 0);
  let { transition: l = g.getDefaultTransition() || {} } = c || {};
  C.transitionOverride && (l = C.transitionOverride);
  const t = c ? () => Promise.all(zo(g, c, C)) : () => Promise.resolve(), i = g.variantChildren && g.variantChildren.size ? (n = 0) => {
    const { delayChildren: b = 0, staggerChildren: a, staggerDirection: s } = l;
    return qy(g, I, n, b, a, s, C);
  } : () => Promise.resolve(), { when: e } = l;
  if (e) {
    const [n, b] = e === "beforeChildren" ? [t, i] : [i, t];
    return n().then(() => b());
  } else
    return Promise.all([t(), i(C.delay)]);
}
function qy(g, I, C = 0, A = 0, c = 0, l = 1, t) {
  const i = [];
  for (const e of g.variantChildren)
    e.notify("AnimationStart", I), i.push(Ti(e, I, {
      ...t,
      delay: C + (typeof A == "function" ? 0 : A) + Ro(g.variantChildren, e, A, c, l)
    }).then(() => e.notify("AnimationComplete", I)));
  return Promise.all(i);
}
function $y(g, I, C = {}) {
  g.notify("AnimationStart", I);
  let A;
  if (Array.isArray(I)) {
    const c = I.map((l) => Ti(g, l, C));
    A = Promise.all(c);
  } else if (typeof I == "string")
    A = Ti(g, I, C);
  else {
    const c = typeof I == "function" ? DC(g, I, C.custom) : I;
    A = Promise.all(zo(g, c, C));
  }
  return A.then(() => {
    g.notify("AnimationComplete", I);
  });
}
const gp = {
  test: (g) => g === "auto",
  parse: (g) => g
}, fo = (g) => (I) => I.test(g), Ho = [tA, L, aI, zI, Bx, Rx, gp], Wa = (g) => Ho.find(fo(g));
function Ip(g) {
  return typeof g == "number" ? g === 0 : g !== null ? g === "none" || g === "0" || jd(g) : !0;
}
const Cp = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function Ap(g) {
  const [I, C] = g.slice(0, -1).split("(");
  if (I === "drop-shadow")
    return g;
  const [A] = C.match(je) || [];
  if (!A)
    return g;
  const c = C.replace(A, "");
  let l = Cp.has(I) ? 1 : 0;
  return A !== C && (l *= 100), I + "(" + l + c + ")";
}
const cp = /\b([a-z-]*)\(.*?\)/gu, Li = {
  ...cI,
  getAnimatableNone: (g) => {
    const I = g.match(cp);
    return I ? I.map(Ap).join(" ") : g;
  }
}, Ui = {
  ...cI,
  getAnimatableNone: (g) => {
    const I = cI.parse(g);
    return cI.createTransformer(g)(I.map((C) => typeof C == "number" ? 0 : typeof C == "object" ? { ...C, alpha: 1 } : C));
  }
}, Na = {
  ...tA,
  transform: Math.round
}, lp = {
  rotate: zI,
  rotateX: zI,
  rotateY: zI,
  rotateZ: zI,
  scale: Sc,
  scaleX: Sc,
  scaleY: Sc,
  scaleZ: Sc,
  skew: zI,
  skewX: zI,
  skewY: zI,
  distance: L,
  translateX: L,
  translateY: L,
  translateZ: L,
  x: L,
  y: L,
  z: L,
  perspective: L,
  transformPerspective: L,
  opacity: QA,
  originX: ba,
  originY: ba,
  originZ: L
}, cn = {
  // Border props
  borderWidth: L,
  borderTopWidth: L,
  borderRightWidth: L,
  borderBottomWidth: L,
  borderLeftWidth: L,
  borderRadius: L,
  borderTopLeftRadius: L,
  borderTopRightRadius: L,
  borderBottomRightRadius: L,
  borderBottomLeftRadius: L,
  // Positioning props
  width: L,
  maxWidth: L,
  height: L,
  maxHeight: L,
  top: L,
  right: L,
  bottom: L,
  left: L,
  inset: L,
  insetBlock: L,
  insetBlockStart: L,
  insetBlockEnd: L,
  insetInline: L,
  insetInlineStart: L,
  insetInlineEnd: L,
  // Spacing props
  padding: L,
  paddingTop: L,
  paddingRight: L,
  paddingBottom: L,
  paddingLeft: L,
  paddingBlock: L,
  paddingBlockStart: L,
  paddingBlockEnd: L,
  paddingInline: L,
  paddingInlineStart: L,
  paddingInlineEnd: L,
  margin: L,
  marginTop: L,
  marginRight: L,
  marginBottom: L,
  marginLeft: L,
  marginBlock: L,
  marginBlockStart: L,
  marginBlockEnd: L,
  marginInline: L,
  marginInlineStart: L,
  marginInlineEnd: L,
  // Typography
  fontSize: L,
  // Misc
  backgroundPositionX: L,
  backgroundPositionY: L,
  ...lp,
  zIndex: Na,
  // SVG
  fillOpacity: QA,
  strokeOpacity: QA,
  numOctaves: Na
}, tp = {
  ...cn,
  // Color props
  color: Bg,
  backgroundColor: Bg,
  outlineColor: Bg,
  fill: Bg,
  stroke: Bg,
  // Border props
  borderColor: Bg,
  borderTopColor: Bg,
  borderRightColor: Bg,
  borderBottomColor: Bg,
  borderLeftColor: Bg,
  filter: Li,
  WebkitFilter: Li,
  mask: Ui,
  WebkitMask: Ui
}, wo = (g) => tp[g], ip = /* @__PURE__ */ new Set([Li, Ui]);
function So(g, I) {
  let C = wo(g);
  return ip.has(C) || (C = cI), C.getAnimatableNone ? C.getAnimatableNone(I) : void 0;
}
const ep = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function np(g, I, C) {
  let A = 0, c;
  for (; A < g.length && !c; ) {
    const l = g[A];
    typeof l == "string" && !ep.has(l) && MA(l).values.length && (c = g[A]), A++;
  }
  if (c && C)
    for (const l of I)
      g[l] = So(C, c);
}
class bp extends $e {
  constructor(I, C, A, c, l) {
    super(I, C, A, c, l, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: I, element: C, name: A } = this;
    if (!C || !C.current)
      return;
    super.readKeyframes();
    for (let b = 0; b < I.length; b++) {
      let a = I[b];
      if (typeof a == "string" && (a = a.trim(), Oe(a))) {
        const s = Bo(a, C.current);
        s !== void 0 && (I[b] = s), b === I.length - 1 && (this.finalKeyframe = a);
      }
    }
    if (this.resolveNoneKeyframes(), !Jo.has(A) || I.length !== 2)
      return;
    const [c, l] = I, t = Wa(c), i = Wa(l), e = na(c), n = na(l);
    if (e !== n && fI[A]) {
      this.needsMeasurement = !0;
      return;
    }
    if (t !== i)
      if (Xa(t) && Xa(i))
        for (let b = 0; b < I.length; b++) {
          const a = I[b];
          typeof a == "string" && (I[b] = parseFloat(a));
        }
      else
        fI[A] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: I, name: C } = this, A = [];
    for (let c = 0; c < I.length; c++)
      (I[c] === null || Ip(I[c])) && A.push(c);
    A.length && np(I, A, C);
  }
  measureInitialState() {
    const { element: I, unresolvedKeyframes: C, name: A } = this;
    if (!I || !I.current)
      return;
    A === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = fI[A](I.measureViewportBox(), window.getComputedStyle(I.current)), C[0] = this.measuredOrigin;
    const c = C[C.length - 1];
    c !== void 0 && I.getValue(A, c).jump(c, !1);
  }
  measureEndState() {
    var I;
    const { element: C, name: A, unresolvedKeyframes: c } = this;
    if (!C || !C.current)
      return;
    const l = C.getValue(A);
    l && l.jump(this.measuredOrigin, !1);
    const t = c.length - 1, i = c[t];
    c[t] = fI[A](C.measureViewportBox(), window.getComputedStyle(C.current)), i !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = i), (I = this.removedTransforms) != null && I.length && this.removedTransforms.forEach(([e, n]) => {
      C.getValue(e).set(n);
    }), this.resolveNoneKeyframes();
  }
}
const ap = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]);
function To(g, I, C) {
  if (g == null)
    return [];
  if (g instanceof EventTarget)
    return [g];
  if (typeof g == "string") {
    let A = document;
    I && (A = I.current);
    const c = (C == null ? void 0 : C[g]) ?? A.querySelectorAll(g);
    return c ? Array.from(c) : [];
  }
  return Array.from(g).filter((A) => A != null);
}
const Lo = (g, I) => I && typeof g == "number" ? I.transform(g) : g;
function sp(g) {
  return Od(g) && "offsetHeight" in g;
}
const { schedule: ln, cancel: j3 } = /* @__PURE__ */ lo(queueMicrotask, !1), II = {
  x: !1,
  y: !1
};
function Uo() {
  return II.x || II.y;
}
function up(g) {
  return g === "x" || g === "y" ? II[g] ? null : (II[g] = !0, () => {
    II[g] = !1;
  }) : II.x || II.y ? null : (II.x = II.y = !0, () => {
    II.x = II.y = !1;
  });
}
function Po(g, I) {
  const C = To(g), A = new AbortController(), c = {
    passive: !0,
    ...I,
    signal: A.signal
  };
  return [C, c, () => A.abort()];
}
function dp(g) {
  return !(g.pointerType === "touch" || Uo());
}
function op(g, I, C = {}) {
  const [A, c, l] = Po(g, C);
  return A.forEach((t) => {
    let i = !1, e = !1, n;
    const b = () => {
      t.removeEventListener("pointerleave", Z);
    }, a = (h) => {
      n && (n(h), n = void 0), b();
    }, s = (h) => {
      i = !1, window.removeEventListener("pointerup", s), window.removeEventListener("pointercancel", s), e && (e = !1, a(h));
    }, d = () => {
      i = !0, window.addEventListener("pointerup", s, c), window.addEventListener("pointercancel", s, c);
    }, Z = (h) => {
      if (h.pointerType !== "touch") {
        if (i) {
          e = !0;
          return;
        }
        a(h);
      }
    }, r = (h) => {
      if (!dp(h))
        return;
      e = !1;
      const x = I(t, h);
      typeof x == "function" && (n = x, t.addEventListener("pointerleave", Z, c));
    };
    t.addEventListener("pointerenter", r, c), t.addEventListener("pointerdown", d, c);
  }), l;
}
const ko = (g, I) => I ? g === I ? !0 : ko(g, I.parentElement) : !1, tn = (g) => g.pointerType === "mouse" ? typeof g.button != "number" || g.button <= 0 : g.isPrimary !== !1, Gp = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function rp(g) {
  return Gp.has(g.tagName) || g.isContentEditable === !0;
}
const Xp = /* @__PURE__ */ new Set(["INPUT", "SELECT", "TEXTAREA"]);
function Zp(g) {
  return Xp.has(g.tagName) || g.isContentEditable === !0;
}
const Ec = /* @__PURE__ */ new WeakSet();
function xa(g) {
  return (I) => {
    I.key === "Enter" && g(I);
  };
}
function Bt(g, I) {
  g.dispatchEvent(new PointerEvent("pointer" + I, { isPrimary: !0, bubbles: !0 }));
}
const Vp = (g, I) => {
  const C = g.currentTarget;
  if (!C)
    return;
  const A = xa(() => {
    if (Ec.has(C))
      return;
    Bt(C, "down");
    const c = xa(() => {
      Bt(C, "up");
    }), l = () => Bt(C, "cancel");
    C.addEventListener("keyup", c, I), C.addEventListener("blur", l, I);
  });
  C.addEventListener("keydown", A, I), C.addEventListener("blur", () => C.removeEventListener("keydown", A), I);
};
function ya(g) {
  return tn(g) && !Uo();
}
const pa = /* @__PURE__ */ new WeakSet();
function mp(g, I, C = {}) {
  const [A, c, l] = Po(g, C), t = (i) => {
    const e = i.currentTarget;
    if (!ya(i) || pa.has(i))
      return;
    Ec.add(e), C.stopPropagation && pa.add(i);
    const n = I(e, i), b = (d, Z) => {
      window.removeEventListener("pointerup", a), window.removeEventListener("pointercancel", s), Ec.has(e) && Ec.delete(e), ya(d) && typeof n == "function" && n(d, { success: Z });
    }, a = (d) => {
      b(d, e === window || e === document || C.useGlobalTarget || ko(e, d.target));
    }, s = (d) => {
      b(d, !1);
    };
    window.addEventListener("pointerup", a, c), window.addEventListener("pointercancel", s, c);
  };
  return A.forEach((i) => {
    (C.useGlobalTarget ? window : i).addEventListener("pointerdown", t, c), sp(i) && (i.addEventListener("focus", (e) => Vp(e, c)), !rp(i) && !i.hasAttribute("tabindex") && (i.tabIndex = 0));
  }), l;
}
function en(g) {
  return Od(g) && "ownerSVGElement" in g;
}
const Qc = /* @__PURE__ */ new WeakMap();
let RC;
const Do = (g, I, C) => (A, c) => c && c[0] ? c[0][g + "Size"] : en(A) && "getBBox" in A ? A.getBBox()[I] : A[C], hp = /* @__PURE__ */ Do("inline", "width", "offsetWidth"), Wp = /* @__PURE__ */ Do("block", "height", "offsetHeight");
function Np({ target: g, borderBoxSize: I }) {
  var C;
  (C = Qc.get(g)) == null || C.forEach((A) => {
    A(g, {
      get width() {
        return hp(g, I);
      },
      get height() {
        return Wp(g, I);
      }
    });
  });
}
function xp(g) {
  g.forEach(Np);
}
function yp() {
  typeof ResizeObserver > "u" || (RC = new ResizeObserver(xp));
}
function pp(g, I) {
  RC || yp();
  const C = To(g);
  return C.forEach((A) => {
    let c = Qc.get(A);
    c || (c = /* @__PURE__ */ new Set(), Qc.set(A, c)), c.add(I), RC == null || RC.observe(A);
  }), () => {
    C.forEach((A) => {
      const c = Qc.get(A);
      c == null || c.delete(I), c != null && c.size || RC == null || RC.unobserve(A);
    });
  };
}
const Mc = /* @__PURE__ */ new Set();
let HC;
function Rp() {
  HC = () => {
    const g = {
      get width() {
        return window.innerWidth;
      },
      get height() {
        return window.innerHeight;
      }
    };
    Mc.forEach((I) => I(g));
  }, window.addEventListener("resize", HC);
}
function Bp(g) {
  return Mc.add(g), HC || Rp(), () => {
    Mc.delete(g), !Mc.size && typeof HC == "function" && (window.removeEventListener("resize", HC), HC = void 0);
  };
}
function Ra(g, I) {
  return typeof g == "function" ? Bp(g) : pp(g, I);
}
function vp(g) {
  return en(g) && g.tagName === "svg";
}
function Jp(...g) {
  const I = !Array.isArray(g[0]), C = I ? 0 : -1, A = g[0 + C], c = g[1 + C], l = g[2 + C], t = g[3 + C], i = Xo(c, l, t);
  return I ? i(A) : i;
}
const Yp = [...Ho, Bg, cI], Fp = (g) => Yp.find(fo(g)), Ba = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), wC = () => ({
  x: Ba(),
  y: Ba()
}), va = () => ({ min: 0, max: 0 }), vg = () => ({
  x: va(),
  y: va()
}), zp = /* @__PURE__ */ new WeakMap();
function gt(g) {
  return g !== null && typeof g == "object" && typeof g.start == "function";
}
function KA(g) {
  return typeof g == "string" || Array.isArray(g);
}
const nn = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], bn = ["initial", ...nn];
function It(g) {
  return gt(g.animate) || bn.some((I) => KA(g[I]));
}
function Oo(g) {
  return !!(It(g) || g.variants);
}
function fp(g, I, C) {
  for (const A in I) {
    const c = I[A], l = C[A];
    if (Sg(c))
      g.addValue(A, c);
    else if (Sg(l))
      g.addValue(A, oC(c, { owner: g }));
    else if (l !== c)
      if (g.hasValue(A)) {
        const t = g.getValue(A);
        t.liveStyle === !0 ? t.jump(c) : t.hasAnimated || t.set(c);
      } else {
        const t = g.getStaticValue(A);
        g.addValue(A, oC(t !== void 0 ? t : c, { owner: g }));
      }
  }
  for (const A in C)
    I[A] === void 0 && g.removeValue(A);
  return I;
}
const Pi = { current: null }, jo = { current: !1 }, Hp = typeof window < "u";
function wp() {
  if (jo.current = !0, !!Hp)
    if (window.matchMedia) {
      const g = window.matchMedia("(prefers-reduced-motion)"), I = () => Pi.current = g.matches;
      g.addEventListener("change", I), I();
    } else
      Pi.current = !1;
}
const Ja = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
let Rl = {};
function Eo(g) {
  Rl = g;
}
function Sp() {
  return Rl;
}
class Tp {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(I, C, A) {
    return {};
  }
  constructor({ parent: I, props: C, presenceContext: A, reducedMotionConfig: c, skipAnimations: l, blockInitialAnimation: t, visualState: i }, e = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.shouldSkipAnimations = !1, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = $e, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.hasBeenMounted = !1, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const d = kg.now();
      this.renderScheduledAt < d && (this.renderScheduledAt = d, bg.render(this.render, !1, !0));
    };
    const { latestValues: n, renderState: b } = i;
    this.latestValues = n, this.baseTarget = { ...n }, this.initialValues = C.initial ? { ...n } : {}, this.renderState = b, this.parent = I, this.props = C, this.presenceContext = A, this.depth = I ? I.depth + 1 : 0, this.reducedMotionConfig = c, this.skipAnimationsConfig = l, this.options = e, this.blockInitialAnimation = !!t, this.isControllingVariants = It(C), this.isVariantNode = Oo(C), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(I && I.current);
    const { willChange: a, ...s } = this.scrapeMotionValuesFromProps(C, {}, this);
    for (const d in s) {
      const Z = s[d];
      n[d] !== void 0 && Sg(Z) && Z.set(n[d]);
    }
  }
  mount(I) {
    var C, A;
    if (this.hasBeenMounted)
      for (const c in this.initialValues)
        (C = this.values.get(c)) == null || C.jump(this.initialValues[c]), this.latestValues[c] = this.initialValues[c];
    this.current = I, zp.set(I, this), this.projection && !this.projection.instance && this.projection.mount(I), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((c, l) => this.bindToMotionValue(l, c)), this.reducedMotionConfig === "never" ? this.shouldReduceMotion = !1 : this.reducedMotionConfig === "always" ? this.shouldReduceMotion = !0 : (jo.current || wp(), this.shouldReduceMotion = Pi.current), process.env.NODE_ENV !== "production" && Pe(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), this.shouldSkipAnimations = this.skipAnimationsConfig ?? !1, (A = this.parent) == null || A.addChild(this), this.update(this.props, this.presenceContext), this.hasBeenMounted = !0;
  }
  unmount() {
    var I;
    this.projection && this.projection.unmount(), dI(this.notifyUpdate), dI(this.render), this.valueSubscriptions.forEach((C) => C()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), (I = this.parent) == null || I.removeChild(this);
    for (const C in this.events)
      this.events[C].clear();
    for (const C in this.features) {
      const A = this.features[C];
      A && (A.unmount(), A.isMounted = !1);
    }
    this.current = null;
  }
  addChild(I) {
    this.children.add(I), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(I);
  }
  removeChild(I) {
    this.children.delete(I), this.enteringChildren && this.enteringChildren.delete(I);
  }
  bindToMotionValue(I, C) {
    if (this.valueSubscriptions.has(I) && this.valueSubscriptions.get(I)(), C.accelerate && ap.has(I) && this.current instanceof HTMLElement) {
      const { factory: t, keyframes: i, times: e, ease: n, duration: b } = C.accelerate, a = new yo({
        element: this.current,
        name: I,
        keyframes: i,
        times: e,
        ease: n,
        duration: _g(b)
      }), s = t(a);
      this.valueSubscriptions.set(I, () => {
        s(), a.cancel();
      });
      return;
    }
    const A = eA.has(I);
    A && this.onBindTransform && this.onBindTransform();
    const c = C.on("change", (t) => {
      this.latestValues[I] = t, this.props.onUpdate && bg.preRender(this.notifyUpdate), A && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let l;
    typeof window < "u" && window.MotionCheckAppearSync && (l = window.MotionCheckAppearSync(this, I, C)), this.valueSubscriptions.set(I, () => {
      c(), l && l(), C.owner && C.stop();
    });
  }
  sortNodePosition(I) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== I.type ? 0 : this.sortInstanceNodePosition(this.current, I.current);
  }
  updateFeatures() {
    let I = "animation";
    for (I in Rl) {
      const C = Rl[I];
      if (!C)
        continue;
      const { isEnabled: A, Feature: c } = C;
      if (!this.features[I] && c && A(this.props) && (this.features[I] = new c(this)), this.features[I]) {
        const l = this.features[I];
        l.isMounted ? l.update() : (l.mount(), l.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : vg();
  }
  getStaticValue(I) {
    return this.latestValues[I];
  }
  setStaticValue(I, C) {
    this.latestValues[I] = C;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(I, C) {
    (I.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = I, this.prevPresenceContext = this.presenceContext, this.presenceContext = C;
    for (let A = 0; A < Ja.length; A++) {
      const c = Ja[A];
      this.propEventSubscriptions[c] && (this.propEventSubscriptions[c](), delete this.propEventSubscriptions[c]);
      const l = "on" + c, t = I[l];
      t && (this.propEventSubscriptions[c] = this.on(c, t));
    }
    this.prevMotionValues = fp(this, this.scrapeMotionValuesFromProps(I, this.prevProps || {}, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(I) {
    return this.props.variants ? this.props.variants[I] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(I) {
    const C = this.getClosestVariantNode();
    if (C)
      return C.variantChildren && C.variantChildren.add(I), () => C.variantChildren.delete(I);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(I, C) {
    const A = this.values.get(I);
    C !== A && (A && this.removeValue(I), this.bindToMotionValue(I, C), this.values.set(I, C), this.latestValues[I] = C.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(I) {
    this.values.delete(I);
    const C = this.valueSubscriptions.get(I);
    C && (C(), this.valueSubscriptions.delete(I)), delete this.latestValues[I], this.removeValueFromRenderState(I, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(I) {
    return this.values.has(I);
  }
  getValue(I, C) {
    if (this.props.values && this.props.values[I])
      return this.props.values[I];
    let A = this.values.get(I);
    return A === void 0 && C !== void 0 && (A = oC(C === null ? void 0 : C, { owner: this }), this.addValue(I, A)), A;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(I, C) {
    let A = this.latestValues[I] !== void 0 || !this.current ? this.latestValues[I] : this.getBaseTargetFromProps(this.props, I) ?? this.readValueFromInstance(this.current, I, this.options);
    return A != null && (typeof A == "string" && (Dd(A) || jd(A)) ? A = parseFloat(A) : !Fp(A) && cI.test(C) && (A = So(I, C)), this.setBaseTarget(I, Sg(A) ? A.get() : A)), Sg(A) ? A.get() : A;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(I, C) {
    this.baseTarget[I] = C;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(I) {
    var C;
    const { initial: A } = this.props;
    let c;
    if (typeof A == "string" || typeof A == "object") {
      const t = Cn(this.props, A, (C = this.presenceContext) == null ? void 0 : C.custom);
      t && (c = t[I]);
    }
    if (A && c !== void 0)
      return c;
    const l = this.getBaseTargetFromProps(this.props, I);
    return l !== void 0 && !Sg(l) ? l : this.initialValues[I] !== void 0 && c === void 0 ? void 0 : this.baseTarget[I];
  }
  on(I, C) {
    return this.events[I] || (this.events[I] = new Ue()), this.events[I].add(C);
  }
  notify(I, ...C) {
    this.events[I] && this.events[I].notify(...C);
  }
  scheduleRenderMicrotask() {
    ln.render(this.render);
  }
}
class Qo extends Tp {
  constructor() {
    super(...arguments), this.KeyframeResolver = bp;
  }
  sortInstanceNodePosition(I, C) {
    return I.compareDocumentPosition(C) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(I, C) {
    const A = I.style;
    return A ? A[C] : void 0;
  }
  removeValueFromRenderState(I, { vars: C, style: A }) {
    delete C[I], delete A[I];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: I } = this.props;
    Sg(I) && (this.childSubscription = I.on("change", (C) => {
      this.current && (this.current.textContent = `${C}`);
    }));
  }
}
class EI {
  constructor(I) {
    this.isMounted = !1, this.node = I;
  }
  update() {
  }
}
function Mo({ top: g, left: I, right: C, bottom: A }) {
  return {
    x: { min: I, max: C },
    y: { min: g, max: A }
  };
}
function Lp({ x: g, y: I }) {
  return { top: I.min, right: g.max, bottom: I.max, left: g.min };
}
function Up(g, I) {
  if (!I)
    return g;
  const C = I({ x: g.left, y: g.top }), A = I({ x: g.right, y: g.bottom });
  return {
    top: C.y,
    left: C.x,
    bottom: A.y,
    right: A.x
  };
}
function vt(g) {
  return g === void 0 || g === 1;
}
function ki({ scale: g, scaleX: I, scaleY: C }) {
  return !vt(g) || !vt(I) || !vt(C);
}
function IC(g) {
  return ki(g) || Ko(g) || g.z || g.rotate || g.rotateX || g.rotateY || g.skewX || g.skewY;
}
function Ko(g) {
  return Ya(g.x) || Ya(g.y);
}
function Ya(g) {
  return g && g !== "0%";
}
function Bl(g, I, C) {
  const A = g - C, c = I * A;
  return C + c;
}
function Fa(g, I, C, A, c) {
  return c !== void 0 && (g = Bl(g, c, A)), Bl(g, C, A) + I;
}
function Di(g, I = 0, C = 1, A, c) {
  g.min = Fa(g.min, I, C, A, c), g.max = Fa(g.max, I, C, A, c);
}
function _o(g, { x: I, y: C }) {
  Di(g.x, I.translate, I.scale, I.originPoint), Di(g.y, C.translate, C.scale, C.originPoint);
}
const za = 0.999999999999, fa = 1.0000000000001;
function Pp(g, I, C, A = !1) {
  const c = C.length;
  if (!c)
    return;
  I.x = I.y = 1;
  let l, t;
  for (let i = 0; i < c; i++) {
    l = C[i], t = l.projectionDelta;
    const { visualElement: e } = l.options;
    e && e.props.style && e.props.style.display === "contents" || (A && l.options.layoutScroll && l.scroll && l !== l.root && TC(g, {
      x: -l.scroll.offset.x,
      y: -l.scroll.offset.y
    }), t && (I.x *= t.x.scale, I.y *= t.y.scale, _o(g, t)), A && IC(l.latestValues) && TC(g, l.latestValues));
  }
  I.x < fa && I.x > za && (I.x = 1), I.y < fa && I.y > za && (I.y = 1);
}
function SC(g, I) {
  g.min = g.min + I, g.max = g.max + I;
}
function Ha(g, I, C, A, c = 0.5) {
  const l = Vg(g.min, g.max, c);
  Di(g, I, C, l, A);
}
function TC(g, I) {
  Ha(g.x, I.x, I.scaleX, I.scale, I.originX), Ha(g.y, I.y, I.scaleY, I.scale, I.originY);
}
function qo(g, I) {
  return Mo(Up(g.getBoundingClientRect(), I));
}
function kp(g, I, C) {
  const A = qo(g, C), { scroll: c } = I;
  return c && (SC(A.x, c.offset.x), SC(A.y, c.offset.y)), A;
}
const Dp = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, Op = iA.length;
function jp(g, I, C) {
  let A = "", c = !0;
  for (let l = 0; l < Op; l++) {
    const t = iA[l], i = g[t];
    if (i === void 0)
      continue;
    let e = !0;
    if (typeof i == "number")
      e = i === (t.startsWith("scale") ? 1 : 0);
    else {
      const n = parseFloat(i);
      e = t.startsWith("scale") ? n === 1 : n === 0;
    }
    if (!e || C) {
      const n = Lo(i, cn[t]);
      if (!e) {
        c = !1;
        const b = Dp[t] || t;
        A += `${b}(${n}) `;
      }
      C && (I[t] = n);
    }
  }
  return A = A.trim(), C ? A = C(I, c ? "" : A) : c && (A = "none"), A;
}
function an(g, I, C) {
  const { style: A, vars: c, transformOrigin: l } = g;
  let t = !1, i = !1;
  for (const e in I) {
    const n = I[e];
    if (eA.has(e)) {
      t = !0;
      continue;
    } else if (io(e)) {
      c[e] = n;
      continue;
    } else {
      const b = Lo(n, cn[e]);
      e.startsWith("origin") ? (i = !0, l[e] = b) : A[e] = b;
    }
  }
  if (I.transform || (t || C ? A.transform = jp(I, g.transform, C) : A.transform && (A.transform = "none")), i) {
    const { originX: e = "50%", originY: n = "50%", originZ: b = 0 } = l;
    A.transformOrigin = `${e} ${n} ${b}`;
  }
}
function $o(g, { style: I, vars: C }, A, c) {
  const l = g.style;
  let t;
  for (t in I)
    l[t] = I[t];
  c == null || c.applyProjectionStyles(l, A);
  for (t in C)
    l.setProperty(t, C[t]);
}
function wa(g, I) {
  return I.max === I.min ? 0 : g / (I.max - I.min) * 100;
}
const dA = {
  correct: (g, I) => {
    if (!I.target)
      return g;
    if (typeof g == "string")
      if (L.test(g))
        g = parseFloat(g);
      else
        return g;
    const C = wa(g, I.target.x), A = wa(g, I.target.y);
    return `${C}% ${A}%`;
  }
}, Ep = {
  correct: (g, { treeScale: I, projectionDelta: C }) => {
    const A = g, c = cI.parse(g);
    if (c.length > 5)
      return A;
    const l = cI.createTransformer(g), t = typeof c[0] != "number" ? 1 : 0, i = C.x.scale * I.x, e = C.y.scale * I.y;
    c[0 + t] /= i, c[1 + t] /= e;
    const n = Vg(i, e, 0.5);
    return typeof c[2 + t] == "number" && (c[2 + t] /= n), typeof c[3 + t] == "number" && (c[3 + t] /= n), l(c);
  }
}, Oi = {
  borderRadius: {
    ...dA,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: dA,
  borderTopRightRadius: dA,
  borderBottomLeftRadius: dA,
  borderBottomRightRadius: dA,
  boxShadow: Ep
};
function gG(g, { layout: I, layoutId: C }) {
  return eA.has(g) || g.startsWith("origin") || (I || C !== void 0) && (!!Oi[g] || g === "opacity");
}
function sn(g, I, C) {
  var A;
  const c = g.style, l = I == null ? void 0 : I.style, t = {};
  if (!c)
    return t;
  for (const i in c)
    (Sg(c[i]) || l && Sg(l[i]) || gG(i, g) || ((A = C == null ? void 0 : C.getValue(i)) == null ? void 0 : A.liveStyle) !== void 0) && (t[i] = c[i]);
  return t;
}
function Qp(g) {
  return window.getComputedStyle(g);
}
class Mp extends Qo {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = $o;
  }
  readValueFromInstance(I, C) {
    var A;
    if (eA.has(C))
      return (A = this.projection) != null && A.isProjecting ? Ji(C) : ay(I, C);
    {
      const c = Qp(I), l = (io(C) ? c.getPropertyValue(C) : c[C]) || 0;
      return typeof l == "string" ? l.trim() : l;
    }
  }
  measureInstanceViewportBox(I, { transformPagePoint: C }) {
    return qo(I, C);
  }
  build(I, C, A) {
    an(I, C, A.transformTemplate);
  }
  scrapeMotionValuesFromProps(I, C, A) {
    return sn(I, C, A);
  }
}
const Kp = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, _p = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function qp(g, I, C = 1, A = 0, c = !0) {
  g.pathLength = 1;
  const l = c ? Kp : _p;
  g[l.offset] = `${-A}`, g[l.array] = `${I} ${C}`;
}
const $p = [
  "offsetDistance",
  "offsetPath",
  "offsetRotate",
  "offsetAnchor"
];
function IG(g, {
  attrX: I,
  attrY: C,
  attrScale: A,
  pathLength: c,
  pathSpacing: l = 1,
  pathOffset: t = 0,
  // This is object creation, which we try to avoid per-frame.
  ...i
}, e, n, b) {
  if (an(g, i, n), e) {
    g.style.viewBox && (g.attrs.viewBox = g.style.viewBox);
    return;
  }
  g.attrs = g.style, g.style = {};
  const { attrs: a, style: s } = g;
  a.transform && (s.transform = a.transform, delete a.transform), (s.transform || a.transformOrigin) && (s.transformOrigin = a.transformOrigin ?? "50% 50%", delete a.transformOrigin), s.transform && (s.transformBox = (b == null ? void 0 : b.transformBox) ?? "fill-box", delete a.transformBox);
  for (const d of $p)
    a[d] !== void 0 && (s[d] = a[d], delete a[d]);
  I !== void 0 && (a.x = I), C !== void 0 && (a.y = C), A !== void 0 && (a.scale = A), c !== void 0 && qp(a, c, l, t, !1);
}
const CG = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]), AG = (g) => typeof g == "string" && g.toLowerCase() === "svg";
function gR(g, I, C, A) {
  $o(g, I, void 0, A);
  for (const c in I.attrs)
    g.setAttribute(CG.has(c) ? c : An(c), I.attrs[c]);
}
function cG(g, I, C) {
  const A = sn(g, I, C);
  for (const c in g)
    if (Sg(g[c]) || Sg(I[c])) {
      const l = iA.indexOf(c) !== -1 ? "attr" + c.charAt(0).toUpperCase() + c.substring(1) : c;
      A[l] = g[c];
    }
  return A;
}
class IR extends Qo {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = vg;
  }
  getBaseTargetFromProps(I, C) {
    return I[C];
  }
  readValueFromInstance(I, C) {
    if (eA.has(C)) {
      const A = wo(C);
      return A && A.default || 0;
    }
    return C = CG.has(C) ? C : An(C), I.getAttribute(C);
  }
  scrapeMotionValuesFromProps(I, C, A) {
    return cG(I, C, A);
  }
  build(I, C, A) {
    IG(I, C, this.isSVGTag, A.transformTemplate, A.style);
  }
  renderInstance(I, C, A, c) {
    gR(I, C, A, c);
  }
  mount(I) {
    this.isSVGTag = AG(I.tagName), super.mount(I);
  }
}
const CR = bn.length;
function lG(g) {
  if (!g)
    return;
  if (!g.isControllingVariants) {
    const C = g.parent ? lG(g.parent) || {} : {};
    return g.props.initial !== void 0 && (C.initial = g.props.initial), C;
  }
  const I = {};
  for (let C = 0; C < CR; C++) {
    const A = bn[C], c = g.props[A];
    (KA(c) || c === !1) && (I[A] = c);
  }
  return I;
}
function tG(g, I) {
  if (!Array.isArray(I))
    return !1;
  const C = I.length;
  if (C !== g.length)
    return !1;
  for (let A = 0; A < C; A++)
    if (I[A] !== g[A])
      return !1;
  return !0;
}
const AR = [...nn].reverse(), cR = nn.length;
function lR(g) {
  return (I) => Promise.all(I.map(({ animation: C, options: A }) => $y(g, C, A)));
}
function tR(g) {
  let I = lR(g), C = Sa(), A = !0;
  const c = (e) => (n, b) => {
    var a;
    const s = DC(g, b, e === "exit" ? (a = g.presenceContext) == null ? void 0 : a.custom : void 0);
    if (s) {
      const { transition: d, transitionEnd: Z, ...r } = s;
      n = { ...n, ...r, ...Z };
    }
    return n;
  };
  function l(e) {
    I = e(g);
  }
  function t(e) {
    const { props: n } = g, b = lG(g.parent) || {}, a = [], s = /* @__PURE__ */ new Set();
    let d = {}, Z = 1 / 0;
    for (let h = 0; h < cR; h++) {
      const x = AR[h], u = C[x], G = n[x] !== void 0 ? n[x] : b[x], V = KA(G), X = x === e ? u.isActive : null;
      X === !1 && (Z = h);
      let W = G === b[x] && G !== n[x] && V;
      if (W && A && g.manuallyAnimateOnMount && (W = !1), u.protectedKeys = { ...d }, // If it isn't active and hasn't *just* been set as inactive
      !u.isActive && X === null || // If we didn't and don't have any defined prop for this animation type
      !G && !u.prevProp || // Or if the prop doesn't define an animation
      gt(G) || typeof G == "boolean")
        continue;
      if (x === "exit" && u.isActive && X !== !0) {
        u.prevResolvedValues && (d = {
          ...d,
          ...u.prevResolvedValues
        });
        continue;
      }
      const N = iR(u.prevProp, G);
      let m = N || // If we're making this variant active, we want to always make it active
      x === e && u.isActive && !W && V || // If we removed a higher-priority variant (i is in reverse order)
      h > Z && V, p = !1;
      const Y = Array.isArray(G) ? G : [G];
      let v = Y.reduce(c(x), {});
      X === !1 && (v = {});
      const { prevResolvedValues: Q = {} } = u, cg = {
        ...Q,
        ...v
      }, z = (y) => {
        m = !0, s.has(y) && (p = !0, s.delete(y)), u.needsAnimating[y] = !0;
        const f = g.getValue(y);
        f && (f.liveStyle = !1);
      };
      for (const y in cg) {
        const f = v[y], B = Q[y];
        if (d.hasOwnProperty(y))
          continue;
        let H = !1;
        wi(f) && wi(B) ? H = !tG(f, B) : H = f !== B, H ? f != null ? z(y) : s.add(y) : f !== void 0 && s.has(y) ? z(y) : u.protectedKeys[y] = !0;
      }
      u.prevProp = G, u.prevResolvedValues = v, u.isActive && (d = { ...d, ...v }), A && g.blockInitialAnimation && (m = !1);
      const J = W && N;
      m && (!J || p) && a.push(...Y.map((y) => {
        const f = { type: x };
        if (typeof y == "string" && A && !J && g.manuallyAnimateOnMount && g.parent) {
          const { parent: B } = g, H = DC(B, y);
          if (B.enteringChildren && H) {
            const { delayChildren: F } = H.transition || {};
            f.delay = Ro(B.enteringChildren, g, F);
          }
        }
        return {
          animation: y,
          options: f
        };
      }));
    }
    if (s.size) {
      const h = {};
      if (typeof n.initial != "boolean") {
        const x = DC(g, Array.isArray(n.initial) ? n.initial[0] : n.initial);
        x && x.transition && (h.transition = x.transition);
      }
      s.forEach((x) => {
        const u = g.getBaseTarget(x), G = g.getValue(x);
        G && (G.liveStyle = !0), h[x] = u ?? null;
      }), a.push({ animation: h });
    }
    let r = !!a.length;
    return A && (n.initial === !1 || n.initial === n.animate) && !g.manuallyAnimateOnMount && (r = !1), A = !1, r ? I(a) : Promise.resolve();
  }
  function i(e, n) {
    var b;
    if (C[e].isActive === n)
      return Promise.resolve();
    (b = g.variantChildren) == null || b.forEach((s) => {
      var d;
      return (d = s.animationState) == null ? void 0 : d.setActive(e, n);
    }), C[e].isActive = n;
    const a = t(e);
    for (const s in C)
      C[s].protectedKeys = {};
    return a;
  }
  return {
    animateChanges: t,
    setActive: i,
    setAnimateFunction: l,
    getState: () => C,
    reset: () => {
      C = Sa();
    }
  };
}
function iR(g, I) {
  return typeof I == "string" ? I !== g : Array.isArray(I) ? !tG(I, g) : !1;
}
function $I(g = !1) {
  return {
    isActive: g,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Sa() {
  return {
    animate: $I(!0),
    whileInView: $I(),
    whileHover: $I(),
    whileTap: $I(),
    whileDrag: $I(),
    whileFocus: $I(),
    exit: $I()
  };
}
function Ta(g, I) {
  g.min = I.min, g.max = I.max;
}
function gI(g, I) {
  Ta(g.x, I.x), Ta(g.y, I.y);
}
function La(g, I) {
  g.translate = I.translate, g.scale = I.scale, g.originPoint = I.originPoint, g.origin = I.origin;
}
const iG = 1e-4, eR = 1 - iG, nR = 1 + iG, eG = 0.01, bR = 0 - eG, aR = 0 + eG;
function Dg(g) {
  return g.max - g.min;
}
function sR(g, I, C) {
  return Math.abs(g - I) <= C;
}
function Ua(g, I, C, A = 0.5) {
  g.origin = A, g.originPoint = Vg(I.min, I.max, g.origin), g.scale = Dg(C) / Dg(I), g.translate = Vg(C.min, C.max, g.origin) - g.originPoint, (g.scale >= eR && g.scale <= nR || isNaN(g.scale)) && (g.scale = 1), (g.translate >= bR && g.translate <= aR || isNaN(g.translate)) && (g.translate = 0);
}
function RA(g, I, C, A) {
  Ua(g.x, I.x, C.x, A ? A.originX : void 0), Ua(g.y, I.y, C.y, A ? A.originY : void 0);
}
function Pa(g, I, C) {
  g.min = C.min + I.min, g.max = g.min + Dg(I);
}
function uR(g, I, C) {
  Pa(g.x, I.x, C.x), Pa(g.y, I.y, C.y);
}
function ka(g, I, C) {
  g.min = I.min - C.min, g.max = g.min + Dg(I);
}
function vl(g, I, C) {
  ka(g.x, I.x, C.x), ka(g.y, I.y, C.y);
}
function Da(g, I, C, A, c) {
  return g -= I, g = Bl(g, 1 / C, A), c !== void 0 && (g = Bl(g, 1 / c, A)), g;
}
function dR(g, I = 0, C = 1, A = 0.5, c, l = g, t = g) {
  if (aI.test(I) && (I = parseFloat(I), I = Vg(t.min, t.max, I / 100) - t.min), typeof I != "number")
    return;
  let i = Vg(l.min, l.max, A);
  g === l && (i -= I), g.min = Da(g.min, I, C, i, c), g.max = Da(g.max, I, C, i, c);
}
function Oa(g, I, [C, A, c], l, t) {
  dR(g, I[C], I[A], I[c], I.scale, l, t);
}
const oR = ["x", "scaleX", "originX"], GR = ["y", "scaleY", "originY"];
function ja(g, I, C, A) {
  Oa(g.x, I, oR, C ? C.x : void 0, A ? A.x : void 0), Oa(g.y, I, GR, C ? C.y : void 0, A ? A.y : void 0);
}
function Ea(g) {
  return g.translate === 0 && g.scale === 1;
}
function nG(g) {
  return Ea(g.x) && Ea(g.y);
}
function Qa(g, I) {
  return g.min === I.min && g.max === I.max;
}
function rR(g, I) {
  return Qa(g.x, I.x) && Qa(g.y, I.y);
}
function Ma(g, I) {
  return Math.round(g.min) === Math.round(I.min) && Math.round(g.max) === Math.round(I.max);
}
function bG(g, I) {
  return Ma(g.x, I.x) && Ma(g.y, I.y);
}
function Ka(g) {
  return Dg(g.x) / Dg(g.y);
}
function _a(g, I) {
  return g.translate === I.translate && g.scale === I.scale && g.originPoint === I.originPoint;
}
function lI(g) {
  return [g("x"), g("y")];
}
function XR(g, I, C) {
  let A = "";
  const c = g.x.translate / I.x, l = g.y.translate / I.y, t = (C == null ? void 0 : C.z) || 0;
  if ((c || l || t) && (A = `translate3d(${c}px, ${l}px, ${t}px) `), (I.x !== 1 || I.y !== 1) && (A += `scale(${1 / I.x}, ${1 / I.y}) `), C) {
    const { transformPerspective: n, rotate: b, rotateX: a, rotateY: s, skewX: d, skewY: Z } = C;
    n && (A = `perspective(${n}px) ${A}`), b && (A += `rotate(${b}deg) `), a && (A += `rotateX(${a}deg) `), s && (A += `rotateY(${s}deg) `), d && (A += `skewX(${d}deg) `), Z && (A += `skewY(${Z}deg) `);
  }
  const i = g.x.scale * I.x, e = g.y.scale * I.y;
  return (i !== 1 || e !== 1) && (A += `scale(${i}, ${e})`), A || "none";
}
const aG = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], ZR = aG.length, qa = (g) => typeof g == "string" ? parseFloat(g) : g, $a = (g) => typeof g == "number" || L.test(g);
function VR(g, I, C, A, c, l) {
  c ? (g.opacity = Vg(0, C.opacity ?? 1, mR(A)), g.opacityExit = Vg(I.opacity ?? 1, 0, hR(A))) : l && (g.opacity = Vg(I.opacity ?? 1, C.opacity ?? 1, A));
  for (let t = 0; t < ZR; t++) {
    const i = `border${aG[t]}Radius`;
    let e = gs(I, i), n = gs(C, i);
    e === void 0 && n === void 0 || (e || (e = 0), n || (n = 0), e === 0 || n === 0 || $a(e) === $a(n) ? (g[i] = Math.max(Vg(qa(e), qa(n), A), 0), (aI.test(n) || aI.test(e)) && (g[i] += "%")) : g[i] = n);
  }
  (I.rotate || C.rotate) && (g.rotate = Vg(I.rotate || 0, C.rotate || 0, A));
}
function gs(g, I) {
  return g[I] !== void 0 ? g[I] : g.borderRadius;
}
const mR = /* @__PURE__ */ sG(0, 0.5, Io), hR = /* @__PURE__ */ sG(0.5, 0.95, Kg);
function sG(g, I, C) {
  return (A) => A < g ? 0 : A > I ? 1 : C(EA(g, I, A));
}
function WR(g, I, C) {
  const A = Sg(g) ? g : oC(g);
  return A.start(In("", A, I, C)), A.animation;
}
function _A(g, I, C, A = { passive: !0 }) {
  return g.addEventListener(I, C, A), () => g.removeEventListener(I, C);
}
const NR = (g, I) => g.depth - I.depth;
class xR {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(I) {
    Le(this.children, I), this.isDirty = !0;
  }
  remove(I) {
    Nl(this.children, I), this.isDirty = !0;
  }
  forEach(I) {
    this.isDirty && this.children.sort(NR), this.isDirty = !1, this.children.forEach(I);
  }
}
function yR(g, I) {
  const C = kg.now(), A = ({ timestamp: c }) => {
    const l = c - C;
    l >= I && (dI(A), g(l - I));
  };
  return bg.setup(A, !0), () => dI(A);
}
function Kc(g) {
  return Sg(g) ? g.get() : g;
}
class pR {
  constructor() {
    this.members = [];
  }
  add(I) {
    Le(this.members, I);
    for (let C = this.members.length - 1; C >= 0; C--) {
      const A = this.members[C];
      if (A === I || A === this.lead || A === this.prevLead)
        continue;
      const c = A.instance;
      c && c.isConnected === !1 && A.isPresent !== !1 && !A.snapshot && Nl(this.members, A);
    }
    I.scheduleRender();
  }
  remove(I) {
    if (Nl(this.members, I), I === this.prevLead && (this.prevLead = void 0), I === this.lead) {
      const C = this.members[this.members.length - 1];
      C && this.promote(C);
    }
  }
  relegate(I) {
    const C = this.members.findIndex((c) => I === c);
    if (C === 0)
      return !1;
    let A;
    for (let c = C; c >= 0; c--) {
      const l = this.members[c], t = l.instance;
      if (l.isPresent !== !1 && (!t || t.isConnected !== !1)) {
        A = l;
        break;
      }
    }
    return A ? (this.promote(A), !0) : !1;
  }
  promote(I, C) {
    const A = this.lead;
    if (I !== A && (this.prevLead = A, this.lead = I, I.show(), A)) {
      A.instance && A.scheduleRender(), I.scheduleRender();
      const c = A.options.layoutDependency, l = I.options.layoutDependency;
      if (!(c !== void 0 && l !== void 0 && c === l)) {
        const i = A.instance;
        i && i.isConnected === !1 && !A.snapshot || (I.resumeFrom = A, C && (I.resumeFrom.preserveOpacity = !0), A.snapshot && (I.snapshot = A.snapshot, I.snapshot.latestValues = A.animationValues || A.latestValues), I.root && I.root.isUpdating && (I.isLayoutDirty = !0));
      }
      const { crossfade: t } = I.options;
      t === !1 && A.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((I) => {
      const { options: C, resumingFrom: A } = I;
      C.onExitComplete && C.onExitComplete(), A && A.options.onExitComplete && A.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((I) => {
      I.instance && I.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
const _c = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, Jt = ["", "X", "Y", "Z"], RR = 1e3;
let BR = 0;
function Yt(g, I, C, A) {
  const { latestValues: c } = I;
  c[g] && (C[g] = c[g], I.setStaticValue(g, 0), A && (A[g] = 0));
}
function uG(g) {
  if (g.hasCheckedOptimisedAppear = !0, g.root === g)
    return;
  const { visualElement: I } = g.options;
  if (!I)
    return;
  const C = Fo(I);
  if (window.MotionHasOptimisedAnimation(C, "transform")) {
    const { layout: c, layoutId: l } = g.options;
    window.MotionCancelOptimisedAnimation(C, "transform", bg, !(c || l));
  }
  const { parent: A } = g;
  A && !A.hasCheckedOptimisedAppear && uG(A);
}
function dG({ attachResizeListener: g, defaultParent: I, measureScroll: C, checkIsScrollRoot: A, resetTransform: c }) {
  return class {
    constructor(l = {}, t = I == null ? void 0 : I()) {
      this.id = BR++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.layoutVersion = 0, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(YR), this.nodes.forEach(HR), this.nodes.forEach(wR), this.nodes.forEach(FR);
      }, this.resolvedRelativeTargetAt = 0, this.linkedParentVersion = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = l, this.root = t ? t.root || t : this, this.path = t ? [...t.path, t] : [], this.parent = t, this.depth = t ? t.depth + 1 : 0;
      for (let i = 0; i < this.path.length; i++)
        this.path[i].shouldResetTransform = !0;
      this.root === this && (this.nodes = new xR());
    }
    addEventListener(l, t) {
      return this.eventHandlers.has(l) || this.eventHandlers.set(l, new Ue()), this.eventHandlers.get(l).add(t);
    }
    notifyListeners(l, ...t) {
      const i = this.eventHandlers.get(l);
      i && i.notify(...t);
    }
    hasListeners(l) {
      return this.eventHandlers.has(l);
    }
    /**
     * Lifecycles
     */
    mount(l) {
      if (this.instance)
        return;
      this.isSVG = en(l) && !vp(l), this.instance = l;
      const { layoutId: t, layout: i, visualElement: e } = this.options;
      if (e && !e.current && e.mount(l), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (i || t) && (this.isLayoutDirty = !0), g) {
        let n, b = 0;
        const a = () => this.root.updateBlockedByResize = !1;
        bg.read(() => {
          b = window.innerWidth;
        }), g(l, () => {
          const s = window.innerWidth;
          s !== b && (b = s, this.root.updateBlockedByResize = !0, n && n(), n = yR(a, 250), _c.hasAnimatedSinceResize && (_c.hasAnimatedSinceResize = !1, this.nodes.forEach(As)));
        });
      }
      t && this.root.registerSharedNode(t, this), this.options.animate !== !1 && e && (t || i) && this.addEventListener("didUpdate", ({ delta: n, hasLayoutChanged: b, hasRelativeLayoutChanged: a, layout: s }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const d = this.options.transition || e.getDefaultTransition() || PR, { onLayoutAnimationStart: Z, onLayoutAnimationComplete: r } = e.getProps(), h = !this.targetLayout || !bG(this.targetLayout, s), x = !b && a;
        if (this.options.layoutRoot || this.resumeFrom || x || b && (h || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const u = {
            ...gn(d, "layout"),
            onPlay: Z,
            onComplete: r
          };
          (e.shouldReduceMotion || this.options.layoutRoot) && (u.delay = 0, u.type = !1), this.startAnimation(u), this.setAnimationOrigin(n, x);
        } else
          b || As(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = s;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const l = this.getStack();
      l && l.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), dI(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(SR), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: l } = this.options;
      return l && l.getProps().transformTemplate;
    }
    willUpdate(l = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && uG(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let n = 0; n < this.path.length; n++) {
        const b = this.path[n];
        b.shouldResetTransform = !0, b.updateScroll("snapshot"), b.options.layoutRoot && b.willUpdate(!1);
      }
      const { layoutId: t, layout: i } = this.options;
      if (t === void 0 && !i)
        return;
      const e = this.getTransformTemplate();
      this.prevTransformTemplateValue = e ? e(this.latestValues, "") : void 0, this.updateSnapshot(), l && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Is);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(Cs);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(fR), this.nodes.forEach(vR), this.nodes.forEach(JR)) : this.nodes.forEach(Cs), this.clearAllSnapshots();
      const l = kg.now();
      zg.delta = uI(0, 1e3 / 60, l - zg.timestamp), zg.timestamp = l, zg.isProcessing = !0, Wt.update.process(zg), Wt.preRender.process(zg), Wt.render.process(zg), zg.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, ln.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(zR), this.sharedNodes.forEach(TR);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, bg.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      bg.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Dg(this.snapshot.measuredBox.x) && !Dg(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let i = 0; i < this.path.length; i++)
          this.path[i].updateScroll();
      const l = this.layout;
      this.layout = this.measure(!1), this.layoutVersion++, this.layoutCorrected = vg(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: t } = this.options;
      t && t.notify("LayoutMeasure", this.layout.layoutBox, l ? l.layoutBox : void 0);
    }
    updateScroll(l = "measure") {
      let t = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === l && (t = !1), t && this.instance) {
        const i = A(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: l,
          isRoot: i,
          offset: C(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : i
        };
      }
    }
    resetTransform() {
      if (!c)
        return;
      const l = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, t = this.projectionDelta && !nG(this.projectionDelta), i = this.getTransformTemplate(), e = i ? i(this.latestValues, "") : void 0, n = e !== this.prevTransformTemplateValue;
      l && this.instance && (t || IC(this.latestValues) || n) && (c(this.instance, e), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(l = !0) {
      const t = this.measurePageBox();
      let i = this.removeElementScroll(t);
      return l && (i = this.removeTransform(i)), kR(i), {
        animationId: this.root.animationId,
        measuredBox: t,
        layoutBox: i,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var l;
      const { visualElement: t } = this.options;
      if (!t)
        return vg();
      const i = t.measureViewportBox();
      if (!((l = this.scroll) != null && l.wasRoot || this.path.some(DR))) {
        const { scroll: e } = this.root;
        e && (SC(i.x, e.offset.x), SC(i.y, e.offset.y));
      }
      return i;
    }
    removeElementScroll(l) {
      var t;
      const i = vg();
      if (gI(i, l), (t = this.scroll) != null && t.wasRoot)
        return i;
      for (let e = 0; e < this.path.length; e++) {
        const n = this.path[e], { scroll: b, options: a } = n;
        n !== this.root && b && a.layoutScroll && (b.wasRoot && gI(i, l), SC(i.x, b.offset.x), SC(i.y, b.offset.y));
      }
      return i;
    }
    applyTransform(l, t = !1) {
      const i = vg();
      gI(i, l);
      for (let e = 0; e < this.path.length; e++) {
        const n = this.path[e];
        !t && n.options.layoutScroll && n.scroll && n !== n.root && TC(i, {
          x: -n.scroll.offset.x,
          y: -n.scroll.offset.y
        }), IC(n.latestValues) && TC(i, n.latestValues);
      }
      return IC(this.latestValues) && TC(i, this.latestValues), i;
    }
    removeTransform(l) {
      const t = vg();
      gI(t, l);
      for (let i = 0; i < this.path.length; i++) {
        const e = this.path[i];
        if (!e.instance || !IC(e.latestValues))
          continue;
        ki(e.latestValues) && e.updateSnapshot();
        const n = vg(), b = e.measurePageBox();
        gI(n, b), ja(t, e.latestValues, e.snapshot ? e.snapshot.layoutBox : void 0, n);
      }
      return IC(this.latestValues) && ja(t, this.latestValues), t;
    }
    setTargetDelta(l) {
      this.targetDelta = l, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(l) {
      this.options = {
        ...this.options,
        ...l,
        crossfade: l.crossfade !== void 0 ? l.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== zg.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(l = !1) {
      var t;
      const i = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = i.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = i.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = i.isSharedProjectionDirty);
      const e = !!this.resumingFrom || this !== i;
      if (!(l || e && this.isSharedProjectionDirty || this.isProjectionDirty || (t = this.parent) != null && t.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: n, layoutId: b } = this.options;
      if (!this.layout || !(n || b))
        return;
      this.resolvedRelativeTargetAt = zg.timestamp;
      const a = this.getClosestProjectingParent();
      a && this.linkedParentVersion !== a.layoutVersion && !a.options.layoutRoot && this.removeRelativeTarget(), !this.targetDelta && !this.relativeTarget && (a && a.layout ? this.createRelativeTarget(a, this.layout.layoutBox, a.layout.layoutBox) : this.removeRelativeTarget()), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = vg(), this.targetWithTransforms = vg()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), uR(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : gI(this.target, this.layout.layoutBox), _o(this.target, this.targetDelta)) : gI(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, a && !!a.resumingFrom == !!this.resumingFrom && !a.options.layoutScroll && a.target && this.animationProgress !== 1 ? this.createRelativeTarget(a, this.target, a.target) : this.relativeParent = this.relativeTarget = void 0), Ni.value);
    }
    getClosestProjectingParent() {
      if (!(!this.parent || ki(this.parent.latestValues) || Ko(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    createRelativeTarget(l, t, i) {
      this.relativeParent = l, this.linkedParentVersion = l.layoutVersion, this.forceRelativeParentToResolveTarget(), this.relativeTarget = vg(), this.relativeTargetOrigin = vg(), vl(this.relativeTargetOrigin, t, i), gI(this.relativeTarget, this.relativeTargetOrigin);
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0;
    }
    calcProjection() {
      var l;
      const t = this.getLead(), i = !!this.resumingFrom || this !== t;
      let e = !0;
      if ((this.isProjectionDirty || (l = this.parent) != null && l.isProjectionDirty) && (e = !1), i && (this.isSharedProjectionDirty || this.isTransformDirty) && (e = !1), this.resolvedRelativeTargetAt === zg.timestamp && (e = !1), e)
        return;
      const { layout: n, layoutId: b } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(n || b))
        return;
      gI(this.layoutCorrected, this.layout.layoutBox);
      const a = this.treeScale.x, s = this.treeScale.y;
      Pp(this.layoutCorrected, this.treeScale, this.path, i), t.layout && !t.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (t.target = t.layout.layoutBox, t.targetWithTransforms = vg());
      const { target: d } = t;
      if (!d) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (La(this.prevProjectionDelta.x, this.projectionDelta.x), La(this.prevProjectionDelta.y, this.projectionDelta.y)), RA(this.projectionDelta, this.layoutCorrected, d, this.latestValues), (this.treeScale.x !== a || this.treeScale.y !== s || !_a(this.projectionDelta.x, this.prevProjectionDelta.x) || !_a(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", d));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(l = !0) {
      var t;
      if ((t = this.options.visualElement) == null || t.scheduleRender(), l) {
        const i = this.getStack();
        i && i.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = wC(), this.projectionDelta = wC(), this.projectionDeltaWithTransform = wC();
    }
    setAnimationOrigin(l, t = !1) {
      const i = this.snapshot, e = i ? i.latestValues : {}, n = { ...this.latestValues }, b = wC();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !t;
      const a = vg(), s = i ? i.source : void 0, d = this.layout ? this.layout.source : void 0, Z = s !== d, r = this.getStack(), h = !r || r.members.length <= 1, x = !!(Z && !h && this.options.crossfade === !0 && !this.path.some(UR));
      this.animationProgress = 0;
      let u;
      this.mixTargetDelta = (G) => {
        const V = G / 1e3;
        cs(b.x, l.x, V), cs(b.y, l.y, V), this.setTargetDelta(b), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (vl(a, this.layout.layoutBox, this.relativeParent.layout.layoutBox), LR(this.relativeTarget, this.relativeTargetOrigin, a, V), u && rR(this.relativeTarget, u) && (this.isProjectionDirty = !1), u || (u = vg()), gI(u, this.relativeTarget)), Z && (this.animationValues = n, VR(n, e, this.latestValues, V, x, h)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = V;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(l) {
      var t, i, e;
      this.notifyListeners("animationStart"), (t = this.currentAnimation) == null || t.stop(), (e = (i = this.resumingFrom) == null ? void 0 : i.currentAnimation) == null || e.stop(), this.pendingAnimation && (dI(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = bg.update(() => {
        _c.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = oC(0)), this.motionValue.jump(0, !1), this.currentAnimation = WR(this.motionValue, [0, 1e3], {
          ...l,
          velocity: 0,
          isSync: !0,
          onUpdate: (n) => {
            this.mixTargetDelta(n), l.onUpdate && l.onUpdate(n);
          },
          onStop: () => {
          },
          onComplete: () => {
            l.onComplete && l.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const l = this.getStack();
      l && l.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(RR), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const l = this.getLead();
      let { targetWithTransforms: t, target: i, layout: e, latestValues: n } = l;
      if (!(!t || !i || !e)) {
        if (this !== l && this.layout && e && oG(this.options.animationType, this.layout.layoutBox, e.layoutBox)) {
          i = this.target || vg();
          const b = Dg(this.layout.layoutBox.x);
          i.x.min = l.target.x.min, i.x.max = i.x.min + b;
          const a = Dg(this.layout.layoutBox.y);
          i.y.min = l.target.y.min, i.y.max = i.y.min + a;
        }
        gI(t, i), TC(t, n), RA(this.projectionDeltaWithTransform, this.layoutCorrected, t, n);
      }
    }
    registerSharedNode(l, t) {
      this.sharedNodes.has(l) || this.sharedNodes.set(l, new pR()), this.sharedNodes.get(l).add(t);
      const i = t.options.initialPromotionConfig;
      t.promote({
        transition: i ? i.transition : void 0,
        preserveFollowOpacity: i && i.shouldPreserveFollowOpacity ? i.shouldPreserveFollowOpacity(t) : void 0
      });
    }
    isLead() {
      const l = this.getStack();
      return l ? l.lead === this : !0;
    }
    getLead() {
      var l;
      const { layoutId: t } = this.options;
      return t ? ((l = this.getStack()) == null ? void 0 : l.lead) || this : this;
    }
    getPrevLead() {
      var l;
      const { layoutId: t } = this.options;
      return t ? (l = this.getStack()) == null ? void 0 : l.prevLead : void 0;
    }
    getStack() {
      const { layoutId: l } = this.options;
      if (l)
        return this.root.sharedNodes.get(l);
    }
    promote({ needsReset: l, transition: t, preserveFollowOpacity: i } = {}) {
      const e = this.getStack();
      e && e.promote(this, i), l && (this.projectionDelta = void 0, this.needsReset = !0), t && this.setOptions({ transition: t });
    }
    relegate() {
      const l = this.getStack();
      return l ? l.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: l } = this.options;
      if (!l)
        return;
      let t = !1;
      const { latestValues: i } = l;
      if ((i.z || i.rotate || i.rotateX || i.rotateY || i.rotateZ || i.skewX || i.skewY) && (t = !0), !t)
        return;
      const e = {};
      i.z && Yt("z", l, e, this.animationValues);
      for (let n = 0; n < Jt.length; n++)
        Yt(`rotate${Jt[n]}`, l, e, this.animationValues), Yt(`skew${Jt[n]}`, l, e, this.animationValues);
      l.render();
      for (const n in e)
        l.setStaticValue(n, e[n]), this.animationValues && (this.animationValues[n] = e[n]);
      l.scheduleRender();
    }
    applyProjectionStyles(l, t) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        l.visibility = "hidden";
        return;
      }
      const i = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, l.visibility = "", l.opacity = "", l.pointerEvents = Kc(t == null ? void 0 : t.pointerEvents) || "", l.transform = i ? i(this.latestValues, "") : "none";
        return;
      }
      const e = this.getLead();
      if (!this.projectionDelta || !this.layout || !e.target) {
        this.options.layoutId && (l.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, l.pointerEvents = Kc(t == null ? void 0 : t.pointerEvents) || ""), this.hasProjected && !IC(this.latestValues) && (l.transform = i ? i({}, "") : "none", this.hasProjected = !1);
        return;
      }
      l.visibility = "";
      const n = e.animationValues || e.latestValues;
      this.applyTransformsToTarget();
      let b = XR(this.projectionDeltaWithTransform, this.treeScale, n);
      i && (b = i(n, b)), l.transform = b;
      const { x: a, y: s } = this.projectionDelta;
      l.transformOrigin = `${a.origin * 100}% ${s.origin * 100}% 0`, e.animationValues ? l.opacity = e === this ? n.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : n.opacityExit : l.opacity = e === this ? n.opacity !== void 0 ? n.opacity : "" : n.opacityExit !== void 0 ? n.opacityExit : 0;
      for (const d in Oi) {
        if (n[d] === void 0)
          continue;
        const { correct: Z, applyTo: r, isCSSVariable: h } = Oi[d], x = b === "none" ? n[d] : Z(n[d], e);
        if (r) {
          const u = r.length;
          for (let G = 0; G < u; G++)
            l[r[G]] = x;
        } else
          h ? this.options.visualElement.renderState.vars[d] = x : l[d] = x;
      }
      this.options.layoutId && (l.pointerEvents = e === this ? Kc(t == null ? void 0 : t.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((l) => {
        var t;
        return (t = l.currentAnimation) == null ? void 0 : t.stop();
      }), this.root.nodes.forEach(Is), this.root.sharedNodes.clear();
    }
  };
}
function vR(g) {
  g.updateLayout();
}
function JR(g) {
  var I;
  const C = ((I = g.resumeFrom) == null ? void 0 : I.snapshot) || g.snapshot;
  if (g.isLead() && g.layout && C && g.hasListeners("didUpdate")) {
    const { layoutBox: A, measuredBox: c } = g.layout, { animationType: l } = g.options, t = C.source !== g.layout.source;
    l === "size" ? lI((a) => {
      const s = t ? C.measuredBox[a] : C.layoutBox[a], d = Dg(s);
      s.min = A[a].min, s.max = s.min + d;
    }) : oG(l, C.layoutBox, A) && lI((a) => {
      const s = t ? C.measuredBox[a] : C.layoutBox[a], d = Dg(A[a]);
      s.max = s.min + d, g.relativeTarget && !g.currentAnimation && (g.isProjectionDirty = !0, g.relativeTarget[a].max = g.relativeTarget[a].min + d);
    });
    const i = wC();
    RA(i, A, C.layoutBox);
    const e = wC();
    t ? RA(e, g.applyTransform(c, !0), C.measuredBox) : RA(e, A, C.layoutBox);
    const n = !nG(i);
    let b = !1;
    if (!g.resumeFrom) {
      const a = g.getClosestProjectingParent();
      if (a && !a.resumeFrom) {
        const { snapshot: s, layout: d } = a;
        if (s && d) {
          const Z = vg();
          vl(Z, C.layoutBox, s.layoutBox);
          const r = vg();
          vl(r, A, d.layoutBox), bG(Z, r) || (b = !0), a.options.layoutRoot && (g.relativeTarget = r, g.relativeTargetOrigin = Z, g.relativeParent = a);
        }
      }
    }
    g.notifyListeners("didUpdate", {
      layout: A,
      snapshot: C,
      delta: e,
      layoutDelta: i,
      hasLayoutChanged: n,
      hasRelativeLayoutChanged: b
    });
  } else if (g.isLead()) {
    const { onExitComplete: A } = g.options;
    A && A();
  }
  g.options.transition = void 0;
}
function YR(g) {
  g.parent && (g.isProjecting() || (g.isProjectionDirty = g.parent.isProjectionDirty), g.isSharedProjectionDirty || (g.isSharedProjectionDirty = !!(g.isProjectionDirty || g.parent.isProjectionDirty || g.parent.isSharedProjectionDirty)), g.isTransformDirty || (g.isTransformDirty = g.parent.isTransformDirty));
}
function FR(g) {
  g.isProjectionDirty = g.isSharedProjectionDirty = g.isTransformDirty = !1;
}
function zR(g) {
  g.clearSnapshot();
}
function Is(g) {
  g.clearMeasurements();
}
function Cs(g) {
  g.isLayoutDirty = !1;
}
function fR(g) {
  const { visualElement: I } = g.options;
  I && I.getProps().onBeforeLayoutMeasure && I.notify("BeforeLayoutMeasure"), g.resetTransform();
}
function As(g) {
  g.finishAnimation(), g.targetDelta = g.relativeTarget = g.target = void 0, g.isProjectionDirty = !0;
}
function HR(g) {
  g.resolveTargetDelta();
}
function wR(g) {
  g.calcProjection();
}
function SR(g) {
  g.resetSkewAndRotation();
}
function TR(g) {
  g.removeLeadSnapshot();
}
function cs(g, I, C) {
  g.translate = Vg(I.translate, 0, C), g.scale = Vg(I.scale, 1, C), g.origin = I.origin, g.originPoint = I.originPoint;
}
function ls(g, I, C, A) {
  g.min = Vg(I.min, C.min, A), g.max = Vg(I.max, C.max, A);
}
function LR(g, I, C, A) {
  ls(g.x, I.x, C.x, A), ls(g.y, I.y, C.y, A);
}
function UR(g) {
  return g.animationValues && g.animationValues.opacityExit !== void 0;
}
const PR = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, ts = (g) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(g), is = ts("applewebkit/") && !ts("chrome/") ? Math.round : Kg;
function es(g) {
  g.min = is(g.min), g.max = is(g.max);
}
function kR(g) {
  es(g.x), es(g.y);
}
function oG(g, I, C) {
  return g === "position" || g === "preserve-aspect" && !sR(Ka(I), Ka(C), 0.2);
}
function DR(g) {
  var I;
  return g !== g.root && ((I = g.scroll) == null ? void 0 : I.wasRoot);
}
const OR = dG({
  attachResizeListener: (g, I) => _A(g, "resize", I),
  measureScroll: () => {
    var g, I;
    return {
      x: document.documentElement.scrollLeft || ((g = document.body) == null ? void 0 : g.scrollLeft) || 0,
      y: document.documentElement.scrollTop || ((I = document.body) == null ? void 0 : I.scrollTop) || 0
    };
  },
  checkIsScrollRoot: () => !0
}), Ft = {
  current: void 0
}, GG = dG({
  measureScroll: (g) => ({
    x: g.scrollLeft,
    y: g.scrollTop
  }),
  defaultParent: () => {
    if (!Ft.current) {
      const g = new OR({});
      g.mount(window), g.setOptions({ layoutScroll: !0 }), Ft.current = g;
    }
    return Ft.current;
  },
  resetTransform: (g, I) => {
    g.style.transform = I !== void 0 ? I : "none";
  },
  checkIsScrollRoot: (g) => window.getComputedStyle(g).position === "fixed"
}), Ct = jg({
  transformPagePoint: (g) => g,
  isStatic: !1,
  reducedMotion: "never"
});
function jR(g = !0) {
  const I = Zg(Te);
  if (I === null)
    return [!0, null];
  const { isPresent: C, onExitComplete: A, register: c } = I, l = Ls();
  q(() => {
    if (g)
      return c(l);
  }, [g]);
  const t = k(() => g && A && A(l), [l, A, g]);
  return !C && A ? [!1, t] : [!0];
}
const rG = jg({ strict: !1 }), ns = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
let bs = !1;
function ER() {
  if (bs)
    return;
  const g = {};
  for (const I in ns)
    g[I] = {
      isEnabled: (C) => ns[I].some((A) => !!C[A])
    };
  Eo(g), bs = !0;
}
function XG() {
  return ER(), Sp();
}
function QR(g) {
  const I = XG();
  for (const C in g)
    I[C] = {
      ...I[C],
      ...g[C]
    };
  Eo(I);
}
const MR = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "propagate",
  "ignoreStrict",
  "viewport"
]);
function Jl(g) {
  return g.startsWith("while") || g.startsWith("drag") && g !== "draggable" || g.startsWith("layout") || g.startsWith("onTap") || g.startsWith("onPan") || g.startsWith("onLayout") || MR.has(g);
}
let ZG = (g) => !Jl(g);
function KR(g) {
  typeof g == "function" && (ZG = (I) => I.startsWith("on") ? !Jl(I) : g(I));
}
try {
  KR(require("@emotion/is-prop-valid").default);
} catch {
}
function _R(g, I, C) {
  const A = {};
  for (const c in g)
    c === "values" && typeof g.values == "object" || (ZG(c) || C === !0 && Jl(c) || !I && !Jl(c) || // If trying to use native HTML drag events, forward drag listeners
    g.draggable && c.startsWith("onDrag")) && (A[c] = g[c]);
  return A;
}
const At = /* @__PURE__ */ jg({});
function qR(g, I) {
  if (It(g)) {
    const { initial: C, animate: A } = g;
    return {
      initial: C === !1 || KA(C) ? C : void 0,
      animate: KA(A) ? A : void 0
    };
  }
  return g.inherit !== !1 ? I : {};
}
function $R(g) {
  const { initial: I, animate: C } = qR(g, Zg(At));
  return tg(() => ({ initial: I, animate: C }), [as(I), as(C)]);
}
function as(g) {
  return Array.isArray(g) ? g.join(" ") : g;
}
const un = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function VG(g, I, C) {
  for (const A in I)
    !Sg(I[A]) && !gG(A, C) && (g[A] = I[A]);
}
function gB({ transformTemplate: g }, I) {
  return tg(() => {
    const C = un();
    return an(C, I, g), Object.assign({}, C.vars, C.style);
  }, [I]);
}
function IB(g, I) {
  const C = g.style || {}, A = {};
  return VG(A, C, g), Object.assign(A, gB(g, I)), A;
}
function CB(g, I) {
  const C = {}, A = IB(g, I);
  return g.drag && g.dragListener !== !1 && (C.draggable = !1, A.userSelect = A.WebkitUserSelect = A.WebkitTouchCallout = "none", A.touchAction = g.drag === !0 ? "none" : `pan-${g.drag === "x" ? "y" : "x"}`), g.tabIndex === void 0 && (g.onTap || g.onTapStart || g.whileTap) && (C.tabIndex = 0), C.style = A, C;
}
const mG = () => ({
  ...un(),
  attrs: {}
});
function AB(g, I, C, A) {
  const c = tg(() => {
    const l = mG();
    return IG(l, I, AG(A), g.transformTemplate, g.style), {
      ...l.attrs,
      style: { ...l.style }
    };
  }, [I]);
  if (g.style) {
    const l = {};
    VG(l, g.style, g), c.style = { ...l, ...c.style };
  }
  return c;
}
const cB = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function dn(g) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof g != "string" || /**
    * If it contains a dash, the element is a custom HTML webcomponent.
    */
    g.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(cB.indexOf(g) > -1 || /**
      * If it contains a capital letter, it's an SVG component
      */
      /[A-Z]/u.test(g))
    )
  );
}
function lB(g, I, C, { latestValues: A }, c, l = !1, t) {
  const i = (t ?? dn(g) ? AB : CB)(I, A, c, g), e = _R(I, typeof g == "string", l), n = g !== _i ? { ...e, ...i, ref: C } : {}, { children: b } = I, a = tg(() => Sg(b) ? b.get() : b, [b]);
  return ws(g, {
    ...n,
    children: a
  });
}
function tB({ scrapeMotionValuesFromProps: g, createRenderState: I }, C, A, c) {
  return {
    latestValues: iB(C, A, c, g),
    renderState: I()
  };
}
function iB(g, I, C, A) {
  const c = {}, l = A(g, {});
  for (const s in l)
    c[s] = Kc(l[s]);
  let { initial: t, animate: i } = g;
  const e = It(g), n = Oo(g);
  I && n && !e && g.inherit !== !1 && (t === void 0 && (t = I.initial), i === void 0 && (i = I.animate));
  let b = C ? C.initial === !1 : !1;
  b = b || t === !1;
  const a = b ? i : t;
  if (a && typeof a != "boolean" && !gt(a)) {
    const s = Array.isArray(a) ? a : [a];
    for (let d = 0; d < s.length; d++) {
      const Z = Cn(g, s[d]);
      if (Z) {
        const { transitionEnd: r, transition: h, ...x } = Z;
        for (const u in x) {
          let G = x[u];
          if (Array.isArray(G)) {
            const V = b ? G.length - 1 : 0;
            G = G[V];
          }
          G !== null && (c[u] = G);
        }
        for (const u in r)
          c[u] = r[u];
      }
    }
  }
  return c;
}
const hG = (g) => (I, C) => {
  const A = Zg(At), c = Zg(Te), l = () => tB(g, I, A, c);
  return C ? l() : jA(l);
}, eB = /* @__PURE__ */ hG({
  scrapeMotionValuesFromProps: sn,
  createRenderState: un
}), nB = /* @__PURE__ */ hG({
  scrapeMotionValuesFromProps: cG,
  createRenderState: mG
}), bB = Symbol.for("motionComponentSymbol");
function aB(g, I, C) {
  const A = Ag(C);
  Ts(() => {
    A.current = C;
  });
  const c = Ag(null);
  return k((l) => {
    var t;
    l && ((t = g.onMount) == null || t.call(g, l)), I && (l ? I.mount(l) : I.unmount());
    const i = A.current;
    if (typeof i == "function")
      if (l) {
        const e = i(l);
        typeof e == "function" && (c.current = e);
      } else
        c.current ? (c.current(), c.current = null) : i(l);
    else
      i && (i.current = l);
  }, [I]);
}
const WG = jg({});
function BC(g) {
  return g && typeof g == "object" && Object.prototype.hasOwnProperty.call(g, "current");
}
function sB(g, I, C, A, c, l) {
  var t, i;
  const { visualElement: e } = Zg(At), n = Zg(rG), b = Zg(Te), a = Zg(Ct), s = a.reducedMotion, d = a.skipAnimations, Z = Ag(null), r = Ag(!1);
  A = A || n.renderer, !Z.current && A && (Z.current = A(g, {
    visualState: I,
    parent: e,
    props: C,
    presenceContext: b,
    blockInitialAnimation: b ? b.initial === !1 : !1,
    reducedMotionConfig: s,
    skipAnimations: d,
    isSVG: l
  }), r.current && Z.current && (Z.current.manuallyAnimateOnMount = !0));
  const h = Z.current, x = Zg(WG);
  h && !h.projection && c && (h.type === "html" || h.type === "svg") && uB(Z.current, C, c, x);
  const u = Ag(!1);
  Ts(() => {
    h && u.current && h.update(C, b);
  });
  const G = C[Yo], V = Ag(!!G && !((t = window.MotionHandoffIsComplete) != null && t.call(window, G)) && ((i = window.MotionHasOptimisedAnimation) == null ? void 0 : i.call(window, G)));
  return kd(() => {
    r.current = !0, h && (u.current = !0, window.MotionIsMounted = !0, h.updateFeatures(), h.scheduleRenderMicrotask(), V.current && h.animationState && h.animationState.animateChanges());
  }), q(() => {
    h && (!V.current && h.animationState && h.animationState.animateChanges(), V.current && (queueMicrotask(() => {
      var X;
      (X = window.MotionHandoffMarkAsComplete) == null || X.call(window, G);
    }), V.current = !1), h.enteringChildren = void 0);
  }), h;
}
function uB(g, I, C, A) {
  const { layoutId: c, layout: l, drag: t, dragConstraints: i, layoutScroll: e, layoutRoot: n, layoutCrossfade: b } = I;
  g.projection = new C(g.latestValues, I["data-framer-portal-id"] ? void 0 : NG(g.parent)), g.projection.setOptions({
    layoutId: c,
    layout: l,
    alwaysMeasureLayout: !!t || i && BC(i),
    visualElement: g,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof l == "string" ? l : "both",
    initialPromotionConfig: A,
    crossfade: b,
    layoutScroll: e,
    layoutRoot: n
  });
}
function NG(g) {
  if (g)
    return g.options.allowProjection !== !1 ? g.projection : NG(g.parent);
}
function zt(g, { forwardMotionProps: I = !1, type: C } = {}, A, c) {
  A && QR(A);
  const l = C ? C === "svg" : dn(g), t = l ? nB : eB;
  function i(n, b) {
    let a;
    const s = {
      ...Zg(Ct),
      ...n,
      layoutId: dB(n)
    }, { isStatic: d } = s, Z = $R(n), r = t(n, d);
    if (!d && Pd) {
      oB(s, A);
      const h = GB(s);
      a = h.MeasureLayout, Z.visualElement = sB(g, r, s, c, h.ProjectionNode, l);
    }
    return Ps(At.Provider, { value: Z, children: [a && Z.visualElement ? Yl(a, { visualElement: Z.visualElement, ...s }) : null, lB(g, n, aB(r, Z.visualElement, b), r, d, I, l)] });
  }
  i.displayName = `motion.${typeof g == "string" ? g : `create(${g.displayName ?? g.name ?? ""})`}`;
  const e = Fr(i);
  return e[bB] = g, e;
}
function dB({ layoutId: g }) {
  const I = Zg(Ud).id;
  return I && g !== void 0 ? I + "-" + g : g;
}
function oB(g, I) {
  const C = Zg(rG).strict;
  if (process.env.NODE_ENV !== "production" && I && C) {
    const A = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    g.ignoreStrict ? lA(!1, A, "lazy-strict-mode") : RI(!1, A, "lazy-strict-mode");
  }
}
function GB(g) {
  const I = XG(), { drag: C, layout: A } = I;
  if (!C && !A)
    return {};
  const c = { ...C, ...A };
  return {
    MeasureLayout: C != null && C.isEnabled(g) || A != null && A.isEnabled(g) ? c.MeasureLayout : void 0,
    ProjectionNode: c.ProjectionNode
  };
}
function rB(g, I) {
  if (typeof Proxy > "u")
    return zt;
  const C = /* @__PURE__ */ new Map(), A = (l, t) => zt(l, t, g, I), c = (l, t) => (process.env.NODE_ENV !== "production" && Pe(!1, "motion() is deprecated. Use motion.create() instead."), A(l, t));
  return new Proxy(c, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (l, t) => t === "create" ? A : (C.has(t) || C.set(t, zt(t, void 0, g, I)), C.get(t))
  });
}
const XB = (g, I) => I.isSVG ?? dn(g) ? new IR(I) : new Mp(I, {
  allowProjection: g !== _i
});
class ZB extends EI {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(I) {
    super(I), I.animationState || (I.animationState = tR(I));
  }
  updateAnimationControlsSubscription() {
    const { animate: I } = this.node.getProps();
    gt(I) && (this.unmountControls = I.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: I } = this.node.getProps(), { animate: C } = this.node.prevProps || {};
    I !== C && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var I;
    this.node.animationState.reset(), (I = this.unmountControls) == null || I.call(this);
  }
}
let VB = 0;
class mB extends EI {
  constructor() {
    super(...arguments), this.id = VB++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: I, onExitComplete: C } = this.node.presenceContext, { isPresent: A } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || I === A)
      return;
    const c = this.node.animationState.setActive("exit", !I);
    C && !I && c.then(() => {
      C(this.id);
    });
  }
  mount() {
    const { register: I, onExitComplete: C } = this.node.presenceContext || {};
    C && C(this.id), I && (this.unmount = I(this.id));
  }
  unmount() {
  }
}
const hB = {
  animation: {
    Feature: ZB
  },
  exit: {
    Feature: mB
  }
};
function bc(g) {
  return {
    point: {
      x: g.pageX,
      y: g.pageY
    }
  };
}
const WB = (g) => (I) => tn(I) && g(I, bc(I));
function BA(g, I, C, A) {
  return _A(g, I, WB(C), A);
}
const xG = ({ current: g }) => g ? g.ownerDocument.defaultView : null, ss = (g, I) => Math.abs(g - I);
function NB(g, I) {
  const C = ss(g.x, I.x), A = ss(g.y, I.y);
  return Math.sqrt(C ** 2 + A ** 2);
}
const us = /* @__PURE__ */ new Set(["auto", "scroll"]);
class yG {
  constructor(I, C, { transformPagePoint: A, contextWindow: c = window, dragSnapToOrigin: l = !1, distanceThreshold: t = 3, element: i } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.scrollPositions = /* @__PURE__ */ new Map(), this.removeScrollListeners = null, this.onElementScroll = (d) => {
      this.handleScroll(d.target);
    }, this.onWindowScroll = () => {
      this.handleScroll(window);
    }, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const d = Ht(this.lastMoveEventInfo, this.history), Z = this.startEvent !== null, r = NB(d.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!Z && !r)
        return;
      const { point: h } = d, { timestamp: x } = zg;
      this.history.push({ ...h, timestamp: x });
      const { onStart: u, onMove: G } = this.handlers;
      Z || (u && u(this.lastMoveEvent, d), this.startEvent = this.lastMoveEvent), G && G(this.lastMoveEvent, d);
    }, this.handlePointerMove = (d, Z) => {
      this.lastMoveEvent = d, this.lastMoveEventInfo = ft(Z, this.transformPagePoint), bg.update(this.updatePoint, !0);
    }, this.handlePointerUp = (d, Z) => {
      this.end();
      const { onEnd: r, onSessionEnd: h, resumeAnimation: x } = this.handlers;
      if ((this.dragSnapToOrigin || !this.startEvent) && x && x(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const u = Ht(d.type === "pointercancel" ? this.lastMoveEventInfo : ft(Z, this.transformPagePoint), this.history);
      this.startEvent && r && r(d, u), h && h(d, u);
    }, !tn(I))
      return;
    this.dragSnapToOrigin = l, this.handlers = C, this.transformPagePoint = A, this.distanceThreshold = t, this.contextWindow = c || window;
    const e = bc(I), n = ft(e, this.transformPagePoint), { point: b } = n, { timestamp: a } = zg;
    this.history = [{ ...b, timestamp: a }];
    const { onSessionStart: s } = C;
    s && s(I, Ht(n, this.history)), this.removeListeners = ic(BA(this.contextWindow, "pointermove", this.handlePointerMove), BA(this.contextWindow, "pointerup", this.handlePointerUp), BA(this.contextWindow, "pointercancel", this.handlePointerUp)), i && this.startScrollTracking(i);
  }
  /**
   * Start tracking scroll on ancestors and window.
   */
  startScrollTracking(I) {
    let C = I.parentElement;
    for (; C; ) {
      const A = getComputedStyle(C);
      (us.has(A.overflowX) || us.has(A.overflowY)) && this.scrollPositions.set(C, {
        x: C.scrollLeft,
        y: C.scrollTop
      }), C = C.parentElement;
    }
    this.scrollPositions.set(window, {
      x: window.scrollX,
      y: window.scrollY
    }), window.addEventListener("scroll", this.onElementScroll, {
      capture: !0,
      passive: !0
    }), window.addEventListener("scroll", this.onWindowScroll, {
      passive: !0
    }), this.removeScrollListeners = () => {
      window.removeEventListener("scroll", this.onElementScroll, {
        capture: !0
      }), window.removeEventListener("scroll", this.onWindowScroll);
    };
  }
  /**
   * Handle scroll compensation during drag.
   *
   * For element scroll: adjusts history origin since pageX/pageY doesn't change.
   * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
   */
  handleScroll(I) {
    const C = this.scrollPositions.get(I);
    if (!C)
      return;
    const A = I === window, c = A ? { x: window.scrollX, y: window.scrollY } : {
      x: I.scrollLeft,
      y: I.scrollTop
    }, l = { x: c.x - C.x, y: c.y - C.y };
    l.x === 0 && l.y === 0 || (A ? this.lastMoveEventInfo && (this.lastMoveEventInfo.point.x += l.x, this.lastMoveEventInfo.point.y += l.y) : this.history.length > 0 && (this.history[0].x -= l.x, this.history[0].y -= l.y), this.scrollPositions.set(I, c), bg.update(this.updatePoint, !0));
  }
  updateHandlers(I) {
    this.handlers = I;
  }
  end() {
    this.removeListeners && this.removeListeners(), this.removeScrollListeners && this.removeScrollListeners(), this.scrollPositions.clear(), dI(this.updatePoint);
  }
}
function ft(g, I) {
  return I ? { point: I(g.point) } : g;
}
function ds(g, I) {
  return { x: g.x - I.x, y: g.y - I.y };
}
function Ht({ point: g }, I) {
  return {
    point: g,
    delta: ds(g, pG(I)),
    offset: ds(g, xB(I)),
    velocity: yB(I, 0.1)
  };
}
function xB(g) {
  return g[0];
}
function pG(g) {
  return g[g.length - 1];
}
function yB(g, I) {
  if (g.length < 2)
    return { x: 0, y: 0 };
  let C = g.length - 1, A = null;
  const c = pG(g);
  for (; C >= 0 && (A = g[C], !(c.timestamp - A.timestamp > _g(I))); )
    C--;
  if (!A)
    return { x: 0, y: 0 };
  A === g[0] && g.length > 2 && c.timestamp - A.timestamp > _g(I) * 2 && (A = g[1]);
  const l = Qg(c.timestamp - A.timestamp);
  if (l === 0)
    return { x: 0, y: 0 };
  const t = {
    x: (c.x - A.x) / l,
    y: (c.y - A.y) / l
  };
  return t.x === 1 / 0 && (t.x = 0), t.y === 1 / 0 && (t.y = 0), t;
}
function pB(g, { min: I, max: C }, A) {
  return I !== void 0 && g < I ? g = A ? Vg(I, g, A.min) : Math.max(g, I) : C !== void 0 && g > C && (g = A ? Vg(C, g, A.max) : Math.min(g, C)), g;
}
function os(g, I, C) {
  return {
    min: I !== void 0 ? g.min + I : void 0,
    max: C !== void 0 ? g.max + C - (g.max - g.min) : void 0
  };
}
function RB(g, { top: I, left: C, bottom: A, right: c }) {
  return {
    x: os(g.x, C, c),
    y: os(g.y, I, A)
  };
}
function Gs(g, I) {
  let C = I.min - g.min, A = I.max - g.max;
  return I.max - I.min < g.max - g.min && ([C, A] = [A, C]), { min: C, max: A };
}
function BB(g, I) {
  return {
    x: Gs(g.x, I.x),
    y: Gs(g.y, I.y)
  };
}
function vB(g, I) {
  let C = 0.5;
  const A = Dg(g), c = Dg(I);
  return c > A ? C = EA(I.min, I.max - A, g.min) : A > c && (C = EA(g.min, g.max - c, I.min)), uI(0, 1, C);
}
function JB(g, I) {
  const C = {};
  return I.min !== void 0 && (C.min = I.min - g.min), I.max !== void 0 && (C.max = I.max - g.min), C;
}
const ji = 0.35;
function YB(g = ji) {
  return g === !1 ? g = 0 : g === !0 && (g = ji), {
    x: rs(g, "left", "right"),
    y: rs(g, "top", "bottom")
  };
}
function rs(g, I, C) {
  return {
    min: Xs(g, I),
    max: Xs(g, C)
  };
}
function Xs(g, I) {
  return typeof g == "number" ? g : g[I] || 0;
}
const FB = /* @__PURE__ */ new WeakMap();
class zB {
  constructor(I) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = vg(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = I;
  }
  start(I, { snapToCursor: C = !1, distanceThreshold: A } = {}) {
    const { presenceContext: c } = this.visualElement;
    if (c && c.isPresent === !1)
      return;
    const l = (a) => {
      C && this.snapToCursor(bc(a).point), this.stopAnimation();
    }, t = (a, s) => {
      const { drag: d, dragPropagation: Z, onDragStart: r } = this.getProps();
      if (d && !Z && (this.openDragLock && this.openDragLock(), this.openDragLock = up(d), !this.openDragLock))
        return;
      this.latestPointerEvent = a, this.latestPanInfo = s, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), lI((x) => {
        let u = this.getAxisMotionValue(x).get() || 0;
        if (aI.test(u)) {
          const { projection: G } = this.visualElement;
          if (G && G.layout) {
            const V = G.layout.layoutBox[x];
            V && (u = Dg(V) * (parseFloat(u) / 100));
          }
        }
        this.originPoint[x] = u;
      }), r && bg.update(() => r(a, s), !1, !0), Si(this.visualElement, "transform");
      const { animationState: h } = this.visualElement;
      h && h.setActive("whileDrag", !0);
    }, i = (a, s) => {
      this.latestPointerEvent = a, this.latestPanInfo = s;
      const { dragPropagation: d, dragDirectionLock: Z, onDirectionLock: r, onDrag: h } = this.getProps();
      if (!d && !this.openDragLock)
        return;
      const { offset: x } = s;
      if (Z && this.currentDirection === null) {
        this.currentDirection = HB(x), this.currentDirection !== null && r && r(this.currentDirection);
        return;
      }
      this.updateAxis("x", s.point, x), this.updateAxis("y", s.point, x), this.visualElement.render(), h && bg.update(() => h(a, s), !1, !0);
    }, e = (a, s) => {
      this.latestPointerEvent = a, this.latestPanInfo = s, this.stop(a, s), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, n = () => {
      const { dragSnapToOrigin: a } = this.getProps();
      (a || this.constraints) && this.startAnimation({ x: 0, y: 0 });
    }, { dragSnapToOrigin: b } = this.getProps();
    this.panSession = new yG(I, {
      onSessionStart: l,
      onStart: t,
      onMove: i,
      onSessionEnd: e,
      resumeAnimation: n
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: b,
      distanceThreshold: A,
      contextWindow: xG(this.visualElement),
      element: this.visualElement.current
    });
  }
  /**
   * @internal
   */
  stop(I, C) {
    const A = I || this.latestPointerEvent, c = C || this.latestPanInfo, l = this.isDragging;
    if (this.cancel(), !l || !c || !A)
      return;
    const { velocity: t } = c;
    this.startAnimation(t);
    const { onDragEnd: i } = this.getProps();
    i && bg.postRender(() => i(A, c));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: I, animationState: C } = this.visualElement;
    I && (I.isAnimationBlocked = !1), this.endPanSession();
    const { dragPropagation: A } = this.getProps();
    !A && this.openDragLock && (this.openDragLock(), this.openDragLock = null), C && C.setActive("whileDrag", !1);
  }
  /**
   * Clean up the pan session without modifying other drag state.
   * This is used during unmount to ensure event listeners are removed
   * without affecting projection animations or drag locks.
   * @internal
   */
  endPanSession() {
    this.panSession && this.panSession.end(), this.panSession = void 0;
  }
  updateAxis(I, C, A) {
    const { drag: c } = this.getProps();
    if (!A || !Tc(I, c, this.currentDirection))
      return;
    const l = this.getAxisMotionValue(I);
    let t = this.originPoint[I] + A[I];
    this.constraints && this.constraints[I] && (t = pB(t, this.constraints[I], this.elastic[I])), l.set(t);
  }
  resolveConstraints() {
    var I;
    const { dragConstraints: C, dragElastic: A } = this.getProps(), c = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (I = this.visualElement.projection) == null ? void 0 : I.layout, l = this.constraints;
    C && BC(C) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : C && c ? this.constraints = RB(c.layoutBox, C) : this.constraints = !1, this.elastic = YB(A), l !== this.constraints && !BC(C) && c && this.constraints && !this.hasMutatedConstraints && lI((t) => {
      this.constraints !== !1 && this.getAxisMotionValue(t) && (this.constraints[t] = JB(c.layoutBox[t], this.constraints[t]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: I, onMeasureDragConstraints: C } = this.getProps();
    if (!I || !BC(I))
      return !1;
    const A = I.current;
    RI(A !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: c } = this.visualElement;
    if (!c || !c.layout)
      return !1;
    const l = kp(A, c.root, this.visualElement.getTransformPagePoint());
    let t = BB(c.layout.layoutBox, l);
    if (C) {
      const i = C(Lp(t));
      this.hasMutatedConstraints = !!i, i && (t = Mo(i));
    }
    return t;
  }
  startAnimation(I) {
    const { drag: C, dragMomentum: A, dragElastic: c, dragTransition: l, dragSnapToOrigin: t, onDragTransitionEnd: i } = this.getProps(), e = this.constraints || {}, n = lI((b) => {
      if (!Tc(b, C, this.currentDirection))
        return;
      let a = e && e[b] || {};
      t && (a = { min: 0, max: 0 });
      const s = c ? 200 : 1e6, d = c ? 40 : 1e7, Z = {
        type: "inertia",
        velocity: A ? I[b] : 0,
        bounceStiffness: s,
        bounceDamping: d,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...l,
        ...a
      };
      return this.startAxisValueAnimation(b, Z);
    });
    return Promise.all(n).then(i);
  }
  startAxisValueAnimation(I, C) {
    const A = this.getAxisMotionValue(I);
    return Si(this.visualElement, I), A.start(In(I, A, 0, C, this.visualElement, !1));
  }
  stopAnimation() {
    lI((I) => this.getAxisMotionValue(I).stop());
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(I) {
    const C = `_drag${I.toUpperCase()}`, A = this.visualElement.getProps();
    return A[C] || this.visualElement.getValue(I, (A.initial ? A.initial[I] : void 0) || 0);
  }
  snapToCursor(I) {
    lI((C) => {
      const { drag: A } = this.getProps();
      if (!Tc(C, A, this.currentDirection))
        return;
      const { projection: c } = this.visualElement, l = this.getAxisMotionValue(C);
      if (c && c.layout) {
        const { min: t, max: i } = c.layout.layoutBox[C], e = l.get() || 0;
        l.set(I[C] - Vg(t, i, 0.5) + e);
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: I, dragConstraints: C } = this.getProps(), { projection: A } = this.visualElement;
    if (!BC(C) || !A || !this.constraints)
      return;
    this.stopAnimation();
    const c = { x: 0, y: 0 };
    lI((t) => {
      const i = this.getAxisMotionValue(t);
      if (i && this.constraints !== !1) {
        const e = i.get();
        c[t] = vB({ min: e, max: e }, this.constraints[t]);
      }
    });
    const { transformTemplate: l } = this.visualElement.getProps();
    this.visualElement.current.style.transform = l ? l({}, "") : "none", A.root && A.root.updateScroll(), A.updateLayout(), this.constraints = !1, this.resolveConstraints(), lI((t) => {
      if (!Tc(t, I, null))
        return;
      const i = this.getAxisMotionValue(t), { min: e, max: n } = this.constraints[t];
      i.set(Vg(e, n, c[t]));
    }), this.visualElement.render();
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    FB.set(this.visualElement, this);
    const I = this.visualElement.current, C = BA(I, "pointerdown", (n) => {
      const { drag: b, dragListener: a = !0 } = this.getProps(), s = n.target, d = s !== I && Zp(s);
      b && a && !d && this.start(n);
    });
    let A;
    const c = () => {
      const { dragConstraints: n } = this.getProps();
      BC(n) && n.current && (this.constraints = this.resolveRefConstraints(), A || (A = fB(I, n.current, () => this.scalePositionWithinConstraints())));
    }, { projection: l } = this.visualElement, t = l.addEventListener("measure", c);
    l && !l.layout && (l.root && l.root.updateScroll(), l.updateLayout()), bg.read(c);
    const i = _A(window, "resize", () => this.scalePositionWithinConstraints()), e = l.addEventListener("didUpdate", ({ delta: n, hasLayoutChanged: b }) => {
      this.isDragging && b && (lI((a) => {
        const s = this.getAxisMotionValue(a);
        s && (this.originPoint[a] += n[a].translate, s.set(s.get() + n[a].translate));
      }), this.visualElement.render());
    });
    return () => {
      i(), C(), t(), e && e(), A && A();
    };
  }
  getProps() {
    const I = this.visualElement.getProps(), { drag: C = !1, dragDirectionLock: A = !1, dragPropagation: c = !1, dragConstraints: l = !1, dragElastic: t = ji, dragMomentum: i = !0 } = I;
    return {
      ...I,
      drag: C,
      dragDirectionLock: A,
      dragPropagation: c,
      dragConstraints: l,
      dragElastic: t,
      dragMomentum: i
    };
  }
}
function Zs(g) {
  let I = !0;
  return () => {
    if (I) {
      I = !1;
      return;
    }
    g();
  };
}
function fB(g, I, C) {
  const A = Ra(g, Zs(C)), c = Ra(I, Zs(C));
  return () => {
    A(), c();
  };
}
function Tc(g, I, C) {
  return (I === !0 || I === g) && (C === null || C === g);
}
function HB(g, I = 10) {
  let C = null;
  return Math.abs(g.y) > I ? C = "y" : Math.abs(g.x) > I && (C = "x"), C;
}
class wB extends EI {
  constructor(I) {
    super(I), this.removeGroupControls = Kg, this.removeListeners = Kg, this.controls = new zB(I);
  }
  mount() {
    const { dragControls: I } = this.node.getProps();
    I && (this.removeGroupControls = I.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Kg;
  }
  update() {
    const { dragControls: I } = this.node.getProps(), { dragControls: C } = this.node.prevProps || {};
    I !== C && (this.removeGroupControls(), I && (this.removeGroupControls = I.subscribe(this.controls)));
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners(), this.controls.isDragging || this.controls.endPanSession();
  }
}
const wt = (g) => (I, C) => {
  g && bg.update(() => g(I, C), !1, !0);
};
class SB extends EI {
  constructor() {
    super(...arguments), this.removePointerDownListener = Kg;
  }
  onPointerDown(I) {
    this.session = new yG(I, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: xG(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: I, onPanStart: C, onPan: A, onPanEnd: c } = this.node.getProps();
    return {
      onSessionStart: wt(I),
      onStart: wt(C),
      onMove: wt(A),
      onEnd: (l, t) => {
        delete this.session, c && bg.postRender(() => c(l, t));
      }
    };
  }
  mount() {
    this.removePointerDownListener = BA(this.node.current, "pointerdown", (I) => this.onPointerDown(I));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
let St = !1;
class TB extends zr {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: I, layoutGroup: C, switchLayoutGroup: A, layoutId: c } = this.props, { projection: l } = I;
    l && (C.group && C.group.add(l), A && A.register && c && A.register(l), St && l.root.didUpdate(), l.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), l.setOptions({
      ...l.options,
      layoutDependency: this.props.layoutDependency,
      onExitComplete: () => this.safeToRemove()
    })), _c.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(I) {
    const { layoutDependency: C, visualElement: A, drag: c, isPresent: l } = this.props, { projection: t } = A;
    return t && (t.isPresent = l, I.layoutDependency !== C && t.setOptions({
      ...t.options,
      layoutDependency: C
    }), St = !0, c || I.layoutDependency !== C || C === void 0 || I.isPresent !== l ? t.willUpdate() : this.safeToRemove(), I.isPresent !== l && (l ? t.promote() : t.relegate() || bg.postRender(() => {
      const i = t.getStack();
      (!i || !i.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: I } = this.props.visualElement;
    I && (I.root.didUpdate(), ln.postRender(() => {
      !I.currentAnimation && I.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: I, layoutGroup: C, switchLayoutGroup: A } = this.props, { projection: c } = I;
    St = !0, c && (c.scheduleCheckAfterUnmount(), C && C.group && C.group.remove(c), A && A.deregister && A.deregister(c));
  }
  safeToRemove() {
    const { safeToRemove: I } = this.props;
    I && I();
  }
  render() {
    return null;
  }
}
function RG(g) {
  const [I, C] = jR(), A = Zg(Ud);
  return Yl(TB, { ...g, layoutGroup: A, switchLayoutGroup: Zg(WG), isPresent: I, safeToRemove: C });
}
const LB = {
  pan: {
    Feature: SB
  },
  drag: {
    Feature: wB,
    ProjectionNode: GG,
    MeasureLayout: RG
  }
};
function Vs(g, I, C) {
  const { props: A } = g;
  g.animationState && A.whileHover && g.animationState.setActive("whileHover", C === "Start");
  const c = "onHover" + C, l = A[c];
  l && bg.postRender(() => l(I, bc(I)));
}
class UB extends EI {
  mount() {
    const { current: I } = this.node;
    I && (this.unmount = op(I, (C, A) => (Vs(this.node, A, "Start"), (c) => Vs(this.node, c, "End"))));
  }
  unmount() {
  }
}
class PB extends EI {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let I = !1;
    try {
      I = this.node.current.matches(":focus-visible");
    } catch {
      I = !0;
    }
    !I || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = ic(_A(this.node.current, "focus", () => this.onFocus()), _A(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function ms(g, I, C) {
  const { props: A } = g;
  if (g.current instanceof HTMLButtonElement && g.current.disabled)
    return;
  g.animationState && A.whileTap && g.animationState.setActive("whileTap", C === "Start");
  const c = "onTap" + (C === "End" ? "" : C), l = A[c];
  l && bg.postRender(() => l(I, bc(I)));
}
class kB extends EI {
  mount() {
    const { current: I } = this.node;
    if (!I)
      return;
    const { globalTapTarget: C, propagate: A } = this.node.props;
    this.unmount = mp(I, (c, l) => (ms(this.node, l, "Start"), (t, { success: i }) => ms(this.node, t, i ? "End" : "Cancel")), {
      useGlobalTarget: C,
      stopPropagation: (A == null ? void 0 : A.tap) === !1
    });
  }
  unmount() {
  }
}
const Ei = /* @__PURE__ */ new WeakMap(), Tt = /* @__PURE__ */ new WeakMap(), DB = (g) => {
  const I = Ei.get(g.target);
  I && I(g);
}, OB = (g) => {
  g.forEach(DB);
};
function jB({ root: g, ...I }) {
  const C = g || document;
  Tt.has(C) || Tt.set(C, {});
  const A = Tt.get(C), c = JSON.stringify(I);
  return A[c] || (A[c] = new IntersectionObserver(OB, { root: g, ...I })), A[c];
}
function EB(g, I, C) {
  const A = jB(I);
  return Ei.set(g, C), A.observe(g), () => {
    Ei.delete(g), A.unobserve(g);
  };
}
const QB = {
  some: 0,
  all: 1
};
class MB extends EI {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: I = {} } = this.node.getProps(), { root: C, margin: A, amount: c = "some", once: l } = I, t = {
      root: C ? C.current : void 0,
      rootMargin: A,
      threshold: typeof c == "number" ? c : QB[c]
    }, i = (e) => {
      const { isIntersecting: n } = e;
      if (this.isInView === n || (this.isInView = n, l && !n && this.hasEnteredView))
        return;
      n && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", n);
      const { onViewportEnter: b, onViewportLeave: a } = this.node.getProps(), s = n ? b : a;
      s && s(e);
    };
    return EB(this.node.current, t, i);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: I, prevProps: C } = this.node;
    ["amount", "margin", "root"].some(KB(I, C)) && this.startObserver();
  }
  unmount() {
  }
}
function KB({ viewport: g = {} }, { viewport: I = {} } = {}) {
  return (C) => g[C] !== I[C];
}
const _B = {
  inView: {
    Feature: MB
  },
  tap: {
    Feature: kB
  },
  focus: {
    Feature: PB
  },
  hover: {
    Feature: UB
  }
}, qB = {
  layout: {
    ProjectionNode: GG,
    MeasureLayout: RG
  }
}, $B = {
  ...hB,
  ..._B,
  ...LB,
  ...qB
}, Lt = /* @__PURE__ */ rB($B, XB);
function BG(g) {
  const I = jA(() => oC(g)), { isStatic: C } = Zg(Ct);
  if (C) {
    const [, A] = O(g);
    q(() => I.on("change", A), []);
  }
  return I;
}
function vG(g, I) {
  const C = BG(I()), A = () => C.set(I());
  return A(), kd(() => {
    const c = () => bg.preRender(A, !1, !0), l = g.map((t) => t.on("change", c));
    return () => {
      l.forEach((t) => t()), dI(A);
    };
  }), C;
}
function gv(g) {
  pA.current = [], g();
  const I = vG(pA.current, g);
  return pA.current = void 0, I;
}
function JG(g, I, C, A) {
  if (typeof g == "function")
    return gv(g);
  if (C !== void 0 && !Array.isArray(C) && typeof I != "function")
    return Iv(g, I, C, A);
  const c = typeof I == "function" ? I : Jp(I, C, A), l = Array.isArray(g) ? hs(g, c) : hs([g], ([i]) => c(i)), t = Array.isArray(g) ? void 0 : g.accelerate;
  return t && !t.isTransformed && typeof I != "function" && Array.isArray(C) && (A == null ? void 0 : A.clamp) !== !1 && (l.accelerate = {
    ...t,
    times: I,
    keyframes: C,
    isTransformed: !0,
    ...A != null && A.ease ? { ease: A.ease } : {}
  }), l;
}
function hs(g, I) {
  const C = jA(() => []);
  return vG(g, () => {
    C.length = 0;
    const A = g.length;
    for (let c = 0; c < A; c++)
      C[c] = g[c].get();
    return I(C);
  });
}
function Iv(g, I, C, A) {
  const c = jA(() => Object.keys(C)), l = jA(() => ({}));
  for (const t of c)
    l[t] = JG(g, I, C[t], A);
  return l;
}
function Cv(g) {
  const I = Ag(0), { isStatic: C } = Zg(Ct);
  q(() => {
    if (C)
      return;
    const A = ({ timestamp: c, delta: l }) => {
      I.current || (I.current = c), g(c - I.current, l);
    };
    return bg.update(A, !0), () => dI(A);
  }, [g]);
}
function Av({
  children: g,
  className: I = "",
  colors: C = ["#5227FF", "#FF9FFC", "#B19EEF"],
  animationSpeed: A = 8,
  showBorder: c = !1,
  direction: l = "horizontal",
  pauseOnHover: t = !1,
  yoyo: i = !0,
  fz: e,
  fw: n,
  lh: b,
  ta: a,
  ...s
}) {
  const [d, Z] = O(!1), r = BG(0), h = Ag(0), x = Ag(null), u = A * 1e3;
  Cv((p) => {
    if (d) {
      x.current = null;
      return;
    }
    if (x.current === null) {
      x.current = p;
      return;
    }
    const Y = p - x.current;
    if (x.current = p, h.current += Y, i) {
      const v = u * 2, Q = h.current % v;
      Q < u ? r.set(Q / u * 100) : r.set(100 - (Q - u) / u * 100);
    } else
      r.set(h.current / u * 100);
  }), q(() => {
    h.current = 0, r.set(0);
  }, [A, i, r]);
  const G = JG(r, (p) => l === "horizontal" ? `${p}% 50%` : l === "vertical" ? `50% ${p}%` : `${p}% 50%`), V = k(() => {
    t && Z(!0);
  }, [t]), X = k(() => {
    t && Z(!1);
  }, [t]), W = l === "horizontal" ? "to right" : l === "vertical" ? "to bottom" : "to bottom right", N = [...C, C[0]].join(", "), m = {
    backgroundImage: `linear-gradient(${W}, ${N})`,
    backgroundSize: l === "horizontal" ? "300% 100%" : l === "vertical" ? "100% 300%" : "300% 300%",
    backgroundRepeat: "repeat"
  };
  return /* @__PURE__ */ R(Lt.div, { className: `animated-gradient-text ${c ? "with-border" : ""} ${I}`, onMouseEnter: V, onMouseLeave: X, children: [
    c && /* @__PURE__ */ o(Lt.div, { className: "gradient-overlay", style: {
      ...m,
      backgroundPosition: G
    } }),
    /* @__PURE__ */ o(Lt.div, { className: "text-content", style: {
      ...m,
      backgroundPosition: G
    }, children: /* @__PURE__ */ o(U, { fz: e, fw: n, lh: b, ta: a, ...s, children: g }) })
  ] });
}
const cv = {
  background: "linear-gradient(91.89deg, rgba(237, 224, 255, 0.3) 0%, rgba(196, 223, 255, 0.3) 31.56%, rgba(192, 243, 244, 0.3) 83.21%, rgba(198, 250, 234, 0.3) 100%)"
}, lv = ["#0CB6A1", "#10B1D6", "#6D79EA"];
yg(function({
  selectedInterestLabels: g,
  onFindMatch: I,
  onBrowsePopular: C,
  onBrowseFreely: A
}) {
  const {
    t: c
  } = hg();
  return /* @__PURE__ */ o(P, { px: 20, py: 32, h: "100%", children: /* @__PURE__ */ R(gg, { spacing: 20, children: [
    /* @__PURE__ */ R(gg, { spacing: 4, w: "100%", children: [
      /* @__PURE__ */ o(U, { fz: "md", fw: 600, lh: 1.5, color: "gray.9", children: c("준비끝! 관심사를 파악했어요~") }),
      /* @__PURE__ */ R(P, { children: [
        /* @__PURE__ */ o(U, { fz: "md", fw: 400, lh: 1.5, color: "gray.7", children: c("답해주신 내용을 바탕으로 인기 강의 또는 추가 답변으로 맞는 강의를 찾아보세요.") }),
        /* @__PURE__ */ o(U, { fz: "md", fw: 400, lh: 1.5, color: "gray.7", children: c("어떻게 시작하면 좋을지 골라주세요.") })
      ] })
    ] }),
    /* @__PURE__ */ R(gg, { align: "flex-end", spacing: 8, w: "100%", children: [
      /* @__PURE__ */ o(xg, { variant: "light", color: "gray", size: "sm", radius: "md", onClick: I, rightIcon: /* @__PURE__ */ o(lx, { icon: ht, size: "sm" }), css: cv, children: /* @__PURE__ */ o(Av, { colors: lv, animationSpeed: 2, direction: "diagonal", fz: "sm", fw: 600, children: c("나한테 딱 맞는걸 찾고 싶어요") }) }),
      /* @__PURE__ */ o(xg, { variant: "default", color: "infgreen", size: "sm", radius: "md", onClick: C, rightIcon: /* @__PURE__ */ o(sg, { icon: ht, size: "sm", color: "gray.9" }), children: c("{{interests}} 인기 강의 둘러보기", {
        interests: g
      }) }),
      /* @__PURE__ */ o(xg, { variant: "default", color: "infgreen", size: "sm", radius: "md", onClick: A, rightIcon: /* @__PURE__ */ o(sg, { icon: ht, size: "sm", color: "gray.9" }), children: c("직접 둘러볼게요") })
    ] })
  ] }) });
});
const tv = yg(function({
  onGoToMain: g,
  userName: I,
  onEnterLlm: C,
  entryPoint: A
}) {
  const {
    t: c
  } = hg();
  return /* @__PURE__ */ o(Cg, { direction: "column", px: 20, py: 32, h: "100%", children: /* @__PURE__ */ R(gg, { spacing: 16, children: [
    /* @__PURE__ */ R(gg, { spacing: 4, children: [
      /* @__PURE__ */ o(U, { size: "md", fw: 600, lh: 1.5, color: "gray.9", children: c("선택해주신 내용을 바탕으로 인기 강의를 모아봤어요! ✨") }),
      /* @__PURE__ */ o(U, { size: "md", fw: 400, lh: 1.5, color: "gray.9", children: c("마음에 드는 강의를 클릭해보세요") })
    ] }),
    /* @__PURE__ */ o(Ld, { userName: I, onEnterLlm: C, onGoToMain: g, entryPoint: A })
  ] }) });
}), Ws = yg(function({
  items: g,
  onEdit: I
}) {
  const {
    t: C
  } = hg(), A = js(Fs.mobile), [c, l] = O(!1), t = A || c;
  return g.length === 0 ? I ? /* @__PURE__ */ o(Cg, { gap: 8, align: "center", children: /* @__PURE__ */ o(Vn, { label: C("수정"), withArrow: !0, position: "bottom", children: /* @__PURE__ */ o(qg, { variant: "subtle", color: "gray", size: "n-xs", radius: "md", onClick: I, children: /* @__PURE__ */ o(sg, { icon: ca, size: "xs", color: "gray.7" }) }) }) }) : null : /* @__PURE__ */ R(Cg, { gap: 8, align: "center", onMouseEnter: () => l(!0), onMouseLeave: () => l(!1), children: [
    I && /* @__PURE__ */ o(Vn, { label: C("수정"), withArrow: !0, position: "bottom", disabled: !t, children: /* @__PURE__ */ o(qg, { "aria-label": C("수정"), variant: "subtle", color: "gray", size: "n-xs", radius: "md", onClick: I, style: {
      opacity: t ? 1 : 0,
      pointerEvents: t ? "auto" : "none"
    }, tabIndex: t ? 0 : -1, children: /* @__PURE__ */ o(sg, { icon: ca, size: "xs", color: "gray.7" }) }) }),
    /* @__PURE__ */ o(Cg, { bg: "gray.0", px: 14, py: 8, style: {
      borderRadius: 8
    }, maw: 330, children: /* @__PURE__ */ o(gg, { spacing: 8, style: {
      flex: 1
    }, children: g.map((i) => /* @__PURE__ */ R(P, { children: [
      /* @__PURE__ */ o(U, { component: "span", size: "xs", fw: 600, color: "gray.7", children: i.label }),
      i.description && /* @__PURE__ */ R(U, { component: "span", size: "xs", fw: 400, color: "gray.6", children: [
        " ",
        i.description
      ] })
    ] }, i.label)) }) })
  ] });
});
function YG() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var iv = process.env.NODE_ENV === "production" ? {
  name: "6xcp7g",
  styles: "position:sticky;bottom:0;left:0;right:0;padding:10px 0px"
} : {
  name: "1wrpdmu-ChatInput",
  styles: "position:sticky;bottom:0;left:0;right:0;padding:10px 0px;label:ChatInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: YG
}, ev = process.env.NODE_ENV === "production" ? {
  name: "uekdr6",
  styles: "flex:1;.mantine-Textarea-input{padding:6px 8px;font-size:16px;line-height:1.5;}"
} : {
  name: "1npxuvb-ChatInput",
  styles: "flex:1;.mantine-Textarea-input{padding:6px 8px;font-size:16px;line-height:1.5;};label:ChatInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: YG
};
const FG = yg(function({
  isGenerating: g,
  isLimitReached: I,
  isQuotaExhausted: C,
  placeholder: A,
  onSend: c
}) {
  const [l, t] = O(""), i = Ag(null), e = l.trim().length > 0, n = k(() => {
    const a = l.trim();
    !a || g || I || C || (c(a), t(""), i.current && (i.current.style.height = "auto"));
  }, [l, g, I, C, c]), b = k((a) => {
    a.nativeEvent.isComposing || a.key === "Enter" && !a.shiftKey && (a.preventDefault(), n());
  }, [n]);
  return /* @__PURE__ */ o(P, { css: iv, children: /* @__PURE__ */ R(Cg, { align: "flex-end", gap: 8, css: /* @__PURE__ */ $({
    border: `1px solid ${rg.gray[3]}`,
    borderRadius: 12,
    padding: 10,
    backgroundColor: C ? rg.gray[1] : "white",
    cursor: C ? "not-allowed" : "pointer"
  }, process.env.NODE_ENV === "production" ? "" : ";label:ChatInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
    /* @__PURE__ */ o(zs, { ref: i, value: l, onChange: (a) => t(a.currentTarget.value), onKeyDown: b, placeholder: A, autosize: !0, maxRows: 10, variant: "unstyled", disabled: C, size: "md", css: ev }),
    /* @__PURE__ */ o(qg, { variant: "filled", color: "infgreen", size: "lg", radius: "md", disabled: !e || g || I || C, onClick: n, children: /* @__PURE__ */ o(sg, { icon: sN, size: "sm" }) })
  ] }) });
}), nv = yg(function({
  course: g,
  onClick: I
}) {
  const {
    t: C
  } = hg();
  return /* @__PURE__ */ R(gg, { spacing: 8, children: [
    /* @__PURE__ */ o(Sd, { title: g.title, slug: "", url: g.url, thumbnailUrl: g.thumbnailUrl, instructorName: g.instructorName, star: Number(g.reviewAverage) || 0, reviewCount: g.reviewCount, studentCount: g.studentCount, onClick: I }),
    g.recommendationReason && /* @__PURE__ */ o(P, { css: /* @__PURE__ */ $({
      backgroundColor: rg.gray[0],
      borderRadius: 16,
      padding: 16,
      overflow: "hidden"
    }, process.env.NODE_ENV === "production" ? "" : ";label:AiCourseCard;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ R(gg, { spacing: 10, children: [
      /* @__PURE__ */ R(Ig, { spacing: 6, children: [
        /* @__PURE__ */ o(sg, { icon: nN, size: "sm", color: "green.7" }),
        /* @__PURE__ */ o(U, { fz: "sm", fw: 600, lh: 1.3, color: "gray.9", children: C("추천 이유") })
      ] }),
      /* @__PURE__ */ o(U, { fz: "sm", fw: 500, lh: 1.5, color: "gray.7", children: g.recommendationReason })
    ] }) })
  ] });
});
function bv() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var av = process.env.NODE_ENV === "production" ? {
  name: "1h52dri",
  styles: "overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
} : {
  name: "1e0li77-SelectionRow",
  styles: "overflow:hidden;text-overflow:ellipsis;white-space:nowrap;label:SelectionRow;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: bv
};
function Ut({
  label: g,
  value: I
}) {
  return I ? /* @__PURE__ */ R(sI, { children: [
    /* @__PURE__ */ o(U, { size: "sm", color: "gray.6", children: g }),
    /* @__PURE__ */ o(U, { size: "sm", color: "gray.8", css: av, children: I })
  ] }) : null;
}
const zG = yg(function({
  userSelections: g
}) {
  const {
    t: I
  } = hg(), C = g.goals.join(", "), A = g.interests.join(", "), c = g.skills.join(", ");
  return !C && !A && !c ? null : /* @__PURE__ */ R(P, { css: /* @__PURE__ */ $({
    backgroundColor: rg.gray[0],
    borderRadius: 8,
    padding: "12px 16px",
    display: "grid",
    gridTemplateColumns: "minmax(80px, max-content) 1fr",
    columnGap: 8,
    rowGap: 8,
    alignItems: "center"
  }, process.env.NODE_ENV === "production" ? "" : ";label:UserSelectionCard;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
    /* @__PURE__ */ o(Ut, { label: I("llm-empty-state.label-goal"), value: C }),
    /* @__PURE__ */ o(Ut, { label: I("llm-empty-state.label-interest"), value: A }),
    /* @__PURE__ */ o(Ut, { label: I("llm-empty-state.label-skill"), value: c })
  ] });
});
function QI() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const sv = 300;
var uv = process.env.NODE_ENV === "production" ? {
  name: "9pupg7",
  styles: "background-color:#f5f5f4;border-radius:8px;padding:9px 15px;max-width:80%"
} : {
  name: "zr23av-UserMessage",
  styles: "background-color:#f5f5f4;border-radius:8px;padding:9px 15px;max-width:80%;label:UserMessage;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: QI
};
function dv({
  content: g
}) {
  return /* @__PURE__ */ o(Cg, { justify: "flex-end", children: /* @__PURE__ */ o(P, { css: uv, children: /* @__PURE__ */ o(U, { size: "md", lh: 1.5, color: "gray.9", weight: 400, children: g }) }) });
}
function Ns({
  text: g
}) {
  const {
    t: I
  } = hg();
  return /* @__PURE__ */ R(Cg, { gap: 8, align: "center", children: [
    /* @__PURE__ */ o(Hs, { size: "sm", color: "green", variant: "dots" }),
    /* @__PURE__ */ o(U, { size: "sm", lh: 1.5, color: "gray.5", children: g ?? I("AI가 답변을 생성하고 있어요...") })
  ] });
}
var ov = process.env.NODE_ENV === "production" ? {
  name: "qhxz92",
  styles: "max-width:100%"
} : {
  name: "1kxnpxi-AssistantMessage",
  styles: "max-width:100%;label:AssistantMessage;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: QI
}, Gv = process.env.NODE_ENV === "production" ? {
  name: "1089mxj",
  styles: "white-space:pre-wrap"
} : {
  name: "1n9fs7o-AssistantMessage",
  styles: "white-space:pre-wrap;label:AssistantMessage;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: QI
};
function rv({
  message: g,
  onCourseClick: I
}) {
  const {
    t: C
  } = hg();
  return g.isLoading ? /* @__PURE__ */ o(Cg, { justify: "flex-start", children: /* @__PURE__ */ o(Ns, { text: g.processingText }) }) : /* @__PURE__ */ o(Cg, { justify: "flex-start", children: /* @__PURE__ */ R(gg, { spacing: 12, css: ov, children: [
    g.content && /* @__PURE__ */ o(U, { size: "md", weight: 600, color: "gray.9", css: Gv, children: g.content }),
    g.processingText && /* @__PURE__ */ o(Ns, { text: g.processingText }),
    g.courses && g.courses.length > 0 && /* @__PURE__ */ R(gg, { spacing: 16, children: [
      /* @__PURE__ */ o(U, { fz: "md", fw: 600, lh: 1.5, color: "gray.9", children: C("추천 강의 {{count}}개", {
        count: g.courses.length
      }) }),
      g.courses.map((A, c) => /* @__PURE__ */ R(_i, { children: [
        c > 0 && /* @__PURE__ */ o(Rr, {}),
        /* @__PURE__ */ o(nv, { course: A, onClick: I ? () => I(A, c) : void 0 })
      ] }, A.id)),
      g.isPendingCompletion && /* @__PURE__ */ o(Hs, { size: "sm", color: "green", variant: "dots" })
    ] })
  ] }) });
}
var Xv = process.env.NODE_ENV === "production" ? {
  name: "12kxyyq",
  styles: "flex:1;position:relative;overflow:hidden"
} : {
  name: "kq6xw2-ChatMessageList",
  styles: "flex:1;position:relative;overflow:hidden;label:ChatMessageList;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: QI
}, Zv = process.env.NODE_ENV === "production" ? {
  name: "yk4cs2",
  styles: "height:100%;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch"
} : {
  name: "a7me8u-ChatMessageList",
  styles: "height:100%;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;label:ChatMessageList;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: QI
}, Vv = process.env.NODE_ENV === "production" ? {
  name: "iqoq9n",
  styles: "margin-top:20px"
} : {
  name: "1x0p5ng-ChatMessageList",
  styles: "margin-top:20px;label:ChatMessageList;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: QI
}, mv = process.env.NODE_ENV === "production" ? {
  name: "19n4s14",
  styles: "position:absolute;bottom:0;left:0;right:0;height:80px;background:linear-gradient(to bottom, transparent, white);pointer-events:none"
} : {
  name: "bnqce9-ChatMessageList",
  styles: "position:absolute;bottom:0;left:0;right:0;height:80px;background:linear-gradient(to bottom, transparent, white);pointer-events:none;label:ChatMessageList;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: QI
}, hv = process.env.NODE_ENV === "production" ? {
  name: "zl1inp",
  styles: "display:flex;justify-content:center"
} : {
  name: "oxybf1-ChatMessageList",
  styles: "display:flex;justify-content:center;label:ChatMessageList;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: QI
};
const Wv = yg(function({
  messages: g,
  isGenerating: I,
  endActions: C,
  suggestionsNode: A,
  userSelections: c,
  onCourseClick: l
}) {
  const {
    t
  } = hg(), i = Ag(null), e = Ag(g.length), [n, b] = O(!1);
  q(() => {
    const d = i.current;
    if (!d)
      return;
    const Z = g.length > e.current;
    e.current = g.length, Z && d.scrollTo({
      top: d.scrollHeight,
      behavior: "smooth"
    });
  }, [g]);
  const a = k(() => {
    const d = i.current;
    if (!d)
      return;
    const Z = d.scrollHeight - d.scrollTop - d.clientHeight;
    b(Z > sv);
  }, []);
  q(() => {
    const d = i.current;
    if (d)
      return d.addEventListener("scroll", a, {
        passive: !0
      }), () => d.removeEventListener("scroll", a);
  }, [a]), q(() => {
    a();
  }, [g, I, a]);
  const s = k(() => {
    var d;
    (d = i.current) == null || d.scrollTo({
      top: i.current.scrollHeight,
      behavior: "smooth"
    });
  }, []);
  return /* @__PURE__ */ R(P, { css: Xv, children: [
    /* @__PURE__ */ o(P, { ref: i, css: Zv, children: /* @__PURE__ */ R(P, { css: /* @__PURE__ */ $({
      maxWidth: 768,
      margin: "0 auto",
      padding: "24px 32px",
      [Mg.mobile]: {
        padding: "24px 16px"
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:ChatMessageList;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
      /* @__PURE__ */ o(zG, { userSelections: c }),
      /* @__PURE__ */ R(gg, { spacing: 20, css: Vv, children: [
        g.map((d) => d.role === "user" ? /* @__PURE__ */ o(P, { children: /* @__PURE__ */ o(dv, { content: d.content }) }, d.id) : /* @__PURE__ */ o(rv, { message: d, onCourseClick: l }, d.id)),
        A,
        C
      ] })
    ] }) }),
    n && /* @__PURE__ */ o(P, { css: mv }),
    n && /* @__PURE__ */ o(P, { pos: "absolute", w: "100%", bottom: 16, css: hv, children: /* @__PURE__ */ o(qg, { "aria-label": t("llm-chat.scroll-to-bottom"), variant: "default", color: "infgreen", size: "n-md", radius: "xl", onClick: s, children: /* @__PURE__ */ o(sg, { icon: FN, size: "md", color: "gray.9" }) }) })
  ] });
});
function Nv({
  options: g
}) {
  return ON({
    queryKey: xv(),
    url: jI.CLIENT_V1_USER_ONBOARDINGS_SUGGESTED_QUESTIONS,
    options: g
  });
}
const xv = () => [jI.CLIENT_V1_USER_ONBOARDINGS_SUGGESTED_QUESTIONS];
function ct() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var yv = process.env.NODE_ENV === "production" ? {
  name: "hp0jjc",
  styles: "flex-shrink:0;display:flex"
} : {
  name: "1sknsfj-ChatInputSuggestion",
  styles: "flex-shrink:0;display:flex;label:ChatInputSuggestion;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: ct
}, pv = process.env.NODE_ENV === "production" ? {
  name: "imepyw",
  styles: "flex:1;text-align:left"
} : {
  name: "npoeew-ChatInputSuggestion",
  styles: "flex:1;text-align:left;label:ChatInputSuggestion;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: ct
}, Rv = process.env.NODE_ENV === "production" ? {
  name: "hp0jjc",
  styles: "flex-shrink:0;display:flex"
} : {
  name: "1sknsfj-ChatInputSuggestion",
  styles: "flex-shrink:0;display:flex;label:ChatInputSuggestion;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: ct
};
function Bv({
  text: g,
  onClick: I
}) {
  return /* @__PURE__ */ R(fs, { onClick: I, css: /* @__PURE__ */ $({
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "12px 16px",
    borderRadius: 32,
    transition: "background-color 0.15s ease",
    "&:hover": {
      backgroundColor: rg.gray[0]
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:ChatInputSuggestion;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvbW9kYWxzL3NyYy9jb21wb25lbnRzL09uYm9hcmRpbmdNb2RhbC9jb21wb25lbnRzL0xsbUNoYXRWaWV3L0xsbUVtcHR5U3RhdGVWaWV3LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF1Q00iLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9tb2RhbHMvc3JjL2NvbXBvbmVudHMvT25ib2FyZGluZ01vZGFsL2NvbXBvbmVudHMvTGxtQ2hhdFZpZXcvTGxtRW1wdHlTdGF0ZVZpZXcudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtcbiAgQm94LFxuICBkZXNrdG9wRmlyc3RNZWRpYVF1ZXJ5LFxuICBDT0xPUl9QQUxFVFRFLFxuICBGbGV4LFxuICBJY29uLFxuICBTdGFjayxcbiAgVGV4dCxcbiAgVW5zdHlsZWRCdXR0b24sXG59IGZyb20gJ0BpbmZsZWFybi9kcy1yZWFjdCc7XG5pbXBvcnQgeyBmYUFycm93VHVybkRvd25MZWZ0LCBmYVNwYXJrbGUgfSBmcm9tICdAaW5mbGVhcm4vcHJvLXNvbGlkLXN2Zy1pY29ucyc7XG5pbXBvcnQgeyBpc05pbCB9IGZyb20gJ2xvZGFzaC1lcyc7XG5pbXBvcnQgeyBtZW1vIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgdXNlVHJhbnNsYXRpb24gfSBmcm9tICdyZWFjdC1pMThuZXh0JztcblxuaW1wb3J0IHsgQ2hhdElucHV0IH0gZnJvbSAnLi9DaGF0SW5wdXQnO1xuaW1wb3J0IHsgVXNlclNlbGVjdGlvbkNhcmQgfSBmcm9tICcuL1VzZXJTZWxlY3Rpb25DYXJkJztcbmltcG9ydCB7IHVzZVVzZXJPbmJvYXJkaW5nc1N1Z2dlc3RlZFF1ZXN0aW9uc1F1ZXJ5IH0gZnJvbSAnLi4vLi4vLi4vLi4vLi4vcXVlcmllcy91c2VVc2VyT25ib2FyZGluZ3NTdWdnZXN0ZWRRdWVzdGlvbnNRdWVyeSc7XG5pbXBvcnQgdHlwZSB7IFVzZXJTZWxlY3Rpb25zIH0gZnJvbSAnLi4vLi4vaG9va3MvdXNlTGxtQ2hhdCc7XG5cbmludGVyZmFjZSBMbG1FbXB0eVN0YXRlVmlld1Byb3BzIHtcbiAgdXNlclNlbGVjdGlvbnM6IFVzZXJTZWxlY3Rpb25zO1xuICB0b3RhbFF1ZXN0aW9uczogbnVtYmVyO1xuICByZW1haW5pbmdRdWVzdGlvbnM6IG51bWJlcjtcbiAgaXNHZW5lcmF0aW5nOiBib29sZWFuO1xuICBpc0xpbWl0UmVhY2hlZDogYm9vbGVhbjtcbiAgb25TZW5kOiAodGV4dDogc3RyaW5nKSA9PiB2b2lkO1xuICBwbGFjZWhvbGRlcjogc3RyaW5nO1xufVxuXG5pbnRlcmZhY2UgQ2hhdElucHV0U3VnZ2VzdGlvblByb3BzIHtcbiAgdGV4dDogc3RyaW5nO1xuICBvbkNsaWNrOiAoKSA9PiB2b2lkO1xufVxuXG5mdW5jdGlvbiBDaGF0SW5wdXRTdWdnZXN0aW9uKHsgdGV4dCwgb25DbGljayB9OiBDaGF0SW5wdXRTdWdnZXN0aW9uUHJvcHMpIHtcbiAgcmV0dXJuIChcbiAgICA8VW5zdHlsZWRCdXR0b25cbiAgICAgIG9uQ2xpY2s9e29uQ2xpY2t9XG4gICAgICBjc3M9e3tcbiAgICAgICAgd2lkdGg6ICcxMDAlJyxcbiAgICAgICAgZGlzcGxheTogJ2ZsZXgnLFxuICAgICAgICBhbGlnbkl0ZW1zOiAnY2VudGVyJyxcbiAgICAgICAgZ2FwOiAxMCxcbiAgICAgICAgcGFkZGluZzogJzEycHggMTZweCcsXG4gICAgICAgIGJvcmRlclJhZGl1czogMzIsXG4gICAgICAgIHRyYW5zaXRpb246ICdiYWNrZ3JvdW5kLWNvbG9yIDAuMTVzIGVhc2UnLFxuICAgICAgICAnJjpob3Zlcic6IHtcbiAgICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IENPTE9SX1BBTEVUVEUuZ3JheVswXSxcbiAgICAgICAgfSxcbiAgICAgIH19PlxuICAgICAgPEJveCBjc3M9e3sgZmxleFNocmluazogMCwgZGlzcGxheTogJ2ZsZXgnIH19PlxuICAgICAgICA8SWNvbiBpY29uPXtmYVNwYXJrbGV9IHNpemU9XCJzbVwiIGNvbG9yPVwiZ3JheS41XCIgLz5cbiAgICAgIDwvQm94PlxuICAgICAgPFRleHQgc2l6ZT1cInNtXCIgY29sb3I9XCJncmF5LjdcIiB3ZWlnaHQ9ezYwMH0gY3NzPXt7IGZsZXg6IDEsIHRleHRBbGlnbjogJ2xlZnQnIH19PlxuICAgICAgICB7dGV4dH1cbiAgICAgIDwvVGV4dD5cbiAgICAgIDxCb3ggY3NzPXt7IGZsZXhTaHJpbms6IDAsIGRpc3BsYXk6ICdmbGV4JyB9fT5cbiAgICAgICAgPEljb24gaWNvbj17ZmFBcnJvd1R1cm5Eb3duTGVmdH0gc2l6ZT1cInNtXCIgY29sb3I9XCJncmF5LjdcIiAvPlxuICAgICAgPC9Cb3g+XG4gICAgPC9VbnN0eWxlZEJ1dHRvbj5cbiAgKTtcbn1cblxuZXhwb3J0IGNvbnN0IExsbUVtcHR5U3RhdGVWaWV3ID0gbWVtbyhmdW5jdGlvbiBMbG1FbXB0eVN0YXRlVmlldyh7XG4gIHVzZXJTZWxlY3Rpb25zLFxuICB0b3RhbFF1ZXN0aW9ucyxcbiAgcmVtYWluaW5nUXVlc3Rpb25zLFxuICBpc0dlbmVyYXRpbmcsXG4gIGlzTGltaXRSZWFjaGVkLFxuICBvblNlbmQsXG4gIHBsYWNlaG9sZGVyLFxufTogTGxtRW1wdHlTdGF0ZVZpZXdQcm9wcykge1xuICBjb25zdCB7IHQgfSA9IHVzZVRyYW5zbGF0aW9uKCk7XG4gIGNvbnN0IHsgZGF0YTogc3VnZ2VzdGVkUXVlc3Rpb25zIH0gPSB1c2VVc2VyT25ib2FyZGluZ3NTdWdnZXN0ZWRRdWVzdGlvbnNRdWVyeSh7fSk7XG5cbiAgY29uc3QgaGFzU2VsZWN0aW9ucyA9XG4gICAgdXNlclNlbGVjdGlvbnMuZ29hbHMubGVuZ3RoID4gMCB8fFxuICAgIHVzZXJTZWxlY3Rpb25zLmludGVyZXN0cy5sZW5ndGggPiAwIHx8XG4gICAgdXNlclNlbGVjdGlvbnMuc2tpbGxzLmxlbmd0aCA+IDA7XG5cbiAgaWYgKGlzTmlsKHN1Z2dlc3RlZFF1ZXN0aW9ucykpIHtcbiAgICByZXR1cm4gbnVsbDtcbiAgfVxuXG4gIHJldHVybiAoXG4gICAgPEZsZXhcbiAgICAgIGRpcmVjdGlvbj1cImNvbHVtblwiXG4gICAgICBjc3M9e3tcbiAgICAgICAgZmxleDogMSxcbiAgICAgICAganVzdGlmeUNvbnRlbnQ6ICdjZW50ZXInLFxuICAgICAgICBhbGlnbkl0ZW1zOiAnY2VudGVyJyxcbiAgICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgfX0+XG4gICAgICA8U3RhY2tcbiAgICAgICAgc3BhY2luZz17NDB9XG4gICAgICAgIGNzcz17e1xuICAgICAgICAgIG1heFdpZHRoOiA3NjgsXG4gICAgICAgICAgd2lkdGg6ICcxMDAlJyxcbiAgICAgICAgICBwYWRkaW5nOiAnMCAzMnB4JyxcbiAgICAgICAgICBbZGVza3RvcEZpcnN0TWVkaWFRdWVyeS5tb2JpbGVdOiB7XG4gICAgICAgICAgICBwYWRkaW5nOiAnMCAxNnB4JyxcbiAgICAgICAgICB9LFxuICAgICAgICB9fT5cbiAgICAgICAge2hhc1NlbGVjdGlvbnMgJiYgKFxuICAgICAgICAgIDxTdGFjayBzcGFjaW5nPXsxNn0+XG4gICAgICAgICAgICA8VGV4dCBzaXplPVwibWRcIiBjb2xvcj1cImdyYXkuOVwiIHdlaWdodD17NjAwfT5cbiAgICAgICAgICAgICAge3QoJ2xsbS1lbXB0eS1zdGF0ZS5zdW1tYXJ5LXRpdGxlJyl9XG4gICAgICAgICAgICA8L1RleHQ+XG4gICAgICAgICAgICA8VXNlclNlbGVjdGlvbkNhcmQgdXNlclNlbGVjdGlvbnM9e3VzZXJTZWxlY3Rpb25zfSAvPlxuICAgICAgICAgICAgPFRleHQgc2l6ZT1cIm1kXCIgY29sb3I9XCJncmF5LjlcIiB3ZWlnaHQ9ezYwMH0+XG4gICAgICAgICAgICAgIHt0KCdsbG0tZW1wdHktc3RhdGUucHJvbXB0LWhpbnQnKX1cbiAgICAgICAgICAgIDwvVGV4dD5cbiAgICAgICAgICA8L1N0YWNrPlxuICAgICAgICApfVxuXG4gICAgICAgIDxCb3g+XG4gICAgICAgICAgPENoYXRJbnB1dFxuICAgICAgICAgICAgaXNHZW5lcmF0aW5nPXtpc0dlbmVyYXRpbmd9XG4gICAgICAgICAgICBpc0xpbWl0UmVhY2hlZD17aXNMaW1pdFJlYWNoZWR9XG4gICAgICAgICAgICBpc1F1b3RhRXhoYXVzdGVkPXt0b3RhbFF1ZXN0aW9ucyA+IDAgJiYgcmVtYWluaW5nUXVlc3Rpb25zIDw9IDB9XG4gICAgICAgICAgICBwbGFjZWhvbGRlcj17cGxhY2Vob2xkZXJ9XG4gICAgICAgICAgICBvblNlbmQ9e29uU2VuZH1cbiAgICAgICAgICAvPlxuICAgICAgICAgIDxGbGV4XG4gICAgICAgICAgICBkaXJlY3Rpb249XCJjb2x1bW5cIlxuICAgICAgICAgICAgYWxpZ249XCJzdHJldGNoXCJcbiAgICAgICAgICAgIGdhcD17MH1cbiAgICAgICAgICAgIHA9ezh9XG4gICAgICAgICAgICBjc3M9e3tcbiAgICAgICAgICAgICAgYm9yZGVyUmFkaXVzOiAxNixcbiAgICAgICAgICAgICAgYm9yZGVyOiBgMXB4IHNvbGlkICR7Q09MT1JfUEFMRVRURS5ncmF5WzJdfWAsXG4gICAgICAgICAgICB9fT5cbiAgICAgICAgICAgIHtzdWdnZXN0ZWRRdWVzdGlvbnM/LnF1ZXN0aW9ucy5tYXAoKHN1Z2dlc3Rpb24sIGluZGV4KSA9PiAoXG4gICAgICAgICAgICAgIDxDaGF0SW5wdXRTdWdnZXN0aW9uXG4gICAgICAgICAgICAgICAga2V5PXtpbmRleH1cbiAgICAgICAgICAgICAgICB0ZXh0PXtzdWdnZXN0aW9ufVxuICAgICAgICAgICAgICAgIG9uQ2xpY2s9eygpID0+IG9uU2VuZChzdWdnZXN0aW9uKX1cbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICkpfVxuICAgICAgICAgIDwvRmxleD5cbiAgICAgICAgPC9Cb3g+XG4gICAgICA8L1N0YWNrPlxuICAgIDwvRmxleD5cbiAgKTtcbn0pO1xuIl19 */"), children: [
    /* @__PURE__ */ o(P, { css: yv, children: /* @__PURE__ */ o(sg, { icon: GN, size: "sm", color: "gray.5" }) }),
    /* @__PURE__ */ o(U, { size: "sm", color: "gray.7", weight: 600, css: pv, children: g }),
    /* @__PURE__ */ o(P, { css: Rv, children: /* @__PURE__ */ o(sg, { icon: rN, size: "sm", color: "gray.7" }) })
  ] });
}
var vv = process.env.NODE_ENV === "production" ? {
  name: "2mtnk1",
  styles: "flex:1;justify-content:center;align-items:center;overflow:hidden"
} : {
  name: "11yd3a1-LlmEmptyStateView",
  styles: "flex:1;justify-content:center;align-items:center;overflow:hidden;label:LlmEmptyStateView;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: ct
};
const Jv = yg(function({
  userSelections: g,
  totalQuestions: I,
  remainingQuestions: C,
  isGenerating: A,
  isLimitReached: c,
  onSend: l,
  placeholder: t
}) {
  const {
    t: i
  } = hg(), {
    data: e
  } = Nv({}), n = g.goals.length > 0 || g.interests.length > 0 || g.skills.length > 0;
  return su(e) ? null : /* @__PURE__ */ o(Cg, { direction: "column", css: vv, children: /* @__PURE__ */ R(gg, { spacing: 40, css: /* @__PURE__ */ $({
    maxWidth: 768,
    width: "100%",
    padding: "0 32px",
    [Mg.mobile]: {
      padding: "0 16px"
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:LlmEmptyStateView;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
    n && /* @__PURE__ */ R(gg, { spacing: 16, children: [
      /* @__PURE__ */ o(U, { size: "md", color: "gray.9", weight: 600, children: i("llm-empty-state.summary-title") }),
      /* @__PURE__ */ o(zG, { userSelections: g }),
      /* @__PURE__ */ o(U, { size: "md", color: "gray.9", weight: 600, children: i("llm-empty-state.prompt-hint") })
    ] }),
    /* @__PURE__ */ R(P, { children: [
      /* @__PURE__ */ o(FG, { isGenerating: A, isLimitReached: c, isQuotaExhausted: I > 0 && C <= 0, placeholder: t, onSend: l }),
      /* @__PURE__ */ o(Cg, { direction: "column", align: "stretch", gap: 0, p: 8, css: /* @__PURE__ */ $({
        borderRadius: 16,
        border: `1px solid ${rg.gray[2]}`
      }, process.env.NODE_ENV === "production" ? "" : ";label:LlmEmptyStateView;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: e == null ? void 0 : e.questions.map((b, a) => /* @__PURE__ */ o(Bv, { text: b, onClick: () => l(b) }, a)) })
    ] })
  ] }) });
}), Yv = yg(function({
  onBack: g,
  onExit: I
}) {
  const {
    t: C
  } = hg();
  return /* @__PURE__ */ R(Cg, { justify: "space-between", align: "center", px: 20, py: 12, css: /* @__PURE__ */ $({
    borderBottom: `1px solid ${rg.gray[3]}`,
    flexShrink: 0,
    [Mg.mobile]: {
      padding: "16px 6px"
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:LlmHeader;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvbW9kYWxzL3NyYy9jb21wb25lbnRzL09uYm9hcmRpbmdNb2RhbC9jb21wb25lbnRzL0xsbUNoYXRWaWV3L0xsbUhlYWRlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJNIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvbW9kYWxzL3NyYy9jb21wb25lbnRzL09uYm9hcmRpbmdNb2RhbC9jb21wb25lbnRzL0xsbUNoYXRWaWV3L0xsbUhlYWRlci50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBCdXR0b24sIENPTE9SX1BBTEVUVEUsIGRlc2t0b3BGaXJzdE1lZGlhUXVlcnksIEZsZXgsIEljb24gfSBmcm9tICdAaW5mbGVhcm4vZHMtcmVhY3QnO1xuaW1wb3J0IHsgZmFBcnJvd0xlZnQgfSBmcm9tICdAaW5mbGVhcm4vcHJvLXJlZ3VsYXItc3ZnLWljb25zJztcbmltcG9ydCB7IG1lbW8gfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyB1c2VUcmFuc2xhdGlvbiB9IGZyb20gJ3JlYWN0LWkxOG5leHQnO1xuXG5pbnRlcmZhY2UgTGxtSGVhZGVyUHJvcHMge1xuICBvbkJhY2s6ICgpID0+IHZvaWQ7XG4gIG9uRXhpdDogKCkgPT4gdm9pZDtcbn1cblxuZXhwb3J0IGNvbnN0IExsbUhlYWRlciA9IG1lbW8oZnVuY3Rpb24gTGxtSGVhZGVyKHsgb25CYWNrLCBvbkV4aXQgfTogTGxtSGVhZGVyUHJvcHMpIHtcbiAgY29uc3QgeyB0IH0gPSB1c2VUcmFuc2xhdGlvbigpO1xuXG4gIHJldHVybiAoXG4gICAgPEZsZXhcbiAgICAgIGp1c3RpZnk9XCJzcGFjZS1iZXR3ZWVuXCJcbiAgICAgIGFsaWduPVwiY2VudGVyXCJcbiAgICAgIHB4PXsyMH1cbiAgICAgIHB5PXsxMn1cbiAgICAgIGNzcz17e1xuICAgICAgICBib3JkZXJCb3R0b206IGAxcHggc29saWQgJHtDT0xPUl9QQUxFVFRFLmdyYXlbM119YCxcbiAgICAgICAgZmxleFNocmluazogMCxcbiAgICAgICAgW2Rlc2t0b3BGaXJzdE1lZGlhUXVlcnkubW9iaWxlXToge1xuICAgICAgICAgIHBhZGRpbmc6ICcxNnB4IDZweCcsXG4gICAgICAgIH0sXG4gICAgICB9fT5cbiAgICAgIDxCdXR0b25cbiAgICAgICAgdmFyaWFudD1cInN1YnRsZVwiXG4gICAgICAgIGNvbG9yPVwiZ3JheVwiXG4gICAgICAgIHNpemU9XCJ4c1wiXG4gICAgICAgIGxlZnRJY29uPXs8SWNvbiBpY29uPXtmYUFycm93TGVmdH0gc2l6ZT1cInhzXCIgLz59XG4gICAgICAgIG9uQ2xpY2s9e29uQmFja30+XG4gICAgICAgIHt0KCfsnbTsoIQg64uo6rOEJyl9XG4gICAgICA8L0J1dHRvbj5cbiAgICAgIDxCdXR0b24gdmFyaWFudD1cInN1YnRsZVwiIGNvbG9yPVwiZ3JheVwiIHNpemU9XCJ4c1wiIG9uQ2xpY2s9e29uRXhpdH0+XG4gICAgICAgIHt0KCfrgpjqsIDquLAnKX1cbiAgICAgIDwvQnV0dG9uPlxuICAgIDwvRmxleD5cbiAgKTtcbn0pO1xuIl19 */"), children: [
    /* @__PURE__ */ o(xg, { variant: "subtle", color: "gray", size: "xs", leftIcon: /* @__PURE__ */ o(sg, { icon: vN, size: "xs" }), onClick: g, children: C("이전 단계") }),
    /* @__PURE__ */ o(xg, { variant: "subtle", color: "gray", size: "xs", onClick: I, children: C("나가기") })
  ] });
});
function Fv() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var zv = process.env.NODE_ENV === "production" ? {
  name: "1l0p3iw",
  styles: "white-space:pre-line"
} : {
  name: "1gp44af-LlmLeaveConfirmModal",
  styles: "white-space:pre-line;label:LlmLeaveConfirmModal;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvbW9kYWxzL3NyYy9jb21wb25lbnRzL09uYm9hcmRpbmdNb2RhbC9jb21wb25lbnRzL0xsbUNoYXRWaWV3L0xsbUxlYXZlQ29uZmlybU1vZGFsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFtQzBCIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvbW9kYWxzL3NyYy9jb21wb25lbnRzL09uYm9hcmRpbmdNb2RhbC9jb21wb25lbnRzL0xsbUNoYXRWaWV3L0xsbUxlYXZlQ29uZmlybU1vZGFsLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEJ1dHRvbiwgTW9kYWwsIFRleHQgfSBmcm9tICdAaW5mbGVhcm4vZHMtcmVhY3QnO1xuaW1wb3J0IHsgbWVtbyB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IHVzZVRyYW5zbGF0aW9uIH0gZnJvbSAncmVhY3QtaTE4bmV4dCc7XG5cbmludGVyZmFjZSBMbG1MZWF2ZUNvbmZpcm1Nb2RhbFByb3BzIHtcbiAgb3BlbmVkOiBib29sZWFuO1xuICBvbkNvbmZpcm06ICgpID0+IHZvaWQ7XG4gIG9uQ2FuY2VsOiAoKSA9PiB2b2lkO1xufVxuXG5leHBvcnQgY29uc3QgTGxtTGVhdmVDb25maXJtTW9kYWwgPSBtZW1vKGZ1bmN0aW9uIExsbUxlYXZlQ29uZmlybU1vZGFsKHtcbiAgb3BlbmVkLFxuICBvbkNvbmZpcm0sXG4gIG9uQ2FuY2VsLFxufTogTGxtTGVhdmVDb25maXJtTW9kYWxQcm9wcykge1xuICBjb25zdCB7IHQgfSA9IHVzZVRyYW5zbGF0aW9uKCk7XG5cbiAgcmV0dXJuIChcbiAgICA8TW9kYWwuUm9vdFxuICAgICAgb3BlbmVkPXtvcGVuZWR9XG4gICAgICBvbkNsb3NlPXtvbkNhbmNlbH1cbiAgICAgIGNlbnRlcmVkXG4gICAgICBzaXplPVwic21cIlxuICAgICAgc3R5bGVzPXt7XG4gICAgICAgIGNvbnRlbnQ6IHtcbiAgICAgICAgICBib3JkZXJSYWRpdXM6IDE2LFxuICAgICAgICB9LFxuICAgICAgfX0+XG4gICAgICA8TW9kYWwuT3ZlcmxheSBiZz1cInJnYmEoMCwgMCwgMCwgMC43NSlcIiAvPlxuICAgICAgPE1vZGFsLkNvbnRlbnQ+XG4gICAgICAgIDxNb2RhbC5IZWFkZXI+XG4gICAgICAgICAgPE1vZGFsLlRpdGxlPnt0KCdsbG0tbGVhdmUtY29uZmlybS50aXRsZScpfTwvTW9kYWwuVGl0bGU+XG4gICAgICAgICAgPE1vZGFsLkNsb3NlQnV0dG9uIC8+XG4gICAgICAgIDwvTW9kYWwuSGVhZGVyPlxuICAgICAgICA8TW9kYWwuQm9keT5cbiAgICAgICAgICA8VGV4dCBzaXplPVwic21cIiBjc3M9e3sgd2hpdGVTcGFjZTogJ3ByZS1saW5lJyB9fT5cbiAgICAgICAgICAgIHt0KCdsbG0tbGVhdmUtY29uZmlybS5kZXNjcmlwdGlvbicpfVxuICAgICAgICAgIDwvVGV4dD5cbiAgICAgICAgPC9Nb2RhbC5Cb2R5PlxuICAgICAgICA8TW9kYWwuRm9vdGVyIGFsaWduPVwiZ3Jvd1wiPlxuICAgICAgICAgIDxCdXR0b24gdmFyaWFudD1cImRlZmF1bHRcIiBjb2xvcj1cImluZmdyZWVuXCIgc2l6ZT1cIm1kXCIgcmFkaXVzPVwibWRcIiBvbkNsaWNrPXtvbkNhbmNlbH0+XG4gICAgICAgICAgICB7dCgnbGxtLWxlYXZlLWNvbmZpcm0uY2FuY2VsJyl9XG4gICAgICAgICAgPC9CdXR0b24+XG4gICAgICAgICAgPEJ1dHRvbiB2YXJpYW50PVwiZGVmYXVsdFwiIGNvbG9yPVwicmVkXCIgc2l6ZT1cIm1kXCIgcmFkaXVzPVwibWRcIiBvbkNsaWNrPXtvbkNvbmZpcm19PlxuICAgICAgICAgICAgPFRleHQgY29sb3I9XCJyZWQuN1wiPnt0KCdsbG0tbGVhdmUtY29uZmlybS5jb25maXJtJyl9PC9UZXh0PlxuICAgICAgICAgIDwvQnV0dG9uPlxuICAgICAgICA8L01vZGFsLkZvb3Rlcj5cbiAgICAgIDwvTW9kYWwuQ29udGVudD5cbiAgICA8L01vZGFsLlJvb3Q+XG4gICk7XG59KTtcbiJdfQ== */",
  toString: Fv
};
const fv = yg(function({
  opened: g,
  onConfirm: I,
  onCancel: C
}) {
  const {
    t: A
  } = hg();
  return /* @__PURE__ */ R(wg.Root, { opened: g, onClose: C, centered: !0, size: "sm", styles: {
    content: {
      borderRadius: 16
    }
  }, children: [
    /* @__PURE__ */ o(wg.Overlay, { bg: "rgba(0, 0, 0, 0.75)" }),
    /* @__PURE__ */ R(wg.Content, { children: [
      /* @__PURE__ */ R(wg.Header, { children: [
        /* @__PURE__ */ o(wg.Title, { children: A("llm-leave-confirm.title") }),
        /* @__PURE__ */ o(wg.CloseButton, {})
      ] }),
      /* @__PURE__ */ o(wg.Body, { children: /* @__PURE__ */ o(U, { size: "sm", css: zv, children: A("llm-leave-confirm.description") }) }),
      /* @__PURE__ */ R(wg.Footer, { align: "grow", children: [
        /* @__PURE__ */ o(xg, { variant: "default", color: "infgreen", size: "md", radius: "md", onClick: C, children: A("llm-leave-confirm.cancel") }),
        /* @__PURE__ */ o(xg, { variant: "default", color: "red", size: "md", radius: "md", onClick: I, children: /* @__PURE__ */ o(U, { color: "red.7", children: A("llm-leave-confirm.confirm") }) })
      ] })
    ] })
  ] });
});
function Hv({
  options: g
}) {
  return TN({
    url: jI.CLIENT_V1_USER_ONBOARDINGS_SATISFIES_SURVEY,
    options: g
  });
}
function wv({
  sessionId: g,
  options: I
}) {
  return QN({
    queryKey: Sv(g),
    url: jI.CLIENT_V1_USER_ONBOARDINGS_SESSIONS_SESSIONID_SATISFIES_SURVEY_EXISTS(g),
    options: I
  });
}
const Sv = (g) => [jI.CLIENT_V1_USER_ONBOARDINGS_SESSIONS_SESSIONID_SATISFIES_SURVEY_EXISTS(g), g];
function Tv() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Lv = process.env.NODE_ENV === "production" ? {
  name: "yikdnd",
  styles: "align-self:stretch;display:grid;grid-template-columns:repeat(auto-fit, 42px);justify-content:space-between;gap:16px"
} : {
  name: "1umpehn-SatisfiesSurveyInput",
  styles: "align-self:stretch;display:grid;grid-template-columns:repeat(auto-fit, 42px);justify-content:space-between;gap:16px;label:SatisfiesSurveyInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Tv
};
function Uv({
  sessionId: g
}) {
  const {
    t: I
  } = hg(), [C, A] = O(!1), [c, l] = O(!1), {
    showNotification: t
  } = Mi(), {
    trackClickLlmWantMoreChat: i
  } = cA(), {
    data: e,
    isLoading: n
  } = wv({
    sessionId: g
  }), {
    mutate: b,
    isLoading: a
  } = Hv({
    options: {
      onSuccess: () => {
        A(!0);
      },
      onError: () => {
        t({
          type: "error",
          title: I("오류가 발생했습니다"),
          message: I("잠시 후 다시 시도해주세요")
        });
      }
    }
  }), s = k(() => {
    i({}), t({
      hasIcon: !1,
      type: "default",
      title: I("llm-survey.thanks-title"),
      message: I("llm-survey.thanks-description")
    }), l(!0);
  }, [i, t, I]);
  return c ? null : C ? /* @__PURE__ */ R(gg, { spacing: 16, mb: 16, css: /* @__PURE__ */ $({
    position: "sticky",
    bottom: 16,
    padding: 20,
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 10px 15px -5px rgba(0, 0, 0, 0.05), 0 7px 7px -5px rgba(0, 0, 0, 0.04)",
    borderRadius: 16,
    backgroundColor: "white",
    border: `1px solid ${rg.gray[2]}`
  }, process.env.NODE_ENV === "production" ? "" : ";label:SatisfiesSurveyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
    /* @__PURE__ */ R(Cg, { justify: "space-between", children: [
      /* @__PURE__ */ o(U, { size: "md", lh: "1.3", weight: 600, color: "gray.9", children: I("질문 3번 기회를 모두 사용했어요. 더 대화하고 싶다면 알려주세요!") }),
      /* @__PURE__ */ o(qg, { variant: "subtle", color: "gray", size: "n-xs", radius: "md", onClick: () => l(!0), children: /* @__PURE__ */ o(sg, { icon: YN, size: "xs", color: "gray.7" }) })
    ] }),
    /* @__PURE__ */ o(xg, { variant: "light", color: "gray", size: "md", fullWidth: !0, radius: "xl", onClick: s, children: I("더 대화하고 싶어요") })
  ] }) : n || e != null && e.exists ? null : (e == null ? void 0 : e.exists) === !1 ? /* @__PURE__ */ R(gg, { spacing: 16, mb: 16, css: /* @__PURE__ */ $({
    position: "sticky",
    bottom: 16,
    padding: 20,
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 10px 15px -5px rgba(0, 0, 0, 0.05), 0 7px 7px -5px rgba(0, 0, 0, 0.04)",
    borderRadius: 16,
    backgroundColor: "white",
    border: `1px solid ${rg.gray[2]}`
  }, process.env.NODE_ENV === "production" ? "" : ";label:SatisfiesSurveyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
    /* @__PURE__ */ o(U, { size: "md", lh: "1.3", weight: 600, color: "gray.9", children: I("추천 강의는 어떠셨나요?") }),
    /* @__PURE__ */ o(P, { css: Lv, children: Array.from({
      length: 10
    }, (d, Z) => Z + 1).map((d) => /* @__PURE__ */ o(xg, { variant: "subtle", color: "gray", size: "sm", radius: "xl", bg: "gray.0", w: 42, h: 42, p: 8, "aria-label": I("llm-survey.score-aria-label", {
      score: d
    }), disabled: a, onClick: () => b({
      score: d,
      sessionId: g
    }), children: /* @__PURE__ */ o(U, { size: "md", lh: "1.3", weight: 600, color: "gray.9", children: d }) }, d)) })
  ] }) : null;
}
const Pv = yg(function({
  questions: g,
  visible: I,
  onSelect: C
}) {
  return I ? /* @__PURE__ */ o(Cg, { direction: "column", align: "flex-start", gap: 8, py: 8, children: g.map((A, c) => /* @__PURE__ */ o(fs, { onClick: () => C(A), css: /* @__PURE__ */ $({
    maxWidth: "100%",
    border: `1px solid ${rg.gray[3]}`,
    borderRadius: 32,
    padding: "8px 16px",
    transition: "all 0.2s ease",
    transitionDelay: `${c * 100}ms`,
    animation: "slideUp 0.3s ease forwards",
    opacity: 0,
    animationDelay: `${c * 100}ms`,
    transform: "translateY(8px)",
    "@keyframes slideUp": {
      to: {
        opacity: 1,
        transform: "translateY(0)"
      }
    },
    "&:hover": {
      backgroundColor: rg.gray[0],
      borderColor: rg.gray[5]
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:SuggestedQuestions;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ o(U, { size: "sm", lh: 1.3, color: "gray.7", weight: 600, children: A }) }, `${A}-${c}`)) }) : null;
}), xs = {
  analyzeConversation: uA("대화 분석 및 사용자 선호도 추출"),
  searchCourses: uA("선호도에 맞는 강의 검색"),
  fetchCourseDetails: uA("검색된 강의 상세 정보 조회"),
  askQuestion: uA("추가 정보 필요 시 사용자에게 질문"),
  generateRecommendation: uA("최종 강의 추천 생성")
};
function kv(g) {
  return g.map((I) => ({
    id: String(I.id),
    role: I.role === "USER" ? "user" : "assistant",
    content: I.message,
    quickReplies: I.quickReplies,
    courses: I.isCourseRecommendation && I.courses.length > 0 ? I.courses : void 0
  }));
}
function Dv(g) {
  if (g != null && typeof g == "object" && "sessionId" in g) {
    const I = g.sessionId;
    return typeof I == "number" ? I : void 0;
  }
}
async function Ov(g, I, C, A) {
  var c;
  const l = await fetch(g, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "text/event-stream"
    },
    credentials: "include",
    body: JSON.stringify(I),
    signal: A
  });
  if (!l.ok)
    throw new Error(`Stream request failed: ${l.status}`);
  const t = (c = l.body) == null ? void 0 : c.getReader();
  if (!t)
    throw new Error("ReadableStream not supported");
  const i = new TextDecoder();
  let e = "", n;
  const b = (a) => {
    if (!a.startsWith("data:"))
      return;
    const s = a.slice(5).trim();
    if (s === "[DONE]")
      return;
    let d;
    try {
      d = JSON.parse(s).data;
    } catch (Z) {
      console.error("[useLlmChat] SSE JSON parse error:", Z, "raw data:", s);
      return;
    }
    d && (n = d, C(d));
  };
  for (; ; ) {
    const {
      done: a,
      value: s
    } = await t.read();
    if (a)
      break;
    e += i.decode(s, {
      stream: !0
    });
    const d = e.split(`
`);
    e = d.pop();
    for (const Z of d)
      b(Z);
  }
  return e.trim() && b(e.trim()), {
    lastPayload: n
  };
}
function jv({
  lang: g,
  selectionLabels: I
}) {
  const {
    t: C
  } = hg(), {
    trackSendLlmPrompt: A,
    trackViewLlmQuestion: c,
    trackViewCoursesRecommendation: l
  } = cA(), [t, i] = O([]), [e, n] = O(!1), [b, a] = O(0), [s, d] = O(0), [Z, r] = O([]), [h, x] = O(void 0), [u, G] = O(!1), [V, X] = O(!1), W = Ag(!1), N = Ag(null), {
    data: m
  } = Hd({
    options: {}
  });
  q(() => {
    var v;
    if (!m || W.current)
      return;
    W.current = !0;
    const Q = Dv(m);
    if (Q != null && x(Q), X(m.messages.length === 0), G(!0), a(m.totalMessageCount), d(m.remainMessageCount), m.messages.length > 0) {
      i(kv(m.messages));
      const cg = [...m.messages].reverse().find((J) => J.role === "ASSISTANT");
      (v = cg == null ? void 0 : cg.quickReplies) != null && v.length && r(cg.quickReplies);
      const z = m.messages.filter((J) => J.isCourseRecommendation && J.courses.length > 0).flatMap((J) => J.courses.map((y) => String(y.id)));
      z.length > 0 && l({
        step: DA.AI_RECOMMENDATION,
        course_identification: z,
        course_count: z.length,
        q1_selection_label: I.q1.length > 0 ? I.q1 : void 0,
        q2_selection_label: I.q2.length > 0 ? I.q2 : void 0,
        q3_selection_label: I.q3.length > 0 ? I.q3 : void 0,
        custom_input_text: I.custom.length > 0 ? I.custom : void 0,
        chat_session_id: su(Q) ? void 0 : String(Q)
      });
    }
  }, [m, I, l]), q(() => () => {
    var v;
    (v = N.current) == null || v.abort();
  }, []);
  const p = k(async (v) => {
    var Q, cg;
    if (e || b > 0 && s <= 0)
      return;
    const z = `user-${Date.now()}`, J = `assistant-${Date.now()}`, y = AI(), f = t.filter((H) => H.role === "user").length + 1;
    A({
      prompt_text: v,
      prompt_length: v.length,
      turn_number: f
    }), i((H) => [...H, {
      id: z,
      role: "user",
      content: v
    }]), n(!0), d((H) => Math.max(0, H - 1)), r([]), i((H) => [...H, {
      id: J,
      role: "assistant",
      content: "",
      isLoading: !0
    }]), (Q = N.current) == null || Q.abort();
    const B = new AbortController();
    N.current = B;
    try {
      const H = `${vd}${jI.CLIENT_V1_USER_ONBOARDINGS_STREAM}`, F = (await Ov(H, {
        sessionId: h,
        message: v,
        lang: g
      }, (M) => {
        var _;
        const j = M.processingNode ? (_ = xs[M.processingNode]) == null ? void 0 : _.call(xs) : void 0, eg = M.isProcessing && j ? j : void 0;
        i((Wg) => Wg.map((Hg) => Hg.id === J ? {
          ...Hg,
          content: M.message,
          isLoading: M.isProcessing && !M.message,
          processingText: eg,
          courses: M.courses.length > 0 ? M.courses : Hg.courses,
          isPendingCompletion: !M.isProcessing && M.isCourseRecommendation
        } : Hg));
      }, B.signal)).lastPayload, E = (F == null ? void 0 : F.sessionId) ?? h;
      E != null && x(E), F != null && F.isCourseRecommendation && F.courses.length > 0 && l({
        step: DA.AI_RECOMMENDATION,
        course_identification: F.courses.map((M) => String(M.id)),
        course_count: F.courses.length,
        q1_selection_label: I.q1.length > 0 ? I.q1 : void 0,
        q2_selection_label: I.q2.length > 0 ? I.q2 : void 0,
        q3_selection_label: I.q3.length > 0 ? I.q3 : void 0,
        custom_input_text: I.custom.length > 0 ? I.custom : void 0,
        chat_session_id: String(E ?? ""),
        response_time_ms: AI().diff(y)
      }), !(F != null && F.isCourseRecommendation) && F != null && F.message && c({
        chat_session_id: String(E ?? ""),
        question_text: F.message,
        response_time_ms: AI().diff(y)
      }), F && (a(F.totalMessageCount), d(F.remainMessageCount), (cg = F.quickReplies) != null && cg.length && r(F.quickReplies)), i((M) => M.map((_) => _.id === J ? {
        ..._,
        content: (F == null ? void 0 : F.message) ?? "",
        isLoading: !1,
        processingText: void 0,
        isPendingCompletion: !1,
        courses: F != null && F.isCourseRecommendation && F.courses.length > 0 ? F.courses : void 0,
        quickReplies: F == null ? void 0 : F.quickReplies
      } : _));
    } catch (H) {
      if (H instanceof DOMException && H.name === "AbortError")
        return;
      console.error("[useLlmChat] sendMessage error:", H), i((F) => F.map((E) => E.id === J ? {
        ...E,
        content: C("죄송합니다. 오류가 발생했어요. 다시 시도해주세요."),
        isLoading: !1
      } : E));
    } finally {
      B.signal.aborted || n(!1);
    }
  }, [t, h, I, s, b, e, g, C, A, c, l]), Y = !e && s <= 0 && b > 0;
  return {
    messages: t,
    isGenerating: e,
    isLimitReached: Y,
    totalQuestions: b,
    remainingQuestions: s,
    suggestedQuestions: Z,
    sendMessage: p,
    sessionId: h,
    isSessionInitialized: u,
    isNewSession: V
  };
}
function Ev() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Qv = process.env.NODE_ENV === "production" ? {
  name: "13udsys",
  styles: "height:100%"
} : {
  name: "1x2lx1d-LlmChatView",
  styles: "height:100%;label:LlmChatView;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Ev
};
const Mv = yg(function({
  onBack: g,
  onExit: I,
  userSelections: C,
  entryPoint: A,
  selectionLabels: c
}) {
  const {
    lang: l
  } = Je(), {
    t
  } = hg(), {
    trackStartLlmRecommendationSession: i,
    trackClickLlmSuggestion: e,
    trackClickBackToPopularCourses: n,
    trackCourseAtRecommendation: b
  } = cA(), {
    messages: a,
    isGenerating: s,
    isLimitReached: d,
    totalQuestions: Z,
    remainingQuestions: r,
    suggestedQuestions: h,
    sendMessage: x,
    sessionId: u,
    isSessionInitialized: G,
    isNewSession: V
  } = jv({
    lang: l,
    selectionLabels: c
  }), [X, W] = O(!1), N = Ag(null), m = Ag(s), p = Ag(!1);
  q(() => {
    m.current = s;
  }, [s]), q(() => {
    !G || p.current || d || (p.current = !0, i({
      chat_session_id: String(u ?? ""),
      entry_type: V ? "new" : "resume",
      entry_point: A,
      q1_selection_label: c.q1.length > 0 ? c.q1 : void 0,
      q2_selection_label: c.q2.length > 0 ? c.q2 : void 0,
      q3_selection_label: c.q3.length > 0 ? c.q3 : void 0,
      custom_input_text: c.custom.length > 0 ? c.custom : void 0
    }));
  }, [G, d, V, u, A, c, i]);
  const Y = k((j) => {
    m.current ? (N.current = j, W(!0)) : j();
  }, []), v = k(() => {
    var j;
    W(!1), (j = N.current) == null || j.call(N), N.current = null;
  }, []), Q = k(() => {
    W(!1), N.current = null;
  }, []);
  q(() => {
    window.history.pushState(null, "");
    const j = () => {
      m.current ? (window.history.pushState(null, ""), N.current = g, W(!0)) : g();
    }, eg = (Wg) => {
      m.current && (Wg.preventDefault(), Wg.returnValue = "");
    };
    return window.addEventListener("popstate", j), window.addEventListener("beforeunload", eg), () => {
      window.removeEventListener("popstate", j), window.removeEventListener("beforeunload", eg);
    };
  }, [g]);
  const cg = k((j) => {
    x(j);
  }, [x]), z = k(() => {
    const j = a.some((Wg) => Wg.courses && Wg.courses.length > 0), eg = a.length === 0 ? kC.BEFORE_CONVERSATION : j ? kC.AFTER_RECOMMENDATION : kC.DURING_CONVERSATION;
    return {
      chat_session_id: String(u ?? ""),
      churn_context: eg,
      is_recommended: j
    };
  }, [a, u]), J = k((j) => {
    const eg = a.filter((Wg) => Wg.role === "user").length + 1;
    e({
      chat_session_id: String(u ?? ""),
      suggestion_text: j,
      turn_number: eg
    }), x(j);
  }, [x, a, u, e]), y = k(() => {
    n({
      ...z(),
      label: "이전 단계"
    }), Y(g);
  }, [z, Y, g, n]), f = k(() => {
    const j = z();
    Y(() => I(j.churn_context));
  }, [z, Y, I]), B = k((j, eg) => {
    b({
      step: DA.AI_RECOMMENDATION,
      course_identification: String(j.id),
      course_title: j.title,
      index_abs: eg,
      seq0_instructor_name: j.instructorName,
      student_count: j.studentCount
    });
  }, [b]), H = k(() => {
    n({
      ...z(),
      label: "관심분야 인기강의 다시보기"
    }), g();
  }, [z, g, n]), F = a.length === 0, E = !s && h.length > 0, M = Z > 0 && r <= 0, _ = M ? t("질문 {{count}}개를 모두 사용했어요", {
    count: Z
  }) : t("메시지 입력... (질문권 {{count}}개)", {
    count: r
  });
  return /* @__PURE__ */ R(Cg, { direction: "column", css: Qv, children: [
    /* @__PURE__ */ o(Yv, { onBack: y, onExit: f }),
    F ? /* @__PURE__ */ o(Jv, { userSelections: C, totalQuestions: Z, remainingQuestions: r, isGenerating: s, isLimitReached: d, onSend: J, placeholder: t("llm-empty-state.input-placeholder", {
      count: Z
    }) }) : /* @__PURE__ */ R(sI, { children: [
      /* @__PURE__ */ o(Wv, { messages: a, isGenerating: s, userSelections: C, onCourseClick: B, suggestionsNode: /* @__PURE__ */ o(Pv, { questions: h, visible: E, onSelect: J }), endActions: d ? /* @__PURE__ */ R(gg, { spacing: 10, children: [
        /* @__PURE__ */ o(xg, { variant: "light", color: "gray", size: "md", fullWidth: !0, radius: "xl", onClick: H, children: t("관심분야 인기강의 다시보기") }),
        A !== OA.MY_SETTINGS && /* @__PURE__ */ o(xg, { variant: "light", color: "gray", size: "md", fullWidth: !0, radius: "xl", onClick: f, children: t("홈으로 가기") })
      ] }) : void 0 }),
      /* @__PURE__ */ o(P, { css: /* @__PURE__ */ $({
        maxWidth: 768,
        margin: "0 auto",
        width: "100%",
        padding: "0 32px",
        [Mg.mobile]: {
          padding: "0 16px"
        }
      }, process.env.NODE_ENV === "production" ? "" : ";label:LlmChatView;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: d && u != null ? /* @__PURE__ */ o(Uv, { sessionId: u }) : /* @__PURE__ */ o(FG, { isGenerating: s, isLimitReached: d, isQuotaExhausted: M, placeholder: _, onSend: cg }) })
    ] }),
    /* @__PURE__ */ o(fv, { opened: X, onConfirm: v, onCancel: Q })
  ] });
}), Pt = yg(function({
  step: g,
  stepRef: I,
  title: C,
  headerContent: A,
  currentStep: c,
  editingStep: l,
  renderOptions: t,
  secondaryState: i,
  onSecondaryToggle: e,
  summaryItems: n,
  onEdit: b,
  onCompleteEdit: a,
  customInput: s,
  isNextDisabled: d,
  onNext: Z,
  isDataLoading: r = !1,
  enableAnimation: h = !1
}) {
  const {
    t: x
  } = hg(), u = js(Fs.mobile), G = c === g, V = l === g, X = (g === 1 || c >= g) && (l === null || l === g), W = G || V, N = W && (i.showCustomInput || V && i.hasCustomInputValue) && s;
  if (!X)
    return null;
  const m = () => /* @__PURE__ */ R(sI, { children: [
    /* @__PURE__ */ o(P, { css: /* @__PURE__ */ $({
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: 12,
      [Mg.mobile]: {
        gridTemplateColumns: "1fr"
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:renderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: Array.from({
      length: 6
    }).map((Y, v) => /* @__PURE__ */ o(ng, { h: 60, radius: 32 }, v)) }),
    G && /* @__PURE__ */ o(Cg, { justify: "center", children: /* @__PURE__ */ o(ng, { h: 36, w: 346, radius: "xl" }) })
  ] }), p = () => /* @__PURE__ */ R(gg, { spacing: 20, w: "100%", children: [
    V && /* @__PURE__ */ o(U, { fz: "md", fw: 600, lh: 1.5, color: "gray.9", children: C }),
    /* @__PURE__ */ R(gg, { spacing: 8, py: V ? 12 : 0, px: 0, w: "100%", css: h ? {
      animation: "slideUp 0.7s ease-out",
      "@keyframes slideUp": {
        from: {
          opacity: 0,
          transform: "translateY(15px)"
        },
        to: {
          opacity: 1,
          transform: "translateY(0)"
        }
      }
    } : void 0, children: [
      /* @__PURE__ */ o(U, { fz: "xs", color: "gray.6", fw: 400, align: "right", children: x("중복 선택 가능") }),
      t(),
      /* @__PURE__ */ R(gg, { spacing: 12, mt: 12, align: "center", w: "100%", children: [
        /* @__PURE__ */ o(P, { css: u ? {
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          padding: "16px 20px",
          background: "white",
          borderTop: `1px solid ${rg.gray[2]}`,
          zIndex: 10
        } : {}, children: /* @__PURE__ */ o(Cg, { justify: "center", children: /* @__PURE__ */ o(xg, { variant: d ? "default" : "filled", color: d ? "gray" : "infgreen", radius: u ? "md" : "xl", w: u ? "100%" : 346, disabled: d, onClick: V ? a : Z, children: x("다음") }) }) }),
        /* @__PURE__ */ o(xg, { variant: i.hasUnknown ? "light" : "default", color: i.hasUnknown ? "infgreen" : void 0, size: "sm", radius: "xl", w: "100%", maw: 346, onClick: () => e("unknown"), children: x("잘 모르겠어요") }),
        !(i.hasCustomInputValue && !i.showCustomInput && !V) && /* @__PURE__ */ o(xg, { variant: i.showCustomInput || i.hasCustomInputValue ? "light" : "default", color: i.showCustomInput || i.hasCustomInputValue ? "infgreen" : void 0, size: "sm", radius: "xl", w: "100%", maw: 346, onClick: () => e("custom"), children: x("직접 입력하기") }),
        N && /* @__PURE__ */ o(Cg, { w: "100%", justify: "center", children: /* @__PURE__ */ o(Cx, { value: s.value, onChange: s.onChange }) })
      ] })
    ] })
  ] });
  return /* @__PURE__ */ o(P, { ref: I, pt: g === 1 ? 0 : 32, pb: u ? 80 : 32, children: /* @__PURE__ */ R(gg, { spacing: 20, children: [
    !V && A,
    !V && !A && /* @__PURE__ */ o(U, { fz: "md", fw: 600, lh: 1.5, color: "gray.9", children: C }),
    h && (r ? m() : W ? p() : /* @__PURE__ */ o(Cg, { justify: "flex-end", children: /* @__PURE__ */ o(Ws, { items: n, onEdit: b }) })),
    !h && !r && (W ? p() : /* @__PURE__ */ o(Cg, { justify: "flex-end", children: /* @__PURE__ */ o(Ws, { items: n, onEdit: b }) }))
  ] }) });
}), Kv = {
  briefcase: hN,
  bolt: VN,
  sprout: oN,
  rocket: mN,
  coins: XN,
  "id-card": ZN,
  "mug-hot": uN,
  "book-open": WN
}, on = "#00A760", Gn = "#E5F9F1", rn = rg.gray[3], _v = yg(function({
  goal: g,
  isSelected: I,
  onClick: C
}) {
  const A = g.icon ? Kv[g.icon] : void 0;
  return /* @__PURE__ */ o(P, { component: "button", type: "button", onClick: C, style: {
    padding: "11px 17px",
    border: `1px solid ${I ? on : rn}`,
    borderRadius: 32,
    backgroundColor: I ? Gn : "#FFFFFF",
    cursor: "pointer",
    transition: "all 0.2s",
    textAlign: "left"
  }, children: /* @__PURE__ */ R(Cg, { gap: 16, align: "center", children: [
    A && /* @__PURE__ */ o(sg, { icon: A, size: "md", color: I ? "infgreen.7" : "gray.5" }),
    /* @__PURE__ */ R(Cg, { direction: "column", gap: 4, style: {
      flex: 1
    }, children: [
      /* @__PURE__ */ o(U, { component: "span", fz: "sm", lh: 1.3, fw: 600, c: I ? "infgreen.7" : "gray.9", children: g.label }),
      g.description && /* @__PURE__ */ o(U, { component: "span", fz: "xs", lh: 1.3, fw: 400, c: I ? "infgreen.7" : "gray.6", children: g.description })
    ] })
  ] }) });
}), qv = yg(function({
  interest: g,
  isSelected: I,
  onClick: C
}) {
  return /* @__PURE__ */ o(P, { component: "button", type: "button", onClick: C, style: {
    padding: "9px 17px",
    border: `1px solid ${I ? on : rn}`,
    borderRadius: 32,
    backgroundColor: I ? Gn : "#FFFFFF",
    cursor: "pointer",
    transition: "all 0.2s",
    textAlign: "left"
  }, children: /* @__PURE__ */ o(U, { component: "span", fz: "sm", lh: 1.3, fw: 600, c: I ? "infgreen.7" : "gray.9", children: g.title }) });
}), $v = yg(function({
  skill: g,
  isSelected: I,
  onClick: C
}) {
  return /* @__PURE__ */ o(P, { component: "button", type: "button", onClick: C, style: {
    padding: "9px 17px",
    border: `1px solid ${I ? on : rn}`,
    borderRadius: 32,
    backgroundColor: I ? Gn : "#FFFFFF",
    cursor: "pointer",
    transition: "all 0.2s",
    textAlign: "left"
  }, children: /* @__PURE__ */ o(U, { component: "span", fz: "xs", lh: 1.3, fw: 600, c: I ? "infgreen.7" : "gray.9", children: g.title }) });
});
function Lc({
  text: g,
  typingSpeed: I = 20,
  showCursor: C = !1,
  cursorCharacter: A = "|",
  onComplete: c,
  startAnimation: l = !0
}) {
  const [t, i] = O(""), [e, n] = O(0), [b, a] = O(!1);
  return q(() => {
    if (!l)
      return;
    let s;
    return e < g.length && (s = setTimeout(() => {
      i((d) => d + g[e]), n((d) => d + 1);
    }, I)), e === g.length && !b && (a(!0), c == null || c()), () => {
      clearTimeout(s);
    };
  }, [e, l, g.length, I]), /* @__PURE__ */ R(sI, { children: [
    t,
    C && e < g.length && /* @__PURE__ */ o("span", { style: {
      animation: "blink 0.5s step-end infinite",
      marginLeft: "2px"
    }, children: A }),
    /* @__PURE__ */ o("style", { children: `
        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0; }
        }
      ` })
  ] });
}
function gJ({
  options: g
}) {
  return _9({
    url: mC.CLIENT_V1_USER_ONBOARDINGS_ANSWERS,
    options: g
  });
}
function IJ({
  lang: g = "ko",
  options: I
} = {}) {
  return M9({
    queryKey: CJ({
      lang: g
    }),
    url: tc.stringifyUrl({
      url: VC.CLIENT_V1_CATEGORY_MAIN,
      query: {
        lang: g
      }
    }),
    options: I
  });
}
const CJ = ({
  lang: g
} = {
  lang: "ko"
}) => [VC.CLIENT_V1_CATEGORY_MAIN, g];
function AJ({
  categories: g,
  keyword: I,
  lang: C = "ko",
  size: A,
  isCategoriesReady: c,
  options: l
}) {
  const {
    data: t,
    isLoading: i
  } = k9({
    queryKey: cJ({
      categories: g,
      keyword: I,
      lang: C,
      size: A
    }),
    url: tc.stringifyUrl({
      url: VC.CLIENT_V2_SKILLS_SEARCH,
      query: {
        categories: g,
        keyword: I,
        lang: C,
        size: A
      }
    }),
    options: {
      staleTime: Number.POSITIVE_INFINITY,
      enabled: c,
      keepPreviousData: !0,
      ...l
    }
  });
  return {
    skills: tg(() => (t == null ? void 0 : t.skills) ?? [], [t]),
    isLoading: i || !c
  };
}
const cJ = ({
  categories: g,
  keyword: I,
  lang: C = "ko",
  size: A
}) => [VC.CLIENT_V2_SKILLS_SEARCH, {
  categories: g,
  keyword: I,
  lang: C,
  size: A
}];
function lJ({
  lang: g = "ko",
  options: I
} = {}) {
  return AN({
    queryKey: tJ({
      lang: g
    }),
    url: tc.stringifyUrl({
      url: mC.CLIENT_V1_USAGE_PURPOSES,
      query: {
        lang: g
      }
    }),
    options: I
  });
}
const tJ = ({
  lang: g = "ko"
} = {}) => [mC.CLIENT_V1_USAGE_PURPOSES, g];
function fG() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const Uc = 20, iJ = `${b9}/assets/brand/small-logo.png`, eJ = {
  flex: 1,
  overflowY: "auto",
  scrollBehavior: "smooth",
  overscrollBehavior: "contain",
  WebkitOverflowScrolling: "touch"
}, nJ = {
  maxWidth: 768,
  width: "100%",
  margin: "0 auto",
  padding: "20px 32px 0",
  [Mg.mobile]: {
    padding: "20px 16px 0"
  }
}, yC = {
  DEBOUNCE_DELAY_MS: 100,
  MAX_SELECTION_COUNT: 15
}, bJ = {
  1: "book-open",
  2: "briefcase",
  3: "bolt",
  4: "sprout",
  5: "rocket",
  6: "coins",
  7: "id-card",
  8: "mug-hot"
};
var aJ = process.env.NODE_ENV === "production" ? {
  name: "1eic0kq",
  styles: ":hover{background-color:white;text-decoration:underline;}"
} : {
  name: "1pby5vt-renderSkillStep",
  styles: ":hover{background-color:white;text-decoration:underline;};label:renderSkillStep;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: fG
}, sJ = process.env.NODE_ENV === "production" ? {
  name: "18nai0f",
  styles: "display:block;flex-shrink:0"
} : {
  name: "ph082y-OnboardingStepsView",
  styles: "display:block;flex-shrink:0;label:OnboardingStepsView;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: fG
};
const uJ = yg(function({
  state: g,
  userName: I,
  isTypingVariant: C,
  introPhase: A,
  onSkip: c,
  onSubmit: l,
  onEnterLlm: t,
  showStep1Options: i,
  startLine2Animation: e,
  startLine3Animation: n,
  startLine4Animation: b,
  setStartLine2Animation: a,
  setStartLine3Animation: s,
  setStartLine4Animation: d,
  setShowStep1Options: Z,
  entryPoint: r
}) {
  const {
    t: h
  } = zN(), {
    lang: x
  } = Je(), {
    showNotification: u
  } = Mi(), G = qA(), {
    data: V,
    isLoading: X
  } = lJ({
    lang: x
  }), {
    data: W,
    isLoading: N
  } = IJ({
    lang: x
  }), m = tg(() => (W == null ? void 0 : W.categories) ?? [], [W]), {
    data: p
  } = we({
    lang: x,
    options: {}
  }), [Y, v] = O(20), Q = Ag(0), cg = Ag(0), z = tg(() => ((V == null ? void 0 : V.purposes) ?? []).map((w) => ({
    id: String(w.id),
    label: w.content,
    description: w.description,
    icon: bJ[w.id]
  })), [V]), J = tg(() => p != null && p.categories ? p.categories.filter((w) => w.type === "CATEGORY" && w.categoryId != null).map((w) => ({
    id: w.categoryId,
    title: w.content ?? "",
    slug: w.slug ?? ""
  })) : [], [p]), y = tg(() => p != null && p.skillTags ? p.skillTags.filter((w) => w.type === "SKILL_TAG" && w.skillId != null).map((w) => ({
    id: w.skillId,
    title: w.content ?? "",
    slug: w.slug ?? ""
  })) : [], [p]), f = tg(() => {
    const w = new Set(J.map((Rg) => Rg.id)), pg = m.filter((Rg) => !w.has(Rg.id));
    return [...J, ...pg];
  }, [m, J]), B = tg(() => g.selectedGoals.includes("1"), [g.selectedGoals]), H = tg(() => {
    const w = new Map(z.map((pg) => [pg.id, pg]));
    return g.selectedGoals.map((pg) => w.get(pg)).filter((pg) => pg !== void 0);
  }, [z, g.selectedGoals]), {
    skills: F,
    isLoading: E
  } = AJ({
    categories: g.hasInterestUnknown || g.hasInterestCustomInputValue ? "all" : g.selectedInterests.map((w) => w.slug).join(","),
    keyword: "",
    lang: x,
    isCategoriesReady: g.selectedInterests.length > 0 || g.hasInterestUnknown || g.hasInterestCustomInputValue,
    size: Y
  }), M = tg(() => {
    const w = new Set(y.map((Rg) => Rg.id)), pg = F.filter((Rg) => !w.has(Rg.id));
    return [...y, ...pg];
  }, [F, y]), {
    trackOnboardingSelection: _,
    trackOnboardingQuestionSubmit: j,
    trackRecommendationClose: eg
  } = cA(), {
    mutate: Wg
  } = gJ({
    options: {
      onError: (w) => {
        console.error("[Onboarding] Failed to save answers:", w), u({
          type: "error",
          title: h("저장에 실패했습니다. 잠시 후 다시 시도해주세요.")
        });
      }
    }
  }), Hg = k((w, pg) => {
    const Rg = g.isSelected(w);
    _({
      step: "q1",
      type: Rg ? "deselect" : "select",
      selection_label: pg
    }), g.handleGoalToggle(w);
  }, [g, _]), rI = k((w) => {
    const pg = Date.now();
    if (pg - Q.current < yC.DEBOUNCE_DELAY_MS)
      return;
    Q.current = pg;
    const Rg = g.isInterestSelected(w.id);
    if (!Rg && g.selectedInterests.length >= yC.MAX_SELECTION_COUNT) {
      u({
        type: "error",
        title: h("최대 {{count}}개까지 선택할 수 있습니다.", {
          count: yC.MAX_SELECTION_COUNT
        })
      });
      return;
    }
    g.handleInterestToggle(w), _({
      step: "q2",
      type: Rg ? "deselect" : "select",
      selection_label: w.slug
    });
  }, [g, _, u, h]), lg = k((w) => {
    const pg = Date.now();
    if (pg - cg.current < yC.DEBOUNCE_DELAY_MS)
      return;
    cg.current = pg;
    const Rg = g.isSkillSelected(w.id);
    if (!Rg && g.selectedSkills.length >= yC.MAX_SELECTION_COUNT) {
      u({
        type: "error",
        title: h("최대 {{count}}개까지 선택할 수 있습니다.", {
          count: yC.MAX_SELECTION_COUNT
        })
      });
      return;
    }
    g.handleSkillToggle(w), _({
      step: "q3",
      type: Rg ? "deselect" : "select",
      selection_label: w.slug
    });
  }, [g, _, u, h]), ig = k((w) => {
    _({
      step: "q1",
      type: "select",
      selection_label: w === "unknown" ? "not sure yet" : "enter my own"
    }), g.handleGoalSecondaryToggle(w);
  }, [g, _]), Ng = k((w) => {
    _({
      step: "q2",
      type: "select",
      selection_label: w === "unknown" ? "not sure yet" : "enter my own"
    }), g.handleInterestSecondaryToggle(w);
  }, [g, _]), ag = k((w) => {
    _({
      step: "q3",
      type: "select",
      selection_label: w === "unknown" ? "not sure yet" : "enter my own"
    }), g.handleSkillSecondaryToggle(w);
  }, [g, _]), Lg = k((w, pg = !1) => {
    let Rg, uc, dc = [], oc, Gc = !1;
    switch (w) {
      case "USAGE_PURPOSE":
        Rg = g.buildUsagePurposeAnswers(), uc = "q1", dc = z.filter((KI) => g.selectedGoals.includes(KI.id)).map((KI) => KI.label), oc = g.customInputValue || void 0, Gc = g.hasGoalUnknown;
        break;
      case "CATEGORY":
        Rg = g.buildCategoryAnswers(), uc = "q2", dc = g.selectedInterests.map((KI) => KI.slug), oc = g.interestCustomInputValue || void 0, Gc = g.hasInterestUnknown;
        break;
      case "SKILL_TAG":
        Rg = g.buildSkillAnswers(), uc = "q3", dc = g.getSelectedSkillInfo().map((KI) => KI.slug), oc = g.skillCustomInputValue || void 0, Gc = g.hasSkillUnknown;
        break;
    }
    j({
      step: uc,
      selected_options: dc,
      custom_input_text: oc,
      is_unknown: Gc
    }), Wg({
      type: w,
      answers: Rg
    }, {
      onSuccess: () => {
        G.invalidateQueries({
          queryKey: Se({
            lang: x
          })
        }), G.invalidateQueries({
          queryKey: fe({
            lang: x,
            limit: 20
          })
        }), pg || g.handleNextStep();
      }
    });
  }, [Wg, g, j, z, G, x]), XI = k((w) => {
    eg({
      step: w === 1 ? "q1" : w === 2 ? "q2" : w === 3 ? "q3" : "popular_courses",
      label: w === 4 ? "나가기" : "다음에하기"
    }), c();
  }, [c, eg]), MI = k(() => {
    l(), window.location.href = K9.OPEN_KNOWLEDGE();
  }, [l]), sc = k(() => {
    eg({
      step: "popular_courses",
      label: "홈으로 가기"
    }), l();
  }, [l, eg]), et = () => /* @__PURE__ */ o(Pt, { step: 1, title: h("인프런에 어떤 목적으로 오셨나요?"), headerContent: C && g.currentStep === 1 ? /* @__PURE__ */ R(gg, { spacing: 4, children: [
    /* @__PURE__ */ R(P, { children: [
      /* @__PURE__ */ o(U, { fz: "md", lh: 1.5, c: "gray.9", fw: 600, children: /* @__PURE__ */ o(Lc, { text: h("안녕하세요 {{name}}님", {
        name: I
      }) + " 👋", typingSpeed: Uc, startAnimation: !0, onComplete: () => a(!0) }) }),
      e && /* @__PURE__ */ o(U, { fz: "md", fw: 600, lh: 1.5, c: "gray.9", children: /* @__PURE__ */ o(Lc, { text: h("3가지 질문을 통해"), typingSpeed: Uc, startAnimation: !0, onComplete: () => s(!0) }) }),
      n && /* @__PURE__ */ o(U, { fz: "md", fw: 600, lh: 1.5, c: "gray.9", children: /* @__PURE__ */ o(Lc, { text: h("잘 맞는 인기 강의를 추천해드릴게요"), typingSpeed: Uc, startAnimation: !0, onComplete: () => d(!0) }) })
    ] }),
    b && /* @__PURE__ */ o(U, { fz: "md", lh: 1.5, c: "gray.7", fw: 400, children: /* @__PURE__ */ o(Lc, { text: h("인프런에 어떤 목적으로 오셨나요?"), typingSpeed: Uc, startAnimation: !0, onComplete: () => Z(!0) }) })
  ] }) : /* @__PURE__ */ R(gg, { spacing: 4, children: [
    /* @__PURE__ */ R(P, { children: [
      /* @__PURE__ */ R(U, { fz: "md", lh: 1.5, c: "gray.9", fw: 600, children: [
        h("안녕하세요 {{name}}님", {
          name: I
        }),
        " 👋"
      ] }),
      /* @__PURE__ */ o(U, { fz: "md", fw: 600, lh: 1.5, c: "gray.9", children: h("3가지 질문을 통해") }),
      /* @__PURE__ */ o(U, { fz: "md", fw: 600, lh: 1.5, c: "gray.9", children: h("잘 맞는 인기 강의를 추천해드릴게요") })
    ] }),
    /* @__PURE__ */ o(U, { fz: "md", lh: 1.5, c: "gray.7", fw: 400, children: h("인프런에 어떤 목적으로 오셨나요?") })
  ] }), currentStep: g.currentStep, editingStep: g.editingStep, renderOptions: () => /* @__PURE__ */ o(P, { css: /* @__PURE__ */ $({
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: 12,
    [Mg.mobile]: {
      gridTemplateColumns: "1fr"
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:renderGoalStep;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: z.map((w) => /* @__PURE__ */ o(_v, { goal: w, isSelected: g.isSelected(w.id), onClick: () => Hg(w.id, w.label) }, w.id)) }), secondaryState: {
    showCustomInput: g.showCustomInput,
    hasUnknown: g.hasGoalUnknown,
    hasCustomInputValue: g.hasGoalCustomInputValue
  }, onSecondaryToggle: ig, enableAnimation: C ? i : void 0, isDataLoading: g.currentStep === 1 && X || C && g.currentStep === 1 && !i, summaryItems: [...H.map((w) => ({
    label: w.label,
    description: w.description
  })), ...g.hasGoalCustomInputValue ? [{
    label: g.customInputValue
  }] : [], ...g.hasGoalUnknown ? [{
    label: h("아직 잘 모르겠다")
  }] : []], onEdit: () => g.startEdit(1), onCancelEdit: g.cancelEdit, onCompleteEdit: () => {
    g.completeEdit(), Lg("USAGE_PURPOSE", !0);
  }, customInput: {
    value: g.customInputValue,
    onChange: g.setCustomInputValue
  }, isNextDisabled: g.isNextButtonDisabled, onNext: () => Lg("USAGE_PURPOSE") }), Xr = () => /* @__PURE__ */ o(Pt, { step: 2, stepRef: g.step2Ref, title: h("좋아요! 어떤 분야에 관심이 있으세요?"), headerContent: /* @__PURE__ */ o(U, { fz: "md", fw: 600, lh: 1.5, color: "gray.9", children: h("좋아요! 어떤 분야에 관심이 있으세요?") }), currentStep: g.currentStep, editingStep: g.editingStep, renderOptions: () => /* @__PURE__ */ o(P, { css: /* @__PURE__ */ $({
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: 12,
    [Mg.mobile]: {
      gridTemplateColumns: "1fr"
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:renderInterestStep;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: f.map((w) => /* @__PURE__ */ o(qv, { interest: w, isSelected: g.isInterestSelected(w.id), onClick: () => rI(w) }, w.id)) }), secondaryState: {
    showCustomInput: g.showInterestCustomInput,
    hasUnknown: g.hasInterestUnknown,
    hasCustomInputValue: g.hasInterestCustomInputValue
  }, onSecondaryToggle: Ng, isDataLoading: g.currentStep === 2 && N, summaryItems: [...g.getSelectedInterestInfo().map((w) => ({
    label: w.title
  })), ...g.hasInterestCustomInputValue ? [{
    label: g.interestCustomInputValue
  }] : [], ...g.hasInterestUnknown ? [{
    label: h("아직 잘 모르겠다")
  }] : []], onEdit: () => g.startEdit(2), onCancelEdit: g.cancelEdit, onCompleteEdit: () => {
    g.completeEdit(), Lg("CATEGORY", !0);
  }, customInput: {
    value: g.interestCustomInputValue,
    onChange: g.setInterestCustomInputValue
  }, isNextDisabled: g.isNextButtonDisabled, onNext: () => Lg("CATEGORY") }), Zr = () => /* @__PURE__ */ o(Pt, { step: 3, stepRef: g.step3Ref, title: h("거의 다 왔어요! 배우고 싶은 기술을 선택해주세요 🎯"), headerContent: /* @__PURE__ */ R(gg, { spacing: 4, children: [
    /* @__PURE__ */ o(U, { fz: "md", fw: 600, lh: 1.5, color: "gray.9", children: h("거의 다 왔어요! 배우고 싶은 기술을 선택해주세요 🎯") }),
    /* @__PURE__ */ o(U, { fz: "md", lh: 1.5, color: "gray.7", fw: 400, children: h("선택한 분야의 세부 기술이에요") })
  ] }), currentStep: g.currentStep, editingStep: g.editingStep, renderOptions: () => /* @__PURE__ */ R(gg, { spacing: 8, children: [
    /* @__PURE__ */ o(P, { css: /* @__PURE__ */ $({
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: 12,
      [Mg.mobile]: {
        gridTemplateColumns: "1fr"
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:renderSkillStep;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: M.map((w) => /* @__PURE__ */ o($v, { skill: w, isSelected: g.isSkillSelected(w.id), onClick: () => lg(w) }, w.id)) }),
    Y === 20 && F.length >= 20 && /* @__PURE__ */ o(Cg, { justify: "center", children: /* @__PURE__ */ o(xg, { variant: "subtle", color: "gray", size: "xs", compact: !0, radius: "md", onClick: () => {
      v(40);
    }, css: aJ, rightIcon: /* @__PURE__ */ o(sg, { icon: JN, size: "xs", color: "gray.7" }), children: h("더보기") }) })
  ] }), secondaryState: {
    showCustomInput: g.showSkillCustomInput,
    hasUnknown: g.hasSkillUnknown,
    hasCustomInputValue: g.hasSkillCustomInputValue
  }, onSecondaryToggle: ag, isDataLoading: g.currentStep === 3 && E, summaryItems: [...g.getSelectedSkillInfo().map((w) => ({
    label: w.title
  })), ...g.hasSkillCustomInputValue ? [{
    label: g.skillCustomInputValue
  }] : [], ...g.hasSkillUnknown ? [{
    label: h("아직 잘 모르겠다")
  }] : []], onEdit: () => g.startEdit(3), onCancelEdit: g.cancelEdit, onCompleteEdit: () => {
    g.completeEdit(), Lg("SKILL_TAG", !0);
  }, customInput: {
    value: g.skillCustomInputValue,
    onChange: g.setSkillCustomInputValue
  }, isNextDisabled: g.isNextButtonDisabled, onNext: () => Lg("SKILL_TAG") }), Vr = () => g.currentStep !== 4 || g.editingStep !== null ? null : /* @__PURE__ */ o(P, { ref: g.step4Ref, h: "100%", children: B ? /* @__PURE__ */ o(bx, { onApplyInstructor: MI, onGoToMain: sc, userName: I, onEnterLlm: t }) : /* @__PURE__ */ o(tv, { onGoToMain: sc, userName: I, onEnterLlm: t, entryPoint: r }) });
  return /* @__PURE__ */ R(sI, { children: [
    /* @__PURE__ */ R(wg.Header, { p: 0, css: sJ, children: [
      /* @__PURE__ */ R(Cg, { justify: "space-between", align: "center", w: "100%", px: 20, pt: 16, pb: 20, children: [
        /* @__PURE__ */ R(Cg, { gap: 20, align: "center", children: [
          /* @__PURE__ */ o(P, { w: 20, h: 20, children: /* @__PURE__ */ o(bC, { w: 40, width: 20, height: 20, src: iJ, alt: h("인프런") }) }),
          /* @__PURE__ */ R(U, { size: "md", lh: 1.5, children: [
            g.currentStep - 1,
            "/3"
          ] })
        ] }),
        A === "hidden" && (!C || g.currentStep !== 1 || i) && /* @__PURE__ */ o(xg, { variant: "light", color: "gray", size: "xs", radius: "md", onClick: () => XI(g.currentStep), children: g.currentStep === 4 ? h("나가기") : h("다음에 하기") })
      ] }),
      /* @__PURE__ */ o(pr, { value: g.progress, w: "100%", h: 2 })
    ] }),
    /* @__PURE__ */ o(P, { ref: g.scrollContainerRef, css: eJ, children: /* @__PURE__ */ o(P, { css: nJ, children: A !== "hidden" ? /* @__PURE__ */ o(P, { h: "100%" }) : /* @__PURE__ */ R(sI, { children: [
      et(),
      Xr(),
      Zr(),
      Vr()
    ] }) }) })
  ] });
});
function hC() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var dJ = process.env.NODE_ENV === "production" ? {
  name: "13udsys",
  styles: "height:100%"
} : {
  name: "juttuu-OnboardingLoadingSkeleton",
  styles: "height:100%;label:OnboardingLoadingSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: hC
}, oJ = process.env.NODE_ENV === "production" ? {
  name: "l5ig46",
  styles: "border-bottom:1px solid #e9ecef;flex-shrink:0"
} : {
  name: "1bdbay6-OnboardingLoadingSkeleton",
  styles: "border-bottom:1px solid #e9ecef;flex-shrink:0;label:OnboardingLoadingSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: hC
}, GJ = process.env.NODE_ENV === "production" ? {
  name: "1o3nkn",
  styles: "margin-left:auto"
} : {
  name: "1wy8aw5-OnboardingLoadingSkeleton",
  styles: "margin-left:auto;label:OnboardingLoadingSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: hC
}, rJ = process.env.NODE_ENV === "production" ? {
  name: "18nai0f",
  styles: "display:block;flex-shrink:0"
} : {
  name: "1klch1e-OnboardingLoadingSkeleton",
  styles: "display:block;flex-shrink:0;label:OnboardingLoadingSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: hC
}, XJ = process.env.NODE_ENV === "production" ? {
  name: "11kwdhz",
  styles: "height:2px;background-color:#e9ecef;width:100%"
} : {
  name: "etoh7u-OnboardingLoadingSkeleton",
  styles: "height:2px;background-color:#e9ecef;width:100%;label:OnboardingLoadingSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: hC
}, ZJ = process.env.NODE_ENV === "production" ? {
  name: "9jwnf3",
  styles: "flex:1;overflow-y:auto"
} : {
  name: "fkale0-OnboardingLoadingSkeleton",
  styles: "flex:1;overflow-y:auto;label:OnboardingLoadingSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: hC
}, VJ = process.env.NODE_ENV === "production" ? {
  name: "1hy36mu",
  styles: "max-width:700px;width:100%;margin:0 auto;padding:0 20px"
} : {
  name: "16kfnd0-OnboardingLoadingSkeleton",
  styles: "max-width:700px;width:100%;margin:0 auto;padding:0 20px;label:OnboardingLoadingSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: hC
};
function mJ({
  initialStep: g
}) {
  return g >= 4 ? /* @__PURE__ */ R(Cg, { direction: "column", css: dJ, children: [
    /* @__PURE__ */ R(Cg, { justify: "space-between", align: "center", px: 20, py: 12, css: oJ, children: [
      /* @__PURE__ */ o(ng, { height: 28, width: 80, radius: "md" }),
      /* @__PURE__ */ o(ng, { height: 28, width: 52, radius: "md" })
    ] }),
    /* @__PURE__ */ o(P, { css: /* @__PURE__ */ $({
      flex: 1,
      padding: "24px 32px",
      maxWidth: 768,
      margin: "0 auto",
      width: "100%",
      [Mg.mobile]: {
        padding: "24px 16px"
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:OnboardingLoadingSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ R(gg, { spacing: 16, children: [
      /* @__PURE__ */ o(ng, { height: 80, radius: "md" }),
      /* @__PURE__ */ o(ng, { height: 40, width: "65%", radius: "xl" }),
      /* @__PURE__ */ o(ng, { height: 60, radius: "md" }),
      /* @__PURE__ */ o(ng, { height: 40, width: "50%", radius: "xl", css: GJ })
    ] }) })
  ] }) : /* @__PURE__ */ R(sI, { children: [
    /* @__PURE__ */ R(wg.Header, { p: 0, css: rJ, children: [
      /* @__PURE__ */ R(Cg, { justify: "space-between", align: "center", w: "100%", px: 20, pt: 16, pb: 20, children: [
        /* @__PURE__ */ R(Cg, { gap: 20, align: "center", children: [
          /* @__PURE__ */ o(ng, { width: 20, height: 20, radius: "sm" }),
          /* @__PURE__ */ o(ng, { height: 18, width: 24, radius: "sm" })
        ] }),
        /* @__PURE__ */ o(ng, { height: 28, width: 88, radius: "md" })
      ] }),
      /* @__PURE__ */ o(P, { css: XJ })
    ] }),
    /* @__PURE__ */ o(P, { css: ZJ, children: /* @__PURE__ */ o(P, { css: VJ, children: /* @__PURE__ */ o(P, { px: 20, pt: 32, children: /* @__PURE__ */ R(gg, { spacing: 20, children: [
      /* @__PURE__ */ R(gg, { spacing: 4, children: [
        /* @__PURE__ */ o(ng, { h: 24, w: "60%", radius: "xl" }),
        /* @__PURE__ */ o(ng, { h: 24, w: "70%", radius: "xl" }),
        /* @__PURE__ */ o(ng, { h: 24, w: "75%", radius: "xl" }),
        /* @__PURE__ */ o(ng, { h: 24, w: "55%", radius: "xl" })
      ] }),
      /* @__PURE__ */ o(Cg, { direction: "column", align: "flex-end", w: "100%", children: /* @__PURE__ */ R(gg, { spacing: 8, w: "100%", align: "flex-end", children: [
        /* @__PURE__ */ o(ng, { h: 14, w: 80, radius: 4 }),
        /* @__PURE__ */ R(Ig, { spacing: 8, position: "right", maw: 330, children: [
          /* @__PURE__ */ o(ng, { h: 28, w: 100, radius: "md" }),
          /* @__PURE__ */ o(ng, { h: 28, w: 120, radius: "md" }),
          /* @__PURE__ */ o(ng, { h: 28, w: 90, radius: "md" }),
          /* @__PURE__ */ o(ng, { h: 28, w: 110, radius: "md" })
        ] }),
        /* @__PURE__ */ R(gg, { spacing: 8, align: "flex-end", children: [
          /* @__PURE__ */ o(ng, { h: 28, w: 140, radius: "md" }),
          /* @__PURE__ */ o(ng, { h: 28, w: 120, radius: "md" })
        ] })
      ] }) }),
      /* @__PURE__ */ o(Cg, { justify: "flex-end", children: /* @__PURE__ */ o(ng, { h: 28, w: 60, radius: "md" }) })
    ] }) }) }) })
  ] });
}
const Tg = {
  showCustomInput: !1,
  customInputValue: "",
  hasUnknown: !1
}, Xn = (g, I) => {
  const C = [...g];
  return I.hasUnknown && C.push({
    type: "UNKNOWN"
  }), I.customInputValue.trim() && C.push({
    type: "CUSTOM_INPUT",
    content: I.customInputValue.trim()
  }), C;
}, kt = (g, I) => g.showCustomInput && g.customInputValue.trim() ? !1 : g.showCustomInput ? !0 : !I && !g.hasUnknown && !g.customInputValue.trim(), hJ = () => ({
  currentStep: 1,
  selectedGoals: [],
  selectedInterests: [],
  selectedSkills: [],
  secondaryOptions: {
    1: {
      ...Tg
    },
    2: {
      ...Tg
    },
    3: {
      ...Tg
    }
  },
  editingStep: null,
  editBackup: null
}), Dt = (g) => {
  const I = g.find((A) => A.type === "CUSTOM_INPUT"), C = g.some((A) => A.type === "UNKNOWN");
  return {
    showCustomInput: !1,
    customInputValue: (I == null ? void 0 : I.content) ?? "",
    hasUnknown: C
  };
}, WJ = (g) => {
  const {
    usagePurposes: I,
    categories: C,
    skillTags: A
  } = g, c = I.filter((s) => s.type === "USAGE_PURPOSE" && s.usagePurposeId != null).map((s) => String(s.usagePurposeId)), l = C.filter((s) => s.type === "CATEGORY" && s.categoryId != null).map((s) => ({
    id: s.categoryId,
    title: s.content ?? "",
    slug: s.slug ?? ""
  })), t = A.filter((s) => s.type === "SKILL_TAG" && s.skillId != null).map((s) => ({
    id: s.skillId,
    title: s.content ?? "",
    slug: s.slug ?? ""
  })), i = {
    1: Dt(I),
    2: Dt(C),
    3: Dt(A)
  }, e = c.length > 0 || i[1].hasUnknown || i[1].customInputValue, n = l.length > 0 || i[2].hasUnknown || i[2].customInputValue, b = t.length > 0 || i[3].hasUnknown || i[3].customInputValue;
  let a = 1;
  return b ? a = 4 : n ? a = 3 : e && (a = 2), {
    currentStep: a,
    selectedGoals: c,
    selectedInterests: l,
    selectedSkills: t,
    secondaryOptions: i,
    editingStep: null,
    editBackup: null
  };
}, NJ = (g) => {
  const {
    currentStep: I,
    editingStep: C,
    selectedGoals: A,
    selectedInterests: c,
    selectedSkills: l,
    secondaryOptions: t
  } = g, i = t[1] ?? Tg, e = t[2] ?? Tg, n = t[3] ?? Tg;
  switch (C ?? I) {
    case 1:
      return kt(i, A.length > 0);
    case 2:
      return kt(e, c.length > 0);
    case 3:
      return kt(n, l.length > 0);
    default:
      return !1;
  }
}, xJ = (g) => {
  const {
    selectedGoals: I,
    secondaryOptions: C
  } = g, A = C[1] ?? Tg, c = I.filter((l) => !l.startsWith("custom:") && l !== "unknown").map((l) => ({
    type: "USAGE_PURPOSE",
    usagePurposeId: Number(l)
  })).filter((l) => !Number.isNaN(l.usagePurposeId));
  return Xn(c, A);
}, yJ = (g) => {
  const {
    selectedInterests: I,
    secondaryOptions: C
  } = g, A = C[2] ?? Tg, c = I.map((l) => ({
    type: "CATEGORY",
    categoryId: l.id
  }));
  return Xn(c, A);
}, pJ = (g) => {
  const {
    selectedSkills: I,
    secondaryOptions: C
  } = g, A = C[3] ?? Tg, c = I.map((l) => ({
    type: "SKILL_TAG",
    skillId: l.id
  }));
  return Xn(c, A);
}, RJ = (g) => [25, 50, 75, 100][g - 1] ?? 100, BJ = (g, I) => {
  switch (I.type) {
    case "NEXT_STEP":
      return g.currentStep >= 4 ? g : {
        ...g,
        currentStep: g.currentStep + 1
      };
    case "TOGGLE_GOAL": {
      const {
        goalId: C
      } = I, A = g.selectedGoals.includes(C);
      return {
        ...g,
        selectedGoals: A ? g.selectedGoals.filter((c) => c !== C) : [...g.selectedGoals, C],
        // goal 선택 시 unknown 해제
        secondaryOptions: {
          ...g.secondaryOptions,
          1: {
            ...g.secondaryOptions[1],
            hasUnknown: !1
          }
        }
      };
    }
    case "TOGGLE_INTEREST": {
      const {
        interest: C
      } = I, A = g.selectedInterests.some((c) => c.id === C.id);
      return {
        ...g,
        selectedInterests: A ? g.selectedInterests.filter((c) => c.id !== C.id) : [...g.selectedInterests, C],
        secondaryOptions: {
          ...g.secondaryOptions,
          2: {
            ...g.secondaryOptions[2],
            hasUnknown: !1
          }
        }
      };
    }
    case "TOGGLE_SKILL": {
      const {
        skill: C
      } = I, A = g.selectedSkills.some((c) => c.id === C.id);
      return {
        ...g,
        selectedSkills: A ? g.selectedSkills.filter((c) => c.id !== C.id) : [...g.selectedSkills, C],
        secondaryOptions: {
          ...g.secondaryOptions,
          3: {
            ...g.secondaryOptions[3],
            hasUnknown: !1
          }
        }
      };
    }
    case "TOGGLE_SECONDARY_OPTION": {
      const {
        step: C,
        optionId: A
      } = I, c = g.secondaryOptions[C] ?? Tg;
      if (A === "custom") {
        const l = !c.showCustomInput;
        return {
          ...g,
          secondaryOptions: {
            ...g.secondaryOptions,
            [C]: {
              ...c,
              showCustomInput: l,
              hasUnknown: !1,
              // 해제 시 입력값도 삭제
              customInputValue: l ? c.customInputValue : ""
            }
          }
        };
      }
      if (A === "unknown") {
        const l = !c.hasUnknown, t = l ? {
          1: {
            selectedGoals: []
          },
          2: {
            selectedInterests: []
          },
          3: {
            selectedSkills: []
          }
        }[C] ?? {} : {};
        return {
          ...g,
          ...t,
          secondaryOptions: {
            ...g.secondaryOptions,
            [C]: {
              ...c,
              hasUnknown: l,
              // unknown 선택 시 custom 입력 초기화 (상호 배타적)
              ...l ? {
                showCustomInput: !1,
                customInputValue: ""
              } : {}
            }
          }
        };
      }
      return g;
    }
    case "SET_SECONDARY_CUSTOM_INPUT": {
      const {
        step: C,
        value: A
      } = I, c = g.secondaryOptions[C] ?? Tg;
      return {
        ...g,
        secondaryOptions: {
          ...g.secondaryOptions,
          [C]: {
            ...c,
            customInputValue: A
          }
        }
      };
    }
    case "CANCEL_SECONDARY_CUSTOM_INPUT": {
      const {
        step: C
      } = I, A = g.secondaryOptions[C] ?? Tg;
      return {
        ...g,
        secondaryOptions: {
          ...g.secondaryOptions,
          [C]: {
            ...A,
            showCustomInput: !1,
            customInputValue: ""
          }
        }
      };
    }
    case "COMPLETE_SECONDARY_CUSTOM_INPUT": {
      const {
        step: C
      } = I, A = g.secondaryOptions[C] ?? Tg;
      return {
        ...g,
        secondaryOptions: {
          ...g.secondaryOptions,
          [C]: {
            ...A,
            showCustomInput: !1
          }
        }
      };
    }
    case "START_EDIT": {
      const {
        step: C
      } = I;
      return {
        ...g,
        editingStep: C,
        editBackup: {
          selectedGoals: [...g.selectedGoals],
          selectedInterests: [...g.selectedInterests],
          selectedSkills: [...g.selectedSkills],
          secondaryOptions: {
            1: {
              ...g.secondaryOptions[1]
            },
            2: {
              ...g.secondaryOptions[2]
            },
            3: {
              ...g.secondaryOptions[3]
            }
          }
        }
      };
    }
    case "CANCEL_EDIT":
      return g.editBackup ? {
        ...g,
        selectedGoals: g.editBackup.selectedGoals,
        selectedInterests: g.editBackup.selectedInterests,
        selectedSkills: g.editBackup.selectedSkills,
        secondaryOptions: g.editBackup.secondaryOptions,
        editingStep: null,
        editBackup: null
      } : {
        ...g,
        editingStep: null
      };
    case "COMPLETE_EDIT":
      return {
        ...g,
        editingStep: null,
        editBackup: null
      };
    case "INITIALIZE_STATE":
      return I.payload;
    default:
      return g;
  }
};
function vJ() {
  const [g, I] = Yr(BJ, null, hJ), C = Ag(null), A = Ag(null), c = Ag(null), l = Ag(null), t = g.secondaryOptions[1] ?? Tg, i = g.secondaryOptions[2] ?? Tg, e = g.secondaryOptions[3] ?? Tg, n = tg(() => new Set(g.selectedGoals), [g.selectedGoals]), b = tg(() => new Set(g.selectedInterests.map((r) => r.id)), [g.selectedInterests]), a = tg(() => new Set(g.selectedSkills.map((r) => r.id)), [g.selectedSkills]), s = k(() => {
    I({
      type: "NEXT_STEP"
    }), setTimeout(() => {
      var r, h;
      (h = (r = [null, A, c, l][g.currentStep]) == null ? void 0 : r.current) == null || h.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }, 50);
  }, [g.currentStep]), d = k((r) => {
    const h = WJ(r);
    return I({
      type: "INITIALIZE_STATE",
      payload: h
    }), h;
  }, []), Z = tg(() => ({
    // Step 1: Goals
    handleGoalToggle: (r) => I({
      type: "TOGGLE_GOAL",
      goalId: r
    }),
    handleGoalSecondaryToggle: (r) => I({
      type: "TOGGLE_SECONDARY_OPTION",
      step: 1,
      optionId: r
    }),
    handleCustomInputCancel: () => I({
      type: "CANCEL_SECONDARY_CUSTOM_INPUT",
      step: 1
    }),
    handleCustomInputComplete: () => I({
      type: "COMPLETE_SECONDARY_CUSTOM_INPUT",
      step: 1
    }),
    setCustomInputValue: (r) => I({
      type: "SET_SECONDARY_CUSTOM_INPUT",
      step: 1,
      value: r
    }),
    // Step 2: Interests
    handleInterestToggle: (r) => I({
      type: "TOGGLE_INTEREST",
      interest: r
    }),
    handleInterestSecondaryToggle: (r) => I({
      type: "TOGGLE_SECONDARY_OPTION",
      step: 2,
      optionId: r
    }),
    handleInterestCustomInputCancel: () => I({
      type: "CANCEL_SECONDARY_CUSTOM_INPUT",
      step: 2
    }),
    handleInterestCustomInputComplete: () => I({
      type: "COMPLETE_SECONDARY_CUSTOM_INPUT",
      step: 2
    }),
    setInterestCustomInputValue: (r) => I({
      type: "SET_SECONDARY_CUSTOM_INPUT",
      step: 2,
      value: r
    }),
    // Step 3: Skills
    handleSkillToggle: (r) => I({
      type: "TOGGLE_SKILL",
      skill: r
    }),
    handleSkillSecondaryToggle: (r) => I({
      type: "TOGGLE_SECONDARY_OPTION",
      step: 3,
      optionId: r
    }),
    handleSkillCustomInputCancel: () => I({
      type: "CANCEL_SECONDARY_CUSTOM_INPUT",
      step: 3
    }),
    handleSkillCustomInputComplete: () => I({
      type: "COMPLETE_SECONDARY_CUSTOM_INPUT",
      step: 3
    }),
    setSkillCustomInputValue: (r) => I({
      type: "SET_SECONDARY_CUSTOM_INPUT",
      step: 3,
      value: r
    }),
    // Edit mode
    startEdit: (r) => I({
      type: "START_EDIT",
      step: r
    }),
    cancelEdit: () => I({
      type: "CANCEL_EDIT"
    }),
    completeEdit: () => I({
      type: "COMPLETE_EDIT"
    })
  }), []);
  return {
    // Navigation
    currentStep: g.currentStep,
    progress: RJ(g.currentStep),
    handleNextStep: s,
    isNextButtonDisabled: NJ(g),
    // Initialization
    initializeState: d,
    // Edit mode
    editingStep: g.editingStep,
    isEditing: g.editingStep !== null,
    // Refs
    scrollContainerRef: C,
    step2Ref: A,
    step3Ref: c,
    step4Ref: l,
    // Step 1: Goals
    selectedGoals: g.selectedGoals,
    showCustomInput: t.showCustomInput,
    customInputValue: t.customInputValue,
    hasGoalUnknown: t.hasUnknown,
    hasCustomSelection: t.customInputValue.trim() !== "",
    hasGoalCustomInputValue: t.customInputValue.trim() !== "",
    hasSelection: g.selectedGoals.length > 0,
    isSelected: (r) => n.has(r),
    buildUsagePurposeAnswers: () => xJ(g),
    ...Z,
    // Step 2: Interests
    selectedInterests: g.selectedInterests,
    showInterestCustomInput: i.showCustomInput,
    interestCustomInputValue: i.customInputValue,
    hasInterestUnknown: i.hasUnknown,
    hasInterestSelection: g.selectedInterests.length > 0,
    hasInterestCustomInputValue: i.customInputValue.trim() !== "",
    isInterestSelected: (r) => b.has(r),
    getSelectedInterestInfo: () => g.selectedInterests,
    buildCategoryAnswers: () => yJ(g),
    // Step 3: Skills
    selectedSkills: g.selectedSkills,
    showSkillCustomInput: e.showCustomInput,
    skillCustomInputValue: e.customInputValue,
    hasSkillUnknown: e.hasUnknown,
    hasSkillSelection: g.selectedSkills.length > 0,
    hasSkillCustomInputValue: e.customInputValue.trim() !== "",
    isSkillSelected: (r) => a.has(r),
    getSelectedSkillInfo: () => g.selectedSkills,
    buildSkillAnswers: () => pJ(g)
  };
}
const JJ = {
  // 온보딩 모달 관련 AB 테스트
  ONBOARDING_INTRO_ANIMATION: 98
}, ys = /* @__PURE__ */ new Set(), YJ = (g, I = !0, C = "A") => {
  const {
    decision: A,
    isLoading: c
  } = Tr(g), {
    trackEvent: l
  } = zd();
  return q(() => {
    I && (ys.has(g) || (A.reason === hn.TRAFFIC_ALLOCATED || A.reason === hn.OVERRIDDEN) && (l(Ug.EXPERIMENT_STARTED, {
      props: {
        "Experiment name": String(g),
        "Variant name": A.variation
      }
    }), ys.add(g)));
  }, [g, A, I]), I ? {
    decision: A,
    isLoading: c
  } : {
    decision: {
      ...A,
      variation: C
    },
    isLoading: c
  };
};
function FJ() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const zJ = vr(() => import("./FirstSignUpAnimation-98f7138f-d412b86d.mjs")), fJ = {
  content: {
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    maxHeight: "100%",
    borderRadius: 0,
    padding: 0
  },
  body: {
    padding: 0,
    height: "100%"
  },
  inner: {
    padding: "0 !important",
    position: "fixed",
    inset: 0
  }
};
function E3(g) {
  const {
    i18nInstance: I,
    isReady: C
  } = wN({
    lang: g.lang,
    isOpened: g.opened
  });
  return C ? /* @__PURE__ */ o(s0, { i18n: I, children: /* @__PURE__ */ o(wJ, { ...g }) }) : null;
}
var HJ = process.env.NODE_ENV === "production" ? {
  name: "1fttcpj",
  styles: "display:flex;flex-direction:column"
} : {
  name: "1m4tywv-OnboardingModalContent",
  styles: "display:flex;flex-direction:column;label:OnboardingModalContent;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: FJ
};
function wJ({
  lang: g,
  opened: I,
  onClose: C,
  onSkip: A,
  onSubmit: c,
  entryPoint: l = OA.POP_UP,
  initialView: t,
  isFirstSignUp: i = !1
}) {
  const e = qA(), {
    data: n,
    isLoading: b
  } = ze(), a = (n == null ? void 0 : n.name) ?? "", s = vJ(), {
    decision: {
      variation: d
    },
    isLoading: Z
  } = YJ(JJ.ONBOARDING_INTRO_ANIMATION, I && i), r = i && !Z && d === "A", {
    trackViewOnboardingRecommendationModal: h,
    trackRecommendationClose: x
  } = cA(), [u, G] = O("onboarding"), [V, X] = O(!1), [W, N] = O("hidden"), [m, p] = O(!1), [Y, v] = O(!1), [Q, cg] = O(!1), [z, J] = O(!1);
  q(() => {
    !I || !i || Z || N(d === "A" ? "hidden" : "greeting");
  }, [I, i, Z, d]);
  const {
    data: y,
    isLoading: f
  } = we({
    lang: g,
    options: {
      enabled: I
    }
  }), {
    data: B,
    isLoading: H
  } = Hd({
    options: {
      enabled: I
    }
  }), {
    data: F
  } = fd({
    lang: g,
    limit: 20,
    options: {
      enabled: s.currentStep === 4,
      staleTime: 1e3 * 60 * 5
    }
  }), E = Ag(!1), M = Ag(!1), _ = tg(() => {
    if (!y)
      return "not_started";
    const lg = y.usagePurposes && y.usagePurposes.length > 0, ig = y.categories && y.categories.length > 0, Ng = y.skillTags && y.skillTags.length > 0, ag = [lg, ig, Ng].filter(Boolean).length;
    return ag === 0 ? "not_started" : ag === 3 ? "completed" : "in_progress";
  }, [y]), j = tg(() => {
    if (!y)
      return 1;
    const lg = y.usagePurposes && y.usagePurposes.length > 0, ig = y.categories && y.categories.length > 0, Ng = y.skillTags && y.skillTags.length > 0;
    return lg && !ig ? 2 : lg && ig && !Ng ? 3 : lg && ig && Ng ? 4 : 1;
  }, [y]);
  q(() => {
    var lg, ig, Ng;
    if (I && y && !E.current) {
      if (H)
        return;
      E.current = !0;
      const ag = s.initializeState(y), Lg = ((lg = ag == null ? void 0 : ag.secondaryOptions[1]) == null ? void 0 : lg.customInputValue.trim()) !== "" || ((ig = ag == null ? void 0 : ag.secondaryOptions[2]) == null ? void 0 : ig.customInputValue.trim()) !== "" || ((Ng = ag == null ? void 0 : ag.secondaryOptions[3]) == null ? void 0 : Ng.customInputValue.trim()) !== "";
      t ? (G(t), X(!0)) : B != null && B.messages && B.messages.length > 0 || (ag == null ? void 0 : ag.currentStep) === 4 && Lg ? (G("llm"), X(!0)) : ag && ag.currentStep > 1 ? (X(!0), setTimeout(() => {
        var XI, MI;
        (MI = (XI = [null, null, s.step2Ref, s.step3Ref, s.step4Ref][ag.currentStep]) == null ? void 0 : XI.current) == null || MI.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, 100)) : X(!0);
    }
    I || (E.current = !1, X(!1), M.current = !1, G("onboarding"), p(!1), v(!1), cg(!1), J(!1));
  }, [I, y, B, H, s, t]), q(() => {
    var lg, ig, Ng;
    if (!I || !V || f || M.current || H || b)
      return;
    const ag = (() => {
      if (u === "llm") {
        const MI = (B == null ? void 0 : B.messages) ?? [], sc = MI.some((et) => et.isCourseRecommendation);
        return MI.length === 0 ? kC.BEFORE_CONVERSATION : sc ? kC.AFTER_RECOMMENDATION : kC.DURING_CONVERSATION;
      }
      return ["q1", "q2", "q3", "popular_courses"][j - 1] || null;
    })();
    if (!ag)
      return;
    const Lg = ag === "popular_courses" ? (lg = F == null ? void 0 : F.items) == null ? void 0 : lg.map((XI) => String(XI.course.id)) : (Ng = (ig = B == null ? void 0 : B.messages) == null ? void 0 : ig.pop()) == null ? void 0 : Ng.courses.map((XI) => String(XI.id));
    h({
      step: ag,
      entry_point: l,
      status: _,
      course_identification: Lg
    }), M.current = !0;
  }, [I, V, f, H, b, u, B, j, l, _, F, h]);
  const eg = k(() => {
    G("onboarding"), e.invalidateQueries({
      queryKey: Wl()
    }), e.invalidateQueries({
      queryKey: Se({
        lang: g
      })
    }), setTimeout(() => {
      var lg, ig;
      (ig = (lg = [null, null, s.step2Ref, s.step3Ref, s.step4Ref][s.currentStep]) == null ? void 0 : lg.current) == null || ig.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }, 100);
  }, [s.currentStep, s.step2Ref, s.step3Ref, s.step4Ref, e, g]), Wg = k((lg) => {
    x({
      step: lg,
      label: "나가기"
    }), A();
  }, [A, x]), Hg = tg(() => y != null && y.usagePurposes ? y.usagePurposes.filter((lg) => lg.type === "USAGE_PURPOSE" && lg.content).map((lg) => lg.content) : [], [y]), rI = tg(() => {
    const lg = Td(y);
    return {
      q1: ZI(y == null ? void 0 : y.usagePurposes, "content"),
      q2: ZI(y == null ? void 0 : y.categories, "slug"),
      q3: ZI(y == null ? void 0 : y.skillTags, "slug"),
      custom: lg
    };
  }, [y]);
  return /* @__PURE__ */ R(wg.Root, { opened: I, onClose: C, size: "lg", fullScreen: !0, styles: fJ, closeOnEscape: !1, closeOnClickOutside: !1, trapFocus: !1, children: [
    /* @__PURE__ */ o(wg.Overlay, { bg: "rgba(0, 0, 0, 0.75)", blur: 15 }),
    /* @__PURE__ */ R(wg.Content, { css: HJ, children: [
      i && W !== "hidden" && /* @__PURE__ */ o(Jr, { fallback: null, children: /* @__PURE__ */ o(zJ, { userName: a, introPhase: W, onGreetingComplete: () => N("fading"), onFadeComplete: () => N("hidden") }) }),
      I && !V ? /* @__PURE__ */ o(mJ, { initialStep: j }) : u === "onboarding" ? /* @__PURE__ */ o(uJ, { state: s, userName: a, isTypingVariant: r, introPhase: W, onSkip: A, onSubmit: () => {
        c == null || c();
      }, onEnterLlm: () => {
        e.invalidateQueries({
          queryKey: Wl()
        }), G("llm");
      }, showStep1Options: m, startLine2Animation: Y, startLine3Animation: Q, startLine4Animation: z, setStartLine2Animation: v, setStartLine3Animation: cg, setStartLine4Animation: J, setShowStep1Options: p, entryPoint: l }) : /* @__PURE__ */ o(Mv, { onBack: eg, onExit: Wg, userSelections: {
        goals: [...Hg, ...s.customInputValue.trim() ? [s.customInputValue.trim()] : []],
        interests: [...s.selectedInterests.map((lg) => lg.title), ...s.interestCustomInputValue.trim() ? [s.interestCustomInputValue.trim()] : []],
        skills: [...s.getSelectedSkillInfo().map((lg) => lg.title), ...s.skillCustomInputValue.trim() ? [s.skillCustomInputValue.trim()] : []]
      }, entryPoint: l, selectionLabels: rI })
    ] })
  ] });
}
var HG = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "language", A = 640, c = 512, l = [], t = "f1ab", i = "M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faLanguage = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(HG);
var wG = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "robot", A = 640, c = 512, l = [129302], t = "f544", i = "M320 0c17.7 0 32 14.3 32 32V96H472c39.8 0 72 32.2 72 72V440c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72H288V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM264 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faRobot = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(wG);
var SG = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "star", A = 576, c = 512, l = [11088, 61446], t = "f005", i = "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faStar = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(SG);
var TG = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "book-open-reader", A = 512, c = 512, l = ["book-reader"], t = "f5da", i = "M160 96a96 96 0 1 1 192 0A96 96 0 1 1 160 96zm80 152V512l-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427V224c0-17.7 14.3-32 32-32H62.3c63.6 0 125.6 19.6 177.7 56zm32 264V248c52.1-36.4 114.1-56 177.7-56H480c17.7 0 32 14.3 32 32V427c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faBookOpenReader = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(TG);
var LG = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "compass", A = 512, c = 512, l = [129517], t = "f14e", i = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faCompass = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(LG);
var UG = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "book-atlas", A = 448, c = 512, l = ["atlas"], t = "f558", i = "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM247.4 283.8c-3.7 3.7-6.2 4.2-7.4 4.2s-3.7-.5-7.4-4.2c-3.8-3.7-8-10-11.8-18.9c-6.2-14.5-10.8-34.3-12.2-56.9h63c-1.5 22.6-6 42.4-12.2 56.9c-3.8 8.9-8 15.2-11.8 18.9zm42.7-9.9c7.3-18.3 12-41.1 13.4-65.9h31.1c-4.7 27.9-21.4 51.7-44.5 65.9zm0-163.8c23.2 14.2 39.9 38 44.5 65.9H303.5c-1.4-24.7-6.1-47.5-13.4-65.9zM368 192a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM145.3 208h31.1c1.4 24.7 6.1 47.5 13.4 65.9c-23.2-14.2-39.9-38-44.5-65.9zm31.1-32H145.3c4.7-27.9 21.4-51.7 44.5-65.9c-7.3 18.3-12 41.1-13.4 65.9zm56.1-75.8c3.7-3.7 6.2-4.2 7.4-4.2s3.7 .5 7.4 4.2c3.8 3.7 8 10 11.8 18.9c6.2 14.5 10.8 34.3 12.2 56.9h-63c1.5-22.6 6-42.4 12.2-56.9c3.8-8.9 8-15.2 11.8-18.9z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faBookAtlas = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(UG);
var PG = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "palette", A = 512, c = 512, l = [127912], t = "f53f", i = "M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faPalette = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(PG);
var kG = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "microchip", A = 512, c = 512, l = [], t = "f2db", i = "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V176h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H176V24zM160 128H352c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm192 32H160V352H352V160z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faMicrochip = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(kG);
var DG = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "briefcase", A = 512, c = 512, l = [128188], t = "f0b1", i = "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faBriefcase = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(DG);
var OG = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "shield-check", A = 512, c = 512, l = [], t = "f2f7", i = "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faShieldCheck = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(OG);
var jG = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "microchip-ai", A = 512, c = 512, l = [], t = "e1ec", i = "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V176h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H176V24zm32 152c6.4 0 12.1 3.8 14.7 9.6l42 96 14 32c3.5 8.1-.1 17.5-8.2 21.1s-17.5-.2-21.1-8.2L239.5 304H176.5l-9.8 22.4c-3.5 8.1-13 11.8-21.1 8.2s-11.8-13-8.2-21.1l14-32 42-96c2.5-5.8 8.3-9.6 14.7-9.6zm17.5 96L208 231.9 190.5 272h35.1zM336 176c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faMicrochipAi = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(jG);
var EG = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "atom-simple", A = 512, c = 512, l = ["atom-alt"], t = "f5d3", i = "M100.9 411.1c-1.3-1.3-12.4-16.8 3.3-64c3.5-10.4 8-21.4 13.6-32.9c11.6 14.2 24.3 28.3 38 41.9s27.7 26.4 41.9 38c-11.4 5.6-22.4 10.2-32.8 13.6c-47.2 15.7-62.7 4.6-64 3.3zM153.7 256c13.5-18.3 29.3-36.8 47.4-54.9s36.6-33.9 54.9-47.4c18.3 13.5 36.8 29.3 54.9 47.4s33.9 36.6 47.4 54.9c-13.5 18.3-29.3 36.8-47.4 54.9s-36.6 33.9-54.9 47.4c-18.3-13.5-36.8-29.3-54.9-47.4s-33.9-36.6-47.4-54.9zm44.1-138.1c-14.2 11.6-28.3 24.3-41.9 38s-26.4 27.7-38 41.9c-5.6-11.4-10.2-22.4-13.6-32.8c-15.7-47.2-4.6-62.7-3.3-64s16.8-12.4 64 3.3c10.4 3.5 21.4 8 32.8 13.6zM256 76.8C173.9 27.6 94.9 16.5 55.7 55.7S27.6 173.9 76.8 256C27.6 338.1 16.5 417.1 55.7 456.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1s28.1-118.2-21.1-200.3c49.2-82.1 60.3-161.1 21.1-200.3S338.1 27.6 256 76.8zm58.2 41.1c11.4-5.6 22.4-10.2 32.9-13.6c47.2-15.7 62.7-4.6 64-3.3s12.4 16.8-3.3 64c-3.5 10.4-8 21.4-13.6 32.8c-11.6-14.2-24.3-28.3-38-41.9s-27.7-26.4-41.9-38zm79.9 196.3c5.6 11.4 10.2 22.4 13.6 32.9c15.7 47.2 4.6 62.7 3.3 64s-16.8 12.4-64-3.3c-10.4-3.5-21.4-8-32.9-13.6c14.2-11.6 28.3-24.3 41.9-38s26.4-27.7 38-41.9zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faAtomSimple = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(EG);
var QG = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "alien-8bit", A = 640, c = 512, l = [128126, "alien-monster"], t = "f8f6", i = "M128 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h48c8.8 0 16 7.2 16 16v48H384V80c0-8.8 7.2-16 16-16h48V48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H448v32 32h48c8.8 0 16 7.2 16 16v48h32V144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16H544v80c0 8.8-7.2 16-16 16H480v80c0 8.8-7.2 16-16 16H416 368c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16h48V384H224v32h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224 176c-8.8 0-16-7.2-16-16V384H112c-8.8 0-16-7.2-16-16V288H48c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v80h32V176c0-8.8 7.2-16 16-16h48V128 96H144c-8.8 0-16-7.2-16-16V48zm64 192v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm192 0v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faAlien8bit = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(QG);
var MG = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "computer-classic", A = 448, c = 512, l = [], t = "f8b1", i = "M0 48C0 21.5 21.5 0 48 0H400c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48zM32 480V448H416v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zM96 64C78.3 64 64 78.3 64 96V224c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96zM80 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm144-24c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faComputerClassic = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(MG);
var KG = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "layer-group", A = 576, c = 512, l = [], t = "f5fd", i = "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faLayerGroup = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(KG);
var _G = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "far", C = "language", A = 640, c = 512, l = [], t = "f1ab", i = "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H272h32 16H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H320 304 272 64zm512 48c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H320V112H576zM178.3 175.9l64 144c4.5 10.1-.1 21.9-10.2 26.4s-21.9-.1-26.4-10.2L196.8 316H123.2l-8.9 20.1c-4.5 10.1-16.3 14.6-26.4 10.2s-14.6-16.3-10.2-26.4l64-144c3.2-7.2 10.4-11.9 18.3-11.9s15.1 4.7 18.3 11.9zM179 276l-19-42.8L141 276h38zM456 164c-11 0-20 9-20 20v4H384c-11 0-20 9-20 20s9 20 20 20h72 35.1c-7.3 16.7-17.4 31.9-29.8 45l-.5-.5-14.6-14.6c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3L430 298.3c-5.9 3.6-12.1 6.9-18.5 9.8l-3.6 1.6c-10.1 4.5-14.6 16.3-10.2 26.4s16.3 14.6 26.4 10.2l3.6-1.6c12-5.3 23.4-11.8 34-19.4c4.3 3 8.6 5.8 13.1 8.5l18.9 11.3c9.5 5.7 21.8 2.6 27.4-6.9s2.6-21.8-6.9-27.4l-18.9-11.3c-.9-.5-1.8-1.1-2.7-1.6c17.2-18.8 30.7-40.9 39.6-65.4L534 228h2c11 0 20-9 20-20s-9-20-20-20H520 476v-4c0-11-9-20-20-20z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faLanguage = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(_G);
var qG = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "far", C = "robot", A = 640, c = 512, l = [129302], t = "f544", i = "M320 0c13.3 0 24 10.7 24 24V96H448c53 0 96 43 96 96V416c0 53-43 96-96 96H192c-53 0-96-43-96-96V192c0-53 43-96 96-96H296V24c0-13.3 10.7-24 24-24zM192 144c-26.5 0-48 21.5-48 48V416c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V192c0-26.5-21.5-48-48-48H320 192zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16zM208 384h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16zM200 256a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm200-40a40 40 0 1 1 0 80 40 40 0 1 1 0-80z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faRobot = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(qG);
var $G = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = oe;
  g.definition = {
    prefix: I.prefix,
    iconName: I.iconName,
    icon: [
      I.width,
      I.height,
      I.aliases,
      I.unicode,
      I.svgPathData
    ]
  }, g.faSearch = g.definition, g.prefix = I.prefix, g.iconName = I.iconName, g.width = I.width, g.height = I.height, g.ligatures = I.aliases, g.unicode = I.unicode, g.svgPathData = I.svgPathData, g.aliases = I.aliases;
})($G);
var gr = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "far", C = "star", A = 576, c = 512, l = [11088, 61446], t = "f005", i = "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.6 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faStar = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(gr);
var Ir = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "far", C = "book-open-reader", A = 512, c = 512, l = ["book-reader"], t = "f5da", i = "M256 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 0a96 96 0 1 1 0 192A96 96 0 1 1 256 0zM228 279l-.2-.1c-.7-.5-2.4-1.5-5.2-2.9c-5.5-2.8-15.4-7.3-30.6-12.2c-28-9-74.2-19.3-144-22.7V417.4c84.9 5 147.1 22.3 184 35.7V282l-4-3zm52 3V453.1c36.9-13.4 99.1-30.7 184-35.7V241.1c-69.9 3.4-116 13.7-144 22.7c-15.1 4.9-25 9.4-30.6 12.2c-2.8 1.4-4.5 2.4-5.2 2.9l-.2 .1-4 3zM32 192.5C199.2 197.4 256 240 256 240s56.8-42.6 224-47.5c17.7-.5 32 13.9 32 31.5V432c0 17.7-14.4 31.9-32 32.7c-114.9 4.7-186.9 33.7-208.8 43.8c-4.8 2.2-9.9 3.5-15.1 3.5s-10.4-1.3-15.1-3.5c-21.9-10.1-93.9-39.1-208.8-43.8c-17.7-.7-32-15-32-32.7V224c0-17.7 14.4-32.1 32-31.5z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faBookOpenReader = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(Ir);
var Cr = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "far", C = "compass", A = 512, c = 512, l = [129517], t = "f14e", i = "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm306.7 69.1L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faCompass = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(Cr);
var Ar = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "far", C = "book-atlas", A = 448, c = 512, l = ["atlas"], t = "f558", i = "M0 88C0 39.4 39.4 0 88 0H392c30.9 0 56 25.1 56 56V344c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H392c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88C65.9 48 48 65.9 48 88V358.7zM176.5 216h-31c4.8 26.1 21.1 48.2 43.5 60.8c-6.6-16.9-11-37.8-12.5-60.8zm0-32c1.4-22.9 5.9-43.8 12.5-60.8c-22.4 12.6-38.7 34.7-43.5 60.8h31zM112 200a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zm206.5 16h-31c-1.4 22.9-5.9 43.8-12.5 60.8c22.4-12.6 38.7-34.7 43.5-60.8zM275 123.2c6.6 16.9 11 37.8 12.5 60.8h31c-4.8-26.1-21.1-48.2-43.5-60.8zM255.4 216H208.6c1.6 22.6 6.5 41.8 12.8 55.3c4.7 10.1 8.6 14.2 10.6 15.8c2-1.6 5.9-5.7 10.6-15.8c6.3-13.5 11.2-32.7 12.8-55.3zm-46.9-32h46.9c-1.6-22.6-6.5-41.8-12.8-55.3c-4.7-10.1-8.6-14.2-10.6-15.8c-2 1.6-5.9 5.7-10.6 15.8c-6.3 13.5-11.2 32.7-12.8 55.3z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faBookAtlas = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(Ar);
var cr = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "far", C = "palette", A = 512, c = 512, l = [127912], t = "f53f", i = "M464 258.2c0 2.7-1 5.2-4.2 8c-3.8 3.1-10.1 5.8-17.8 5.8H344c-53 0-96 43-96 96c0 6.8 .7 13.4 2.1 19.8c3.3 15.7 10.2 31.1 14.4 40.6l0 0c.7 1.6 1.4 3 1.9 4.3c5 11.5 5.6 15.4 5.6 17.1c0 5.3-1.9 9.5-3.8 11.8c-.9 1.1-1.6 1.6-2 1.8c-.3 .2-.8 .3-1.6 .4c-2.9 .1-5.7 .2-8.6 .2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 .7 0 1.4 0 2.2zm48 .5c0-.9 0-1.8 0-2.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c3.5 0 7.1-.1 10.6-.2c31.8-1.3 53.4-30.1 53.4-62c0-14.5-6.1-28.3-12.1-42c-4.3-9.8-8.7-19.7-10.8-29.9c-.7-3.2-1-6.5-1-9.9c0-26.5 21.5-48 48-48h97.9c36.5 0 69.7-24.8 70.1-61.3zM160 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faPalette = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(cr);
var lr = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "far", C = "microchip", A = 512, c = 512, l = [], t = "f2db", i = "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64h-8c-35.3 0-64 28.7-64 64v8H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v8c0 35.3 28.7 64 64 64h8v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h48v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h48v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h8c35.3 0 64-28.7 64-64v-8h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V184h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448v-8c0-35.3-28.7-64-64-64h-8V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H184V24zM400 128V384c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16zM192 160c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H192zm16 48h96v96H208V208z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faMicrochip = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(lr);
var tr = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "far", C = "briefcase", A = 512, c = 512, l = [128188], t = "f0b1", i = "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96h64c35.3 0 64 28.7 64 64V280 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V280 160c0-35.3 28.7-64 64-64h64zM48 304V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V304H320v16c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V304H48zm144-48H320 464V160c0-8.8-7.2-16-16-16H360 152 64c-8.8 0-16 7.2-16 16v96H192z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faBriefcase = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(tr);
var ir = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "far", C = "shield-check", A = 512, c = 512, l = [], t = "f2f7", i = "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faShieldCheck = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(ir);
var er = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "far", C = "microchip-ai", A = 512, c = 512, l = [], t = "e1ec", i = "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64h-8c-35.3 0-64 28.7-64 64v8H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v8c0 35.3 28.7 64 64 64h8v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h48v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h48v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h8c35.3 0 64-28.7 64-64v-8h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V184h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448v-8c0-35.3-28.7-64-64-64h-8V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H184V24zM112 128c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V128zm224 44c-11 0-20 9-20 20V320c0 11 9 20 20 20s20-9 20-20V192c0-11-9-20-20-20zM234.3 184c-3.2-7.3-10.4-12-18.3-12s-15.1 4.7-18.3 12l-56 128c-4.4 10.1 .2 21.9 10.3 26.3s21.9-.2 26.3-10.3l5.3-12h64.8l5.3 12c4.4 10.1 16.2 14.7 26.3 10.3s14.7-16.2 10.3-26.3l-56-128zM216 241.9L230.9 276H201.1L216 241.9z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faMicrochipAi = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(er);
var nr = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "far", C = "atom-simple", A = 512, c = 512, l = ["atom-alt"], t = "f5d3", i = "M89.6 422.4c7.9 7.9 31.4 16.9 80.4 .6c13.2-4.4 27.2-10.4 41.6-17.9c-18.9-14.4-37.7-30.8-55.8-48.9s-34.5-36.9-48.9-55.8c-7.5 14.4-13.5 28.4-17.9 41.6c-16.3 49-7.3 72.5 .6 80.4zM76.8 256C27.6 173.9 16.5 94.9 55.7 55.7S173.9 27.6 256 76.8c82.1-49.2 161.1-60.3 200.3-21.1s28.1 118.2-21.1 200.3c49.2 82.1 60.3 161.1 21.1 200.3s-118.2 28.1-200.3-21.1c-82.1 49.2-161.1 60.3-200.3 21.1S27.6 338.1 76.8 256zM107 211.6c14.4-18.9 30.8-37.7 48.9-55.8s36.9-34.5 55.8-48.9c-14.4-7.5-28.4-13.5-41.6-17.9c-49-16.3-72.5-7.3-80.4 .6s-16.9 31.4-.6 80.4c4.4 13.2 10.4 27.2 17.9 41.6zM256 134c-22.1 15.5-44.5 34.1-66.2 55.8s-40.3 44.1-55.8 66.2c15.5 22.1 34.1 44.5 55.8 66.2s44.1 40.3 66.2 55.8c22.1-15.5 44.5-34.1 66.2-55.8s40.3-44.1 55.8-66.2c-15.5-22.1-34.1-44.5-55.8-66.2s-44.1-40.3-66.2-55.8zm149 77.7c7.5-14.4 13.5-28.4 17.9-41.6c16.3-49 7.3-72.5-.6-80.4s-31.4-16.9-80.4-.6c-13.2 4.4-27.2 10.4-41.6 17.9c18.9 14.4 37.7 30.8 55.8 48.9s34.5 36.9 48.9 55.8zm0 88.7c-14.4 18.9-30.8 37.7-48.9 55.8s-36.9 34.5-55.8 48.9c14.4 7.5 28.4 13.5 41.6 17.9c49 16.3 72.5 7.3 80.4-.6s16.9-31.4 .6-80.4c-4.4-13.2-10.4-27.2-17.9-41.6zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faAtomSimple = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(nr);
var br = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "far", C = "alien-8bit", A = 640, c = 512, l = [128126, "alien-monster"], t = "f8f6", i = "M152 32c13.3 0 24 10.7 24 24h24c13.3 0 24 10.7 24 24v48H416V80c0-13.3 10.7-24 24-24h24c0-13.3 10.7-24 24-24s24 10.7 24 24V80c0 13.3-10.7 24-24 24H464v48 8h24c13.3 0 24 10.7 24 24v56h8 40V152c0-13.3 10.7-24 24-24s24 10.7 24 24V264c0 13.3-10.7 24-24 24H544v72c0 13.3-10.7 24-24 24H480v72c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h56V384H208v48h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V384H120c-13.3 0-24-10.7-24-24V288H56c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24v88h40 8V184c0-13.3 10.7-24 24-24h24v-8V104H152c-13.3 0-24-10.7-24-24V56c0-13.3 10.7-24 24-24zm72 144v8c0 13.3-10.7 24-24 24H176v56c0 13.3-10.7 24-24 24h-8v48h40H456h40V288h-8c-13.3 0-24-10.7-24-24V208H440c-13.3 0-24-10.7-24-24v-8H224zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V240zm144-16h32c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faAlien8bit = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(br);
var ar = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "far", C = "computer-classic", A = 448, c = 512, l = [], t = "f8b1", i = "M384 48c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H384zM64 0C28.7 0 0 28.7 0 64V368c0 23.7 12.9 44.4 32 55.4V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V423.4c19.1-11.1 32-31.7 32-55.4V64c0-35.3-28.7-64-64-64H64zM80 432H368v32H80V432zm0-320v96c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V112c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32zM208 320c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm-88 32a24 24 0 1 0 0-48 24 24 0 1 0 0 48z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faComputerClassic = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(ar);
var sr = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "far", C = "layer-group", A = 576, c = 512, l = [], t = "f5fd", i = "M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faLayerGroup = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(sr);
function SJ() {
  vW.add(
    sr.faLayerGroup,
    // 전체 강의
    ar.faComputerClassic,
    // 프로그래밍
    br.faAlien8bit,
    // 게임 개발
    nr.faAtomSimple,
    // 데이터 사이언스
    er.faMicrochipAi,
    // 인공지능
    ir.faShieldCheck,
    // 보안 네트워크
    tr.faBriefcase,
    // 비지니스 마케팅
    lr.faMicrochip,
    // 하드웨어
    cr.faPalette,
    // 디자인
    Ar.faBookAtlas,
    // 학문 외국어
    Cr.faCompass,
    // 커리어
    Ir.faBookOpenReader,
    // 자기 계발
    gr.faStar,
    // 마이 카테고리
    $G.faSearch,
    // 검색
    qG.faRobot,
    // AI 활용
    _G.faLanguage,
    // 언어 선택
    //
    KG.faLayerGroup,
    // 전체 강의 솔리드
    MG.faComputerClassic,
    // 프로그래밍 솔리드
    QG.faAlien8bit,
    // 게임 개발 솔리드
    EG.faAtomSimple,
    // 데이터 사이언스 솔리드
    jG.faMicrochipAi,
    // 인공지능 솔리드
    OG.faShieldCheck,
    // 보안 네트워크 솔리드
    DG.faBriefcase,
    // 비지니스 마케팅 솔리드
    kG.faMicrochip,
    // 하드웨어 솔리드
    PG.faPalette,
    // 디자인 솔리드
    UG.faBookAtlas,
    // 학문 외국어 솔리드
    LG.faCompass,
    // 커리어 솔리드
    TG.faBookOpenReader,
    // 자기 계발 솔리드
    SG.faStar,
    // 마이 카테고리 솔리드
    gc.faSearch,
    // 검색 솔리드
    wG.faRobot,
    // AI 활용 솔리드
    HG.faLanguage
    // 언어 선택 솔리드
  );
}
const Ot = {
  ONBOARDING_NO_SHOW: {
    expireDay: 30,
    KEY: (g) => `onboarding_no_show_${g}`,
    DOMAIN: du
  }
}, ac = S0, ur = {
  CLIENT_V1_COURSE_CATEGORY: "/client/api/v1/course-category",
  CLIENT_V1_MY_CATEGORY: "/client/api/v1/my-category",
  CLIENT_V1_NOTICE_USER_DISCOUNT: "/client/api/v1/notice/user-discount",
  CLIENT_V1_USER_SEGMENTS: "/client/api/v1/user-segments",
  CLIENT_V1_USER_ONBOARDINGS_STATUS: "/client/api/v1/user-onboardings/status"
}, TJ = async (g, I) => ac.get(g, I), LJ = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => TJ(I, A),
  ...C
});
function Q3(g) {
  var C;
  const I = ug(LJ(g));
  return {
    ...I,
    data: (C = I.data) == null ? void 0 : C.data
  };
}
const UJ = async (g, I) => ac.get(g, I), PJ = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => UJ(I, A),
  ...C
});
function M3(g) {
  var C;
  const I = ug(PJ(g));
  return {
    ...I,
    data: (C = I.data) == null ? void 0 : C.data
  };
}
const kJ = async (g, I) => ac.get(g, I), DJ = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => kJ(I, A),
  ...C
});
function K3(g) {
  var C;
  const I = ug(DJ(g));
  return {
    ...I,
    data: (C = I.data) == null ? void 0 : C.data
  };
}
const OJ = async (g, I) => ac.get(g, I), jJ = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => OJ(I, A),
  ...C
});
function _3(g) {
  var C;
  const I = ug(jJ(g));
  return {
    ...I,
    data: (C = I.data) == null ? void 0 : C.data
  };
}
const EJ = async (g, I) => ac.get(g, I), QJ = ({
  queryKey: g,
  url: I,
  options: C,
  requestOptions: A
}) => ({
  queryKey: g,
  queryFn: () => EJ(I, A),
  ...C
});
function MJ(g) {
  var C;
  const I = ug(QJ(g));
  return {
    ...I,
    data: (C = I.data) == null ? void 0 : C.data
  };
}
function KJ({
  options: g
}) {
  return MJ({
    queryKey: _J(),
    url: ur.CLIENT_V1_USER_ONBOARDINGS_STATUS,
    options: {
      ...g,
      suspense: !1,
      useErrorBoundary: !1
    }
  });
}
const _J = () => [ur.CLIENT_V1_USER_ONBOARDINGS_STATUS];
function qJ(g, I) {
  return Q1({
    queryKey: $J(g),
    url: tI.stringifyUrl({
      url: Dl.CLIENT_V1_CATEGORY_MAIN,
      query: {
        lang: g
      }
    }),
    options: {
      ...I,
      suspense: !1,
      useErrorBoundary: !1
    }
  });
}
const $J = (g) => [Dl.CLIENT_V1_CATEGORY_MAIN, g];
function lt() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
SJ();
var g5 = process.env.NODE_ENV === "production" ? {
  name: "y32cdx",
  styles: "position:relative;width:100%;border-radius:16px;background:linear-gradient(90deg, #0CB6A1 0%, #10B1D6 50%, #6D79EA 100%);padding:1px"
} : {
  name: "11xv4ng-OnboardingButton",
  styles: "position:relative;width:100%;border-radius:16px;background:linear-gradient(90deg, #0CB6A1 0%, #10B1D6 50%, #6D79EA 100%);padding:1px;label:OnboardingButton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: lt
}, I5 = process.env.NODE_ENV === "production" ? {
  name: "pk9l6n",
  styles: "border-radius:16px;border:none;background:#FFFFFF;background-image:linear-gradient(93.46deg, rgba(237, 224, 255, 0.3) 0%, rgba(196, 223, 255, 0.3) 31.56%, rgba(192, 243, 244, 0.3) 83.21%, rgba(198, 250, 234, 0.3) 100%);cursor:pointer;transition:all 0.2s ease;&:hover{opacity:0.9;}"
} : {
  name: "1qw22hk-OnboardingButton",
  styles: "border-radius:16px;border:none;background:#FFFFFF;background-image:linear-gradient(93.46deg, rgba(237, 224, 255, 0.3) 0%, rgba(196, 223, 255, 0.3) 31.56%, rgba(192, 243, 244, 0.3) 83.21%, rgba(198, 250, 234, 0.3) 100%);cursor:pointer;transition:all 0.2s ease;&:hover{opacity:0.9;};label:OnboardingButton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: lt
}, C5 = process.env.NODE_ENV === "production" ? {
  name: "12yvrxs",
  styles: "display:inline-flex;align-items:center;gap:2px"
} : {
  name: "11xq059-OnboardingButton",
  styles: "display:inline-flex;align-items:center;gap:2px;label:OnboardingButton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvU2VhcmNoQmFyL0FwcFNoZWxsSW5wdXRFeHBsb3JlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnSFkiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL2NvbXBvbmVudHMvbmV4dC9TZWFyY2hCYXIvQXBwU2hlbGxJbnB1dEV4cGxvcmUudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgQm94LCBDT0xPUl9QQUxFVFRFLCBHcmlkLCBHcm91cCwgSWNvbiwgU3RhY2ssIFRleHQsIFRpdGxlIH0gZnJvbSAnQGluZmxlYXJuL2RzLXJlYWN0JztcbmltcG9ydCB7IGZpbmRJY29uRGVmaW5pdGlvbiwgdHlwZSBJY29uTmFtZSB9IGZyb20gJ0BpbmZsZWFybi9mb250YXdlc29tZS1zdmctY29yZSc7XG5pbXBvcnQgeyB1c2VMYW5nIH0gZnJvbSAnQGluZmxlYXJuL2kxOG4tdG9vbHMnO1xuaW1wb3J0IHsgdXNlT25ib2FyZGluZ0NvbnRleHQgfSBmcm9tICdAaW5mbGVhcm4vbW9kYWxzL09uYm9hcmRpbmdNb2RhbCc7XG5pbXBvcnQgQ29va2llcyBmcm9tICdqcy1jb29raWUnO1xuaW1wb3J0IHsgdXNlRWZmZWN0LCB1c2VJZCwgdXNlUmVmLCB1c2VTdGF0ZSB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgc2V0SWNvbnMgfSBmcm9tICcuL3NldEljb25zJztcbmltcG9ydCB0eXBlIHsgRmluZFBhcmVudENhdGVnb3J5UmVzcG9uc2UgfSBmcm9tICcuLi8uLi8uLi9AdHlwZXMvY291cnNlU2NoZW1hJztcbmltcG9ydCB7IGV2ZW50TmFtZXMgfSBmcm9tICcuLi8uLi8uLi9jb25zdGFudHMvZ3RtRXZlbnROYW1lcyc7XG5pbXBvcnQgeyBDT09LSUVfU1RPUkFHRSB9IGZyb20gJy4uLy4uLy4uL2NvbnN0YW50cy9zdG9yYWdlJztcbmltcG9ydCB7IFNFUlZJQ0VfVVJMIH0gZnJvbSAnLi4vLi4vLi4vY29uc3RhbnRzL3VybHMnO1xuaW1wb3J0IHsgdXNlVXNlck9uYm9hcmRpbmdzU3RhdHVzUXVlcnkgfSBmcm9tICcuLi8uLi8uLi9ob29rcy9xdWVyaWVzL3VzZVVzZXJPbmJvYXJkaW5nc1N0YXR1c1F1ZXJ5JztcbmltcG9ydCB1c2VDYXRlZ29yeU1haW5RdWVyeSBmcm9tICcuLi8uLi8uLi9ob29rcy9xdWVyeS91c2VDYXRlZ29yeU1haW5RdWVyeSc7XG5pbXBvcnQgeyB1c2VBcHBTaGVsbFRyYW5zbGF0aW9uIH0gZnJvbSAnLi4vLi4vLi4vaG9va3MvdXNlQXBwU2hlbGxUcmFuc2xhdGlvbic7XG5pbXBvcnQgeyB1c2VUcmFja0V2ZW50IH0gZnJvbSAnLi4vLi4vLi4vdXRpbHMvdXNlVHJhY2tFdmVudCc7XG5pbXBvcnQgeyB1c2VSb3V0ZXJDb250ZXh0IH0gZnJvbSAnLi4vLi4vUm91dGVyL1JvdXRlclByb3ZpZGVyJztcbmltcG9ydCB7IEVYUExPUkVfSVRFTV9DTEFTU19OQU1FIH0gZnJvbSAnLi4vSGVhZGVyL2NvbnN0YW50cyc7XG5pbXBvcnQgeyBUQUJfSU5ERVggfSBmcm9tICcuLi9IZWFkZXIvY29uc3RhbnRzL3RhYkluZGV4JztcbmltcG9ydCB7IHVzZVByb2ZpbGVDb250ZXh0IH0gZnJvbSAnLi4vSGVhZGVyL3VzZVByb2ZpbGVDb250ZXh0Jztcblxuc2V0SWNvbnMoKTtcblxuY29uc3QgT25ib2FyZGluZ0J1dHRvbiA9ICh7XG4gIG9uQ2xvc2VQb3BvdmVyLFxuICBpc09uYm9hcmRpbmdDb21wbGV0ZWQsXG59OiB7XG4gIG9uQ2xvc2VQb3BvdmVyOiAoKSA9PiB2b2lkO1xuICBpc09uYm9hcmRpbmdDb21wbGV0ZWQ6IGJvb2xlYW47XG59KSA9PiB7XG4gIGNvbnN0IHsgdCB9ID0gdXNlQXBwU2hlbGxUcmFuc2xhdGlvbigpO1xuICBjb25zdCB7IG9wZW5Nb2RhbCB9ID0gdXNlT25ib2FyZGluZ0NvbnRleHQoKTtcbiAgY29uc3QgeyB0cmFja0V2ZW50IH0gPSB1c2VUcmFja0V2ZW50KCk7XG4gIGNvbnN0IHsgcHJvZmlsZSB9ID0gdXNlUHJvZmlsZUNvbnRleHQoKTtcbiAgY29uc3QgZ3JhZGllbnRJZCA9IGBncmFkaWVudC0ke3VzZUlkKCl9YDtcblxuICBjb25zdCBnZXRSZWRpcmVjdFRvID0gKCk6IHN0cmluZyB8IHVuZGVmaW5lZCA9PiB7XG4gICAgaWYgKHR5cGVvZiB3aW5kb3cgPT09ICd1bmRlZmluZWQnIHx8ICF3aW5kb3cubG9jYXRpb24pIHJldHVybiB1bmRlZmluZWQ7XG4gICAgY29uc3Qgbm9ybWFsaXplZFBhdGhuYW1lID0gd2luZG93LmxvY2F0aW9uLnBhdGhuYW1lLnJlcGxhY2UoL15cXC8oa298ZW58amF8dmkpKFxcL3wkKS8sICcvJyk7XG4gICAgY29uc3Qgc2hvdWxkUmVkaXJlY3QgPSBub3JtYWxpemVkUGF0aG5hbWUgIT09ICcvJyAmJiBub3JtYWxpemVkUGF0aG5hbWUgIT09ICcvY291cnNlcyc7XG5cbiAgICByZXR1cm4gc2hvdWxkUmVkaXJlY3QgPyB3aW5kb3cubG9jYXRpb24uaHJlZiA6IHVuZGVmaW5lZDtcbiAgfTtcblxuICBjb25zdCBoYW5kbGVDbGljayA9IChlOiBSZWFjdC5Nb3VzZUV2ZW50KSA9PiB7XG4gICAgZS5wcmV2ZW50RGVmYXVsdCgpO1xuICAgIGUuc3RvcFByb3BhZ2F0aW9uKCk7XG4gICAgdm9pZCB0cmFja0V2ZW50KGV2ZW50TmFtZXMuQ0xJQ0tfUkVDT01NRU5EQVRJT05fQVRfU0VBUkNIQkFSKTtcblxuICAgIC8vIOyCrOyaqeyekCBJROqwgCDsnojsnLzrqbQgb25ib2FyZGluZ19ub19zaG93X3t1c2VySWR9IOy/oO2CpOulvCBmYWxzZeuhnCDshKTsoJVcbiAgICBpZiAocHJvZmlsZT8uaWQpIHtcbiAgICAgIENvb2tpZXMuc2V0KENPT0tJRV9TVE9SQUdFLk9OQk9BUkRJTkdfTk9fU0hPVy5LRVkocHJvZmlsZS5pZCksICdmYWxzZScsIHtcbiAgICAgICAgZXhwaXJlczogQ09PS0lFX1NUT1JBR0UuT05CT0FSRElOR19OT19TSE9XLmV4cGlyZURheSxcbiAgICAgICAgZG9tYWluOiBDT09LSUVfU1RPUkFHRS5PTkJPQVJESU5HX05PX1NIT1cuRE9NQUlOLFxuICAgICAgfSk7XG4gICAgfVxuXG4gICAgb3Blbk1vZGFsKHtcbiAgICAgIGVudHJ5UG9pbnQ6ICdzZWFyY2hiYXInLFxuICAgICAgaXNGaXJzdFNpZ25VcDogZmFsc2UsXG4gICAgICByZWRpcmVjdFRvOiBnZXRSZWRpcmVjdFRvKCksXG4gICAgfSk7XG5cbiAgICBvbkNsb3NlUG9wb3ZlcigpO1xuICB9O1xuXG4gIHJldHVybiAoXG4gICAgPEJveFxuICAgICAgY3NzPXt7XG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICB3aWR0aDogJzEwMCUnLFxuICAgICAgICBib3JkZXJSYWRpdXM6IDE2LFxuICAgICAgICBiYWNrZ3JvdW5kOiAnbGluZWFyLWdyYWRpZW50KDkwZGVnLCAjMENCNkExIDAlLCAjMTBCMUQ2IDUwJSwgIzZENzlFQSAxMDAlKScsXG4gICAgICAgIHBhZGRpbmc6IDEsXG4gICAgICB9fT5cbiAgICAgIDxHcm91cFxuICAgICAgICB0YWJJbmRleD17VEFCX0lOREVYLkVYUExPUkVfSVRFTX1cbiAgICAgICAgY29tcG9uZW50PVwiYnV0dG9uXCJcbiAgICAgICAgb25DbGljaz17aGFuZGxlQ2xpY2t9XG4gICAgICAgIHBvc2l0aW9uPVwiYXBhcnRcIlxuICAgICAgICB3PVwiMTAwJVwiXG4gICAgICAgIHB4PXsyMH1cbiAgICAgICAgcHk9ezEyfVxuICAgICAgICBub1dyYXBcbiAgICAgICAgY3NzPXt7XG4gICAgICAgICAgYm9yZGVyUmFkaXVzOiAxNixcbiAgICAgICAgICBib3JkZXI6ICdub25lJyxcbiAgICAgICAgICBiYWNrZ3JvdW5kOiAnI0ZGRkZGRicsXG4gICAgICAgICAgYmFja2dyb3VuZEltYWdlOlxuICAgICAgICAgICAgJ2xpbmVhci1ncmFkaWVudCg5My40NmRlZywgcmdiYSgyMzcsIDIyNCwgMjU1LCAwLjMpIDAlLCByZ2JhKDE5NiwgMjIzLCAyNTUsIDAuMykgMzEuNTYlLCByZ2JhKDE5MiwgMjQzLCAyNDQsIDAuMykgODMuMjElLCByZ2JhKDE5OCwgMjUwLCAyMzQsIDAuMykgMTAwJSknLFxuICAgICAgICAgIGN1cnNvcjogJ3BvaW50ZXInLFxuICAgICAgICAgIHRyYW5zaXRpb246ICdhbGwgMC4ycyBlYXNlJyxcbiAgICAgICAgICAnJjpob3Zlcic6IHsgb3BhY2l0eTogMC45IH0sXG4gICAgICAgIH19PlxuICAgICAgICA8R3JvdXAgc3BhY2luZz17MTB9IG5vV3JhcD5cbiAgICAgICAgICA8c3ZnIHdpZHRoPVwiMTZcIiBoZWlnaHQ9XCIxNlwiIHZpZXdCb3g9XCIwIDAgNTEyIDUxMlwiIHN0eWxlPXt7IGZsZXhTaHJpbms6IDAgfX0+XG4gICAgICAgICAgICA8ZGVmcz5cbiAgICAgICAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPXtncmFkaWVudElkfSB4MT1cIjAlXCIgeTE9XCIwJVwiIHgyPVwiMTAwJVwiIHkyPVwiMCVcIj5cbiAgICAgICAgICAgICAgICA8c3RvcCBvZmZzZXQ9XCIwJVwiIHN0b3BDb2xvcj1cIiMwQ0I2QTFcIiAvPlxuICAgICAgICAgICAgICAgIDxzdG9wIG9mZnNldD1cIjUwJVwiIHN0b3BDb2xvcj1cIiMxMEIxRDZcIiAvPlxuICAgICAgICAgICAgICAgIDxzdG9wIG9mZnNldD1cIjEwMCVcIiBzdG9wQ29sb3I9XCIjNkQ3OUVBXCIgLz5cbiAgICAgICAgICAgICAgPC9saW5lYXJHcmFkaWVudD5cbiAgICAgICAgICAgIDwvZGVmcz5cbiAgICAgICAgICAgIDxwYXRoXG4gICAgICAgICAgICAgIGZpbGw9e2B1cmwoIyR7Z3JhZGllbnRJZH0pYH1cbiAgICAgICAgICAgICAgZD1cIk00MTYgMjA4YzAgNDUuOS0xNC45IDg4LjMtNDAgMTIyLjdMNTAyLjYgNDU3LjRjMTIuNSAxMi41IDEyLjUgMzIuOCAwIDQ1LjNzLTMyLjggMTIuNS00NS4zIDBMMzMwLjcgMzc2Yy0zNC40IDI1LjItNzYuOCA0MC0xMjIuNyA0MEM5My4xIDQxNiAwIDMyMi45IDAgMjA4UzkzLjEgMCAyMDggMFM0MTYgOTMuMSA0MTYgMjA4ek0yMDggMzUyYTE0NCAxNDQgMCAxIDAgMC0yODggMTQ0IDE0NCAwIDEgMCAwIDI4OHpcIlxuICAgICAgICAgICAgLz5cbiAgICAgICAgICA8L3N2Zz5cbiAgICAgICAgICA8VGV4dFxuICAgICAgICAgICAgc2l6ZT1cIm1kXCJcbiAgICAgICAgICAgIGxoPVwiMS41XCJcbiAgICAgICAgICAgIGZ3PXs2MDB9XG4gICAgICAgICAgICBjc3M9e3sgZGlzcGxheTogJ2lubGluZS1mbGV4JywgYWxpZ25JdGVtczogJ2NlbnRlcicsIGdhcDogMiB9fT5cbiAgICAgICAgICAgIDxCb3hcbiAgICAgICAgICAgICAgY29tcG9uZW50PVwic3BhblwiXG4gICAgICAgICAgICAgIGNzcz17e1xuICAgICAgICAgICAgICAgIGJhY2tncm91bmQ6ICdsaW5lYXItZ3JhZGllbnQoOTBkZWcsICMwQ0I2QTEgMCUsICMxMEIxRDYgNTAlLCAjNkQ3OUVBIDEwMCUpJyxcbiAgICAgICAgICAgICAgICBXZWJraXRCYWNrZ3JvdW5kQ2xpcDogJ3RleHQnLFxuICAgICAgICAgICAgICAgIFdlYmtpdFRleHRGaWxsQ29sb3I6ICd0cmFuc3BhcmVudCcsXG4gICAgICAgICAgICAgICAgYmFja2dyb3VuZENsaXA6ICd0ZXh0JyxcbiAgICAgICAgICAgICAgfX0+XG4gICAgICAgICAgICAgIHtpc09uYm9hcmRpbmdDb21wbGV0ZWRcbiAgICAgICAgICAgICAgICA/IHQoJ+yWtOuWpCDqsJXsnZjqsIAg64KY7ZWc7YWMIOunnuydhOq5jD8nKVxuICAgICAgICAgICAgICAgIDogdCgn7KeA6riIIOunjuydtCDrk6PripQg6rCV7J2YIO2ZleyduO2VtOuztOyEuOyalCcpfVxuICAgICAgICAgICAgPC9Cb3g+XG4gICAgICAgICAgICB7IWlzT25ib2FyZGluZ0NvbXBsZXRlZCAmJiA8Qm94IGNvbXBvbmVudD1cInNwYW5cIj7wn5SlPC9Cb3g+fVxuICAgICAgICAgIDwvVGV4dD5cbiAgICAgICAgPC9Hcm91cD5cbiAgICAgICAgPHN2ZyB3aWR0aD1cIjE0XCIgaGVpZ2h0PVwiMTRcIiB2aWV3Qm94PVwiMCAwIDMyMCA1MTJcIiBzdHlsZT17eyBmbGV4U2hyaW5rOiAwIH19PlxuICAgICAgICAgIDxwYXRoXG4gICAgICAgICAgICBmaWxsPXtgdXJsKCMke2dyYWRpZW50SWR9KWB9XG4gICAgICAgICAgICBkPVwiTTI3OC42IDIzMy40YzEyLjUgMTIuNSAxMi41IDMyLjggMCA0NS4zbC0xNjAgMTYwYy0xMi41IDEyLjUtMzIuOCAxMi41LTQ1LjMgMHMtMTIuNS0zMi44IDAtNDUuM0wyMTAuNyAyNTYgNzMuNCAxMTguNmMtMTIuNS0xMi41LTEyLjUtMzIuOCAwLTQ1LjNzMzIuOC0xMi41IDQ1LjMgMGwxNjAgMTYwelwiXG4gICAgICAgICAgLz5cbiAgICAgICAgPC9zdmc+XG4gICAgICA8L0dyb3VwPlxuICAgIDwvQm94PlxuICApO1xufTtcblxuZXhwb3J0IGNvbnN0IEFwcFNoZWxsSW5wdXRFeHBsb3JlID0gKHtcbiAgb25DbG9zZVBvcG92ZXIsXG4gIGlzTW9iaWxlID0gZmFsc2UsXG59OiB7XG4gIG9uQ2xvc2VQb3BvdmVyOiAoKSA9PiB2b2lkO1xuICBpc01vYmlsZT86IGJvb2xlYW47XG59KSA9PiB7XG4gIGNvbnN0IHsgbGFuZyB9ID0gdXNlTGFuZygpO1xuICBjb25zdCB7IHQgfSA9IHVzZUFwcFNoZWxsVHJhbnNsYXRpb24oKTtcbiAgY29uc3QgeyBkYXRhIH0gPSB1c2VDYXRlZ29yeU1haW5RdWVyeShsYW5nKTtcbiAgY29uc3QgeyBwcm9maWxlIH0gPSB1c2VQcm9maWxlQ29udGV4dCgpO1xuICBjb25zdCB7IGRhdGE6IG9uYm9hcmRpbmdTdGF0dXMgfSA9IHVzZVVzZXJPbmJvYXJkaW5nc1N0YXR1c1F1ZXJ5KHtcbiAgICBvcHRpb25zOiB7XG4gICAgICBlbmFibGVkOiAhIXByb2ZpbGUsXG4gICAgfSxcbiAgfSk7XG5cbiAgY29uc3QgaXNCMmIgPSBwcm9maWxlPy5pc0IyYjtcbiAgY29uc3QgaXNPbmJvYXJkaW5nQ29tcGxldGVkID0gb25ib2FyZGluZ1N0YXR1cz8ucHJvZ3Jlc3NTdGF0dXMgPT09ICdDT01QTEVURSc7XG4gIGNvbnN0IHNob3VsZFNob3dPbmJvYXJkaW5nQnV0dG9uID1cbiAgICBvbmJvYXJkaW5nU3RhdHVzPy5pc09uYm9hcmRpbmdUYXJnZXQgJiYgIShpc0IyYiAmJiBpc09uYm9hcmRpbmdDb21wbGV0ZWQpO1xuXG4gIHJldHVybiAoXG4gICAgPFN0YWNrIGNvbXBvbmVudD1cInNlY3Rpb25cIiB3PVwiMTAwJVwiIHNwYWNpbmc9ezh9PlxuICAgICAge3Nob3VsZFNob3dPbmJvYXJkaW5nQnV0dG9uICYmIChcbiAgICAgICAgPE9uYm9hcmRpbmdCdXR0b25cbiAgICAgICAgICBvbkNsb3NlUG9wb3Zlcj17b25DbG9zZVBvcG92ZXJ9XG4gICAgICAgICAgaXNPbmJvYXJkaW5nQ29tcGxldGVkPXtpc09uYm9hcmRpbmdDb21wbGV0ZWR9XG4gICAgICAgIC8+XG4gICAgICApfVxuICAgICAgPFRpdGxlIG9yZGVyPXszfSBzaXplPVwibWRcIiB3ZWlnaHQ9ezUwMH0gY29sb3I9XCJncmF5LjlcIj5cbiAgICAgICAge3QoJ+uRmOufrOuztOq4sCcpfVxuICAgICAgPC9UaXRsZT5cbiAgICAgIDxHcmlkIGd1dHRlcj17OH0+XG4gICAgICAgIHtkYXRhPy5jYXRlZ29yaWVzLm1hcCgoY2F0ZWdvcnkpID0+IChcbiAgICAgICAgICA8R3JpZC5Db2wgc3Bhbj17aXNNb2JpbGUgPyA2IDogNH0ga2V5PXtjYXRlZ29yeS5pZH0+XG4gICAgICAgICAgICA8RXhwbG9yZUl0ZW0gY2F0ZWdvcnk9e2NhdGVnb3J5fSBvbkNsb3NlUG9wb3Zlcj17b25DbG9zZVBvcG92ZXJ9IC8+XG4gICAgICAgICAgPC9HcmlkLkNvbD5cbiAgICAgICAgKSl9XG4gICAgICA8L0dyaWQ+XG4gICAgPC9TdGFjaz5cbiAgKTtcbn07XG5cbmNvbnN0IEV4cGxvcmVJdGVtID0gKHtcbiAgY2F0ZWdvcnksXG4gIG9uQ2xvc2VQb3BvdmVyLFxufToge1xuICBjYXRlZ29yeTogRmluZFBhcmVudENhdGVnb3J5UmVzcG9uc2VbJ2NhdGVnb3JpZXMnXVtudW1iZXJdO1xuICBvbkNsb3NlUG9wb3ZlcjogKCkgPT4gdm9pZDtcbn0pID0+IHtcbiAgY29uc3QgeyBuYXZpZ2F0ZSB9ID0gdXNlUm91dGVyQ29udGV4dCgpO1xuICBjb25zdCBpY29uUmVmID0gdXNlUmVmPEhUTUxEaXZFbGVtZW50PihudWxsKTtcbiAgY29uc3QgW3NldER1bW15SWNvbiwgc2V0U2V0RHVtbXlJY29uXSA9IHVzZVN0YXRlPGJvb2xlYW4gfCB1bmRlZmluZWQ+KHVuZGVmaW5lZCk7XG4gIGNvbnN0IHsgdHJhY2tFdmVudCB9ID0gdXNlVHJhY2tFdmVudCgpO1xuXG4gIGNvbnN0IGhhbmRsZU5hdmlnYXRlID0gKGU6IFJlYWN0Lk1vdXNlRXZlbnQpID0+IHtcbiAgICBlLnByZXZlbnREZWZhdWx0KCk7XG4gICAgZS5zdG9wUHJvcGFnYXRpb24oKTtcblxuICAgIHZvaWQgdHJhY2tFdmVudChldmVudE5hbWVzLkNMSUNLX0NBVEVHT1JZX0FUX1NFQVJDSEJBUiwge1xuICAgICAgbGFiZWw6IGNhdGVnb3J5LnRpdGxlLFxuICAgIH0pO1xuICAgIG5hdmlnYXRlKFNFUlZJQ0VfVVJMLkNPVVJTRVMoeyBjYXRlZ29yeTogY2F0ZWdvcnkuc2x1ZyB9KSk7XG5cbiAgICBvbkNsb3NlUG9wb3ZlcigpO1xuICB9O1xuXG4gIHVzZUVmZmVjdCgoKSA9PiB7XG4gICAgaWYgKGljb25SZWYuY3VycmVudCkge1xuICAgICAgLy8g7J6Q7Iud7JqU7IaM6rCAIOyhtOyerO2VmOyngCDslYrripQg6rK97JqwXG4gICAgICBpZiAoaWNvblJlZi5jdXJyZW50LmNoaWxkcmVuLmxlbmd0aCA9PT0gMCkge1xuICAgICAgICBzZXRTZXREdW1teUljb24odHJ1ZSk7XG5cbiAgICAgICAgcmV0dXJuO1xuICAgICAgfVxuICAgICAgc2V0U2V0RHVtbXlJY29uKGZhbHNlKTtcbiAgICB9XG4gIH0sIFtdKTtcblxuICByZXR1cm4gKFxuICAgIDxTdGFja1xuICAgICAgdGFiSW5kZXg9e1RBQl9JTkRFWC5FWFBMT1JFX0lURU19XG4gICAgICBjb21wb25lbnQ9XCJhXCJcbiAgICAgIGhyZWY9e1NFUlZJQ0VfVVJMLkNPVVJTRVMoeyBjYXRlZ29yeTogY2F0ZWdvcnkuc2x1ZyB9KX1cbiAgICAgIG9uQ2xpY2s9e2hhbmRsZU5hdmlnYXRlfVxuICAgICAgYWxpZ249XCJzdGFydFwiXG4gICAgICBoPVwiMTAwJVwiXG4gICAgICBzcGFjaW5nPXs4fVxuICAgICAgcD17MTJ9XG4gICAgICBjbGFzc05hbWU9e0VYUExPUkVfSVRFTV9DTEFTU19OQU1FfVxuICAgICAgY3NzPXt7XG4gICAgICAgIGJvcmRlclJhZGl1czogOCxcbiAgICAgICAgYm9yZGVyOiBgMXB4IHNvbGlkICR7Q09MT1JfUEFMRVRURS5ncmF5WzJdfWAsXG4gICAgICAgICcmOmhvdmVyJzoge1xuICAgICAgICAgIGJhY2tncm91bmRDb2xvcjogQ09MT1JfUEFMRVRURS5ncmF5WzFdLFxuICAgICAgICAgIGJvcmRlckNvbG9yOiBDT0xPUl9QQUxFVFRFLmdyYXlbM10sXG4gICAgICAgICAgY3Vyc29yOiAncG9pbnRlcicsXG4gICAgICAgIH0sXG4gICAgICB9fT5cbiAgICAgIDxHcm91cCByZWY9e2ljb25SZWZ9IGg9ezE2fT5cbiAgICAgICAge3NldER1bW15SWNvbiA/IChcbiAgICAgICAgICA8SWNvblxuICAgICAgICAgICAgaWNvbj17ZmluZEljb25EZWZpbml0aW9uKHsgcHJlZml4OiAnZmFyJywgaWNvbk5hbWU6ICdjb21wdXRlci1jbGFzc2ljJyB9KSF9XG4gICAgICAgICAgICBjb2xvcj1cImdyYXkuN1wiXG4gICAgICAgICAgICBzaXplPVwibWRcIlxuICAgICAgICAgIC8+XG4gICAgICAgICkgOiAoXG4gICAgICAgICAgPEljb25cbiAgICAgICAgICAgIGljb249e2ZpbmRJY29uRGVmaW5pdGlvbih7IHByZWZpeDogJ2ZhcicsIGljb25OYW1lOiBjYXRlZ29yeS5pY29uIGFzIEljb25OYW1lIH0pIX1cbiAgICAgICAgICAgIGNvbG9yPVwiZ3JheS43XCJcbiAgICAgICAgICAgIHNpemU9XCJtZFwiXG4gICAgICAgICAgICBvbkVycm9yPXsoKSA9PiBzZXRTZXREdW1teUljb24odHJ1ZSl9XG4gICAgICAgICAgLz5cbiAgICAgICAgKX1cbiAgICAgIDwvR3JvdXA+XG4gICAgICA8VGV4dCBzaXplPVwic21cIiB3ZWlnaHQ9ezQwMH0gY29sb3I9XCJncmF5LjlcIj5cbiAgICAgICAge2NhdGVnb3J5LnRpdGxlfVxuICAgICAgPC9UZXh0PlxuICAgIDwvU3RhY2s+XG4gICk7XG59O1xuIl19 */",
  toString: lt
}, A5 = process.env.NODE_ENV === "production" ? {
  name: "iokrzu",
  styles: "background:linear-gradient(90deg, #0CB6A1 0%, #10B1D6 50%, #6D79EA 100%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text"
} : {
  name: "sz8eiw-OnboardingButton",
  styles: "background:linear-gradient(90deg, #0CB6A1 0%, #10B1D6 50%, #6D79EA 100%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;label:OnboardingButton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: lt
};
const c5 = ({
  onClosePopover: g,
  isOnboardingCompleted: I
}) => {
  const {
    t: C
  } = UI(), {
    openModal: A
  } = _N(), {
    trackEvent: c
  } = PI(), {
    profile: l
  } = Ic(), t = `gradient-${Ls()}`, i = () => {
    if (typeof window > "u" || !window.location)
      return;
    const n = window.location.pathname.replace(/^\/(ko|en|ja|vi)(\/|$)/, "/");
    return n !== "/" && n !== "/courses" ? window.location.href : void 0;
  }, e = (n) => {
    n.preventDefault(), n.stopPropagation(), c(Og.CLICK_RECOMMENDATION_AT_SEARCHBAR), l != null && l.id && ee.set(Ot.ONBOARDING_NO_SHOW.KEY(l.id), "false", {
      expires: Ot.ONBOARDING_NO_SHOW.expireDay,
      domain: Ot.ONBOARDING_NO_SHOW.DOMAIN
    }), A({
      entryPoint: "searchbar",
      isFirstSignUp: !1,
      redirectTo: i()
    }), g();
  };
  return /* @__PURE__ */ o(P, { css: g5, children: /* @__PURE__ */ R(Ig, { tabIndex: ZC.EXPLORE_ITEM, component: "button", onClick: e, position: "apart", w: "100%", px: 20, py: 12, noWrap: !0, css: I5, children: [
    /* @__PURE__ */ R(Ig, { spacing: 10, noWrap: !0, children: [
      /* @__PURE__ */ R("svg", { width: "16", height: "16", viewBox: "0 0 512 512", style: {
        flexShrink: 0
      }, children: [
        /* @__PURE__ */ o("defs", { children: /* @__PURE__ */ R("linearGradient", { id: t, x1: "0%", y1: "0%", x2: "100%", y2: "0%", children: [
          /* @__PURE__ */ o("stop", { offset: "0%", stopColor: "#0CB6A1" }),
          /* @__PURE__ */ o("stop", { offset: "50%", stopColor: "#10B1D6" }),
          /* @__PURE__ */ o("stop", { offset: "100%", stopColor: "#6D79EA" })
        ] }) }),
        /* @__PURE__ */ o("path", { fill: `url(#${t})`, d: "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" })
      ] }),
      /* @__PURE__ */ R(U, { size: "md", lh: "1.5", fw: 600, css: C5, children: [
        /* @__PURE__ */ o(P, { component: "span", css: A5, children: C(I ? "어떤 강의가 나한테 맞을까?" : "지금 많이 듣는 강의 확인해보세요") }),
        !I && /* @__PURE__ */ o(P, { component: "span", children: "🔥" })
      ] })
    ] }),
    /* @__PURE__ */ o("svg", { width: "14", height: "14", viewBox: "0 0 320 512", style: {
      flexShrink: 0
    }, children: /* @__PURE__ */ o("path", { fill: `url(#${t})`, d: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z" }) })
  ] }) });
}, dr = ({
  onClosePopover: g,
  isMobile: I = !1
}) => {
  const {
    lang: C
  } = se(), {
    t: A
  } = UI(), {
    data: c
  } = qJ(C), {
    profile: l
  } = Ic(), {
    data: t
  } = KJ({
    options: {
      enabled: !!l
    }
  }), i = l == null ? void 0 : l.isB2b, e = (t == null ? void 0 : t.progressStatus) === "COMPLETE", n = (t == null ? void 0 : t.isOnboardingTarget) && !(i && e);
  return /* @__PURE__ */ R(gg, { component: "section", w: "100%", spacing: 8, children: [
    n && /* @__PURE__ */ o(c5, { onClosePopover: g, isOnboardingCompleted: e }),
    /* @__PURE__ */ o(Br, { order: 3, size: "md", weight: 500, color: "gray.9", children: A("둘러보기") }),
    /* @__PURE__ */ o(mn, { gutter: 8, children: c == null ? void 0 : c.categories.map((b) => /* @__PURE__ */ o(mn.Col, { span: I ? 6 : 4, children: /* @__PURE__ */ o(l5, { category: b, onClosePopover: g }) }, b.id)) })
  ] });
}, l5 = ({
  category: g,
  onClosePopover: I
}) => {
  const {
    navigate: C
  } = Ge(), A = Ag(null), [c, l] = O(void 0), {
    trackEvent: t
  } = PI(), i = (e) => {
    e.preventDefault(), e.stopPropagation(), t(Og.CLICK_CATEGORY_AT_SEARCHBAR, {
      label: g.title
    }), C(Jg.COURSES({
      category: g.slug
    })), I();
  };
  return q(() => {
    if (A.current) {
      if (A.current.children.length === 0) {
        l(!0);
        return;
      }
      l(!1);
    }
  }, []), /* @__PURE__ */ R(gg, { tabIndex: ZC.EXPLORE_ITEM, component: "a", href: Jg.COURSES({
    category: g.slug
  }), onClick: i, align: "start", h: "100%", spacing: 8, p: 12, className: Pu, css: /* @__PURE__ */ $({
    borderRadius: 8,
    border: `1px solid ${rg.gray[2]}`,
    "&:hover": {
      backgroundColor: rg.gray[1],
      borderColor: rg.gray[3],
      cursor: "pointer"
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:ExploreItem;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
    /* @__PURE__ */ o(Ig, { ref: A, h: 16, children: c ? /* @__PURE__ */ o(sg, { icon: Kb({
      prefix: "far",
      iconName: "computer-classic"
    }), color: "gray.7", size: "md" }) : /* @__PURE__ */ o(sg, { icon: Kb({
      prefix: "far",
      iconName: g.icon
    }), color: "gray.7", size: "md", onError: () => l(!0) }) }),
    /* @__PURE__ */ o(U, { size: "sm", weight: 400, color: "gray.9", children: g.title })
  ] });
}, Qi = 520, t5 = ({
  children: g,
  isMobile: I
}) => {
  const {
    isFocused: C,
    keyword: A,
    selectedMenu: c,
    inputRef: l
  } = kI(), [t, i] = O(!1), e = !I && t && c === "COURSES", n = () => {
    i(!0);
  };
  return q(() => {
    const b = (a) => {
      const s = a.target, d = l.current && l.current.contains(s), Z = s.closest(`.${G1}`) && !s.closest(`.${Pu}`);
      if (d || Z) {
        i(!0);
        return;
      }
      i(!1);
    };
    return t && document.addEventListener("mousedown", b), () => {
      document.removeEventListener("mousedown", b);
    };
  }, [t, l]), q(() => {
    if (C) {
      i(C);
      return;
    }
    i(!1);
  }, [C]), I ? /* @__PURE__ */ o(sI, { children: g }) : A ? /* @__PURE__ */ R(WC, { position: "bottom", shadow: "xl", radius: "md", opened: e, offset: 3, keepMounted: !0, width: Qi, styles: {
    dropdown: {
      ...ps,
      borderRadius: 16,
      // 데이터 로딩 중이거나 존재하지 않을 때 드롭다운 제거
      "&:empty": {
        display: "none"
      }
    }
  }, children: [
    /* @__PURE__ */ o(WC.Target, { children: g }),
    /* @__PURE__ */ o(WC.Dropdown, { p: 16, onClick: n, children: /* @__PURE__ */ o($u, {}) })
  ] }) : /* @__PURE__ */ R(WC, { position: "bottom", shadow: "xl", radius: "md", opened: e, offset: 3, keepMounted: !0, width: Qi, styles: {
    dropdown: {
      ...ps,
      borderRadius: 16
    }
  }, children: [
    /* @__PURE__ */ o(WC.Target, { children: g }),
    /* @__PURE__ */ o(WC.Dropdown, { p: 16, onClick: n, children: /* @__PURE__ */ o(dr, { onClosePopover: () => i(!1) }) })
  ] });
}, ps = {
  width: Qi,
  maxHeight: "auto",
  overflow: "auto",
  [$g("mobile")]: {
    width: "calc(100% - 32px) !important"
  }
};
function i5(g, I) {
  q(function() {
    if (!$A())
      return;
    const A = (c) => {
      (c.ctrlKey || c.metaKey) && c.key.toLowerCase() === g && (c.preventDefault(), I());
    };
    return window.addEventListener("keydown", A), () => {
      window.removeEventListener("keydown", A);
    };
  }, [g, I]);
}
const Rs = 20, e5 = ({
  isMobile: g = !1,
  onNavigate: I
}) => {
  const {
    navigate: C
  } = Ge(), {
    isFocused: A,
    keyword: c,
    selectedMenu: l,
    inputRef: t
  } = kI(), {
    showMenuList: i
  } = IA(), {
    trackEvent: e
  } = PI(), n = g ? !1 : i;
  return i5("k", () => {
    var a;
    (a = t.current) == null || a.focus();
  }), /* @__PURE__ */ o(t5, { isMobile: g, children: /* @__PURE__ */ R(Ig, { component: "form", onSubmit: (a) => {
    var d, Z;
    a.preventDefault();
    const s = VI("tab");
    if (!VI("s") && !c) {
      (d = t.current) == null || d.focus();
      return;
    }
    if (e(Og.SEARCH_COURSE, {
      search_keyword: c,
      type: l.toLowerCase()
    }), (Z = t.current) == null || Z.blur(), I == null || I(), l === "CHALLENGES" && !c) {
      C(Jg.CHALLENGES);
      return;
    }
    if (l === "ROADMAPS") {
      C(Jg.ROADMAPS_WITH_SEARCH({
        keyword: c,
        sort: "SEARCH",
        pageNumber: 1
      }));
      return;
    }
    if (l === "MENTORING") {
      C(Jg.MENTORING_WITH_SEARCH({
        keyword: c
      }));
      return;
    }
    if (l === "CLIPS") {
      C(Jg.CLIPS_WITH_SEARCH({
        searchKeyword: c,
        sort: "RECENT"
      }));
      return;
    }
    if (l === "COURSES") {
      C(Jg.COURSES({
        searchKeyword: c,
        tab: s
      }));
      return;
    }
    if (l === "COMMUNITY") {
      C(Jg.COMMUNITY_WITH_SEARCH({
        keyword: c
      }));
      return;
    }
    C(Jg.COURSES({
      searchKeyword: c,
      types: "CHALLENGE",
      tab: s
    }));
  }, spacing: 10, "aria-label": "search-bar", css: tt({
    showMenuList: n,
    isFocused: A,
    isMobile: g
  }), children: [
    /* @__PURE__ */ o(Ku, { isMobile: g }),
    /* @__PURE__ */ o(Eu, { isMobile: g }),
    /* @__PURE__ */ o(Qu, { isMobile: g })
  ] }) });
}, n5 = ({
  showMenuList: g,
  isAntMan: I
}) => /* @__PURE__ */ $({
  width: 520,
  zIndex: de(I).HEADER,
  position: "absolute",
  paddingTop: Rs,
  top: g ? "auto" : 28,
  height: g ? `calc(58px + ${Rs}px)` : "auto",
  transform: "translateX(-50%)",
  left: "50%",
  transition: "top 0.2s ease-out, padding-top 0.2s ease-out, height 0.2s ease-out",
  [$g("tablet")]: {
    display: "none"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleAppShellSearchBarWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvU2VhcmNoQmFyL0FwcFNoZWxsU2VhcmNoQmFySXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNElFIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvU2VhcmNoQmFyL0FwcFNoZWxsU2VhcmNoQmFySXRlbS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBDT0xPUl9QQUxFVFRFLCBHcm91cCB9IGZyb20gJ0BpbmZsZWFybi9kcy1yZWFjdCc7XG5cbmltcG9ydCB7IEFwcFNoZWxsSW5wdXQsIFBMQUNFSE9MREVSX0hFSUdIVCB9IGZyb20gJy4vQXBwU2hlbGxJbnB1dCc7XG5pbXBvcnQgeyBBcHBTaGVsbElucHV0QnV0dG9uIH0gZnJvbSAnLi9BcHBTaGVsbElucHV0QnV0dG9uJztcbmltcG9ydCB7IEFwcFNoZWxsSW5wdXRNZW51IH0gZnJvbSAnLi9BcHBTaGVsbElucHV0TWVudSc7XG5pbXBvcnQgeyBBcHBTaGVsbElucHV0RHJvcGRvd24gfSBmcm9tICcuL0FwcFNoZWxsSW5wdXRQb3BvdmVyJztcbmltcG9ydCB7IHVzZUFwcFNoZWxsSW5wdXRDb250ZXh0IH0gZnJvbSAnLi91c2VBcHBTaGVsbElucHV0Q29udGV4dCc7XG5pbXBvcnQgeyBldmVudE5hbWVzIH0gZnJvbSAnLi4vLi4vLi4vY29uc3RhbnRzL2d0bUV2ZW50TmFtZXMnO1xuaW1wb3J0IHsgU0VSVklDRV9VUkwgfSBmcm9tICcuLi8uLi8uLi9jb25zdGFudHMvdXJscyc7XG5pbXBvcnQgeyB1c2VLYmRTaG9ydGN1dCB9IGZyb20gJy4uLy4uLy4uL2hvb2tzL3VzZUtiZFNob3J0Y3V0JztcbmltcG9ydCB7IG1lZGlhUXVlcmllcywgZ2V0WkluZGV4IH0gZnJvbSAnLi4vLi4vLi4vc3R5bGVzJztcbmltcG9ydCB7IGdldFF1ZXJ5UGFyYW0gfSBmcm9tICcuLi8uLi8uLi91dGlscy9icm93c2VyJztcbmltcG9ydCB7IHVzZVRyYWNrRXZlbnQgfSBmcm9tICcuLi8uLi8uLi91dGlscy91c2VUcmFja0V2ZW50JztcbmltcG9ydCB7IHVzZVJvdXRlckNvbnRleHQgfSBmcm9tICcuLi8uLi9Sb3V0ZXIvUm91dGVyUHJvdmlkZXInO1xuaW1wb3J0IHsgdXNlU2VhcmNoQmFyQ29udGV4dCB9IGZyb20gJy4uL0hlYWRlci91c2VTZWFyY2hCYXJDb250ZXh0JztcblxuY29uc3QgUEFERElOR19UT1AgPSAyMDtcblxuZXhwb3J0IGNvbnN0IEFwcFNoZWxsU2VhcmNoQmFySXRlbSA9ICh7XG4gIGlzTW9iaWxlID0gZmFsc2UsXG4gIG9uTmF2aWdhdGUsXG59OiB7XG4gIGlzTW9iaWxlPzogYm9vbGVhbjtcbiAgb25OYXZpZ2F0ZT86ICgpID0+IHZvaWQ7XG59KSA9PiB7XG4gIGNvbnN0IHsgbmF2aWdhdGUgfSA9IHVzZVJvdXRlckNvbnRleHQoKTtcbiAgY29uc3QgeyBpc0ZvY3VzZWQsIGtleXdvcmQsIHNlbGVjdGVkTWVudSwgaW5wdXRSZWYgfSA9IHVzZUFwcFNoZWxsSW5wdXRDb250ZXh0KCk7XG4gIGNvbnN0IHsgc2hvd01lbnVMaXN0OiBzaG93TWVudUxpc3RJbkRlc2t0b3AgfSA9IHVzZVNlYXJjaEJhckNvbnRleHQoKTtcbiAgY29uc3QgeyB0cmFja0V2ZW50IH0gPSB1c2VUcmFja0V2ZW50KCk7XG5cbiAgY29uc3Qgc2hvd01lbnVMaXN0ID0gaXNNb2JpbGUgPyBmYWxzZSA6IHNob3dNZW51TGlzdEluRGVza3RvcDtcblxuICAvLyDsoITsl60g7YKk67O065OcIOuLqOy2le2CpCDsspjrpqxcbiAgdXNlS2JkU2hvcnRjdXQoJ2snLCAoKSA9PiB7XG4gICAgaW5wdXRSZWYuY3VycmVudD8uZm9jdXMoKTtcbiAgfSk7XG5cbiAgY29uc3QgaGFuZGxlU3VibWl0ID0gKGU6IFJlYWN0LkZvcm1FdmVudCkgPT4ge1xuICAgIGUucHJldmVudERlZmF1bHQoKTtcblxuICAgIGNvbnN0IHRhYiA9IGdldFF1ZXJ5UGFyYW0oJ3RhYicpO1xuXG4gICAgLy8g7YKk7JuM65Oc6rCAIOyhtOyerO2VmOyngCDslYrsnYQg65WMIO2PrOy7pOyLsSDsnKDsp4BcbiAgICBpZiAoIWdldFF1ZXJ5UGFyYW0oJ3MnKSAmJiAha2V5d29yZCkge1xuICAgICAgaW5wdXRSZWYuY3VycmVudD8uZm9jdXMoKTtcblxuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIHZvaWQgdHJhY2tFdmVudChldmVudE5hbWVzLlNFQVJDSF9DT1VSU0UsIHtcbiAgICAgIHNlYXJjaF9rZXl3b3JkOiBrZXl3b3JkLFxuICAgICAgdHlwZTogc2VsZWN0ZWRNZW51LnRvTG93ZXJDYXNlKCksXG4gICAgfSk7XG5cbiAgICBpbnB1dFJlZi5jdXJyZW50Py5ibHVyKCk7XG5cbiAgICBvbk5hdmlnYXRlPy4oKTtcblxuICAgIGlmIChzZWxlY3RlZE1lbnUgPT09ICdDSEFMTEVOR0VTJyAmJiAha2V5d29yZCkge1xuICAgICAgbmF2aWdhdGUoU0VSVklDRV9VUkwuQ0hBTExFTkdFUyk7XG5cbiAgICAgIHJldHVybjtcbiAgICB9XG5cbiAgICAvLyDroZzrk5zrp7VcbiAgICBpZiAoc2VsZWN0ZWRNZW51ID09PSAnUk9BRE1BUFMnKSB7XG4gICAgICBuYXZpZ2F0ZShcbiAgICAgICAgU0VSVklDRV9VUkwuUk9BRE1BUFNfV0lUSF9TRUFSQ0goe1xuICAgICAgICAgIGtleXdvcmQsXG4gICAgICAgICAgc29ydDogJ1NFQVJDSCcsXG4gICAgICAgICAgcGFnZU51bWJlcjogMSxcbiAgICAgICAgfSlcbiAgICAgICk7XG5cbiAgICAgIHJldHVybjtcbiAgICB9XG5cbiAgICAvLyDrqZjthqDrp4FcbiAgICBpZiAoc2VsZWN0ZWRNZW51ID09PSAnTUVOVE9SSU5HJykge1xuICAgICAgbmF2aWdhdGUoU0VSVklDRV9VUkwuTUVOVE9SSU5HX1dJVEhfU0VBUkNIKHsga2V5d29yZCB9KSk7XG5cbiAgICAgIHJldHVybjtcbiAgICB9XG5cbiAgICAvLyDtgbTrpr1cbiAgICBpZiAoc2VsZWN0ZWRNZW51ID09PSAnQ0xJUFMnKSB7XG4gICAgICBuYXZpZ2F0ZShTRVJWSUNFX1VSTC5DTElQU19XSVRIX1NFQVJDSCh7IHNlYXJjaEtleXdvcmQ6IGtleXdvcmQsIHNvcnQ6ICdSRUNFTlQnIH0pKTtcblxuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIC8vIOqwleydmFxuICAgIGlmIChzZWxlY3RlZE1lbnUgPT09ICdDT1VSU0VTJykge1xuICAgICAgbmF2aWdhdGUoU0VSVklDRV9VUkwuQ09VUlNFUyh7IHNlYXJjaEtleXdvcmQ6IGtleXdvcmQsIHRhYiB9KSk7XG5cbiAgICAgIHJldHVybjtcbiAgICB9XG5cbiAgICAvLyDsu6TrrqTri4jti7BcbiAgICBpZiAoc2VsZWN0ZWRNZW51ID09PSAnQ09NTVVOSVRZJykge1xuICAgICAgbmF2aWdhdGUoU0VSVklDRV9VUkwuQ09NTVVOSVRZX1dJVEhfU0VBUkNIKHsga2V5d29yZCB9KSk7XG5cbiAgICAgIHJldHVybjtcbiAgICB9XG5cbiAgICAvLyDssYzrprDsp4BcbiAgICBuYXZpZ2F0ZShTRVJWSUNFX1VSTC5DT1VSU0VTKHsgc2VhcmNoS2V5d29yZDoga2V5d29yZCwgdHlwZXM6ICdDSEFMTEVOR0UnLCB0YWIgfSkpO1xuICB9O1xuXG4gIHJldHVybiAoXG4gICAgPEFwcFNoZWxsSW5wdXREcm9wZG93biBpc01vYmlsZT17aXNNb2JpbGV9PlxuICAgICAgPEdyb3VwXG4gICAgICAgIGNvbXBvbmVudD1cImZvcm1cIlxuICAgICAgICBvblN1Ym1pdD17aGFuZGxlU3VibWl0fVxuICAgICAgICBzcGFjaW5nPXsxMH1cbiAgICAgICAgYXJpYS1sYWJlbD1cInNlYXJjaC1iYXJcIlxuICAgICAgICBjc3M9e3N0eWxlQXBwU2hlbGxTZWFyY2hCYXJJbm5lcldyYXBwZXIoe1xuICAgICAgICAgIHNob3dNZW51TGlzdCxcbiAgICAgICAgICBpc0ZvY3VzZWQsXG4gICAgICAgICAgaXNNb2JpbGUsXG4gICAgICAgIH0pfT5cbiAgICAgICAgPEFwcFNoZWxsSW5wdXRNZW51IGlzTW9iaWxlPXtpc01vYmlsZX0gLz5cbiAgICAgICAgPEFwcFNoZWxsSW5wdXQgaXNNb2JpbGU9e2lzTW9iaWxlfSAvPlxuICAgICAgICA8QXBwU2hlbGxJbnB1dEJ1dHRvbiBpc01vYmlsZT17aXNNb2JpbGV9IC8+XG4gICAgICA8L0dyb3VwPlxuICAgIDwvQXBwU2hlbGxJbnB1dERyb3Bkb3duPlxuICApO1xufTtcblxuLyoqXG4gKiBAcGFyYW0gc2hvd01lbnVMaXN0IOuplOuJtCDrpqzsiqTtirgg7ZGc7IucIOyXrOu2gCAodHJ1ZTog7LWc7IOB64uo7J28IOuVjCDtgbAg6rKA7IOJ67CUIOuFuOy2nCwgZmFsc2U6IOy1nOyDgeuLqOydtCDslYTri5Ag65WMIO2XpOuNlOyXkCDsnpHsnYAg6rKA7IOJ67CUIOuFuOy2nClcbiAqL1xuZXhwb3J0IGNvbnN0IHN0eWxlQXBwU2hlbGxTZWFyY2hCYXJXcmFwcGVyID0gKHtcbiAgc2hvd01lbnVMaXN0LFxuICBpc0FudE1hbixcbn06IHtcbiAgc2hvd01lbnVMaXN0OiBib29sZWFuO1xuICBpc0FudE1hbjogYm9vbGVhbjtcbn0pID0+XG4gIGNzcyh7XG4gICAgd2lkdGg6IDUyMCxcbiAgICB6SW5kZXg6IGdldFpJbmRleChpc0FudE1hbikuSEVBREVSLFxuICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgIHBhZGRpbmdUb3A6IFBBRERJTkdfVE9QLFxuICAgIHRvcDogIXNob3dNZW51TGlzdCA/IDI4IDogJ2F1dG8nLFxuICAgIGhlaWdodDogc2hvd01lbnVMaXN0ID8gYGNhbGMoNThweCArICR7UEFERElOR19UT1B9cHgpYCA6ICdhdXRvJyxcbiAgICB0cmFuc2Zvcm06ICd0cmFuc2xhdGVYKC01MCUpJyxcbiAgICBsZWZ0OiAnNTAlJyxcbiAgICB0cmFuc2l0aW9uOiAndG9wIDAuMnMgZWFzZS1vdXQsIHBhZGRpbmctdG9wIDAuMnMgZWFzZS1vdXQsIGhlaWdodCAwLjJzIGVhc2Utb3V0JyxcbiAgICBbbWVkaWFRdWVyaWVzKCd0YWJsZXQnKV06IHtcbiAgICAgIGRpc3BsYXk6ICdub25lJyxcbiAgICB9LFxuICB9KTtcblxuZXhwb3J0IGNvbnN0IHN0eWxlQXBwU2hlbGxTZWFyY2hCYXJJbm5lcldyYXBwZXIgPSAoe1xuICBzaG93TWVudUxpc3QsXG4gIGlzRm9jdXNlZCxcbiAgaXNNb2JpbGUsXG59OiB7XG4gIHNob3dNZW51TGlzdDogYm9vbGVhbjtcbiAgaXNGb2N1c2VkOiBib29sZWFuO1xuICBpc01vYmlsZTogYm9vbGVhbjtcbn0pID0+IHtcbiAgY29uc3QgZGVmYXVsdFdpZHRoID0gc2hvd01lbnVMaXN0ID8gNTE4IDogNDIwO1xuICBjb25zdCB3aWR0aCA9IGlzTW9iaWxlID8gJzEwMCUnIDogZGVmYXVsdFdpZHRoO1xuXG4gIHJldHVybiBjc3Moe1xuICAgIHdpZHRoLFxuICAgIGhlaWdodDogUExBQ0VIT0xERVJfSEVJR0hUKHNob3dNZW51TGlzdCksXG4gICAgcGFkZGluZ0xlZnQ6IHNob3dNZW51TGlzdCA/IDggOiA3LFxuICAgIHBhZGRpbmdSaWdodDogc2hvd01lbnVMaXN0ID8gOCA6IDcsXG4gICAgdHJhbnNpdGlvbjpcbiAgICAgICd3aWR0aCAwLjJzIGVhc2Utb3V0LCBoZWlnaHQgMC4ycyBlYXNlLW91dCwgYm9yZGVyLXJhZGl1cyAwLjJzIGVhc2Utb3V0LCBib3JkZXIgMC4ycyBlYXNlLW91dCwgYm94LXNoYWRvdyAwLjJzIGVhc2Utb3V0JyxcbiAgICBib3JkZXJSYWRpdXM6IDUwLFxuICAgIGJvcmRlcjogYDFweCBzb2xpZCAke0NPTE9SX1BBTEVUVEUuZ3JheVtpc0ZvY3VzZWQgPyA5IDogM119YCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6ICd3aGl0ZScsXG4gICAgYm94U2hhZG93OlxuICAgICAgIWlzTW9iaWxlICYmIGlzRm9jdXNlZFxuICAgICAgICA/ICcwIDFweCAzcHggMCByZ2JhKDAsIDAsIDAsIDAuMDUpLCAwIDM2cHggMjhweCAtN3B4IHJnYmEoMCwgMCwgMCwgMC4wNSksIDAgMTdweCAxN3B4IC03cHggcmdiYSgwLCAwLCAwLCAwLjA0KSdcbiAgICAgICAgOiAnbm9uZScsXG4gIH0pO1xufTtcbiJdfQ== */"), tt = ({
  showMenuList: g,
  isFocused: I,
  isMobile: C
}) => /* @__PURE__ */ $({
  width: C ? "100%" : g ? 518 : 420,
  height: WA(g),
  paddingLeft: g ? 8 : 7,
  paddingRight: g ? 8 : 7,
  transition: "width 0.2s ease-out, height 0.2s ease-out, border-radius 0.2s ease-out, border 0.2s ease-out, box-shadow 0.2s ease-out",
  borderRadius: 50,
  border: `1px solid ${rg.gray[I ? 9 : 3]}`,
  backgroundColor: "white",
  boxShadow: !C && I ? "0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 36px 28px -7px rgba(0, 0, 0, 0.05), 0 17px 17px -7px rgba(0, 0, 0, 0.04)" : "none"
}, process.env.NODE_ENV === "production" ? "" : ";label:styleAppShellSearchBarInnerWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var or = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", C = "arrow-left", A = 448, c = 512, l = [8592], t = "f060", i = "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z";
  g.definition = {
    prefix: I,
    iconName: C,
    icon: [
      A,
      c,
      l,
      t,
      i
    ]
  }, g.faArrowLeft = g.definition, g.prefix = I, g.iconName = C, g.width = A, g.height = c, g.ligatures = l, g.unicode = t, g.svgPathData = i, g.aliases = l;
})(or);
const b5 = () => {
  const [g, {
    open: I,
    close: C
  }] = Os(!1), {
    isFocused: A,
    setKeyword: c
  } = kI(), l = () => {
    C(), c("");
  };
  return /* @__PURE__ */ R(sI, { children: [
    /* @__PURE__ */ R(Ig, { role: "button", onClick: (t) => {
      t.preventDefault(), t.stopPropagation(), I();
    }, spacing: 10, "aria-label": "search-bar", css: tt({
      showMenuList: !1,
      isFocused: A,
      isMobile: !0
    }), children: [
      /* @__PURE__ */ o(Ku, { isMobile: !0, disabled: !0 }),
      /* @__PURE__ */ o(Eu, { isMobile: !0, disabled: !0 }),
      /* @__PURE__ */ o(Qu, { isMobile: !0 })
    ] }),
    /* @__PURE__ */ o(a5, { opened: g, close: l })
  ] });
}, a5 = ({
  opened: g,
  close: I
}) => {
  const {
    keyword: C,
    selectedMenu: A
  } = kI(), c = tg(() => A === "COURSES", [A]), l = tg(() => c ? C ? /* @__PURE__ */ o($u, { onNavigate: I }) : /* @__PURE__ */ o(dr, { onClosePopover: I, isMobile: !0 }) : null, [c, I, C]);
  return /* @__PURE__ */ o(wg, { opened: g, onClose: I, closeOnClickOutside: !1, fullScreen: !0, withCloseButton: !1, css: /* @__PURE__ */ $({
    display: "none",
    [$g("tablet")]: {
      display: "inline-block"
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:AppShellInputFullModal;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ o(wg.Content, { children: /* @__PURE__ */ o(wg.Body, { children: /* @__PURE__ */ R(gg, { spacing: 16, children: [
    /* @__PURE__ */ R(Ig, { noWrap: !0, spacing: 6, ml: -8, children: [
      /* @__PURE__ */ o(qg, { size: "n-md", onClick: I, children: /* @__PURE__ */ o(sg, { icon: or.faArrowLeft }) }),
      /* @__PURE__ */ o(e5, { onNavigate: I, isMobile: !0 })
    ] }),
    l
  ] }) }) }) });
}, q3 = () => {
  const {
    showMenuList: g,
    isSearchBarVisible: I
  } = IA();
  return I ? /* @__PURE__ */ o(N1, { children: /* @__PURE__ */ o(Ig, { position: "center", css: Gr({
    showMenuList: g
  }), children: /* @__PURE__ */ o(b5, {}) }) }) : null;
}, Gr = ({
  showMenuList: g
}) => /* @__PURE__ */ $({
  display: "none",
  zIndex: de(!0).HEADER,
  top: g ? "auto" : 12,
  height: "auto",
  backgroundColor: "white",
  transition: "top 0.2s ease-out, padding-top 0.2s ease-out, height 0.2s ease-out",
  [$g("tablet")]: {
    display: "flex",
    margin: "0 -32px",
    padding: "10px 32px 24px"
  },
  [$g("mobile")]: {
    margin: "0 -16px",
    padding: "10px 16px 24px"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleAppShellSearchBarMobileWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function rr() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const s5 = `${jC}/assets/images/header/inflearn_logo_business.svg`, u5 = `${jC}/assets/brand/logo.png?t=1`, Bs = 48, vs = 42, $3 = ({
  isMobile: g = !1
}) => {
  var e;
  const {
    getSnapshot: I,
    setSnapshot: C
  } = pu(), {
    trackEvent: A
  } = PI(), {
    profile: c
  } = Ic(), t = (c == null ? void 0 : c.isB2b) ? ((e = c == null ? void 0 : c.group) == null ? void 0 : e.logoUrl) ?? s5 : u5, i = I();
  return q(() => {
    (!i || i.logo !== t) && C({
      logo: t
    });
  }, [t, C, I, i]), /* @__PURE__ */ o(o5, { url: t, onClick: () => {
    A(Og.CLICK_LOGO_AT_HEADER);
  }, isMobile: g });
}, Zn = ({
  onClick: g,
  children: I
}) => {
  const {
    t: C
  } = UI();
  return /* @__PURE__ */ o(Js, { href: Jg.MAIN, "aria-label": C("인프런 메인 페이지로 이동"), tabIndex: ZC.BRAND_LOGO, css: G5, onClick: g, children: I });
};
var d5 = process.env.NODE_ENV === "production" ? {
  name: "1qesdsb",
  styles: "background-color:white"
} : {
  name: "uzjx03-HeaderBrandLogoImage",
  styles: "background-color:white;label:HeaderBrandLogoImage;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: rr
};
const o5 = ({
  url: g,
  onClick: I,
  isMobile: C
}) => {
  const [A, c] = O(!1);
  return /* @__PURE__ */ o(gg, { pos: "relative", children: /* @__PURE__ */ R(Zn, { onClick: I, children: [
    /* @__PURE__ */ o(Cg, { h: C ? vs : Bs, children: /* @__PURE__ */ o(bC, { w: 201, height: C ? vs : Bs, src: g, alt: "inflearn logo", onLoad: () => {
      c(!0);
    } }) }),
    !A && /* @__PURE__ */ o(P, { pos: "absolute", top: 0, left: 0, w: "auto", h: "auto", css: d5, children: /* @__PURE__ */ o(P, { className: "class-logo" }) })
  ] }) });
}, G5 = process.env.NODE_ENV === "production" ? {
  name: "1eingpo",
  styles: "display:flex;height:100%;align-items:center;& picture{display:flex;width:100%;height:100%;}"
} : {
  name: "1qgh1ec-styleHeaderBrandLogo",
  styles: "display:flex;height:100%;align-items:center;& picture{display:flex;width:100%;height:100%;};label:styleHeaderBrandLogo;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: rr
};
function r5() {
  return /* @__PURE__ */ o(Ig, { w: ue, mt: -4, children: /* @__PURE__ */ o(Ig, { className: "class-show-logo", children: /* @__PURE__ */ o(Zn, { children: /* @__PURE__ */ o(P, { className: "class-logo" }) }) }) });
}
function X5() {
  return /* @__PURE__ */ o(Ig, { w: ue, mt: -4, children: /* @__PURE__ */ o(Ig, { className: "class-show-logo", children: /* @__PURE__ */ o(Zn, { children: /* @__PURE__ */ o(P, { className: "class-logo" }) }) }) });
}
function it() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function gY({
  styles: g,
  isAntMan: I
}) {
  var C, A, c, l;
  return /* @__PURE__ */ o(Cg, { component: "header", className: "class-show-search-bar-header", css: [/* @__PURE__ */ $({
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    width: "100%",
    backgroundColor: "#fff",
    zIndex: de(I).HEADER,
    alignItems: "flex-start",
    justifyContent: "center",
    [$g("tablet")]: {
      height: 50
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:StickyHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), (C = g == null ? void 0 : g.header) == null ? void 0 : C.root, process.env.NODE_ENV === "production" ? "" : ";label:StickyHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: /* @__PURE__ */ R(Ig, { css: [W1, B5, (A = g == null ? void 0 : g.header) == null ? void 0 : A.container, process.env.NODE_ENV === "production" ? "" : ";label:StickyHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
    /* @__PURE__ */ o(V5, { styles: (c = g == null ? void 0 : g.header) == null ? void 0 : c.desktop, isAntMan: I }),
    /* @__PURE__ */ o(y5, { styles: (l = g == null ? void 0 : g.header) == null ? void 0 : l.mobile })
  ] }) });
}
var Z5 = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "1gwiwrs-DesktopHeaderSkeleton",
  styles: "position:relative;label:DesktopHeaderSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: it
};
const V5 = ({
  styles: g,
  isAntMan: I
}) => /* @__PURE__ */ o(Ki, { justify: "start", align: "center", w: "100%", className: "class-show-search-bar-wrapper", css: /* @__PURE__ */ $({
  backgroundColor: "white",
  [$g("tablet")]: {
    height: "auto"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:DesktopHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ R(Ig, { position: "apart", align: "center", spacing: 0, w: "100%", h: Du, noWrap: !0, css: [/* @__PURE__ */ $({
  [$g("tablet")]: {
    display: "none"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:DesktopHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), g == null ? void 0 : g.root, process.env.NODE_ENV === "production" ? "" : ";label:DesktopHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
  /* @__PURE__ */ o(r5, {}),
  /* @__PURE__ */ R(P, { css: Z5, children: [
    /* @__PURE__ */ o(N5, {}),
    /* @__PURE__ */ o(W5, { isAntMan: I })
  ] }),
  /* @__PURE__ */ o(m5, {})
] }) }), m5 = () => /* @__PURE__ */ R(Ig, { w: ue, spacing: 10, position: "right", children: [
  /* @__PURE__ */ o(qg, { variant: "light", size: "n-md", color: "gray", radius: "xl", disabled: !0, children: /* @__PURE__ */ o(sg, { icon: Tu.faGrid }) }),
  /* @__PURE__ */ o(qg, { variant: "light", size: "n-md", color: "gray", radius: "xl", disabled: !0, children: /* @__PURE__ */ o(sg, { icon: Su.faGlobe }) }),
  /* @__PURE__ */ o(ng, { width: 92, height: 42, radius: "xl" })
] });
var h5 = process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "184j5yn-SearchBarSkeleton",
  styles: "flex:1;label:SearchBarSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: it
};
const W5 = ({
  isAntMan: g
}) => /* @__PURE__ */ o(Ig, { className: "class-show-search-bar", css: n5({
  showMenuList: !0,
  isAntMan: g
}), children: /* @__PURE__ */ R(Ig, { css: tt({
  showMenuList: !0,
  isFocused: !1,
  isMobile: !1
}), children: [
  /* @__PURE__ */ o(P, { css: h5 }),
  /* @__PURE__ */ o(qg, { type: "submit", size: "n-md", variant: "filled", color: "infgreen", radius: 999, disabled: !0, children: /* @__PURE__ */ o(sg, { icon: gc.faSearch, size: "md" }) })
] }) }), N5 = () => /* @__PURE__ */ o(Ig, { h: 44, children: /* @__PURE__ */ R(Ig, { spacing: 10, className: "class-show-menu-list", noWrap: !0, children: [
  /* @__PURE__ */ o(oA, { type: "COURSES" }),
  /* @__PURE__ */ o(oA, { type: "CHALLENGES", showIndicator: !0 }),
  /* @__PURE__ */ o(oA, { type: "MENTORING" }),
  /* @__PURE__ */ o(oA, { type: "CLIPS", showIndicator: !0 }),
  /* @__PURE__ */ o(oA, { type: "ROADMAPS" })
] }) }), oA = ({
  type: g,
  showIndicator: I = !1
}) => /* @__PURE__ */ o(Ki, { justify: "center", className: `class-show-menu-${g.toLowerCase()}`, children: /* @__PURE__ */ o(pC, { type: g, skeletonType: g, showIndicator: I }) });
var x5 = process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "ow3ghr-MobileHeaderSkeleton",
  styles: "flex:1;label:MobileHeaderSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: it
};
const y5 = ({
  styles: g
}) => /* @__PURE__ */ R(Ki, { w: "100%", spacing: 0, css: /* @__PURE__ */ $({
  display: "none",
  [$g("tablet")]: {
    display: "flex"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:MobileHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: [
  /* @__PURE__ */ R(Ig, { w: "100%", h: 50, css: [g == null ? void 0 : g.root, process.env.NODE_ENV === "production" ? "" : ";label:MobileHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
    /* @__PURE__ */ o(X5, {}),
    /* @__PURE__ */ o(Ig, { position: "right", spacing: 8, ml: 10, noWrap: !0, css: x5, children: /* @__PURE__ */ o(ng, { width: 36, height: 36, radius: "xl", visible: !0 }) })
  ] }),
  /* @__PURE__ */ o(R5, {})
] });
var p5 = process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "11fw941-SearchBarSkeletonMobile",
  styles: "flex:1;label:SearchBarSkeletonMobile;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: it
};
const R5 = () => /* @__PURE__ */ o(Ig, { w: "100vw", className: "class-show-search-bar", css: Gr({
  showMenuList: !1
}), children: /* @__PURE__ */ R(Ig, { w: "100%", css: tt({
  showMenuList: !1,
  isFocused: !1,
  isMobile: !0
}), children: [
  /* @__PURE__ */ o(P, { css: p5 }),
  /* @__PURE__ */ o(qg, { type: "submit", size: "n-xs", variant: "filled", color: "infgreen", radius: 999, disabled: !0, children: /* @__PURE__ */ o(sg, { icon: gc.faSearch, size: "md" }) })
] }) }), B5 = /* @__PURE__ */ $({
  maxWidth: 1440,
  padding: "0 32px",
  backgroundColor: "white",
  [$g("mobile")]: {
    padding: "0 16px"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleHeaderContainerInner;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
export {
  R3 as $,
  li as A,
  sm as B,
  Pc as C,
  dm as D,
  ci as E,
  lm as F,
  cm as G,
  $5 as H,
  s0 as I,
  tm as J,
  A3 as K,
  g3 as L,
  MV as M,
  su as N,
  q5 as O,
  L3 as P,
  Dl as Q,
  P3 as R,
  Jg as S,
  I3 as T,
  cb as U,
  DV as V,
  ku as W,
  x1 as X,
  Uu as Y,
  Ic as Z,
  p3 as _,
  UI as a,
  ce as a$,
  y3 as a0,
  de as a1,
  c3 as a2,
  K3 as a3,
  ur as a4,
  se as a5,
  rA as a6,
  u3 as a7,
  ZC as a8,
  Tu as a9,
  v3 as aA,
  f3 as aB,
  z3 as aC,
  x3 as aD,
  q3 as aE,
  W1 as aF,
  E3 as aG,
  g9 as aH,
  ie as aI,
  Sl as aJ,
  _3 as aK,
  Ot as aL,
  O3 as aM,
  V3 as aN,
  o1 as aO,
  iI as aP,
  il as aQ,
  gb as aR,
  w2 as aS,
  T2 as aT,
  mI as aU,
  cu as aV,
  LI as aW,
  OC as aX,
  zl as aY,
  Dn as aZ,
  nV as a_,
  $g as aa,
  B3 as ab,
  h3 as ac,
  Z3 as ad,
  b3 as ae,
  N3 as af,
  YW as ag,
  Ia as ah,
  wN as ai,
  Je as aj,
  zN as ak,
  zd as al,
  Ug as am,
  D3 as an,
  Jd as ao,
  C3 as ap,
  w3 as aq,
  G3 as ar,
  d3 as as,
  hg as at,
  ue as au,
  IA as av,
  N1 as aw,
  n5 as ax,
  e5 as ay,
  $3 as az,
  s3 as b,
  $C as b0,
  le as b1,
  GC as b2,
  hI as b3,
  dV as b4,
  C2 as b5,
  $i as b6,
  qC as b7,
  sX as b8,
  DX as b9,
  vC as bA,
  X3 as bB,
  H3 as bC,
  T3 as bD,
  ou as bE,
  $t as bF,
  t0 as bG,
  iC as bH,
  qV as bI,
  g0 as bJ,
  e0 as bK,
  Zu as bL,
  ze as bM,
  k3 as bN,
  b9 as bO,
  kA as bP,
  AI as bQ,
  K9 as bR,
  VC as bS,
  U3 as bT,
  t3 as bU,
  E5 as bV,
  l3 as ba,
  Q3 as bb,
  M3 as bc,
  gr as bd,
  m3 as be,
  Ge as bf,
  VI as bg,
  $G as bh,
  S3 as bi,
  f1 as bj,
  Y1 as bk,
  Y3 as bl,
  kc as bm,
  Cb as bn,
  E0 as bo,
  gm as bp,
  i3 as bq,
  Im as br,
  e3 as bs,
  n3 as bt,
  O0 as bu,
  j0 as bv,
  Ib as bw,
  MC as bx,
  W3 as by,
  r3 as bz,
  PI as c,
  a3 as d,
  Og as e,
  jC as f,
  UC as g,
  $A as h,
  fu as i,
  EC as j,
  tl as k,
  $n as l,
  Q5 as m,
  K5 as n,
  _5 as o,
  M5 as p,
  tI as q,
  gY as r,
  J3 as s,
  _u as t,
  _N as u,
  ee as v,
  o3 as w,
  F3 as x,
  hm as y,
  pu as z
};
